
// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';

// import {
//     ResponsiveContainer,
//     BarChart,
//     Bar,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip
// } from "recharts";
// import { Bar as ChartBar, Pie, Doughnut } from 'react-chartjs-2';

// // ✅ REACT + ROUTER
// import React, { useState, useEffect, useMemo } from 'react';
// import { useParams, useNavigate, useLocation } from 'react-router-dom';

// // ✅ MODULES
// import Attendance from '../../modules/Attendance';
// import PayBenefits from '../../modules/PayBenefits';
// import OKRTracker from '../../modules/OKRTracker';
// import CareerPathways from '../../modules/CareerPathways';
// import EquipmentRequest from '../../modules/EquipmentRequest';
// import OfficeRequisition from '../../modules/OfficeRequisition';
// import ITSupport from '../../modules/ITSupport';
// import Documents from '../../modules/Documents';
// import CompanyPolicy from '../../modules/CompanyPolicy';
// import OrgChart from '../../modules/OrgChart';
// import CampusInfo from '../../modules/CampusInfo';
// import AddDepartment from '../../modules/AddDepartment';
// import AddEmployee from '../../modules/AddEmployee';
// import ManageDepartment from '../../modules/ManageDepartment';
// import ManageEmployee from '../../modules/ManageEmployee';
// import MyProfile from '../../modules/MyProfile';
// import LeaveManagement from '../../modules/LeaveManagement';
// import EESExperience from '../../modules/EESExperience';
// import EESFeedbackManagement from '../../modules/EESFeedbackManagement';
// import MedicalReports from '../../modules/MedicalReports';
// import ManagementOKRViewer from '../../modules/ManagementOKRViewer';
// import ManagerLeaveManagement from '../../modules/ManagerLeaveManagement';
// import ManagerMedicalReports from '../../modules/ManagerMedicalReports';
// import EmployeeSalaryBenefits from '../../modules/EmployeeSalaryBenefits';
// import PolicyAdminDashboard from '../../modules/PolicyAdminDashboard';
// import ManageEmployeeDocs from '../../modules/ManageEmployeeDocs';
// import OneOnOne from '../../modules/OneOnOne';
// import EventsCelebrations from '../../modules/EventsCelebrations';
// import ProjectModule from '../../modules/ProjectModule';
// import QuarterlyUpdates from '../../modules/QuarterlyUpdates';
// import ManagementQuarterlyUpdate from '../../modules/ManagementQuarterlyUpdate';
// import ReimbursementManagement from '../../modules/ReimbursementManagement';
// import WorkFromHome from '../../modules/WorkFromHome';
// import WFHManagement from '../../modules/WFHManagement';
// import OneOnOneAnalyticsCard from "../../modules/OneOnOneAnalyticsCard";
// import InvoiceGenerator from '../../modules/InvoiceGenerator';
// import AttendanceTracker from '../../modules/AttendanceTracker';
// import CompanySetup from '../../modules/CompanySetup';
// import Sidebar from "../../components/Sidebar/sidebar";

// // ✅ ASSETS
// import logoLight from '../../assets/logowhite-p.png';
// import logoDark from '../../assets/logo-white-r.png';

// // ✅ STYLES
// import './Dashboard.css';


// // ✅ CHART.JS CORE
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip as ChartTooltip,  // ✅ rename this
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// } from 'chart.js';

// // ✅ REGISTER CHART.JS
// ChartJS.register(
//     ArcElement,
//     ChartTooltip, // ✅ use renamed one
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// );



// const QuarterlyCard = ({ handleModuleChange }) => {

//     const [latest, setLatest] = React.useState(null);

//     React.useEffect(() => {
//         fetch(
//             "/gt-api/get_quarterly_media.php?type=ACM Presentation",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "ACM DATA:",
//                     data
//                 );

//                 if (data.success && data.data.length > 0) {
//                     setLatest(data.data[0]);
//                 }
//             })
//             .catch(err => console.error("Quarterly Fetch Error:", err));
//     }, []);

//     console.log("LATEST ACM:", latest);

//     return (
//         <div
//             className="quarterly-pro-card clickable"
//             onClick={() => handleModuleChange("quarterly-updates")}
//         >
//             {/* Glow Layer */}
//             <div className="card-glow"></div>

//             {/* HEADER */}
//             <div className="qp-header">
//                 <div className="qp-left">
//                     <span className="qp-tag">ACM Updates</span>
//                     <h3 className="qp-title">Quarterly Insights</h3>
//                 </div>

//                 <div className="qp-icon">📢</div>
//             </div>

//             {/* BODY */}
//             <div className="qp-body">
//                 {latest ? (
//                     <>
//                         <h4 className="qp-main-title">{latest.title}</h4>

//                         <div className="qp-meta">
//                             <span className="qp-date">
//                                 {new Date(latest.created_at).toLocaleDateString('en-GB')}
//                             </span>
//                             <span className="qp-badge">NEW</span>
//                         </div>
//                     </>
//                 ) : (
//                     <div className="qp-empty">
//                         <div className="qp-loader"></div>
//                         <span>Awaiting next update</span>
//                     </div>
//                 )}
//             </div>

//             {/* FOOTER */}
//             <div className="qp-footer">
//                 <span>View Presentation</span>
//                 <span className="arrow">→</span>
//             </div>
//         </div>
//     );
// };


// const Dashboard = () => {
//     const [dashboardDepartments, setDashboardDepartments] = useState([]);
//     const [dashboardPathways, setDashboardPathways] = useState([]);
//     const [policyCount, setPolicyCount] = useState(0);

//     const [showAIChat, setShowAIChat] = useState(false);

//     const [chatMessages, setChatMessages] = useState([
//         {
//             sender: "ai",
//             text: "Hello 👋 Ask me anything about your ELMS database."
//         }
//     ]);

//     const [chatInput, setChatInput] = useState("");
//     const [chatLoading, setChatLoading] = useState(false);



//     const [showMissedModal, setShowMissedModal] = useState(false);

//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//     const [todayEvents, setTodayEvents] = useState([]);
//     useEffect(() => {
//         const fetchTodayEvents = async () => {
//             try {
//                 const res = await fetch('/gt-api/get_celebrations.php');
//                 const data = await res.json();

//                 if (data.success) {
//                     setTodayEvents(data.data || []);
//                 }
//             } catch (err) {
//                 console.error("Dashboard Events Error:", err);
//             }
//         };

//         fetchTodayEvents();
//     }, []);
//     const [currentEventIndex, setCurrentEventIndex] = useState(0);
//     useEffect(() => {
//         if (!todayEvents || todayEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setCurrentEventIndex((prev) =>
//                 (prev + 1) % todayEvents.length
//             );
//         }, 3000); // change every 3 sec

//         return () => clearInterval(interval);
//     }, [todayEvents]);


//     const [equipmentData, setEquipmentData] = useState({
//         total: 0,
//         pending: 0,
//         blocking: 0
//     });



//     const [logs, setLogs] = useState({});

//     const totalPolicies = 11;
//     const readCount = Object.keys(logs || {}).length;

//     const progress = totalPolicies > 0
//         ? Math.round((readCount / totalPolicies) * 100)
//         : 0;


//     const params = useParams();
//     const module = params.module;

//     const storedUser = JSON.parse(localStorage.getItem("userData"));
//     const role = storedUser?.role;
//     const navigate = useNavigate();

//     useEffect(() => {
//         const storedUser = localStorage.getItem("userData");

//         if (!storedUser) {
//             navigate("/", { replace: true });
//             return;
//         }

//         // prevent back button access after logout
//         window.history.pushState(null, "", window.location.href);
//         window.onpopstate = function () {
//             const user = localStorage.getItem("userData");
//             if (!user) {
//                 navigate("/", { replace: true });
//             }
//         };

//     }, [navigate]);







//     const [policyLogs, setPolicyLogs] = useState({});





//     const [upcomingFestival, setUpcomingFestival] = useState(null);
//     const [daysLeft, setDaysLeft] = useState(null);
//     const [isFestivalToday, setIsFestivalToday] = useState(false);
//     const [activeEventIndex, setActiveEventIndex] = useState(0);
//     useEffect(() => {
//         fetch("/gt-api/get_upcoming_festival.php", {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.success) {
//                     setUpcomingFestival(data.festival);
//                     setDaysLeft(data.daysLeft);
//                     setIsFestivalToday(data.isToday);
//                 }
//             })
//             .catch(err => console.error(err));
//     }, []);


//     const location = useLocation();



//     const [showProfile, setShowProfile] = useState(false);
//     const [showPasswordModal, setShowPasswordModal] = useState(false);
//     const [isEditing, setIsEditing] = useState(false);

//     const [activeModule, setActiveModule] = useState(module || "grid");
//     const [isLightMode, setIsLightMode] = useState(false);

//     const [openMenus, setOpenMenus] = useState({
//         department: false,
//         employee: false
//     });

//     const [pendingRequestsCount, setPendingRequestsCount] = useState(0);
//     const [pendingLeavesCount, setPendingLeavesCount] = useState(0);
//     const [requestsList, setRequestsList] = useState([]);
//     const [notifCount, setNotifCount] = useState(0);

//     const [eesSubmissions, setEesSubmissions] = useState([]);
//     const handleEESSubmit = (newFeedback) => {
//         setEesSubmissions(prev => [...prev, newFeedback]);
//     };

//     const [passwordForm, setPasswordForm] = useState({
//         currentPassword: '',
//         newPassword: '',
//         confirmPassword: ''
//     });

//     const [showMandatoryProfileModal, setShowMandatoryProfileModal] = useState(false);
//     const [missingProfileFields, setMissingProfileFields] = useState({
//         phone: false,
//         dob: false,
//         city: false,
//         address: false,
//         local_address: false,
//         country: false
//     });
//     const [mandatoryFormData, setMandatoryFormData] = useState({
//         phone: '',
//         dob: '',
//         city: '',
//         address: '',
//         local_address: '',
//         country: ''
//     });
//     const [mandatorySaving, setMandatorySaving] = useState(false);
//     const [mandatoryError, setMandatoryError] = useState('');
//     const [mandatorySuccessMsg, setMandatorySuccessMsg] = useState('');

//     // 🔴 MANDATORY BANK DETAILS MODAL STATE
//     const [showMandatoryBankModal, setShowMandatoryBankModal] = useState(false);
//     const [missingBankFields, setMissingBankFields] = useState({
//         bankName: false,
//         holderName: false,
//         accNumber: false,
//         ifsc: false,
//         branch: false,
//         accType: false
//     });
//     const [bankFormData, setBankFormData] = useState({
//         bankName: '',
//         holderName: '',
//         accNumber: '',
//         ifsc: '',
//         branch: '',
//         accType: 'Saving Account'
//     });
//     const [bankSaving, setBankSaving] = useState(false);
//     const [bankError, setBankError] = useState('');
//     const [bankSuccessMsg, setBankSuccessMsg] = useState('');




//     const [userData, setUserData] = useState(() => {
//         const storedData = localStorage.getItem("userData");
//         if (storedData) return JSON.parse(storedData);

//         const firstName = location.state?.userName?.split(' ')[0] || "User";
//         const lastName = location.state?.userName?.split(' ')[1] || "";

//         return {
//             firstName,
//             lastName,
//             email: "",
//             dept: "Loading...",
//             phone: "",
//             gender: "",
//             dob: "",
//             address: "",
//             city: "",
//             country: "",
//             employeeId: location.state?.empId || null,
//             profileImage: null,
//             joiningDate: null,
//             HOD: null
//         };
//     });


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_career_pathways.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setDashboardPathways(
//                         data.pathways || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_departments.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "DASHBOARD DEPARTMENTS:",
//                     data
//                 );

//                 if (data.success) {

//                     setDashboardDepartments(
//                         data.departments || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) {

//             setPolicyCount(11);
//             return;

//         }

//         fetch(
//             "/gt-api/get_policies.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setPolicyCount(
//                         data.policies?.length || 0
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);
//     // ✅ THEN use it
//     const employeeId = userData?.id || userData?.employeeId;


//     useEffect(() => {
//         const fetchLeaveDashboardData = async () => {
//             if (!employeeId) return;

//             try {
//                 const res = await fetch(`/gt-api/get_leaves.php?empid=${employeeId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 const wfhRes = await fetch(`/gt-api/get_wfh.php?empid=${employeeId}`, {
//                     credentials: "include"
//                 });
//                 const wfhData = await wfhRes.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];

//                     // 🔥 SAME LOGIC AS ATTENDANCE
//                     const today = new Date();
//                     const currentYear = today.getFullYear();

//                     const fiscalYearStart = new Date(currentYear, 3, 1);

//                     const activeFiscalYearStart =
//                         today < fiscalYearStart
//                             ? new Date(currentYear - 1, 3, 1)
//                             : fiscalYearStart;

//                     // ✅ Dynamic Sick Total (joining based)
//                     let sickTotal = 12;

//                     if (userData?.joiningDate) {
//                         const joining = new Date(userData.joiningDate);

//                         const fyEnd = new Date(activeFiscalYearStart);
//                         fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
//                         fyEnd.setMonth(2);
//                         fyEnd.setDate(31);

//                         if (joining > activeFiscalYearStart) {
//                             if (joining > fyEnd) {
//                                 sickTotal = 0;
//                             } else {
//                                 const joinMonth = joining.getMonth();
//                                 const fyEndMonth = 2;

//                                 let monthsRemaining;

//                                 if (joinMonth <= fyEndMonth) {
//                                     monthsRemaining = fyEndMonth - joinMonth + 1;
//                                 } else {
//                                     monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
//                                 }

//                                 sickTotal = monthsRemaining;
//                             }
//                         }
//                     }

//                     let sickUsed = 0;
//                     let earnedUsed = 0;

//                     leaves.forEach(leave => {
//                         const status = String(leave.Status);
//                         const days = parseFloat(leave.total) || 0;
//                         const leaveDate = new Date(leave.fromdate);
//                         const medStatus = String(leave.medical_doc_status);

//                         // ✅ SAME CONDITION AS ATTENDANCE
//                         if (status === '0' || status === '1') {

//                             if (leave.leavetype === 'Sick Leave') {
//                                 if (leaveDate >= activeFiscalYearStart) {
//                                     sickUsed += days;
//                                 }
//                             }

//                             else if (leave.leavetype === 'Earned Leave') {

//                                 // 🔥 MEDICAL CONVERSION LOGIC
//                                 if (medStatus === '1' || medStatus === '0') {
//                                     if (leaveDate >= activeFiscalYearStart) {
//                                         sickUsed += days;
//                                     }
//                                 } else {
//                                     earnedUsed += days;
//                                 }
//                             }
//                         }
//                     });


//                     console.log("LEAVES:", leaves);
//                     console.log("SICK USED:", sickUsed);
//                     console.log("EARNED USED:", earnedUsed);
//                     console.log("API EARNED BALANCE:", data.earned);

//                     setLeaveData({
//                         leaveHistory: leaves,
//                         leaveBalances: {
//                             sick: { used: sickUsed, total: sickTotal },
//                             earned: { used: earnedUsed, total: parseFloat(data.earned) || 0 }
//                         },
//                         wfhHistory: wfhData.requests || []
//                     });
//                 }

//             } catch (err) {
//                 console.error("Dashboard Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaveDashboardData();
//     }, [employeeId, userData?.joiningDate]);


//     useEffect(() => {
//         setActiveModule(module || "grid");
//     }, [module]);

//     useEffect(() => {

//         if (role === 'Management' || role === 'Manager') {

//             const fetchRealTimeLeaves = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_leaves.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {
//                         // Count requests with Status '0' or null
//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };


//             fetchRealTimeLeaves();


//             const liveInterval = setInterval(fetchRealTimeLeaves, 5000);

//             return () => clearInterval(liveInterval);
//         }
//     }, [role]);



//     useEffect(() => {

//         const fetchUserData = async () => {

//             try {

//                 const response = await fetch("/gt-api/get_profile.php", {
//                     credentials: "include"
//                 });

//                 const data = await response.json();

//                 if (data.success && data.employee) {

//                     const storedUser = JSON.parse(localStorage.getItem("userData"));

//                     const updatedUser = {
//                         id: data.employee.id,
//                         EmpId: data.employee.EmpId,

//                         firstName: data.employee.FirstName,
//                         FirstName: data.employee.FirstName,

//                         lastName: data.employee.LastName,
//                         LastName: data.employee.LastName,

//                         email: data.employee.EmailId,
//                         EmailId: data.employee.EmailId,

//                         Department: data.employee.DepartmentName || data.employee.Department,

//                         HOD: data.employee.HOD,
//                         Designation: data.employee.Designation,
//                         phone: data.employee.Phonenumber,
//                         gender: data.employee.Gender,
//                         dob: data.employee.Dob,
//                         address: data.employee.Address,
//                         local_address: data.employee.LocalAddress,
//                         city: data.employee.City,
//                         country: data.employee.Country,
//                         profileImage: data.employee.ProfilePicture || null,
//                         joiningDate: data.employee.JoiningDate,

//                         role: storedUser?.role
//                     };

//                     setUserData(updatedUser);

//                     localStorage.setItem("userData", JSON.stringify(updatedUser));

//                     // ✅ CHECK ONLY MISSING MANDATORY PROFILE FIELDS
//                     const isMissing = (val) => !val || String(val).trim() === '' || String(val).trim() === '0000-00-00';
//                     const missing = {
//                         phone: isMissing(updatedUser.phone),
//                         dob: isMissing(updatedUser.dob),
//                         city: isMissing(updatedUser.city),
//                         address: isMissing(updatedUser.address),
//                         local_address: isMissing(updatedUser.local_address),
//                         country: isMissing(updatedUser.country)
//                     };

//                     if (Object.values(missing).some(Boolean)) {
//                         setMissingProfileFields(missing);
//                         setMandatoryFormData({
//                             phone: updatedUser.phone || '',
//                             dob: updatedUser.dob || '',
//                             city: updatedUser.city || '',
//                             address: updatedUser.address || '',
//                             local_address: updatedUser.local_address || '',
//                             country: updatedUser.country || ''
//                         });
//                         setShowMandatoryProfileModal(true);
//                     }

//                     // 🏦 CHECK MANDATORY BANK DETAILS
//                     const empIdForBank = data.employee.id || data.employee.EmpId;
//                     if (empIdForBank) {
//                         let bank = null;
//                         try {
//                             const bankRes = await fetch(`/gt-api/get_bank_details.php?emp_id=${empIdForBank}`, {
//                                 credentials: "include"
//                             });
//                             const rawText = await bankRes.text();
//                             try {
//                                 const json = JSON.parse(rawText);
//                                 if (json && (json.success || json.bank || json.bank_name || json.bankName)) {
//                                     bank = json.bank || json.data || json.details || json.employee_bank_details || json;
//                                 }
//                             } catch (parseErr) {
//                                 console.log("get_bank_details json parse error:", parseErr);
//                             }
//                         } catch (bErr) {
//                             console.error("Bank details fetch network error:", bErr);
//                         }

//                         const b = bank || {};

//                         const getVal = (...keys) => {
//                             for (const k of keys) {
//                                 if (b[k] !== undefined && b[k] !== null && String(b[k]).trim() !== '') {
//                                     return String(b[k]).trim();
//                                 }
//                             }
//                             return '';
//                         };

//                         const bankNameVal = getVal('bankName', 'bank_name', 'BankName', 'Bankname');
//                         const holderNameVal = getVal('holderName', 'holder_name', 'HolderName', 'account_holder_name', 'AccountHolderName');
//                         const accNumberVal = getVal('accNumber', 'account_number', 'AccountNumber', 'AccNumber', 'account_no', 'AccountNo');
//                         const ifscVal = getVal('ifsc', 'ifsc_code', 'IFSC', 'Ifsc', 'IfscCode');
//                         const branchVal = getVal('branch', 'branch_name', 'Branch', 'BranchName');
//                         const accTypeVal = getVal('accType', 'account_type', 'AccountType', 'AccType');

//                         const isBankMissing = (val) => !val || String(val).trim() === '';

//                         const missingBank = {
//                             bankName: isBankMissing(bankNameVal),
//                             holderName: isBankMissing(holderNameVal),
//                             accNumber: isBankMissing(accNumberVal),
//                             ifsc: isBankMissing(ifscVal),
//                             branch: isBankMissing(branchVal),
//                             accType: isBankMissing(accTypeVal)
//                         };

//                         console.log("MANDATORY BANK CHECK RESULT:", { empId: empIdForBank, bankData: b, missingBank });

//                         if (Object.values(missingBank).some(Boolean)) {
//                             setMissingBankFields(missingBank);
//                             setBankFormData({
//                                 bankName: bankNameVal,
//                                 holderName: holderNameVal || `${data.employee.FirstName || ''} ${data.employee.LastName || ''}`.trim(),
//                                 accNumber: bankNameVal ? accNumberVal : '',
//                                 ifsc: ifscVal,
//                                 branch: branchVal,
//                                 accType: accTypeVal || 'Saving Account'
//                             });
//                             setShowMandatoryBankModal(true);
//                         }
//                     }
//                 }

//             } catch (error) {
//                 console.error("Database Error:", error);
//             }

//         };

//         fetchUserData();

//     }, []);

//     // 🔒 LOCK BODY SCROLL WHEN MANDATORY MODAL IS OPEN
//     useEffect(() => {
//         if (showMandatoryProfileModal || showMandatoryBankModal) {
//             document.body.style.overflow = 'hidden';
//             document.documentElement.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         }
//         return () => {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         };
//     }, [showMandatoryProfileModal, showMandatoryBankModal]);

//     const handleSaveMandatoryProfile = async (e) => {
//         e.preventDefault();
//         setMandatoryError('');

//         const { phone, dob, city, address, local_address, country } = mandatoryFormData;
        
//         if (missingProfileFields.phone && (!phone || !phone.trim())) {
//             setMandatoryError('Please enter your Mobile Number.');
//             return;
//         }
//         if (missingProfileFields.dob && (!dob || !dob.trim() || dob === '0000-00-00')) {
//             setMandatoryError('Please select your Date of Birth.');
//             return;
//         }
//         if (missingProfileFields.city && (!city || !city.trim())) {
//             setMandatoryError('Please enter your City.');
//             return;
//         }
//         if (missingProfileFields.country && (!country || !country.trim())) {
//             setMandatoryError('Please enter your Country.');
//             return;
//         }
//         if (missingProfileFields.address && (!address || !address.trim())) {
//             setMandatoryError('Please enter your Permanent Address.');
//             return;
//         }
//         if (missingProfileFields.local_address && (!local_address || !local_address.trim())) {
//             setMandatoryError('Please enter your Current / Local Address.');
//             return;
//         }

//         setMandatorySaving(true);
//         try {
//             const payload = {
//                 id: userData.id,
//                 EmpId: userData.EmpId,
//                 Phonenumber: (phone || userData.phone || '').trim(),
//                 Dob: (dob || userData.dob || '').trim(),
//                 City: (city || userData.city || '').trim(),
//                 Address: (address || userData.address || '').trim(),
//                 LocalAddress: (local_address || userData.local_address || '').trim(),
//                 Country: (country || userData.country || '').trim(),
//                 Gender: userData.gender || '',
//                 ProfilePicture: userData.profileImage || null
//             };

//             const res = await fetch("/gt-api/update_profile.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 const updatedUser = {
//                     ...userData,
//                     phone: phone.trim(),
//                     dob: dob.trim(),
//                     city: city.trim(),
//                     address: address.trim(),
//                     local_address: local_address.trim(),
//                     country: country.trim()
//                 };
//                 setUserData(updatedUser);
//                 localStorage.setItem("userData", JSON.stringify(updatedUser));
//                 setMandatorySuccessMsg("🎉 Profile information updated! You may now use the system.");
//                 setTimeout(() => {
//                     setShowMandatoryProfileModal(false);
//                     setMandatorySuccessMsg('');
//                 }, 1200);
//             } else {
//                 setMandatoryError(result.message || "Failed to update profile. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory profile update error:", err);
//             setMandatoryError("Connection error. Ensure backend API is running.");
//         } finally {
//             setMandatorySaving(false);
//         }
//     };

//     const handleSaveMandatoryBankDetails = async (e) => {
//         e.preventDefault();
//         setBankError('');

//         const { bankName, holderName, accNumber, ifsc, branch, accType } = bankFormData;

//         if (missingBankFields.bankName && (!bankName || !bankName.trim())) {
//             setBankError('Please enter Bank Name.');
//             return;
//         }
//         if (missingBankFields.holderName && (!holderName || !holderName.trim())) {
//             setBankError('Please enter Account Holder Name.');
//             return;
//         }
//         if (missingBankFields.accNumber && (!accNumber || !accNumber.trim())) {
//             setBankError('Please enter Bank Account Number.');
//             return;
//         }
//         if (missingBankFields.ifsc && (!ifsc || !ifsc.trim())) {
//             setBankError('Please enter IFSC Code.');
//             return;
//         }
//         if (missingBankFields.branch && (!branch || !branch.trim())) {
//             setBankError('Please enter Branch Name.');
//             return;
//         }
//         if (missingBankFields.accType && (!accType || !accType.trim())) {
//             setBankError('Please select Account Type.');
//             return;
//         }

//         setBankSaving(true);
//         try {
//             const payload = {
//                 emp_id: userData.id || userData.employeeId || userData.EmpId,
//                 emp_number: userData.EmpId || userData.employeeId,
//                 bankName: bankName.trim(),
//                 bank_name: bankName.trim(),
//                 holderName: holderName.trim(),
//                 account_holder_name: holderName.trim(),
//                 accNumber: accNumber.trim(),
//                 account_number: accNumber.trim(),
//                 ifsc: ifsc.trim(),
//                 ifsc_code: ifsc.trim(),
//                 branch: branch.trim(),
//                 branch_name: branch.trim(),
//                 accType: accType.trim(),
//                 account_type: accType.trim()
//             };

//             const res = await fetch("/gt-api/save_bank_details.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 setBankSuccessMsg("🎉 Bank details updated successfully!");
//                 setTimeout(() => {
//                     setShowMandatoryBankModal(false);
//                     setBankSuccessMsg('');
//                 }, 1200);
//             } else {
//                 setBankError(result.message || "Failed to save bank details. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory bank details update error:", err);
//             setBankError("Connection error. Ensure backend API is running.");
//         } finally {
//             setBankSaving(false);
//         }
//     };




//     // const employeeId = userData.id || userData.employeeId;

//     const toggleSubMenu = (menu) => {
//         setOpenMenus(prev => ({ ...prev, [menu]: !prev[menu] }));
//     };

//     useEffect(() => {
//         const checkNotifications = () => {
//             if (role !== 'Management' && userData?.employeeId) {
//                 fetch(`/gt-api/clear_notifications.php?employee_id=${userData.employeeId}`)
//                     .then(res => res.json())
//                     .then(data => {
//                         if (data.success) setNotifCount(data.count);
//                     })
//                     .catch(err => console.error("Notif Fetch Error:", err));
//             }
//         };
//         checkNotifications();
//         const interval = setInterval(checkNotifications, 30000);
//         return () => clearInterval(interval);
//     }, [userData.employeeId, role]);

//     useEffect(() => {
//         if (role === 'Management' || role === 'Manager') {
//             const fetchRealTimeLeaves = async () => {
//                 try {
//                     // Determine which API to call based on Role
//                     // Managers should call the specific manager-leaves API using their ID
//                     const url = role === 'Management'
//                         ? "/gt-api/get_all_leaves.php"
//                         : `/gt-api/get_manager_leaves.php?managerId=${userData.id || location.state?.empId}`;

//                     // const res = await fetch(url);
//                     const res = await fetch(url, {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {

//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };

//             // Only fetch if we have the ID for the Manager, or if role is Management
//             if (role === 'Management' || (role === 'Manager' && (userData.id || location.state?.empId))) {
//                 fetchRealTimeLeaves();
//                 const liveInterval = setInterval(fetchRealTimeLeaves, 5000);
//                 return () => clearInterval(liveInterval);
//             }
//         }
//     }, [role, userData.id, location.state?.empId]);

//     const handleStatusUpdate = async (id, newStatus) => {
//         try {
//             const response = await fetch("/gt-api/update_request_status.php", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ id, status: newStatus }),
//             });
//             const data = await response.json();
//             if (data.success) {
//                 setRequestsList(prev => prev.map(req => req.id === id ? { ...req, status: newStatus } : req));
//                 setPendingRequestsCount(prev => Math.max(0, prev - 1));
//                 alert(`Request ${newStatus} successfully!`);
//             }
//         } catch (error) {
//             console.error("Update error:", error);
//         }
//     };

//     ;


//     const sendAIMessage = async () => {
//         if (!chatInput.trim()) return;

//         const userMessage = {
//             sender: "user",
//             text: chatInput
//         };

//         setChatMessages(prev => [...prev, userMessage]);
//         setChatLoading(true);

//         try {
//             const res = await fetch("/gt-api/chatbot.php", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     question: chatInput
//                 })
//             });

//             const data = await res.json();

//             let aiReply = "No response.";

//             if (data.success) {
//                 aiReply = data.reply || "No response.";
//             } else {
//                 aiReply = data.message || "Something went wrong.";
//             }
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: aiReply
//                 }
//             ]);

//         } catch (err) {
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: "Server error."
//                 }
//             ]);
//         }

//         setChatInput("");
//         setChatLoading(false);
//     };
//     const handleModuleChange = (slug, extraData = null) => {
//         navigate(`/dashboard/${role}/${slug}`, {
//             state:
//                 extraData && typeof extraData === "object"
//                     ? extraData
//                     : { selectedPathway: extraData }
//         });
//     };

//     const handlePasswordSubmit = (e) => {
//         e.preventDefault();
//         if (passwordForm.newPassword !== passwordForm.confirmPassword) {
//             alert("New passwords do not match!");
//             return;
//         }
//         alert("Encryption Key Updated Successfully!");
//         setShowPasswordModal(false);
//     };

//     const handleSave = () => {
//         setIsEditing(false);
//         alert("Profile changes synchronized!");
//     };

//     // Ensure only ONE instance of this exists in your file
//     const [theme, setTheme] = useState(localStorage.getItem('dashboard-theme') || 'dark');

//     useEffect(() => {
//         document.documentElement.setAttribute('data-theme', theme);
//         localStorage.setItem('dashboard-theme', theme);
//     }, [theme]);

//     const toggleTheme = () => {
//         setTheme(prev => prev === 'dark' ? 'light' : 'dark');
//     };
//     useEffect(() => {

//         const handlePageShow = (event) => {
//             if (event.persisted) {
//                 const user = localStorage.getItem("userData");
//                 if (!user) {
//                     window.location.replace("/");
//                 }
//             }
//         };

//         window.addEventListener("pageshow", handlePageShow);

//         return () => window.removeEventListener("pageshow", handlePageShow);

//     }, []);
//     useEffect(() => {
//         if (role === 'Management') {
//             const fetchEquipmentCount = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_equip_request.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();
//                     if (data.success && data.requests) {
//                         const count = data.requests.filter(r => r.status?.toLowerCase() === 'pending').length;
//                         setPendingRequestsCount(count);
//                         setRequestsList(data.requests);
//                     }
//                 } catch (err) {
//                     console.error("Equipment Fetch Error:", err);
//                 }
//             };

//             fetchEquipmentCount();
//             const interval = setInterval(fetchEquipmentCount, 10000);
//             return () => clearInterval(interval);
//         }
//     }, [role]);




//     const [payData, setPayData] = useState([]);

//     useEffect(() => {

//         // 🔥 MANAGEMENT DASHBOARD
//         if (role === "Management") {

//             const fetchAllDocs = () => {
//                 fetch("/gt-api/get_all_salary_documents.php", {
//                     credentials: "include"
//                 })
//                     .then(res => res.json())
//                     .then(data => {
//                         console.log("MGMT DATA:", data);

//                         if (data.success) {

//                             setPayData(data.documents);
//                         }
//                     })
//                     .catch(err => console.error("Management Fetch Error:", err));
//             };

//             fetchAllDocs();

//             const interval = setInterval(fetchAllDocs, 5000);

//             return () => clearInterval(interval);
//         }

//         // 👤 EMPLOYEE DASHBOARD
//         if (employeeId) {
//             fetch(`/gt-api/get_my_documents.php?emp_id=${employeeId}`, {
//                 credentials: "include"
//             })
//                 .then(res => res.json())
//                 .then(data => {
//                     console.log("EMP DATA:", data);

//                     if (data.success) {
//                         setPayData(data.documents);
//                     }
//                 })
//                 .catch(err => console.error("Employee Fetch Error:", err));
//         }

//     }, [role, employeeId]);





//     const renderPayChart = () => {
//         const safePayData = payData || [];

//         const payslips = safePayData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = safePayData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = safePayData.filter(d => d.doc_type === "APPRAISAL LETTER").length;
//         const totalDocs = payslips + form16 + appraisal;

//         return (
//             <div className="pay-ultra-card" onClick={() => handleModuleChange("pay and benefits")}>
//                 <div className="card-inner">
//                     {/* Top Section */}
//                     <div className="pay-header">
//                         <div className="pay-icon-wrapper">
//                             <div className="pay-icon-glow"></div>
//                             <span className="main-icon">📄</span>
//                         </div>
//                         <div className="pay-total-info">
//                             <h3>Pay & Benefits</h3>
//                             <p>{totalDocs} Total Documents</p>
//                         </div>
//                     </div>

//                     {/* Distribution */}
//                     <div className="distribution-container">
//                         <div className="distribution-label">
//                             <span>Vault Composition</span>
//                             <span className="percentage">
//                                 {totalDocs > 0 ? "100%" : "0%"}
//                             </span>
//                         </div>

//                         <div className="multi-progress-bar">
//                             {totalDocs > 0 ? (
//                                 <>
//                                     <div
//                                         className="segment green"
//                                         style={{ flex: payslips, backgroundColor: '#22c55e' }}
//                                     ></div>
//                                     <div
//                                         className="segment blue"
//                                         style={{ flex: form16, backgroundColor: '#3b82f6' }}
//                                     ></div>
//                                     <div
//                                         className="segment amber"
//                                         style={{ flex: appraisal, backgroundColor: '#f59e0b' }}
//                                     ></div>
//                                 </>
//                             ) : (
//                                 <div
//                                     style={{
//                                         width: "100%",
//                                         height: "100%",
//                                         backgroundColor: "#e5e7eb",
//                                         borderRadius: "10px"
//                                     }}
//                                 ></div>
//                             )}
//                         </div>
//                     </div>

//                     {/* List */}
//                     <div className="pay-list">
//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator green"></span>
//                                 <span className="name">Monthly Payslips</span>
//                             </div>
//                             <span className="count-badge">{payslips}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator blue"></span>
//                                 <span className="name">Tax Form 16</span>
//                             </div>
//                             <span className="count-badge">{form16}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator amber"></span>
//                                 <span className="name">Appraisal Letter</span>
//                             </div>
//                             <span className="count-badge">{appraisal}</span>
//                         </div>
//                     </div>

//                     <div className="pay-footer">
//                         <span>Explore Document</span>
//                         <span className="arrow-icon">→</span>
//                     </div>

//                     <div className="reimburse-cta-wrapper">
//                         <button
//                             className="reimburse-btn"
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleModuleChange("supplies");
//                             }}
//                         >
//                             Click here for Reimbursement Form
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };



//     const renderLeavePieChart = () => {
//         const PUBLIC_HOLIDAYS = [
//             '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//             '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//         ];

//         const isWorkDay = (date) => {
//             const day = date.getDay();
//             const dateString = date.toISOString().split('T')[0];
//             return !(day === 0 || day === 6) && !PUBLIC_HOLIDAYS.includes(dateString);
//         };

//         if (!leaveData || !leaveData.leaveBalances) return null;

//         const sickUsed = leaveData.leaveBalances.sick.used || 0;
//         const earnedUsed = leaveData.leaveBalances.earned.used || 0;
//         const wfhCount = leaveData.wfhHistory.reduce((total, wfh) => {
//             const start = new Date(wfh.start);
//             const end = new Date(wfh.end);
//             let days = 0;
//             let current = new Date(start);
//             while (current <= end) {
//                 if (isWorkDay(current)) days++;
//                 current.setDate(current.getDate() + 1);
//             }
//             return total + days;
//         }, 0);

//         const totalUsed = sickUsed + earnedUsed;

//         // Determine max for scaling bars (minimum scale of 10)
//         const maxVal = Math.max(sickUsed, earnedUsed, wfhCount, 10);
//         return (

//             <div
//                 className={`elite-podium-card leave-analytics-card ${theme === 'dark' ? 'dark-variant' : 'light-theme'}`}
//                 onClick={() => handleModuleChange("attendance")}
//             >

//                 <div className="card-header-v3">
//                     <div className="title-group">

//                         <h2 className="main-title">Leave Overview</h2>
//                     </div>
//                     <div className="year-tag">2026</div>
//                 </div>

//                 <div className="podium-content">
//                     {/* VERTICAL BAR SECTION - Made prominent */}
//                     <div className="bar-podium-large">
//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill sick" style={{ height: `${(sickUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">SICK</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill earned" style={{ height: `${(earnedUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">EARNED</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill wfh" style={{ height: `${(wfhCount / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">WFH</span>
//                         </div>
//                     </div>

//                     {/* KPI SIDEBAR - Cleaned up to match image 1's style */}
//                     <div className="kpi-sidebar-compact">
//                         <div className="total-display">
//                             <span className="total-val">{totalUsed}</span>
//                             <span className="total-sub">Days Off-Site</span>
//                         </div>

//                         <div className="status-legend">
//                             <div className="legend-row">
//                                 <span className="indicator sick"></span>
//                                 <span>{sickUsed} Sick</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator earned"></span>
//                                 <span>{earnedUsed} Earned</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator wfh"></span>
//                                 <span>{wfhCount} WFH</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="card-footer-v3">
//                     <div className="sync-info">
//                         <span className="status-glow"></span>
//                         Annual Summary Active
//                     </div>
//                     <button className="details-btn">VIEW DETAILS →</button>
//                 </div>
//             </div>
//         );
//     };

//     const [leaveData, setLeaveData] = useState({
//         leaveHistory: [],
//         leaveBalances: {
//             sick: { used: 0, total: 0 },
//             earned: { used: 0, total: 0 }
//         },
//         wfhHistory: []
//     });


//     const [managementNotices, setManagementNotices] = useState({
//         reviews: [],
//         probations: []
//     });

//     useEffect(() => {
//         const fetchNotices = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/get_manager_feedback.php?empId=${userData.EmpId}`
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     setManagementNotices({
//                         reviews: data.reviews || [],
//                         probations: data.probations || []
//                     });
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchNotices();
//     }, [userData]);





//     const renderEquipmentCard = () => {
//         const { total, approved, rejected, pending } = equipmentData;

//         return (
//             <div className="equipment-ultra-card clickable" onClick={() => handleModuleChange("equipment-request")}>
//                 <div className="equip-header">
//                     <div className="equip-icon-box">💻</div>
//                     <div className="equip-title-group">
//                         <span className="equip-label">Hardware</span>
//                         <h3 className="equip-title">Requests</h3>
//                     </div>
//                 </div>

//                 <div className="equip-main-stat">
//                     <span className="total-count">{total}</span>
//                     <span className="total-label">Submissions</span>
//                 </div>

//                 <div className="equip-progress-bar">
//                     <div className="bar-fill approved" style={{ width: `${(approved / total) * 100}%` }}></div>
//                     <div className="bar-fill pending" style={{ width: `${(pending / total) * 100}%` }}></div>
//                 </div>

//                 <div className="equip-stats-list">
//                     <div className="equip-item">
//                         <span className="dot approved"></span>
//                         <span className="item-name">Approved</span>
//                         <span className="item-val">{approved}</span>
//                     </div>
//                     <div className="equip-item">
//                         <span className="dot pending"></span>
//                         <span className="item-name">Pending</span>
//                         <span className="item-val text-warning">{pending}</span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     useEffect(() => {
//         const empIdForFetch = userData?.EmpId || userData?.employeeId;

//         if (!empIdForFetch) return;

//         fetch(`/gt-api/get_all_equip_request.php?employee_id=${empIdForFetch}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log("EQUIPMENT API RESPONSE:", data);
//                 if (data.success && data.requests) {

//                     const requests = data.requests;

//                     const approved = requests.filter(r =>
//                         r.status?.toLowerCase() === "approved"
//                     ).length;

//                     const rejected = requests.filter(r =>
//                         r.status?.toLowerCase() === "rejected"
//                     ).length;

//                     const pending = requests.filter(r =>
//                         r.status?.toLowerCase() === "pending"
//                     ).length;

//                     setEquipmentData({
//                         total: requests.length,
//                         approved,
//                         rejected,
//                         pending
//                     });
//                 }
//             })
//             .catch(err => console.error("Equipment Dashboard Error:", err));
//         console.log("EMP ID:", empIdForFetch);



//     }, [userData?.EmpId, userData?.employeeId]);





//     const [oneOnOneData, setOneOnOneData] = useState({
//         totalMeetings: 0,
//         pendingTasks: 0,
//         completedTasks: 0
//     });

//     useEffect(() => {
//         if (!employeeId) return;

//         fetch(`/gt-api/get_my_meetings.php?emp_id=${employeeId}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.meetings) {

//                     const meetings = data.meetings;

//                     let pending = 0;
//                     let completed = 0;

//                     meetings.forEach(meet => {
//                         const tasks = JSON.parse(meet.action_items || "[]");

//                         tasks.forEach(task => {
//                             if (task.done) completed++;
//                             else pending++;
//                         });
//                     });

//                     setOneOnOneData({
//                         totalMeetings: meetings.length,
//                         pendingTasks: pending,
//                         completedTasks: completed
//                     });
//                 }
//             })
//             .catch(err => console.error("1-1 Fetch Error:", err));

//     }, [employeeId]);



//     const renderOneOnOneCard = () => {
//         const { totalMeetings, pendingTasks, completedTasks } = oneOnOneData;
//         const totalTasks = (pendingTasks + completedTasks) || 1;
//         const progressPercent = Math.min(Math.round((completedTasks / totalTasks) * 100), 100);

//         return (
//             <div className="liquid-card clickable" onClick={() => handleModuleChange("one-on-one")}>
//                 {/* BACKGROUND BLOOM */}
//                 <div className="liquid-bloom"></div>

//                 <div className="liquid-layout">
//                     {/* HERO TILE: THE CORE IDENTITY */}
//                     <div className="liquid-tile-hero">
//                         <div className="hero-header">
//                             {/* <span className="hero-eyebrow">Engagement Console</span> */}
//                             <h2 className="hero-title">1-on-1 Sessions</h2>
//                         </div>
//                         <div className="hero-main-metric">
//                             <span className="hero-val">{totalMeetings}</span>
//                             <span className="hero-label">TOTAL<br />MEETINGS</span>
//                         </div>
//                         {/* FULL WIDTH PROGRESS THREAD */}
//                         <div className="liquid-thread-container">
//                             <div className="liquid-thread-bg">
//                                 <div className="liquid-thread-fill" style={{ width: `${progressPercent}%` }}>
//                                     <div className="liquid-thread-glow-tip"></div>
//                                 </div>
//                             </div>
//                             <div className="liquid-thread-label">
//                                 <span className="label-text">Task Completion</span>
//                                 <span className="label-val">{progressPercent}%</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* DATA TRAY: THE SPECIFIC CHIPS */}
//                     <div className="liquid-tray">
//                         <div className="liquid-chip danger">
//                             <div className="chip-inner">
//                                 <label>Pending Task</label>
//                                 <span className="chip-val">{pendingTasks}</span>
//                             </div>
//                         </div>
//                         <div className="liquid-chip success">
//                             <div className="chip-inner">
//                                 <label>Completed Task</label>
//                                 <span className="chip-val">{completedTasks}</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* INTERACTIVE FOOTER */}
//                 <div className="liquid-footer">
//                     <div className="status-container">
//                         <div className={`status-node-wrapper ${pendingTasks > 0 ? 'is-alert' : 'is-sync'}`}>
//                             <div className="status-node-core"></div>
//                             <div className="status-node-bloom"></div>
//                         </div>
//                         <span className={`status-text ${pendingTasks > 0 ? 'text-alert' : ''}`}>
//                             {pendingTasks > 0 ? 'ACTION ITEMS DETECTED' : 'SYSTEM OPTIMIZED'}
//                         </span>
//                     </div>
//                     <div className="liquid-action">

//                         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
//                     </div>
//                 </div>
//             </div>
//         );
//     };






//     const renderCareerPathwaysCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const pathways = isGenesis

//             ? [

//                 {
//                     id: "01",
//                     name: "FI DESIGN",
//                     color: "rgba(0, 77, 113, 0.9)"
//                 },

//                 {
//                     id: "02",
//                     name: "BIM MODELING",
//                     color: "rgba(0, 120, 172, 0.8)"
//                 },

//                 {
//                     id: "03",
//                     name: "POWER BI",
//                     color: "rgba(0, 162, 237, 0.7)"
//                 }

//             ]

//             : dashboardPathways.map(
//                 (item, index) => ({
//                     id: String(index + 1)
//                         .padStart(2, "0"),

//                     name: item.pathway_title,

//                     color:
//                         "rgba(0, 120, 172, 0.8)"
//                 })
//             );

//         return (

//             <div
//                 className="pathway-card-container"
//                 onClick={() =>
//                     handleModuleChange(
//                         "career pathways"
//                     )
//                 }
//             >

//                 <h2 className="pathway-title">
//                     CAREER PATHWAYS
//                 </h2>

//                 <div className="pathway-stack">

//                     {pathways.map(
//                         (item, index) => (

//                             <div
//                                 key={index}
//                                 className="pathway-step"
//                                 style={{
//                                     '--step-color':
//                                         item.color
//                                 }}
//                                 onClick={(e) => {

//                                     e.stopPropagation();

//                                     handleModuleChange(
//                                         "career pathways",
//                                         item.name
//                                     );

//                                 }}
//                             >

//                                 <span className="step-number">
//                                     {item.id}
//                                 </span>

//                                 <div className="step-content">

//                                     <span className="step-name">
//                                         {item.name}
//                                     </span>

//                                     <div className="step-glow"></div>

//                                 </div>

//                             </div>

//                         )
//                     )}

//                 </div>

//                 <button
//                     className="explore-btn"
//                     onClick={(e) => {

//                         e.stopPropagation();

//                         handleModuleChange(
//                             "career pathways"
//                         );

//                     }}
//                 >
//                     EXPLORE CAREER PATHWAYS
//                 </button>

//             </div>

//         );

//     };


//     const renderPolicyCard = () => {
//         const totalPolicies =
//             policyCount;

//         console.log(
//             "Policy Count:",
//             totalPolicies
//         );

//         const readCount =
//             Object.keys(logs || {}).length;
//         const pending = totalPolicies - readCount;
//         const progress = totalPolicies > 0 ? Math.round((readCount / totalPolicies) * 100) : 0;

//         return (
//             <div className="terminal-policy-card" onClick={() => handleModuleChange("company-policy")}>
//                 {/* Background Decorative Scanline */}
//                 <div className="terminal-scanline"></div>

//                 <div className="terminal-header">
//                     <div className="header-left">
//                         {/* <span className="terminal-tag">PROTOCOL_09</span> */}
//                         <h3 className="terminal-title">Company Policy</h3>
//                     </div>
//                     <div className={`status-indicator ${progress === 100 ? 'secure' : 'breach'}`}>
//                         {progress === 100 ? "SECURE" : "PENDING"}
//                     </div>
//                 </div>

//                 <div className="terminal-content">
//                     {/* Circular Progress using SVG for precision */}
//                     <div className="terminal-visual">
//                         <svg viewBox="0 0 36 36" className="cyber-circle">
//                             <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                             <path
//                                 className="circle-fill"
//                                 strokeDasharray={`${progress}, 100`}
//                                 d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
//                                 style={{ stroke: progress === 100 ? '#22c55e' : '#3b82f6' }}
//                             />
//                         </svg>
//                         <div className="percentage-display">
//                             <span className="pct-num">{progress}</span>
//                             <span className="pct-unit">%</span>
//                         </div>
//                     </div>

//                     {/* Data Readout Section */}
//                     <div className="terminal-stats">
//                         <div className="stat-row">
//                             <span className="label">COMPLETED</span>
//                             <span className="value">{readCount}</span>
//                         </div>
//                         <div className="stat-row">
//                             <span className="label">TOTAL_FILES</span>
//                             <span className="value">{totalPolicies}</span>
//                         </div>
//                         <div className="stat-row urgent">
//                             <span className="label">AWAITING_ACTION</span>
//                             <span className="value">{pending}</span>
//                         </div>
//                     </div>
//                 </div>

//             </div>
//         );
//     };

//     useEffect(() => {
//         const fetchLogs = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/acknowledgepolicy.php?empId=${userData.EmpId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 console.log("API DATA:", data);

//                 // 🔥 FIX: use data.logs (NOT data)
//                 const logsArray = Array.isArray(data?.logs) ? data.logs : [];

//                 const map = logsArray.reduce((acc, curr) => {
//                     if (curr?.policy_title) {
//                         acc[curr.policy_title] = true;
//                     }
//                     return acc;
//                 }, {});

//                 setLogs(map);

//             } catch (err) {
//                 console.error("Policy logs error:", err);
//                 setLogs({});
//             }
//         };

//         fetchLogs();
//     }, [userData]);


//     const [showProfileOptions, setShowProfileOptions] = useState(false);



//     const [showProfileMenu, setShowProfileMenu] = useState(false);
//     const handleEditProfile = () => {
//         setShowProfileMenu(false);
//         navigate(`/dashboard/${role}/my-profile`);
//         setShowProfile(true);
//     };

//     const handleLogout = () => {
//         document.documentElement.removeAttribute('data-theme');
//         localStorage.clear();
//         sessionStorage.clear();
//         navigate("/", { replace: true });
//     };

//     const [currentTime, setCurrentTime] = useState("");

//     useEffect(() => {
//         const updateTime = () => {
//             const now = new Date();
//             setCurrentTime(
//                 now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
//             );
//         };

//         updateTime();
//         const interval = setInterval(updateTime, 1000);

//         return () => clearInterval(interval);
//     }, []);
//     const todayDate = new Date().toLocaleDateString('en-GB', {
//         day: '2-digit',
//         month: 'short'
//     });



//     const employeeModulesList = [
//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "attendance" },

//         { id: 2, name: "Pay and Benefits", icon: "💳", color: "#3b82f6", slug: "pay and benefits" },
//         { id: 3, name: "OKR and Performance Tracker", icon: "🎯", color: "#f59e0b", slug: "okr and performance tracker" },

//         { id: 5, name: "Career Pathways", icon: "🏆", color: "#ec4899", slug: "career pathways" },
//         { id: 6, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },

//         { id: 9, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         { id: 10, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         // { id: 11, name: "Documents", icon: "📂", color: "#f43f5e", slug: "documents" },
//         // { id: 12, name: "Employee Experience Survey - EES", icon: "📝", color: "#8b5cf6", slug: "ees-survey" },   
//         { id: 13, name: "1:1 Meeting", icon: "💬", color: "#00fff2", slug: "one-on-one" },
//         { id: 21, name: "ACM Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//         { id: 7, name: "Expense Reimbursement", icon: "🧾", color: "#10b981", slug: "supplies" },

//     ];

//     const managementModulesList = [

//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "leave-management", badge: pendingLeavesCount },

//         { id: 2, name: "Employee Salary and Benefits", icon: "💳", color: "#3b82f6", slug: "employee-salary-benefits" },

//         { id: 3, name: "Employee OKR'S", icon: "🎯", color: "#f59e0b", slug: "employee-okrs" },

//         { id: 5, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: pendingRequestsCount },

//         { id: 6, name: "Own Finanacials", icon: "💰", color: "#10b981", slug: "pay and benefits" },

//         { id: 8, name: "Career Development", icon: "🏆", color: "#ec4899", slug: "career pathways" },

//         { id: 10, name: "Self OKR Tracker", icon: "🏁", color: "#f59e0b", slug: "okr and performance tracker" },
//         { id: 11, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         { id: 12, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         // { id: 21, name: "Manage Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates", badge: "PUSH" },

//         {
//             id: 21,
//             name: "ACM Updates",
//             icon: "📢",
//             color: "#00fff2",
//             slug: "manage-quarterly-updates",
//             badge: "PUSH"
//         },

//         // {
//         //   id: 15,
//         //   name: "EES Feedback Analytics",
//         //   icon: "📊",
//         //   color: "#00f2ff",
//         //   slug: "ees-analytics",
//         //   badge: "NEW"
//         // },

//         // { id: 14, name: "Skills Development", icon: "📚", color: "#06b6d4", slug: "career" },

//         {
//             id: 16,
//             name: "Medical Reports",
//             icon: "🏥",
//             color: "#f43f5e",
//             slug: "medical-reports",
//             badge: "DOCS"
//         },
//         {
//             id: 17,
//             name: "Policy RnU Status",
//             icon: "📋",
//             color: "#10b981",
//             slug: "policy-logs",
//             badge: "ADMIN"
//         },

//         // { 
//         //   id: 18, 
//         //   name: "Employee Documents", 
//         //   icon: "📂", 
//         //   color: "#f43f5e", 
//         //   slug: "manage-documents", 
//         //   badge: "VIEW" 
//         // },

//         {
//             id: 19,
//             name: "1:1 Connect",
//             icon: "🤝",
//             color: "#00fff2",
//             slug: "manager-one-on-one",

//             badge: "LIVE"
//         },

//         { id: 20, name: "Events and Celebrations", icon: "🎉", color: "#3b82f6", slug: "events-celebrations" },

//         {
//             id: 22,
//             name: "Expense Reimbursements",
//             icon: "💰",
//             color: "#22c55e",
//             slug: "reimbursements",
//             badge: "NEW"
//         },

//         // {
//         //     id: 23,
//         //     name: "WFH Requests",
//         //     icon: "🏠",
//         //     color: "#3b82f6",
//         //     slug: "manage-wfh-requests",
//         //     badge: "WFH"
//         // },


//     ];

//     const renderActiveModule = () => {

//         switch (activeModule) {

//             case "attendance-tracker":
//                 return <AttendanceTracker />;

//             case "CompanySetup":
//                 return <CompanySetup />;

//             case "create-invoice":
//                 return <InvoiceGenerator />;

//             case "my-profile":
//                 return (
//                     <MyProfile
//                         userData={userData}
//                         setUserData={setUserData}
//                         isEditing={isEditing}
//                         setIsEditing={setIsEditing}
//                         handleSave={handleSave}
//                         setShowPasswordModal={setShowPasswordModal}
//                     />
//                 );


//             case "reimbursements":
//                 if (role === "Management" || role === "Manager") {
//                     return <ReimbursementManagement />;
//                 }
//                 return <OfficeRequisition userData={userData} />;

//             case "manage-wfh-requests":
//                 return <WFHManagement />;


//             case "work-from-home":
//                 return <WorkFromHome />;


//             case "quarterly-updates":

//                 return <QuarterlyUpdates />;

//             case "manage-quarterly-updates":

//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementQuarterlyUpdate userData={userData} />;
//                 }
//                 return <QuarterlyUpdates />;


//             case "leave-management":
//                 // Unified behavior for Management and Manager
//                 if (role === 'Management' || role === 'Manager') {
//                     return <LeaveManagement userData={userData} />;
//                 }


//                 return <Attendance employeeId={employeeId} userData={userData} />;

//             case "manage-documents":
//                 if (role === 'Management') {
//                     return <ManageEmployeeDocs />;
//                 }
//                 return <Documents userData={userData} />;



//             // case "attendance":
//             //     if (role === 'Management') return <Attendance />;
//             //     return (
//             //         <Attendance
//             //             employeeId={userData.id}
//             //             empBadgeId={userData.EmpId}
//             //             userData={userData}
//             //         />
//             //     );
//             case "attendance":

//                 if (role === 'Management') {

//                     return (
//                         <Attendance
//                             employeeId={userData.id}
//                             empBadgeId={userData.EmpId}
//                             userData={userData}
//                         />
//                     );

//                 }

//                 return (
//                     <Attendance
//                         employeeId={userData.id}
//                         empBadgeId={userData.EmpId}
//                         userData={userData}
//                     />
//                 );


//             case "policy-logs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <PolicyAdminDashboard />;
//                 }

//                 return (
//                     <CompanyPolicy
//                         employeeId={userData.id}
//                         userData={userData}
//                     />
//                 );

//             case "events-celebrations":
//                 return <EventsCelebrations userData={userData} />;

//             case "pay and benefits": return <PayBenefits userData={userData} employeeId={employeeId} />;

//             // case "okr and performance tracker":
//             //     return <OKRTracker userData={userData} />;

//             case "okr and performance tracker":
//                 return (
//                     <OKRTracker
//                         userData={userData}
//                         defaultTab={location.state?.tab}
//                     />
//                 );

//             // Inside Dashboard.js -> renderActiveModule
//             // case "employee-okrs":
//             //     if (role === 'Management' || role === 'Manager') {
//             //         return (
//             //             <ManagementOKRViewer
//             //                 managerId={userData.id}
//             //                 userRole={role}
//             //                 // This is the CRITICAL line:
//             //                 managedDept={userData.HOD}
//             //             />
//             //         );
//             //     }
//             //     return <OKRTracker userData={userData} />;

//             case "employee-okrs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementOKRViewer userRole={role} />;
//                 }
//                 return <OKRTracker userData={userData} />;

//             case "career pathways": return <CareerPathways userData={userData} />;
//             case "add-department": return <AddDepartment />;
//             case "manage-department": return <ManageDepartment />;
//             case "add-employee": return <AddEmployee />;
//             case "manage-employee": return <ManageEmployee />;

//             case "employee-salary-benefits":
//                 return <EmployeeSalaryBenefits />;


//             case "equipment-request":
//                 if (role === "Management") {
//                     const pending = requestsList.filter(
//                         (r) => r.status?.toLowerCase() === "pending"
//                     );

//                     const history = requestsList.filter(
//                         (r) => r.status?.toLowerCase() !== "pending"
//                     );

//                     return (
//                         <div
//                             className="management-request-wrapper animate-fade"
//                             style={{ padding: "20px" }}
//                         >
//                             {/* Pending Queue */}
//                             <div
//                                 className="module-glass-card"
//                                 style={{ marginBottom: "30px" }}
//                             >
//                                 <h3 className="cyan-text">
//                                     ACTIVE_PENDING_QUEUE ({pending.length})
//                                 </h3>

//                                 {/* Desktop Table */}
//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>IMPACT</th>
//                                                 <th>ACTION</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {pending.length > 0 ? (
//                                                 pending.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                             >
//                                                                 {req.impact?.toUpperCase()}
//                                                             </span>
//                                                         </td>

//                                                         <td>
//                                                             <div className="equiptable-actions">
//                                                                 <button
//                                                                     className="equiptable-btn equiptable-approve"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Approved"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✔
//                                                                 </button>

//                                                                 <button
//                                                                     className="equiptable-btn equiptable-reject"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Rejected"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✖
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_PENDING_REQUESTS
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 {/* Mobile Cards */}
//                                 <div className="equiptable-mobile">
//                                     {pending.length > 0 ? (
//                                         pending.map((req) => (
//                                             <div
//                                                 className="equiptable-card"
//                                                 key={req.id}
//                                             >
//                                                 <div className="equiptable-row">
//                                                     <span>Employee</span>
//                                                     <strong>
//                                                         {req.employee_name}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Hardware</span>
//                                                     <strong>
//                                                         {req.equipment_type}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Impact</span>

//                                                     <span
//                                                         className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                     >
//                                                         {req.impact?.toUpperCase()}
//                                                     </span>
//                                                 </div>

//                                                 <div className="equiptable-actions">
//                                                     <button
//                                                         className="equiptable-btn equiptable-approve"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Approved"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✔ Approve
//                                                     </button>

//                                                     <button
//                                                         className="equiptable-btn equiptable-reject"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Rejected"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✖ Reject
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         ))
//                                     ) : (
//                                         <div className="equiptable-card">
//                                             NO_PENDING_REQUESTS
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Completed History */}
//                             <div
//                                 className="module-glass-card history-card"
//                                 style={{ opacity: 0.9 }}
//                             >
//                                 <h3
//                                     className="gray-text"
//                                     style={{ color: "#888" }}
//                                 >
//                                     📜 COMPLETED_HISTORY ({history.length})
//                                 </h3>

//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>DATE</th>
//                                                 <th>STATUS</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {history.length > 0 ? (
//                                                 history.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             {new Date(
//                                                                 req.updated_at ||
//                                                                 req.created_at
//                                                             ).toLocaleDateString(
//                                                                 "en-GB"
//                                                             )}
//                                                         </td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-status ${req.status?.toLowerCase()}`}
//                                                             >
//                                                                 {req.status?.toUpperCase()}
//                                                             </span>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_HISTORY_FOUND
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     );
//                 }

//                 return <EquipmentRequest userData={userData} />;

//             case "supplies": return <OfficeRequisition userData={userData} />;
//             // case "it": return <ITSupport userData={userData} />;
//             case "documents": return <Documents userData={userData} />;
//             // case "company-policy": return <CompanyPolicy />;
//             case "company-policy":
//                 return <CompanyPolicy userData={userData} />;
//             case "Organization Chart": return <OrgChart userData={userData} />;
//             // case "campus information": return <CampusInfo />;
//             case "campus information":
//                 return <CampusInfo userData={userData} />;
//             case "ees-survey": return <EESExperience userData={userData} />;

//             case "ees-analytics":
//                 if (role === 'Management' || role === 'Manager') {
//                     // Management sees the list of real data
//                     return <EESFeedbackManagement feedbacks={eesSubmissions} />;
//                 }
//                 // Employee sees the form
//                 return <EESExperience userData={userData} onFinalSubmit={handleEESSubmit} />;

//             //       case "one-on-one":
//             // return <OneOnOne userData={userData} role={role} />;

//             case "one-on-one":
//                 // This is the PERSONAL view (Employee mode)
//                 return <OneOnOne userData={userData} role="Employee" viewMode="personal" />;

//             case "manager-one-on-one":
//                 // This is the MANAGERIAL view (Manager/Management mode)
//                 return <OneOnOne userData={userData} role={role} viewMode="managerial" />;

//             // Inside Dashboard.js renderActiveModule
//             case "medical-reports":
//                 if (role === 'Management') return <MedicalReports />;
//                 if (role === 'Manager') {
//                     return (
//                         <ManagerMedicalReports
//                             managerId={userData.id}           // Database Primary Key
//                             managerBadgeId={userData.EmpId}   // Company ID (HOD flag often matches this)
//                             managerDept={userData.Department} // The string "Software Development"
//                         />
//                     );
//                 }

//             case "employee-it-support":
//                 return <EquipmentRequest userData={userData} />;

//             default:


//                 if (role === 'Manager') {
//                     return renderManagerDashboard();
//                 }

//                 const currentList = role === 'Management' ? managementModulesList : employeeModulesList;
//                 return (
//                     <section className="bento-grid">
//                         {currentList.map((mod) => (
//                             <div key={mod.id} className="bento-card glass" style={{ "--accent": mod.color }} onClick={() => handleModuleChange(mod.slug)}>
//                                 <div className="card-top">
//                                     <span className="mod-icon">{mod.icon}</span>
//                                     {mod.badge > 0 && <span className={role === 'Management' ? "card-badge" : "notification-badge-ui"}>{mod.badge}</span>}
//                                 </div>
//                                 <div className="card-info"><h3>{mod.name}</h3><div className="cyber-line"></div></div>
//                             </div>
//                         ))}
//                     </section>
//                 );
//         }
//     };

//     const [companyLogo, setCompanyLogo] = useState("");
//     const currentLogo = theme === 'light' ? logoLight : logoDark;


//     const [leaveStats, setLeaveStats] = useState({
//         pending: 0,
//         approved: 0,
//         rejected: 0,
//         wfhPending: 0
//     });

//     useEffect(() => {
//         if (role !== "Management") return;

//         const fetchLeaveStats = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];


//                     const pending = leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                     const approved = leaves.filter(l => l.Status === '1').length;
//                     const rejected = leaves.filter(l => l.Status === '2').length;

//                     // WFH
//                     const wfhRes = await fetch("/gt-api/get_all_wfh_requests.php", {
//                         credentials: "include"
//                     });
//                     const wfhData = await wfhRes.json();

//                     const wfhPending = wfhData.success
//                         ? wfhData.requests.filter(r => r.status === "Pending").length
//                         : 0;

//                     setLeaveStats({ pending, approved, rejected, wfhPending });
//                 }

//             } catch (err) {
//                 console.error("Leave Stats Error:", err);
//             }
//         };

//         fetchLeaveStats();
//         const interval = setInterval(fetchLeaveStats, 5000);

//         return () => clearInterval(interval);
//     }, [role]);


//     const [mgmtLeaves, setMgmtLeaves] = useState([]);
//     const [mgmtActiveTeam, setMgmtActiveTeam] = useState("All");

//     useEffect(() => {
//         const fetchLeaves = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();
//                 if (data.success) setMgmtLeaves(data.leaves);
//             } catch (err) {
//                 console.error("Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaves();
//     }, []);





//     const mgmtChartData = useMemo(() => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept => dept.DepartmentName
//             );

//         const now = new Date();
//         const currentMonth = (now.getMonth() + 1).toString();
//         const currentYear = now.getFullYear().toString();

//         const teamList = mgmtActiveTeam === "All" ? teams : [mgmtActiveTeam];

//         return teamList.map(team => {

//             const filtered = mgmtLeaves.filter(l => {
//                 const dateParts = l.fromdate?.split("-");
//                 const lYear = dateParts?.[0];
//                 const lMonth = dateParts?.[1]
//                     ? parseInt(dateParts[1]).toString()
//                     : "";

//                 return (
//                     l.Department === team &&
//                     lMonth === currentMonth &&
//                     lYear === currentYear
//                 );
//             });

//             return {
//                 name: team,

//                 // ✅ SUM OF UNITS (FIXED)
//                 Approved: filtered
//                     .filter(l => l.Status === "1")
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

//                 Pending: filtered
//                     .filter(l => l.Status === "0" || l.Status === null)
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
//             };
//         });

//     }, [mgmtLeaves, mgmtActiveTeam]);


//     const renderManagementLeaveCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept =>
//                     dept.DepartmentName
//             );

//         return (
//             <div
//                 className="mgmt-leave-analytics clickable"
//                 onClick={() => handleModuleChange("leave-management")}
//             >

//                 <div className="card-header">
//                     <h3>Employee Leave Analytics</h3>
//                     <span className="sub-text">This Month</span>
//                 </div>

//                 {/* TEAM CHIPS */}
//                 <div className="team-row">
//                     <div
//                         className={`team-chip ${mgmtActiveTeam === "All" ? "active" : ""}`}
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             setMgmtActiveTeam("All");
//                         }}
//                     >
//                         ALL
//                     </div>

//                     {teams.map((team, i) => (
//                         <div
//                             key={i}
//                             className={`team-chip ${mgmtActiveTeam === team ? "active" : ""}`}
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 setMgmtActiveTeam(team);
//                             }}
//                         >
//                             {team}
//                         </div>
//                     ))}
//                 </div>

//                 {/* CHART */}
//                 {(() => {
//                     const isSingle = mgmtActiveTeam !== "All";

//                     return (
//                         <div className={`chart-area ${isSingle ? "single-view" : ""}`}>
//                             <ResponsiveContainer width="100%" height={170}>
//                                 <BarChart
//                                     data={mgmtChartData}
//                                     barCategoryGap={isSingle ? "70%" : "30%"}
//                                     margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
//                                 >

//                                     {/* GRADIENTS */}
//                                     <defs>
//                                         <linearGradient id="approvedGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#34d399" />
//                                             <stop offset="100%" stopColor="#059669" />
//                                         </linearGradient>

//                                         <linearGradient id="pendingGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#fbbf24" />
//                                             <stop offset="100%" stopColor="#f59e0b" />
//                                         </linearGradient>
//                                     </defs>

//                                     <CartesianGrid
//                                         strokeDasharray="3 3"
//                                         stroke="rgba(255,255,255,0.05)"
//                                         vertical={false}
//                                     />

//                                     <XAxis
//                                         dataKey="name"
//                                         tick={{ fill: "#888", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <YAxis
//                                         tick={{ fill: "#666", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <Tooltip
//                                         cursor={{ fill: "rgba(255,255,255,0.05)" }}
//                                         contentStyle={{
//                                             backgroundColor: "rgba(15, 23, 42, 0.95)", // dark glass
//                                             border: "1px solid rgba(0,255,242,0.3)",
//                                             borderRadius: "10px",
//                                             color: "#ffffff",
//                                             backdropFilter: "blur(8px)"
//                                         }}
//                                         labelStyle={{ color: "#00fff2", fontWeight: 600 }}
//                                         itemStyle={{ color: "#ffffff" }}
//                                     />


//                                     <Bar
//                                         dataKey="Approved"
//                                         stackId="a"
//                                         fill="url(#approvedGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                     <Bar
//                                         dataKey="Pending"
//                                         stackId="a"
//                                         fill="url(#pendingGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                 </BarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     );
//                 })()}


//                 <div className="card-footer">
//                     <span>Open Leave Console</span>
//                     <span>→</span>
//                 </div>
//             </div>
//         );
//     };

//     const renderSalaryIntelCard = () => {
//         // 1. Existing Counts
//         const payslips = payData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = payData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = payData.filter(d => d.doc_type === "APPRAISAL LETTER").length;

//         // 2. New Miscellaneous Count (Filtering for the images you provided)
//         const miscDocs = [
//             "FNF LETTER", "OFFER LETTER", "RELIEVING LETTER",
//             "EXPERIENCE LETTER", "EMPLOYEMENT AGREEMENT", "BANK ACCOUNT OPENING"
//         ];
//         const miscellaneous = payData.filter(d => miscDocs.includes(d.doc_type)).length;

//         // 3. Updated Total
//         const total = payslips + form16 + appraisal + miscellaneous;

//         // 4. SVG Math for 4 segments
//         const chartTotal = 125.6;
//         const gap = total > 0 ? 2 : 0;

//         const s1 = (payslips / total) * chartTotal || 0;
//         const s2 = (form16 / total) * chartTotal || 0;
//         const s3 = (appraisal / total) * chartTotal || 0;
//         const s4 = (miscellaneous / total) * chartTotal || 0;

//         return (
//             <div className="sa-card-wrapper" onClick={() => handleModuleChange("employee-salary-benefits")}>


//                 <div className="sa-card-header">
//                     <h3 className="sa-title">Salary Document Insights</h3>
//                     <button className="sa-menu-trigger">⋮</button>
//                 </div>

//                 <div className="sa-main-body">
//                     <div className="sa-gauge-area">
//                         <div className="sa-gauge-container">
//                             <svg viewBox="0 0 100 55" className="sa-gauge-svg">
//                                 {/* Background Track */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="var(--sa-track)" strokeWidth="9" strokeLinecap="round" />

//                                 {/* Segment 4: Misc (Blue) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#0ea5e9" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s4 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2 + s3}`} />

//                                 {/* Segment 3: Appraisals (Orange) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#f97316" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s3 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2}`} />

//                                 {/* Segment 2: Form 16 (Yellow) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#fbbf24" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s2 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1}`} />

//                                 {/* Segment 1: Payslips (Purple) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#8b5cf6" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s1 - gap)} ${chartTotal}`}
//                                     strokeDashoffset="0" />
//                             </svg>

//                             <div className="sa-gauge-text">
//                                 <span className="sa-overall-num">{total}</span>
//                                 <span className="sa-overall-label">Overall</span>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="sa-legend-area">
//                         {[
//                             { label: "Payslips", count: payslips, color: "purple" },
//                             { label: "Form 16", count: form16, color: "yellow" },
//                             { label: "Appraisals", count: appraisal, color: "orange" },
//                             { label: "Miscellaneous", count: miscellaneous, color: "blue" }
//                         ].map((item, index) => (
//                             <div key={index} className="sa-legend-item">
//                                 <div className="sa-item-top">
//                                     <span className={`sa-dot ${item.color}`}></span>
//                                     <span className="sa-item-count">{item.count}</span>
//                                 </div>
//                                 <span className="sa-item-label">{item.label}</span>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <div className="sa-card-footer">
//                     <span className="sa-footer-link">View Detailed Report →</span>
//                 </div>
//             </div>
//         );
//     };



//     const [okrData, setOkrData] = useState([]);
//     useEffect(() => {
//         if (!userData?.id) return;

//         const fetchOKR = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/get_user_okr.php?empId=${userData.id}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     const parsed = typeof data.data === "string"
//                         ? JSON.parse(data.data)
//                         : data.data;

//                     setOkrData(parsed);
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchOKR();

//     }, [userData?.id]);



//     const [okrStats, setOkrStats] = useState({
//         total: 0,
//         completed: 0,
//         pending: 0,
//         progressPercent: 0
//     });



//     const fetchOKRStats = async () => {
//         if (!userData?.EmpId) return;

//         try {
//             const res = await fetch(
//                 `/gt-api/get_okr_stats.php?empId=${userData.EmpId}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setOkrStats(data);
//             }

//         } catch (err) {
//             console.error("OKR STATS ERROR:", err);
//         }
//     };

//     useEffect(() => {
//         if (!userData?.EmpId) return;

//         fetchOKRStats();

//         const handleUpdate = () => fetchOKRStats();

//         window.addEventListener("okrUpdated", handleUpdate);

//         return () => window.removeEventListener("okrUpdated", handleUpdate);

//     }, [userData?.EmpId]);




//     const renderOKRCard = () => {
//         const { total, completed, pending, progressPercent } = okrStats;

//         return (
//             <div
//                 className="expanded-management-card clickable"
//                 onClick={() => handleModuleChange("okr and performance tracker")}
//             >
//                 <div className="okr-card-container">

//                     {/* HEADER */}
//                     <div className="okr-header">
//                         <div>
//                             <span className="eyebrow-text">Performance Tracker</span>
//                             <h2 className="display-title">OKR Progress</h2>
//                         </div>

//                         {/* TOP RIGHT TOTAL */}
//                         <div className="stat-box featured big">
//                             <span className="stat-label">Total KR</span>
//                             <span className="stat-value">{total}</span>
//                         </div>
//                     </div>

//                     {/* STATS ROW */}
//                     <div className="okr-stats-row">
//                         <div className="stat-box danger">
//                             <span className="stat-label">Pending</span>
//                             <span className="stat-value">{pending}</span>
//                         </div>

//                         <div className="stat-box success">
//                             <span className="stat-label">Completed</span>
//                             <span className="stat-value">{completed}</span>
//                         </div>
//                     </div>

//                     {/* PROGRESS FULL WIDTH */}
//                     <div className="progress-section-wide full">
//                         <div className="progress-labels">
//                             <span className="label-muted">Completion</span>
//                             <span className="label-bold">{progressPercent}%</span>
//                         </div>

//                         <div className="wide-bar-bg">
//                             <div
//                                 className="wide-bar-fill"
//                                 style={{ width: `${progressPercent}%` }}
//                             ></div>
//                         </div>
//                     </div>

//                     {/* FOOTER */}
//                     <div className="expanded-footer">
//                         <span className={`status-indicator ${pending > 0 ? 'is-warning' : 'is-clear'}`}>
//                             {pending > 0
//                                 ? `● ${pending} Key Results Pending`
//                                 : '● All Key Results Completed'}
//                         </span>

//                         <span className="interaction-hint">
//                             Open OKR Console →
//                         </span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     const [mgmtOneOnOneData, setMgmtOneOnOneData] = useState([]);
//     useEffect(() => {
//         const fetchMeetings = async () => {
//             const storedUser = localStorage.getItem('userData');
//             const user = JSON.parse(storedUser) || {};

//             const res = await fetch(
//                 `/gt-api/get_oneonone.php?manager_id=${user.id}&role=manager`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.meetings) {
//                 setMgmtOneOnOneData(data.meetings);
//             }
//         };

//         fetchMeetings();
//     }, []);

//     const renderOneOnOneHealthCard = () => {
//         const missedData = mgmtOneOnOneData.filter(m => m.status === "MISSED");

//         const total = mgmtOneOnOneData.length;
//         const missed = mgmtOneOnOneData.filter(m => m.status === "MISSED").length;
//         const completed = total - missed;

//         const rate = total > 0 ? Math.round((completed / total) * 100) : 0;

//         let status = "Healthy";
//         if (rate < 50) status = "Critical ⚠️";
//         else if (rate < 80) status = "Needs Attention";

//         return (
//             <div className="meeting-card" onClick={() => handleModuleChange("manager-one-on-one")}>

//                 <div className="mc-header">
//                     <h3>1:1 Meeting Scheduler</h3>
//                     <span>{status}</span>
//                 </div>

//                 {/* BIG NUMBER */}
//                 <div className="mc-center">
//                     <h1>{rate}%</h1>
//                     <p>Engagement</p>
//                 </div>

//                 {/* BARS */}
//                 <div className="mc-bars">
//                     <div className="bar completed" style={{ width: `${rate}%` }}></div>
//                     <div className="bar missed" style={{ width: `${100 - rate}%` }}></div>
//                 </div>

//                 {/* INFO */}
//                 <div className="mc-info">
//                     <span>✅ {completed} Done</span>
//                     <span>❌ {missed} Missed</span>
//                 </div>
//                 <button
//                     className="view-missed-btn"
//                     onClick={(e) => {
//                         e.stopPropagation();
//                         setShowMissedModal(true);
//                     }}
//                 >
//                     View Missed
//                 </button>

//             </div>
//         );
//     };

//     const [okrActivity, setOkrActivity] = useState([]);
//     useEffect(() => {
//         const fetchOKR = async () => {
//             try {
//                 const storedUser = localStorage.getItem("userData");
//                 const user = JSON.parse(storedUser) || {};

//                 const res = await fetch(
//                     `/gt-api/get_employee_okrs.php?role=${user.role}&managedDept=${user.department}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 if (data.success) {
//                     setOkrActivity(data.data);
//                 }

//             } catch (err) {
//                 console.error("OKR Fetch Error:", err);
//             }
//         };

//         fetchOKR();
//     }, []);

//     const recentOKR = okrActivity
//         .slice(0, 5)
//         .map(item => {
//             let type = "updated";

//             if (item.workflow_status === "Planning") {
//                 type = "new";
//             }

//             if (item.workflow_status === "Manager_Scoring_Review") {
//                 type = "pending";
//             }

//             return {
//                 name: item.emp_name,
//                 quarter: item.quarter,
//                 type,
//                 workflow_status: item.workflow_status   // 🔥 VERY IMPORTANT
//             };
//         });



//     const renderOKRActivityCard = () => {
//         const getStatusConfig = (status) => {
//             switch (status) {
//                 case "Planning": return { color: "#3b82f6", label: "submitted OKR" };
//                 case "Management_Review": return { color: "#f59e0b", label: "sent for Review" };
//                 case "Scoring": return { color: "#8b5cf6", label: "sent for Scoring" };
//                 case "Sign_Off": return { color: "#10b981", label: "finalized OKR" };
//                 default: return { color: "#00bcd4", label: "updated OKR" };
//             }
//         };

//         return (
//             <div className="mgt-okr-card1 timeline-style clickable" onClick={() => handleModuleChange("employee-okrs")}>
//                 <div className="card-header-v2">
//                     <div className="title-section">
//                         <h3>OKR Stream</h3>
//                         <div className="live-dot-wrapper">
//                             <span className="live-dot"></span>
//                             <span className="sub-text">Live updates</span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="okr-activity-timeline">
//                     {recentOKR.length === 0 ? (
//                         <div className="empty-state">No recent activity detected</div>
//                     ) : (
//                         recentOKR.slice(0, 3).map((item, i) => {
//                             const config = getStatusConfig(item.workflow_status);
//                             return (
//                                 <div key={i} className="timeline-item">
//                                     {/* The Vertical Line & Dot */}
//                                     <div className="timeline-visual">
//                                         <div className="timeline-line"></div>
//                                         <div className="timeline-marker" style={{ borderColor: '#111827', background: config.color }}>
//                                             <div className="marker-inner-dot"></div>
//                                         </div>
//                                     </div>

//                                     {/* Single Content Box */}
//                                     <div className="timeline-content-box">
//                                         <div className="content-top">
//                                             <span className="emp-name">{item.name}</span>
//                                             <span className="quarter-tag">{item.quarter}</span>
//                                         </div>
//                                         <p className="status-message">{config.label}</p>
//                                     </div>
//                                 </div>
//                             );
//                         })
//                     )}
//                 </div>

//                 <div className="card-footer-v2">
//                     <span>Access Module</span>
//                     {/* <div className="arrow-circle">→</div> */}
//                 </div>


//             </div>
//         );
//     };

//     const renderManagementShortcutsCard = () => {
//         const shortcuts = [

//             { name: "Create Invoice", icon: "🏦", slug: "create-invoice" },
//             { name: "Policy RnU", icon: "📋", slug: "policy-logs" },
//             { name: "Career Development", icon: "🏆", slug: "career pathways" },
//             { name: "Expense Reimbursement", icon: "💰", slug: "reimbursements" },
//             // { name: "ACM Updates", icon: "📢", slug: "manage-quarterly-updates" },
//             { name: "Self OKR", icon: "🎯", slug: "okr and performance tracker" },
//             { name: "Own Financial", icon: "💳", slug: "pay and benefits" },
//             { name: "Access ACM Info", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//             // { name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },
//             { name: "IT Support", icon: "🖥️", slug: "employee-it-support" },
//             { name: "Attendance Tracker", icon: "📊", slug: "attendance-tracker" },
//             // { name: "Company Setup", icon: "⚙️", slug: "CompanySetup" },





//         ];

//         return (
//             <div className="mgt-shortcut-card">

//                 <div className="card-header">
//                     <h3>Quick Access</h3>
//                     <span className="sub-text">Shortcuts</span>
//                 </div>

//                 <div className="shortcut-grid">
//                     {shortcuts.map((item, i) => (
//                         <div
//                             key={i}
//                             className="shortcut-item"
//                             onClick={() => handleModuleChange(item.slug)}
//                         >
//                             <span className="shortcut-icon">{item.icon}</span>
//                             <span className="shortcut-text">{item.name}</span>
//                         </div>
//                     ))}
//                 </div>

//             </div>
//         );
//     };


//     const renderEmployeeDashboard = () => {
//         return (
//             <div className="dashboard-layout">

//                 <div className="dashboard-row row-top">
//                     {renderLeavePieChart()}
//                     {renderPayChart()}
//                     {renderOneOnOneCard()}



//                     {/* {renderEquipmentCard()} */}
//                 </div>

//                 <div className="dashboard-row row-middle">
//                     {renderOKRCard()}
//                     {renderCareerPathwaysCard()}
//                 </div>

//                 <div className="dashboard-row row-bottom">
//                     {renderPolicyCard()}
//                     <QuarterlyCard handleModuleChange={handleModuleChange} />
//                 </div>

//             </div>
//         );
//     };

//     const renderManagementDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>






//         );
//     };

//     const renderManagerDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>




//         );
//     };

//     const currentEvent =
//         todayEvents && todayEvents.length > 0
//             ? todayEvents[currentEventIndex]
//             : null;


//     const combinedEvents = [];

//     // 🎂 Birthday / Anniversary
//     if (currentEvent && currentEvent.fullName) {
//         combinedEvents.push({
//             type: "event",
//             title: currentEvent.fullName,
//             tag: currentEvent.isBirthday ? "BIRTHDAY" : "WORK ANNIVERSARY",
//             icon: currentEvent.isBirthday ? "🎂" : "🎉"
//         });
//     }

//     // 🎊 Festival
//     if (upcomingFestival) {
//         combinedEvents.push({
//             type: "festival",
//             title: upcomingFestival.name,
//             tag: isFestivalToday ? "FESTIVAL TODAY" : "UPCOMING FESTIVAL",
//             icon: "🎊",
//             sub: isFestivalToday ? "Today 🎉" : `In ${daysLeft} days`
//         });
//     }

//     useEffect(() => {
//         if (combinedEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setActiveEventIndex(prev => (prev + 1) % combinedEvents.length);
//         }, 4000);

//         return () => clearInterval(interval);
//     }, [combinedEvents.length]);

//     const activeEvent = combinedEvents[activeEventIndex];


//     return (

//         <div


//             className={`dash-container ${theme}-theme`}
//             style={
//                 theme === 'light'
//                     ? {
//                         backgroundImage: `url(${logoLight})`,
//                         backgroundSize: 'cover',
//                         backgroundRepeat: 'no-repeat',
//                         backgroundPosition: 'center',
//                         backgroundColor: 'var(--bg-main)'

//                     }
//                     : {}
//             }
//         >


//             {showMissedModal && (
//                 <div className="modal-overlay" onClick={() => setShowMissedModal(false)}>
//                     <div className="modal-card" onClick={(e) => e.stopPropagation()}>

//                         <h3>Missed 1:1 Meetings</h3>

//                         {mgmtOneOnOneData.filter(m => m.status === "MISSED").length === 0 ? (
//                             <p>No missed meetings 🎉</p>
//                         ) : (
//                             mgmtOneOnOneData
//                                 .filter(m => m.status === "MISSED")
//                                 .map((m, i) => (
//                                     <div key={i} className="missed-item">
//                                         <strong>{m.employee_name}</strong>
//                                         <span>{m.date}</span>
//                                     </div>
//                                 ))
//                         )}

//                         <button onClick={() => setShowMissedModal(false)}>
//                             Close
//                         </button>

//                     </div>
//                 </div>
//             )}



//             <div className="auth-background-overlay"></div>






//             <Sidebar
//                 role={role}
//                 userData={userData}
//                 activeModule={activeModule}
//                 openMenus={openMenus}
//                 toggleSubMenu={toggleSubMenu}
//                 handleModuleChange={handleModuleChange}
//                 handleLogout={handleLogout}
//                 mobileMenuOpen={mobileMenuOpen}
//                 setMobileMenuOpen={setMobileMenuOpen}
//                 pendingRequestsCount={pendingRequestsCount}
//             />

//             <main className="dash-content">

//                 <header className="content-header">

//                     {/* 🔷 LEFT */}
//                     <div className="header-left">
//                         <div className="header-text">

//                             <h1>
//                                 {activeModule === "grid" && !showProfile ? "Welcome," : ""}{" "}
//                                 <span className={theme === 'light' ? "name-light" : "name-accent"}>
//                                     {showProfile
//                                         ? "MY PROFILE"
//                                         : (activeModule === "grid"
//                                             ? userData.firstName || userData.FirstName
//                                             : (activeModule === "attendance"
//                                                 ? "LEAVE MANAGEMENT"
//                                                 : activeModule.toUpperCase().replace('-', ' ')
//                                             )
//                                         )
//                                     }
//                                 </span>
//                             </h1>

//                             {activeModule === 'attendance' && userData.joiningDate && (
//                                 <div className="joining-info">
//                                     JOINING_DATE: {new Date(userData.joiningDate).toLocaleDateString('en-GB').toUpperCase()}
//                                 </div>
//                             )}

//                         </div>
//                     </div>







//                     <div className="header-center">

//                         {/* TIME + DATE FIRST */}
//                         <div className="time-date-right">
//                             <div className="live-time">{currentTime}</div>

//                             <div className="today-widget">
//                                 <span>📅 {todayDate}</span>
//                                 <small>Have a Nice Day!</small>
//                             </div>
//                         </div>

//                         {/* EVENT CARD SECOND */}
//                         <div
//                             className={`executive-event-bar ${theme === 'light' ? 'light-theme-elite' : 'dark-theme-elite'}
//         ${role === "Management" || role === "Manager" ? "clickable" : ""}`}
//                             onClick={() => {
//                                 if (role === "Management" || role === "Manager") {
//                                     handleModuleChange("events-celebrations");
//                                 }
//                             }}
//                         >
//                             <div
//                                 className={`event-status-box ${currentEvent
//                                     ? (currentEvent.isBirthday ? 'bg-birth' : 'bg-anniv')
//                                     : 'bg-neutral'
//                                     }`}
//                             >
//                                 <span className="event-icon-small">
//                                     {currentEvent
//                                         ? (currentEvent.isBirthday ? "🎂" : "🎉")
//                                         : "✨"}
//                                 </span>
//                             </div>

//                             <div className="event-content-main">
//                                 <div className="event-label-row">
//                                     <span className="event-tag">
//                                         {activeEvent ? activeEvent.tag : "TODAY"}
//                                     </span>
//                                 </div>

//                                 <h3 className="event-title-text">

//                                     {activeEvent ? (
//                                         <span className="event-highlight">
//                                             {activeEvent.icon} {activeEvent.title}
//                                         </span>
//                                     ) : (
//                                         <span className="event-empty-text">
//                                             No events today
//                                         </span>
//                                     )}
//                                 </h3>
//                             </div>

//                             <div className="event-action-wrapper">
//                                 <button
//                                     className="minimal-wish-btn"
//                                     disabled={!currentEvent}
//                                     onClick={(e) => e.stopPropagation()}
//                                 >
//                                     <div className="btn-line"></div>
//                                 </button>
//                             </div>
//                         </div>

//                     </div>







//                     <div className="header-controls">

//                         {/* 🌗 THEME */}
//                         <div className="theme-switch-container">
//                             <label className="theme-slider-switch">
//                                 <input
//                                     type="checkbox"
//                                     onChange={toggleTheme}
//                                     checked={theme === 'light'}
//                                 />
//                                 <span className="theme-slider round">
//                                     <span className="sun-icon">☀️</span>
//                                     <span className="moon-icon">🌙</span>
//                                 </span>
//                             </label>
//                         </div>




//                         {(activeModule !== "grid" || showProfile) && (
//                             <button
//                                 className="back-btn"
//                                 onClick={() => handleModuleChange("grid")}
//                             >
//                                 Back
//                             </button>
//                         )}

//                     </div>

//                 </header>


//                 {activeModule === "grid" ? (

//                     role === "Management"
//                         ? renderManagementDashboard()
//                         : role === "Manager"
//                             ? renderManagerDashboard()   // 🔥 ADD THIS LINE
//                             : renderEmployeeDashboard()

//                 ) : (
//                     renderActiveModule()
//                 )}

//                 <div className="dash-footer">
//                     Design & Developed by Genesis Tech Engineers © 2026
//                 </div>
//             </main>

//             {(role === "Management" || role === "Manager") && (
//                 <>
//                     <div
//                         className="ai-chat-float-btn"
//                         onClick={() => setShowAIChat(true)}
//                     >
//                         🤖
//                     </div>

//                     {showAIChat && (
//                         <div className="ai-chat-modal">
//                             <div className="ai-chat-header">
//                                 <span>ELMS AI Assistant</span>
//                                 <button onClick={() => setShowAIChat(false)}>
//                                     ✕
//                                 </button>
//                             </div>

//                             <div className="ai-chat-body">
//                                 {chatMessages.map((msg, index) => (
//                                     <div
//                                         key={index}
//                                         className={`chat-bubble ${msg.sender}`}
//                                     >
//                                         <pre>{msg.text}</pre>
//                                     </div>
//                                 ))}

//                                 {chatLoading && (
//                                     <div className="chat-bubble ai">
//                                         Thinking...
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="ai-chat-footer">
//                                 <input
//                                     type="text"
//                                     value={chatInput}
//                                     onChange={(e) => setChatInput(e.target.value)}
//                                     placeholder="Ask anything..."
//                                     onKeyDown={(e) => {
//                                         if (e.key === "Enter") {
//                                             sendAIMessage();
//                                         }
//                                     }}
//                                 />

//                                 <button onClick={sendAIMessage}>
//                                     Send
//                                 </button>
//                             </div>
//                         </div>
//                     )}
//                 </>
//             )}

//             {/* 🔴 MANDATORY PROFILE POPUP MODAL */}
//             {showMandatoryProfileModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">⚠️</div>
//                             <h2>Mandatory Profile Completion Required</h2>
//                             <p>
//                                 Your employee profile has missing information. Please fill in the required field(s) below to continue using the system.
//                             </p>
//                         </div>

//                         {mandatoryError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {mandatoryError}</span>
//                             </div>
//                         )}

//                         {mandatorySuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {mandatorySuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryProfile} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingProfileFields.phone && (
//                                     <div className="mandatory-input-group">
//                                         <label>Mobile Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="tel"
//                                             placeholder="Enter mobile number"
//                                             value={mandatoryFormData.phone}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, phone: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.dob && (
//                                     <div className="mandatory-input-group">
//                                         <label>Date of Birth <span className="req-star">*</span></label>
//                                         <input
//                                             type="date"
//                                             max={new Date().toISOString().split("T")[0]}
//                                             value={mandatoryFormData.dob}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, dob: e.target.value }))}
//                                             onClick={(e) => {
//                                                 try {
//                                                     if (e.target.showPicker) e.target.showPicker();
//                                                 } catch (err) {}
//                                             }}
//                                             required
//                                             className="mandatory-date-input"
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.city && (
//                                     <div className="mandatory-input-group">
//                                         <label>City <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter city"
//                                             value={mandatoryFormData.city}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, city: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.country && (
//                                     <div className="mandatory-input-group">
//                                         <label>Country <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter country"
//                                             value={mandatoryFormData.country}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, country: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Permanent Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter permanent address"
//                                             value={mandatoryFormData.address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.local_address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Current / Local Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter current / local address"
//                                             value={mandatoryFormData.local_address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, local_address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={mandatorySaving}
//                                 >
//                                     {mandatorySaving ? "Saving Profile..." : "Save Profile & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//             {/* 🏦 MANDATORY BANK DETAILS POPUP MODAL */}
//             {showMandatoryBankModal && !showMandatoryProfileModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">🏦</div>
//                             <h2>Mandatory Bank Details Required</h2>
//                             <p>
//                                 Your employee bank record has missing information. Please fill in the required field(s) below for payroll & salary processing.
//                             </p>
//                         </div>

//                         {bankError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {bankError}</span>
//                             </div>
//                         )}

//                         {bankSuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {bankSuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryBankDetails} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingBankFields.bankName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Bank Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC Bank, ICICI Bank"
//                                             value={bankFormData.bankName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, bankName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.holderName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Holder Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account holder name"
//                                             value={bankFormData.holderName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, holderName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accNumber && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account number"
//                                             value={bankFormData.accNumber}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accNumber: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.ifsc && (
//                                     <div className="mandatory-input-group">
//                                         <label>IFSC Code <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC0001234"
//                                             value={bankFormData.ifsc}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, ifsc: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.branch && (
//                                     <div className="mandatory-input-group">
//                                         <label>Branch Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter branch name"
//                                             value={bankFormData.branch}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, branch: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accType && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Type <span className="req-star">*</span></label>
//                                         <select
//                                             value={bankFormData.accType}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accType: e.target.value }))}
//                                             required
//                                         >
//                                             <option value="Saving Account">Saving Account</option>
//                                             <option value="Current Account">Current Account</option>
//                                             <option value="Salary Account">Salary Account</option>
//                                         </select>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={bankSaving}
//                                 >
//                                     {bankSaving ? "Saving Bank Details..." : "Save Bank Details & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Dashboard;







































// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';

// import {
//     ResponsiveContainer,
//     BarChart,
//     Bar,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip
// } from "recharts";
// import { Bar as ChartBar, Pie, Doughnut } from 'react-chartjs-2';

// // ✅ REACT + ROUTER
// import React, { useState, useEffect, useMemo } from 'react';
// import { useParams, useNavigate, useLocation } from 'react-router-dom';

// // ✅ MODULES
// import Attendance from '../../modules/Attendance';
// import PayBenefits from '../../modules/PayBenefits';
// import OKRTracker from '../../modules/OKRTracker';
// import CareerPathways from '../../modules/CareerPathways';
// import EquipmentRequest from '../../modules/EquipmentRequest';
// import OfficeRequisition from '../../modules/OfficeRequisition';
// import ITSupport from '../../modules/ITSupport';
// import Documents from '../../modules/Documents';
// import CompanyPolicy from '../../modules/CompanyPolicy';
// import OrgChart from '../../modules/OrgChart';
// import CampusInfo from '../../modules/CampusInfo';
// import AddDepartment from '../../modules/AddDepartment';
// import AddEmployee from '../../modules/AddEmployee';
// import ManageDepartment from '../../modules/ManageDepartment';
// import ManageEmployee from '../../modules/ManageEmployee';
// import MyProfile from '../../modules/MyProfile';
// import LeaveManagement from '../../modules/LeaveManagement';
// import EESExperience from '../../modules/EESExperience';
// import EESFeedbackManagement from '../../modules/EESFeedbackManagement';
// import MedicalReports from '../../modules/MedicalReports';
// import ManagementOKRViewer from '../../modules/ManagementOKRViewer';
// import ManagerLeaveManagement from '../../modules/ManagerLeaveManagement';
// import ManagerMedicalReports from '../../modules/ManagerMedicalReports';
// import EmployeeSalaryBenefits from '../../modules/EmployeeSalaryBenefits';
// import PolicyAdminDashboard from '../../modules/PolicyAdminDashboard';
// import ManageEmployeeDocs from '../../modules/ManageEmployeeDocs';
// import OneOnOne from '../../modules/OneOnOne';
// import EventsCelebrations from '../../modules/EventsCelebrations';
// import ProjectModule from '../../modules/ProjectModule';
// import QuarterlyUpdates from '../../modules/QuarterlyUpdates';
// import ManagementQuarterlyUpdate from '../../modules/ManagementQuarterlyUpdate';
// import ReimbursementManagement from '../../modules/ReimbursementManagement';
// import WorkFromHome from '../../modules/WorkFromHome';
// import WFHManagement from '../../modules/WFHManagement';
// import OneOnOneAnalyticsCard from "../../modules/OneOnOneAnalyticsCard";
// import OneOnOneReport from '../../modules/OneOnOneReport';
// import InvoiceGenerator from '../../modules/InvoiceGenerator';
// import AttendanceTracker from '../../modules/AttendanceTracker';
// import CompanySetup from '../../modules/CompanySetup';
// import Sidebar from "../../components/Sidebar/sidebar";

// // ✅ ASSETS
// import logoLight from '../../assets/logowhite-p.png';
// import logoDark from '../../assets/logo-white-r.png';

// // ✅ STYLES
// import './Dashboard.css';


// // ✅ CHART.JS CORE
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip as ChartTooltip,  // ✅ rename this
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// } from 'chart.js';

// // ✅ REGISTER CHART.JS
// ChartJS.register(
//     ArcElement,
//     ChartTooltip, // ✅ use renamed one
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// );



// const QuarterlyCard = ({ handleModuleChange }) => {

//     const [latest, setLatest] = React.useState(null);

//     React.useEffect(() => {
//         fetch(
//             "/gt-api/get_quarterly_media.php?type=ACM Presentation",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "ACM DATA:",
//                     data
//                 );

//                 if (data.success && data.data.length > 0) {
//                     setLatest(data.data[0]);
//                 }
//             })
//             .catch(err => console.error("Quarterly Fetch Error:", err));
//     }, []);

//     console.log("LATEST ACM:", latest);

//     return (
//         <div
//             className="quarterly-pro-card clickable"
//             onClick={() => handleModuleChange("quarterly-updates")}
//         >
//             {/* Glow Layer */}
//             <div className="card-glow"></div>

//             {/* HEADER */}
//             <div className="qp-header">
//                 <div className="qp-left">
//                     <span className="qp-tag">ACM Updates</span>
//                     <h3 className="qp-title">Quarterly Insights</h3>
//                 </div>

//                 <div className="qp-icon">📢</div>
//             </div>

//             {/* BODY */}
//             <div className="qp-body">
//                 {latest ? (
//                     <>
//                         <h4 className="qp-main-title">{latest.title}</h4>

//                         <div className="qp-meta">
//                             <span className="qp-date">
//                                 {new Date(latest.created_at).toLocaleDateString('en-GB')}
//                             </span>
//                             <span className="qp-badge">NEW</span>
//                         </div>
//                     </>
//                 ) : (
//                     <div className="qp-empty">
//                         <div className="qp-loader"></div>
//                         <span>Awaiting next update</span>
//                     </div>
//                 )}
//             </div>

//             {/* FOOTER */}
//             <div className="qp-footer">
//                 <span>View Presentation</span>
//                 <span className="arrow">→</span>
//             </div>
//         </div>
//     );
// };


// const Dashboard = () => {
//     const [dashboardDepartments, setDashboardDepartments] = useState([]);
//     const [dashboardPathways, setDashboardPathways] = useState([]);
//     const [policyCount, setPolicyCount] = useState(0);

//     const [showAIChat, setShowAIChat] = useState(false);

//     const [chatMessages, setChatMessages] = useState([
//         {
//             sender: "ai",
//             text: "Hello 👋 Ask me anything about your ELMS database."
//         }
//     ]);

//     const [chatInput, setChatInput] = useState("");
//     const [chatLoading, setChatLoading] = useState(false);



//     const [showMissedModal, setShowMissedModal] = useState(false);

//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//     const [todayEvents, setTodayEvents] = useState([]);
//     useEffect(() => {
//         const fetchTodayEvents = async () => {
//             try {
//                 const res = await fetch('/gt-api/get_celebrations.php');
//                 const data = await res.json();

//                 if (data.success) {
//                     setTodayEvents(data.data || []);
//                 }
//             } catch (err) {
//                 console.error("Dashboard Events Error:", err);
//             }
//         };

//         fetchTodayEvents();
//     }, []);
//     const [currentEventIndex, setCurrentEventIndex] = useState(0);
//     useEffect(() => {
//         if (!todayEvents || todayEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setCurrentEventIndex((prev) =>
//                 (prev + 1) % todayEvents.length
//             );
//         }, 3000); // change every 3 sec

//         return () => clearInterval(interval);
//     }, [todayEvents]);


//     const [equipmentData, setEquipmentData] = useState({
//         total: 0,
//         pending: 0,
//         blocking: 0
//     });



//     const [logs, setLogs] = useState({});

//     const totalPolicies = 11;
//     const readCount = Object.keys(logs || {}).length;

//     const progress = totalPolicies > 0
//         ? Math.round((readCount / totalPolicies) * 100)
//         : 0;


//     const params = useParams();
//     const module = params.module;

//     const storedUser = JSON.parse(localStorage.getItem("userData"));
//     const role = storedUser?.role;
//     const navigate = useNavigate();

//     useEffect(() => {
//         const storedUser = localStorage.getItem("userData");

//         if (!storedUser) {
//             navigate("/", { replace: true });
//             return;
//         }

//         // prevent back button access after logout
//         window.history.pushState(null, "", window.location.href);
//         window.onpopstate = function () {
//             const user = localStorage.getItem("userData");
//             if (!user) {
//                 navigate("/", { replace: true });
//             }
//         };

//     }, [navigate]);







//     const [policyLogs, setPolicyLogs] = useState({});





//     const [upcomingFestival, setUpcomingFestival] = useState(null);
//     const [daysLeft, setDaysLeft] = useState(null);
//     const [isFestivalToday, setIsFestivalToday] = useState(false);
//     const [activeEventIndex, setActiveEventIndex] = useState(0);
//     useEffect(() => {
//         fetch("/gt-api/get_upcoming_festival.php", {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.success) {
//                     setUpcomingFestival(data.festival);
//                     setDaysLeft(data.daysLeft);
//                     setIsFestivalToday(data.isToday);
//                 }
//             })
//             .catch(err => console.error(err));
//     }, []);


//     const location = useLocation();



//     const [showProfile, setShowProfile] = useState(false);
//     const [showPasswordModal, setShowPasswordModal] = useState(false);
//     const [isEditing, setIsEditing] = useState(false);

//     const [activeModule, setActiveModule] = useState(module || "grid");
//     const [isLightMode, setIsLightMode] = useState(false);

//     const [openMenus, setOpenMenus] = useState({
//         department: false,
//         employee: false
//     });

//     const [pendingRequestsCount, setPendingRequestsCount] = useState(0);
//     const [pendingLeavesCount, setPendingLeavesCount] = useState(0);
//     const [requestsList, setRequestsList] = useState([]);
//     const [notifCount, setNotifCount] = useState(0);

//     const [eesSubmissions, setEesSubmissions] = useState([]);
//     const handleEESSubmit = (newFeedback) => {
//         setEesSubmissions(prev => [...prev, newFeedback]);
//     };

//     const [passwordForm, setPasswordForm] = useState({
//         currentPassword: '',
//         newPassword: '',
//         confirmPassword: ''
//     });

//     const [showMandatoryProfileModal, setShowMandatoryProfileModal] = useState(false);
//     const [missingProfileFields, setMissingProfileFields] = useState({
//         phone: false,
//         dob: false,
//         city: false,
//         address: false,
//         local_address: false,
//         country: false
//     });
//     const [mandatoryFormData, setMandatoryFormData] = useState({
//         phone: '',
//         dob: '',
//         city: '',
//         address: '',
//         local_address: '',
//         country: ''
//     });
//     const [mandatorySaving, setMandatorySaving] = useState(false);
//     const [mandatoryError, setMandatoryError] = useState('');
//     const [mandatorySuccessMsg, setMandatorySuccessMsg] = useState('');

//     // 🔴 MANDATORY BANK DETAILS MODAL STATE
//     const [showMandatoryBankModal, setShowMandatoryBankModal] = useState(false);
//     const [missingBankFields, setMissingBankFields] = useState({
//         bankName: false,
//         holderName: false,
//         accNumber: false,
//         ifsc: false,
//         branch: false,
//         accType: false
//     });
//     const [bankFormData, setBankFormData] = useState({
//         bankName: '',
//         holderName: '',
//         accNumber: '',
//         ifsc: '',
//         branch: '',
//         accType: 'Saving Account'
//     });
//     const [bankSaving, setBankSaving] = useState(false);
//     const [bankError, setBankError] = useState('');
//     const [bankSuccessMsg, setBankSuccessMsg] = useState('');




//     const [userData, setUserData] = useState(() => {
//         const storedData = localStorage.getItem("userData");
//         if (storedData) return JSON.parse(storedData);

//         const firstName = location.state?.userName?.split(' ')[0] || "User";
//         const lastName = location.state?.userName?.split(' ')[1] || "";

//         return {
//             firstName,
//             lastName,
//             email: "",
//             dept: "Loading...",
//             phone: "",
//             gender: "",
//             dob: "",
//             address: "",
//             city: "",
//             country: "",
//             employeeId: location.state?.empId || null,
//             profileImage: null,
//             joiningDate: null,
//             HOD: null
//         };
//     });


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_career_pathways.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setDashboardPathways(
//                         data.pathways || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_departments.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "DASHBOARD DEPARTMENTS:",
//                     data
//                 );

//                 if (data.success) {

//                     setDashboardDepartments(
//                         data.departments || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) {

//             setPolicyCount(11);
//             return;

//         }

//         fetch(
//             "/gt-api/get_policies.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setPolicyCount(
//                         data.policies?.length || 0
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);
//     // ✅ THEN use it
//     const employeeId = userData?.id || userData?.employeeId;


//     useEffect(() => {
//         const fetchLeaveDashboardData = async () => {
//             if (!employeeId) return;

//             try {
//                 const res = await fetch(`/gt-api/get_leaves.php?empid=${employeeId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 const wfhRes = await fetch(`/gt-api/get_wfh.php?empid=${employeeId}`, {
//                     credentials: "include"
//                 });
//                 const wfhData = await wfhRes.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];

//                     // 🔥 SAME LOGIC AS ATTENDANCE
//                     const today = new Date();
//                     const currentYear = today.getFullYear();

//                     const fiscalYearStart = new Date(currentYear, 3, 1);

//                     const activeFiscalYearStart =
//                         today < fiscalYearStart
//                             ? new Date(currentYear - 1, 3, 1)
//                             : fiscalYearStart;

//                     // ✅ Dynamic Sick Total (joining based)
//                     let sickTotal = 12;

//                     if (userData?.joiningDate) {
//                         const joining = new Date(userData.joiningDate);

//                         const fyEnd = new Date(activeFiscalYearStart);
//                         fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
//                         fyEnd.setMonth(2);
//                         fyEnd.setDate(31);

//                         if (joining > activeFiscalYearStart) {
//                             if (joining > fyEnd) {
//                                 sickTotal = 0;
//                             } else {
//                                 const joinMonth = joining.getMonth();
//                                 const fyEndMonth = 2;

//                                 let monthsRemaining;

//                                 if (joinMonth <= fyEndMonth) {
//                                     monthsRemaining = fyEndMonth - joinMonth + 1;
//                                 } else {
//                                     monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
//                                 }

//                                 sickTotal = monthsRemaining;
//                             }
//                         }
//                     }

//                     let sickUsed = 0;
//                     let earnedUsed = 0;

//                     leaves.forEach(leave => {
//                         const status = String(leave.Status);
//                         const days = parseFloat(leave.total) || 0;
//                         const leaveDate = new Date(leave.fromdate);
//                         const medStatus = String(leave.medical_doc_status);

//                         // ✅ SAME CONDITION AS ATTENDANCE
//                         if (status === '0' || status === '1') {

//                             if (leave.leavetype === 'Sick Leave') {
//                                 if (leaveDate >= activeFiscalYearStart) {
//                                     sickUsed += days;
//                                 }
//                             }

//                             else if (leave.leavetype === 'Earned Leave') {

//                                 // 🔥 MEDICAL CONVERSION LOGIC
//                                 if (medStatus === '1' || medStatus === '0') {
//                                     if (leaveDate >= activeFiscalYearStart) {
//                                         sickUsed += days;
//                                     }
//                                 } else {
//                                     earnedUsed += days;
//                                 }
//                             }
//                         }
//                     });


//                     console.log("LEAVES:", leaves);
//                     console.log("SICK USED:", sickUsed);
//                     console.log("EARNED USED:", earnedUsed);
//                     console.log("API EARNED BALANCE:", data.earned);

//                     setLeaveData({
//                         leaveHistory: leaves,
//                         leaveBalances: {
//                             sick: { used: sickUsed, total: sickTotal },
//                             earned: { used: earnedUsed, total: parseFloat(data.earned) || 0 }
//                         },
//                         wfhHistory: wfhData.requests || []
//                     });
//                 }

//             } catch (err) {
//                 console.error("Dashboard Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaveDashboardData();
//     }, [employeeId, userData?.joiningDate]);


//     useEffect(() => {
//         setActiveModule(module || "grid");
//     }, [module]);

//     useEffect(() => {

//         if (role === 'Management' || role === 'Manager') {

//             const fetchRealTimeLeaves = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_leaves.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {
//                         // Count requests with Status '0' or null
//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };


//             fetchRealTimeLeaves();


//             const liveInterval = setInterval(fetchRealTimeLeaves, 5000);

//             return () => clearInterval(liveInterval);
//         }
//     }, [role]);



//     useEffect(() => {

//         const fetchUserData = async () => {

//             try {

//                 const response = await fetch("/gt-api/get_profile.php", {
//                     credentials: "include"
//                 });

//                 const data = await response.json();

//                 if (data.success && data.employee) {

//                     const storedUser = JSON.parse(localStorage.getItem("userData"));

//                     const updatedUser = {
//                         id: data.employee.id,
//                         EmpId: data.employee.EmpId,

//                         firstName: data.employee.FirstName,
//                         FirstName: data.employee.FirstName,

//                         lastName: data.employee.LastName,
//                         LastName: data.employee.LastName,

//                         email: data.employee.EmailId,
//                         EmailId: data.employee.EmailId,

//                         Department: data.employee.DepartmentName || data.employee.Department,

//                         HOD: data.employee.HOD,
//                         Designation: data.employee.Designation,
//                         phone: data.employee.Phonenumber,
//                         gender: data.employee.Gender,
//                         dob: data.employee.Dob,
//                         address: data.employee.Address,
//                         local_address: data.employee.LocalAddress,
//                         city: data.employee.City,
//                         country: data.employee.Country,
//                         profileImage: data.employee.ProfilePicture || null,
//                         joiningDate: data.employee.JoiningDate,

//                         role: storedUser?.role
//                     };

//                     setUserData(updatedUser);

//                     localStorage.setItem("userData", JSON.stringify(updatedUser));

//                     // ✅ CHECK ONLY MISSING MANDATORY PROFILE FIELDS
//                     const isMissing = (val) => !val || String(val).trim() === '' || String(val).trim() === '0000-00-00';
//                     const missing = {
//                         phone: isMissing(updatedUser.phone),
//                         dob: isMissing(updatedUser.dob),
//                         city: isMissing(updatedUser.city),
//                         address: isMissing(updatedUser.address),
//                         local_address: isMissing(updatedUser.local_address),
//                         country: isMissing(updatedUser.country)
//                     };

//                     if (Object.values(missing).some(Boolean)) {
//                         setMissingProfileFields(missing);
//                         setMandatoryFormData({
//                             phone: updatedUser.phone || '',
//                             dob: updatedUser.dob || '',
//                             city: updatedUser.city || '',
//                             address: updatedUser.address || '',
//                             local_address: updatedUser.local_address || '',
//                             country: updatedUser.country || ''
//                         });
//                         setShowMandatoryProfileModal(true);
//                     }

//                     // 🏦 CHECK MANDATORY BANK DETAILS
//                     const empIdForBank = data.employee.id || data.employee.EmpId;
//                     if (empIdForBank) {
//                         let bank = null;
//                         try {
//                             const bankRes = await fetch(`/gt-api/get_bank_details.php?emp_id=${empIdForBank}`, {
//                                 credentials: "include"
//                             });
//                             const rawText = await bankRes.text();
//                             try {
//                                 const json = JSON.parse(rawText);
//                                 if (json && (json.success || json.bank || json.bank_name || json.bankName)) {
//                                     bank = json.bank || json.data || json.details || json.employee_bank_details || json;
//                                 }
//                             } catch (parseErr) {
//                                 console.log("get_bank_details json parse error:", parseErr);
//                             }
//                         } catch (bErr) {
//                             console.error("Bank details fetch network error:", bErr);
//                         }

//                         const b = bank || {};

//                         const getVal = (...keys) => {
//                             for (const k of keys) {
//                                 if (b[k] !== undefined && b[k] !== null && String(b[k]).trim() !== '') {
//                                     return String(b[k]).trim();
//                                 }
//                             }
//                             return '';
//                         };

//                         const bankNameVal = getVal('bankName', 'bank_name', 'BankName', 'Bankname');
//                         const holderNameVal = getVal('holderName', 'holder_name', 'HolderName', 'account_holder_name', 'AccountHolderName');
//                         const accNumberVal = getVal('accNumber', 'account_number', 'AccountNumber', 'AccNumber', 'account_no', 'AccountNo');
//                         const ifscVal = getVal('ifsc', 'ifsc_code', 'IFSC', 'Ifsc', 'IfscCode');
//                         const branchVal = getVal('branch', 'branch_name', 'Branch', 'BranchName');
//                         const accTypeVal = getVal('accType', 'account_type', 'AccountType', 'AccType');

//                         const isBankMissing = (val) => !val || String(val).trim() === '';

//                         const missingBank = {
//                             bankName: isBankMissing(bankNameVal),
//                             holderName: isBankMissing(holderNameVal),
//                             accNumber: isBankMissing(accNumberVal),
//                             ifsc: isBankMissing(ifscVal),
//                             branch: isBankMissing(branchVal),
//                             accType: isBankMissing(accTypeVal)
//                         };

//                         console.log("MANDATORY BANK CHECK RESULT:", { empId: empIdForBank, bankData: b, missingBank });

//                         if (Object.values(missingBank).some(Boolean)) {
//                             setMissingBankFields(missingBank);
//                             setBankFormData({
//                                 bankName: bankNameVal,
//                                 holderName: holderNameVal || `${data.employee.FirstName || ''} ${data.employee.LastName || ''}`.trim(),
//                                 accNumber: bankNameVal ? accNumberVal : '',
//                                 ifsc: ifscVal,
//                                 branch: branchVal,
//                                 accType: accTypeVal || 'Saving Account'
//                             });
//                             setShowMandatoryBankModal(true);
//                         }
//                     }
//                 }

//             } catch (error) {
//                 console.error("Database Error:", error);
//             }

//         };

//         fetchUserData();

//     }, []);

//     // 🔒 LOCK BODY SCROLL WHEN MANDATORY MODAL IS OPEN
//     useEffect(() => {
//         if (showMandatoryProfileModal || showMandatoryBankModal) {
//             document.body.style.overflow = 'hidden';
//             document.documentElement.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         }
//         return () => {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         };
//     }, [showMandatoryProfileModal, showMandatoryBankModal]);

//     const handleSaveMandatoryProfile = async (e) => {
//         e.preventDefault();
//         setMandatoryError('');

//         const { phone, dob, city, address, local_address, country } = mandatoryFormData;

//         if (missingProfileFields.phone && (!phone || !phone.trim())) {
//             setMandatoryError('Please enter your Mobile Number.');
//             return;
//         }
//         if (missingProfileFields.dob && (!dob || !dob.trim() || dob === '0000-00-00')) {
//             setMandatoryError('Please select your Date of Birth.');
//             return;
//         }
//         if (missingProfileFields.city && (!city || !city.trim())) {
//             setMandatoryError('Please enter your City.');
//             return;
//         }
//         if (missingProfileFields.country && (!country || !country.trim())) {
//             setMandatoryError('Please enter your Country.');
//             return;
//         }
//         if (missingProfileFields.address && (!address || !address.trim())) {
//             setMandatoryError('Please enter your Permanent Address.');
//             return;
//         }
//         if (missingProfileFields.local_address && (!local_address || !local_address.trim())) {
//             setMandatoryError('Please enter your Current / Local Address.');
//             return;
//         }

//         setMandatorySaving(true);
//         try {
//             const payload = {
//                 id: userData.id,
//                 EmpId: userData.EmpId,
//                 Phonenumber: (phone || userData.phone || '').trim(),
//                 Dob: (dob || userData.dob || '').trim(),
//                 City: (city || userData.city || '').trim(),
//                 Address: (address || userData.address || '').trim(),
//                 LocalAddress: (local_address || userData.local_address || '').trim(),
//                 Country: (country || userData.country || '').trim(),
//                 Gender: userData.gender || '',
//                 ProfilePicture: userData.profileImage || null
//             };

//             const res = await fetch("/gt-api/update_profile.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 const updatedUser = {
//                     ...userData,
//                     phone: phone.trim(),
//                     dob: dob.trim(),
//                     city: city.trim(),
//                     address: address.trim(),
//                     local_address: local_address.trim(),
//                     country: country.trim()
//                 };
//                 setUserData(updatedUser);
//                 localStorage.setItem("userData", JSON.stringify(updatedUser));
//                 setMandatorySuccessMsg("🎉 Profile information updated! You may now use the system.");
//                 setTimeout(() => {
//                     setShowMandatoryProfileModal(false);
//                     setMandatorySuccessMsg('');
//                 }, 1200);
//             } else {
//                 setMandatoryError(result.message || "Failed to update profile. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory profile update error:", err);
//             setMandatoryError("Connection error. Ensure backend API is running.");
//         } finally {
//             setMandatorySaving(false);
//         }
//     };

//     const handleSaveMandatoryBankDetails = async (e) => {
//         e.preventDefault();
//         setBankError('');

//         const { bankName, holderName, accNumber, ifsc, branch, accType } = bankFormData;

//         if (missingBankFields.bankName && (!bankName || !bankName.trim())) {
//             setBankError('Please enter Bank Name.');
//             return;
//         }
//         if (missingBankFields.holderName && (!holderName || !holderName.trim())) {
//             setBankError('Please enter Account Holder Name.');
//             return;
//         }
//         if (missingBankFields.accNumber && (!accNumber || !accNumber.trim())) {
//             setBankError('Please enter Bank Account Number.');
//             return;
//         }
//         if (missingBankFields.ifsc && (!ifsc || !ifsc.trim())) {
//             setBankError('Please enter IFSC Code.');
//             return;
//         }
//         if (missingBankFields.branch && (!branch || !branch.trim())) {
//             setBankError('Please enter Branch Name.');
//             return;
//         }
//         if (missingBankFields.accType && (!accType || !accType.trim())) {
//             setBankError('Please select Account Type.');
//             return;
//         }

//         setBankSaving(true);
//         try {
//             const payload = {
//                 emp_id: userData.id || userData.employeeId || userData.EmpId,
//                 emp_number: userData.EmpId || userData.employeeId,
//                 bankName: bankName.trim(),
//                 bank_name: bankName.trim(),
//                 holderName: holderName.trim(),
//                 account_holder_name: holderName.trim(),
//                 accNumber: accNumber.trim(),
//                 account_number: accNumber.trim(),
//                 ifsc: ifsc.trim(),
//                 ifsc_code: ifsc.trim(),
//                 branch: branch.trim(),
//                 branch_name: branch.trim(),
//                 accType: accType.trim(),
//                 account_type: accType.trim()
//             };

//             const res = await fetch("/gt-api/save_bank_details.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 setBankSuccessMsg("🎉 Bank details updated successfully!");
//                 setTimeout(() => {
//                     setShowMandatoryBankModal(false);
//                     setBankSuccessMsg('');
//                 }, 1200);
//             } else {
//                 setBankError(result.message || "Failed to save bank details. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory bank details update error:", err);
//             setBankError("Connection error. Ensure backend API is running.");
//         } finally {
//             setBankSaving(false);
//         }
//     };




//     // const employeeId = userData.id || userData.employeeId;

//     const toggleSubMenu = (menu) => {
//         setOpenMenus(prev => ({ ...prev, [menu]: !prev[menu] }));
//     };

//     useEffect(() => {
//         const checkNotifications = () => {
//             if (role !== 'Management' && userData?.employeeId) {
//                 fetch(`/gt-api/clear_notifications.php?employee_id=${userData.employeeId}`)
//                     .then(res => res.json())
//                     .then(data => {
//                         if (data.success) setNotifCount(data.count);
//                     })
//                     .catch(err => console.error("Notif Fetch Error:", err));
//             }
//         };
//         checkNotifications();
//         const interval = setInterval(checkNotifications, 30000);
//         return () => clearInterval(interval);
//     }, [userData.employeeId, role]);

//     useEffect(() => {
//         if (role === 'Management' || role === 'Manager') {
//             const fetchRealTimeLeaves = async () => {
//                 try {
//                     // Determine which API to call based on Role
//                     // Managers should call the specific manager-leaves API using their ID
//                     const url = role === 'Management'
//                         ? "/gt-api/get_all_leaves.php"
//                         : `/gt-api/get_manager_leaves.php?managerId=${userData.id || location.state?.empId}`;

//                     // const res = await fetch(url);
//                     const res = await fetch(url, {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {

//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };

//             // Only fetch if we have the ID for the Manager, or if role is Management
//             if (role === 'Management' || (role === 'Manager' && (userData.id || location.state?.empId))) {
//                 fetchRealTimeLeaves();
//                 const liveInterval = setInterval(fetchRealTimeLeaves, 5000);
//                 return () => clearInterval(liveInterval);
//             }
//         }
//     }, [role, userData.id, location.state?.empId]);

//     const handleStatusUpdate = async (id, newStatus) => {
//         try {
//             const response = await fetch("/gt-api/update_request_status.php", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ id, status: newStatus }),
//             });
//             const data = await response.json();
//             if (data.success) {
//                 setRequestsList(prev => prev.map(req => req.id === id ? { ...req, status: newStatus } : req));
//                 setPendingRequestsCount(prev => Math.max(0, prev - 1));
//                 alert(`Request ${newStatus} successfully!`);
//             }
//         } catch (error) {
//             console.error("Update error:", error);
//         }
//     };

//     ;


//     const sendAIMessage = async () => {
//         if (!chatInput.trim()) return;

//         const userMessage = {
//             sender: "user",
//             text: chatInput
//         };

//         setChatMessages(prev => [...prev, userMessage]);
//         setChatLoading(true);

//         try {
//             const res = await fetch("/gt-api/chatbot.php", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     question: chatInput
//                 })
//             });

//             const data = await res.json();

//             let aiReply = "No response.";

//             if (data.success) {
//                 aiReply = data.reply || "No response.";
//             } else {
//                 aiReply = data.message || "Something went wrong.";
//             }
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: aiReply
//                 }
//             ]);

//         } catch (err) {
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: "Server error."
//                 }
//             ]);
//         }

//         setChatInput("");
//         setChatLoading(false);
//     };
//     const handleModuleChange = (slug, extraData = null) => {
//         navigate(`/dashboard/${role}/${slug}`, {
//             state:
//                 extraData && typeof extraData === "object"
//                     ? extraData
//                     : { selectedPathway: extraData }
//         });
//     };

//     const handlePasswordSubmit = (e) => {
//         e.preventDefault();
//         if (passwordForm.newPassword !== passwordForm.confirmPassword) {
//             alert("New passwords do not match!");
//             return;
//         }
//         alert("Encryption Key Updated Successfully!");
//         setShowPasswordModal(false);
//     };

//     const handleSave = () => {
//         setIsEditing(false);
//         alert("Profile changes synchronized!");
//     };

//     // Ensure only ONE instance of this exists in your file
//     const [theme, setTheme] = useState(localStorage.getItem('dashboard-theme') || 'dark');

//     useEffect(() => {
//         document.documentElement.setAttribute('data-theme', theme);
//         localStorage.setItem('dashboard-theme', theme);
//     }, [theme]);

//     const toggleTheme = () => {
//         setTheme(prev => prev === 'dark' ? 'light' : 'dark');
//     };
//     useEffect(() => {

//         const handlePageShow = (event) => {
//             if (event.persisted) {
//                 const user = localStorage.getItem("userData");
//                 if (!user) {
//                     window.location.replace("/");
//                 }
//             }
//         };

//         window.addEventListener("pageshow", handlePageShow);

//         return () => window.removeEventListener("pageshow", handlePageShow);

//     }, []);
//     useEffect(() => {
//         if (role === 'Management') {
//             const fetchEquipmentCount = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_equip_request.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();
//                     if (data.success && data.requests) {
//                         const count = data.requests.filter(r => r.status?.toLowerCase() === 'pending').length;
//                         setPendingRequestsCount(count);
//                         setRequestsList(data.requests);
//                     }
//                 } catch (err) {
//                     console.error("Equipment Fetch Error:", err);
//                 }
//             };

//             fetchEquipmentCount();
//             const interval = setInterval(fetchEquipmentCount, 10000);
//             return () => clearInterval(interval);
//         }
//     }, [role]);




//     const [payData, setPayData] = useState([]);

//     useEffect(() => {

//         // 🔥 MANAGEMENT DASHBOARD
//         if (role === "Management") {

//             const fetchAllDocs = () => {
//                 fetch("/gt-api/get_all_salary_documents.php", {
//                     credentials: "include"
//                 })
//                     .then(res => res.json())
//                     .then(data => {
//                         console.log("MGMT DATA:", data);

//                         if (data.success) {

//                             setPayData(data.documents);
//                         }
//                     })
//                     .catch(err => console.error("Management Fetch Error:", err));
//             };

//             fetchAllDocs();

//             const interval = setInterval(fetchAllDocs, 5000);

//             return () => clearInterval(interval);
//         }

//         // 👤 EMPLOYEE DASHBOARD
//         if (employeeId) {
//             fetch(`/gt-api/get_my_documents.php?emp_id=${employeeId}`, {
//                 credentials: "include"
//             })
//                 .then(res => res.json())
//                 .then(data => {
//                     console.log("EMP DATA:", data);

//                     if (data.success) {
//                         setPayData(data.documents);
//                     }
//                 })
//                 .catch(err => console.error("Employee Fetch Error:", err));
//         }

//     }, [role, employeeId]);





//     const renderPayChart = () => {
//         const safePayData = payData || [];

//         const payslips = safePayData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = safePayData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = safePayData.filter(d => d.doc_type === "APPRAISAL LETTER").length;
//         const totalDocs = payslips + form16 + appraisal;

//         return (
//             <div className="pay-ultra-card" onClick={() => handleModuleChange("pay and benefits")}>
//                 <div className="card-inner">
//                     {/* Top Section */}
//                     <div className="pay-header">
//                         <div className="pay-icon-wrapper">
//                             <div className="pay-icon-glow"></div>
//                             <span className="main-icon">📄</span>
//                         </div>
//                         <div className="pay-total-info">
//                             <h3>Pay & Benefits</h3>
//                             <p>{totalDocs} Total Documents</p>
//                         </div>
//                     </div>

//                     {/* Distribution */}
//                     <div className="distribution-container">
//                         <div className="distribution-label">
//                             <span>Vault Composition</span>
//                             <span className="percentage">
//                                 {totalDocs > 0 ? "100%" : "0%"}
//                             </span>
//                         </div>

//                         <div className="multi-progress-bar">
//                             {totalDocs > 0 ? (
//                                 <>
//                                     <div
//                                         className="segment green"
//                                         style={{ flex: payslips, backgroundColor: '#22c55e' }}
//                                     ></div>
//                                     <div
//                                         className="segment blue"
//                                         style={{ flex: form16, backgroundColor: '#3b82f6' }}
//                                     ></div>
//                                     <div
//                                         className="segment amber"
//                                         style={{ flex: appraisal, backgroundColor: '#f59e0b' }}
//                                     ></div>
//                                 </>
//                             ) : (
//                                 <div
//                                     style={{
//                                         width: "100%",
//                                         height: "100%",
//                                         backgroundColor: "#e5e7eb",
//                                         borderRadius: "10px"
//                                     }}
//                                 ></div>
//                             )}
//                         </div>
//                     </div>

//                     {/* List */}
//                     <div className="pay-list">
//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator green"></span>
//                                 <span className="name">Monthly Payslips</span>
//                             </div>
//                             <span className="count-badge">{payslips}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator blue"></span>
//                                 <span className="name">Tax Form 16</span>
//                             </div>
//                             <span className="count-badge">{form16}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator amber"></span>
//                                 <span className="name">Appraisal Letter</span>
//                             </div>
//                             <span className="count-badge">{appraisal}</span>
//                         </div>
//                     </div>

//                     <div className="pay-footer">
//                         <span>Explore Document</span>
//                         <span className="arrow-icon">→</span>
//                     </div>

//                     <div className="reimburse-cta-wrapper">
//                         <button
//                             className="reimburse-btn"
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleModuleChange("supplies");
//                             }}
//                         >
//                             Click here for Reimbursement Form
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };



//     const renderLeavePieChart = () => {
//         const PUBLIC_HOLIDAYS = [
//             '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//             '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//         ];

//         const isWorkDay = (date) => {
//             const day = date.getDay();
//             const dateString = date.toISOString().split('T')[0];
//             return !(day === 0 || day === 6) && !PUBLIC_HOLIDAYS.includes(dateString);
//         };

//         if (!leaveData || !leaveData.leaveBalances) return null;

//         const sickUsed = leaveData.leaveBalances.sick.used || 0;
//         const earnedUsed = leaveData.leaveBalances.earned.used || 0;
//         const wfhCount = leaveData.wfhHistory.reduce((total, wfh) => {
//             const start = new Date(wfh.start);
//             const end = new Date(wfh.end);
//             let days = 0;
//             let current = new Date(start);
//             while (current <= end) {
//                 if (isWorkDay(current)) days++;
//                 current.setDate(current.getDate() + 1);
//             }
//             return total + days;
//         }, 0);

//         const totalUsed = sickUsed + earnedUsed;

//         // Determine max for scaling bars (minimum scale of 10)
//         const maxVal = Math.max(sickUsed, earnedUsed, wfhCount, 10);
//         return (

//             <div
//                 className={`elite-podium-card leave-analytics-card ${theme === 'dark' ? 'dark-variant' : 'light-theme'}`}
//                 onClick={() => handleModuleChange("attendance")}
//             >

//                 <div className="card-header-v3">
//                     <div className="title-group">

//                         <h2 className="main-title">Leave Overview</h2>
//                     </div>
//                     <div className="year-tag">2026</div>
//                 </div>

//                 <div className="podium-content">
//                     {/* VERTICAL BAR SECTION - Made prominent */}
//                     <div className="bar-podium-large">
//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill sick" style={{ height: `${(sickUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">SICK</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill earned" style={{ height: `${(earnedUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">EARNED</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill wfh" style={{ height: `${(wfhCount / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">WFH</span>
//                         </div>
//                     </div>

//                     {/* KPI SIDEBAR - Cleaned up to match image 1's style */}
//                     <div className="kpi-sidebar-compact">
//                         <div className="total-display">
//                             <span className="total-val">{totalUsed}</span>
//                             <span className="total-sub">Days Off-Site</span>
//                         </div>

//                         <div className="status-legend">
//                             <div className="legend-row">
//                                 <span className="indicator sick"></span>
//                                 <span>{sickUsed} Sick</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator earned"></span>
//                                 <span>{earnedUsed} Earned</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator wfh"></span>
//                                 <span>{wfhCount} WFH</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="card-footer-v3">
//                     <div className="sync-info">
//                         <span className="status-glow"></span>
//                         Annual Summary Active
//                     </div>
//                     <button className="details-btn">VIEW DETAILS →</button>
//                 </div>
//             </div>
//         );
//     };

//     const [leaveData, setLeaveData] = useState({
//         leaveHistory: [],
//         leaveBalances: {
//             sick: { used: 0, total: 0 },
//             earned: { used: 0, total: 0 }
//         },
//         wfhHistory: []
//     });


//     const [managementNotices, setManagementNotices] = useState({
//         reviews: [],
//         probations: []
//     });

//     useEffect(() => {
//         const fetchNotices = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/get_manager_feedback.php?empId=${userData.EmpId}`
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     setManagementNotices({
//                         reviews: data.reviews || [],
//                         probations: data.probations || []
//                     });
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchNotices();
//     }, [userData]);





//     const renderEquipmentCard = () => {
//         const { total, approved, rejected, pending } = equipmentData;

//         return (
//             <div className="equipment-ultra-card clickable" onClick={() => handleModuleChange("equipment-request")}>
//                 <div className="equip-header">
//                     <div className="equip-icon-box">💻</div>
//                     <div className="equip-title-group">
//                         <span className="equip-label">Hardware</span>
//                         <h3 className="equip-title">Requests</h3>
//                     </div>
//                 </div>

//                 <div className="equip-main-stat">
//                     <span className="total-count">{total}</span>
//                     <span className="total-label">Submissions</span>
//                 </div>

//                 <div className="equip-progress-bar">
//                     <div className="bar-fill approved" style={{ width: `${(approved / total) * 100}%` }}></div>
//                     <div className="bar-fill pending" style={{ width: `${(pending / total) * 100}%` }}></div>
//                 </div>

//                 <div className="equip-stats-list">
//                     <div className="equip-item">
//                         <span className="dot approved"></span>
//                         <span className="item-name">Approved</span>
//                         <span className="item-val">{approved}</span>
//                     </div>
//                     <div className="equip-item">
//                         <span className="dot pending"></span>
//                         <span className="item-name">Pending</span>
//                         <span className="item-val text-warning">{pending}</span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     useEffect(() => {
//         const empIdForFetch = userData?.EmpId || userData?.employeeId;

//         if (!empIdForFetch) return;

//         fetch(`/gt-api/get_all_equip_request.php?employee_id=${empIdForFetch}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log("EQUIPMENT API RESPONSE:", data);
//                 if (data.success && data.requests) {

//                     const requests = data.requests;

//                     const approved = requests.filter(r =>
//                         r.status?.toLowerCase() === "approved"
//                     ).length;

//                     const rejected = requests.filter(r =>
//                         r.status?.toLowerCase() === "rejected"
//                     ).length;

//                     const pending = requests.filter(r =>
//                         r.status?.toLowerCase() === "pending"
//                     ).length;

//                     setEquipmentData({
//                         total: requests.length,
//                         approved,
//                         rejected,
//                         pending
//                     });
//                 }
//             })
//             .catch(err => console.error("Equipment Dashboard Error:", err));
//         console.log("EMP ID:", empIdForFetch);



//     }, [userData?.EmpId, userData?.employeeId]);





//     const [oneOnOneData, setOneOnOneData] = useState({
//         totalMeetings: 0,
//         pendingTasks: 0,
//         completedTasks: 0
//     });

//     useEffect(() => {
//         if (!employeeId) return;

//         fetch(`/gt-api/get_my_meetings.php?emp_id=${employeeId}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.meetings) {

//                     const meetings = data.meetings;

//                     let pending = 0;
//                     let completed = 0;

//                     meetings.forEach(meet => {
//                         const tasks = JSON.parse(meet.action_items || "[]");

//                         tasks.forEach(task => {
//                             if (task.done) completed++;
//                             else pending++;
//                         });
//                     });

//                     setOneOnOneData({
//                         totalMeetings: meetings.length,
//                         pendingTasks: pending,
//                         completedTasks: completed
//                     });
//                 }
//             })
//             .catch(err => console.error("1-1 Fetch Error:", err));

//     }, [employeeId]);



//     const renderOneOnOneCard = () => {
//         const { totalMeetings, pendingTasks, completedTasks } = oneOnOneData;
//         const totalTasks = (pendingTasks + completedTasks) || 1;
//         const progressPercent = Math.min(Math.round((completedTasks / totalTasks) * 100), 100);

//         return (
//             <div className="liquid-card clickable" onClick={() => handleModuleChange("one-on-one")}>
//                 {/* BACKGROUND BLOOM */}
//                 <div className="liquid-bloom"></div>

//                 <div className="liquid-layout">
//                     {/* HERO TILE: THE CORE IDENTITY */}
//                     <div className="liquid-tile-hero">
//                         <div className="hero-header">
//                             {/* <span className="hero-eyebrow">Engagement Console</span> */}
//                             <h2 className="hero-title">1-on-1 Sessions</h2>
//                         </div>
//                         <div className="hero-main-metric">
//                             <span className="hero-val">{totalMeetings}</span>
//                             <span className="hero-label">TOTAL<br />MEETINGS</span>
//                         </div>
//                         {/* FULL WIDTH PROGRESS THREAD */}
//                         <div className="liquid-thread-container">
//                             <div className="liquid-thread-bg">
//                                 <div className="liquid-thread-fill" style={{ width: `${progressPercent}%` }}>
//                                     <div className="liquid-thread-glow-tip"></div>
//                                 </div>
//                             </div>
//                             <div className="liquid-thread-label">
//                                 <span className="label-text">Task Completion</span>
//                                 <span className="label-val">{progressPercent}%</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* DATA TRAY: THE SPECIFIC CHIPS */}
//                     <div className="liquid-tray">
//                         <div className="liquid-chip danger">
//                             <div className="chip-inner">
//                                 <label>Pending Task</label>
//                                 <span className="chip-val">{pendingTasks}</span>
//                             </div>
//                         </div>
//                         <div className="liquid-chip success">
//                             <div className="chip-inner">
//                                 <label>Completed Task</label>
//                                 <span className="chip-val">{completedTasks}</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* INTERACTIVE FOOTER */}
//                 <div className="liquid-footer">
//                     <div className="status-container">
//                         <div className={`status-node-wrapper ${pendingTasks > 0 ? 'is-alert' : 'is-sync'}`}>
//                             <div className="status-node-core"></div>
//                             <div className="status-node-bloom"></div>
//                         </div>
//                         <span className={`status-text ${pendingTasks > 0 ? 'text-alert' : ''}`}>
//                             {pendingTasks > 0 ? 'ACTION ITEMS DETECTED' : 'SYSTEM OPTIMIZED'}
//                         </span>
//                     </div>
//                     <div className="liquid-action">

//                         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
//                     </div>
//                 </div>
//             </div>
//         );
//     };






//     const renderCareerPathwaysCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const pathways = isGenesis

//             ? [

//                 {
//                     id: "01",
//                     name: "FI DESIGN",
//                     color: "rgba(0, 77, 113, 0.9)"
//                 },

//                 {
//                     id: "02",
//                     name: "BIM MODELING",
//                     color: "rgba(0, 120, 172, 0.8)"
//                 },

//                 {
//                     id: "03",
//                     name: "POWER BI",
//                     color: "rgba(0, 162, 237, 0.7)"
//                 }

//             ]

//             : dashboardPathways.map(
//                 (item, index) => ({
//                     id: String(index + 1)
//                         .padStart(2, "0"),

//                     name: item.pathway_title,

//                     color:
//                         "rgba(0, 120, 172, 0.8)"
//                 })
//             );

//         return (

//             <div
//                 className="pathway-card-container"
//                 onClick={() =>
//                     handleModuleChange(
//                         "career pathways"
//                     )
//                 }
//             >

//                 <h2 className="pathway-title">
//                     CAREER PATHWAYS
//                 </h2>

//                 <div className="pathway-stack">

//                     {pathways.map(
//                         (item, index) => (

//                             <div
//                                 key={index}
//                                 className="pathway-step"
//                                 style={{
//                                     '--step-color':
//                                         item.color
//                                 }}
//                                 onClick={(e) => {

//                                     e.stopPropagation();

//                                     handleModuleChange(
//                                         "career pathways",
//                                         item.name
//                                     );

//                                 }}
//                             >

//                                 <span className="step-number">
//                                     {item.id}
//                                 </span>

//                                 <div className="step-content">

//                                     <span className="step-name">
//                                         {item.name}
//                                     </span>

//                                     <div className="step-glow"></div>

//                                 </div>

//                             </div>

//                         )
//                     )}

//                 </div>

//                 <button
//                     className="explore-btn"
//                     onClick={(e) => {

//                         e.stopPropagation();

//                         handleModuleChange(
//                             "career pathways"
//                         );

//                     }}
//                 >
//                     EXPLORE CAREER PATHWAYS
//                 </button>

//             </div>

//         );

//     };


//     const renderPolicyCard = () => {
//         const totalPolicies =
//             policyCount;

//         console.log(
//             "Policy Count:",
//             totalPolicies
//         );

//         const readCount =
//             Object.keys(logs || {}).length;
//         const pending = totalPolicies - readCount;
//         const progress = totalPolicies > 0 ? Math.round((readCount / totalPolicies) * 100) : 0;

//         return (
//             <div className="terminal-policy-card" onClick={() => handleModuleChange("company-policy")}>
//                 {/* Background Decorative Scanline */}
//                 <div className="terminal-scanline"></div>

//                 <div className="terminal-header">
//                     <div className="header-left">
//                         {/* <span className="terminal-tag">PROTOCOL_09</span> */}
//                         <h3 className="terminal-title">Company Policy</h3>
//                     </div>
//                     <div className={`status-indicator ${progress === 100 ? 'secure' : 'breach'}`}>
//                         {progress === 100 ? "SECURE" : "PENDING"}
//                     </div>
//                 </div>

//                 <div className="terminal-content">
//                     {/* Circular Progress using SVG for precision */}
//                     <div className="terminal-visual">
//                         <svg viewBox="0 0 36 36" className="cyber-circle">
//                             <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                             <path
//                                 className="circle-fill"
//                                 strokeDasharray={`${progress}, 100`}
//                                 d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
//                                 style={{ stroke: progress === 100 ? '#22c55e' : '#3b82f6' }}
//                             />
//                         </svg>
//                         <div className="percentage-display">
//                             <span className="pct-num">{progress}</span>
//                             <span className="pct-unit">%</span>
//                         </div>
//                     </div>

//                     {/* Data Readout Section */}
//                     <div className="terminal-stats">
//                         <div className="stat-row">
//                             <span className="label">COMPLETED</span>
//                             <span className="value">{readCount}</span>
//                         </div>
//                         <div className="stat-row">
//                             <span className="label">TOTAL_FILES</span>
//                             <span className="value">{totalPolicies}</span>
//                         </div>
//                         <div className="stat-row urgent">
//                             <span className="label">AWAITING_ACTION</span>
//                             <span className="value">{pending}</span>
//                         </div>
//                     </div>
//                 </div>

//             </div>
//         );
//     };

//     useEffect(() => {
//         const fetchLogs = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/acknowledgepolicy.php?empId=${userData.EmpId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 console.log("API DATA:", data);

//                 // 🔥 FIX: use data.logs (NOT data)
//                 const logsArray = Array.isArray(data?.logs) ? data.logs : [];

//                 const map = logsArray.reduce((acc, curr) => {
//                     if (curr?.policy_title) {
//                         acc[curr.policy_title] = true;
//                     }
//                     return acc;
//                 }, {});

//                 setLogs(map);

//             } catch (err) {
//                 console.error("Policy logs error:", err);
//                 setLogs({});
//             }
//         };

//         fetchLogs();
//     }, [userData]);


//     const [showProfileOptions, setShowProfileOptions] = useState(false);



//     const [showProfileMenu, setShowProfileMenu] = useState(false);
//     const handleEditProfile = () => {
//         setShowProfileMenu(false);
//         navigate(`/dashboard/${role}/my-profile`);
//         setShowProfile(true);
//     };

//     const handleLogout = () => {
//         document.documentElement.removeAttribute('data-theme');
//         localStorage.clear();
//         sessionStorage.clear();
//         navigate("/", { replace: true });
//     };

//     const [currentTime, setCurrentTime] = useState("");

//     useEffect(() => {
//         const updateTime = () => {
//             const now = new Date();
//             setCurrentTime(
//                 now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
//             );
//         };

//         updateTime();
//         const interval = setInterval(updateTime, 1000);

//         return () => clearInterval(interval);
//     }, []);
//     const todayDate = new Date().toLocaleDateString('en-GB', {
//         day: '2-digit',
//         month: 'short'
//     });



//     const employeeModulesList = [
//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "attendance" },

//         { id: 2, name: "Pay and Benefits", icon: "💳", color: "#3b82f6", slug: "pay and benefits" },
//         { id: 3, name: "OKR and Performance Tracker", icon: "🎯", color: "#f59e0b", slug: "okr and performance tracker" },

//         { id: 5, name: "Career Pathways", icon: "🏆", color: "#ec4899", slug: "career pathways" },
//         { id: 6, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },

//         { id: 9, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         { id: 10, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         // { id: 11, name: "Documents", icon: "📂", color: "#f43f5e", slug: "documents" },
//         // { id: 12, name: "Employee Experience Survey - EES", icon: "📝", color: "#8b5cf6", slug: "ees-survey" },   
//         { id: 13, name: "1:1 Meeting", icon: "💬", color: "#00fff2", slug: "one-on-one" },
//         { id: 21, name: "ACM Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//         { id: 7, name: "Expense Reimbursement", icon: "🧾", color: "#10b981", slug: "supplies" },

//     ];

//     const managementModulesList = [

//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "leave-management", badge: pendingLeavesCount },

//         { id: 2, name: "Employee Salary and Benefits", icon: "💳", color: "#3b82f6", slug: "employee-salary-benefits" },

//         { id: 3, name: "Employee OKR'S", icon: "🎯", color: "#f59e0b", slug: "employee-okrs" },

//         { id: 5, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: pendingRequestsCount },

//         { id: 6, name: "Own Finanacials", icon: "💰", color: "#10b981", slug: "pay and benefits" },

//         { id: 8, name: "Career Development", icon: "🏆", color: "#ec4899", slug: "career pathways" },

//         { id: 10, name: "Self OKR Tracker", icon: "🏁", color: "#f59e0b", slug: "okr and performance tracker" },
//         { id: 11, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         { id: 12, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         // { id: 21, name: "Manage Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates", badge: "PUSH" },

//         {
//             id: 21,
//             name: "ACM Updates",
//             icon: "📢",
//             color: "#00fff2",
//             slug: "manage-quarterly-updates",
//             badge: "PUSH"
//         },

//         // {
//         //   id: 15,
//         //   name: "EES Feedback Analytics",
//         //   icon: "📊",
//         //   color: "#00f2ff",
//         //   slug: "ees-analytics",
//         //   badge: "NEW"
//         // },

//         // { id: 14, name: "Skills Development", icon: "📚", color: "#06b6d4", slug: "career" },

//         {
//             id: 16,
//             name: "Medical Reports",
//             icon: "🏥",
//             color: "#f43f5e",
//             slug: "medical-reports",
//             badge: "DOCS"
//         },
//         {
//             id: 17,
//             name: "Policy RnU Status",
//             icon: "📋",
//             color: "#10b981",
//             slug: "policy-logs",
//             badge: "ADMIN"
//         },

//         // { 
//         //   id: 18, 
//         //   name: "Employee Documents", 
//         //   icon: "📂", 
//         //   color: "#f43f5e", 
//         //   slug: "manage-documents", 
//         //   badge: "VIEW" 
//         // },

//         {
//             id: 19,
//             name: "1:1 Connect",
//             icon: "🤝",
//             color: "#00fff2",
//             slug: "manager-one-on-one",

//             badge: "LIVE"
//         },

//         { id: 20, name: "Events and Celebrations", icon: "🎉", color: "#3b82f6", slug: "events-celebrations" },

//         {
//             id: 22,
//             name: "Expense Reimbursements",
//             icon: "💰",
//             color: "#22c55e",
//             slug: "reimbursements",
//             badge: "NEW"
//         },

//         // {
//         //     id: 23,
//         //     name: "WFH Requests",
//         //     icon: "🏠",
//         //     color: "#3b82f6",
//         //     slug: "manage-wfh-requests",
//         //     badge: "WFH"
//         // },


//     ];

//     const renderActiveModule = () => {

//         switch (activeModule) {

//             case "attendance-tracker":
//                 return <AttendanceTracker />;

//             case "CompanySetup":
//                 return <CompanySetup />;

//             case "create-invoice":
//                 return <InvoiceGenerator />;

//             case "my-profile":
//                 return (
//                     <MyProfile
//                         userData={userData}
//                         setUserData={setUserData}
//                         isEditing={isEditing}
//                         setIsEditing={setIsEditing}
//                         handleSave={handleSave}
//                         setShowPasswordModal={setShowPasswordModal}
//                     />
//                 );


//             case "reimbursements":
//                 if (role === "Management" || role === "Manager") {
//                     return <ReimbursementManagement />;
//                 }
//                 return <OfficeRequisition userData={userData} />;

//             case "manage-wfh-requests":
//                 return <WFHManagement />;


//             case "work-from-home":
//                 return <WorkFromHome />;


//             case "quarterly-updates":

//                 return <QuarterlyUpdates />;

//             case "manage-quarterly-updates":

//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementQuarterlyUpdate userData={userData} />;
//                 }
//                 return <QuarterlyUpdates />;


//             case "leave-management":
//                 // Unified behavior for Management and Manager
//                 if (role === 'Management' || role === 'Manager') {
//                     return <LeaveManagement userData={userData} />;
//                 }


//                 return <Attendance employeeId={employeeId} userData={userData} />;

//             case "manage-documents":
//                 if (role === 'Management') {
//                     return <ManageEmployeeDocs />;
//                 }
//                 return <Documents userData={userData} />;



//             // case "attendance":
//             //     if (role === 'Management') return <Attendance />;
//             //     return (
//             //         <Attendance
//             //             employeeId={userData.id}
//             //             empBadgeId={userData.EmpId}
//             //             userData={userData}
//             //         />
//             //     );
//             case "attendance":

//                 if (role === 'Management') {

//                     return (
//                         <Attendance
//                             employeeId={userData.id}
//                             empBadgeId={userData.EmpId}
//                             userData={userData}
//                         />
//                     );

//                 }

//                 return (
//                     <Attendance
//                         employeeId={userData.id}
//                         empBadgeId={userData.EmpId}
//                         userData={userData}
//                     />
//                 );


//             case "policy-logs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <PolicyAdminDashboard />;
//                 }

//                 return (
//                     <CompanyPolicy
//                         employeeId={userData.id}
//                         userData={userData}
//                     />
//                 );

//             case "events-celebrations":
//                 return <EventsCelebrations userData={userData} />;

//             case "pay and benefits": return <PayBenefits userData={userData} employeeId={employeeId} />;

//             // case "okr and performance tracker":
//             //     return <OKRTracker userData={userData} />;

//             case "okr and performance tracker":
//                 return (
//                     <OKRTracker
//                         userData={userData}
//                         defaultTab={location.state?.tab}
//                     />
//                 );

//             // Inside Dashboard.js -> renderActiveModule
//             // case "employee-okrs":
//             //     if (role === 'Management' || role === 'Manager') {
//             //         return (
//             //             <ManagementOKRViewer
//             //                 managerId={userData.id}
//             //                 userRole={role}
//             //                 // This is the CRITICAL line:
//             //                 managedDept={userData.HOD}
//             //             />
//             //         );
//             //     }
//             //     return <OKRTracker userData={userData} />;

//             case "employee-okrs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementOKRViewer userRole={role} />;
//                 }
//                 return <OKRTracker userData={userData} />;

//             case "career pathways": return <CareerPathways userData={userData} />;
//             case "add-department": return <AddDepartment />;
//             case "manage-department": return <ManageDepartment />;
//             case "add-employee": return <AddEmployee />;
//             case "manage-employee": return <ManageEmployee />;

//             case "employee-salary-benefits":
//                 return <EmployeeSalaryBenefits />;


//             case "equipment-request":
//                 if (role === "Management") {
//                     const pending = requestsList.filter(
//                         (r) => r.status?.toLowerCase() === "pending"
//                     );

//                     const history = requestsList.filter(
//                         (r) => r.status?.toLowerCase() !== "pending"
//                     );

//                     return (
//                         <div
//                             className="management-request-wrapper animate-fade"
//                             style={{ padding: "20px" }}
//                         >
//                             {/* Pending Queue */}
//                             <div
//                                 className="module-glass-card"
//                                 style={{ marginBottom: "30px" }}
//                             >
//                                 <h3 className="cyan-text">
//                                     ACTIVE_PENDING_QUEUE ({pending.length})
//                                 </h3>

//                                 {/* Desktop Table */}
//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>IMPACT</th>
//                                                 <th>ACTION</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {pending.length > 0 ? (
//                                                 pending.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                             >
//                                                                 {req.impact?.toUpperCase()}
//                                                             </span>
//                                                         </td>

//                                                         <td>
//                                                             <div className="equiptable-actions">
//                                                                 <button
//                                                                     className="equiptable-btn equiptable-approve"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Approved"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✔
//                                                                 </button>

//                                                                 <button
//                                                                     className="equiptable-btn equiptable-reject"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Rejected"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✖
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_PENDING_REQUESTS
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 {/* Mobile Cards */}
//                                 <div className="equiptable-mobile">
//                                     {pending.length > 0 ? (
//                                         pending.map((req) => (
//                                             <div
//                                                 className="equiptable-card"
//                                                 key={req.id}
//                                             >
//                                                 <div className="equiptable-row">
//                                                     <span>Employee</span>
//                                                     <strong>
//                                                         {req.employee_name}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Hardware</span>
//                                                     <strong>
//                                                         {req.equipment_type}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Impact</span>

//                                                     <span
//                                                         className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                     >
//                                                         {req.impact?.toUpperCase()}
//                                                     </span>
//                                                 </div>

//                                                 <div className="equiptable-actions">
//                                                     <button
//                                                         className="equiptable-btn equiptable-approve"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Approved"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✔ Approve
//                                                     </button>

//                                                     <button
//                                                         className="equiptable-btn equiptable-reject"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Rejected"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✖ Reject
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         ))
//                                     ) : (
//                                         <div className="equiptable-card">
//                                             NO_PENDING_REQUESTS
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Completed History */}
//                             <div
//                                 className="module-glass-card history-card"
//                                 style={{ opacity: 0.9 }}
//                             >
//                                 <h3
//                                     className="gray-text"
//                                     style={{ color: "#888" }}
//                                 >
//                                     📜 COMPLETED_HISTORY ({history.length})
//                                 </h3>

//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>DATE</th>
//                                                 <th>STATUS</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {history.length > 0 ? (
//                                                 history.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             {new Date(
//                                                                 req.updated_at ||
//                                                                 req.created_at
//                                                             ).toLocaleDateString(
//                                                                 "en-GB"
//                                                             )}
//                                                         </td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-status ${req.status?.toLowerCase()}`}
//                                                             >
//                                                                 {req.status?.toUpperCase()}
//                                                             </span>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_HISTORY_FOUND
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     );
//                 }

//                 return <EquipmentRequest userData={userData} />;

//             case "supplies": return <OfficeRequisition userData={userData} />;
//             // case "it": return <ITSupport userData={userData} />;
//             case "documents": return <Documents userData={userData} />;
//             // case "company-policy": return <CompanyPolicy />;
//             case "company-policy":
//                 return <CompanyPolicy userData={userData} />;
//             case "Organization Chart": return <OrgChart userData={userData} />;
//             // case "campus information": return <CampusInfo />;
//             case "campus information":
//                 return <CampusInfo userData={userData} />;
//             case "ees-survey": return <EESExperience userData={userData} />;

//             case "ees-analytics":
//                 if (role === 'Management' || role === 'Manager') {
//                     // Management sees the list of real data
//                     return <EESFeedbackManagement feedbacks={eesSubmissions} />;
//                 }
//                 // Employee sees the form
//                 return <EESExperience userData={userData} onFinalSubmit={handleEESSubmit} />;

//             //       case "one-on-one":
//             // return <OneOnOne userData={userData} role={role} />;

//             case "one-on-one":
//                 // This is the PERSONAL view (Employee mode)
//                 return <OneOnOne userData={userData} role="Employee" viewMode="personal" />;

//             case "manager-one-on-one":
//                 // This is the MANAGERIAL view (Manager/Management mode)
//                 return <OneOnOne userData={userData} role={role} viewMode="managerial" />;

//             case "one-on-one-report":
//                 return <OneOnOneReport userData={userData} role={role} handleModuleChange={handleModuleChange} />;

//             // Inside Dashboard.js renderActiveModule
//             case "medical-reports":
//                 if (role === 'Management') return <MedicalReports />;
//                 if (role === 'Manager') {
//                     return (
//                         <ManagerMedicalReports
//                             managerId={userData.id}           // Database Primary Key
//                             managerBadgeId={userData.EmpId}   // Company ID (HOD flag often matches this)
//                             managerDept={userData.Department} // The string "Software Development"
//                         />
//                     );
//                 }

//             case "employee-it-support":
//                 return <EquipmentRequest userData={userData} />;

//             default:


//                 if (role === 'Manager') {
//                     return renderManagerDashboard();
//                 }

//                 const currentList = role === 'Management' ? managementModulesList : employeeModulesList;
//                 return (
//                     <section className="bento-grid">
//                         {currentList.map((mod) => (
//                             <div key={mod.id} className="bento-card glass" style={{ "--accent": mod.color }} onClick={() => handleModuleChange(mod.slug)}>
//                                 <div className="card-top">
//                                     <span className="mod-icon">{mod.icon}</span>
//                                     {mod.badge > 0 && <span className={role === 'Management' ? "card-badge" : "notification-badge-ui"}>{mod.badge}</span>}
//                                 </div>
//                                 <div className="card-info"><h3>{mod.name}</h3><div className="cyber-line"></div></div>
//                             </div>
//                         ))}
//                     </section>
//                 );
//         }
//     };

//     const [companyLogo, setCompanyLogo] = useState("");
//     const currentLogo = theme === 'light' ? logoLight : logoDark;


//     const [leaveStats, setLeaveStats] = useState({
//         pending: 0,
//         approved: 0,
//         rejected: 0,
//         wfhPending: 0
//     });

//     useEffect(() => {
//         if (role !== "Management") return;

//         const fetchLeaveStats = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];


//                     const pending = leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                     const approved = leaves.filter(l => l.Status === '1').length;
//                     const rejected = leaves.filter(l => l.Status === '2').length;

//                     // WFH
//                     const wfhRes = await fetch("/gt-api/get_all_wfh_requests.php", {
//                         credentials: "include"
//                     });
//                     const wfhData = await wfhRes.json();

//                     const wfhPending = wfhData.success
//                         ? wfhData.requests.filter(r => r.status === "Pending").length
//                         : 0;

//                     setLeaveStats({ pending, approved, rejected, wfhPending });
//                 }

//             } catch (err) {
//                 console.error("Leave Stats Error:", err);
//             }
//         };

//         fetchLeaveStats();
//         const interval = setInterval(fetchLeaveStats, 5000);

//         return () => clearInterval(interval);
//     }, [role]);


//     const [mgmtLeaves, setMgmtLeaves] = useState([]);
//     const [mgmtActiveTeam, setMgmtActiveTeam] = useState("All");

//     useEffect(() => {
//         const fetchLeaves = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();
//                 if (data.success) setMgmtLeaves(data.leaves);
//             } catch (err) {
//                 console.error("Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaves();
//     }, []);





//     const mgmtChartData = useMemo(() => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept => dept.DepartmentName
//             );

//         const now = new Date();
//         const currentMonth = (now.getMonth() + 1).toString();
//         const currentYear = now.getFullYear().toString();

//         const teamList = mgmtActiveTeam === "All" ? teams : [mgmtActiveTeam];

//         return teamList.map(team => {

//             const filtered = mgmtLeaves.filter(l => {
//                 const dateParts = l.fromdate?.split("-");
//                 const lYear = dateParts?.[0];
//                 const lMonth = dateParts?.[1]
//                     ? parseInt(dateParts[1]).toString()
//                     : "";

//                 return (
//                     l.Department === team &&
//                     lMonth === currentMonth &&
//                     lYear === currentYear
//                 );
//             });

//             return {
//                 name: team,

//                 // ✅ SUM OF UNITS (FIXED)
//                 Approved: filtered
//                     .filter(l => l.Status === "1")
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

//                 Pending: filtered
//                     .filter(l => l.Status === "0" || l.Status === null)
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
//             };
//         });

//     }, [mgmtLeaves, mgmtActiveTeam]);


//     const renderManagementLeaveCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept =>
//                     dept.DepartmentName
//             );

//         return (
//             <div
//                 className="mgmt-leave-analytics clickable"
//                 onClick={() => handleModuleChange("leave-management")}
//             >

//                 <div className="card-header">
//                     <h3>Employee Leave Analytics</h3>
//                     <span className="sub-text">This Month</span>
//                 </div>

//                 {/* TEAM CHIPS */}
//                 <div className="team-row">
//                     <div
//                         className={`team-chip ${mgmtActiveTeam === "All" ? "active" : ""}`}
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             setMgmtActiveTeam("All");
//                         }}
//                     >
//                         ALL
//                     </div>

//                     {teams.map((team, i) => (
//                         <div
//                             key={i}
//                             className={`team-chip ${mgmtActiveTeam === team ? "active" : ""}`}
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 setMgmtActiveTeam(team);
//                             }}
//                         >
//                             {team}
//                         </div>
//                     ))}
//                 </div>

//                 {/* CHART */}
//                 {(() => {
//                     const isSingle = mgmtActiveTeam !== "All";

//                     return (
//                         <div className={`chart-area ${isSingle ? "single-view" : ""}`}>
//                             <ResponsiveContainer width="100%" height={170}>
//                                 <BarChart
//                                     data={mgmtChartData}
//                                     barCategoryGap={isSingle ? "70%" : "30%"}
//                                     margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
//                                 >

//                                     {/* GRADIENTS */}
//                                     <defs>
//                                         <linearGradient id="approvedGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#34d399" />
//                                             <stop offset="100%" stopColor="#059669" />
//                                         </linearGradient>

//                                         <linearGradient id="pendingGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#fbbf24" />
//                                             <stop offset="100%" stopColor="#f59e0b" />
//                                         </linearGradient>
//                                     </defs>

//                                     <CartesianGrid
//                                         strokeDasharray="3 3"
//                                         stroke="rgba(255,255,255,0.05)"
//                                         vertical={false}
//                                     />

//                                     <XAxis
//                                         dataKey="name"
//                                         tick={{ fill: "#888", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <YAxis
//                                         tick={{ fill: "#666", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <Tooltip
//                                         cursor={{ fill: "rgba(255,255,255,0.05)" }}
//                                         contentStyle={{
//                                             backgroundColor: "rgba(15, 23, 42, 0.95)", // dark glass
//                                             border: "1px solid rgba(0,255,242,0.3)",
//                                             borderRadius: "10px",
//                                             color: "#ffffff",
//                                             backdropFilter: "blur(8px)"
//                                         }}
//                                         labelStyle={{ color: "#00fff2", fontWeight: 600 }}
//                                         itemStyle={{ color: "#ffffff" }}
//                                     />


//                                     <Bar
//                                         dataKey="Approved"
//                                         stackId="a"
//                                         fill="url(#approvedGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                     <Bar
//                                         dataKey="Pending"
//                                         stackId="a"
//                                         fill="url(#pendingGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                 </BarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     );
//                 })()}


//                 <div className="card-footer">
//                     <span>Open Leave Console</span>
//                     <span>→</span>
//                 </div>
//             </div>
//         );
//     };

//     const renderSalaryIntelCard = () => {
//         // 1. Existing Counts
//         const payslips = payData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = payData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = payData.filter(d => d.doc_type === "APPRAISAL LETTER").length;

//         // 2. New Miscellaneous Count (Filtering for the images you provided)
//         const miscDocs = [
//             "FNF LETTER", "OFFER LETTER", "RELIEVING LETTER",
//             "EXPERIENCE LETTER", "EMPLOYEMENT AGREEMENT", "BANK ACCOUNT OPENING"
//         ];
//         const miscellaneous = payData.filter(d => miscDocs.includes(d.doc_type)).length;

//         // 3. Updated Total
//         const total = payslips + form16 + appraisal + miscellaneous;

//         // 4. SVG Math for 4 segments
//         const chartTotal = 125.6;
//         const gap = total > 0 ? 2 : 0;

//         const s1 = (payslips / total) * chartTotal || 0;
//         const s2 = (form16 / total) * chartTotal || 0;
//         const s3 = (appraisal / total) * chartTotal || 0;
//         const s4 = (miscellaneous / total) * chartTotal || 0;

//         return (
//             <div className="sa-card-wrapper" onClick={() => handleModuleChange("employee-salary-benefits")}>


//                 <div className="sa-card-header">
//                     <h3 className="sa-title">Salary Document Insights</h3>
//                     <button className="sa-menu-trigger">⋮</button>
//                 </div>

//                 <div className="sa-main-body">
//                     <div className="sa-gauge-area">
//                         <div className="sa-gauge-container">
//                             <svg viewBox="0 0 100 55" className="sa-gauge-svg">
//                                 {/* Background Track */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="var(--sa-track)" strokeWidth="9" strokeLinecap="round" />

//                                 {/* Segment 4: Misc (Blue) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#0ea5e9" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s4 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2 + s3}`} />

//                                 {/* Segment 3: Appraisals (Orange) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#f97316" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s3 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2}`} />

//                                 {/* Segment 2: Form 16 (Yellow) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#fbbf24" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s2 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1}`} />

//                                 {/* Segment 1: Payslips (Purple) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#8b5cf6" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s1 - gap)} ${chartTotal}`}
//                                     strokeDashoffset="0" />
//                             </svg>

//                             <div className="sa-gauge-text">
//                                 <span className="sa-overall-num">{total}</span>
//                                 <span className="sa-overall-label">Overall</span>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="sa-legend-area">
//                         {[
//                             { label: "Payslips", count: payslips, color: "purple" },
//                             { label: "Form 16", count: form16, color: "yellow" },
//                             { label: "Appraisals", count: appraisal, color: "orange" },
//                             { label: "Miscellaneous", count: miscellaneous, color: "blue" }
//                         ].map((item, index) => (
//                             <div key={index} className="sa-legend-item">
//                                 <div className="sa-item-top">
//                                     <span className={`sa-dot ${item.color}`}></span>
//                                     <span className="sa-item-count">{item.count}</span>
//                                 </div>
//                                 <span className="sa-item-label">{item.label}</span>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <div className="sa-card-footer">
//                     <span className="sa-footer-link">View Detailed Report →</span>
//                 </div>
//             </div>
//         );
//     };



//     const [okrData, setOkrData] = useState([]);
//     useEffect(() => {
//         if (!userData?.id) return;

//         const fetchOKR = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/get_user_okr.php?empId=${userData.id}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     const parsed = typeof data.data === "string"
//                         ? JSON.parse(data.data)
//                         : data.data;

//                     setOkrData(parsed);
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchOKR();

//     }, [userData?.id]);



//     const [okrStats, setOkrStats] = useState({
//         total: 0,
//         completed: 0,
//         pending: 0,
//         progressPercent: 0
//     });



//     const fetchOKRStats = async () => {
//         if (!userData?.EmpId) return;

//         try {
//             const res = await fetch(
//                 `/gt-api/get_okr_stats.php?empId=${userData.EmpId}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setOkrStats(data);
//             }

//         } catch (err) {
//             console.error("OKR STATS ERROR:", err);
//         }
//     };

//     useEffect(() => {
//         if (!userData?.EmpId) return;

//         fetchOKRStats();

//         const handleUpdate = () => fetchOKRStats();

//         window.addEventListener("okrUpdated", handleUpdate);

//         return () => window.removeEventListener("okrUpdated", handleUpdate);

//     }, [userData?.EmpId]);




//     const renderOKRCard = () => {
//         const { total, completed, pending, progressPercent } = okrStats;

//         return (
//             <div
//                 className="expanded-management-card clickable"
//                 onClick={() => handleModuleChange("okr and performance tracker")}
//             >
//                 <div className="okr-card-container">

//                     {/* HEADER */}
//                     <div className="okr-header">
//                         <div>
//                             <span className="eyebrow-text">Performance Tracker</span>
//                             <h2 className="display-title">OKR Progress</h2>
//                         </div>

//                         {/* TOP RIGHT TOTAL */}
//                         <div className="stat-box featured big">
//                             <span className="stat-label">Total KR</span>
//                             <span className="stat-value">{total}</span>
//                         </div>
//                     </div>

//                     {/* STATS ROW */}
//                     <div className="okr-stats-row">
//                         <div className="stat-box danger">
//                             <span className="stat-label">Pending</span>
//                             <span className="stat-value">{pending}</span>
//                         </div>

//                         <div className="stat-box success">
//                             <span className="stat-label">Completed</span>
//                             <span className="stat-value">{completed}</span>
//                         </div>
//                     </div>

//                     {/* PROGRESS FULL WIDTH */}
//                     <div className="progress-section-wide full">
//                         <div className="progress-labels">
//                             <span className="label-muted">Completion</span>
//                             <span className="label-bold">{progressPercent}%</span>
//                         </div>

//                         <div className="wide-bar-bg">
//                             <div
//                                 className="wide-bar-fill"
//                                 style={{ width: `${progressPercent}%` }}
//                             ></div>
//                         </div>
//                     </div>

//                     {/* FOOTER */}
//                     <div className="expanded-footer">
//                         <span className={`status-indicator ${pending > 0 ? 'is-warning' : 'is-clear'}`}>
//                             {pending > 0
//                                 ? `● ${pending} Key Results Pending`
//                                 : '● All Key Results Completed'}
//                         </span>

//                         <span className="interaction-hint">
//                             Open OKR Console →
//                         </span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     const [mgmtOneOnOneData, setMgmtOneOnOneData] = useState([]);
//     useEffect(() => {
//         const fetchMeetings = async () => {
//             const storedUser = localStorage.getItem('userData');
//             const user = JSON.parse(storedUser) || {};

//             const res = await fetch(
//                 `/gt-api/get_oneonone.php?manager_id=${user.id}&role=manager`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.meetings) {
//                 setMgmtOneOnOneData(data.meetings);
//             }
//         };

//         fetchMeetings();
//     }, []);

//     const renderOneOnOneHealthCard = () => {
//         const missedData = mgmtOneOnOneData.filter(m => m.status === "MISSED");

//         const total = mgmtOneOnOneData.length;
//         const missed = mgmtOneOnOneData.filter(m => m.status === "MISSED").length;
//         const completed = total - missed;

//         const rate = total > 0 ? Math.round((completed / total) * 100) : 0;

//         let status = "Healthy";
//         if (rate < 50) status = "Critical ⚠️";
//         else if (rate < 80) status = "Needs Attention";

//         return (
//             <div className="meeting-card" onClick={() => handleModuleChange("manager-one-on-one")}>

//                 <div className="mc-header">
//                     <h3>1:1 Meeting Scheduler</h3>
//                     <span>{status}</span>
//                 </div>

//                 {/* BIG NUMBER */}
//                 <div className="mc-center">
//                     <h1>{rate}%</h1>
//                     <p>Engagement</p>
//                 </div>

//                 {/* BARS */}
//                 <div className="mc-bars">
//                     <div className="bar completed" style={{ width: `${rate}%` }}></div>
//                     <div className="bar missed" style={{ width: `${100 - rate}%` }}></div>
//                 </div>

//                 {/* INFO */}
//                 <div className="mc-info">
//                     <span>✅ {completed} Done</span>
//                     <span>❌ {missed} Missed</span>
//                 </div>
//                 <button
//                     className="view-missed-btn"
//                     onClick={(e) => {
//                         e.stopPropagation();
//                         setShowMissedModal(true);
//                     }}
//                 >
//                     View Missed
//                 </button>

//             </div>
//         );
//     };

//     const [okrActivity, setOkrActivity] = useState([]);
//     useEffect(() => {
//         const fetchOKR = async () => {
//             try {
//                 const storedUser = localStorage.getItem("userData");
//                 const user = JSON.parse(storedUser) || {};

//                 const res = await fetch(
//                     `/gt-api/get_employee_okrs.php?role=${user.role}&managedDept=${user.department}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 if (data.success) {
//                     setOkrActivity(data.data);
//                 }

//             } catch (err) {
//                 console.error("OKR Fetch Error:", err);
//             }
//         };

//         fetchOKR();
//     }, []);

//     const recentOKR = okrActivity
//         .slice(0, 5)
//         .map(item => {
//             let type = "updated";

//             if (item.workflow_status === "Planning") {
//                 type = "new";
//             }

//             if (item.workflow_status === "Manager_Scoring_Review") {
//                 type = "pending";
//             }

//             return {
//                 name: item.emp_name,
//                 quarter: item.quarter,
//                 type,
//                 workflow_status: item.workflow_status   // 🔥 VERY IMPORTANT
//             };
//         });



//     const renderOKRActivityCard = () => {
//         const getStatusConfig = (status) => {
//             switch (status) {
//                 case "Planning": return { color: "#3b82f6", label: "submitted OKR" };
//                 case "Management_Review": return { color: "#f59e0b", label: "sent for Review" };
//                 case "Scoring": return { color: "#8b5cf6", label: "sent for Scoring" };
//                 case "Sign_Off": return { color: "#10b981", label: "finalized OKR" };
//                 default: return { color: "#00bcd4", label: "updated OKR" };
//             }
//         };

//         return (
//             <div className="mgt-okr-card1 timeline-style clickable" onClick={() => handleModuleChange("employee-okrs")}>
//                 <div className="card-header-v2">
//                     <div className="title-section">
//                         <h3>OKR Stream</h3>
//                         <div className="live-dot-wrapper">
//                             <span className="live-dot"></span>
//                             <span className="sub-text">Live updates</span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="okr-activity-timeline">
//                     {recentOKR.length === 0 ? (
//                         <div className="empty-state">No recent activity detected</div>
//                     ) : (
//                         recentOKR.slice(0, 3).map((item, i) => {
//                             const config = getStatusConfig(item.workflow_status);
//                             return (
//                                 <div key={i} className="timeline-item">
//                                     {/* The Vertical Line & Dot */}
//                                     <div className="timeline-visual">
//                                         <div className="timeline-line"></div>
//                                         <div className="timeline-marker" style={{ borderColor: '#111827', background: config.color }}>
//                                             <div className="marker-inner-dot"></div>
//                                         </div>
//                                     </div>

//                                     {/* Single Content Box */}
//                                     <div className="timeline-content-box">
//                                         <div className="content-top">
//                                             <span className="emp-name">{item.name}</span>
//                                             <span className="quarter-tag">{item.quarter}</span>
//                                         </div>
//                                         <p className="status-message">{config.label}</p>
//                                     </div>
//                                 </div>
//                             );
//                         })
//                     )}
//                 </div>

//                 <div className="card-footer-v2">
//                     <span>Access Module</span>
//                     {/* <div className="arrow-circle">→</div> */}
//                 </div>


//             </div>
//         );
//     };

//     const renderManagementShortcutsCard = () => {
//         const shortcuts = [

//             { name: "Create Invoice", icon: "🏦", slug: "create-invoice" },
//             { name: "Policy RnU", icon: "📋", slug: "policy-logs" },
//             { name: "Career Development", icon: "🏆", slug: "career pathways" },
//             { name: "Expense Reimbursement", icon: "💰", slug: "reimbursements" },
//             // { name: "ACM Updates", icon: "📢", slug: "manage-quarterly-updates" },
//             { name: "Self OKR", icon: "🎯", slug: "okr and performance tracker" },
//             { name: "Own Financial", icon: "💳", slug: "pay and benefits" },
//             { name: "Access ACM Info", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//             // { name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },
//             { name: "IT Support", icon: "🖥️", slug: "employee-it-support" },
//             { name: "Attendance Tracker", icon: "📊", slug: "attendance-tracker" },
//             // { name: "Company Setup", icon: "⚙️", slug: "CompanySetup" },





//         ];

//         return (
//             <div className="mgt-shortcut-card">

//                 <div className="card-header">
//                     <h3>Quick Access</h3>
//                     <span className="sub-text">Shortcuts</span>
//                 </div>

//                 <div className="shortcut-grid">
//                     {shortcuts.map((item, i) => (
//                         <div
//                             key={i}
//                             className="shortcut-item"
//                             onClick={() => handleModuleChange(item.slug)}
//                         >
//                             <span className="shortcut-icon">{item.icon}</span>
//                             <span className="shortcut-text">{item.name}</span>
//                         </div>
//                     ))}
//                 </div>

//             </div>
//         );
//     };


//     const renderEmployeeDashboard = () => {
//         return (
//             <div className="dashboard-layout">

//                 <div className="dashboard-row row-top">
//                     {renderLeavePieChart()}
//                     {renderPayChart()}
//                     {renderOneOnOneCard()}



//                     {/* {renderEquipmentCard()} */}
//                 </div>

//                 <div className="dashboard-row row-middle">
//                     {renderOKRCard()}
//                     {renderCareerPathwaysCard()}
//                 </div>

//                 <div className="dashboard-row row-bottom">
//                     {renderPolicyCard()}
//                     <QuarterlyCard handleModuleChange={handleModuleChange} />
//                 </div>

//             </div>
//         );
//     };

//     const renderManagementDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>






//         );
//     };

//     const renderManagerDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>




//         );
//     };

//     const currentEvent =
//         todayEvents && todayEvents.length > 0
//             ? todayEvents[currentEventIndex]
//             : null;


//     const combinedEvents = [];

//     // 🎂 Birthday / Anniversary
//     if (currentEvent && currentEvent.fullName) {
//         combinedEvents.push({
//             type: "event",
//             title: currentEvent.fullName,
//             tag: currentEvent.isBirthday ? "BIRTHDAY" : "WORK ANNIVERSARY",
//             icon: currentEvent.isBirthday ? "🎂" : "🎉"
//         });
//     }

//     // 🎊 Festival
//     if (upcomingFestival) {
//         combinedEvents.push({
//             type: "festival",
//             title: upcomingFestival.name,
//             tag: isFestivalToday ? "FESTIVAL TODAY" : "UPCOMING FESTIVAL",
//             icon: "🎊",
//             sub: isFestivalToday ? "Today 🎉" : `In ${daysLeft} days`
//         });
//     }

//     useEffect(() => {
//         if (combinedEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setActiveEventIndex(prev => (prev + 1) % combinedEvents.length);
//         }, 4000);

//         return () => clearInterval(interval);
//     }, [combinedEvents.length]);

//     const activeEvent = combinedEvents[activeEventIndex];


//     return (

//         <div


//             className={`dash-container ${theme}-theme`}
//             style={
//                 theme === 'light'
//                     ? {
//                         backgroundImage: `url(${logoLight})`,
//                         backgroundSize: 'cover',
//                         backgroundRepeat: 'no-repeat',
//                         backgroundPosition: 'center',
//                         backgroundColor: 'var(--bg-main)'

//                     }
//                     : {}
//             }
//         >


//             {showMissedModal && (
//                 <div className="modal-overlay" onClick={() => setShowMissedModal(false)}>
//                     <div className="modal-card" onClick={(e) => e.stopPropagation()}>

//                         <h3>Missed 1:1 Meetings</h3>

//                         {mgmtOneOnOneData.filter(m => m.status === "MISSED").length === 0 ? (
//                             <p>No missed meetings 🎉</p>
//                         ) : (
//                             mgmtOneOnOneData
//                                 .filter(m => m.status === "MISSED")
//                                 .map((m, i) => (
//                                     <div key={i} className="missed-item">
//                                         <strong>{m.employee_name}</strong>
//                                         <span>{m.date}</span>
//                                     </div>
//                                 ))
//                         )}

//                         <button onClick={() => setShowMissedModal(false)}>
//                             Close
//                         </button>

//                     </div>
//                 </div>
//             )}



//             <div className="auth-background-overlay"></div>






//             <Sidebar
//                 role={role}
//                 userData={userData}
//                 activeModule={activeModule}
//                 openMenus={openMenus}
//                 toggleSubMenu={toggleSubMenu}
//                 handleModuleChange={handleModuleChange}
//                 handleLogout={handleLogout}
//                 mobileMenuOpen={mobileMenuOpen}
//                 setMobileMenuOpen={setMobileMenuOpen}
//                 pendingRequestsCount={pendingRequestsCount}
//             />

//             <main className="dash-content">

//                 <header className="content-header">

//                     {/* 🔷 LEFT */}
//                     <div className="header-left">
//                         <div className="header-text">

//                             <h1>
//                                 {activeModule === "grid" && !showProfile ? "Welcome," : ""}{" "}
//                                 <span className={theme === 'light' ? "name-light" : "name-accent"}>
//                                     {showProfile
//                                         ? "MY PROFILE"
//                                         : (activeModule === "grid"
//                                             ? userData.firstName || userData.FirstName
//                                             : (activeModule === "attendance"
//                                                 ? "LEAVE MANAGEMENT"
//                                                 : (activeModule === "one-on-one-report"
//                                                     ? "ONE-ON-ONE REPORT"
//                                                     : activeModule.toUpperCase().replace(/-/g, ' ')
//                                                 )
//                                             )
//                                         )
//                                     }
//                                 </span>
//                             </h1>

//                             {activeModule === 'attendance' && userData.joiningDate && (
//                                 <div className="joining-info">
//                                     JOINING_DATE: {new Date(userData.joiningDate).toLocaleDateString('en-GB').toUpperCase()}
//                                 </div>
//                             )}

//                         </div>
//                     </div>







//                     <div className="header-center">

//                         {/* TIME + DATE FIRST */}
//                         <div className="time-date-right">
//                             <div className="live-time">{currentTime}</div>

//                             <div className="today-widget">
//                                 <span>📅 {todayDate}</span>
//                                 <small>Have a Nice Day!</small>
//                             </div>
//                         </div>

//                         {/* EVENT CARD SECOND */}
//                         <div
//                             className={`executive-event-bar ${theme === 'light' ? 'light-theme-elite' : 'dark-theme-elite'}
//         ${role === "Management" || role === "Manager" ? "clickable" : ""}`}
//                             onClick={() => {
//                                 if (role === "Management" || role === "Manager") {
//                                     handleModuleChange("events-celebrations");
//                                 }
//                             }}
//                         >
//                             <div
//                                 className={`event-status-box ${currentEvent
//                                     ? (currentEvent.isBirthday ? 'bg-birth' : 'bg-anniv')
//                                     : 'bg-neutral'
//                                     }`}
//                             >
//                                 <span className="event-icon-small">
//                                     {currentEvent
//                                         ? (currentEvent.isBirthday ? "🎂" : "🎉")
//                                         : "✨"}
//                                 </span>
//                             </div>

//                             <div className="event-content-main">
//                                 <div className="event-label-row">
//                                     <span className="event-tag">
//                                         {activeEvent ? activeEvent.tag : "TODAY"}
//                                     </span>
//                                 </div>

//                                 <h3 className="event-title-text">

//                                     {activeEvent ? (
//                                         <span className="event-highlight">
//                                             {activeEvent.icon} {activeEvent.title}
//                                         </span>
//                                     ) : (
//                                         <span className="event-empty-text">
//                                             No events today
//                                         </span>
//                                     )}
//                                 </h3>
//                             </div>

//                             <div className="event-action-wrapper">
//                                 <button
//                                     className="minimal-wish-btn"
//                                     disabled={!currentEvent}
//                                     onClick={(e) => e.stopPropagation()}
//                                 >
//                                     <div className="btn-line"></div>
//                                 </button>
//                             </div>
//                         </div>

//                     </div>







//                     <div className="header-controls">

//                         {/* 🌗 THEME */}
//                         <div className="theme-switch-container">
//                             <label className="theme-slider-switch">
//                                 <input
//                                     type="checkbox"
//                                     onChange={toggleTheme}
//                                     checked={theme === 'light'}
//                                 />
//                                 <span className="theme-slider round">
//                                     <span className="sun-icon">☀️</span>
//                                     <span className="moon-icon">🌙</span>
//                                 </span>
//                             </label>
//                         </div>




//                         {(activeModule !== "grid" || showProfile) && (
//                             <button
//                                 className="back-btn"
//                                 onClick={() => handleModuleChange("grid")}
//                             >
//                                 Back
//                             </button>
//                         )}

//                     </div>

//                 </header>


//                 {activeModule === "grid" ? (

//                     role === "Management"
//                         ? renderManagementDashboard()
//                         : role === "Manager"
//                             ? renderManagerDashboard()   // 🔥 ADD THIS LINE
//                             : renderEmployeeDashboard()

//                 ) : (
//                     renderActiveModule()
//                 )}

//                 <div className="dash-footer">
//                     Design & Developed by Genesis Tech Engineers © 2026
//                 </div>
//             </main>

//             {(role === "Management" || role === "Manager") && (
//                 <>
//                     <div
//                         className="ai-chat-float-btn"
//                         onClick={() => setShowAIChat(true)}
//                     >
//                         🤖
//                     </div>

//                     {showAIChat && (
//                         <div className="ai-chat-modal">
//                             <div className="ai-chat-header">
//                                 <span>ELMS AI Assistant</span>
//                                 <button onClick={() => setShowAIChat(false)}>
//                                     ✕
//                                 </button>
//                             </div>

//                             <div className="ai-chat-body">
//                                 {chatMessages.map((msg, index) => (
//                                     <div
//                                         key={index}
//                                         className={`chat-bubble ${msg.sender}`}
//                                     >
//                                         <pre>{msg.text}</pre>
//                                     </div>
//                                 ))}

//                                 {chatLoading && (
//                                     <div className="chat-bubble ai">
//                                         Thinking...
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="ai-chat-footer">
//                                 <input
//                                     type="text"
//                                     value={chatInput}
//                                     onChange={(e) => setChatInput(e.target.value)}
//                                     placeholder="Ask anything..."
//                                     onKeyDown={(e) => {
//                                         if (e.key === "Enter") {
//                                             sendAIMessage();
//                                         }
//                                     }}
//                                 />

//                                 <button onClick={sendAIMessage}>
//                                     Send
//                                 </button>
//                             </div>
//                         </div>
//                     )}
//                 </>
//             )}

//             {/* 🔴 MANDATORY PROFILE POPUP MODAL */}
//             {showMandatoryProfileModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">⚠️</div>
//                             <h2>Mandatory Profile Completion Required</h2>
//                             <p>
//                                 Your employee profile has missing information. Please fill in the required field(s) below to continue using the system.
//                             </p>
//                         </div>

//                         {mandatoryError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {mandatoryError}</span>
//                             </div>
//                         )}

//                         {mandatorySuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {mandatorySuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryProfile} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingProfileFields.phone && (
//                                     <div className="mandatory-input-group">
//                                         <label>Mobile Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="tel"
//                                             placeholder="Enter mobile number"
//                                             value={mandatoryFormData.phone}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, phone: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.dob && (
//                                     <div className="mandatory-input-group">
//                                         <label>Date of Birth <span className="req-star">*</span></label>
//                                         <input
//                                             type="date"
//                                             max={new Date().toISOString().split("T")[0]}
//                                             value={mandatoryFormData.dob}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, dob: e.target.value }))}
//                                             onClick={(e) => {
//                                                 try {
//                                                     if (e.target.showPicker) e.target.showPicker();
//                                                 } catch (err) { }
//                                             }}
//                                             required
//                                             className="mandatory-date-input"
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.city && (
//                                     <div className="mandatory-input-group">
//                                         <label>City <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter city"
//                                             value={mandatoryFormData.city}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, city: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.country && (
//                                     <div className="mandatory-input-group">
//                                         <label>Country <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter country"
//                                             value={mandatoryFormData.country}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, country: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Permanent Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter permanent address"
//                                             value={mandatoryFormData.address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.local_address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Current / Local Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter current / local address"
//                                             value={mandatoryFormData.local_address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, local_address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={mandatorySaving}
//                                 >
//                                     {mandatorySaving ? "Saving Profile..." : "Save Profile & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//             {/* 🏦 MANDATORY BANK DETAILS POPUP MODAL */}
//             {showMandatoryBankModal && !showMandatoryProfileModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">🏦</div>
//                             <h2>Mandatory Bank Details Required</h2>
//                             <p>
//                                 Your employee bank record has missing information. Please fill in the required field(s) below for payroll & salary processing.
//                             </p>
//                         </div>

//                         {bankError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {bankError}</span>
//                             </div>
//                         )}

//                         {bankSuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {bankSuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryBankDetails} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingBankFields.bankName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Bank Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC Bank, ICICI Bank"
//                                             value={bankFormData.bankName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, bankName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.holderName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Holder Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account holder name"
//                                             value={bankFormData.holderName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, holderName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accNumber && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account number"
//                                             value={bankFormData.accNumber}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accNumber: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.ifsc && (
//                                     <div className="mandatory-input-group">
//                                         <label>IFSC Code <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC0001234"
//                                             value={bankFormData.ifsc}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, ifsc: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.branch && (
//                                     <div className="mandatory-input-group">
//                                         <label>Branch Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter branch name"
//                                             value={bankFormData.branch}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, branch: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accType && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Type <span className="req-star">*</span></label>
//                                         <select
//                                             value={bankFormData.accType}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accType: e.target.value }))}
//                                             required
//                                         >
//                                             <option value="Saving Account">Saving Account</option>
//                                             <option value="Current Account">Current Account</option>
//                                             <option value="Salary Account">Salary Account</option>
//                                         </select>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={bankSaving}
//                                 >
//                                     {bankSaving ? "Saving Bank Details..." : "Save Bank Details & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Dashboard;


























// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';

// import {
//     ResponsiveContainer,
//     BarChart,
//     Bar,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip
// } from "recharts";
// import { Bar as ChartBar, Pie, Doughnut } from 'react-chartjs-2';

// // ✅ REACT + ROUTER
// import React, { useState, useEffect, useMemo } from 'react';
// import { useParams, useNavigate, useLocation } from 'react-router-dom';

// // ✅ MODULES
// import Attendance from '../../modules/Attendance';
// import PayBenefits from '../../modules/PayBenefits';
// import OKRTracker from '../../modules/OKRTracker';
// import CareerPathways from '../../modules/CareerPathways';
// import EquipmentRequest from '../../modules/EquipmentRequest';
// import OfficeRequisition from '../../modules/OfficeRequisition';
// import ITSupport from '../../modules/ITSupport';
// import Documents from '../../modules/Documents';
// import CompanyPolicy from '../../modules/CompanyPolicy';
// import OrgChart from '../../modules/OrgChart';
// import CampusInfo from '../../modules/CampusInfo';
// import AddDepartment from '../../modules/AddDepartment';
// import AddEmployee from '../../modules/AddEmployee';
// import ManageDepartment from '../../modules/ManageDepartment';
// import ManageEmployee from '../../modules/ManageEmployee';
// import MyProfile from '../../modules/MyProfile';
// import LeaveManagement from '../../modules/LeaveManagement';
// import EESExperience from '../../modules/EESExperience';
// import EESFeedbackManagement from '../../modules/EESFeedbackManagement';
// import MedicalReports from '../../modules/MedicalReports';
// import ManagementOKRViewer from '../../modules/ManagementOKRViewer';
// import ManagerLeaveManagement from '../../modules/ManagerLeaveManagement';
// import ManagerMedicalReports from '../../modules/ManagerMedicalReports';
// import EmployeeSalaryBenefits from '../../modules/EmployeeSalaryBenefits';
// import PolicyAdminDashboard from '../../modules/PolicyAdminDashboard';
// import ManageEmployeeDocs from '../../modules/ManageEmployeeDocs';
// import OneOnOne from '../../modules/OneOnOne';
// import EventsCelebrations from '../../modules/EventsCelebrations';
// import ProjectModule from '../../modules/ProjectModule';
// import QuarterlyUpdates from '../../modules/QuarterlyUpdates';
// import ManagementQuarterlyUpdate from '../../modules/ManagementQuarterlyUpdate';
// import ReimbursementManagement from '../../modules/ReimbursementManagement';
// import WorkFromHome from '../../modules/WorkFromHome';
// import WFHManagement from '../../modules/WFHManagement';
// import OneOnOneAnalyticsCard from "../../modules/OneOnOneAnalyticsCard";
// import OneOnOneReport from '../../modules/OneOnOneReport';
// import InvoiceGenerator from '../../modules/InvoiceGenerator';
// import AttendanceTracker from '../../modules/AttendanceTracker';
// import CompanySetup from '../../modules/CompanySetup';
// import Sidebar from "../../components/Sidebar/sidebar";

// // ✅ ASSETS
// import logoLight from '../../assets/logowhite-p.png';
// import logoDark from '../../assets/logo-white-r.png';

// // ✅ STYLES
// import './Dashboard.css';


// // ✅ CHART.JS CORE
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip as ChartTooltip,  // ✅ rename this
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// } from 'chart.js';

// // ✅ REGISTER CHART.JS
// ChartJS.register(
//     ArcElement,
//     ChartTooltip, // ✅ use renamed one
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// );



// const QuarterlyCard = ({ handleModuleChange }) => {

//     const [latest, setLatest] = React.useState(null);

//     React.useEffect(() => {
//         fetch(
//             "/gt-api/get_quarterly_media.php?type=ACM Presentation",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "ACM DATA:",
//                     data
//                 );

//                 if (data.success && data.data.length > 0) {
//                     setLatest(data.data[0]);
//                 }
//             })
//             .catch(err => console.error("Quarterly Fetch Error:", err));
//     }, []);

//     console.log("LATEST ACM:", latest);

//     return (
//         <div
//             className="quarterly-pro-card clickable"
//             onClick={() => handleModuleChange("quarterly-updates")}
//         >
//             {/* Glow Layer */}
//             <div className="card-glow"></div>

//             {/* HEADER */}
//             <div className="qp-header">
//                 <div className="qp-left">
//                     <span className="qp-tag">ACM Updates</span>
//                     <h3 className="qp-title">Quarterly Insights</h3>
//                 </div>

//                 <div className="qp-icon">📢</div>
//             </div>

//             {/* BODY */}
//             <div className="qp-body">
//                 {latest ? (
//                     <>
//                         <h4 className="qp-main-title">{latest.title}</h4>

//                         <div className="qp-meta">
//                             <span className="qp-date">
//                                 {new Date(latest.created_at).toLocaleDateString('en-GB')}
//                             </span>
//                             <span className="qp-badge">NEW</span>
//                         </div>
//                     </>
//                 ) : (
//                     <div className="qp-empty">
//                         <div className="qp-loader"></div>
//                         <span>Awaiting next update</span>
//                     </div>
//                 )}
//             </div>

//             {/* FOOTER */}
//             <div className="qp-footer">
//                 <span>View Presentation</span>
//                 <span className="arrow">→</span>
//             </div>
//         </div>
//     );
// };


// const Dashboard = () => {
//     const [dashboardDepartments, setDashboardDepartments] = useState([]);
//     const [dashboardPathways, setDashboardPathways] = useState([]);
//     const [policyCount, setPolicyCount] = useState(0);

//     const [showAIChat, setShowAIChat] = useState(false);

//     const [chatMessages, setChatMessages] = useState([
//         {
//             sender: "ai",
//             text: "Hello 👋 Ask me anything about your ELMS database."
//         }
//     ]);

//     const [chatInput, setChatInput] = useState("");
//     const [chatLoading, setChatLoading] = useState(false);



//     const [showMissedModal, setShowMissedModal] = useState(false);

//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//     const [todayEvents, setTodayEvents] = useState([]);
//     useEffect(() => {
//         const fetchTodayEvents = async () => {
//             try {
//                 const res = await fetch('/gt-api/get_celebrations.php');
//                 const data = await res.json();

//                 if (data.success) {
//                     setTodayEvents(data.data || []);
//                 }
//             } catch (err) {
//                 console.error("Dashboard Events Error:", err);
//             }
//         };

//         fetchTodayEvents();
//     }, []);
//     const [currentEventIndex, setCurrentEventIndex] = useState(0);
//     useEffect(() => {
//         if (!todayEvents || todayEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setCurrentEventIndex((prev) =>
//                 (prev + 1) % todayEvents.length
//             );
//         }, 3000); // change every 3 sec

//         return () => clearInterval(interval);
//     }, [todayEvents]);


//     const [equipmentData, setEquipmentData] = useState({
//         total: 0,
//         pending: 0,
//         blocking: 0
//     });



//     const [logs, setLogs] = useState({});

//     const totalPolicies = 11;
//     const readCount = Object.keys(logs || {}).length;

//     const progress = totalPolicies > 0
//         ? Math.round((readCount / totalPolicies) * 100)
//         : 0;


//     const params = useParams();
//     const module = params.module;

//     const storedUser = JSON.parse(localStorage.getItem("userData"));
//     const role = storedUser?.role;
//     const navigate = useNavigate();

//     useEffect(() => {
//         const storedUser = localStorage.getItem("userData");

//         if (!storedUser) {
//             navigate("/", { replace: true });
//             return;
//         }

//         // prevent back button access after logout
//         window.history.pushState(null, "", window.location.href);
//         window.onpopstate = function () {
//             const user = localStorage.getItem("userData");
//             if (!user) {
//                 navigate("/", { replace: true });
//             }
//         };

//     }, [navigate]);







//     const [policyLogs, setPolicyLogs] = useState({});





//     const checkIfFestivalIsToday = (festival, daysLeftVal, isTodayFlag) => {
//         if (!festival) return false;
//         if (isTodayFlag === true || daysLeftVal === 0) return true;

//         if (festival.date) {
//             const today = new Date();
//             const currentDay = today.getDate();
//             const currentMonth = today.getMonth();
//             const monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
//             const currentMonthName = monthNames[currentMonth];

//             const dateLower = String(festival.date).toLowerCase();

//             if (dateLower.includes(currentMonthName) || (currentMonthName === "sep" && dateLower.includes("sept"))) {
//                 const rangeMatch = dateLower.match(/(\d+)\s*(?:st|nd|rd|th)?\s*to\s*(\d+)\s*(?:st|nd|rd|th)?/);
//                 if (rangeMatch) {
//                     const startDay = parseInt(rangeMatch[1], 10);
//                     const endDay = parseInt(rangeMatch[2], 10);
//                     if (currentDay >= startDay && currentDay <= endDay) {
//                         return true;
//                     }
//                 }

//                 const numbers = dateLower.match(/\d+/g);
//                 if (numbers) {
//                     for (let numStr of numbers) {
//                         const num = parseInt(numStr, 10);
//                         if (Math.abs(num - currentDay) <= 1) {
//                             return true;
//                         }
//                     }
//                 }
//             }
//         }

//         if (typeof daysLeftVal === 'number' && daysLeftVal <= 1) {
//             return true;
//         }

//         return false;
//     };

//     const [upcomingFestival, setUpcomingFestival] = useState(null);
//     const [daysLeft, setDaysLeft] = useState(null);
//     const [isFestivalToday, setIsFestivalToday] = useState(false);
//     const [activeEventIndex, setActiveEventIndex] = useState(0);
//     useEffect(() => {
//         fetch("/gt-api/get_upcoming_festival.php", {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 const fest = data.festival || data.upcoming || (data.data && data.data[0]);
//                 if (fest) {
//                     const normalized = {
//                         ...fest,
//                         name: fest.name || fest.festival_name || fest.title || "Festival",
//                         image: fest.image || fest.img || fest.imageName || ""
//                     };
//                     setUpcomingFestival(normalized);
//                     setDaysLeft(data.daysLeft ?? 0);
//                     const festIsToday = data.isToday || data.daysLeft === 0 || checkIfFestivalIsToday(normalized, data.daysLeft, data.isToday);
//                     setIsFestivalToday(festIsToday);
//                 }
//             })
//             .catch(err => console.error(err));
//     }, []);


//     const location = useLocation();



//     const [showProfile, setShowProfile] = useState(false);
//     const [showPasswordModal, setShowPasswordModal] = useState(false);
//     const [isEditing, setIsEditing] = useState(false);

//     const [activeModule, setActiveModule] = useState(module || "grid");
//     const [isLightMode, setIsLightMode] = useState(false);

//     const [openMenus, setOpenMenus] = useState({
//         department: false,
//         employee: false
//     });

//     const [pendingRequestsCount, setPendingRequestsCount] = useState(0);
//     const [pendingLeavesCount, setPendingLeavesCount] = useState(0);
//     const [requestsList, setRequestsList] = useState([]);
//     const [notifCount, setNotifCount] = useState(0);

//     const [eesSubmissions, setEesSubmissions] = useState([]);
//     const handleEESSubmit = (newFeedback) => {
//         setEesSubmissions(prev => [...prev, newFeedback]);
//     };

//     const [passwordForm, setPasswordForm] = useState({
//         currentPassword: '',
//         newPassword: '',
//         confirmPassword: ''
//     });

//     const [showMandatoryProfileModal, setShowMandatoryProfileModal] = useState(false);
//     const [missingProfileFields, setMissingProfileFields] = useState({
//         phone: false,
//         dob: false,
//         city: false,
//         address: false,
//         local_address: false,
//         country: false
//     });
//     const [mandatoryFormData, setMandatoryFormData] = useState({
//         phone: '',
//         dob: '',
//         city: '',
//         address: '',
//         local_address: '',
//         country: ''
//     });
//     const [mandatorySaving, setMandatorySaving] = useState(false);
//     const [mandatoryError, setMandatoryError] = useState('');
//     const [mandatorySuccessMsg, setMandatorySuccessMsg] = useState('');

//     // 🔴 MANDATORY BANK DETAILS MODAL STATE
//     const [showMandatoryBankModal, setShowMandatoryBankModal] = useState(false);
//     const [missingBankFields, setMissingBankFields] = useState({
//         bankName: false,
//         holderName: false,
//         accNumber: false,
//         ifsc: false,
//         branch: false,
//         accType: false
//     });
//     const [bankFormData, setBankFormData] = useState({
//         bankName: '',
//         holderName: '',
//         accNumber: '',
//         ifsc: '',
//         branch: '',
//         accType: 'Saving Account'
//     });
//     const [bankSaving, setBankSaving] = useState(false);
//     const [bankError, setBankError] = useState('');
//     const [bankSuccessMsg, setBankSuccessMsg] = useState('');




//     const [userData, setUserData] = useState(() => {
//         const storedData = localStorage.getItem("userData");
//         if (storedData) return JSON.parse(storedData);

//         const firstName = location.state?.userName?.split(' ')[0] || "User";
//         const lastName = location.state?.userName?.split(' ')[1] || "";

//         return {
//             firstName,
//             lastName,
//             email: "",
//             dept: "Loading...",
//             phone: "",
//             gender: "",
//             dob: "",
//             address: "",
//             city: "",
//             country: "",
//             employeeId: location.state?.empId || null,
//             profileImage: null,
//             joiningDate: null,
//             HOD: null
//         };
//     });


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_career_pathways.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setDashboardPathways(
//                         data.pathways || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_departments.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "DASHBOARD DEPARTMENTS:",
//                     data
//                 );

//                 if (data.success) {

//                     setDashboardDepartments(
//                         data.departments || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) {

//             setPolicyCount(11);
//             return;

//         }

//         fetch(
//             "/gt-api/get_policies.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setPolicyCount(
//                         data.policies?.length || 0
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);
//     // ✅ THEN use it
//     const employeeId = userData?.id || userData?.employeeId;


//     useEffect(() => {
//         const fetchLeaveDashboardData = async () => {
//             if (!employeeId) return;

//             try {
//                 const res = await fetch(`/gt-api/get_leaves.php?empid=${employeeId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 const wfhRes = await fetch(`/gt-api/get_wfh.php?empid=${employeeId}`, {
//                     credentials: "include"
//                 });
//                 const wfhData = await wfhRes.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];

//                     // 🔥 SAME LOGIC AS ATTENDANCE
//                     const today = new Date();
//                     const currentYear = today.getFullYear();

//                     const fiscalYearStart = new Date(currentYear, 3, 1);

//                     const activeFiscalYearStart =
//                         today < fiscalYearStart
//                             ? new Date(currentYear - 1, 3, 1)
//                             : fiscalYearStart;

//                     // ✅ Dynamic Sick Total (joining based)
//                     let sickTotal = 12;

//                     if (userData?.joiningDate) {
//                         const joining = new Date(userData.joiningDate);

//                         const fyEnd = new Date(activeFiscalYearStart);
//                         fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
//                         fyEnd.setMonth(2);
//                         fyEnd.setDate(31);

//                         if (joining > activeFiscalYearStart) {
//                             if (joining > fyEnd) {
//                                 sickTotal = 0;
//                             } else {
//                                 const joinMonth = joining.getMonth();
//                                 const fyEndMonth = 2;

//                                 let monthsRemaining;

//                                 if (joinMonth <= fyEndMonth) {
//                                     monthsRemaining = fyEndMonth - joinMonth + 1;
//                                 } else {
//                                     monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
//                                 }

//                                 sickTotal = monthsRemaining;
//                             }
//                         }
//                     }

//                     let sickUsed = 0;
//                     let earnedUsed = 0;

//                     leaves.forEach(leave => {
//                         const status = String(leave.Status);
//                         const days = parseFloat(leave.total) || 0;
//                         const leaveDate = new Date(leave.fromdate);
//                         const medStatus = String(leave.medical_doc_status);

//                         // ✅ SAME CONDITION AS ATTENDANCE
//                         if (status === '0' || status === '1') {

//                             if (leave.leavetype === 'Sick Leave') {
//                                 if (leaveDate >= activeFiscalYearStart) {
//                                     sickUsed += days;
//                                 }
//                             }

//                             else if (leave.leavetype === 'Earned Leave') {

//                                 // 🔥 MEDICAL CONVERSION LOGIC
//                                 if (medStatus === '1' || medStatus === '0') {
//                                     if (leaveDate >= activeFiscalYearStart) {
//                                         sickUsed += days;
//                                     }
//                                 } else {
//                                     earnedUsed += days;
//                                 }
//                             }
//                         }
//                     });


//                     console.log("LEAVES:", leaves);
//                     console.log("SICK USED:", sickUsed);
//                     console.log("EARNED USED:", earnedUsed);
//                     console.log("API EARNED BALANCE:", data.earned);

//                     setLeaveData({
//                         leaveHistory: leaves,
//                         leaveBalances: {
//                             sick: { used: sickUsed, total: sickTotal },
//                             earned: { used: earnedUsed, total: parseFloat(data.earned) || 0 }
//                         },
//                         wfhHistory: wfhData.requests || []
//                     });
//                 }

//             } catch (err) {
//                 console.error("Dashboard Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaveDashboardData();
//     }, [employeeId, userData?.joiningDate]);


//     useEffect(() => {
//         setActiveModule(module || "grid");
//     }, [module]);

//     useEffect(() => {

//         if (role === 'Management' || role === 'Manager') {

//             const fetchRealTimeLeaves = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_leaves.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {
//                         // Count requests with Status '0' or null
//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };


//             fetchRealTimeLeaves();


//             const liveInterval = setInterval(fetchRealTimeLeaves, 5000);

//             return () => clearInterval(liveInterval);
//         }
//     }, [role]);



//     useEffect(() => {

//         const fetchUserData = async () => {

//             try {

//                 const response = await fetch("/gt-api/get_profile.php", {
//                     credentials: "include"
//                 });

//                 const data = await response.json();

//                 if (data.success && data.employee) {

//                     const storedUser = JSON.parse(localStorage.getItem("userData"));

//                     const updatedUser = {
//                         id: data.employee.id,
//                         EmpId: data.employee.EmpId,

//                         firstName: data.employee.FirstName,
//                         FirstName: data.employee.FirstName,

//                         lastName: data.employee.LastName,
//                         LastName: data.employee.LastName,

//                         email: data.employee.EmailId,
//                         EmailId: data.employee.EmailId,

//                         Department: data.employee.DepartmentName || data.employee.Department,

//                         HOD: data.employee.HOD,
//                         Designation: data.employee.Designation,
//                         phone: data.employee.Phonenumber,
//                         gender: data.employee.Gender,
//                         dob: data.employee.Dob,
//                         address: data.employee.Address,
//                         local_address: data.employee.LocalAddress,
//                         city: data.employee.City,
//                         country: data.employee.Country,
//                         profileImage: data.employee.ProfilePicture || null,
//                         joiningDate: data.employee.JoiningDate,

//                         role: storedUser?.role
//                     };

//                     setUserData(updatedUser);

//                     localStorage.setItem("userData", JSON.stringify(updatedUser));

//                     // ✅ CHECK ONLY MISSING MANDATORY PROFILE FIELDS
//                     const isMissing = (val) => !val || String(val).trim() === '' || String(val).trim() === '0000-00-00';
//                     const missing = {
//                         phone: isMissing(updatedUser.phone),
//                         dob: isMissing(updatedUser.dob),
//                         city: isMissing(updatedUser.city),
//                         address: isMissing(updatedUser.address),
//                         local_address: isMissing(updatedUser.local_address),
//                         country: isMissing(updatedUser.country)
//                     };

//                     if (Object.values(missing).some(Boolean)) {
//                         setMissingProfileFields(missing);
//                         setMandatoryFormData({
//                             phone: updatedUser.phone || '',
//                             dob: updatedUser.dob || '',
//                             city: updatedUser.city || '',
//                             address: updatedUser.address || '',
//                             local_address: updatedUser.local_address || '',
//                             country: updatedUser.country || ''
//                         });
//                         setShowMandatoryProfileModal(true);
//                     }

//                     // 🏦 CHECK MANDATORY BANK DETAILS
//                     const empIdForBank = data.employee.id || data.employee.EmpId;
//                     if (empIdForBank) {
//                         let bank = null;
//                         try {
//                             const bankRes = await fetch(`/gt-api/get_bank_details.php?emp_id=${empIdForBank}`, {
//                                 credentials: "include"
//                             });
//                             const rawText = await bankRes.text();
//                             try {
//                                 const json = JSON.parse(rawText);
//                                 if (json && (json.success || json.bank || json.bank_name || json.bankName)) {
//                                     bank = json.bank || json.data || json.details || json.employee_bank_details || json;
//                                 }
//                             } catch (parseErr) {
//                                 console.log("get_bank_details json parse error:", parseErr);
//                             }
//                         } catch (bErr) {
//                             console.error("Bank details fetch network error:", bErr);
//                         }

//                         const b = bank || {};

//                         const getVal = (...keys) => {
//                             for (const k of keys) {
//                                 if (b[k] !== undefined && b[k] !== null && String(b[k]).trim() !== '') {
//                                     return String(b[k]).trim();
//                                 }
//                             }
//                             return '';
//                         };

//                         const bankNameVal = getVal('bankName', 'bank_name', 'BankName', 'Bankname');
//                         const holderNameVal = getVal('holderName', 'holder_name', 'HolderName', 'account_holder_name', 'AccountHolderName');
//                         const accNumberVal = getVal('accNumber', 'account_number', 'AccountNumber', 'AccNumber', 'account_no', 'AccountNo');
//                         const ifscVal = getVal('ifsc', 'ifsc_code', 'IFSC', 'Ifsc', 'IfscCode');
//                         const branchVal = getVal('branch', 'branch_name', 'Branch', 'BranchName');
//                         const accTypeVal = getVal('accType', 'account_type', 'AccountType', 'AccType');

//                         const isBankMissing = (val) => !val || String(val).trim() === '';

//                         const missingBank = {
//                             bankName: isBankMissing(bankNameVal),
//                             holderName: isBankMissing(holderNameVal),
//                             accNumber: isBankMissing(accNumberVal),
//                             ifsc: isBankMissing(ifscVal),
//                             branch: isBankMissing(branchVal),
//                             accType: isBankMissing(accTypeVal)
//                         };

//                         console.log("MANDATORY BANK CHECK RESULT:", { empId: empIdForBank, bankData: b, missingBank });

//                         if (Object.values(missingBank).some(Boolean)) {
//                             setMissingBankFields(missingBank);
//                             setBankFormData({
//                                 bankName: bankNameVal,
//                                 holderName: holderNameVal || `${data.employee.FirstName || ''} ${data.employee.LastName || ''}`.trim(),
//                                 accNumber: bankNameVal ? accNumberVal : '',
//                                 ifsc: ifscVal,
//                                 branch: branchVal,
//                                 accType: accTypeVal || 'Saving Account'
//                             });
//                             setShowMandatoryBankModal(true);
//                         }
//                     }
//                 }

//             } catch (error) {
//                 console.error("Database Error:", error);
//             }

//         };

//         fetchUserData();

//     }, []);

//     // 🔒 LOCK BODY SCROLL WHEN MANDATORY MODAL IS OPEN
//     useEffect(() => {
//         if (showMandatoryProfileModal || showMandatoryBankModal) {
//             document.body.style.overflow = 'hidden';
//             document.documentElement.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         }
//         return () => {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         };
//     }, [showMandatoryProfileModal, showMandatoryBankModal]);

//     const handleSaveMandatoryProfile = async (e) => {
//         e.preventDefault();
//         setMandatoryError('');

//         const { phone, dob, city, address, local_address, country } = mandatoryFormData;

//         if (missingProfileFields.phone && (!phone || !phone.trim())) {
//             setMandatoryError('Please enter your Mobile Number.');
//             return;
//         }
//         if (missingProfileFields.dob && (!dob || !dob.trim() || dob === '0000-00-00')) {
//             setMandatoryError('Please select your Date of Birth.');
//             return;
//         }
//         if (missingProfileFields.city && (!city || !city.trim())) {
//             setMandatoryError('Please enter your City.');
//             return;
//         }
//         if (missingProfileFields.country && (!country || !country.trim())) {
//             setMandatoryError('Please enter your Country.');
//             return;
//         }
//         if (missingProfileFields.address && (!address || !address.trim())) {
//             setMandatoryError('Please enter your Permanent Address.');
//             return;
//         }
//         if (missingProfileFields.local_address && (!local_address || !local_address.trim())) {
//             setMandatoryError('Please enter your Current / Local Address.');
//             return;
//         }

//         setMandatorySaving(true);
//         try {
//             const payload = {
//                 id: userData.id,
//                 EmpId: userData.EmpId,
//                 Phonenumber: (phone || userData.phone || '').trim(),
//                 Dob: (dob || userData.dob || '').trim(),
//                 City: (city || userData.city || '').trim(),
//                 Address: (address || userData.address || '').trim(),
//                 LocalAddress: (local_address || userData.local_address || '').trim(),
//                 Country: (country || userData.country || '').trim(),
//                 Gender: userData.gender || '',
//                 ProfilePicture: userData.profileImage || null
//             };

//             const res = await fetch("/gt-api/update_profile.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 const updatedUser = {
//                     ...userData,
//                     phone: phone.trim(),
//                     dob: dob.trim(),
//                     city: city.trim(),
//                     address: address.trim(),
//                     local_address: local_address.trim(),
//                     country: country.trim()
//                 };
//                 setUserData(updatedUser);
//                 localStorage.setItem("userData", JSON.stringify(updatedUser));
//                 setMandatorySuccessMsg("🎉 Profile information updated! You may now use the system.");
//                 setTimeout(() => {
//                     setShowMandatoryProfileModal(false);
//                     setMandatorySuccessMsg('');
//                 }, 1200);
//             } else {
//                 setMandatoryError(result.message || "Failed to update profile. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory profile update error:", err);
//             setMandatoryError("Connection error. Ensure backend API is running.");
//         } finally {
//             setMandatorySaving(false);
//         }
//     };

//     const handleSaveMandatoryBankDetails = async (e) => {
//         e.preventDefault();
//         setBankError('');

//         const { bankName, holderName, accNumber, ifsc, branch, accType } = bankFormData;

//         if (missingBankFields.bankName && (!bankName || !bankName.trim())) {
//             setBankError('Please enter Bank Name.');
//             return;
//         }
//         if (missingBankFields.holderName && (!holderName || !holderName.trim())) {
//             setBankError('Please enter Account Holder Name.');
//             return;
//         }
//         if (missingBankFields.accNumber && (!accNumber || !accNumber.trim())) {
//             setBankError('Please enter Bank Account Number.');
//             return;
//         }
//         if (missingBankFields.ifsc && (!ifsc || !ifsc.trim())) {
//             setBankError('Please enter IFSC Code.');
//             return;
//         }
//         if (missingBankFields.branch && (!branch || !branch.trim())) {
//             setBankError('Please enter Branch Name.');
//             return;
//         }
//         if (missingBankFields.accType && (!accType || !accType.trim())) {
//             setBankError('Please select Account Type.');
//             return;
//         }

//         setBankSaving(true);
//         try {
//             const payload = {
//                 emp_id: userData.id || userData.employeeId || userData.EmpId,
//                 emp_number: userData.EmpId || userData.employeeId,
//                 bankName: bankName.trim(),
//                 bank_name: bankName.trim(),
//                 holderName: holderName.trim(),
//                 account_holder_name: holderName.trim(),
//                 accNumber: accNumber.trim(),
//                 account_number: accNumber.trim(),
//                 ifsc: ifsc.trim(),
//                 ifsc_code: ifsc.trim(),
//                 branch: branch.trim(),
//                 branch_name: branch.trim(),
//                 accType: accType.trim(),
//                 account_type: accType.trim()
//             };

//             const res = await fetch("/gt-api/save_bank_details.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 setBankSuccessMsg("🎉 Bank details updated successfully!");
//                 setTimeout(() => {
//                     setShowMandatoryBankModal(false);
//                     setBankSuccessMsg('');
//                 }, 1200);
//             } else {
//                 setBankError(result.message || "Failed to save bank details. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory bank details update error:", err);
//             setBankError("Connection error. Ensure backend API is running.");
//         } finally {
//             setBankSaving(false);
//         }
//     };




//     // const employeeId = userData.id || userData.employeeId;

//     const toggleSubMenu = (menu) => {
//         setOpenMenus(prev => ({ ...prev, [menu]: !prev[menu] }));
//     };

//     useEffect(() => {
//         const checkNotifications = () => {
//             if (role !== 'Management' && userData?.employeeId) {
//                 fetch(`/gt-api/clear_notifications.php?employee_id=${userData.employeeId}`)
//                     .then(res => res.json())
//                     .then(data => {
//                         if (data.success) setNotifCount(data.count);
//                     })
//                     .catch(err => console.error("Notif Fetch Error:", err));
//             }
//         };
//         checkNotifications();
//         const interval = setInterval(checkNotifications, 30000);
//         return () => clearInterval(interval);
//     }, [userData.employeeId, role]);

//     useEffect(() => {
//         if (role === 'Management' || role === 'Manager') {
//             const fetchRealTimeLeaves = async () => {
//                 try {
//                     // Determine which API to call based on Role
//                     // Managers should call the specific manager-leaves API using their ID
//                     const url = role === 'Management'
//                         ? "/gt-api/get_all_leaves.php"
//                         : `/gt-api/get_manager_leaves.php?managerId=${userData.id || location.state?.empId}`;

//                     // const res = await fetch(url);
//                     const res = await fetch(url, {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {

//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };

//             // Only fetch if we have the ID for the Manager, or if role is Management
//             if (role === 'Management' || (role === 'Manager' && (userData.id || location.state?.empId))) {
//                 fetchRealTimeLeaves();
//                 const liveInterval = setInterval(fetchRealTimeLeaves, 5000);
//                 return () => clearInterval(liveInterval);
//             }
//         }
//     }, [role, userData.id, location.state?.empId]);

//     const handleStatusUpdate = async (id, newStatus) => {
//         try {
//             const response = await fetch("/gt-api/update_request_status.php", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ id, status: newStatus }),
//             });
//             const data = await response.json();
//             if (data.success) {
//                 setRequestsList(prev => prev.map(req => req.id === id ? { ...req, status: newStatus } : req));
//                 setPendingRequestsCount(prev => Math.max(0, prev - 1));
//                 alert(`Request ${newStatus} successfully!`);
//             }
//         } catch (error) {
//             console.error("Update error:", error);
//         }
//     };

//     ;


//     const sendAIMessage = async () => {
//         if (!chatInput.trim()) return;

//         const userMessage = {
//             sender: "user",
//             text: chatInput
//         };

//         setChatMessages(prev => [...prev, userMessage]);
//         setChatLoading(true);

//         try {
//             const res = await fetch("/gt-api/chatbot.php", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     question: chatInput
//                 })
//             });

//             const data = await res.json();

//             let aiReply = "No response.";

//             if (data.success) {
//                 aiReply = data.reply || "No response.";
//             } else {
//                 aiReply = data.message || "Something went wrong.";
//             }
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: aiReply
//                 }
//             ]);

//         } catch (err) {
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: "Server error."
//                 }
//             ]);
//         }

//         setChatInput("");
//         setChatLoading(false);
//     };
//     const handleModuleChange = (slug, extraData = null) => {
//         navigate(`/dashboard/${role}/${slug}`, {
//             state:
//                 extraData && typeof extraData === "object"
//                     ? extraData
//                     : { selectedPathway: extraData }
//         });
//     };

//     const handlePasswordSubmit = (e) => {
//         e.preventDefault();
//         if (passwordForm.newPassword !== passwordForm.confirmPassword) {
//             alert("New passwords do not match!");
//             return;
//         }
//         alert("Encryption Key Updated Successfully!");
//         setShowPasswordModal(false);
//     };

//     const handleSave = () => {
//         setIsEditing(false);
//         alert("Profile changes synchronized!");
//     };

//     // Ensure only ONE instance of this exists in your file
//     const [theme, setTheme] = useState(localStorage.getItem('dashboard-theme') || 'dark');

//     useEffect(() => {
//         document.documentElement.setAttribute('data-theme', theme);
//         localStorage.setItem('dashboard-theme', theme);
//     }, [theme]);

//     const toggleTheme = () => {
//         setTheme(prev => prev === 'dark' ? 'light' : 'dark');
//     };
//     useEffect(() => {

//         const handlePageShow = (event) => {
//             if (event.persisted) {
//                 const user = localStorage.getItem("userData");
//                 if (!user) {
//                     window.location.replace("/");
//                 }
//             }
//         };

//         window.addEventListener("pageshow", handlePageShow);

//         return () => window.removeEventListener("pageshow", handlePageShow);

//     }, []);
//     useEffect(() => {
//         if (role === 'Management') {
//             const fetchEquipmentCount = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_equip_request.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();
//                     if (data.success && data.requests) {
//                         const count = data.requests.filter(r => r.status?.toLowerCase() === 'pending').length;
//                         setPendingRequestsCount(count);
//                         setRequestsList(data.requests);
//                     }
//                 } catch (err) {
//                     console.error("Equipment Fetch Error:", err);
//                 }
//             };

//             fetchEquipmentCount();
//             const interval = setInterval(fetchEquipmentCount, 10000);
//             return () => clearInterval(interval);
//         }
//     }, [role]);




//     const [payData, setPayData] = useState([]);

//     useEffect(() => {

//         // 🔥 MANAGEMENT DASHBOARD
//         if (role === "Management") {

//             const fetchAllDocs = () => {
//                 fetch("/gt-api/get_all_salary_documents.php", {
//                     credentials: "include"
//                 })
//                     .then(res => res.json())
//                     .then(data => {
//                         console.log("MGMT DATA:", data);

//                         if (data.success) {

//                             setPayData(data.documents);
//                         }
//                     })
//                     .catch(err => console.error("Management Fetch Error:", err));
//             };

//             fetchAllDocs();

//             const interval = setInterval(fetchAllDocs, 5000);

//             return () => clearInterval(interval);
//         }

//         // 👤 EMPLOYEE DASHBOARD
//         if (employeeId) {
//             fetch(`/gt-api/get_my_documents.php?emp_id=${employeeId}`, {
//                 credentials: "include"
//             })
//                 .then(res => res.json())
//                 .then(data => {
//                     console.log("EMP DATA:", data);

//                     if (data.success) {
//                         setPayData(data.documents);
//                     }
//                 })
//                 .catch(err => console.error("Employee Fetch Error:", err));
//         }

//     }, [role, employeeId]);





//     const renderPayChart = () => {
//         const safePayData = payData || [];

//         const payslips = safePayData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = safePayData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = safePayData.filter(d => d.doc_type === "APPRAISAL LETTER").length;
//         const totalDocs = payslips + form16 + appraisal;

//         return (
//             <div className="pay-ultra-card" onClick={() => handleModuleChange("pay and benefits")}>
//                 <div className="card-inner">
//                     {/* Top Section */}
//                     <div className="pay-header">
//                         <div className="pay-icon-wrapper">
//                             <div className="pay-icon-glow"></div>
//                             <span className="main-icon">📄</span>
//                         </div>
//                         <div className="pay-total-info">
//                             <h3>Pay & Benefits</h3>
//                             <p>{totalDocs} Total Documents</p>
//                         </div>
//                     </div>

//                     {/* Distribution */}
//                     <div className="distribution-container">
//                         <div className="distribution-label">
//                             <span>Vault Composition</span>
//                             <span className="percentage">
//                                 {totalDocs > 0 ? "100%" : "0%"}
//                             </span>
//                         </div>

//                         <div className="multi-progress-bar">
//                             {totalDocs > 0 ? (
//                                 <>
//                                     <div
//                                         className="segment green"
//                                         style={{ flex: payslips, backgroundColor: '#22c55e' }}
//                                     ></div>
//                                     <div
//                                         className="segment blue"
//                                         style={{ flex: form16, backgroundColor: '#3b82f6' }}
//                                     ></div>
//                                     <div
//                                         className="segment amber"
//                                         style={{ flex: appraisal, backgroundColor: '#f59e0b' }}
//                                     ></div>
//                                 </>
//                             ) : (
//                                 <div
//                                     style={{
//                                         width: "100%",
//                                         height: "100%",
//                                         backgroundColor: "#e5e7eb",
//                                         borderRadius: "10px"
//                                     }}
//                                 ></div>
//                             )}
//                         </div>
//                     </div>

//                     {/* List */}
//                     <div className="pay-list">
//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator green"></span>
//                                 <span className="name">Monthly Payslips</span>
//                             </div>
//                             <span className="count-badge">{payslips}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator blue"></span>
//                                 <span className="name">Tax Form 16</span>
//                             </div>
//                             <span className="count-badge">{form16}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator amber"></span>
//                                 <span className="name">Appraisal Letter</span>
//                             </div>
//                             <span className="count-badge">{appraisal}</span>
//                         </div>
//                     </div>

//                     <div className="pay-footer">
//                         <span>Explore Document</span>
//                         <span className="arrow-icon">→</span>
//                     </div>

//                     <div className="reimburse-cta-wrapper">
//                         <button
//                             className="reimburse-btn"
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleModuleChange("supplies");
//                             }}
//                         >
//                             Click here for Reimbursement Form
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };



//     const renderLeavePieChart = () => {
//         const PUBLIC_HOLIDAYS = [
//             '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//             '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//         ];

//         const isWorkDay = (date) => {
//             const day = date.getDay();
//             const dateString = date.toISOString().split('T')[0];
//             return !(day === 0 || day === 6) && !PUBLIC_HOLIDAYS.includes(dateString);
//         };

//         if (!leaveData || !leaveData.leaveBalances) return null;

//         const sickUsed = leaveData.leaveBalances.sick.used || 0;
//         const earnedUsed = leaveData.leaveBalances.earned.used || 0;
//         const wfhCount = leaveData.wfhHistory.reduce((total, wfh) => {
//             const start = new Date(wfh.start);
//             const end = new Date(wfh.end);
//             let days = 0;
//             let current = new Date(start);
//             while (current <= end) {
//                 if (isWorkDay(current)) days++;
//                 current.setDate(current.getDate() + 1);
//             }
//             return total + days;
//         }, 0);

//         const totalUsed = sickUsed + earnedUsed;

//         // Determine max for scaling bars (minimum scale of 10)
//         const maxVal = Math.max(sickUsed, earnedUsed, wfhCount, 10);
//         return (

//             <div
//                 className={`elite-podium-card leave-analytics-card ${theme === 'dark' ? 'dark-variant' : 'light-theme'}`}
//                 onClick={() => handleModuleChange("attendance")}
//             >

//                 <div className="card-header-v3">
//                     <div className="title-group">

//                         <h2 className="main-title">Leave Overview</h2>
//                     </div>
//                     <div className="year-tag">2026</div>
//                 </div>

//                 <div className="podium-content">
//                     {/* VERTICAL BAR SECTION - Made prominent */}
//                     <div className="bar-podium-large">
//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill sick" style={{ height: `${(sickUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">SICK</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill earned" style={{ height: `${(earnedUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">EARNED</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill wfh" style={{ height: `${(wfhCount / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">WFH</span>
//                         </div>
//                     </div>

//                     {/* KPI SIDEBAR - Cleaned up to match image 1's style */}
//                     <div className="kpi-sidebar-compact">
//                         <div className="total-display">
//                             <span className="total-val">{totalUsed}</span>
//                             <span className="total-sub">Days Off-Site</span>
//                         </div>

//                         <div className="status-legend">
//                             <div className="legend-row">
//                                 <span className="indicator sick"></span>
//                                 <span>{sickUsed} Sick</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator earned"></span>
//                                 <span>{earnedUsed} Earned</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator wfh"></span>
//                                 <span>{wfhCount} WFH</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="card-footer-v3">
//                     <div className="sync-info">
//                         <span className="status-glow"></span>
//                         Annual Summary Active
//                     </div>
//                     <button className="details-btn">VIEW DETAILS →</button>
//                 </div>
//             </div>
//         );
//     };

//     const [leaveData, setLeaveData] = useState({
//         leaveHistory: [],
//         leaveBalances: {
//             sick: { used: 0, total: 0 },
//             earned: { used: 0, total: 0 }
//         },
//         wfhHistory: []
//     });


//     const [managementNotices, setManagementNotices] = useState({
//         reviews: [],
//         probations: []
//     });

//     useEffect(() => {
//         const fetchNotices = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/get_manager_feedback.php?empId=${userData.EmpId}`
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     setManagementNotices({
//                         reviews: data.reviews || [],
//                         probations: data.probations || []
//                     });
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchNotices();
//     }, [userData]);





//     const renderEquipmentCard = () => {
//         const { total, approved, rejected, pending } = equipmentData;

//         return (
//             <div className="equipment-ultra-card clickable" onClick={() => handleModuleChange("equipment-request")}>
//                 <div className="equip-header">
//                     <div className="equip-icon-box">💻</div>
//                     <div className="equip-title-group">
//                         <span className="equip-label">Hardware</span>
//                         <h3 className="equip-title">Requests</h3>
//                     </div>
//                 </div>

//                 <div className="equip-main-stat">
//                     <span className="total-count">{total}</span>
//                     <span className="total-label">Submissions</span>
//                 </div>

//                 <div className="equip-progress-bar">
//                     <div className="bar-fill approved" style={{ width: `${(approved / total) * 100}%` }}></div>
//                     <div className="bar-fill pending" style={{ width: `${(pending / total) * 100}%` }}></div>
//                 </div>

//                 <div className="equip-stats-list">
//                     <div className="equip-item">
//                         <span className="dot approved"></span>
//                         <span className="item-name">Approved</span>
//                         <span className="item-val">{approved}</span>
//                     </div>
//                     <div className="equip-item">
//                         <span className="dot pending"></span>
//                         <span className="item-name">Pending</span>
//                         <span className="item-val text-warning">{pending}</span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     useEffect(() => {
//         const empIdForFetch = userData?.EmpId || userData?.employeeId;

//         if (!empIdForFetch) return;

//         fetch(`/gt-api/get_all_equip_request.php?employee_id=${empIdForFetch}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log("EQUIPMENT API RESPONSE:", data);
//                 if (data.success && data.requests) {

//                     const requests = data.requests;

//                     const approved = requests.filter(r =>
//                         r.status?.toLowerCase() === "approved"
//                     ).length;

//                     const rejected = requests.filter(r =>
//                         r.status?.toLowerCase() === "rejected"
//                     ).length;

//                     const pending = requests.filter(r =>
//                         r.status?.toLowerCase() === "pending"
//                     ).length;

//                     setEquipmentData({
//                         total: requests.length,
//                         approved,
//                         rejected,
//                         pending
//                     });
//                 }
//             })
//             .catch(err => console.error("Equipment Dashboard Error:", err));
//         console.log("EMP ID:", empIdForFetch);



//     }, [userData?.EmpId, userData?.employeeId]);





//     const [oneOnOneData, setOneOnOneData] = useState({
//         totalMeetings: 0,
//         pendingTasks: 0,
//         completedTasks: 0
//     });

//     useEffect(() => {
//         if (!employeeId) return;

//         fetch(`/gt-api/get_my_meetings.php?emp_id=${employeeId}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.meetings) {

//                     const meetings = data.meetings;

//                     let pending = 0;
//                     let completed = 0;

//                     meetings.forEach(meet => {
//                         const tasks = JSON.parse(meet.action_items || "[]");

//                         tasks.forEach(task => {
//                             if (task.done) completed++;
//                             else pending++;
//                         });
//                     });

//                     setOneOnOneData({
//                         totalMeetings: meetings.length,
//                         pendingTasks: pending,
//                         completedTasks: completed
//                     });
//                 }
//             })
//             .catch(err => console.error("1-1 Fetch Error:", err));

//     }, [employeeId]);



//     const renderOneOnOneCard = () => {
//         const { totalMeetings, pendingTasks, completedTasks } = oneOnOneData;
//         const totalTasks = (pendingTasks + completedTasks) || 1;
//         const progressPercent = Math.min(Math.round((completedTasks / totalTasks) * 100), 100);

//         return (
//             <div className="liquid-card clickable" onClick={() => handleModuleChange("one-on-one")}>
//                 {/* BACKGROUND BLOOM */}
//                 <div className="liquid-bloom"></div>

//                 <div className="liquid-layout">
//                     {/* HERO TILE: THE CORE IDENTITY */}
//                     <div className="liquid-tile-hero">
//                         <div className="hero-header">
//                             {/* <span className="hero-eyebrow">Engagement Console</span> */}
//                             <h2 className="hero-title">1-on-1 Sessions</h2>
//                         </div>
//                         <div className="hero-main-metric">
//                             <span className="hero-val">{totalMeetings}</span>
//                             <span className="hero-label">TOTAL<br />MEETINGS</span>
//                         </div>
//                         {/* FULL WIDTH PROGRESS THREAD */}
//                         <div className="liquid-thread-container">
//                             <div className="liquid-thread-bg">
//                                 <div className="liquid-thread-fill" style={{ width: `${progressPercent}%` }}>
//                                     <div className="liquid-thread-glow-tip"></div>
//                                 </div>
//                             </div>
//                             <div className="liquid-thread-label">
//                                 <span className="label-text">Task Completion</span>
//                                 <span className="label-val">{progressPercent}%</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* DATA TRAY: THE SPECIFIC CHIPS */}
//                     <div className="liquid-tray">
//                         <div className="liquid-chip danger">
//                             <div className="chip-inner">
//                                 <label>Pending Task</label>
//                                 <span className="chip-val">{pendingTasks}</span>
//                             </div>
//                         </div>
//                         <div className="liquid-chip success">
//                             <div className="chip-inner">
//                                 <label>Completed Task</label>
//                                 <span className="chip-val">{completedTasks}</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* INTERACTIVE FOOTER */}
//                 <div className="liquid-footer">
//                     <div className="status-container">
//                         <div className={`status-node-wrapper ${pendingTasks > 0 ? 'is-alert' : 'is-sync'}`}>
//                             <div className="status-node-core"></div>
//                             <div className="status-node-bloom"></div>
//                         </div>
//                         <span className={`status-text ${pendingTasks > 0 ? 'text-alert' : ''}`}>
//                             {pendingTasks > 0 ? 'ACTION ITEMS DETECTED' : 'SYSTEM OPTIMIZED'}
//                         </span>
//                     </div>
//                     <div className="liquid-action">

//                         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
//                     </div>
//                 </div>
//             </div>
//         );
//     };






//     const renderCareerPathwaysCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const pathways = isGenesis

//             ? [

//                 {
//                     id: "01",
//                     name: "FI DESIGN",
//                     color: "rgba(0, 77, 113, 0.9)"
//                 },

//                 {
//                     id: "02",
//                     name: "BIM MODELING",
//                     color: "rgba(0, 120, 172, 0.8)"
//                 },

//                 {
//                     id: "03",
//                     name: "POWER BI",
//                     color: "rgba(0, 162, 237, 0.7)"
//                 }

//             ]

//             : dashboardPathways.map(
//                 (item, index) => ({
//                     id: String(index + 1)
//                         .padStart(2, "0"),

//                     name: item.pathway_title,

//                     color:
//                         "rgba(0, 120, 172, 0.8)"
//                 })
//             );

//         return (

//             <div
//                 className="pathway-card-container"
//                 onClick={() =>
//                     handleModuleChange(
//                         "career pathways"
//                     )
//                 }
//             >

//                 <h2 className="pathway-title">
//                     CAREER PATHWAYS
//                 </h2>

//                 <div className="pathway-stack">

//                     {pathways.map(
//                         (item, index) => (

//                             <div
//                                 key={index}
//                                 className="pathway-step"
//                                 style={{
//                                     '--step-color':
//                                         item.color
//                                 }}
//                                 onClick={(e) => {

//                                     e.stopPropagation();

//                                     handleModuleChange(
//                                         "career pathways",
//                                         item.name
//                                     );

//                                 }}
//                             >

//                                 <span className="step-number">
//                                     {item.id}
//                                 </span>

//                                 <div className="step-content">

//                                     <span className="step-name">
//                                         {item.name}
//                                     </span>

//                                     <div className="step-glow"></div>

//                                 </div>

//                             </div>

//                         )
//                     )}

//                 </div>

//                 <button
//                     className="explore-btn"
//                     onClick={(e) => {

//                         e.stopPropagation();

//                         handleModuleChange(
//                             "career pathways"
//                         );

//                     }}
//                 >
//                     EXPLORE CAREER PATHWAYS
//                 </button>

//             </div>

//         );

//     };


//     const renderPolicyCard = () => {
//         const totalPolicies =
//             policyCount;

//         console.log(
//             "Policy Count:",
//             totalPolicies
//         );

//         const readCount =
//             Object.keys(logs || {}).length;
//         const pending = totalPolicies - readCount;
//         const progress = totalPolicies > 0 ? Math.round((readCount / totalPolicies) * 100) : 0;

//         return (
//             <div className="terminal-policy-card" onClick={() => handleModuleChange("company-policy")}>
//                 {/* Background Decorative Scanline */}
//                 <div className="terminal-scanline"></div>

//                 <div className="terminal-header">
//                     <div className="header-left">
//                         {/* <span className="terminal-tag">PROTOCOL_09</span> */}
//                         <h3 className="terminal-title">Company Policy</h3>
//                     </div>
//                     <div className={`status-indicator ${progress === 100 ? 'secure' : 'breach'}`}>
//                         {progress === 100 ? "SECURE" : "PENDING"}
//                     </div>
//                 </div>

//                 <div className="terminal-content">
//                     {/* Circular Progress using SVG for precision */}
//                     <div className="terminal-visual">
//                         <svg viewBox="0 0 36 36" className="cyber-circle">
//                             <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                             <path
//                                 className="circle-fill"
//                                 strokeDasharray={`${progress}, 100`}
//                                 d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
//                                 style={{ stroke: progress === 100 ? '#22c55e' : '#3b82f6' }}
//                             />
//                         </svg>
//                         <div className="percentage-display">
//                             <span className="pct-num">{progress}</span>
//                             <span className="pct-unit">%</span>
//                         </div>
//                     </div>

//                     {/* Data Readout Section */}
//                     <div className="terminal-stats">
//                         <div className="stat-row">
//                             <span className="label">COMPLETED</span>
//                             <span className="value">{readCount}</span>
//                         </div>
//                         <div className="stat-row">
//                             <span className="label">TOTAL_FILES</span>
//                             <span className="value">{totalPolicies}</span>
//                         </div>
//                         <div className="stat-row urgent">
//                             <span className="label">AWAITING_ACTION</span>
//                             <span className="value">{pending}</span>
//                         </div>
//                     </div>
//                 </div>

//             </div>
//         );
//     };

//     useEffect(() => {
//         const fetchLogs = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/acknowledgepolicy.php?empId=${userData.EmpId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 console.log("API DATA:", data);

//                 // 🔥 FIX: use data.logs (NOT data)
//                 const logsArray = Array.isArray(data?.logs) ? data.logs : [];

//                 const map = logsArray.reduce((acc, curr) => {
//                     if (curr?.policy_title) {
//                         acc[curr.policy_title] = true;
//                     }
//                     return acc;
//                 }, {});

//                 setLogs(map);

//             } catch (err) {
//                 console.error("Policy logs error:", err);
//                 setLogs({});
//             }
//         };

//         fetchLogs();
//     }, [userData]);


//     const [showProfileOptions, setShowProfileOptions] = useState(false);



//     const [showProfileMenu, setShowProfileMenu] = useState(false);
//     const handleEditProfile = () => {
//         setShowProfileMenu(false);
//         navigate(`/dashboard/${role}/my-profile`);
//         setShowProfile(true);
//     };

//     const handleLogout = () => {
//         document.documentElement.removeAttribute('data-theme');
//         localStorage.clear();
//         sessionStorage.clear();
//         navigate("/", { replace: true });
//     };

//     const [currentTime, setCurrentTime] = useState("");

//     useEffect(() => {
//         const updateTime = () => {
//             const now = new Date();
//             setCurrentTime(
//                 now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
//             );
//         };

//         updateTime();
//         const interval = setInterval(updateTime, 1000);

//         return () => clearInterval(interval);
//     }, []);
//     const todayDate = new Date().toLocaleDateString('en-GB', {
//         day: '2-digit',
//         month: 'short'
//     });



//     const employeeModulesList = [
//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "attendance" },

//         { id: 2, name: "Pay and Benefits", icon: "💳", color: "#3b82f6", slug: "pay and benefits" },
//         { id: 3, name: "OKR and Performance Tracker", icon: "🎯", color: "#f59e0b", slug: "okr and performance tracker" },

//         { id: 5, name: "Career Pathways", icon: "🏆", color: "#ec4899", slug: "career pathways" },
//         { id: 6, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },

//         { id: 9, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         { id: 10, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         // { id: 11, name: "Documents", icon: "📂", color: "#f43f5e", slug: "documents" },
//         // { id: 12, name: "Employee Experience Survey - EES", icon: "📝", color: "#8b5cf6", slug: "ees-survey" },   
//         { id: 13, name: "1:1 Meeting", icon: "💬", color: "#00fff2", slug: "one-on-one" },
//         { id: 21, name: "ACM Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//         { id: 7, name: "Expense Reimbursement", icon: "🧾", color: "#10b981", slug: "supplies" },

//     ];

//     const managementModulesList = [

//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "leave-management", badge: pendingLeavesCount },

//         { id: 2, name: "Employee Salary and Benefits", icon: "💳", color: "#3b82f6", slug: "employee-salary-benefits" },

//         { id: 3, name: "Employee OKR'S", icon: "🎯", color: "#f59e0b", slug: "employee-okrs" },

//         { id: 5, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: pendingRequestsCount },

//         { id: 6, name: "Own Finanacials", icon: "💰", color: "#10b981", slug: "pay and benefits" },

//         { id: 8, name: "Career Development", icon: "🏆", color: "#ec4899", slug: "career pathways" },

//         { id: 10, name: "Self OKR Tracker", icon: "🏁", color: "#f59e0b", slug: "okr and performance tracker" },
//         { id: 11, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         { id: 12, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         // { id: 21, name: "Manage Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates", badge: "PUSH" },

//         {
//             id: 21,
//             name: "ACM Updates",
//             icon: "📢",
//             color: "#00fff2",
//             slug: "manage-quarterly-updates",
//             badge: "PUSH"
//         },

//         // {
//         //   id: 15,
//         //   name: "EES Feedback Analytics",
//         //   icon: "📊",
//         //   color: "#00f2ff",
//         //   slug: "ees-analytics",
//         //   badge: "NEW"
//         // },

//         // { id: 14, name: "Skills Development", icon: "📚", color: "#06b6d4", slug: "career" },

//         {
//             id: 16,
//             name: "Medical Reports",
//             icon: "🏥",
//             color: "#f43f5e",
//             slug: "medical-reports",
//             badge: "DOCS"
//         },
//         {
//             id: 17,
//             name: "Policy RnU Status",
//             icon: "📋",
//             color: "#10b981",
//             slug: "policy-logs",
//             badge: "ADMIN"
//         },

//         // { 
//         //   id: 18, 
//         //   name: "Employee Documents", 
//         //   icon: "📂", 
//         //   color: "#f43f5e", 
//         //   slug: "manage-documents", 
//         //   badge: "VIEW" 
//         // },

//         {
//             id: 19,
//             name: "1:1 Connect",
//             icon: "🤝",
//             color: "#00fff2",
//             slug: "manager-one-on-one",

//             badge: "LIVE"
//         },

//         { id: 20, name: "Events and Celebrations", icon: "🎉", color: "#3b82f6", slug: "events-celebrations" },

//         {
//             id: 22,
//             name: "Expense Reimbursements",
//             icon: "💰",
//             color: "#22c55e",
//             slug: "reimbursements",
//             badge: "NEW"
//         },

//         // {
//         //     id: 23,
//         //     name: "WFH Requests",
//         //     icon: "🏠",
//         //     color: "#3b82f6",
//         //     slug: "manage-wfh-requests",
//         //     badge: "WFH"
//         // },


//     ];

//     const renderActiveModule = () => {

//         switch (activeModule) {

//             case "attendance-tracker":
//                 return <AttendanceTracker />;

//             case "CompanySetup":
//                 return <CompanySetup />;

//             case "create-invoice":
//                 return <InvoiceGenerator />;

//             case "my-profile":
//                 return (
//                     <MyProfile
//                         userData={userData}
//                         setUserData={setUserData}
//                         isEditing={isEditing}
//                         setIsEditing={setIsEditing}
//                         handleSave={handleSave}
//                         setShowPasswordModal={setShowPasswordModal}
//                     />
//                 );


//             case "reimbursements":
//                 if (role === "Management" || role === "Manager") {
//                     return <ReimbursementManagement />;
//                 }
//                 return <OfficeRequisition userData={userData} />;

//             case "manage-wfh-requests":
//                 return <WFHManagement />;


//             case "work-from-home":
//                 return <WorkFromHome />;


//             case "quarterly-updates":

//                 return <QuarterlyUpdates />;

//             case "manage-quarterly-updates":

//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementQuarterlyUpdate userData={userData} />;
//                 }
//                 return <QuarterlyUpdates />;


//             case "leave-management":
//                 // Unified behavior for Management and Manager
//                 if (role === 'Management' || role === 'Manager') {
//                     return <LeaveManagement userData={userData} />;
//                 }


//                 return <Attendance employeeId={employeeId} userData={userData} />;

//             case "manage-documents":
//                 if (role === 'Management') {
//                     return <ManageEmployeeDocs />;
//                 }
//                 return <Documents userData={userData} />;



//             // case "attendance":
//             //     if (role === 'Management') return <Attendance />;
//             //     return (
//             //         <Attendance
//             //             employeeId={userData.id}
//             //             empBadgeId={userData.EmpId}
//             //             userData={userData}
//             //         />
//             //     );
//             case "attendance":

//                 if (role === 'Management') {

//                     return (
//                         <Attendance
//                             employeeId={userData.id}
//                             empBadgeId={userData.EmpId}
//                             userData={userData}
//                         />
//                     );

//                 }

//                 return (
//                     <Attendance
//                         employeeId={userData.id}
//                         empBadgeId={userData.EmpId}
//                         userData={userData}
//                     />
//                 );


//             case "policy-logs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <PolicyAdminDashboard />;
//                 }

//                 return (
//                     <CompanyPolicy
//                         employeeId={userData.id}
//                         userData={userData}
//                     />
//                 );

//             case "events-celebrations":
//                 return <EventsCelebrations userData={userData} />;

//             case "pay and benefits": return <PayBenefits userData={userData} employeeId={employeeId} />;

//             // case "okr and performance tracker":
//             //     return <OKRTracker userData={userData} />;

//             case "okr and performance tracker":
//                 return (
//                     <OKRTracker
//                         userData={userData}
//                         defaultTab={location.state?.tab}
//                     />
//                 );

//             // Inside Dashboard.js -> renderActiveModule
//             // case "employee-okrs":
//             //     if (role === 'Management' || role === 'Manager') {
//             //         return (
//             //             <ManagementOKRViewer
//             //                 managerId={userData.id}
//             //                 userRole={role}
//             //                 // This is the CRITICAL line:
//             //                 managedDept={userData.HOD}
//             //             />
//             //         );
//             //     }
//             //     return <OKRTracker userData={userData} />;

//             case "employee-okrs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementOKRViewer userRole={role} />;
//                 }
//                 return <OKRTracker userData={userData} />;

//             case "career pathways": return <CareerPathways userData={userData} />;
//             case "add-department": return <AddDepartment />;
//             case "manage-department": return <ManageDepartment />;
//             case "add-employee": return <AddEmployee />;
//             case "manage-employee": return <ManageEmployee />;

//             case "employee-salary-benefits":
//                 return <EmployeeSalaryBenefits />;


//             case "equipment-request":
//                 if (role === "Management") {
//                     const pending = requestsList.filter(
//                         (r) => r.status?.toLowerCase() === "pending"
//                     );

//                     const history = requestsList.filter(
//                         (r) => r.status?.toLowerCase() !== "pending"
//                     );

//                     return (
//                         <div
//                             className="management-request-wrapper animate-fade"
//                             style={{ padding: "20px" }}
//                         >
//                             {/* Pending Queue */}
//                             <div
//                                 className="module-glass-card"
//                                 style={{ marginBottom: "30px" }}
//                             >
//                                 <h3 className="cyan-text">
//                                     ACTIVE_PENDING_QUEUE ({pending.length})
//                                 </h3>

//                                 {/* Desktop Table */}
//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>IMPACT</th>
//                                                 <th>ACTION</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {pending.length > 0 ? (
//                                                 pending.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                             >
//                                                                 {req.impact?.toUpperCase()}
//                                                             </span>
//                                                         </td>

//                                                         <td>
//                                                             <div className="equiptable-actions">
//                                                                 <button
//                                                                     className="equiptable-btn equiptable-approve"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Approved"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✔
//                                                                 </button>

//                                                                 <button
//                                                                     className="equiptable-btn equiptable-reject"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Rejected"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✖
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_PENDING_REQUESTS
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 {/* Mobile Cards */}
//                                 <div className="equiptable-mobile">
//                                     {pending.length > 0 ? (
//                                         pending.map((req) => (
//                                             <div
//                                                 className="equiptable-card"
//                                                 key={req.id}
//                                             >
//                                                 <div className="equiptable-row">
//                                                     <span>Employee</span>
//                                                     <strong>
//                                                         {req.employee_name}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Hardware</span>
//                                                     <strong>
//                                                         {req.equipment_type}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Impact</span>

//                                                     <span
//                                                         className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                     >
//                                                         {req.impact?.toUpperCase()}
//                                                     </span>
//                                                 </div>

//                                                 <div className="equiptable-actions">
//                                                     <button
//                                                         className="equiptable-btn equiptable-approve"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Approved"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✔ Approve
//                                                     </button>

//                                                     <button
//                                                         className="equiptable-btn equiptable-reject"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Rejected"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✖ Reject
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         ))
//                                     ) : (
//                                         <div className="equiptable-card">
//                                             NO_PENDING_REQUESTS
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Completed History */}
//                             <div
//                                 className="module-glass-card history-card"
//                                 style={{ opacity: 0.9 }}
//                             >
//                                 <h3
//                                     className="gray-text"
//                                     style={{ color: "#888" }}
//                                 >
//                                     📜 COMPLETED_HISTORY ({history.length})
//                                 </h3>

//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>DATE</th>
//                                                 <th>STATUS</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {history.length > 0 ? (
//                                                 history.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             {new Date(
//                                                                 req.updated_at ||
//                                                                 req.created_at
//                                                             ).toLocaleDateString(
//                                                                 "en-GB"
//                                                             )}
//                                                         </td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-status ${req.status?.toLowerCase()}`}
//                                                             >
//                                                                 {req.status?.toUpperCase()}
//                                                             </span>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_HISTORY_FOUND
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     );
//                 }

//                 return <EquipmentRequest userData={userData} />;

//             case "supplies": return <OfficeRequisition userData={userData} />;
//             // case "it": return <ITSupport userData={userData} />;
//             case "documents": return <Documents userData={userData} />;
//             // case "company-policy": return <CompanyPolicy />;
//             case "company-policy":
//                 return <CompanyPolicy userData={userData} />;
//             case "Organization Chart": return <OrgChart userData={userData} />;
//             // case "campus information": return <CampusInfo />;
//             case "campus information":
//                 return <CampusInfo userData={userData} />;
//             case "ees-survey": return <EESExperience userData={userData} />;

//             case "ees-analytics":
//                 if (role === 'Management' || role === 'Manager') {
//                     // Management sees the list of real data
//                     return <EESFeedbackManagement feedbacks={eesSubmissions} />;
//                 }
//                 // Employee sees the form
//                 return <EESExperience userData={userData} onFinalSubmit={handleEESSubmit} />;

//             //       case "one-on-one":
//             // return <OneOnOne userData={userData} role={role} />;

//             case "one-on-one":
//                 // This is the PERSONAL view (Employee mode)
//                 return <OneOnOne userData={userData} role="Employee" viewMode="personal" />;

//             case "manager-one-on-one":
//                 // This is the MANAGERIAL view (Manager/Management mode)
//                 return <OneOnOne userData={userData} role={role} viewMode="managerial" />;

//             case "one-on-one-report":
//                 return <OneOnOneReport userData={userData} role={role} handleModuleChange={handleModuleChange} />;

//             // Inside Dashboard.js renderActiveModule
//             case "medical-reports":
//                 if (role === 'Management') return <MedicalReports />;
//                 if (role === 'Manager') {
//                     return (
//                         <ManagerMedicalReports
//                             managerId={userData.id}           // Database Primary Key
//                             managerBadgeId={userData.EmpId}   // Company ID (HOD flag often matches this)
//                             managerDept={userData.Department} // The string "Software Development"
//                         />
//                     );
//                 }

//             case "employee-it-support":
//                 return <EquipmentRequest userData={userData} />;

//             default:


//                 if (role === 'Manager') {
//                     return renderManagerDashboard();
//                 }

//                 const currentList = role === 'Management' ? managementModulesList : employeeModulesList;
//                 return (
//                     <section className="bento-grid">
//                         {currentList.map((mod) => (
//                             <div key={mod.id} className="bento-card glass" style={{ "--accent": mod.color }} onClick={() => handleModuleChange(mod.slug)}>
//                                 <div className="card-top">
//                                     <span className="mod-icon">{mod.icon}</span>
//                                     {mod.badge > 0 && <span className={role === 'Management' ? "card-badge" : "notification-badge-ui"}>{mod.badge}</span>}
//                                 </div>
//                                 <div className="card-info"><h3>{mod.name}</h3><div className="cyber-line"></div></div>
//                             </div>
//                         ))}
//                     </section>
//                 );
//         }
//     };

//     const [companyLogo, setCompanyLogo] = useState("");
//     const currentLogo = theme === 'light' ? logoLight : logoDark;


//     const [leaveStats, setLeaveStats] = useState({
//         pending: 0,
//         approved: 0,
//         rejected: 0,
//         wfhPending: 0
//     });

//     useEffect(() => {
//         if (role !== "Management") return;

//         const fetchLeaveStats = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];


//                     const pending = leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                     const approved = leaves.filter(l => l.Status === '1').length;
//                     const rejected = leaves.filter(l => l.Status === '2').length;

//                     // WFH
//                     const wfhRes = await fetch("/gt-api/get_all_wfh_requests.php", {
//                         credentials: "include"
//                     });
//                     const wfhData = await wfhRes.json();

//                     const wfhPending = wfhData.success
//                         ? wfhData.requests.filter(r => r.status === "Pending").length
//                         : 0;

//                     setLeaveStats({ pending, approved, rejected, wfhPending });
//                 }

//             } catch (err) {
//                 console.error("Leave Stats Error:", err);
//             }
//         };

//         fetchLeaveStats();
//         const interval = setInterval(fetchLeaveStats, 5000);

//         return () => clearInterval(interval);
//     }, [role]);


//     const [mgmtLeaves, setMgmtLeaves] = useState([]);
//     const [mgmtActiveTeam, setMgmtActiveTeam] = useState("All");

//     useEffect(() => {
//         const fetchLeaves = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();
//                 if (data.success) setMgmtLeaves(data.leaves);
//             } catch (err) {
//                 console.error("Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaves();
//     }, []);





//     const mgmtChartData = useMemo(() => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept => dept.DepartmentName
//             );

//         const now = new Date();
//         const currentMonth = (now.getMonth() + 1).toString();
//         const currentYear = now.getFullYear().toString();

//         const teamList = mgmtActiveTeam === "All" ? teams : [mgmtActiveTeam];

//         return teamList.map(team => {

//             const filtered = mgmtLeaves.filter(l => {
//                 const dateParts = l.fromdate?.split("-");
//                 const lYear = dateParts?.[0];
//                 const lMonth = dateParts?.[1]
//                     ? parseInt(dateParts[1]).toString()
//                     : "";

//                 return (
//                     l.Department === team &&
//                     lMonth === currentMonth &&
//                     lYear === currentYear
//                 );
//             });

//             return {
//                 name: team,

//                 // ✅ SUM OF UNITS (FIXED)
//                 Approved: filtered
//                     .filter(l => l.Status === "1")
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

//                 Pending: filtered
//                     .filter(l => l.Status === "0" || l.Status === null)
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
//             };
//         });

//     }, [mgmtLeaves, mgmtActiveTeam]);


//     const renderManagementLeaveCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept =>
//                     dept.DepartmentName
//             );

//         return (
//             <div
//                 className="mgmt-leave-analytics clickable"
//                 onClick={() => handleModuleChange("leave-management")}
//             >

//                 <div className="card-header">
//                     <h3>Employee Leave Analytics</h3>
//                     <span className="sub-text">This Month</span>
//                 </div>

//                 {/* TEAM CHIPS */}
//                 <div className="team-row">
//                     <div
//                         className={`team-chip ${mgmtActiveTeam === "All" ? "active" : ""}`}
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             setMgmtActiveTeam("All");
//                         }}
//                     >
//                         ALL
//                     </div>

//                     {teams.map((team, i) => (
//                         <div
//                             key={i}
//                             className={`team-chip ${mgmtActiveTeam === team ? "active" : ""}`}
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 setMgmtActiveTeam(team);
//                             }}
//                         >
//                             {team}
//                         </div>
//                     ))}
//                 </div>

//                 {/* CHART */}
//                 {(() => {
//                     const isSingle = mgmtActiveTeam !== "All";

//                     return (
//                         <div className={`chart-area ${isSingle ? "single-view" : ""}`}>
//                             <ResponsiveContainer width="100%" height={170}>
//                                 <BarChart
//                                     data={mgmtChartData}
//                                     barCategoryGap={isSingle ? "70%" : "30%"}
//                                     margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
//                                 >

//                                     {/* GRADIENTS */}
//                                     <defs>
//                                         <linearGradient id="approvedGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#34d399" />
//                                             <stop offset="100%" stopColor="#059669" />
//                                         </linearGradient>

//                                         <linearGradient id="pendingGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#fbbf24" />
//                                             <stop offset="100%" stopColor="#f59e0b" />
//                                         </linearGradient>
//                                     </defs>

//                                     <CartesianGrid
//                                         strokeDasharray="3 3"
//                                         stroke="rgba(255,255,255,0.05)"
//                                         vertical={false}
//                                     />

//                                     <XAxis
//                                         dataKey="name"
//                                         tick={{ fill: "#888", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <YAxis
//                                         tick={{ fill: "#666", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <Tooltip
//                                         cursor={{ fill: "rgba(255,255,255,0.05)" }}
//                                         contentStyle={{
//                                             backgroundColor: "rgba(15, 23, 42, 0.95)", // dark glass
//                                             border: "1px solid rgba(0,255,242,0.3)",
//                                             borderRadius: "10px",
//                                             color: "#ffffff",
//                                             backdropFilter: "blur(8px)"
//                                         }}
//                                         labelStyle={{ color: "#00fff2", fontWeight: 600 }}
//                                         itemStyle={{ color: "#ffffff" }}
//                                     />


//                                     <Bar
//                                         dataKey="Approved"
//                                         stackId="a"
//                                         fill="url(#approvedGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                     <Bar
//                                         dataKey="Pending"
//                                         stackId="a"
//                                         fill="url(#pendingGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                 </BarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     );
//                 })()}


//                 <div className="card-footer">
//                     <span>Open Leave Console</span>
//                     <span>→</span>
//                 </div>
//             </div>
//         );
//     };

//     const renderSalaryIntelCard = () => {
//         // 1. Existing Counts
//         const payslips = payData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = payData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = payData.filter(d => d.doc_type === "APPRAISAL LETTER").length;

//         // 2. New Miscellaneous Count (Filtering for the images you provided)
//         const miscDocs = [
//             "FNF LETTER", "OFFER LETTER", "RELIEVING LETTER",
//             "EXPERIENCE LETTER", "EMPLOYEMENT AGREEMENT", "BANK ACCOUNT OPENING"
//         ];
//         const miscellaneous = payData.filter(d => miscDocs.includes(d.doc_type)).length;

//         // 3. Updated Total
//         const total = payslips + form16 + appraisal + miscellaneous;

//         // 4. SVG Math for 4 segments
//         const chartTotal = 125.6;
//         const gap = total > 0 ? 2 : 0;

//         const s1 = (payslips / total) * chartTotal || 0;
//         const s2 = (form16 / total) * chartTotal || 0;
//         const s3 = (appraisal / total) * chartTotal || 0;
//         const s4 = (miscellaneous / total) * chartTotal || 0;

//         return (
//             <div className="sa-card-wrapper" onClick={() => handleModuleChange("employee-salary-benefits")}>


//                 <div className="sa-card-header">
//                     <h3 className="sa-title">Salary Document Insights</h3>
//                     <button className="sa-menu-trigger">⋮</button>
//                 </div>

//                 <div className="sa-main-body">
//                     <div className="sa-gauge-area">
//                         <div className="sa-gauge-container">
//                             <svg viewBox="0 0 100 55" className="sa-gauge-svg">
//                                 {/* Background Track */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="var(--sa-track)" strokeWidth="9" strokeLinecap="round" />

//                                 {/* Segment 4: Misc (Blue) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#0ea5e9" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s4 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2 + s3}`} />

//                                 {/* Segment 3: Appraisals (Orange) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#f97316" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s3 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2}`} />

//                                 {/* Segment 2: Form 16 (Yellow) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#fbbf24" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s2 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1}`} />

//                                 {/* Segment 1: Payslips (Purple) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#8b5cf6" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s1 - gap)} ${chartTotal}`}
//                                     strokeDashoffset="0" />
//                             </svg>

//                             <div className="sa-gauge-text">
//                                 <span className="sa-overall-num">{total}</span>
//                                 <span className="sa-overall-label">Overall</span>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="sa-legend-area">
//                         {[
//                             { label: "Payslips", count: payslips, color: "purple" },
//                             { label: "Form 16", count: form16, color: "yellow" },
//                             { label: "Appraisals", count: appraisal, color: "orange" },
//                             { label: "Miscellaneous", count: miscellaneous, color: "blue" }
//                         ].map((item, index) => (
//                             <div key={index} className="sa-legend-item">
//                                 <div className="sa-item-top">
//                                     <span className={`sa-dot ${item.color}`}></span>
//                                     <span className="sa-item-count">{item.count}</span>
//                                 </div>
//                                 <span className="sa-item-label">{item.label}</span>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <div className="sa-card-footer">
//                     <span className="sa-footer-link">View Detailed Report →</span>
//                 </div>
//             </div>
//         );
//     };



//     const [okrData, setOkrData] = useState([]);
//     useEffect(() => {
//         if (!userData?.id) return;

//         const fetchOKR = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/get_user_okr.php?empId=${userData.id}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     const parsed = typeof data.data === "string"
//                         ? JSON.parse(data.data)
//                         : data.data;

//                     setOkrData(parsed);
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchOKR();

//     }, [userData?.id]);



//     const [okrStats, setOkrStats] = useState({
//         total: 0,
//         completed: 0,
//         pending: 0,
//         progressPercent: 0
//     });



//     const fetchOKRStats = async () => {
//         if (!userData?.EmpId) return;

//         try {
//             const res = await fetch(
//                 `/gt-api/get_okr_stats.php?empId=${userData.EmpId}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setOkrStats(data);
//             }

//         } catch (err) {
//             console.error("OKR STATS ERROR:", err);
//         }
//     };

//     useEffect(() => {
//         if (!userData?.EmpId) return;

//         fetchOKRStats();

//         const handleUpdate = () => fetchOKRStats();

//         window.addEventListener("okrUpdated", handleUpdate);

//         return () => window.removeEventListener("okrUpdated", handleUpdate);

//     }, [userData?.EmpId]);




//     const renderOKRCard = () => {
//         const { total, completed, pending, progressPercent } = okrStats;

//         return (
//             <div
//                 className="expanded-management-card clickable"
//                 onClick={() => handleModuleChange("okr and performance tracker")}
//             >
//                 <div className="okr-card-container">

//                     {/* HEADER */}
//                     <div className="okr-header">
//                         <div>
//                             <span className="eyebrow-text">Performance Tracker</span>
//                             <h2 className="display-title">OKR Progress</h2>
//                         </div>

//                         {/* TOP RIGHT TOTAL */}
//                         <div className="stat-box featured big">
//                             <span className="stat-label">Total KR</span>
//                             <span className="stat-value">{total}</span>
//                         </div>
//                     </div>

//                     {/* STATS ROW */}
//                     <div className="okr-stats-row">
//                         <div className="stat-box danger">
//                             <span className="stat-label">Pending</span>
//                             <span className="stat-value">{pending}</span>
//                         </div>

//                         <div className="stat-box success">
//                             <span className="stat-label">Completed</span>
//                             <span className="stat-value">{completed}</span>
//                         </div>
//                     </div>

//                     {/* PROGRESS FULL WIDTH */}
//                     <div className="progress-section-wide full">
//                         <div className="progress-labels">
//                             <span className="label-muted">Completion</span>
//                             <span className="label-bold">{progressPercent}%</span>
//                         </div>

//                         <div className="wide-bar-bg">
//                             <div
//                                 className="wide-bar-fill"
//                                 style={{ width: `${progressPercent}%` }}
//                             ></div>
//                         </div>
//                     </div>

//                     {/* FOOTER */}
//                     <div className="expanded-footer">
//                         <span className={`status-indicator ${pending > 0 ? 'is-warning' : 'is-clear'}`}>
//                             {pending > 0
//                                 ? `● ${pending} Key Results Pending`
//                                 : '● All Key Results Completed'}
//                         </span>

//                         <span className="interaction-hint">
//                             Open OKR Console →
//                         </span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     const [mgmtOneOnOneData, setMgmtOneOnOneData] = useState([]);
//     useEffect(() => {
//         const fetchMeetings = async () => {
//             const storedUser = localStorage.getItem('userData');
//             const user = JSON.parse(storedUser) || {};

//             const res = await fetch(
//                 `/gt-api/get_oneonone.php?manager_id=${user.id}&role=manager`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.meetings) {
//                 setMgmtOneOnOneData(data.meetings);
//             }
//         };

//         fetchMeetings();
//     }, []);

//     const renderOneOnOneHealthCard = () => {
//         const missedData = mgmtOneOnOneData.filter(m => m.status === "MISSED");

//         const total = mgmtOneOnOneData.length;
//         const missed = mgmtOneOnOneData.filter(m => m.status === "MISSED").length;
//         const completed = total - missed;

//         const rate = total > 0 ? Math.round((completed / total) * 100) : 0;

//         let status = "Healthy";
//         if (rate < 50) status = "Critical ⚠️";
//         else if (rate < 80) status = "Needs Attention";

//         return (
//             <div className="meeting-card" onClick={() => handleModuleChange("manager-one-on-one")}>

//                 <div className="mc-header">
//                     <h3>1:1 Meeting Scheduler</h3>
//                     <span>{status}</span>
//                 </div>

//                 {/* BIG NUMBER */}
//                 <div className="mc-center">
//                     <h1>{rate}%</h1>
//                     <p>Engagement</p>
//                 </div>

//                 {/* BARS */}
//                 <div className="mc-bars">
//                     <div className="bar completed" style={{ width: `${rate}%` }}></div>
//                     <div className="bar missed" style={{ width: `${100 - rate}%` }}></div>
//                 </div>

//                 {/* INFO */}
//                 <div className="mc-info">
//                     <span>✅ {completed} Done</span>
//                     <span>❌ {missed} Missed</span>
//                 </div>
//                 <button
//                     className="view-missed-btn"
//                     onClick={(e) => {
//                         e.stopPropagation();
//                         setShowMissedModal(true);
//                     }}
//                 >
//                     View Missed
//                 </button>

//             </div>
//         );
//     };

//     const [okrActivity, setOkrActivity] = useState([]);
//     useEffect(() => {
//         const fetchOKR = async () => {
//             try {
//                 const storedUser = localStorage.getItem("userData");
//                 const user = JSON.parse(storedUser) || {};

//                 const res = await fetch(
//                     `/gt-api/get_employee_okrs.php?role=${user.role}&managedDept=${user.department}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 if (data.success) {
//                     setOkrActivity(data.data);
//                 }

//             } catch (err) {
//                 console.error("OKR Fetch Error:", err);
//             }
//         };

//         fetchOKR();
//     }, []);

//     const recentOKR = okrActivity
//         .slice(0, 5)
//         .map(item => {
//             let type = "updated";

//             if (item.workflow_status === "Planning") {
//                 type = "new";
//             }

//             if (item.workflow_status === "Manager_Scoring_Review") {
//                 type = "pending";
//             }

//             return {
//                 name: item.emp_name,
//                 quarter: item.quarter,
//                 type,
//                 workflow_status: item.workflow_status   // 🔥 VERY IMPORTANT
//             };
//         });



//     const renderOKRActivityCard = () => {
//         const getStatusConfig = (status) => {
//             switch (status) {
//                 case "Planning": return { color: "#3b82f6", label: "submitted OKR" };
//                 case "Management_Review": return { color: "#f59e0b", label: "sent for Review" };
//                 case "Scoring": return { color: "#8b5cf6", label: "sent for Scoring" };
//                 case "Sign_Off": return { color: "#10b981", label: "finalized OKR" };
//                 default: return { color: "#00bcd4", label: "updated OKR" };
//             }
//         };

//         return (
//             <div className="mgt-okr-card1 timeline-style clickable" onClick={() => handleModuleChange("employee-okrs")}>
//                 <div className="card-header-v2">
//                     <div className="title-section">
//                         <h3>OKR Stream</h3>
//                         <div className="live-dot-wrapper">
//                             <span className="live-dot"></span>
//                             <span className="sub-text">Live updates</span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="okr-activity-timeline">
//                     {recentOKR.length === 0 ? (
//                         <div className="empty-state">No recent activity detected</div>
//                     ) : (
//                         recentOKR.slice(0, 3).map((item, i) => {
//                             const config = getStatusConfig(item.workflow_status);
//                             return (
//                                 <div key={i} className="timeline-item">
//                                     {/* The Vertical Line & Dot */}
//                                     <div className="timeline-visual">
//                                         <div className="timeline-line"></div>
//                                         <div className="timeline-marker" style={{ borderColor: '#111827', background: config.color }}>
//                                             <div className="marker-inner-dot"></div>
//                                         </div>
//                                     </div>

//                                     {/* Single Content Box */}
//                                     <div className="timeline-content-box">
//                                         <div className="content-top">
//                                             <span className="emp-name">{item.name}</span>
//                                             <span className="quarter-tag">{item.quarter}</span>
//                                         </div>
//                                         <p className="status-message">{config.label}</p>
//                                     </div>
//                                 </div>
//                             );
//                         })
//                     )}
//                 </div>

//                 <div className="card-footer-v2">
//                     <span>Access Module</span>
//                     {/* <div className="arrow-circle">→</div> */}
//                 </div>


//             </div>
//         );
//     };

//     const renderManagementShortcutsCard = () => {
//         const shortcuts = [

//             { name: "Create Invoice", icon: "🏦", slug: "create-invoice" },
//             { name: "Policy RnU", icon: "📋", slug: "policy-logs" },
//             { name: "Career Development", icon: "🏆", slug: "career pathways" },
//             { name: "Expense Reimbursement", icon: "💰", slug: "reimbursements" },
//             // { name: "ACM Updates", icon: "📢", slug: "manage-quarterly-updates" },
//             { name: "Self OKR", icon: "🎯", slug: "okr and performance tracker" },
//             { name: "Own Financial", icon: "💳", slug: "pay and benefits" },
//             { name: "Access ACM Info", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//             // { name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },
//             { name: "IT Support", icon: "🖥️", slug: "employee-it-support" },
//             { name: "Attendance Tracker", icon: "📊", slug: "attendance-tracker" },
//             // { name: "Company Setup", icon: "⚙️", slug: "CompanySetup" },





//         ];

//         return (
//             <div className="mgt-shortcut-card">

//                 <div className="card-header">
//                     <h3>Quick Access</h3>
//                     <span className="sub-text">Shortcuts</span>
//                 </div>

//                 <div className="shortcut-grid">
//                     {shortcuts.map((item, i) => (
//                         <div
//                             key={i}
//                             className="shortcut-item"
//                             onClick={() => handleModuleChange(item.slug)}
//                         >
//                             <span className="shortcut-icon">{item.icon}</span>
//                             <span className="shortcut-text">{item.name}</span>
//                         </div>
//                     ))}
//                 </div>

//             </div>
//         );
//     };


//     const renderEmployeeDashboard = () => {
//         return (
//             <div className="dashboard-layout">

//                 <div className="dashboard-row row-top">
//                     {renderLeavePieChart()}
//                     {renderPayChart()}
//                     {renderOneOnOneCard()}



//                     {/* {renderEquipmentCard()} */}
//                 </div>

//                 <div className="dashboard-row row-middle">
//                     {renderOKRCard()}
//                     {renderCareerPathwaysCard()}
//                 </div>

//                 <div className="dashboard-row row-bottom">
//                     {renderPolicyCard()}
//                     <QuarterlyCard handleModuleChange={handleModuleChange} />
//                 </div>

//             </div>
//         );
//     };

//     const renderManagementDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>






//         );
//     };

//     const renderManagerDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>




//         );
//     };

//     const currentEvent =
//         todayEvents && todayEvents.length > 0
//             ? todayEvents[currentEventIndex]
//             : null;


//     const combinedEvents = [];

//     // 🎊 Festival TODAY (Priority if festival is today)
//     if (upcomingFestival && isFestivalToday) {
//         combinedEvents.push({
//             type: "festival",
//             title: upcomingFestival.name,
//             tag: "FESTIVAL TODAY",
//             icon: "🎊",
//             sub: "Today 🎉"
//         });
//     }

//     // 🎂 Birthday / Anniversary
//     if (currentEvent && currentEvent.fullName) {
//         combinedEvents.push({
//             type: "event",
//             title: currentEvent.fullName,
//             tag: currentEvent.isBirthday ? "BIRTHDAY" : "WORK ANNIVERSARY",
//             icon: currentEvent.isBirthday ? "🎂" : "🎉"
//         });
//     }

//     // 🎊 Upcoming Festival (If future)
//     if (upcomingFestival && !isFestivalToday) {
//         combinedEvents.push({
//             type: "festival",
//             title: upcomingFestival.name,
//             tag: "UPCOMING FESTIVAL",
//             icon: "🎊",
//             sub: `In ${daysLeft} days`
//         });
//     }

//     useEffect(() => {
//         if (combinedEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setActiveEventIndex(prev => (prev + 1) % combinedEvents.length);
//         }, 4000);

//         return () => clearInterval(interval);
//     }, [combinedEvents.length]);

//     const activeEvent = combinedEvents[activeEventIndex];


//     return (

//         <div


//             className={`dash-container ${theme}-theme`}
//             style={
//                 theme === 'light'
//                     ? {
//                         backgroundImage: `url(${logoLight})`,
//                         backgroundSize: 'cover',
//                         backgroundRepeat: 'no-repeat',
//                         backgroundPosition: 'center',
//                         backgroundColor: 'var(--bg-main)'

//                     }
//                     : {}
//             }
//         >


//             {showMissedModal && (
//                 <div className="modal-overlay" onClick={() => setShowMissedModal(false)}>
//                     <div className="modal-card" onClick={(e) => e.stopPropagation()}>

//                         <h3>Missed 1:1 Meetings</h3>

//                         {mgmtOneOnOneData.filter(m => m.status === "MISSED").length === 0 ? (
//                             <p>No missed meetings 🎉</p>
//                         ) : (
//                             mgmtOneOnOneData
//                                 .filter(m => m.status === "MISSED")
//                                 .map((m, i) => (
//                                     <div key={i} className="missed-item">
//                                         <strong>{m.employee_name}</strong>
//                                         <span>{m.date}</span>
//                                     </div>
//                                 ))
//                         )}

//                         <button onClick={() => setShowMissedModal(false)}>
//                             Close
//                         </button>

//                     </div>
//                 </div>
//             )}



//             <div className="auth-background-overlay"></div>






//             <Sidebar
//                 role={role}
//                 userData={userData}
//                 activeModule={activeModule}
//                 openMenus={openMenus}
//                 toggleSubMenu={toggleSubMenu}
//                 handleModuleChange={handleModuleChange}
//                 handleLogout={handleLogout}
//                 mobileMenuOpen={mobileMenuOpen}
//                 setMobileMenuOpen={setMobileMenuOpen}
//                 pendingRequestsCount={pendingRequestsCount}
//             />

//             <main className="dash-content">

//                 <header className="content-header">

//                     {/* 🔷 LEFT */}
//                     <div className="header-left">
//                         <div className="header-text">

//                             <h1>
//                                 {activeModule === "grid" && !showProfile ? "Welcome," : ""}{" "}
//                                 <span className={theme === 'light' ? "name-light" : "name-accent"}>
//                                     {showProfile
//                                         ? "MY PROFILE"
//                                         : (activeModule === "grid"
//                                             ? userData.firstName || userData.FirstName
//                                             : (activeModule === "attendance"
//                                                 ? "LEAVE MANAGEMENT"
//                                                 : (activeModule === "one-on-one-report"
//                                                     ? "ONE-ON-ONE REPORT"
//                                                     : activeModule.toUpperCase().replace(/-/g, ' ')
//                                                 )
//                                             )
//                                         )
//                                     }
//                                 </span>
//                             </h1>

//                             {activeModule === 'attendance' && userData.joiningDate && (
//                                 <div className="joining-info">
//                                     JOINING_DATE: {new Date(userData.joiningDate).toLocaleDateString('en-GB').toUpperCase()}
//                                 </div>
//                             )}

//                         </div>
//                     </div>







//                     <div className="header-center">

//                         {/* TIME + DATE FIRST */}
//                         <div className="time-date-right">
//                             <div className="live-time">{currentTime}</div>

//                             <div className="today-widget">
//                                 <span>📅 {todayDate}</span>
//                                 <small>Have a Nice Day!</small>
//                             </div>
//                         </div>

//                         {/* EVENT CARD SECOND */}
//                         <div
//                             className={`executive-event-bar ${theme === 'light' ? 'light-theme-elite' : 'dark-theme-elite'}
//         ${role === "Management" || role === "Manager" ? "clickable" : ""}`}
//                             onClick={() => {
//                                 if (role === "Management" || role === "Manager") {
//                                     handleModuleChange("events-celebrations");
//                                 }
//                             }}
//                         >
//                             <div
//                                 className={`event-status-box ${activeEvent
//                                     ? (activeEvent.type === 'festival'
//                                         ? 'bg-fest'
//                                         : (activeEvent.tag === 'BIRTHDAY' ? 'bg-birth' : 'bg-anniv'))
//                                     : 'bg-neutral'
//                                     }`}
//                             >
//                                 <span className="event-icon-small">
//                                     {activeEvent ? activeEvent.icon : "✨"}
//                                 </span>
//                             </div>

//                             <div className="event-content-main">
//                                 <div className="event-label-row">
//                                     <span className="event-tag">
//                                         {activeEvent ? activeEvent.tag : "TODAY"}
//                                     </span>
//                                 </div>

//                                 <h3 className="event-title-text">

//                                     {activeEvent ? (
//                                         <span className="event-highlight">
//                                             {activeEvent.icon} {activeEvent.title}
//                                         </span>
//                                     ) : (
//                                         <span className="event-empty-text">
//                                             No events today
//                                         </span>
//                                     )}
//                                 </h3>
//                             </div>

//                             <div className="event-action-wrapper">
//                                 <button
//                                     className="minimal-wish-btn"
//                                     disabled={!currentEvent}
//                                     onClick={(e) => e.stopPropagation()}
//                                 >
//                                     <div className="btn-line"></div>
//                                 </button>
//                             </div>
//                         </div>

//                     </div>







//                     <div className="header-controls">

//                         {/* 🌗 THEME */}
//                         <div className="theme-switch-container">
//                             <label className="theme-slider-switch">
//                                 <input
//                                     type="checkbox"
//                                     onChange={toggleTheme}
//                                     checked={theme === 'light'}
//                                 />
//                                 <span className="theme-slider round">
//                                     <span className="sun-icon">☀️</span>
//                                     <span className="moon-icon">🌙</span>
//                                 </span>
//                             </label>
//                         </div>




//                         {(activeModule !== "grid" || showProfile) && (
//                             <button
//                                 className="back-btn"
//                                 onClick={() => handleModuleChange("grid")}
//                             >
//                                 Back
//                             </button>
//                         )}

//                     </div>

//                 </header>


//                 {activeModule === "grid" ? (

//                     role === "Management"
//                         ? renderManagementDashboard()
//                         : role === "Manager"
//                             ? renderManagerDashboard()   // 🔥 ADD THIS LINE
//                             : renderEmployeeDashboard()

//                 ) : (
//                     renderActiveModule()
//                 )}

//                 <div className="dash-footer">
//                     Design & Developed by Genesis Tech Engineers © 2026
//                 </div>
//             </main>

//             {(role === "Management" || role === "Manager") && (
//                 <>
//                     <div
//                         className="ai-chat-float-btn"
//                         onClick={() => setShowAIChat(true)}
//                     >
//                         🤖
//                     </div>

//                     {showAIChat && (
//                         <div className="ai-chat-modal">
//                             <div className="ai-chat-header">
//                                 <span>ELMS AI Assistant</span>
//                                 <button onClick={() => setShowAIChat(false)}>
//                                     ✕
//                                 </button>
//                             </div>

//                             <div className="ai-chat-body">
//                                 {chatMessages.map((msg, index) => (
//                                     <div
//                                         key={index}
//                                         className={`chat-bubble ${msg.sender}`}
//                                     >
//                                         <pre>{msg.text}</pre>
//                                     </div>
//                                 ))}

//                                 {chatLoading && (
//                                     <div className="chat-bubble ai">
//                                         Thinking...
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="ai-chat-footer">
//                                 <input
//                                     type="text"
//                                     value={chatInput}
//                                     onChange={(e) => setChatInput(e.target.value)}
//                                     placeholder="Ask anything..."
//                                     onKeyDown={(e) => {
//                                         if (e.key === "Enter") {
//                                             sendAIMessage();
//                                         }
//                                     }}
//                                 />

//                                 <button onClick={sendAIMessage}>
//                                     Send
//                                 </button>
//                             </div>
//                         </div>
//                     )}
//                 </>
//             )}

//             {/* 🔴 MANDATORY PROFILE POPUP MODAL */}
//             {showMandatoryProfileModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">⚠️</div>
//                             <h2>Mandatory Profile Completion Required</h2>
//                             <p>
//                                 Your employee profile has missing information. Please fill in the required field(s) below to continue using the system.
//                             </p>
//                         </div>

//                         {mandatoryError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {mandatoryError}</span>
//                             </div>
//                         )}

//                         {mandatorySuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {mandatorySuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryProfile} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingProfileFields.phone && (
//                                     <div className="mandatory-input-group">
//                                         <label>Mobile Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="tel"
//                                             placeholder="Enter mobile number"
//                                             value={mandatoryFormData.phone}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, phone: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.dob && (
//                                     <div className="mandatory-input-group">
//                                         <label>Date of Birth <span className="req-star">*</span></label>
//                                         <input
//                                             type="date"
//                                             max={new Date().toISOString().split("T")[0]}
//                                             value={mandatoryFormData.dob}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, dob: e.target.value }))}
//                                             onClick={(e) => {
//                                                 try {
//                                                     if (e.target.showPicker) e.target.showPicker();
//                                                 } catch (err) { }
//                                             }}
//                                             required
//                                             className="mandatory-date-input"
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.city && (
//                                     <div className="mandatory-input-group">
//                                         <label>City <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter city"
//                                             value={mandatoryFormData.city}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, city: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.country && (
//                                     <div className="mandatory-input-group">
//                                         <label>Country <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter country"
//                                             value={mandatoryFormData.country}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, country: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Permanent Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter permanent address"
//                                             value={mandatoryFormData.address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.local_address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Current / Local Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter current / local address"
//                                             value={mandatoryFormData.local_address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, local_address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={mandatorySaving}
//                                 >
//                                     {mandatorySaving ? "Saving Profile..." : "Save Profile & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//             {/* 🏦 MANDATORY BANK DETAILS POPUP MODAL */}
//             {showMandatoryBankModal && !showMandatoryProfileModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">🏦</div>
//                             <h2>Mandatory Bank Details Required</h2>
//                             <p>
//                                 Your employee bank record has missing information. Please fill in the required field(s) below for payroll & salary processing.
//                             </p>
//                         </div>

//                         {bankError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {bankError}</span>
//                             </div>
//                         )}

//                         {bankSuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {bankSuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryBankDetails} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingBankFields.bankName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Bank Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC Bank, ICICI Bank"
//                                             value={bankFormData.bankName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, bankName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.holderName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Holder Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account holder name"
//                                             value={bankFormData.holderName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, holderName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accNumber && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account number"
//                                             value={bankFormData.accNumber}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accNumber: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.ifsc && (
//                                     <div className="mandatory-input-group">
//                                         <label>IFSC Code <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC0001234"
//                                             value={bankFormData.ifsc}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, ifsc: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.branch && (
//                                     <div className="mandatory-input-group">
//                                         <label>Branch Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter branch name"
//                                             value={bankFormData.branch}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, branch: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accType && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Type <span className="req-star">*</span></label>
//                                         <select
//                                             value={bankFormData.accType}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accType: e.target.value }))}
//                                             required
//                                         >
//                                             <option value="Saving Account">Saving Account</option>
//                                             <option value="Current Account">Current Account</option>
//                                             <option value="Salary Account">Salary Account</option>
//                                         </select>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={bankSaving}
//                                 >
//                                     {bankSaving ? "Saving Bank Details..." : "Save Bank Details & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Dashboard;





































// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';

// import {
//     ResponsiveContainer,
//     BarChart,
//     Bar,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip
// } from "recharts";
// import { Bar as ChartBar, Pie, Doughnut } from 'react-chartjs-2';

// // ✅ REACT + ROUTER
// import React, { useState, useEffect, useMemo } from 'react';
// import { useParams, useNavigate, useLocation } from 'react-router-dom';

// // ✅ MODULES
// import Attendance from '../../modules/Attendance';
// import PayBenefits from '../../modules/PayBenefits';
// import OKRTracker from '../../modules/OKRTracker';
// import CareerPathways from '../../modules/CareerPathways';
// import EquipmentRequest from '../../modules/EquipmentRequest';
// import OfficeRequisition from '../../modules/OfficeRequisition';
// import ITSupport from '../../modules/ITSupport';
// import Documents from '../../modules/Documents';
// import CompanyPolicy from '../../modules/CompanyPolicy';
// import OrgChart from '../../modules/OrgChart';
// import CampusInfo from '../../modules/CampusInfo';
// import AddDepartment from '../../modules/AddDepartment';
// import AddEmployee from '../../modules/AddEmployee';
// import ManageDepartment from '../../modules/ManageDepartment';
// import ManageEmployee from '../../modules/ManageEmployee';
// import MyProfile from '../../modules/MyProfile';
// import LeaveManagement from '../../modules/LeaveManagement';
// import EESExperience from '../../modules/EESExperience';
// import EESFeedbackManagement from '../../modules/EESFeedbackManagement';
// import MedicalReports from '../../modules/MedicalReports';
// import ManagementOKRViewer from '../../modules/ManagementOKRViewer';
// import ManagerLeaveManagement from '../../modules/ManagerLeaveManagement';
// import ManagerMedicalReports from '../../modules/ManagerMedicalReports';
// import EmployeeSalaryBenefits from '../../modules/EmployeeSalaryBenefits';
// import PolicyAdminDashboard from '../../modules/PolicyAdminDashboard';
// import ManageEmployeeDocs from '../../modules/ManageEmployeeDocs';
// import OneOnOne from '../../modules/OneOnOne';
// import EventsCelebrations from '../../modules/EventsCelebrations';
// import ProjectModule from '../../modules/ProjectModule';
// import QuarterlyUpdates from '../../modules/QuarterlyUpdates';
// import ManagementQuarterlyUpdate from '../../modules/ManagementQuarterlyUpdate';
// import ReimbursementManagement from '../../modules/ReimbursementManagement';
// import WorkFromHome from '../../modules/WorkFromHome';
// import WFHManagement from '../../modules/WFHManagement';
// import OneOnOneAnalyticsCard from "../../modules/OneOnOneAnalyticsCard";
// import OneOnOneReport from '../../modules/OneOnOneReport';
// import InvoiceGenerator from '../../modules/InvoiceGenerator';
// import AttendanceTracker from '../../modules/AttendanceTracker';
// import CompanySetup from '../../modules/CompanySetup';
// import Sidebar from "../../components/Sidebar/sidebar";

// // ✅ ASSETS
// import logoLight from '../../assets/logowhite-p.png';
// import logoDark from '../../assets/logo-white-r.png';

// // ✅ STYLES
// import './Dashboard.css';


// // ✅ CHART.JS CORE
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip as ChartTooltip,  // ✅ rename this
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// } from 'chart.js';

// // ✅ REGISTER CHART.JS
// ChartJS.register(
//     ArcElement,
//     ChartTooltip, // ✅ use renamed one
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// );



// const QuarterlyCard = ({ handleModuleChange }) => {

//     const [latest, setLatest] = React.useState(null);

//     React.useEffect(() => {
//         fetch(
//             "/gt-api/get_quarterly_media.php?type=ACM Presentation",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "ACM DATA:",
//                     data
//                 );

//                 if (data.success && data.data.length > 0) {
//                     setLatest(data.data[0]);
//                 }
//             })
//             .catch(err => console.error("Quarterly Fetch Error:", err));
//     }, []);

//     console.log("LATEST ACM:", latest);

//     return (
//         <div
//             className="quarterly-pro-card clickable"
//             onClick={() => handleModuleChange("quarterly-updates")}
//         >
//             {/* Glow Layer */}
//             <div className="card-glow"></div>

//             {/* HEADER */}
//             <div className="qp-header">
//                 <div className="qp-left">
//                     <span className="qp-tag">ACM Updates</span>
//                     <h3 className="qp-title">Quarterly Insights</h3>
//                 </div>

//                 <div className="qp-icon">📢</div>
//             </div>

//             {/* BODY */}
//             <div className="qp-body">
//                 {latest ? (
//                     <>
//                         <h4 className="qp-main-title">{latest.title}</h4>

//                         <div className="qp-meta">
//                             <span className="qp-date">
//                                 {new Date(latest.created_at).toLocaleDateString('en-GB')}
//                             </span>
//                             <span className="qp-badge">NEW</span>
//                         </div>
//                     </>
//                 ) : (
//                     <div className="qp-empty">
//                         <div className="qp-loader"></div>
//                         <span>Awaiting next update</span>
//                     </div>
//                 )}
//             </div>

//             {/* FOOTER */}
//             <div className="qp-footer">
//                 <span>View Presentation</span>
//                 <span className="arrow">→</span>
//             </div>
//         </div>
//     );
// };


// const Dashboard = () => {
//     const [dashboardDepartments, setDashboardDepartments] = useState([]);
//     const [dashboardPathways, setDashboardPathways] = useState([]);
//     const [policyCount, setPolicyCount] = useState(0);

//     const [showAIChat, setShowAIChat] = useState(false);

//     const [chatMessages, setChatMessages] = useState([
//         {
//             sender: "ai",
//             text: "Hello 👋 Ask me anything about your ELMS database."
//         }
//     ]);

//     const [chatInput, setChatInput] = useState("");
//     const [chatLoading, setChatLoading] = useState(false);



//     const [showMissedModal, setShowMissedModal] = useState(false);

//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//     const [todayEvents, setTodayEvents] = useState([]);
//     useEffect(() => {
//         const fetchTodayEvents = async () => {
//             try {
//                 const res = await fetch('/gt-api/get_celebrations.php');
//                 const data = await res.json();

//                 if (data.success) {
//                     setTodayEvents(data.data || []);
//                 }
//             } catch (err) {
//                 console.error("Dashboard Events Error:", err);
//             }
//         };

//         fetchTodayEvents();
//     }, []);
//     const [currentEventIndex, setCurrentEventIndex] = useState(0);
//     useEffect(() => {
//         if (!todayEvents || todayEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setCurrentEventIndex((prev) =>
//                 (prev + 1) % todayEvents.length
//             );
//         }, 3000); // change every 3 sec

//         return () => clearInterval(interval);
//     }, [todayEvents]);


//     const [equipmentData, setEquipmentData] = useState({
//         total: 0,
//         pending: 0,
//         blocking: 0
//     });



//     const [logs, setLogs] = useState({});

//     const totalPolicies = 11;
//     const readCount = Object.keys(logs || {}).length;

//     const progress = totalPolicies > 0
//         ? Math.round((readCount / totalPolicies) * 100)
//         : 0;


//     const params = useParams();
//     const module = params.module;

//     const storedUser = JSON.parse(localStorage.getItem("userData"));
//     const role = storedUser?.role;
//     const navigate = useNavigate();

//     useEffect(() => {
//         const storedUser = localStorage.getItem("userData");

//         if (!storedUser) {
//             navigate("/", { replace: true });
//             return;
//         }

//         // prevent back button access after logout
//         window.history.pushState(null, "", window.location.href);
//         window.onpopstate = function () {
//             const user = localStorage.getItem("userData");
//             if (!user) {
//                 navigate("/", { replace: true });
//             }
//         };

//     }, [navigate]);







//     const [policyLogs, setPolicyLogs] = useState({});





//     const checkIfFestivalIsToday = (festival, daysLeftVal, isTodayFlag) => {
//         if (!festival) return false;
//         if (isTodayFlag === true || daysLeftVal === 0) return true;

//         if (festival.date) {
//             const today = new Date();
//             const currentDay = today.getDate();
//             const currentMonth = today.getMonth();
//             const monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
//             const currentMonthName = monthNames[currentMonth];

//             const dateLower = String(festival.date).trim().toLowerCase();

//             // 1. Text Month Matching (e.g., "7th Sep", "7 Sep", "2nd to 10th Oct")
//             if (dateLower.includes(currentMonthName) || (currentMonthName === "sep" && dateLower.includes("sept"))) {
//                 const rangeMatch = dateLower.match(/(\d+)\s*(?:st|nd|rd|th)?\s*to\s*(\d+)\s*(?:st|nd|rd|th)?/);
//                 if (rangeMatch) {
//                     const startDay = parseInt(rangeMatch[1], 10);
//                     const endDay = parseInt(rangeMatch[2], 10);
//                     if (currentDay >= startDay && currentDay <= endDay) {
//                         return true;
//                     }
//                 }

//                 const numbers = dateLower.match(/\d+/g);
//                 if (numbers) {
//                     for (let numStr of numbers) {
//                         const num = parseInt(numStr, 10);
//                         if (num === currentDay) {
//                             return true;
//                         }
//                     }
//                 }
//             }

//             // 2. Numeric Date Matching (e.g., "7-9-2026", "07-09-2026", "7/9/2026", "2026-09-07")
//             const numMatch = dateLower.match(/^(\d{1,4})[-/.](\d{1,2})[-/.](\d{1,4})$/);
//             if (numMatch) {
//                 let p1 = parseInt(numMatch[1], 10);
//                 let p2 = parseInt(numMatch[2], 10);
//                 let p3 = parseInt(numMatch[3], 10);

//                 let d, m;
//                 if (p1 > 31) {
//                     m = p2; d = p3;
//                 } else {
//                     d = p1; m = p2;
//                 }

//                 if (d === currentDay && m === (currentMonth + 1)) {
//                     return true;
//                 }
//             }
//         }

//         if (typeof daysLeftVal === 'number' && daysLeftVal === 0) {
//             return true;
//         }

//         return false;
//     };

//     const [upcomingFestival, setUpcomingFestival] = useState(null);
//     const [daysLeft, setDaysLeft] = useState(null);
//     const [isFestivalToday, setIsFestivalToday] = useState(false);
//     const [activeEventIndex, setActiveEventIndex] = useState(0);
//     useEffect(() => {
//         fetch("/gt-api/get_upcoming_festival.php", {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 const fest = data.festival || data.upcoming || (data.data && data.data[0]);
//                 if (fest) {
//                     const normalized = {
//                         ...fest,
//                         name: fest.name || fest.festival_name || fest.title || "Festival",
//                         image: fest.image || fest.img || fest.imageName || ""
//                     };
//                     setUpcomingFestival(normalized);
//                     setDaysLeft(data.daysLeft ?? 0);
//                     const festIsToday = data.isToday || data.daysLeft === 0 || checkIfFestivalIsToday(normalized, data.daysLeft, data.isToday);
//                     setIsFestivalToday(festIsToday);
//                 }
//             })
//             .catch(err => console.error(err));
//     }, []);


//     const location = useLocation();



//     const [showProfile, setShowProfile] = useState(false);
//     const [showPasswordModal, setShowPasswordModal] = useState(false);
//     const [isEditing, setIsEditing] = useState(false);

//     const [activeModule, setActiveModule] = useState(module || "grid");
//     const [isLightMode, setIsLightMode] = useState(false);

//     const [openMenus, setOpenMenus] = useState({
//         department: false,
//         employee: false
//     });

//     const [pendingRequestsCount, setPendingRequestsCount] = useState(0);
//     const [pendingLeavesCount, setPendingLeavesCount] = useState(0);
//     const [requestsList, setRequestsList] = useState([]);
//     const [notifCount, setNotifCount] = useState(0);

//     const [eesSubmissions, setEesSubmissions] = useState([]);
//     const handleEESSubmit = (newFeedback) => {
//         setEesSubmissions(prev => [...prev, newFeedback]);
//     };

//     const [passwordForm, setPasswordForm] = useState({
//         currentPassword: '',
//         newPassword: '',
//         confirmPassword: ''
//     });

//     const [showMandatoryProfileModal, setShowMandatoryProfileModal] = useState(false);
//     const [missingProfileFields, setMissingProfileFields] = useState({
//         phone: false,
//         dob: false,
//         city: false,
//         address: false,
//         local_address: false,
//         country: false
//     });
//     const [mandatoryFormData, setMandatoryFormData] = useState({
//         phone: '',
//         dob: '',
//         city: '',
//         address: '',
//         local_address: '',
//         country: ''
//     });
//     const [mandatorySaving, setMandatorySaving] = useState(false);
//     const [mandatoryError, setMandatoryError] = useState('');
//     const [mandatorySuccessMsg, setMandatorySuccessMsg] = useState('');

//     // 🔴 MANDATORY BANK DETAILS MODAL STATE
//     const [showMandatoryBankModal, setShowMandatoryBankModal] = useState(false);
//     const [missingBankFields, setMissingBankFields] = useState({
//         bankName: false,
//         holderName: false,
//         accNumber: false,
//         ifsc: false,
//         branch: false,
//         accType: false
//     });
//     const [bankFormData, setBankFormData] = useState({
//         bankName: '',
//         holderName: '',
//         accNumber: '',
//         ifsc: '',
//         branch: '',
//         accType: 'Saving Account'
//     });
//     const [bankSaving, setBankSaving] = useState(false);
//     const [bankError, setBankError] = useState('');
//     const [bankSuccessMsg, setBankSuccessMsg] = useState('');




//     const [userData, setUserData] = useState(() => {
//         const storedData = localStorage.getItem("userData");
//         if (storedData) return JSON.parse(storedData);

//         const firstName = location.state?.userName?.split(' ')[0] || "User";
//         const lastName = location.state?.userName?.split(' ')[1] || "";

//         return {
//             firstName,
//             lastName,
//             email: "",
//             dept: "Loading...",
//             phone: "",
//             gender: "",
//             dob: "",
//             address: "",
//             city: "",
//             country: "",
//             employeeId: location.state?.empId || null,
//             profileImage: null,
//             joiningDate: null,
//             HOD: null
//         };
//     });


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_career_pathways.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setDashboardPathways(
//                         data.pathways || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_departments.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "DASHBOARD DEPARTMENTS:",
//                     data
//                 );

//                 if (data.success) {

//                     setDashboardDepartments(
//                         data.departments || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) {

//             setPolicyCount(11);
//             return;

//         }

//         fetch(
//             "/gt-api/get_policies.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setPolicyCount(
//                         data.policies?.length || 0
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);
//     // ✅ THEN use it
//     const employeeId = userData?.id || userData?.employeeId;


//     useEffect(() => {
//         const fetchLeaveDashboardData = async () => {
//             if (!employeeId) return;

//             try {
//                 const res = await fetch(`/gt-api/get_leaves.php?empid=${employeeId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 const wfhRes = await fetch(`/gt-api/get_wfh.php?empid=${employeeId}`, {
//                     credentials: "include"
//                 });
//                 const wfhData = await wfhRes.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];

//                     // 🔥 SAME LOGIC AS ATTENDANCE
//                     const today = new Date();
//                     const currentYear = today.getFullYear();

//                     const fiscalYearStart = new Date(currentYear, 3, 1);

//                     const activeFiscalYearStart =
//                         today < fiscalYearStart
//                             ? new Date(currentYear - 1, 3, 1)
//                             : fiscalYearStart;

//                     // ✅ Dynamic Sick Total (joining based)
//                     let sickTotal = 12;

//                     if (userData?.joiningDate) {
//                         const joining = new Date(userData.joiningDate);

//                         const fyEnd = new Date(activeFiscalYearStart);
//                         fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
//                         fyEnd.setMonth(2);
//                         fyEnd.setDate(31);

//                         if (joining > activeFiscalYearStart) {
//                             if (joining > fyEnd) {
//                                 sickTotal = 0;
//                             } else {
//                                 const joinMonth = joining.getMonth();
//                                 const fyEndMonth = 2;

//                                 let monthsRemaining;

//                                 if (joinMonth <= fyEndMonth) {
//                                     monthsRemaining = fyEndMonth - joinMonth + 1;
//                                 } else {
//                                     monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
//                                 }

//                                 sickTotal = monthsRemaining;
//                             }
//                         }
//                     }

//                     let sickUsed = 0;
//                     let earnedUsed = 0;

//                     leaves.forEach(leave => {
//                         const status = String(leave.Status);
//                         const days = parseFloat(leave.total) || 0;
//                         const leaveDate = new Date(leave.fromdate);
//                         const medStatus = String(leave.medical_doc_status);

//                         // ✅ SAME CONDITION AS ATTENDANCE
//                         if (status === '0' || status === '1') {

//                             if (leave.leavetype === 'Sick Leave') {
//                                 if (leaveDate >= activeFiscalYearStart) {
//                                     sickUsed += days;
//                                 }
//                             }

//                             else if (leave.leavetype === 'Earned Leave') {

//                                 // 🔥 MEDICAL CONVERSION LOGIC
//                                 if (medStatus === '1' || medStatus === '0') {
//                                     if (leaveDate >= activeFiscalYearStart) {
//                                         sickUsed += days;
//                                     }
//                                 } else {
//                                     earnedUsed += days;
//                                 }
//                             }
//                         }
//                     });


//                     console.log("LEAVES:", leaves);
//                     console.log("SICK USED:", sickUsed);
//                     console.log("EARNED USED:", earnedUsed);
//                     console.log("API EARNED BALANCE:", data.earned);

//                     setLeaveData({
//                         leaveHistory: leaves,
//                         leaveBalances: {
//                             sick: { used: sickUsed, total: sickTotal },
//                             earned: { used: earnedUsed, total: parseFloat(data.earned) || 0 }
//                         },
//                         wfhHistory: wfhData.requests || []
//                     });
//                 }

//             } catch (err) {
//                 console.error("Dashboard Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaveDashboardData();
//     }, [employeeId, userData?.joiningDate]);


//     useEffect(() => {
//         setActiveModule(module || "grid");
//     }, [module]);

//     useEffect(() => {

//         if (role === 'Management' || role === 'Manager') {

//             const fetchRealTimeLeaves = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_leaves.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {
//                         // Count requests with Status '0' or null
//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };


//             fetchRealTimeLeaves();


//             const liveInterval = setInterval(fetchRealTimeLeaves, 5000);

//             return () => clearInterval(liveInterval);
//         }
//     }, [role]);



//     useEffect(() => {

//         const fetchUserData = async () => {

//             try {

//                 const response = await fetch("/gt-api/get_profile.php", {
//                     credentials: "include"
//                 });

//                 const data = await response.json();

//                 if (data.success && data.employee) {

//                     const storedUser = JSON.parse(localStorage.getItem("userData"));

//                     const updatedUser = {
//                         id: data.employee.id,
//                         EmpId: data.employee.EmpId,

//                         firstName: data.employee.FirstName,
//                         FirstName: data.employee.FirstName,

//                         lastName: data.employee.LastName,
//                         LastName: data.employee.LastName,

//                         email: data.employee.EmailId,
//                         EmailId: data.employee.EmailId,

//                         Department: data.employee.DepartmentName || data.employee.Department,

//                         HOD: data.employee.HOD,
//                         Designation: data.employee.Designation,
//                         phone: data.employee.Phonenumber,
//                         gender: data.employee.Gender,
//                         dob: data.employee.Dob,
//                         address: data.employee.Address,
//                         local_address: data.employee.LocalAddress,
//                         city: data.employee.City,
//                         country: data.employee.Country,
//                         profileImage: data.employee.ProfilePicture || null,
//                         joiningDate: data.employee.JoiningDate,

//                         role: storedUser?.role
//                     };

//                     setUserData(updatedUser);

//                     localStorage.setItem("userData", JSON.stringify(updatedUser));

//                     // ✅ CHECK ONLY MISSING MANDATORY PROFILE FIELDS
//                     const isMissing = (val) => !val || String(val).trim() === '' || String(val).trim() === '0000-00-00';
//                     const missing = {
//                         phone: isMissing(updatedUser.phone),
//                         dob: isMissing(updatedUser.dob),
//                         city: isMissing(updatedUser.city),
//                         address: isMissing(updatedUser.address),
//                         local_address: isMissing(updatedUser.local_address),
//                         country: isMissing(updatedUser.country)
//                     };

//                     if (Object.values(missing).some(Boolean)) {
//                         setMissingProfileFields(missing);
//                         setMandatoryFormData({
//                             phone: updatedUser.phone || '',
//                             dob: updatedUser.dob || '',
//                             city: updatedUser.city || '',
//                             address: updatedUser.address || '',
//                             local_address: updatedUser.local_address || '',
//                             country: updatedUser.country || ''
//                         });
//                         setShowMandatoryProfileModal(true);
//                     }

//                     // 🏦 CHECK MANDATORY BANK DETAILS
//                     const empIdForBank = data.employee.id || data.employee.EmpId;
//                     if (empIdForBank) {
//                         let bank = null;
//                         try {
//                             const bankRes = await fetch(`/gt-api/get_bank_details.php?emp_id=${empIdForBank}`, {
//                                 credentials: "include"
//                             });
//                             const rawText = await bankRes.text();
//                             try {
//                                 const json = JSON.parse(rawText);
//                                 if (json && (json.success || json.bank || json.bank_name || json.bankName)) {
//                                     bank = json.bank || json.data || json.details || json.employee_bank_details || json;
//                                 }
//                             } catch (parseErr) {
//                                 console.log("get_bank_details json parse error:", parseErr);
//                             }
//                         } catch (bErr) {
//                             console.error("Bank details fetch network error:", bErr);
//                         }

//                         const b = bank || {};

//                         const getVal = (...keys) => {
//                             for (const k of keys) {
//                                 if (b[k] !== undefined && b[k] !== null && String(b[k]).trim() !== '') {
//                                     return String(b[k]).trim();
//                                 }
//                             }
//                             return '';
//                         };

//                         const bankNameVal = getVal('bankName', 'bank_name', 'BankName', 'Bankname');
//                         const holderNameVal = getVal('holderName', 'holder_name', 'HolderName', 'account_holder_name', 'AccountHolderName');
//                         const accNumberVal = getVal('accNumber', 'account_number', 'AccountNumber', 'AccNumber', 'account_no', 'AccountNo');
//                         const ifscVal = getVal('ifsc', 'ifsc_code', 'IFSC', 'Ifsc', 'IfscCode');
//                         const branchVal = getVal('branch', 'branch_name', 'Branch', 'BranchName');
//                         const accTypeVal = getVal('accType', 'account_type', 'AccountType', 'AccType');

//                         const isBankMissing = (val) => !val || String(val).trim() === '';

//                         const missingBank = {
//                             bankName: isBankMissing(bankNameVal),
//                             holderName: isBankMissing(holderNameVal),
//                             accNumber: isBankMissing(accNumberVal),
//                             ifsc: isBankMissing(ifscVal),
//                             branch: isBankMissing(branchVal),
//                             accType: isBankMissing(accTypeVal)
//                         };

//                         console.log("MANDATORY BANK CHECK RESULT:", { empId: empIdForBank, bankData: b, missingBank });

//                         if (Object.values(missingBank).some(Boolean)) {
//                             setMissingBankFields(missingBank);
//                             setBankFormData({
//                                 bankName: bankNameVal,
//                                 holderName: holderNameVal || `${data.employee.FirstName || ''} ${data.employee.LastName || ''}`.trim(),
//                                 accNumber: bankNameVal ? accNumberVal : '',
//                                 ifsc: ifscVal,
//                                 branch: branchVal,
//                                 accType: accTypeVal || 'Saving Account'
//                             });
//                             setShowMandatoryBankModal(true);
//                         }
//                     }
//                 }

//             } catch (error) {
//                 console.error("Database Error:", error);
//             }

//         };

//         fetchUserData();

//     }, []);

//     // 🔒 LOCK BODY SCROLL WHEN MANDATORY MODAL IS OPEN
//     useEffect(() => {
//         if (showMandatoryProfileModal || showMandatoryBankModal) {
//             document.body.style.overflow = 'hidden';
//             document.documentElement.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         }
//         return () => {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         };
//     }, [showMandatoryProfileModal, showMandatoryBankModal]);

//     const handleSaveMandatoryProfile = async (e) => {
//         e.preventDefault();
//         setMandatoryError('');

//         const { phone, dob, city, address, local_address, country } = mandatoryFormData;

//         if (missingProfileFields.phone && (!phone || !phone.trim())) {
//             setMandatoryError('Please enter your Mobile Number.');
//             return;
//         }
//         if (missingProfileFields.dob && (!dob || !dob.trim() || dob === '0000-00-00')) {
//             setMandatoryError('Please select your Date of Birth.');
//             return;
//         }
//         if (missingProfileFields.city && (!city || !city.trim())) {
//             setMandatoryError('Please enter your City.');
//             return;
//         }
//         if (missingProfileFields.country && (!country || !country.trim())) {
//             setMandatoryError('Please enter your Country.');
//             return;
//         }
//         if (missingProfileFields.address && (!address || !address.trim())) {
//             setMandatoryError('Please enter your Permanent Address.');
//             return;
//         }
//         if (missingProfileFields.local_address && (!local_address || !local_address.trim())) {
//             setMandatoryError('Please enter your Current / Local Address.');
//             return;
//         }

//         setMandatorySaving(true);
//         try {
//             const payload = {
//                 id: userData.id,
//                 EmpId: userData.EmpId,
//                 Phonenumber: (phone || userData.phone || '').trim(),
//                 Dob: (dob || userData.dob || '').trim(),
//                 City: (city || userData.city || '').trim(),
//                 Address: (address || userData.address || '').trim(),
//                 LocalAddress: (local_address || userData.local_address || '').trim(),
//                 Country: (country || userData.country || '').trim(),
//                 Gender: userData.gender || '',
//                 ProfilePicture: userData.profileImage || null
//             };

//             const res = await fetch("/gt-api/update_profile.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 const updatedUser = {
//                     ...userData,
//                     phone: phone.trim(),
//                     dob: dob.trim(),
//                     city: city.trim(),
//                     address: address.trim(),
//                     local_address: local_address.trim(),
//                     country: country.trim()
//                 };
//                 setUserData(updatedUser);
//                 localStorage.setItem("userData", JSON.stringify(updatedUser));
//                 setMandatorySuccessMsg("🎉 Profile information updated! You may now use the system.");
//                 setTimeout(() => {
//                     setShowMandatoryProfileModal(false);
//                     setMandatorySuccessMsg('');
//                 }, 1200);
//             } else {
//                 setMandatoryError(result.message || "Failed to update profile. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory profile update error:", err);
//             setMandatoryError("Connection error. Ensure backend API is running.");
//         } finally {
//             setMandatorySaving(false);
//         }
//     };

//     const handleSaveMandatoryBankDetails = async (e) => {
//         e.preventDefault();
//         setBankError('');

//         const { bankName, holderName, accNumber, ifsc, branch, accType } = bankFormData;

//         if (missingBankFields.bankName && (!bankName || !bankName.trim())) {
//             setBankError('Please enter Bank Name.');
//             return;
//         }
//         if (missingBankFields.holderName && (!holderName || !holderName.trim())) {
//             setBankError('Please enter Account Holder Name.');
//             return;
//         }
//         if (missingBankFields.accNumber && (!accNumber || !accNumber.trim())) {
//             setBankError('Please enter Bank Account Number.');
//             return;
//         }
//         if (missingBankFields.ifsc && (!ifsc || !ifsc.trim())) {
//             setBankError('Please enter IFSC Code.');
//             return;
//         }
//         if (missingBankFields.branch && (!branch || !branch.trim())) {
//             setBankError('Please enter Branch Name.');
//             return;
//         }
//         if (missingBankFields.accType && (!accType || !accType.trim())) {
//             setBankError('Please select Account Type.');
//             return;
//         }

//         setBankSaving(true);
//         try {
//             const payload = {
//                 emp_id: userData.id || userData.employeeId || userData.EmpId,
//                 emp_number: userData.EmpId || userData.employeeId,
//                 bankName: bankName.trim(),
//                 bank_name: bankName.trim(),
//                 holderName: holderName.trim(),
//                 account_holder_name: holderName.trim(),
//                 accNumber: accNumber.trim(),
//                 account_number: accNumber.trim(),
//                 ifsc: ifsc.trim(),
//                 ifsc_code: ifsc.trim(),
//                 branch: branch.trim(),
//                 branch_name: branch.trim(),
//                 accType: accType.trim(),
//                 account_type: accType.trim()
//             };

//             const res = await fetch("/gt-api/save_bank_details.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 setBankSuccessMsg("🎉 Bank details updated successfully!");
//                 setTimeout(() => {
//                     setShowMandatoryBankModal(false);
//                     setBankSuccessMsg('');
//                 }, 1200);
//             } else {
//                 setBankError(result.message || "Failed to save bank details. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory bank details update error:", err);
//             setBankError("Connection error. Ensure backend API is running.");
//         } finally {
//             setBankSaving(false);
//         }
//     };




//     // const employeeId = userData.id || userData.employeeId;

//     const toggleSubMenu = (menu) => {
//         setOpenMenus(prev => ({ ...prev, [menu]: !prev[menu] }));
//     };

//     useEffect(() => {
//         const checkNotifications = () => {
//             if (role !== 'Management' && userData?.employeeId) {
//                 fetch(`/gt-api/clear_notifications.php?employee_id=${userData.employeeId}`)
//                     .then(res => res.json())
//                     .then(data => {
//                         if (data.success) setNotifCount(data.count);
//                     })
//                     .catch(err => console.error("Notif Fetch Error:", err));
//             }
//         };
//         checkNotifications();
//         const interval = setInterval(checkNotifications, 30000);
//         return () => clearInterval(interval);
//     }, [userData.employeeId, role]);

//     useEffect(() => {
//         if (role === 'Management' || role === 'Manager') {
//             const fetchRealTimeLeaves = async () => {
//                 try {
//                     // Determine which API to call based on Role
//                     // Managers should call the specific manager-leaves API using their ID
//                     const url = role === 'Management'
//                         ? "/gt-api/get_all_leaves.php"
//                         : `/gt-api/get_manager_leaves.php?managerId=${userData.id || location.state?.empId}`;

//                     // const res = await fetch(url);
//                     const res = await fetch(url, {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {

//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };

//             // Only fetch if we have the ID for the Manager, or if role is Management
//             if (role === 'Management' || (role === 'Manager' && (userData.id || location.state?.empId))) {
//                 fetchRealTimeLeaves();
//                 const liveInterval = setInterval(fetchRealTimeLeaves, 5000);
//                 return () => clearInterval(liveInterval);
//             }
//         }
//     }, [role, userData.id, location.state?.empId]);

//     const handleStatusUpdate = async (id, newStatus) => {
//         try {
//             const response = await fetch("/gt-api/update_request_status.php", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ id, status: newStatus }),
//             });
//             const data = await response.json();
//             if (data.success) {
//                 setRequestsList(prev => prev.map(req => req.id === id ? { ...req, status: newStatus } : req));
//                 setPendingRequestsCount(prev => Math.max(0, prev - 1));
//                 alert(`Request ${newStatus} successfully!`);
//             }
//         } catch (error) {
//             console.error("Update error:", error);
//         }
//     };

//     ;


//     const sendAIMessage = async () => {
//         if (!chatInput.trim()) return;

//         const userMessage = {
//             sender: "user",
//             text: chatInput
//         };

//         setChatMessages(prev => [...prev, userMessage]);
//         setChatLoading(true);

//         try {
//             const res = await fetch("/gt-api/chatbot.php", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     question: chatInput
//                 })
//             });

//             const data = await res.json();

//             let aiReply = "No response.";

//             if (data.success) {
//                 aiReply = data.reply || "No response.";
//             } else {
//                 aiReply = data.message || "Something went wrong.";
//             }
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: aiReply
//                 }
//             ]);

//         } catch (err) {
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: "Server error."
//                 }
//             ]);
//         }

//         setChatInput("");
//         setChatLoading(false);
//     };
//     const handleModuleChange = (slug, extraData = null) => {
//         navigate(`/dashboard/${role}/${slug}`, {
//             state:
//                 extraData && typeof extraData === "object"
//                     ? extraData
//                     : { selectedPathway: extraData }
//         });
//     };

//     const handlePasswordSubmit = (e) => {
//         e.preventDefault();
//         if (passwordForm.newPassword !== passwordForm.confirmPassword) {
//             alert("New passwords do not match!");
//             return;
//         }
//         alert("Encryption Key Updated Successfully!");
//         setShowPasswordModal(false);
//     };

//     const handleSave = () => {
//         setIsEditing(false);
//         alert("Profile changes synchronized!");
//     };

//     // Ensure only ONE instance of this exists in your file
//     const [theme, setTheme] = useState(localStorage.getItem('dashboard-theme') || 'dark');

//     useEffect(() => {
//         document.documentElement.setAttribute('data-theme', theme);
//         localStorage.setItem('dashboard-theme', theme);
//     }, [theme]);

//     const toggleTheme = () => {
//         setTheme(prev => prev === 'dark' ? 'light' : 'dark');
//     };
//     useEffect(() => {

//         const handlePageShow = (event) => {
//             if (event.persisted) {
//                 const user = localStorage.getItem("userData");
//                 if (!user) {
//                     window.location.replace("/");
//                 }
//             }
//         };

//         window.addEventListener("pageshow", handlePageShow);

//         return () => window.removeEventListener("pageshow", handlePageShow);

//     }, []);
//     useEffect(() => {
//         if (role === 'Management') {
//             const fetchEquipmentCount = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_equip_request.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();
//                     if (data.success && data.requests) {
//                         const count = data.requests.filter(r => r.status?.toLowerCase() === 'pending').length;
//                         setPendingRequestsCount(count);
//                         setRequestsList(data.requests);
//                     }
//                 } catch (err) {
//                     console.error("Equipment Fetch Error:", err);
//                 }
//             };

//             fetchEquipmentCount();
//             const interval = setInterval(fetchEquipmentCount, 10000);
//             return () => clearInterval(interval);
//         }
//     }, [role]);




//     const [payData, setPayData] = useState([]);

//     useEffect(() => {

//         // 🔥 MANAGEMENT DASHBOARD
//         if (role === "Management") {

//             const fetchAllDocs = () => {
//                 fetch("/gt-api/get_all_salary_documents.php", {
//                     credentials: "include"
//                 })
//                     .then(res => res.json())
//                     .then(data => {
//                         console.log("MGMT DATA:", data);

//                         if (data.success) {

//                             setPayData(data.documents);
//                         }
//                     })
//                     .catch(err => console.error("Management Fetch Error:", err));
//             };

//             fetchAllDocs();

//             const interval = setInterval(fetchAllDocs, 5000);

//             return () => clearInterval(interval);
//         }

//         // 👤 EMPLOYEE DASHBOARD
//         if (employeeId) {
//             fetch(`/gt-api/get_my_documents.php?emp_id=${employeeId}`, {
//                 credentials: "include"
//             })
//                 .then(res => res.json())
//                 .then(data => {
//                     console.log("EMP DATA:", data);

//                     if (data.success) {
//                         setPayData(data.documents);
//                     }
//                 })
//                 .catch(err => console.error("Employee Fetch Error:", err));
//         }

//     }, [role, employeeId]);





//     const renderPayChart = () => {
//         const safePayData = payData || [];

//         const payslips = safePayData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = safePayData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = safePayData.filter(d => d.doc_type === "APPRAISAL LETTER").length;
//         const totalDocs = payslips + form16 + appraisal;

//         return (
//             <div className="pay-ultra-card" onClick={() => handleModuleChange("pay and benefits")}>
//                 <div className="card-inner">
//                     {/* Top Section */}
//                     <div className="pay-header">
//                         <div className="pay-icon-wrapper">
//                             <div className="pay-icon-glow"></div>
//                             <span className="main-icon">📄</span>
//                         </div>
//                         <div className="pay-total-info">
//                             <h3>Pay & Benefits</h3>
//                             <p>{totalDocs} Total Documents</p>
//                         </div>
//                     </div>

//                     {/* Distribution */}
//                     <div className="distribution-container">
//                         <div className="distribution-label">
//                             <span>Vault Composition</span>
//                             <span className="percentage">
//                                 {totalDocs > 0 ? "100%" : "0%"}
//                             </span>
//                         </div>

//                         <div className="multi-progress-bar">
//                             {totalDocs > 0 ? (
//                                 <>
//                                     <div
//                                         className="segment green"
//                                         style={{ flex: payslips, backgroundColor: '#22c55e' }}
//                                     ></div>
//                                     <div
//                                         className="segment blue"
//                                         style={{ flex: form16, backgroundColor: '#3b82f6' }}
//                                     ></div>
//                                     <div
//                                         className="segment amber"
//                                         style={{ flex: appraisal, backgroundColor: '#f59e0b' }}
//                                     ></div>
//                                 </>
//                             ) : (
//                                 <div
//                                     style={{
//                                         width: "100%",
//                                         height: "100%",
//                                         backgroundColor: "#e5e7eb",
//                                         borderRadius: "10px"
//                                     }}
//                                 ></div>
//                             )}
//                         </div>
//                     </div>

//                     {/* List */}
//                     <div className="pay-list">
//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator green"></span>
//                                 <span className="name">Monthly Payslips</span>
//                             </div>
//                             <span className="count-badge">{payslips}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator blue"></span>
//                                 <span className="name">Tax Form 16</span>
//                             </div>
//                             <span className="count-badge">{form16}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator amber"></span>
//                                 <span className="name">Appraisal Letter</span>
//                             </div>
//                             <span className="count-badge">{appraisal}</span>
//                         </div>
//                     </div>

//                     <div className="pay-footer">
//                         <span>Explore Document</span>
//                         <span className="arrow-icon">→</span>
//                     </div>

//                     <div className="reimburse-cta-wrapper">
//                         <button
//                             className="reimburse-btn"
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleModuleChange("supplies");
//                             }}
//                         >
//                             Click here for Reimbursement Form
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };



//     const renderLeavePieChart = () => {
//         const PUBLIC_HOLIDAYS = [
//             '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//             '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//         ];

//         const isWorkDay = (date) => {
//             const day = date.getDay();
//             const dateString = date.toISOString().split('T')[0];
//             return !(day === 0 || day === 6) && !PUBLIC_HOLIDAYS.includes(dateString);
//         };

//         if (!leaveData || !leaveData.leaveBalances) return null;

//         const sickUsed = leaveData.leaveBalances.sick.used || 0;
//         const earnedUsed = leaveData.leaveBalances.earned.used || 0;
//         const wfhCount = leaveData.wfhHistory.reduce((total, wfh) => {
//             const start = new Date(wfh.start);
//             const end = new Date(wfh.end);
//             let days = 0;
//             let current = new Date(start);
//             while (current <= end) {
//                 if (isWorkDay(current)) days++;
//                 current.setDate(current.getDate() + 1);
//             }
//             return total + days;
//         }, 0);

//         const totalUsed = sickUsed + earnedUsed;

//         // Determine max for scaling bars (minimum scale of 10)
//         const maxVal = Math.max(sickUsed, earnedUsed, wfhCount, 10);
//         return (

//             <div
//                 className={`elite-podium-card leave-analytics-card ${theme === 'dark' ? 'dark-variant' : 'light-theme'}`}
//                 onClick={() => handleModuleChange("attendance")}
//             >

//                 <div className="card-header-v3">
//                     <div className="title-group">

//                         <h2 className="main-title">Leave Overview</h2>
//                     </div>
//                     <div className="year-tag">2026</div>
//                 </div>

//                 <div className="podium-content">
//                     {/* VERTICAL BAR SECTION - Made prominent */}
//                     <div className="bar-podium-large">
//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill sick" style={{ height: `${(sickUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">SICK</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill earned" style={{ height: `${(earnedUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">EARNED</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill wfh" style={{ height: `${(wfhCount / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">WFH</span>
//                         </div>
//                     </div>

//                     {/* KPI SIDEBAR - Cleaned up to match image 1's style */}
//                     <div className="kpi-sidebar-compact">
//                         <div className="total-display">
//                             <span className="total-val">{totalUsed}</span>
//                             <span className="total-sub">Days Off-Site</span>
//                         </div>

//                         <div className="status-legend">
//                             <div className="legend-row">
//                                 <span className="indicator sick"></span>
//                                 <span>{sickUsed} Sick</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator earned"></span>
//                                 <span>{earnedUsed} Earned</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator wfh"></span>
//                                 <span>{wfhCount} WFH</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="card-footer-v3">
//                     <div className="sync-info">
//                         <span className="status-glow"></span>
//                         Annual Summary Active
//                     </div>
//                     <button className="details-btn">VIEW DETAILS →</button>
//                 </div>
//             </div>
//         );
//     };

//     const [leaveData, setLeaveData] = useState({
//         leaveHistory: [],
//         leaveBalances: {
//             sick: { used: 0, total: 0 },
//             earned: { used: 0, total: 0 }
//         },
//         wfhHistory: []
//     });


//     const [managementNotices, setManagementNotices] = useState({
//         reviews: [],
//         probations: []
//     });

//     useEffect(() => {
//         const fetchNotices = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/get_manager_feedback.php?empId=${userData.EmpId}`
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     setManagementNotices({
//                         reviews: data.reviews || [],
//                         probations: data.probations || []
//                     });
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchNotices();
//     }, [userData]);





//     const renderEquipmentCard = () => {
//         const { total, approved, rejected, pending } = equipmentData;

//         return (
//             <div className="equipment-ultra-card clickable" onClick={() => handleModuleChange("equipment-request")}>
//                 <div className="equip-header">
//                     <div className="equip-icon-box">💻</div>
//                     <div className="equip-title-group">
//                         <span className="equip-label">Hardware</span>
//                         <h3 className="equip-title">Requests</h3>
//                     </div>
//                 </div>

//                 <div className="equip-main-stat">
//                     <span className="total-count">{total}</span>
//                     <span className="total-label">Submissions</span>
//                 </div>

//                 <div className="equip-progress-bar">
//                     <div className="bar-fill approved" style={{ width: `${(approved / total) * 100}%` }}></div>
//                     <div className="bar-fill pending" style={{ width: `${(pending / total) * 100}%` }}></div>
//                 </div>

//                 <div className="equip-stats-list">
//                     <div className="equip-item">
//                         <span className="dot approved"></span>
//                         <span className="item-name">Approved</span>
//                         <span className="item-val">{approved}</span>
//                     </div>
//                     <div className="equip-item">
//                         <span className="dot pending"></span>
//                         <span className="item-name">Pending</span>
//                         <span className="item-val text-warning">{pending}</span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     useEffect(() => {
//         const empIdForFetch = userData?.EmpId || userData?.employeeId;

//         if (!empIdForFetch) return;

//         fetch(`/gt-api/get_all_equip_request.php?employee_id=${empIdForFetch}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log("EQUIPMENT API RESPONSE:", data);
//                 if (data.success && data.requests) {

//                     const requests = data.requests;

//                     const approved = requests.filter(r =>
//                         r.status?.toLowerCase() === "approved"
//                     ).length;

//                     const rejected = requests.filter(r =>
//                         r.status?.toLowerCase() === "rejected"
//                     ).length;

//                     const pending = requests.filter(r =>
//                         r.status?.toLowerCase() === "pending"
//                     ).length;

//                     setEquipmentData({
//                         total: requests.length,
//                         approved,
//                         rejected,
//                         pending
//                     });
//                 }
//             })
//             .catch(err => console.error("Equipment Dashboard Error:", err));
//         console.log("EMP ID:", empIdForFetch);



//     }, [userData?.EmpId, userData?.employeeId]);





//     const [oneOnOneData, setOneOnOneData] = useState({
//         totalMeetings: 0,
//         pendingTasks: 0,
//         completedTasks: 0
//     });

//     useEffect(() => {
//         if (!employeeId) return;

//         fetch(`/gt-api/get_my_meetings.php?emp_id=${employeeId}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.meetings) {

//                     const meetings = data.meetings;

//                     let pending = 0;
//                     let completed = 0;

//                     meetings.forEach(meet => {
//                         const tasks = JSON.parse(meet.action_items || "[]");

//                         tasks.forEach(task => {
//                             if (task.done) completed++;
//                             else pending++;
//                         });
//                     });

//                     setOneOnOneData({
//                         totalMeetings: meetings.length,
//                         pendingTasks: pending,
//                         completedTasks: completed
//                     });
//                 }
//             })
//             .catch(err => console.error("1-1 Fetch Error:", err));

//     }, [employeeId]);



//     const renderOneOnOneCard = () => {
//         const { totalMeetings, pendingTasks, completedTasks } = oneOnOneData;
//         const totalTasks = (pendingTasks + completedTasks) || 1;
//         const progressPercent = Math.min(Math.round((completedTasks / totalTasks) * 100), 100);

//         return (
//             <div className="liquid-card clickable" onClick={() => handleModuleChange("one-on-one")}>
//                 {/* BACKGROUND BLOOM */}
//                 <div className="liquid-bloom"></div>

//                 <div className="liquid-layout">
//                     {/* HERO TILE: THE CORE IDENTITY */}
//                     <div className="liquid-tile-hero">
//                         <div className="hero-header">
//                             {/* <span className="hero-eyebrow">Engagement Console</span> */}
//                             <h2 className="hero-title">1-on-1 Sessions</h2>
//                         </div>
//                         <div className="hero-main-metric">
//                             <span className="hero-val">{totalMeetings}</span>
//                             <span className="hero-label">TOTAL<br />MEETINGS</span>
//                         </div>
//                         {/* FULL WIDTH PROGRESS THREAD */}
//                         <div className="liquid-thread-container">
//                             <div className="liquid-thread-bg">
//                                 <div className="liquid-thread-fill" style={{ width: `${progressPercent}%` }}>
//                                     <div className="liquid-thread-glow-tip"></div>
//                                 </div>
//                             </div>
//                             <div className="liquid-thread-label">
//                                 <span className="label-text">Task Completion</span>
//                                 <span className="label-val">{progressPercent}%</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* DATA TRAY: THE SPECIFIC CHIPS */}
//                     <div className="liquid-tray">
//                         <div className="liquid-chip danger">
//                             <div className="chip-inner">
//                                 <label>Pending Task</label>
//                                 <span className="chip-val">{pendingTasks}</span>
//                             </div>
//                         </div>
//                         <div className="liquid-chip success">
//                             <div className="chip-inner">
//                                 <label>Completed Task</label>
//                                 <span className="chip-val">{completedTasks}</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* INTERACTIVE FOOTER */}
//                 <div className="liquid-footer">
//                     <div className="status-container">
//                         <div className={`status-node-wrapper ${pendingTasks > 0 ? 'is-alert' : 'is-sync'}`}>
//                             <div className="status-node-core"></div>
//                             <div className="status-node-bloom"></div>
//                         </div>
//                         <span className={`status-text ${pendingTasks > 0 ? 'text-alert' : ''}`}>
//                             {pendingTasks > 0 ? 'ACTION ITEMS DETECTED' : 'SYSTEM OPTIMIZED'}
//                         </span>
//                     </div>
//                     <div className="liquid-action">

//                         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
//                     </div>
//                 </div>
//             </div>
//         );
//     };






//     const renderCareerPathwaysCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const pathways = isGenesis

//             ? [

//                 {
//                     id: "01",
//                     name: "FI DESIGN",
//                     color: "rgba(0, 77, 113, 0.9)"
//                 },

//                 {
//                     id: "02",
//                     name: "BIM MODELING",
//                     color: "rgba(0, 120, 172, 0.8)"
//                 },

//                 {
//                     id: "03",
//                     name: "POWER BI",
//                     color: "rgba(0, 162, 237, 0.7)"
//                 }

//             ]

//             : dashboardPathways.map(
//                 (item, index) => ({
//                     id: String(index + 1)
//                         .padStart(2, "0"),

//                     name: item.pathway_title,

//                     color:
//                         "rgba(0, 120, 172, 0.8)"
//                 })
//             );

//         return (

//             <div
//                 className="pathway-card-container"
//                 onClick={() =>
//                     handleModuleChange(
//                         "career pathways"
//                     )
//                 }
//             >

//                 <h2 className="pathway-title">
//                     CAREER PATHWAYS
//                 </h2>

//                 <div className="pathway-stack">

//                     {pathways.map(
//                         (item, index) => (

//                             <div
//                                 key={index}
//                                 className="pathway-step"
//                                 style={{
//                                     '--step-color':
//                                         item.color
//                                 }}
//                                 onClick={(e) => {

//                                     e.stopPropagation();

//                                     handleModuleChange(
//                                         "career pathways",
//                                         item.name
//                                     );

//                                 }}
//                             >

//                                 <span className="step-number">
//                                     {item.id}
//                                 </span>

//                                 <div className="step-content">

//                                     <span className="step-name">
//                                         {item.name}
//                                     </span>

//                                     <div className="step-glow"></div>

//                                 </div>

//                             </div>

//                         )
//                     )}

//                 </div>

//                 <button
//                     className="explore-btn"
//                     onClick={(e) => {

//                         e.stopPropagation();

//                         handleModuleChange(
//                             "career pathways"
//                         );

//                     }}
//                 >
//                     EXPLORE CAREER PATHWAYS
//                 </button>

//             </div>

//         );

//     };


//     const renderPolicyCard = () => {
//         const totalPolicies =
//             policyCount;

//         console.log(
//             "Policy Count:",
//             totalPolicies
//         );

//         const readCount =
//             Object.keys(logs || {}).length;
//         const pending = totalPolicies - readCount;
//         const progress = totalPolicies > 0 ? Math.round((readCount / totalPolicies) * 100) : 0;

//         return (
//             <div className="terminal-policy-card" onClick={() => handleModuleChange("company-policy")}>
//                 {/* Background Decorative Scanline */}
//                 <div className="terminal-scanline"></div>

//                 <div className="terminal-header">
//                     <div className="header-left">
//                         {/* <span className="terminal-tag">PROTOCOL_09</span> */}
//                         <h3 className="terminal-title">Company Policy</h3>
//                     </div>
//                     <div className={`status-indicator ${progress === 100 ? 'secure' : 'breach'}`}>
//                         {progress === 100 ? "SECURE" : "PENDING"}
//                     </div>
//                 </div>

//                 <div className="terminal-content">
//                     {/* Circular Progress using SVG for precision */}
//                     <div className="terminal-visual">
//                         <svg viewBox="0 0 36 36" className="cyber-circle">
//                             <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                             <path
//                                 className="circle-fill"
//                                 strokeDasharray={`${progress}, 100`}
//                                 d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
//                                 style={{ stroke: progress === 100 ? '#22c55e' : '#3b82f6' }}
//                             />
//                         </svg>
//                         <div className="percentage-display">
//                             <span className="pct-num">{progress}</span>
//                             <span className="pct-unit">%</span>
//                         </div>
//                     </div>

//                     {/* Data Readout Section */}
//                     <div className="terminal-stats">
//                         <div className="stat-row">
//                             <span className="label">COMPLETED</span>
//                             <span className="value">{readCount}</span>
//                         </div>
//                         <div className="stat-row">
//                             <span className="label">TOTAL_FILES</span>
//                             <span className="value">{totalPolicies}</span>
//                         </div>
//                         <div className="stat-row urgent">
//                             <span className="label">AWAITING_ACTION</span>
//                             <span className="value">{pending}</span>
//                         </div>
//                     </div>
//                 </div>

//             </div>
//         );
//     };

//     useEffect(() => {
//         const fetchLogs = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/acknowledgepolicy.php?empId=${userData.EmpId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 console.log("API DATA:", data);

//                 // 🔥 FIX: use data.logs (NOT data)
//                 const logsArray = Array.isArray(data?.logs) ? data.logs : [];

//                 const map = logsArray.reduce((acc, curr) => {
//                     if (curr?.policy_title) {
//                         acc[curr.policy_title] = true;
//                     }
//                     return acc;
//                 }, {});

//                 setLogs(map);

//             } catch (err) {
//                 console.error("Policy logs error:", err);
//                 setLogs({});
//             }
//         };

//         fetchLogs();
//     }, [userData]);


//     const [showProfileOptions, setShowProfileOptions] = useState(false);



//     const [showProfileMenu, setShowProfileMenu] = useState(false);
//     const handleEditProfile = () => {
//         setShowProfileMenu(false);
//         navigate(`/dashboard/${role}/my-profile`);
//         setShowProfile(true);
//     };

//     const handleLogout = () => {
//         document.documentElement.removeAttribute('data-theme');
//         localStorage.clear();
//         sessionStorage.clear();
//         navigate("/", { replace: true });
//     };

//     const [currentTime, setCurrentTime] = useState("");

//     useEffect(() => {
//         const updateTime = () => {
//             const now = new Date();
//             setCurrentTime(
//                 now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
//             );
//         };

//         updateTime();
//         const interval = setInterval(updateTime, 1000);

//         return () => clearInterval(interval);
//     }, []);
//     const todayDate = new Date().toLocaleDateString('en-GB', {
//         day: '2-digit',
//         month: 'short'
//     });



//     const employeeModulesList = [
//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "attendance" },

//         { id: 2, name: "Pay and Benefits", icon: "💳", color: "#3b82f6", slug: "pay and benefits" },
//         { id: 3, name: "OKR and Performance Tracker", icon: "🎯", color: "#f59e0b", slug: "okr and performance tracker" },

//         { id: 5, name: "Career Pathways", icon: "🏆", color: "#ec4899", slug: "career pathways" },
//         { id: 6, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },

//         { id: 9, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         { id: 10, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         // { id: 11, name: "Documents", icon: "📂", color: "#f43f5e", slug: "documents" },
//         // { id: 12, name: "Employee Experience Survey - EES", icon: "📝", color: "#8b5cf6", slug: "ees-survey" },   
//         { id: 13, name: "1:1 Meeting", icon: "💬", color: "#00fff2", slug: "one-on-one" },
//         { id: 21, name: "ACM Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//         { id: 7, name: "Expense Reimbursement", icon: "🧾", color: "#10b981", slug: "supplies" },

//     ];

//     const managementModulesList = [

//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "leave-management", badge: pendingLeavesCount },

//         { id: 2, name: "Employee Salary and Benefits", icon: "💳", color: "#3b82f6", slug: "employee-salary-benefits" },

//         { id: 3, name: "Employee OKR'S", icon: "🎯", color: "#f59e0b", slug: "employee-okrs" },

//         { id: 5, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: pendingRequestsCount },

//         { id: 6, name: "Own Finanacials", icon: "💰", color: "#10b981", slug: "pay and benefits" },

//         { id: 8, name: "Career Development", icon: "🏆", color: "#ec4899", slug: "career pathways" },

//         { id: 10, name: "Self OKR Tracker", icon: "🏁", color: "#f59e0b", slug: "okr and performance tracker" },
//         { id: 11, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         { id: 12, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         // { id: 21, name: "Manage Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates", badge: "PUSH" },

//         {
//             id: 21,
//             name: "ACM Updates",
//             icon: "📢",
//             color: "#00fff2",
//             slug: "manage-quarterly-updates",
//             badge: "PUSH"
//         },

//         // {
//         //   id: 15,
//         //   name: "EES Feedback Analytics",
//         //   icon: "📊",
//         //   color: "#00f2ff",
//         //   slug: "ees-analytics",
//         //   badge: "NEW"
//         // },

//         // { id: 14, name: "Skills Development", icon: "📚", color: "#06b6d4", slug: "career" },

//         {
//             id: 16,
//             name: "Medical Reports",
//             icon: "🏥",
//             color: "#f43f5e",
//             slug: "medical-reports",
//             badge: "DOCS"
//         },
//         {
//             id: 17,
//             name: "Policy RnU Status",
//             icon: "📋",
//             color: "#10b981",
//             slug: "policy-logs",
//             badge: "ADMIN"
//         },

//         // { 
//         //   id: 18, 
//         //   name: "Employee Documents", 
//         //   icon: "📂", 
//         //   color: "#f43f5e", 
//         //   slug: "manage-documents", 
//         //   badge: "VIEW" 
//         // },

//         {
//             id: 19,
//             name: "1:1 Connect",
//             icon: "🤝",
//             color: "#00fff2",
//             slug: "manager-one-on-one",

//             badge: "LIVE"
//         },

//         { id: 20, name: "Events and Celebrations", icon: "🎉", color: "#3b82f6", slug: "events-celebrations" },

//         {
//             id: 22,
//             name: "Expense Reimbursements",
//             icon: "💰",
//             color: "#22c55e",
//             slug: "reimbursements",
//             badge: "NEW"
//         },

//         // {
//         //     id: 23,
//         //     name: "WFH Requests",
//         //     icon: "🏠",
//         //     color: "#3b82f6",
//         //     slug: "manage-wfh-requests",
//         //     badge: "WFH"
//         // },


//     ];

//     const renderActiveModule = () => {

//         switch (activeModule) {

//             case "attendance-tracker":
//                 return <AttendanceTracker />;

//             case "CompanySetup":
//                 return <CompanySetup />;

//             case "create-invoice":
//                 return <InvoiceGenerator />;

//             case "my-profile":
//                 return (
//                     <MyProfile
//                         userData={userData}
//                         setUserData={setUserData}
//                         isEditing={isEditing}
//                         setIsEditing={setIsEditing}
//                         handleSave={handleSave}
//                         setShowPasswordModal={setShowPasswordModal}
//                     />
//                 );


//             case "reimbursements":
//                 if (role === "Management" || role === "Manager") {
//                     return <ReimbursementManagement />;
//                 }
//                 return <OfficeRequisition userData={userData} />;

//             case "manage-wfh-requests":
//                 return <WFHManagement />;


//             case "work-from-home":
//                 return <WorkFromHome />;


//             case "quarterly-updates":

//                 return <QuarterlyUpdates />;

//             case "manage-quarterly-updates":

//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementQuarterlyUpdate userData={userData} />;
//                 }
//                 return <QuarterlyUpdates />;


//             case "leave-management":
//                 // Unified behavior for Management and Manager
//                 if (role === 'Management' || role === 'Manager') {
//                     return <LeaveManagement userData={userData} />;
//                 }


//                 return <Attendance employeeId={employeeId} userData={userData} />;

//             case "manage-documents":
//                 if (role === 'Management') {
//                     return <ManageEmployeeDocs />;
//                 }
//                 return <Documents userData={userData} />;



//             // case "attendance":
//             //     if (role === 'Management') return <Attendance />;
//             //     return (
//             //         <Attendance
//             //             employeeId={userData.id}
//             //             empBadgeId={userData.EmpId}
//             //             userData={userData}
//             //         />
//             //     );
//             case "attendance":

//                 if (role === 'Management') {

//                     return (
//                         <Attendance
//                             employeeId={userData.id}
//                             empBadgeId={userData.EmpId}
//                             userData={userData}
//                         />
//                     );

//                 }

//                 return (
//                     <Attendance
//                         employeeId={userData.id}
//                         empBadgeId={userData.EmpId}
//                         userData={userData}
//                     />
//                 );


//             case "policy-logs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <PolicyAdminDashboard />;
//                 }

//                 return (
//                     <CompanyPolicy
//                         employeeId={userData.id}
//                         userData={userData}
//                     />
//                 );

//             case "events-celebrations":
//                 return <EventsCelebrations userData={userData} />;

//             case "pay and benefits": return <PayBenefits userData={userData} employeeId={employeeId} />;

//             // case "okr and performance tracker":
//             //     return <OKRTracker userData={userData} />;

//             case "okr and performance tracker":
//                 return (
//                     <OKRTracker
//                         userData={userData}
//                         defaultTab={location.state?.tab}
//                     />
//                 );

//             // Inside Dashboard.js -> renderActiveModule
//             // case "employee-okrs":
//             //     if (role === 'Management' || role === 'Manager') {
//             //         return (
//             //             <ManagementOKRViewer
//             //                 managerId={userData.id}
//             //                 userRole={role}
//             //                 // This is the CRITICAL line:
//             //                 managedDept={userData.HOD}
//             //             />
//             //         );
//             //     }
//             //     return <OKRTracker userData={userData} />;

//             case "employee-okrs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementOKRViewer userRole={role} />;
//                 }
//                 return <OKRTracker userData={userData} />;

//             case "career pathways": return <CareerPathways userData={userData} />;
//             case "add-department": return <AddDepartment />;
//             case "manage-department": return <ManageDepartment />;
//             case "add-employee": return <AddEmployee />;
//             case "manage-employee": return <ManageEmployee />;

//             case "employee-salary-benefits":
//                 return <EmployeeSalaryBenefits />;


//             case "equipment-request":
//                 if (role === "Management") {
//                     const pending = requestsList.filter(
//                         (r) => r.status?.toLowerCase() === "pending"
//                     );

//                     const history = requestsList.filter(
//                         (r) => r.status?.toLowerCase() !== "pending"
//                     );

//                     return (
//                         <div
//                             className="management-request-wrapper animate-fade"
//                             style={{ padding: "20px" }}
//                         >
//                             {/* Pending Queue */}
//                             <div
//                                 className="module-glass-card"
//                                 style={{ marginBottom: "30px" }}
//                             >
//                                 <h3 className="cyan-text">
//                                     ACTIVE_PENDING_QUEUE ({pending.length})
//                                 </h3>

//                                 {/* Desktop Table */}
//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>IMPACT</th>
//                                                 <th>ACTION</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {pending.length > 0 ? (
//                                                 pending.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                             >
//                                                                 {req.impact?.toUpperCase()}
//                                                             </span>
//                                                         </td>

//                                                         <td>
//                                                             <div className="equiptable-actions">
//                                                                 <button
//                                                                     className="equiptable-btn equiptable-approve"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Approved"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✔
//                                                                 </button>

//                                                                 <button
//                                                                     className="equiptable-btn equiptable-reject"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Rejected"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✖
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_PENDING_REQUESTS
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 {/* Mobile Cards */}
//                                 <div className="equiptable-mobile">
//                                     {pending.length > 0 ? (
//                                         pending.map((req) => (
//                                             <div
//                                                 className="equiptable-card"
//                                                 key={req.id}
//                                             >
//                                                 <div className="equiptable-row">
//                                                     <span>Employee</span>
//                                                     <strong>
//                                                         {req.employee_name}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Hardware</span>
//                                                     <strong>
//                                                         {req.equipment_type}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Impact</span>

//                                                     <span
//                                                         className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                     >
//                                                         {req.impact?.toUpperCase()}
//                                                     </span>
//                                                 </div>

//                                                 <div className="equiptable-actions">
//                                                     <button
//                                                         className="equiptable-btn equiptable-approve"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Approved"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✔ Approve
//                                                     </button>

//                                                     <button
//                                                         className="equiptable-btn equiptable-reject"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Rejected"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✖ Reject
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         ))
//                                     ) : (
//                                         <div className="equiptable-card">
//                                             NO_PENDING_REQUESTS
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Completed History */}
//                             <div
//                                 className="module-glass-card history-card"
//                                 style={{ opacity: 0.9 }}
//                             >
//                                 <h3
//                                     className="gray-text"
//                                     style={{ color: "#888" }}
//                                 >
//                                     📜 COMPLETED_HISTORY ({history.length})
//                                 </h3>

//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>DATE</th>
//                                                 <th>STATUS</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {history.length > 0 ? (
//                                                 history.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             {new Date(
//                                                                 req.updated_at ||
//                                                                 req.created_at
//                                                             ).toLocaleDateString(
//                                                                 "en-GB"
//                                                             )}
//                                                         </td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-status ${req.status?.toLowerCase()}`}
//                                                             >
//                                                                 {req.status?.toUpperCase()}
//                                                             </span>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_HISTORY_FOUND
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     );
//                 }

//                 return <EquipmentRequest userData={userData} />;

//             case "supplies": return <OfficeRequisition userData={userData} />;
//             // case "it": return <ITSupport userData={userData} />;
//             case "documents": return <Documents userData={userData} />;
//             // case "company-policy": return <CompanyPolicy />;
//             case "company-policy":
//                 return <CompanyPolicy userData={userData} />;
//             case "Organization Chart": return <OrgChart userData={userData} />;
//             // case "campus information": return <CampusInfo />;
//             case "campus information":
//                 return <CampusInfo userData={userData} />;
//             case "ees-survey": return <EESExperience userData={userData} />;

//             case "ees-analytics":
//                 if (role === 'Management' || role === 'Manager') {
//                     // Management sees the list of real data
//                     return <EESFeedbackManagement feedbacks={eesSubmissions} />;
//                 }
//                 // Employee sees the form
//                 return <EESExperience userData={userData} onFinalSubmit={handleEESSubmit} />;

//             //       case "one-on-one":
//             // return <OneOnOne userData={userData} role={role} />;

//             case "one-on-one":
//                 // This is the PERSONAL view (Employee mode)
//                 return <OneOnOne userData={userData} role="Employee" viewMode="personal" />;

//             case "manager-one-on-one":
//                 // This is the MANAGERIAL view (Manager/Management mode)
//                 return <OneOnOne userData={userData} role={role} viewMode="managerial" />;

//             case "one-on-one-report":
//                 return <OneOnOneReport userData={userData} role={role} handleModuleChange={handleModuleChange} />;

//             // Inside Dashboard.js renderActiveModule
//             case "medical-reports":
//                 if (role === 'Management') return <MedicalReports />;
//                 if (role === 'Manager') {
//                     return (
//                         <ManagerMedicalReports
//                             managerId={userData.id}           // Database Primary Key
//                             managerBadgeId={userData.EmpId}   // Company ID (HOD flag often matches this)
//                             managerDept={userData.Department} // The string "Software Development"
//                         />
//                     );
//                 }

//             case "employee-it-support":
//                 return <EquipmentRequest userData={userData} />;

//             default:


//                 if (role === 'Manager') {
//                     return renderManagerDashboard();
//                 }

//                 const currentList = role === 'Management' ? managementModulesList : employeeModulesList;
//                 return (
//                     <section className="bento-grid">
//                         {currentList.map((mod) => (
//                             <div key={mod.id} className="bento-card glass" style={{ "--accent": mod.color }} onClick={() => handleModuleChange(mod.slug)}>
//                                 <div className="card-top">
//                                     <span className="mod-icon">{mod.icon}</span>
//                                     {mod.badge > 0 && <span className={role === 'Management' ? "card-badge" : "notification-badge-ui"}>{mod.badge}</span>}
//                                 </div>
//                                 <div className="card-info"><h3>{mod.name}</h3><div className="cyber-line"></div></div>
//                             </div>
//                         ))}
//                     </section>
//                 );
//         }
//     };

//     const [companyLogo, setCompanyLogo] = useState("");
//     const currentLogo = theme === 'light' ? logoLight : logoDark;


//     const [leaveStats, setLeaveStats] = useState({
//         pending: 0,
//         approved: 0,
//         rejected: 0,
//         wfhPending: 0
//     });

//     useEffect(() => {
//         if (role !== "Management") return;

//         const fetchLeaveStats = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];


//                     const pending = leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                     const approved = leaves.filter(l => l.Status === '1').length;
//                     const rejected = leaves.filter(l => l.Status === '2').length;

//                     // WFH
//                     const wfhRes = await fetch("/gt-api/get_all_wfh_requests.php", {
//                         credentials: "include"
//                     });
//                     const wfhData = await wfhRes.json();

//                     const wfhPending = wfhData.success
//                         ? wfhData.requests.filter(r => r.status === "Pending").length
//                         : 0;

//                     setLeaveStats({ pending, approved, rejected, wfhPending });
//                 }

//             } catch (err) {
//                 console.error("Leave Stats Error:", err);
//             }
//         };

//         fetchLeaveStats();
//         const interval = setInterval(fetchLeaveStats, 5000);

//         return () => clearInterval(interval);
//     }, [role]);


//     const [mgmtLeaves, setMgmtLeaves] = useState([]);
//     const [mgmtActiveTeam, setMgmtActiveTeam] = useState("All");

//     useEffect(() => {
//         const fetchLeaves = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();
//                 if (data.success) setMgmtLeaves(data.leaves);
//             } catch (err) {
//                 console.error("Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaves();
//     }, []);





//     const mgmtChartData = useMemo(() => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept => dept.DepartmentName
//             );

//         const now = new Date();
//         const currentMonth = (now.getMonth() + 1).toString();
//         const currentYear = now.getFullYear().toString();

//         const teamList = mgmtActiveTeam === "All" ? teams : [mgmtActiveTeam];

//         return teamList.map(team => {

//             const filtered = mgmtLeaves.filter(l => {
//                 const dateParts = l.fromdate?.split("-");
//                 const lYear = dateParts?.[0];
//                 const lMonth = dateParts?.[1]
//                     ? parseInt(dateParts[1]).toString()
//                     : "";

//                 return (
//                     l.Department === team &&
//                     lMonth === currentMonth &&
//                     lYear === currentYear
//                 );
//             });

//             return {
//                 name: team,

//                 // ✅ SUM OF UNITS (FIXED)
//                 Approved: filtered
//                     .filter(l => l.Status === "1")
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

//                 Pending: filtered
//                     .filter(l => l.Status === "0" || l.Status === null)
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
//             };
//         });

//     }, [mgmtLeaves, mgmtActiveTeam]);


//     const renderManagementLeaveCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept =>
//                     dept.DepartmentName
//             );

//         return (
//             <div
//                 className="mgmt-leave-analytics clickable"
//                 onClick={() => handleModuleChange("leave-management")}
//             >

//                 <div className="card-header">
//                     <h3>Employee Leave Analytics</h3>
//                     <span className="sub-text">This Month</span>
//                 </div>

//                 {/* TEAM CHIPS */}
//                 <div className="team-row">
//                     <div
//                         className={`team-chip ${mgmtActiveTeam === "All" ? "active" : ""}`}
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             setMgmtActiveTeam("All");
//                         }}
//                     >
//                         ALL
//                     </div>

//                     {teams.map((team, i) => (
//                         <div
//                             key={i}
//                             className={`team-chip ${mgmtActiveTeam === team ? "active" : ""}`}
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 setMgmtActiveTeam(team);
//                             }}
//                         >
//                             {team}
//                         </div>
//                     ))}
//                 </div>

//                 {/* CHART */}
//                 {(() => {
//                     const isSingle = mgmtActiveTeam !== "All";

//                     return (
//                         <div className={`chart-area ${isSingle ? "single-view" : ""}`}>
//                             <ResponsiveContainer width="100%" height={170}>
//                                 <BarChart
//                                     data={mgmtChartData}
//                                     barCategoryGap={isSingle ? "70%" : "30%"}
//                                     margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
//                                 >

//                                     {/* GRADIENTS */}
//                                     <defs>
//                                         <linearGradient id="approvedGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#34d399" />
//                                             <stop offset="100%" stopColor="#059669" />
//                                         </linearGradient>

//                                         <linearGradient id="pendingGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#fbbf24" />
//                                             <stop offset="100%" stopColor="#f59e0b" />
//                                         </linearGradient>
//                                     </defs>

//                                     <CartesianGrid
//                                         strokeDasharray="3 3"
//                                         stroke="rgba(255,255,255,0.05)"
//                                         vertical={false}
//                                     />

//                                     <XAxis
//                                         dataKey="name"
//                                         tick={{ fill: "#888", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <YAxis
//                                         tick={{ fill: "#666", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <Tooltip
//                                         cursor={{ fill: "rgba(255,255,255,0.05)" }}
//                                         contentStyle={{
//                                             backgroundColor: "rgba(15, 23, 42, 0.95)", // dark glass
//                                             border: "1px solid rgba(0,255,242,0.3)",
//                                             borderRadius: "10px",
//                                             color: "#ffffff",
//                                             backdropFilter: "blur(8px)"
//                                         }}
//                                         labelStyle={{ color: "#00fff2", fontWeight: 600 }}
//                                         itemStyle={{ color: "#ffffff" }}
//                                     />


//                                     <Bar
//                                         dataKey="Approved"
//                                         stackId="a"
//                                         fill="url(#approvedGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                     <Bar
//                                         dataKey="Pending"
//                                         stackId="a"
//                                         fill="url(#pendingGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                 </BarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     );
//                 })()}


//                 <div className="card-footer">
//                     <span>Open Leave Console</span>
//                     <span>→</span>
//                 </div>
//             </div>
//         );
//     };

//     const renderSalaryIntelCard = () => {
//         // 1. Existing Counts
//         const payslips = payData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = payData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = payData.filter(d => d.doc_type === "APPRAISAL LETTER").length;

//         // 2. New Miscellaneous Count (Filtering for the images you provided)
//         const miscDocs = [
//             "FNF LETTER", "OFFER LETTER", "RELIEVING LETTER",
//             "EXPERIENCE LETTER", "EMPLOYEMENT AGREEMENT", "BANK ACCOUNT OPENING"
//         ];
//         const miscellaneous = payData.filter(d => miscDocs.includes(d.doc_type)).length;

//         // 3. Updated Total
//         const total = payslips + form16 + appraisal + miscellaneous;

//         // 4. SVG Math for 4 segments
//         const chartTotal = 125.6;
//         const gap = total > 0 ? 2 : 0;

//         const s1 = (payslips / total) * chartTotal || 0;
//         const s2 = (form16 / total) * chartTotal || 0;
//         const s3 = (appraisal / total) * chartTotal || 0;
//         const s4 = (miscellaneous / total) * chartTotal || 0;

//         return (
//             <div className="sa-card-wrapper" onClick={() => handleModuleChange("employee-salary-benefits")}>


//                 <div className="sa-card-header">
//                     <h3 className="sa-title">Salary Document Insights</h3>
//                     <button className="sa-menu-trigger">⋮</button>
//                 </div>

//                 <div className="sa-main-body">
//                     <div className="sa-gauge-area">
//                         <div className="sa-gauge-container">
//                             <svg viewBox="0 0 100 55" className="sa-gauge-svg">
//                                 {/* Background Track */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="var(--sa-track)" strokeWidth="9" strokeLinecap="round" />

//                                 {/* Segment 4: Misc (Blue) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#0ea5e9" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s4 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2 + s3}`} />

//                                 {/* Segment 3: Appraisals (Orange) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#f97316" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s3 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2}`} />

//                                 {/* Segment 2: Form 16 (Yellow) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#fbbf24" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s2 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1}`} />

//                                 {/* Segment 1: Payslips (Purple) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#8b5cf6" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s1 - gap)} ${chartTotal}`}
//                                     strokeDashoffset="0" />
//                             </svg>

//                             <div className="sa-gauge-text">
//                                 <span className="sa-overall-num">{total}</span>
//                                 <span className="sa-overall-label">Overall</span>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="sa-legend-area">
//                         {[
//                             { label: "Payslips", count: payslips, color: "purple" },
//                             { label: "Form 16", count: form16, color: "yellow" },
//                             { label: "Appraisals", count: appraisal, color: "orange" },
//                             { label: "Miscellaneous", count: miscellaneous, color: "blue" }
//                         ].map((item, index) => (
//                             <div key={index} className="sa-legend-item">
//                                 <div className="sa-item-top">
//                                     <span className={`sa-dot ${item.color}`}></span>
//                                     <span className="sa-item-count">{item.count}</span>
//                                 </div>
//                                 <span className="sa-item-label">{item.label}</span>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <div className="sa-card-footer">
//                     <span className="sa-footer-link">View Detailed Report →</span>
//                 </div>
//             </div>
//         );
//     };



//     const [okrData, setOkrData] = useState([]);
//     useEffect(() => {
//         if (!userData?.id) return;

//         const fetchOKR = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/get_user_okr.php?empId=${userData.id}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     const parsed = typeof data.data === "string"
//                         ? JSON.parse(data.data)
//                         : data.data;

//                     setOkrData(parsed);
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchOKR();

//     }, [userData?.id]);



//     const [okrStats, setOkrStats] = useState({
//         total: 0,
//         completed: 0,
//         pending: 0,
//         progressPercent: 0
//     });



//     const fetchOKRStats = async () => {
//         if (!userData?.EmpId) return;

//         try {
//             const res = await fetch(
//                 `/gt-api/get_okr_stats.php?empId=${userData.EmpId}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setOkrStats(data);
//             }

//         } catch (err) {
//             console.error("OKR STATS ERROR:", err);
//         }
//     };

//     useEffect(() => {
//         if (!userData?.EmpId) return;

//         fetchOKRStats();

//         const handleUpdate = () => fetchOKRStats();

//         window.addEventListener("okrUpdated", handleUpdate);

//         return () => window.removeEventListener("okrUpdated", handleUpdate);

//     }, [userData?.EmpId]);




//     const renderOKRCard = () => {
//         const { total, completed, pending, progressPercent } = okrStats;

//         return (
//             <div
//                 className="expanded-management-card clickable"
//                 onClick={() => handleModuleChange("okr and performance tracker")}
//             >
//                 <div className="okr-card-container">

//                     {/* HEADER */}
//                     <div className="okr-header">
//                         <div>
//                             <span className="eyebrow-text">Performance Tracker</span>
//                             <h2 className="display-title">OKR Progress</h2>
//                         </div>

//                         {/* TOP RIGHT TOTAL */}
//                         <div className="stat-box featured big">
//                             <span className="stat-label">Total KR</span>
//                             <span className="stat-value">{total}</span>
//                         </div>
//                     </div>

//                     {/* STATS ROW */}
//                     <div className="okr-stats-row">
//                         <div className="stat-box danger">
//                             <span className="stat-label">Pending</span>
//                             <span className="stat-value">{pending}</span>
//                         </div>

//                         <div className="stat-box success">
//                             <span className="stat-label">Completed</span>
//                             <span className="stat-value">{completed}</span>
//                         </div>
//                     </div>

//                     {/* PROGRESS FULL WIDTH */}
//                     <div className="progress-section-wide full">
//                         <div className="progress-labels">
//                             <span className="label-muted">Completion</span>
//                             <span className="label-bold">{progressPercent}%</span>
//                         </div>

//                         <div className="wide-bar-bg">
//                             <div
//                                 className="wide-bar-fill"
//                                 style={{ width: `${progressPercent}%` }}
//                             ></div>
//                         </div>
//                     </div>

//                     {/* FOOTER */}
//                     <div className="expanded-footer">
//                         <span className={`status-indicator ${pending > 0 ? 'is-warning' : 'is-clear'}`}>
//                             {pending > 0
//                                 ? `● ${pending} Key Results Pending`
//                                 : '● All Key Results Completed'}
//                         </span>

//                         <span className="interaction-hint">
//                             Open OKR Console →
//                         </span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     const [mgmtOneOnOneData, setMgmtOneOnOneData] = useState([]);
//     useEffect(() => {
//         const fetchMeetings = async () => {
//             const storedUser = localStorage.getItem('userData');
//             const user = JSON.parse(storedUser) || {};

//             const res = await fetch(
//                 `/gt-api/get_oneonone.php?manager_id=${user.id}&role=manager`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.meetings) {
//                 setMgmtOneOnOneData(data.meetings);
//             }
//         };

//         fetchMeetings();
//     }, []);

//     const renderOneOnOneHealthCard = () => {
//         const missedData = mgmtOneOnOneData.filter(m => m.status === "MISSED");

//         const total = mgmtOneOnOneData.length;
//         const missed = mgmtOneOnOneData.filter(m => m.status === "MISSED").length;
//         const completed = total - missed;

//         const rate = total > 0 ? Math.round((completed / total) * 100) : 0;

//         let status = "Healthy";
//         if (rate < 50) status = "Critical ⚠️";
//         else if (rate < 80) status = "Needs Attention";

//         return (
//             <div className="meeting-card" onClick={() => handleModuleChange("manager-one-on-one")}>

//                 <div className="mc-header">
//                     <h3>1:1 Meeting Scheduler</h3>
//                     <span>{status}</span>
//                 </div>

//                 {/* BIG NUMBER */}
//                 <div className="mc-center">
//                     <h1>{rate}%</h1>
//                     <p>Engagement</p>
//                 </div>

//                 {/* BARS */}
//                 <div className="mc-bars">
//                     <div className="bar completed" style={{ width: `${rate}%` }}></div>
//                     <div className="bar missed" style={{ width: `${100 - rate}%` }}></div>
//                 </div>

//                 {/* INFO */}
//                 <div className="mc-info">
//                     <span>✅ {completed} Done</span>
//                     <span>❌ {missed} Missed</span>
//                 </div>
//                 <button
//                     className="view-missed-btn"
//                     onClick={(e) => {
//                         e.stopPropagation();
//                         setShowMissedModal(true);
//                     }}
//                 >
//                     View Missed
//                 </button>

//             </div>
//         );
//     };

//     const [okrActivity, setOkrActivity] = useState([]);
//     useEffect(() => {
//         const fetchOKR = async () => {
//             try {
//                 const storedUser = localStorage.getItem("userData");
//                 const user = JSON.parse(storedUser) || {};

//                 const res = await fetch(
//                     `/gt-api/get_employee_okrs.php?role=${user.role}&managedDept=${user.department}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 if (data.success) {
//                     setOkrActivity(data.data);
//                 }

//             } catch (err) {
//                 console.error("OKR Fetch Error:", err);
//             }
//         };

//         fetchOKR();
//     }, []);

//     const recentOKR = okrActivity
//         .slice(0, 5)
//         .map(item => {
//             let type = "updated";

//             if (item.workflow_status === "Planning") {
//                 type = "new";
//             }

//             if (item.workflow_status === "Manager_Scoring_Review") {
//                 type = "pending";
//             }

//             return {
//                 name: item.emp_name,
//                 quarter: item.quarter,
//                 type,
//                 workflow_status: item.workflow_status   // 🔥 VERY IMPORTANT
//             };
//         });



//     const renderOKRActivityCard = () => {
//         const getStatusConfig = (status) => {
//             switch (status) {
//                 case "Planning": return { color: "#3b82f6", label: "submitted OKR" };
//                 case "Management_Review": return { color: "#f59e0b", label: "sent for Review" };
//                 case "Scoring": return { color: "#8b5cf6", label: "sent for Scoring" };
//                 case "Sign_Off": return { color: "#10b981", label: "finalized OKR" };
//                 default: return { color: "#00bcd4", label: "updated OKR" };
//             }
//         };

//         return (
//             <div className="mgt-okr-card1 timeline-style clickable" onClick={() => handleModuleChange("employee-okrs")}>
//                 <div className="card-header-v2">
//                     <div className="title-section">
//                         <h3>OKR Stream</h3>
//                         <div className="live-dot-wrapper">
//                             <span className="live-dot"></span>
//                             <span className="sub-text">Live updates</span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="okr-activity-timeline">
//                     {recentOKR.length === 0 ? (
//                         <div className="empty-state">No recent activity detected</div>
//                     ) : (
//                         recentOKR.slice(0, 3).map((item, i) => {
//                             const config = getStatusConfig(item.workflow_status);
//                             return (
//                                 <div key={i} className="timeline-item">
//                                     {/* The Vertical Line & Dot */}
//                                     <div className="timeline-visual">
//                                         <div className="timeline-line"></div>
//                                         <div className="timeline-marker" style={{ borderColor: '#111827', background: config.color }}>
//                                             <div className="marker-inner-dot"></div>
//                                         </div>
//                                     </div>

//                                     {/* Single Content Box */}
//                                     <div className="timeline-content-box">
//                                         <div className="content-top">
//                                             <span className="emp-name">{item.name}</span>
//                                             <span className="quarter-tag">{item.quarter}</span>
//                                         </div>
//                                         <p className="status-message">{config.label}</p>
//                                     </div>
//                                 </div>
//                             );
//                         })
//                     )}
//                 </div>

//                 <div className="card-footer-v2">
//                     <span>Access Module</span>
//                     {/* <div className="arrow-circle">→</div> */}
//                 </div>


//             </div>
//         );
//     };

//     const renderManagementShortcutsCard = () => {
//         const shortcuts = [

//             { name: "Create Invoice", icon: "🏦", slug: "create-invoice" },
//             { name: "Policy RnU", icon: "📋", slug: "policy-logs" },
//             { name: "Career Development", icon: "🏆", slug: "career pathways" },
//             { name: "Expense Reimbursement", icon: "💰", slug: "reimbursements" },
//             // { name: "ACM Updates", icon: "📢", slug: "manage-quarterly-updates" },
//             { name: "Self OKR", icon: "🎯", slug: "okr and performance tracker" },
//             { name: "Own Financial", icon: "💳", slug: "pay and benefits" },
//             { name: "Access ACM Info", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//             // { name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },
//             { name: "IT Support", icon: "🖥️", slug: "employee-it-support" },
//             { name: "Attendance Tracker", icon: "📊", slug: "attendance-tracker" },
//             // { name: "Company Setup", icon: "⚙️", slug: "CompanySetup" },





//         ];

//         return (
//             <div className="mgt-shortcut-card">

//                 <div className="card-header">
//                     <h3>Quick Access</h3>
//                     <span className="sub-text">Shortcuts</span>
//                 </div>

//                 <div className="shortcut-grid">
//                     {shortcuts.map((item, i) => (
//                         <div
//                             key={i}
//                             className="shortcut-item"
//                             onClick={() => handleModuleChange(item.slug)}
//                         >
//                             <span className="shortcut-icon">{item.icon}</span>
//                             <span className="shortcut-text">{item.name}</span>
//                         </div>
//                     ))}
//                 </div>

//             </div>
//         );
//     };


//     const renderEmployeeDashboard = () => {
//         return (
//             <div className="dashboard-layout">

//                 <div className="dashboard-row row-top">
//                     {renderLeavePieChart()}
//                     {renderPayChart()}
//                     {renderOneOnOneCard()}



//                     {/* {renderEquipmentCard()} */}
//                 </div>

//                 <div className="dashboard-row row-middle">
//                     {renderOKRCard()}
//                     {renderCareerPathwaysCard()}
//                 </div>

//                 <div className="dashboard-row row-bottom">
//                     {renderPolicyCard()}
//                     <QuarterlyCard handleModuleChange={handleModuleChange} />
//                 </div>

//             </div>
//         );
//     };

//     const renderManagementDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>






//         );
//     };

//     const renderManagerDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>




//         );
//     };

//     const currentEvent =
//         todayEvents && todayEvents.length > 0
//             ? todayEvents[currentEventIndex]
//             : null;


//     const combinedEvents = [];

//     // 🎊 Festival TODAY (Priority if festival is today)
//     if (upcomingFestival && isFestivalToday) {
//         combinedEvents.push({
//             type: "festival",
//             title: upcomingFestival.name,
//             tag: "FESTIVAL TODAY",
//             icon: "🎊",
//             sub: "Today 🎉"
//         });
//     }

//     // 🎂 Birthday / Anniversary
//     if (currentEvent && currentEvent.fullName) {
//         combinedEvents.push({
//             type: "event",
//             title: currentEvent.fullName,
//             tag: currentEvent.isBirthday ? "BIRTHDAY" : "WORK ANNIVERSARY",
//             icon: currentEvent.isBirthday ? "🎂" : "🎉"
//         });
//     }

//     // 🎊 Upcoming Festival (If future)
//     if (upcomingFestival && !isFestivalToday) {
//         combinedEvents.push({
//             type: "festival",
//             title: upcomingFestival.name,
//             tag: "UPCOMING FESTIVAL",
//             icon: "🎊",
//             sub: `In ${daysLeft} days`
//         });
//     }

//     useEffect(() => {
//         if (combinedEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setActiveEventIndex(prev => (prev + 1) % combinedEvents.length);
//         }, 4000);

//         return () => clearInterval(interval);
//     }, [combinedEvents.length]);

//     const activeEvent = combinedEvents[activeEventIndex];


//     return (

//         <div


//             className={`dash-container ${theme}-theme`}
//             style={
//                 theme === 'light'
//                     ? {
//                         backgroundImage: `url(${logoLight})`,
//                         backgroundSize: 'cover',
//                         backgroundRepeat: 'no-repeat',
//                         backgroundPosition: 'center',
//                         backgroundColor: 'var(--bg-main)'

//                     }
//                     : {}
//             }
//         >


//             {showMissedModal && (
//                 <div className="modal-overlay" onClick={() => setShowMissedModal(false)}>
//                     <div className="modal-card" onClick={(e) => e.stopPropagation()}>

//                         <h3>Missed 1:1 Meetings</h3>

//                         {mgmtOneOnOneData.filter(m => m.status === "MISSED").length === 0 ? (
//                             <p>No missed meetings 🎉</p>
//                         ) : (
//                             mgmtOneOnOneData
//                                 .filter(m => m.status === "MISSED")
//                                 .map((m, i) => (
//                                     <div key={i} className="missed-item">
//                                         <strong>{m.employee_name}</strong>
//                                         <span>{m.date}</span>
//                                     </div>
//                                 ))
//                         )}

//                         <button onClick={() => setShowMissedModal(false)}>
//                             Close
//                         </button>

//                     </div>
//                 </div>
//             )}



//             <div className="auth-background-overlay"></div>






//             <Sidebar
//                 role={role}
//                 userData={userData}
//                 activeModule={activeModule}
//                 openMenus={openMenus}
//                 toggleSubMenu={toggleSubMenu}
//                 handleModuleChange={handleModuleChange}
//                 handleLogout={handleLogout}
//                 mobileMenuOpen={mobileMenuOpen}
//                 setMobileMenuOpen={setMobileMenuOpen}
//                 pendingRequestsCount={pendingRequestsCount}
//             />

//             <main className="dash-content">

//                 <header className="content-header">

//                     {/* 🔷 LEFT */}
//                     <div className="header-left">
//                         <div className="header-text">

//                             <h1>
//                                 {activeModule === "grid" && !showProfile ? "Welcome," : ""}{" "}
//                                 <span className={theme === 'light' ? "name-light" : "name-accent"}>
//                                     {showProfile
//                                         ? "MY PROFILE"
//                                         : (activeModule === "grid"
//                                             ? userData.firstName || userData.FirstName
//                                             : (activeModule === "attendance"
//                                                 ? "LEAVE MANAGEMENT"
//                                                 : (activeModule === "one-on-one-report"
//                                                     ? "ONE-ON-ONE REPORT"
//                                                     : activeModule.toUpperCase().replace(/-/g, ' ')
//                                                 )
//                                             )
//                                         )
//                                     }
//                                 </span>
//                             </h1>

//                             {activeModule === 'attendance' && userData.joiningDate && (
//                                 <div className="joining-info">
//                                     JOINING_DATE: {new Date(userData.joiningDate).toLocaleDateString('en-GB').toUpperCase()}
//                                 </div>
//                             )}

//                         </div>
//                     </div>







//                     <div className="header-center">

//                         {/* TIME + DATE FIRST */}
//                         <div className="time-date-right">
//                             <div className="live-time">{currentTime}</div>

//                             <div className="today-widget">
//                                 <span>📅 {todayDate}</span>
//                                 <small>Have a Nice Day!</small>
//                             </div>
//                         </div>

//                         {/* EVENT CARD SECOND */}
//                         <div
//                             className={`executive-event-bar ${theme === 'light' ? 'light-theme-elite' : 'dark-theme-elite'}
//         ${role === "Management" || role === "Manager" ? "clickable" : ""}`}
//                             onClick={() => {
//                                 if (role === "Management" || role === "Manager") {
//                                     handleModuleChange("events-celebrations");
//                                 }
//                             }}
//                         >
//                             <div
//                                 className={`event-status-box ${activeEvent
//                                     ? (activeEvent.type === 'festival'
//                                         ? 'bg-fest'
//                                         : (activeEvent.tag === 'BIRTHDAY' ? 'bg-birth' : 'bg-anniv'))
//                                     : 'bg-neutral'
//                                     }`}
//                             >
//                                 <span className="event-icon-small">
//                                     {activeEvent ? activeEvent.icon : "✨"}
//                                 </span>
//                             </div>

//                             <div className="event-content-main">
//                                 <div className="event-label-row">
//                                     <span className="event-tag">
//                                         {activeEvent ? activeEvent.tag : "TODAY"}
//                                     </span>
//                                 </div>

//                                 <h3 className="event-title-text">

//                                     {activeEvent ? (
//                                         <span className="event-highlight">
//                                             {activeEvent.icon} {activeEvent.title}
//                                         </span>
//                                     ) : (
//                                         <span className="event-empty-text">
//                                             No events today
//                                         </span>
//                                     )}
//                                 </h3>
//                             </div>

//                             <div className="event-action-wrapper">
//                                 <button
//                                     className="minimal-wish-btn"
//                                     disabled={!currentEvent}
//                                     onClick={(e) => e.stopPropagation()}
//                                 >
//                                     <div className="btn-line"></div>
//                                 </button>
//                             </div>
//                         </div>

//                     </div>







//                     <div className="header-controls">

//                         {/* 🌗 THEME */}
//                         <div className="theme-switch-container">
//                             <label className="theme-slider-switch">
//                                 <input
//                                     type="checkbox"
//                                     onChange={toggleTheme}
//                                     checked={theme === 'light'}
//                                 />
//                                 <span className="theme-slider round">
//                                     <span className="sun-icon">☀️</span>
//                                     <span className="moon-icon">🌙</span>
//                                 </span>
//                             </label>
//                         </div>




//                         {(activeModule !== "grid" || showProfile) && (
//                             <button
//                                 className="back-btn"
//                                 onClick={() => handleModuleChange("grid")}
//                             >
//                                 Back
//                             </button>
//                         )}

//                     </div>

//                 </header>


//                 {activeModule === "grid" ? (

//                     role === "Management"
//                         ? renderManagementDashboard()
//                         : role === "Manager"
//                             ? renderManagerDashboard()   // 🔥 ADD THIS LINE
//                             : renderEmployeeDashboard()

//                 ) : (
//                     renderActiveModule()
//                 )}

//                 <div className="dash-footer">
//                     Design & Developed by Genesis Tech Engineers © 2026
//                 </div>
//             </main>

//             {(role === "Management" || role === "Manager") && (
//                 <>
//                     <div
//                         className="ai-chat-float-btn"
//                         onClick={() => setShowAIChat(true)}
//                     >
//                         🤖
//                     </div>

//                     {showAIChat && (
//                         <div className="ai-chat-modal">
//                             <div className="ai-chat-header">
//                                 <span>ELMS AI Assistant</span>
//                                 <button onClick={() => setShowAIChat(false)}>
//                                     ✕
//                                 </button>
//                             </div>

//                             <div className="ai-chat-body">
//                                 {chatMessages.map((msg, index) => (
//                                     <div
//                                         key={index}
//                                         className={`chat-bubble ${msg.sender}`}
//                                     >
//                                         <pre>{msg.text}</pre>
//                                     </div>
//                                 ))}

//                                 {chatLoading && (
//                                     <div className="chat-bubble ai">
//                                         Thinking...
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="ai-chat-footer">
//                                 <input
//                                     type="text"
//                                     value={chatInput}
//                                     onChange={(e) => setChatInput(e.target.value)}
//                                     placeholder="Ask anything..."
//                                     onKeyDown={(e) => {
//                                         if (e.key === "Enter") {
//                                             sendAIMessage();
//                                         }
//                                     }}
//                                 />

//                                 <button onClick={sendAIMessage}>
//                                     Send
//                                 </button>
//                             </div>
//                         </div>
//                     )}
//                 </>
//             )}

//             {/* 🔴 MANDATORY PROFILE POPUP MODAL */}
//             {showMandatoryProfileModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">⚠️</div>
//                             <h2>Mandatory Profile Completion Required</h2>
//                             <p>
//                                 Your employee profile has missing information. Please fill in the required field(s) below to continue using the system.
//                             </p>
//                         </div>

//                         {mandatoryError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {mandatoryError}</span>
//                             </div>
//                         )}

//                         {mandatorySuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {mandatorySuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryProfile} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingProfileFields.phone && (
//                                     <div className="mandatory-input-group">
//                                         <label>Mobile Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="tel"
//                                             placeholder="Enter mobile number"
//                                             value={mandatoryFormData.phone}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, phone: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.dob && (
//                                     <div className="mandatory-input-group">
//                                         <label>Date of Birth <span className="req-star">*</span></label>
//                                         <input
//                                             type="date"
//                                             max={new Date().toISOString().split("T")[0]}
//                                             value={mandatoryFormData.dob}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, dob: e.target.value }))}
//                                             onClick={(e) => {
//                                                 try {
//                                                     if (e.target.showPicker) e.target.showPicker();
//                                                 } catch (err) { }
//                                             }}
//                                             required
//                                             className="mandatory-date-input"
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.city && (
//                                     <div className="mandatory-input-group">
//                                         <label>City <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter city"
//                                             value={mandatoryFormData.city}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, city: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.country && (
//                                     <div className="mandatory-input-group">
//                                         <label>Country <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter country"
//                                             value={mandatoryFormData.country}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, country: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Permanent Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter permanent address"
//                                             value={mandatoryFormData.address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.local_address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Current / Local Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter current / local address"
//                                             value={mandatoryFormData.local_address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, local_address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={mandatorySaving}
//                                 >
//                                     {mandatorySaving ? "Saving Profile..." : "Save Profile & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//             {/* 🏦 MANDATORY BANK DETAILS POPUP MODAL */}
//             {showMandatoryBankModal && !showMandatoryProfileModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">🏦</div>
//                             <h2>Mandatory Bank Details Required</h2>
//                             <p>
//                                 Your employee bank record has missing information. Please fill in the required field(s) below for payroll & salary processing.
//                             </p>
//                         </div>

//                         {bankError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {bankError}</span>
//                             </div>
//                         )}

//                         {bankSuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {bankSuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryBankDetails} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingBankFields.bankName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Bank Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC Bank, ICICI Bank"
//                                             value={bankFormData.bankName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, bankName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.holderName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Holder Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account holder name"
//                                             value={bankFormData.holderName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, holderName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accNumber && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account number"
//                                             value={bankFormData.accNumber}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accNumber: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.ifsc && (
//                                     <div className="mandatory-input-group">
//                                         <label>IFSC Code <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC0001234"
//                                             value={bankFormData.ifsc}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, ifsc: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.branch && (
//                                     <div className="mandatory-input-group">
//                                         <label>Branch Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter branch name"
//                                             value={bankFormData.branch}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, branch: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accType && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Type <span className="req-star">*</span></label>
//                                         <select
//                                             value={bankFormData.accType}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accType: e.target.value }))}
//                                             required
//                                         >
//                                             <option value="Saving Account">Saving Account</option>
//                                             <option value="Current Account">Current Account</option>
//                                             <option value="Salary Account">Salary Account</option>
//                                         </select>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={bankSaving}
//                                 >
//                                     {bankSaving ? "Saving Bank Details..." : "Save Bank Details & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Dashboard;
































// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';

// import {
//     ResponsiveContainer,
//     BarChart,
//     Bar,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip
// } from "recharts";
// import { Bar as ChartBar, Pie, Doughnut } from 'react-chartjs-2';

// // ✅ REACT + ROUTER
// import React, { useState, useEffect, useMemo } from 'react';
// import { useParams, useNavigate, useLocation } from 'react-router-dom';

// // ✅ MODULES
// import Attendance from '../../modules/Attendance';
// import PayBenefits from '../../modules/PayBenefits';
// import OKRTracker from '../../modules/OKRTracker';
// import CareerPathways from '../../modules/CareerPathways';
// import EquipmentRequest from '../../modules/EquipmentRequest';
// import OfficeRequisition from '../../modules/OfficeRequisition';
// import ITSupport from '../../modules/ITSupport';
// import Documents from '../../modules/Documents';
// import CompanyPolicy from '../../modules/CompanyPolicy';
// import OrgChart from '../../modules/OrgChart';
// import CampusInfo from '../../modules/CampusInfo';
// import AddDepartment from '../../modules/AddDepartment';
// import AddEmployee from '../../modules/AddEmployee';
// import ManageDepartment from '../../modules/ManageDepartment';
// import ManageEmployee from '../../modules/ManageEmployee';
// import MyProfile from '../../modules/MyProfile';
// import LeaveManagement from '../../modules/LeaveManagement';
// import EESExperience from '../../modules/EESExperience';
// import EESFeedbackManagement from '../../modules/EESFeedbackManagement';
// import MedicalReports from '../../modules/MedicalReports';
// import ManagementOKRViewer from '../../modules/ManagementOKRViewer';
// import ManagerLeaveManagement from '../../modules/ManagerLeaveManagement';
// import ManagerMedicalReports from '../../modules/ManagerMedicalReports';
// import EmployeeSalaryBenefits from '../../modules/EmployeeSalaryBenefits';
// import PolicyAdminDashboard from '../../modules/PolicyAdminDashboard';
// import ManageEmployeeDocs from '../../modules/ManageEmployeeDocs';
// import OneOnOne from '../../modules/OneOnOne';
// import EventsCelebrations from '../../modules/EventsCelebrations';
// import ProjectModule from '../../modules/ProjectModule';
// import QuarterlyUpdates from '../../modules/QuarterlyUpdates';
// import ManagementQuarterlyUpdate from '../../modules/ManagementQuarterlyUpdate';
// import ReimbursementManagement from '../../modules/ReimbursementManagement';
// import WorkFromHome from '../../modules/WorkFromHome';
// import WFHManagement from '../../modules/WFHManagement';
// import OneOnOneAnalyticsCard from "../../modules/OneOnOneAnalyticsCard";
// import OneOnOneReport from '../../modules/OneOnOneReport';
// import InvoiceGenerator from '../../modules/InvoiceGenerator';
// import AttendanceTracker from '../../modules/AttendanceTracker';
// import CompanySetup from '../../modules/CompanySetup';
// import AwardNominations from '../../modules/AwardNominations';
// import AwardAnalyticsDashboard from '../../modules/AwardAnalyticsDashboard';
// import Sidebar from "../../components/Sidebar/sidebar";

// // ✅ ASSETS
// import logoLight from '../../assets/logowhite-p.png';
// import logoDark from '../../assets/logo-white-r.png';

// // ✅ STYLES
// import './Dashboard.css';


// // ✅ CHART.JS CORE
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip as ChartTooltip,  // ✅ rename this
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// } from 'chart.js';

// // ✅ REGISTER CHART.JS
// ChartJS.register(
//     ArcElement,
//     ChartTooltip, // ✅ use renamed one
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// );



// const QuarterlyCard = ({ handleModuleChange }) => {

//     const [latest, setLatest] = React.useState(null);

//     React.useEffect(() => {
//         fetch(
//             "/gt-api/get_quarterly_media.php?type=ACM Presentation",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "ACM DATA:",
//                     data
//                 );

//                 if (data.success && data.data.length > 0) {
//                     setLatest(data.data[0]);
//                 }
//             })
//             .catch(err => console.error("Quarterly Fetch Error:", err));
//     }, []);

//     console.log("LATEST ACM:", latest);

//     return (
//         <div
//             className="quarterly-pro-card clickable"
//             onClick={() => handleModuleChange("quarterly-updates")}
//         >
//             {/* Glow Layer */}
//             <div className="card-glow"></div>

//             {/* HEADER */}
//             <div className="qp-header">
//                 <div className="qp-left">
//                     <span className="qp-tag">ACM Updates</span>
//                     <h3 className="qp-title">Quarterly Insights</h3>
//                 </div>

//                 <div className="qp-icon">📢</div>
//             </div>

//             {/* BODY */}
//             <div className="qp-body">
//                 {latest ? (
//                     <>
//                         <h4 className="qp-main-title">{latest.title}</h4>

//                         <div className="qp-meta">
//                             <span className="qp-date">
//                                 {new Date(latest.created_at).toLocaleDateString('en-GB')}
//                             </span>
//                             <span className="qp-badge">NEW</span>
//                         </div>
//                     </>
//                 ) : (
//                     <div className="qp-empty">
//                         <div className="qp-loader"></div>
//                         <span>Awaiting next update</span>
//                     </div>
//                 )}
//             </div>

//             {/* FOOTER */}
//             <div className="qp-footer">
//                 <span>View Presentation</span>
//                 <span className="arrow">→</span>
//             </div>
//         </div>
//     );
// };


// const Dashboard = () => {
//     const [dashboardDepartments, setDashboardDepartments] = useState([]);
//     const [dashboardPathways, setDashboardPathways] = useState([]);
//     const [policyCount, setPolicyCount] = useState(0);

//     const [showAIChat, setShowAIChat] = useState(false);

//     const [chatMessages, setChatMessages] = useState([
//         {
//             sender: "ai",
//             text: "Hello 👋 Ask me anything about your ELMS database."
//         }
//     ]);

//     const [chatInput, setChatInput] = useState("");
//     const [chatLoading, setChatLoading] = useState(false);



//     const [showMissedModal, setShowMissedModal] = useState(false);

//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//     const [todayEvents, setTodayEvents] = useState([]);
//     useEffect(() => {
//         const fetchTodayEvents = async () => {
//             try {
//                 const res = await fetch('/gt-api/get_celebrations.php');
//                 const data = await res.json();

//                 if (data.success) {
//                     setTodayEvents(data.data || []);
//                 }
//             } catch (err) {
//                 console.error("Dashboard Events Error:", err);
//             }
//         };

//         fetchTodayEvents();
//     }, []);
//     const [currentEventIndex, setCurrentEventIndex] = useState(0);
//     useEffect(() => {
//         if (!todayEvents || todayEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setCurrentEventIndex((prev) =>
//                 (prev + 1) % todayEvents.length
//             );
//         }, 3000); // change every 3 sec

//         return () => clearInterval(interval);
//     }, [todayEvents]);


//     const [equipmentData, setEquipmentData] = useState({
//         total: 0,
//         pending: 0,
//         blocking: 0
//     });



//     const [logs, setLogs] = useState({});

//     const totalPolicies = 11;
//     const readCount = Object.keys(logs || {}).length;

//     const progress = totalPolicies > 0
//         ? Math.round((readCount / totalPolicies) * 100)
//         : 0;


//     const params = useParams();
//     const module = params.module;

//     const storedUser = JSON.parse(localStorage.getItem("userData"));
//     const role = storedUser?.role;
//     const navigate = useNavigate();

//     useEffect(() => {
//         const storedUser = localStorage.getItem("userData");

//         if (!storedUser) {
//             navigate("/", { replace: true });
//             return;
//         }

//         // prevent back button access after logout
//         window.history.pushState(null, "", window.location.href);
//         window.onpopstate = function () {
//             const user = localStorage.getItem("userData");
//             if (!user) {
//                 navigate("/", { replace: true });
//             }
//         };

//     }, [navigate]);







//     const [policyLogs, setPolicyLogs] = useState({});





//     const checkIfFestivalIsToday = (festival, daysLeftVal, isTodayFlag) => {
//         if (!festival) return false;
//         if (isTodayFlag === true || daysLeftVal === 0) return true;

//         if (festival.date) {
//             const today = new Date();
//             const currentDay = today.getDate();
//             const currentMonth = today.getMonth();
//             const monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
//             const currentMonthName = monthNames[currentMonth];

//             const dateLower = String(festival.date).trim().toLowerCase();

//             // 1. Text Month Matching (e.g., "7th Sep", "7 Sep", "2nd to 10th Oct")
//             if (dateLower.includes(currentMonthName) || (currentMonthName === "sep" && dateLower.includes("sept"))) {
//                 const rangeMatch = dateLower.match(/(\d+)\s*(?:st|nd|rd|th)?\s*to\s*(\d+)\s*(?:st|nd|rd|th)?/);
//                 if (rangeMatch) {
//                     const startDay = parseInt(rangeMatch[1], 10);
//                     const endDay = parseInt(rangeMatch[2], 10);
//                     if (currentDay >= startDay && currentDay <= endDay) {
//                         return true;
//                     }
//                 }

//                 const numbers = dateLower.match(/\d+/g);
//                 if (numbers) {
//                     for (let numStr of numbers) {
//                         const num = parseInt(numStr, 10);
//                         if (num === currentDay) {
//                             return true;
//                         }
//                     }
//                 }
//             }

//             // 2. Numeric Date Matching (e.g., "7-9-2026", "07-09-2026", "7/9/2026", "2026-09-07")
//             const numMatch = dateLower.match(/^(\d{1,4})[-/.](\d{1,2})[-/.](\d{1,4})$/);
//             if (numMatch) {
//                 let p1 = parseInt(numMatch[1], 10);
//                 let p2 = parseInt(numMatch[2], 10);
//                 let p3 = parseInt(numMatch[3], 10);

//                 let d, m;
//                 if (p1 > 31) {
//                     m = p2; d = p3;
//                 } else {
//                     d = p1; m = p2;
//                 }

//                 if (d === currentDay && m === (currentMonth + 1)) {
//                     return true;
//                 }
//             }
//         }

//         if (typeof daysLeftVal === 'number' && daysLeftVal === 0) {
//             return true;
//         }

//         return false;
//     };

//     const [upcomingFestival, setUpcomingFestival] = useState(null);
//     const [daysLeft, setDaysLeft] = useState(null);
//     const [isFestivalToday, setIsFestivalToday] = useState(false);
//     const [activeEventIndex, setActiveEventIndex] = useState(0);
//     useEffect(() => {
//         fetch("/gt-api/get_upcoming_festival.php", {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 const fest = data.festival || data.upcoming || (data.data && data.data[0]);
//                 if (fest) {
//                     const normalized = {
//                         ...fest,
//                         name: fest.name || fest.festival_name || fest.title || "Festival",
//                         image: fest.image || fest.img || fest.imageName || ""
//                     };
//                     setUpcomingFestival(normalized);
//                     setDaysLeft(data.daysLeft ?? 0);
//                     const festIsToday = data.isToday || data.daysLeft === 0 || checkIfFestivalIsToday(normalized, data.daysLeft, data.isToday);
//                     setIsFestivalToday(festIsToday);
//                 }
//             })
//             .catch(err => console.error(err));
//     }, []);


//     const location = useLocation();



//     const [showProfile, setShowProfile] = useState(false);
//     const [showPasswordModal, setShowPasswordModal] = useState(false);
//     const [isEditing, setIsEditing] = useState(false);

//     const [activeModule, setActiveModule] = useState(module || "grid");
//     const [isLightMode, setIsLightMode] = useState(false);

//     const [openMenus, setOpenMenus] = useState({
//         department: false,
//         employee: false
//     });

//     const [pendingRequestsCount, setPendingRequestsCount] = useState(0);
//     const [pendingLeavesCount, setPendingLeavesCount] = useState(0);
//     const [requestsList, setRequestsList] = useState([]);
//     const [notifCount, setNotifCount] = useState(0);

//     const [eesSubmissions, setEesSubmissions] = useState([]);
//     const handleEESSubmit = (newFeedback) => {
//         setEesSubmissions(prev => [...prev, newFeedback]);
//     };

//     const [passwordForm, setPasswordForm] = useState({
//         currentPassword: '',
//         newPassword: '',
//         confirmPassword: ''
//     });

//     const [showMandatoryProfileModal, setShowMandatoryProfileModal] = useState(false);
//     const [missingProfileFields, setMissingProfileFields] = useState({
//         phone: false,
//         dob: false,
//         city: false,
//         address: false,
//         local_address: false,
//         country: false
//     });
//     const [mandatoryFormData, setMandatoryFormData] = useState({
//         phone: '',
//         dob: '',
//         city: '',
//         address: '',
//         local_address: '',
//         country: ''
//     });
//     const [mandatorySaving, setMandatorySaving] = useState(false);
//     const [mandatoryError, setMandatoryError] = useState('');
//     const [mandatorySuccessMsg, setMandatorySuccessMsg] = useState('');

//     // 🔴 MANDATORY BANK DETAILS MODAL STATE
//     const [showMandatoryBankModal, setShowMandatoryBankModal] = useState(false);
//     const [missingBankFields, setMissingBankFields] = useState({
//         bankName: false,
//         holderName: false,
//         accNumber: false,
//         ifsc: false,
//         branch: false,
//         accType: false
//     });
//     const [bankFormData, setBankFormData] = useState({
//         bankName: '',
//         holderName: '',
//         accNumber: '',
//         ifsc: '',
//         branch: '',
//         accType: 'Saving Account'
//     });
//     const [bankSaving, setBankSaving] = useState(false);
//     const [bankError, setBankError] = useState('');
//     const [bankSuccessMsg, setBankSuccessMsg] = useState('');




//     const [userData, setUserData] = useState(() => {
//         const storedData = localStorage.getItem("userData");
//         if (storedData) return JSON.parse(storedData);

//         const firstName = location.state?.userName?.split(' ')[0] || "User";
//         const lastName = location.state?.userName?.split(' ')[1] || "";

//         return {
//             firstName,
//             lastName,
//             email: "",
//             dept: "Loading...",
//             phone: "",
//             gender: "",
//             dob: "",
//             address: "",
//             city: "",
//             country: "",
//             employeeId: location.state?.empId || null,
//             profileImage: null,
//             joiningDate: null,
//             HOD: null
//         };
//     });


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_career_pathways.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setDashboardPathways(
//                         data.pathways || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_departments.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "DASHBOARD DEPARTMENTS:",
//                     data
//                 );

//                 if (data.success) {

//                     setDashboardDepartments(
//                         data.departments || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) {

//             setPolicyCount(11);
//             return;

//         }

//         fetch(
//             "/gt-api/get_policies.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setPolicyCount(
//                         data.policies?.length || 0
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);
//     // ✅ THEN use it
//     const employeeId = userData?.id || userData?.employeeId;


//     useEffect(() => {
//         const fetchLeaveDashboardData = async () => {
//             if (!employeeId) return;

//             try {
//                 const res = await fetch(`/gt-api/get_leaves.php?empid=${employeeId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 const wfhRes = await fetch(`/gt-api/get_wfh.php?empid=${employeeId}`, {
//                     credentials: "include"
//                 });
//                 const wfhData = await wfhRes.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];

//                     // 🔥 SAME LOGIC AS ATTENDANCE
//                     const today = new Date();
//                     const currentYear = today.getFullYear();

//                     const fiscalYearStart = new Date(currentYear, 3, 1);

//                     const activeFiscalYearStart =
//                         today < fiscalYearStart
//                             ? new Date(currentYear - 1, 3, 1)
//                             : fiscalYearStart;

//                     // ✅ Dynamic Sick Total (joining based)
//                     let sickTotal = 12;

//                     if (userData?.joiningDate) {
//                         const joining = new Date(userData.joiningDate);

//                         const fyEnd = new Date(activeFiscalYearStart);
//                         fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
//                         fyEnd.setMonth(2);
//                         fyEnd.setDate(31);

//                         if (joining > activeFiscalYearStart) {
//                             if (joining > fyEnd) {
//                                 sickTotal = 0;
//                             } else {
//                                 const joinMonth = joining.getMonth();
//                                 const fyEndMonth = 2;

//                                 let monthsRemaining;

//                                 if (joinMonth <= fyEndMonth) {
//                                     monthsRemaining = fyEndMonth - joinMonth + 1;
//                                 } else {
//                                     monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
//                                 }

//                                 sickTotal = monthsRemaining;
//                             }
//                         }
//                     }

//                     let sickUsed = 0;
//                     let earnedUsed = 0;

//                     leaves.forEach(leave => {
//                         const status = String(leave.Status);
//                         const days = parseFloat(leave.total) || 0;
//                         const leaveDate = new Date(leave.fromdate);
//                         const medStatus = String(leave.medical_doc_status);

//                         // ✅ SAME CONDITION AS ATTENDANCE
//                         if (status === '0' || status === '1') {

//                             if (leave.leavetype === 'Sick Leave') {
//                                 if (leaveDate >= activeFiscalYearStart) {
//                                     sickUsed += days;
//                                 }
//                             }

//                             else if (leave.leavetype === 'Earned Leave') {

//                                 // 🔥 MEDICAL CONVERSION LOGIC
//                                 if (medStatus === '1' || medStatus === '0') {
//                                     if (leaveDate >= activeFiscalYearStart) {
//                                         sickUsed += days;
//                                     }
//                                 } else {
//                                     earnedUsed += days;
//                                 }
//                             }
//                         }
//                     });


//                     console.log("LEAVES:", leaves);
//                     console.log("SICK USED:", sickUsed);
//                     console.log("EARNED USED:", earnedUsed);
//                     console.log("API EARNED BALANCE:", data.earned);

//                     setLeaveData({
//                         leaveHistory: leaves,
//                         leaveBalances: {
//                             sick: { used: sickUsed, total: sickTotal },
//                             earned: { used: earnedUsed, total: parseFloat(data.earned) || 0 }
//                         },
//                         wfhHistory: wfhData.requests || []
//                     });
//                 }

//             } catch (err) {
//                 console.error("Dashboard Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaveDashboardData();
//     }, [employeeId, userData?.joiningDate]);


//     useEffect(() => {
//         setActiveModule(module || "grid");
//     }, [module]);

//     useEffect(() => {

//         if (role === 'Management' || role === 'Manager') {

//             const fetchRealTimeLeaves = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_leaves.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {
//                         // Count requests with Status '0' or null
//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };


//             fetchRealTimeLeaves();


//             const liveInterval = setInterval(fetchRealTimeLeaves, 5000);

//             return () => clearInterval(liveInterval);
//         }
//     }, [role]);



//     useEffect(() => {

//         const fetchUserData = async () => {

//             try {

//                 const response = await fetch("/gt-api/get_profile.php", {
//                     credentials: "include"
//                 });

//                 const data = await response.json();

//                 if (data.success && data.employee) {

//                     const storedUser = JSON.parse(localStorage.getItem("userData"));

//                     const updatedUser = {
//                         id: data.employee.id,
//                         EmpId: data.employee.EmpId,

//                         firstName: data.employee.FirstName,
//                         FirstName: data.employee.FirstName,

//                         lastName: data.employee.LastName,
//                         LastName: data.employee.LastName,

//                         email: data.employee.EmailId,
//                         EmailId: data.employee.EmailId,

//                         Department: data.employee.DepartmentName || data.employee.Department,

//                         HOD: data.employee.HOD,
//                         Designation: data.employee.Designation,
//                         phone: data.employee.Phonenumber,
//                         gender: data.employee.Gender,
//                         dob: data.employee.Dob,
//                         address: data.employee.Address,
//                         local_address: data.employee.LocalAddress,
//                         city: data.employee.City,
//                         country: data.employee.Country,
//                         profileImage: data.employee.ProfilePicture || null,
//                         joiningDate: data.employee.JoiningDate,

//                         role: storedUser?.role
//                     };

//                     setUserData(updatedUser);

//                     localStorage.setItem("userData", JSON.stringify(updatedUser));

//                     // ✅ CHECK ONLY MISSING MANDATORY PROFILE FIELDS
//                     const isMissing = (val) => !val || String(val).trim() === '' || String(val).trim() === '0000-00-00';
//                     const missing = {
//                         phone: isMissing(updatedUser.phone),
//                         dob: isMissing(updatedUser.dob),
//                         city: isMissing(updatedUser.city),
//                         address: isMissing(updatedUser.address),
//                         local_address: isMissing(updatedUser.local_address),
//                         country: isMissing(updatedUser.country)
//                     };

//                     if (Object.values(missing).some(Boolean)) {
//                         setMissingProfileFields(missing);
//                         setMandatoryFormData({
//                             phone: updatedUser.phone || '',
//                             dob: updatedUser.dob || '',
//                             city: updatedUser.city || '',
//                             address: updatedUser.address || '',
//                             local_address: updatedUser.local_address || '',
//                             country: updatedUser.country || ''
//                         });
//                         setShowMandatoryProfileModal(true);
//                     }

//                     // 🏦 CHECK MANDATORY BANK DETAILS
//                     const empIdForBank = data.employee.id || data.employee.EmpId;
//                     if (empIdForBank) {
//                         let bank = null;
//                         try {
//                             const bankRes = await fetch(`/gt-api/get_bank_details.php?emp_id=${empIdForBank}`, {
//                                 credentials: "include"
//                             });
//                             const rawText = await bankRes.text();
//                             try {
//                                 const json = JSON.parse(rawText);
//                                 if (json && (json.success || json.bank || json.bank_name || json.bankName)) {
//                                     bank = json.bank || json.data || json.details || json.employee_bank_details || json;
//                                 }
//                             } catch (parseErr) {
//                                 console.log("get_bank_details json parse error:", parseErr);
//                             }
//                         } catch (bErr) {
//                             console.error("Bank details fetch network error:", bErr);
//                         }

//                         const b = bank || {};

//                         const getVal = (...keys) => {
//                             for (const k of keys) {
//                                 if (b[k] !== undefined && b[k] !== null && String(b[k]).trim() !== '') {
//                                     return String(b[k]).trim();
//                                 }
//                             }
//                             return '';
//                         };

//                         const bankNameVal = getVal('bankName', 'bank_name', 'BankName', 'Bankname');
//                         const holderNameVal = getVal('holderName', 'holder_name', 'HolderName', 'account_holder_name', 'AccountHolderName');
//                         const accNumberVal = getVal('accNumber', 'account_number', 'AccountNumber', 'AccNumber', 'account_no', 'AccountNo');
//                         const ifscVal = getVal('ifsc', 'ifsc_code', 'IFSC', 'Ifsc', 'IfscCode');
//                         const branchVal = getVal('branch', 'branch_name', 'Branch', 'BranchName');
//                         const accTypeVal = getVal('accType', 'account_type', 'AccountType', 'AccType');

//                         const isBankMissing = (val) => !val || String(val).trim() === '';

//                         const missingBank = {
//                             bankName: isBankMissing(bankNameVal),
//                             holderName: isBankMissing(holderNameVal),
//                             accNumber: isBankMissing(accNumberVal),
//                             ifsc: isBankMissing(ifscVal),
//                             branch: isBankMissing(branchVal),
//                             accType: isBankMissing(accTypeVal)
//                         };

//                         console.log("MANDATORY BANK CHECK RESULT:", { empId: empIdForBank, bankData: b, missingBank });

//                         if (Object.values(missingBank).some(Boolean)) {
//                             setMissingBankFields(missingBank);
//                             setBankFormData({
//                                 bankName: bankNameVal,
//                                 holderName: holderNameVal || `${data.employee.FirstName || ''} ${data.employee.LastName || ''}`.trim(),
//                                 accNumber: bankNameVal ? accNumberVal : '',
//                                 ifsc: ifscVal,
//                                 branch: branchVal,
//                                 accType: accTypeVal || 'Saving Account'
//                             });
//                             setShowMandatoryBankModal(true);
//                         }
//                     }
//                 }

//             } catch (error) {
//                 console.error("Database Error:", error);
//             }

//         };

//         fetchUserData();

//     }, []);

//     // 🔒 LOCK BODY SCROLL WHEN MANDATORY MODAL IS OPEN
//     useEffect(() => {
//         if (showMandatoryProfileModal || showMandatoryBankModal) {
//             document.body.style.overflow = 'hidden';
//             document.documentElement.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         }
//         return () => {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         };
//     }, [showMandatoryProfileModal, showMandatoryBankModal]);

//     const handleSaveMandatoryProfile = async (e) => {
//         e.preventDefault();
//         setMandatoryError('');

//         const { phone, dob, city, address, local_address, country } = mandatoryFormData;

//         if (missingProfileFields.phone && (!phone || !phone.trim())) {
//             setMandatoryError('Please enter your Mobile Number.');
//             return;
//         }
//         if (missingProfileFields.dob && (!dob || !dob.trim() || dob === '0000-00-00')) {
//             setMandatoryError('Please select your Date of Birth.');
//             return;
//         }
//         if (missingProfileFields.city && (!city || !city.trim())) {
//             setMandatoryError('Please enter your City.');
//             return;
//         }
//         if (missingProfileFields.country && (!country || !country.trim())) {
//             setMandatoryError('Please enter your Country.');
//             return;
//         }
//         if (missingProfileFields.address && (!address || !address.trim())) {
//             setMandatoryError('Please enter your Permanent Address.');
//             return;
//         }
//         if (missingProfileFields.local_address && (!local_address || !local_address.trim())) {
//             setMandatoryError('Please enter your Current / Local Address.');
//             return;
//         }

//         setMandatorySaving(true);
//         try {
//             const payload = {
//                 id: userData.id,
//                 EmpId: userData.EmpId,
//                 Phonenumber: (phone || userData.phone || '').trim(),
//                 Dob: (dob || userData.dob || '').trim(),
//                 City: (city || userData.city || '').trim(),
//                 Address: (address || userData.address || '').trim(),
//                 LocalAddress: (local_address || userData.local_address || '').trim(),
//                 Country: (country || userData.country || '').trim(),
//                 Gender: userData.gender || '',
//                 ProfilePicture: userData.profileImage || null
//             };

//             const res = await fetch("/gt-api/update_profile.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 const updatedUser = {
//                     ...userData,
//                     phone: phone.trim(),
//                     dob: dob.trim(),
//                     city: city.trim(),
//                     address: address.trim(),
//                     local_address: local_address.trim(),
//                     country: country.trim()
//                 };
//                 setUserData(updatedUser);
//                 localStorage.setItem("userData", JSON.stringify(updatedUser));
//                 setMandatorySuccessMsg("🎉 Profile information updated! You may now use the system.");
//                 setTimeout(() => {
//                     setShowMandatoryProfileModal(false);
//                     setMandatorySuccessMsg('');
//                 }, 1200);
//             } else {
//                 setMandatoryError(result.message || "Failed to update profile. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory profile update error:", err);
//             setMandatoryError("Connection error. Ensure backend API is running.");
//         } finally {
//             setMandatorySaving(false);
//         }
//     };

//     const handleSaveMandatoryBankDetails = async (e) => {
//         e.preventDefault();
//         setBankError('');

//         const { bankName, holderName, accNumber, ifsc, branch, accType } = bankFormData;

//         if (missingBankFields.bankName && (!bankName || !bankName.trim())) {
//             setBankError('Please enter Bank Name.');
//             return;
//         }
//         if (missingBankFields.holderName && (!holderName || !holderName.trim())) {
//             setBankError('Please enter Account Holder Name.');
//             return;
//         }
//         if (missingBankFields.accNumber && (!accNumber || !accNumber.trim())) {
//             setBankError('Please enter Bank Account Number.');
//             return;
//         }
//         if (missingBankFields.ifsc && (!ifsc || !ifsc.trim())) {
//             setBankError('Please enter IFSC Code.');
//             return;
//         }
//         if (missingBankFields.branch && (!branch || !branch.trim())) {
//             setBankError('Please enter Branch Name.');
//             return;
//         }
//         if (missingBankFields.accType && (!accType || !accType.trim())) {
//             setBankError('Please select Account Type.');
//             return;
//         }

//         setBankSaving(true);
//         try {
//             const payload = {
//                 emp_id: userData.id || userData.employeeId || userData.EmpId,
//                 emp_number: userData.EmpId || userData.employeeId,
//                 bankName: bankName.trim(),
//                 bank_name: bankName.trim(),
//                 holderName: holderName.trim(),
//                 account_holder_name: holderName.trim(),
//                 accNumber: accNumber.trim(),
//                 account_number: accNumber.trim(),
//                 ifsc: ifsc.trim(),
//                 ifsc_code: ifsc.trim(),
//                 branch: branch.trim(),
//                 branch_name: branch.trim(),
//                 accType: accType.trim(),
//                 account_type: accType.trim()
//             };

//             const res = await fetch("/gt-api/save_bank_details.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 setBankSuccessMsg("🎉 Bank details updated successfully!");
//                 setTimeout(() => {
//                     setShowMandatoryBankModal(false);
//                     setBankSuccessMsg('');
//                 }, 1200);
//             } else {
//                 setBankError(result.message || "Failed to save bank details. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory bank details update error:", err);
//             setBankError("Connection error. Ensure backend API is running.");
//         } finally {
//             setBankSaving(false);
//         }
//     };




//     // const employeeId = userData.id || userData.employeeId;

//     const toggleSubMenu = (menu) => {
//         setOpenMenus(prev => ({ ...prev, [menu]: !prev[menu] }));
//     };

//     useEffect(() => {
//         const checkNotifications = () => {
//             if (role !== 'Management' && userData?.employeeId) {
//                 fetch(`/gt-api/clear_notifications.php?employee_id=${userData.employeeId}`)
//                     .then(res => res.json())
//                     .then(data => {
//                         if (data.success) setNotifCount(data.count);
//                     })
//                     .catch(err => console.error("Notif Fetch Error:", err));
//             }
//         };
//         checkNotifications();
//         const interval = setInterval(checkNotifications, 30000);
//         return () => clearInterval(interval);
//     }, [userData.employeeId, role]);

//     useEffect(() => {
//         if (role === 'Management' || role === 'Manager') {
//             const fetchRealTimeLeaves = async () => {
//                 try {
//                     // Determine which API to call based on Role
//                     // Managers should call the specific manager-leaves API using their ID
//                     const url = role === 'Management'
//                         ? "/gt-api/get_all_leaves.php"
//                         : `/gt-api/get_manager_leaves.php?managerId=${userData.id || location.state?.empId}`;

//                     // const res = await fetch(url);
//                     const res = await fetch(url, {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {

//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };

//             // Only fetch if we have the ID for the Manager, or if role is Management
//             if (role === 'Management' || (role === 'Manager' && (userData.id || location.state?.empId))) {
//                 fetchRealTimeLeaves();
//                 const liveInterval = setInterval(fetchRealTimeLeaves, 5000);
//                 return () => clearInterval(liveInterval);
//             }
//         }
//     }, [role, userData.id, location.state?.empId]);

//     const handleStatusUpdate = async (id, newStatus) => {
//         try {
//             const response = await fetch("/gt-api/update_request_status.php", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ id, status: newStatus }),
//             });
//             const data = await response.json();
//             if (data.success) {
//                 setRequestsList(prev => prev.map(req => req.id === id ? { ...req, status: newStatus } : req));
//                 setPendingRequestsCount(prev => Math.max(0, prev - 1));
//                 alert(`Request ${newStatus} successfully!`);
//             }
//         } catch (error) {
//             console.error("Update error:", error);
//         }
//     };

//     ;


//     const sendAIMessage = async () => {
//         if (!chatInput.trim()) return;

//         const userMessage = {
//             sender: "user",
//             text: chatInput
//         };

//         setChatMessages(prev => [...prev, userMessage]);
//         setChatLoading(true);

//         try {
//             const res = await fetch("/gt-api/chatbot.php", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     question: chatInput
//                 })
//             });

//             const data = await res.json();

//             let aiReply = "No response.";

//             if (data.success) {
//                 aiReply = data.reply || "No response.";
//             } else {
//                 aiReply = data.message || "Something went wrong.";
//             }
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: aiReply
//                 }
//             ]);

//         } catch (err) {
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: "Server error."
//                 }
//             ]);
//         }

//         setChatInput("");
//         setChatLoading(false);
//     };
//     const handleModuleChange = (slug, extraData = null) => {
//         navigate(`/dashboard/${role}/${slug}`, {
//             state:
//                 extraData && typeof extraData === "object"
//                     ? extraData
//                     : { selectedPathway: extraData }
//         });
//     };

//     const handlePasswordSubmit = (e) => {
//         e.preventDefault();
//         if (passwordForm.newPassword !== passwordForm.confirmPassword) {
//             alert("New passwords do not match!");
//             return;
//         }
//         alert("Encryption Key Updated Successfully!");
//         setShowPasswordModal(false);
//     };

//     const handleSave = () => {
//         setIsEditing(false);
//         alert("Profile changes synchronized!");
//     };

//     // Ensure only ONE instance of this exists in your file
//     const [theme, setTheme] = useState(localStorage.getItem('dashboard-theme') || 'dark');

//     useEffect(() => {
//         document.documentElement.setAttribute('data-theme', theme);
//         localStorage.setItem('dashboard-theme', theme);
//     }, [theme]);

//     const toggleTheme = () => {
//         setTheme(prev => prev === 'dark' ? 'light' : 'dark');
//     };
//     useEffect(() => {

//         const handlePageShow = (event) => {
//             if (event.persisted) {
//                 const user = localStorage.getItem("userData");
//                 if (!user) {
//                     window.location.replace("/");
//                 }
//             }
//         };

//         window.addEventListener("pageshow", handlePageShow);

//         return () => window.removeEventListener("pageshow", handlePageShow);

//     }, []);
//     useEffect(() => {
//         if (role === 'Management') {
//             const fetchEquipmentCount = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_equip_request.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();
//                     if (data.success && data.requests) {
//                         const count = data.requests.filter(r => r.status?.toLowerCase() === 'pending').length;
//                         setPendingRequestsCount(count);
//                         setRequestsList(data.requests);
//                     }
//                 } catch (err) {
//                     console.error("Equipment Fetch Error:", err);
//                 }
//             };

//             fetchEquipmentCount();
//             const interval = setInterval(fetchEquipmentCount, 10000);
//             return () => clearInterval(interval);
//         }
//     }, [role]);




//     const [payData, setPayData] = useState([]);

//     useEffect(() => {

//         // 🔥 MANAGEMENT DASHBOARD
//         if (role === "Management") {

//             const fetchAllDocs = () => {
//                 fetch("/gt-api/get_all_salary_documents.php", {
//                     credentials: "include"
//                 })
//                     .then(res => res.json())
//                     .then(data => {
//                         console.log("MGMT DATA:", data);

//                         if (data.success) {

//                             setPayData(data.documents);
//                         }
//                     })
//                     .catch(err => console.error("Management Fetch Error:", err));
//             };

//             fetchAllDocs();

//             const interval = setInterval(fetchAllDocs, 5000);

//             return () => clearInterval(interval);
//         }

//         // 👤 EMPLOYEE DASHBOARD
//         if (employeeId) {
//             fetch(`/gt-api/get_my_documents.php?emp_id=${employeeId}`, {
//                 credentials: "include"
//             })
//                 .then(res => res.json())
//                 .then(data => {
//                     console.log("EMP DATA:", data);

//                     if (data.success) {
//                         setPayData(data.documents);
//                     }
//                 })
//                 .catch(err => console.error("Employee Fetch Error:", err));
//         }

//     }, [role, employeeId]);





//     const renderPayChart = () => {
//         const safePayData = payData || [];

//         const payslips = safePayData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = safePayData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = safePayData.filter(d => d.doc_type === "APPRAISAL LETTER").length;
//         const totalDocs = payslips + form16 + appraisal;

//         return (
//             <div className="pay-ultra-card" onClick={() => handleModuleChange("pay and benefits")}>
//                 <div className="card-inner">
//                     {/* Top Section */}
//                     <div className="pay-header">
//                         <div className="pay-icon-wrapper">
//                             <div className="pay-icon-glow"></div>
//                             <span className="main-icon">📄</span>
//                         </div>
//                         <div className="pay-total-info">
//                             <h3>Pay & Benefits</h3>
//                             <p>{totalDocs} Total Documents</p>
//                         </div>
//                     </div>

//                     {/* Distribution */}
//                     <div className="distribution-container">
//                         <div className="distribution-label">
//                             <span>Vault Composition</span>
//                             <span className="percentage">
//                                 {totalDocs > 0 ? "100%" : "0%"}
//                             </span>
//                         </div>

//                         <div className="multi-progress-bar">
//                             {totalDocs > 0 ? (
//                                 <>
//                                     <div
//                                         className="segment green"
//                                         style={{ flex: payslips, backgroundColor: '#22c55e' }}
//                                     ></div>
//                                     <div
//                                         className="segment blue"
//                                         style={{ flex: form16, backgroundColor: '#3b82f6' }}
//                                     ></div>
//                                     <div
//                                         className="segment amber"
//                                         style={{ flex: appraisal, backgroundColor: '#f59e0b' }}
//                                     ></div>
//                                 </>
//                             ) : (
//                                 <div
//                                     style={{
//                                         width: "100%",
//                                         height: "100%",
//                                         backgroundColor: "#e5e7eb",
//                                         borderRadius: "10px"
//                                     }}
//                                 ></div>
//                             )}
//                         </div>
//                     </div>

//                     {/* List */}
//                     <div className="pay-list">
//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator green"></span>
//                                 <span className="name">Monthly Payslips</span>
//                             </div>
//                             <span className="count-badge">{payslips}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator blue"></span>
//                                 <span className="name">Tax Form 16</span>
//                             </div>
//                             <span className="count-badge">{form16}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator amber"></span>
//                                 <span className="name">Appraisal Letter</span>
//                             </div>
//                             <span className="count-badge">{appraisal}</span>
//                         </div>
//                     </div>

//                     <div className="pay-footer">
//                         <span>Explore Document</span>
//                         <span className="arrow-icon">→</span>
//                     </div>

//                     <div className="reimburse-cta-wrapper">
//                         <button
//                             className="reimburse-btn"
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleModuleChange("supplies");
//                             }}
//                         >
//                             Click here for Reimbursement Form
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };



//     const renderLeavePieChart = () => {
//         const PUBLIC_HOLIDAYS = [
//             '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//             '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//         ];

//         const isWorkDay = (date) => {
//             const day = date.getDay();
//             const dateString = date.toISOString().split('T')[0];
//             return !(day === 0 || day === 6) && !PUBLIC_HOLIDAYS.includes(dateString);
//         };

//         if (!leaveData || !leaveData.leaveBalances) return null;

//         const sickUsed = leaveData.leaveBalances.sick.used || 0;
//         const earnedUsed = leaveData.leaveBalances.earned.used || 0;
//         const wfhCount = leaveData.wfhHistory.reduce((total, wfh) => {
//             const start = new Date(wfh.start);
//             const end = new Date(wfh.end);
//             let days = 0;
//             let current = new Date(start);
//             while (current <= end) {
//                 if (isWorkDay(current)) days++;
//                 current.setDate(current.getDate() + 1);
//             }
//             return total + days;
//         }, 0);

//         const totalUsed = sickUsed + earnedUsed;

//         // Determine max for scaling bars (minimum scale of 10)
//         const maxVal = Math.max(sickUsed, earnedUsed, wfhCount, 10);
//         return (

//             <div
//                 className={`elite-podium-card leave-analytics-card ${theme === 'dark' ? 'dark-variant' : 'light-theme'}`}
//                 onClick={() => handleModuleChange("attendance")}
//             >

//                 <div className="card-header-v3">
//                     <div className="title-group">

//                         <h2 className="main-title">Leave Overview</h2>
//                     </div>
//                     <div className="year-tag">2026</div>
//                 </div>

//                 <div className="podium-content">
//                     {/* VERTICAL BAR SECTION - Made prominent */}
//                     <div className="bar-podium-large">
//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill sick" style={{ height: `${(sickUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">SICK</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill earned" style={{ height: `${(earnedUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">EARNED</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill wfh" style={{ height: `${(wfhCount / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">WFH</span>
//                         </div>
//                     </div>

//                     {/* KPI SIDEBAR - Cleaned up to match image 1's style */}
//                     <div className="kpi-sidebar-compact">
//                         <div className="total-display">
//                             <span className="total-val">{totalUsed}</span>
//                             <span className="total-sub">Days Off-Site</span>
//                         </div>

//                         <div className="status-legend">
//                             <div className="legend-row">
//                                 <span className="indicator sick"></span>
//                                 <span>{sickUsed} Sick</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator earned"></span>
//                                 <span>{earnedUsed} Earned</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator wfh"></span>
//                                 <span>{wfhCount} WFH</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="card-footer-v3">
//                     <div className="sync-info">
//                         <span className="status-glow"></span>
//                         Annual Summary Active
//                     </div>
//                     <button className="details-btn">VIEW DETAILS →</button>
//                 </div>
//             </div>
//         );
//     };

//     const [leaveData, setLeaveData] = useState({
//         leaveHistory: [],
//         leaveBalances: {
//             sick: { used: 0, total: 0 },
//             earned: { used: 0, total: 0 }
//         },
//         wfhHistory: []
//     });


//     const [managementNotices, setManagementNotices] = useState({
//         reviews: [],
//         probations: []
//     });

//     useEffect(() => {
//         const fetchNotices = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/get_manager_feedback.php?empId=${userData.EmpId}`
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     setManagementNotices({
//                         reviews: data.reviews || [],
//                         probations: data.probations || []
//                     });
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchNotices();
//     }, [userData]);





//     const renderEquipmentCard = () => {
//         const { total, approved, rejected, pending } = equipmentData;

//         return (
//             <div className="equipment-ultra-card clickable" onClick={() => handleModuleChange("equipment-request")}>
//                 <div className="equip-header">
//                     <div className="equip-icon-box">💻</div>
//                     <div className="equip-title-group">
//                         <span className="equip-label">Hardware</span>
//                         <h3 className="equip-title">Requests</h3>
//                     </div>
//                 </div>

//                 <div className="equip-main-stat">
//                     <span className="total-count">{total}</span>
//                     <span className="total-label">Submissions</span>
//                 </div>

//                 <div className="equip-progress-bar">
//                     <div className="bar-fill approved" style={{ width: `${(approved / total) * 100}%` }}></div>
//                     <div className="bar-fill pending" style={{ width: `${(pending / total) * 100}%` }}></div>
//                 </div>

//                 <div className="equip-stats-list">
//                     <div className="equip-item">
//                         <span className="dot approved"></span>
//                         <span className="item-name">Approved</span>
//                         <span className="item-val">{approved}</span>
//                     </div>
//                     <div className="equip-item">
//                         <span className="dot pending"></span>
//                         <span className="item-name">Pending</span>
//                         <span className="item-val text-warning">{pending}</span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     useEffect(() => {
//         const empIdForFetch = userData?.EmpId || userData?.employeeId;

//         if (!empIdForFetch) return;

//         fetch(`/gt-api/get_all_equip_request.php?employee_id=${empIdForFetch}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log("EQUIPMENT API RESPONSE:", data);
//                 if (data.success && data.requests) {

//                     const requests = data.requests;

//                     const approved = requests.filter(r =>
//                         r.status?.toLowerCase() === "approved"
//                     ).length;

//                     const rejected = requests.filter(r =>
//                         r.status?.toLowerCase() === "rejected"
//                     ).length;

//                     const pending = requests.filter(r =>
//                         r.status?.toLowerCase() === "pending"
//                     ).length;

//                     setEquipmentData({
//                         total: requests.length,
//                         approved,
//                         rejected,
//                         pending
//                     });
//                 }
//             })
//             .catch(err => console.error("Equipment Dashboard Error:", err));
//         console.log("EMP ID:", empIdForFetch);



//     }, [userData?.EmpId, userData?.employeeId]);





//     const [oneOnOneData, setOneOnOneData] = useState({
//         totalMeetings: 0,
//         pendingTasks: 0,
//         completedTasks: 0
//     });

//     useEffect(() => {
//         if (!employeeId) return;

//         fetch(`/gt-api/get_my_meetings.php?emp_id=${employeeId}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.meetings) {

//                     const meetings = data.meetings;

//                     let pending = 0;
//                     let completed = 0;

//                     meetings.forEach(meet => {
//                         const tasks = JSON.parse(meet.action_items || "[]");

//                         tasks.forEach(task => {
//                             if (task.done) completed++;
//                             else pending++;
//                         });
//                     });

//                     setOneOnOneData({
//                         totalMeetings: meetings.length,
//                         pendingTasks: pending,
//                         completedTasks: completed
//                     });
//                 }
//             })
//             .catch(err => console.error("1-1 Fetch Error:", err));

//     }, [employeeId]);



//     const renderOneOnOneCard = () => {
//         const { totalMeetings, pendingTasks, completedTasks } = oneOnOneData;
//         const totalTasks = (pendingTasks + completedTasks) || 1;
//         const progressPercent = Math.min(Math.round((completedTasks / totalTasks) * 100), 100);

//         return (
//             <div className="liquid-card clickable" onClick={() => handleModuleChange("one-on-one")}>
//                 {/* BACKGROUND BLOOM */}
//                 <div className="liquid-bloom"></div>

//                 <div className="liquid-layout">
//                     {/* HERO TILE: THE CORE IDENTITY */}
//                     <div className="liquid-tile-hero">
//                         <div className="hero-header">
//                             {/* <span className="hero-eyebrow">Engagement Console</span> */}
//                             <h2 className="hero-title">1-on-1 Sessions</h2>
//                         </div>
//                         <div className="hero-main-metric">
//                             <span className="hero-val">{totalMeetings}</span>
//                             <span className="hero-label">TOTAL<br />MEETINGS</span>
//                         </div>
//                         {/* FULL WIDTH PROGRESS THREAD */}
//                         <div className="liquid-thread-container">
//                             <div className="liquid-thread-bg">
//                                 <div className="liquid-thread-fill" style={{ width: `${progressPercent}%` }}>
//                                     <div className="liquid-thread-glow-tip"></div>
//                                 </div>
//                             </div>
//                             <div className="liquid-thread-label">
//                                 <span className="label-text">Task Completion</span>
//                                 <span className="label-val">{progressPercent}%</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* DATA TRAY: THE SPECIFIC CHIPS */}
//                     <div className="liquid-tray">
//                         <div className="liquid-chip danger">
//                             <div className="chip-inner">
//                                 <label>Pending Task</label>
//                                 <span className="chip-val">{pendingTasks}</span>
//                             </div>
//                         </div>
//                         <div className="liquid-chip success">
//                             <div className="chip-inner">
//                                 <label>Completed Task</label>
//                                 <span className="chip-val">{completedTasks}</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* INTERACTIVE FOOTER */}
//                 <div className="liquid-footer">
//                     <div className="status-container">
//                         <div className={`status-node-wrapper ${pendingTasks > 0 ? 'is-alert' : 'is-sync'}`}>
//                             <div className="status-node-core"></div>
//                             <div className="status-node-bloom"></div>
//                         </div>
//                         <span className={`status-text ${pendingTasks > 0 ? 'text-alert' : ''}`}>
//                             {pendingTasks > 0 ? 'ACTION ITEMS DETECTED' : 'SYSTEM OPTIMIZED'}
//                         </span>
//                     </div>
//                     <div className="liquid-action">

//                         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
//                     </div>
//                 </div>
//             </div>
//         );
//     };






//     const renderCareerPathwaysCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const pathways = isGenesis

//             ? [

//                 {
//                     id: "01",
//                     name: "FI DESIGN",
//                     color: "rgba(0, 77, 113, 0.9)"
//                 },

//                 {
//                     id: "02",
//                     name: "BIM MODELING",
//                     color: "rgba(0, 120, 172, 0.8)"
//                 },

//                 {
//                     id: "03",
//                     name: "POWER BI",
//                     color: "rgba(0, 162, 237, 0.7)"
//                 }

//             ]

//             : dashboardPathways.map(
//                 (item, index) => ({
//                     id: String(index + 1)
//                         .padStart(2, "0"),

//                     name: item.pathway_title,

//                     color:
//                         "rgba(0, 120, 172, 0.8)"
//                 })
//             );

//         return (

//             <div
//                 className="pathway-card-container"
//                 onClick={() =>
//                     handleModuleChange(
//                         "career pathways"
//                     )
//                 }
//             >

//                 <h2 className="pathway-title">
//                     CAREER PATHWAYS
//                 </h2>

//                 <div className="pathway-stack">

//                     {pathways.map(
//                         (item, index) => (

//                             <div
//                                 key={index}
//                                 className="pathway-step"
//                                 style={{
//                                     '--step-color':
//                                         item.color
//                                 }}
//                                 onClick={(e) => {

//                                     e.stopPropagation();

//                                     handleModuleChange(
//                                         "career pathways",
//                                         item.name
//                                     );

//                                 }}
//                             >

//                                 <span className="step-number">
//                                     {item.id}
//                                 </span>

//                                 <div className="step-content">

//                                     <span className="step-name">
//                                         {item.name}
//                                     </span>

//                                     <div className="step-glow"></div>

//                                 </div>

//                             </div>

//                         )
//                     )}

//                 </div>

//                 <button
//                     className="explore-btn"
//                     onClick={(e) => {

//                         e.stopPropagation();

//                         handleModuleChange(
//                             "career pathways"
//                         );

//                     }}
//                 >
//                     EXPLORE CAREER PATHWAYS
//                 </button>

//             </div>

//         );

//     };


//     const renderPolicyCard = () => {
//         const totalPolicies =
//             policyCount;

//         console.log(
//             "Policy Count:",
//             totalPolicies
//         );

//         const readCount =
//             Object.keys(logs || {}).length;
//         const pending = totalPolicies - readCount;
//         const progress = totalPolicies > 0 ? Math.round((readCount / totalPolicies) * 100) : 0;

//         return (
//             <div className="terminal-policy-card" onClick={() => handleModuleChange("company-policy")}>
//                 {/* Background Decorative Scanline */}
//                 <div className="terminal-scanline"></div>

//                 <div className="terminal-header">
//                     <div className="header-left">
//                         {/* <span className="terminal-tag">PROTOCOL_09</span> */}
//                         <h3 className="terminal-title">Company Policy</h3>
//                     </div>
//                     <div className={`status-indicator ${progress === 100 ? 'secure' : 'breach'}`}>
//                         {progress === 100 ? "SECURE" : "PENDING"}
//                     </div>
//                 </div>

//                 <div className="terminal-content">
//                     {/* Circular Progress using SVG for precision */}
//                     <div className="terminal-visual">
//                         <svg viewBox="0 0 36 36" className="cyber-circle">
//                             <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                             <path
//                                 className="circle-fill"
//                                 strokeDasharray={`${progress}, 100`}
//                                 d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
//                                 style={{ stroke: progress === 100 ? '#22c55e' : '#3b82f6' }}
//                             />
//                         </svg>
//                         <div className="percentage-display">
//                             <span className="pct-num">{progress}</span>
//                             <span className="pct-unit">%</span>
//                         </div>
//                     </div>

//                     {/* Data Readout Section */}
//                     <div className="terminal-stats">
//                         <div className="stat-row">
//                             <span className="label">COMPLETED</span>
//                             <span className="value">{readCount}</span>
//                         </div>
//                         <div className="stat-row">
//                             <span className="label">TOTAL_FILES</span>
//                             <span className="value">{totalPolicies}</span>
//                         </div>
//                         <div className="stat-row urgent">
//                             <span className="label">AWAITING_ACTION</span>
//                             <span className="value">{pending}</span>
//                         </div>
//                     </div>
//                 </div>

//             </div>
//         );
//     };

//     useEffect(() => {
//         const fetchLogs = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/acknowledgepolicy.php?empId=${userData.EmpId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 console.log("API DATA:", data);

//                 // 🔥 FIX: use data.logs (NOT data)
//                 const logsArray = Array.isArray(data?.logs) ? data.logs : [];

//                 const map = logsArray.reduce((acc, curr) => {
//                     if (curr?.policy_title) {
//                         acc[curr.policy_title] = true;
//                     }
//                     return acc;
//                 }, {});

//                 setLogs(map);

//             } catch (err) {
//                 console.error("Policy logs error:", err);
//                 setLogs({});
//             }
//         };

//         fetchLogs();
//     }, [userData]);


//     const [showProfileOptions, setShowProfileOptions] = useState(false);



//     const [showProfileMenu, setShowProfileMenu] = useState(false);
//     const handleEditProfile = () => {
//         setShowProfileMenu(false);
//         navigate(`/dashboard/${role}/my-profile`);
//         setShowProfile(true);
//     };

//     const handleLogout = () => {
//         document.documentElement.removeAttribute('data-theme');
//         localStorage.clear();
//         sessionStorage.clear();
//         navigate("/", { replace: true });
//     };

//     const [currentTime, setCurrentTime] = useState("");

//     useEffect(() => {
//         const updateTime = () => {
//             const now = new Date();
//             setCurrentTime(
//                 now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
//             );
//         };

//         updateTime();
//         const interval = setInterval(updateTime, 1000);

//         return () => clearInterval(interval);
//     }, []);
//     const todayDate = new Date().toLocaleDateString('en-GB', {
//         day: '2-digit',
//         month: 'short'
//     });



//     const employeeModulesList = [
//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "attendance" },

//         { id: 2, name: "Pay and Benefits", icon: "💳", color: "#3b82f6", slug: "pay and benefits" },
//         { id: 3, name: "OKR and Performance Tracker", icon: "🎯", color: "#f59e0b", slug: "okr and performance tracker" },

//         { id: 5, name: "Career Pathways", icon: "🏆", color: "#ec4899", slug: "career pathways" },
//         { id: 6, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },

//         { id: 9, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         { id: 10, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         // { id: 11, name: "Documents", icon: "📂", color: "#f43f5e", slug: "documents" },
//         // { id: 12, name: "Employee Experience Survey - EES", icon: "📝", color: "#8b5cf6", slug: "ees-survey" },   
//         { id: 13, name: "1:1 Meeting", icon: "💬", color: "#00fff2", slug: "one-on-one" },
//         { id: 21, name: "ACM Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//         { id: 7, name: "Expense Reimbursement", icon: "🧾", color: "#10b981", slug: "supplies" },

//     ];

//     const managementModulesList = [

//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "leave-management", badge: pendingLeavesCount },

//         { id: 2, name: "Employee Salary and Benefits", icon: "💳", color: "#3b82f6", slug: "employee-salary-benefits" },

//         { id: 3, name: "Employee OKR'S", icon: "🎯", color: "#f59e0b", slug: "employee-okrs" },

//         { id: 5, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: pendingRequestsCount },

//         { id: 6, name: "Own Finanacials", icon: "💰", color: "#10b981", slug: "pay and benefits" },

//         { id: 8, name: "Career Development", icon: "🏆", color: "#ec4899", slug: "career pathways" },

//         { id: 10, name: "Self OKR Tracker", icon: "🏁", color: "#f59e0b", slug: "okr and performance tracker" },
//         { id: 11, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         { id: 12, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         // { id: 21, name: "Manage Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates", badge: "PUSH" },

//         {
//             id: 21,
//             name: "ACM Updates",
//             icon: "📢",
//             color: "#00fff2",
//             slug: "manage-quarterly-updates",
//             badge: "PUSH"
//         },

//         // {
//         //   id: 15,
//         //   name: "EES Feedback Analytics",
//         //   icon: "📊",
//         //   color: "#00f2ff",
//         //   slug: "ees-analytics",
//         //   badge: "NEW"
//         // },

//         // { id: 14, name: "Skills Development", icon: "📚", color: "#06b6d4", slug: "career" },

//         {
//             id: 16,
//             name: "Medical Reports",
//             icon: "🏥",
//             color: "#f43f5e",
//             slug: "medical-reports",
//             badge: "DOCS"
//         },
//         {
//             id: 17,
//             name: "Policy RnU Status",
//             icon: "📋",
//             color: "#10b981",
//             slug: "policy-logs",
//             badge: "ADMIN"
//         },

//         // { 
//         //   id: 18, 
//         //   name: "Employee Documents", 
//         //   icon: "📂", 
//         //   color: "#f43f5e", 
//         //   slug: "manage-documents", 
//         //   badge: "VIEW" 
//         // },

//         {
//             id: 19,
//             name: "1:1 Connect",
//             icon: "🤝",
//             color: "#00fff2",
//             slug: "manager-one-on-one",

//             badge: "LIVE"
//         },

//         { id: 20, name: "Events and Celebrations", icon: "🎉", color: "#3b82f6", slug: "events-celebrations" },

//         {
//             id: 22,
//             name: "Expense Reimbursements",
//             icon: "💰",
//             color: "#22c55e",
//             slug: "reimbursements",
//             badge: "NEW"
//         },

//         {
//             id: 25,
//             name: "Award Nominations Analytics",
//             icon: "📊",
//             color: "#f59e0b",
//             slug: "award-analytics",
//             badge: "GALA"
//         },

//         // {
//         //     id: 23,
//         //     name: "WFH Requests",
//         //     icon: "🏠",
//         //     color: "#3b82f6",
//         //     slug: "manage-wfh-requests",
//         //     badge: "WFH"
//         // },


//     ];

//     const renderActiveModule = () => {

//         switch (activeModule) {

//             case "attendance-tracker":
//                 return <AttendanceTracker />;

//             case "CompanySetup":
//                 return <CompanySetup />;

//             case "create-invoice":
//                 return <InvoiceGenerator />;

//             case "my-profile":
//                 return (
//                     <MyProfile
//                         userData={userData}
//                         setUserData={setUserData}
//                         isEditing={isEditing}
//                         setIsEditing={setIsEditing}
//                         handleSave={handleSave}
//                         setShowPasswordModal={setShowPasswordModal}
//                     />
//                 );


//             case "reimbursements":
//                 if (role === "Management" || role === "Manager") {
//                     return <ReimbursementManagement />;
//                 }
//                 return <OfficeRequisition userData={userData} />;

//             case "manage-wfh-requests":
//                 return <WFHManagement />;


//             case "work-from-home":
//                 return <WorkFromHome />;


//             case "quarterly-updates":

//                 return <QuarterlyUpdates />;

//             case "manage-quarterly-updates":

//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementQuarterlyUpdate userData={userData} />;
//                 }
//                 return <QuarterlyUpdates />;


//             case "leave-management":
//                 // Unified behavior for Management and Manager
//                 if (role === 'Management' || role === 'Manager') {
//                     return <LeaveManagement userData={userData} />;
//                 }


//                 return <Attendance employeeId={employeeId} userData={userData} />;

//             case "manage-documents":
//                 if (role === 'Management') {
//                     return <ManageEmployeeDocs />;
//                 }
//                 return <Documents userData={userData} />;



//             // case "attendance":
//             //     if (role === 'Management') return <Attendance />;
//             //     return (
//             //         <Attendance
//             //             employeeId={userData.id}
//             //             empBadgeId={userData.EmpId}
//             //             userData={userData}
//             //         />
//             //     );
//             case "attendance":

//                 if (role === 'Management') {

//                     return (
//                         <Attendance
//                             employeeId={userData.id}
//                             empBadgeId={userData.EmpId}
//                             userData={userData}
//                         />
//                     );

//                 }

//                 return (
//                     <Attendance
//                         employeeId={userData.id}
//                         empBadgeId={userData.EmpId}
//                         userData={userData}
//                     />
//                 );


//             case "policy-logs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <PolicyAdminDashboard />;
//                 }

//                 return (
//                     <CompanyPolicy
//                         employeeId={userData.id}
//                         userData={userData}
//                     />
//                 );

//             case "events-celebrations":
//                 return <EventsCelebrations userData={userData} />;

//             case "award-nominations":
//                 return <AwardNominations userData={userData} role={role} />;

//              case "award-analytics":
//                 return <AwardAnalyticsDashboard userData={userData} role={role} />;

//             case "pay and benefits": return <PayBenefits userData={userData} employeeId={employeeId} />;

//             // case "okr and performance tracker":
//             //     return <OKRTracker userData={userData} />;

//             case "okr and performance tracker":
//                 return (
//                     <OKRTracker
//                         userData={userData}
//                         defaultTab={location.state?.tab}
//                     />
//                 );

//             // Inside Dashboard.js -> renderActiveModule
//             // case "employee-okrs":
//             //     if (role === 'Management' || role === 'Manager') {
//             //         return (
//             //             <ManagementOKRViewer
//             //                 managerId={userData.id}
//             //                 userRole={role}
//             //                 // This is the CRITICAL line:
//             //                 managedDept={userData.HOD}
//             //             />
//             //         );
//             //     }
//             //     return <OKRTracker userData={userData} />;

//             case "employee-okrs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementOKRViewer userRole={role} />;
//                 }
//                 return <OKRTracker userData={userData} />;

//             case "career pathways": return <CareerPathways userData={userData} />;
//             case "add-department": return <AddDepartment />;
//             case "manage-department": return <ManageDepartment />;
//             case "add-employee": return <AddEmployee />;
//             case "manage-employee": return <ManageEmployee />;

//             case "employee-salary-benefits":
//                 return <EmployeeSalaryBenefits />;


//             case "equipment-request":
//                 if (role === "Management") {
//                     const pending = requestsList.filter(
//                         (r) => r.status?.toLowerCase() === "pending"
//                     );

//                     const history = requestsList.filter(
//                         (r) => r.status?.toLowerCase() !== "pending"
//                     );

//                     return (
//                         <div
//                             className="management-request-wrapper animate-fade"
//                             style={{ padding: "20px" }}
//                         >
//                             {/* Pending Queue */}
//                             <div
//                                 className="module-glass-card"
//                                 style={{ marginBottom: "30px" }}
//                             >
//                                 <h3 className="cyan-text">
//                                     ACTIVE_PENDING_QUEUE ({pending.length})
//                                 </h3>

//                                 {/* Desktop Table */}
//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>IMPACT</th>
//                                                 <th>ACTION</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {pending.length > 0 ? (
//                                                 pending.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                             >
//                                                                 {req.impact?.toUpperCase()}
//                                                             </span>
//                                                         </td>

//                                                         <td>
//                                                             <div className="equiptable-actions">
//                                                                 <button
//                                                                     className="equiptable-btn equiptable-approve"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Approved"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✔
//                                                                 </button>

//                                                                 <button
//                                                                     className="equiptable-btn equiptable-reject"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Rejected"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✖
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_PENDING_REQUESTS
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 {/* Mobile Cards */}
//                                 <div className="equiptable-mobile">
//                                     {pending.length > 0 ? (
//                                         pending.map((req) => (
//                                             <div
//                                                 className="equiptable-card"
//                                                 key={req.id}
//                                             >
//                                                 <div className="equiptable-row">
//                                                     <span>Employee</span>
//                                                     <strong>
//                                                         {req.employee_name}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Hardware</span>
//                                                     <strong>
//                                                         {req.equipment_type}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Impact</span>

//                                                     <span
//                                                         className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                     >
//                                                         {req.impact?.toUpperCase()}
//                                                     </span>
//                                                 </div>

//                                                 <div className="equiptable-actions">
//                                                     <button
//                                                         className="equiptable-btn equiptable-approve"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Approved"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✔ Approve
//                                                     </button>

//                                                     <button
//                                                         className="equiptable-btn equiptable-reject"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Rejected"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✖ Reject
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         ))
//                                     ) : (
//                                         <div className="equiptable-card">
//                                             NO_PENDING_REQUESTS
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Completed History */}
//                             <div
//                                 className="module-glass-card history-card"
//                                 style={{ opacity: 0.9 }}
//                             >
//                                 <h3
//                                     className="gray-text"
//                                     style={{ color: "#888" }}
//                                 >
//                                     📜 COMPLETED_HISTORY ({history.length})
//                                 </h3>

//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>DATE</th>
//                                                 <th>STATUS</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {history.length > 0 ? (
//                                                 history.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             {new Date(
//                                                                 req.updated_at ||
//                                                                 req.created_at
//                                                             ).toLocaleDateString(
//                                                                 "en-GB"
//                                                             )}
//                                                         </td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-status ${req.status?.toLowerCase()}`}
//                                                             >
//                                                                 {req.status?.toUpperCase()}
//                                                             </span>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_HISTORY_FOUND
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     );
//                 }

//                 return <EquipmentRequest userData={userData} />;

//             case "supplies": return <OfficeRequisition userData={userData} />;
//             // case "it": return <ITSupport userData={userData} />;
//             case "documents": return <Documents userData={userData} />;
//             // case "company-policy": return <CompanyPolicy />;
//             case "company-policy":
//                 return <CompanyPolicy userData={userData} />;
//             case "Organization Chart": return <OrgChart userData={userData} />;
//             // case "campus information": return <CampusInfo />;
//             case "campus information":
//                 return <CampusInfo userData={userData} />;
//             case "ees-survey": return <EESExperience userData={userData} />;

//             case "ees-analytics":
//                 if (role === 'Management' || role === 'Manager') {
//                     // Management sees the list of real data
//                     return <EESFeedbackManagement feedbacks={eesSubmissions} />;
//                 }
//                 // Employee sees the form
//                 return <EESExperience userData={userData} onFinalSubmit={handleEESSubmit} />;

//             //       case "one-on-one":
//             // return <OneOnOne userData={userData} role={role} />;

//             case "one-on-one":
//                 // This is the PERSONAL view (Employee mode)
//                 return <OneOnOne userData={userData} role="Employee" viewMode="personal" />;

//             case "manager-one-on-one":
//                 // This is the MANAGERIAL view (Manager/Management mode)
//                 return <OneOnOne userData={userData} role={role} viewMode="managerial" />;

//             case "one-on-one-report":
//                 return <OneOnOneReport userData={userData} role={role} handleModuleChange={handleModuleChange} />;

//             // Inside Dashboard.js renderActiveModule
//             case "medical-reports":
//                 if (role === 'Management') return <MedicalReports />;
//                 if (role === 'Manager') {
//                     return (
//                         <ManagerMedicalReports
//                             managerId={userData.id}           // Database Primary Key
//                             managerBadgeId={userData.EmpId}   // Company ID (HOD flag often matches this)
//                             managerDept={userData.Department} // The string "Software Development"
//                         />
//                     );
//                 }

//             case "employee-it-support":
//                 return <EquipmentRequest userData={userData} />;

//             default:


//                 if (role === 'Manager') {
//                     return renderManagerDashboard();
//                 }

//                 const currentList = role === 'Management' ? managementModulesList : employeeModulesList;
//                 return (
//                     <section className="bento-grid">
//                         {currentList.map((mod) => (
//                             <div key={mod.id} className="bento-card glass" style={{ "--accent": mod.color }} onClick={() => handleModuleChange(mod.slug)}>
//                                 <div className="card-top">
//                                     <span className="mod-icon">{mod.icon}</span>
//                                     {mod.badge > 0 && <span className={role === 'Management' ? "card-badge" : "notification-badge-ui"}>{mod.badge}</span>}
//                                 </div>
//                                 <div className="card-info"><h3>{mod.name}</h3><div className="cyber-line"></div></div>
//                             </div>
//                         ))}
//                     </section>
//                 );
//         }
//     };

//     const [companyLogo, setCompanyLogo] = useState("");
//     const currentLogo = theme === 'light' ? logoLight : logoDark;


//     const [leaveStats, setLeaveStats] = useState({
//         pending: 0,
//         approved: 0,
//         rejected: 0,
//         wfhPending: 0
//     });

//     useEffect(() => {
//         if (role !== "Management") return;

//         const fetchLeaveStats = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];


//                     const pending = leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                     const approved = leaves.filter(l => l.Status === '1').length;
//                     const rejected = leaves.filter(l => l.Status === '2').length;

//                     // WFH
//                     const wfhRes = await fetch("/gt-api/get_all_wfh_requests.php", {
//                         credentials: "include"
//                     });
//                     const wfhData = await wfhRes.json();

//                     const wfhPending = wfhData.success
//                         ? wfhData.requests.filter(r => r.status === "Pending").length
//                         : 0;

//                     setLeaveStats({ pending, approved, rejected, wfhPending });
//                 }

//             } catch (err) {
//                 console.error("Leave Stats Error:", err);
//             }
//         };

//         fetchLeaveStats();
//         const interval = setInterval(fetchLeaveStats, 5000);

//         return () => clearInterval(interval);
//     }, [role]);


//     const [mgmtLeaves, setMgmtLeaves] = useState([]);
//     const [mgmtActiveTeam, setMgmtActiveTeam] = useState("All");

//     useEffect(() => {
//         const fetchLeaves = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();
//                 if (data.success) setMgmtLeaves(data.leaves);
//             } catch (err) {
//                 console.error("Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaves();
//     }, []);





//     const mgmtChartData = useMemo(() => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept => dept.DepartmentName
//             );

//         const now = new Date();
//         const currentMonth = (now.getMonth() + 1).toString();
//         const currentYear = now.getFullYear().toString();

//         const teamList = mgmtActiveTeam === "All" ? teams : [mgmtActiveTeam];

//         return teamList.map(team => {

//             const filtered = mgmtLeaves.filter(l => {
//                 const dateParts = l.fromdate?.split("-");
//                 const lYear = dateParts?.[0];
//                 const lMonth = dateParts?.[1]
//                     ? parseInt(dateParts[1]).toString()
//                     : "";

//                 return (
//                     l.Department === team &&
//                     lMonth === currentMonth &&
//                     lYear === currentYear
//                 );
//             });

//             return {
//                 name: team,

//                 // ✅ SUM OF UNITS (FIXED)
//                 Approved: filtered
//                     .filter(l => l.Status === "1")
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

//                 Pending: filtered
//                     .filter(l => l.Status === "0" || l.Status === null)
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
//             };
//         });

//     }, [mgmtLeaves, mgmtActiveTeam]);


//     const renderManagementLeaveCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept =>
//                     dept.DepartmentName
//             );

//         return (
//             <div
//                 className="mgmt-leave-analytics clickable"
//                 onClick={() => handleModuleChange("leave-management")}
//             >

//                 <div className="card-header">
//                     <h3>Employee Leave Analytics</h3>
//                     <span className="sub-text">This Month</span>
//                 </div>

//                 {/* TEAM CHIPS */}
//                 <div className="team-row">
//                     <div
//                         className={`team-chip ${mgmtActiveTeam === "All" ? "active" : ""}`}
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             setMgmtActiveTeam("All");
//                         }}
//                     >
//                         ALL
//                     </div>

//                     {teams.map((team, i) => (
//                         <div
//                             key={i}
//                             className={`team-chip ${mgmtActiveTeam === team ? "active" : ""}`}
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 setMgmtActiveTeam(team);
//                             }}
//                         >
//                             {team}
//                         </div>
//                     ))}
//                 </div>

//                 {/* CHART */}
//                 {(() => {
//                     const isSingle = mgmtActiveTeam !== "All";

//                     return (
//                         <div className={`chart-area ${isSingle ? "single-view" : ""}`}>
//                             <ResponsiveContainer width="100%" height={170}>
//                                 <BarChart
//                                     data={mgmtChartData}
//                                     barCategoryGap={isSingle ? "70%" : "30%"}
//                                     margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
//                                 >

//                                     {/* GRADIENTS */}
//                                     <defs>
//                                         <linearGradient id="approvedGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#34d399" />
//                                             <stop offset="100%" stopColor="#059669" />
//                                         </linearGradient>

//                                         <linearGradient id="pendingGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#fbbf24" />
//                                             <stop offset="100%" stopColor="#f59e0b" />
//                                         </linearGradient>
//                                     </defs>

//                                     <CartesianGrid
//                                         strokeDasharray="3 3"
//                                         stroke="rgba(255,255,255,0.05)"
//                                         vertical={false}
//                                     />

//                                     <XAxis
//                                         dataKey="name"
//                                         tick={{ fill: "#888", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <YAxis
//                                         tick={{ fill: "#666", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <Tooltip
//                                         cursor={{ fill: "rgba(255,255,255,0.05)" }}
//                                         contentStyle={{
//                                             backgroundColor: "rgba(15, 23, 42, 0.95)", // dark glass
//                                             border: "1px solid rgba(0,255,242,0.3)",
//                                             borderRadius: "10px",
//                                             color: "#ffffff",
//                                             backdropFilter: "blur(8px)"
//                                         }}
//                                         labelStyle={{ color: "#00fff2", fontWeight: 600 }}
//                                         itemStyle={{ color: "#ffffff" }}
//                                     />


//                                     <Bar
//                                         dataKey="Approved"
//                                         stackId="a"
//                                         fill="url(#approvedGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                     <Bar
//                                         dataKey="Pending"
//                                         stackId="a"
//                                         fill="url(#pendingGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                 </BarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     );
//                 })()}


//                 <div className="card-footer">
//                     <span>Open Leave Console</span>
//                     <span>→</span>
//                 </div>
//             </div>
//         );
//     };

//     const renderSalaryIntelCard = () => {
//         // 1. Existing Counts
//         const payslips = payData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = payData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = payData.filter(d => d.doc_type === "APPRAISAL LETTER").length;

//         // 2. New Miscellaneous Count (Filtering for the images you provided)
//         const miscDocs = [
//             "FNF LETTER", "OFFER LETTER", "RELIEVING LETTER",
//             "EXPERIENCE LETTER", "EMPLOYEMENT AGREEMENT", "BANK ACCOUNT OPENING"
//         ];
//         const miscellaneous = payData.filter(d => miscDocs.includes(d.doc_type)).length;

//         // 3. Updated Total
//         const total = payslips + form16 + appraisal + miscellaneous;

//         // 4. SVG Math for 4 segments
//         const chartTotal = 125.6;
//         const gap = total > 0 ? 2 : 0;

//         const s1 = (payslips / total) * chartTotal || 0;
//         const s2 = (form16 / total) * chartTotal || 0;
//         const s3 = (appraisal / total) * chartTotal || 0;
//         const s4 = (miscellaneous / total) * chartTotal || 0;

//         return (
//             <div className="sa-card-wrapper" onClick={() => handleModuleChange("employee-salary-benefits")}>


//                 <div className="sa-card-header">
//                     <h3 className="sa-title">Salary Document Insights</h3>
//                     <button className="sa-menu-trigger">⋮</button>
//                 </div>

//                 <div className="sa-main-body">
//                     <div className="sa-gauge-area">
//                         <div className="sa-gauge-container">
//                             <svg viewBox="0 0 100 55" className="sa-gauge-svg">
//                                 {/* Background Track */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="var(--sa-track)" strokeWidth="9" strokeLinecap="round" />

//                                 {/* Segment 4: Misc (Blue) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#0ea5e9" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s4 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2 + s3}`} />

//                                 {/* Segment 3: Appraisals (Orange) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#f97316" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s3 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2}`} />

//                                 {/* Segment 2: Form 16 (Yellow) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#fbbf24" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s2 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1}`} />

//                                 {/* Segment 1: Payslips (Purple) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#8b5cf6" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s1 - gap)} ${chartTotal}`}
//                                     strokeDashoffset="0" />
//                             </svg>

//                             <div className="sa-gauge-text">
//                                 <span className="sa-overall-num">{total}</span>
//                                 <span className="sa-overall-label">Overall</span>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="sa-legend-area">
//                         {[
//                             { label: "Payslips", count: payslips, color: "purple" },
//                             { label: "Form 16", count: form16, color: "yellow" },
//                             { label: "Appraisals", count: appraisal, color: "orange" },
//                             { label: "Miscellaneous", count: miscellaneous, color: "blue" }
//                         ].map((item, index) => (
//                             <div key={index} className="sa-legend-item">
//                                 <div className="sa-item-top">
//                                     <span className={`sa-dot ${item.color}`}></span>
//                                     <span className="sa-item-count">{item.count}</span>
//                                 </div>
//                                 <span className="sa-item-label">{item.label}</span>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <div className="sa-card-footer">
//                     <span className="sa-footer-link">View Detailed Report →</span>
//                 </div>
//             </div>
//         );
//     };



//     const [okrData, setOkrData] = useState([]);
//     useEffect(() => {
//         if (!userData?.id) return;

//         const fetchOKR = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/get_user_okr.php?empId=${userData.id}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     const parsed = typeof data.data === "string"
//                         ? JSON.parse(data.data)
//                         : data.data;

//                     setOkrData(parsed);
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchOKR();

//     }, [userData?.id]);



//     const [okrStats, setOkrStats] = useState({
//         total: 0,
//         completed: 0,
//         pending: 0,
//         progressPercent: 0
//     });



//     const fetchOKRStats = async () => {
//         if (!userData?.EmpId) return;

//         try {
//             const res = await fetch(
//                 `/gt-api/get_okr_stats.php?empId=${userData.EmpId}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setOkrStats(data);
//             }

//         } catch (err) {
//             console.error("OKR STATS ERROR:", err);
//         }
//     };

//     useEffect(() => {
//         if (!userData?.EmpId) return;

//         fetchOKRStats();

//         const handleUpdate = () => fetchOKRStats();

//         window.addEventListener("okrUpdated", handleUpdate);

//         return () => window.removeEventListener("okrUpdated", handleUpdate);

//     }, [userData?.EmpId]);




//     const renderOKRCard = () => {
//         const { total, completed, pending, progressPercent } = okrStats;

//         return (
//             <div
//                 className="expanded-management-card clickable"
//                 onClick={() => handleModuleChange("okr and performance tracker")}
//             >
//                 <div className="okr-card-container">

//                     {/* HEADER */}
//                     <div className="okr-header">
//                         <div>
//                             <span className="eyebrow-text">Performance Tracker</span>
//                             <h2 className="display-title">OKR Progress</h2>
//                         </div>

//                         {/* TOP RIGHT TOTAL */}
//                         <div className="stat-box featured big">
//                             <span className="stat-label">Total KR</span>
//                             <span className="stat-value">{total}</span>
//                         </div>
//                     </div>

//                     {/* STATS ROW */}
//                     <div className="okr-stats-row">
//                         <div className="stat-box danger">
//                             <span className="stat-label">Pending</span>
//                             <span className="stat-value">{pending}</span>
//                         </div>

//                         <div className="stat-box success">
//                             <span className="stat-label">Completed</span>
//                             <span className="stat-value">{completed}</span>
//                         </div>
//                     </div>

//                     {/* PROGRESS FULL WIDTH */}
//                     <div className="progress-section-wide full">
//                         <div className="progress-labels">
//                             <span className="label-muted">Completion</span>
//                             <span className="label-bold">{progressPercent}%</span>
//                         </div>

//                         <div className="wide-bar-bg">
//                             <div
//                                 className="wide-bar-fill"
//                                 style={{ width: `${progressPercent}%` }}
//                             ></div>
//                         </div>
//                     </div>

//                     {/* FOOTER */}
//                     <div className="expanded-footer">
//                         <span className={`status-indicator ${pending > 0 ? 'is-warning' : 'is-clear'}`}>
//                             {pending > 0
//                                 ? `● ${pending} Key Results Pending`
//                                 : '● All Key Results Completed'}
//                         </span>

//                         <span className="interaction-hint">
//                             Open OKR Console →
//                         </span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     const [mgmtOneOnOneData, setMgmtOneOnOneData] = useState([]);
//     useEffect(() => {
//         const fetchMeetings = async () => {
//             const storedUser = localStorage.getItem('userData');
//             const user = JSON.parse(storedUser) || {};

//             const res = await fetch(
//                 `/gt-api/get_oneonone.php?manager_id=${user.id}&role=manager`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.meetings) {
//                 setMgmtOneOnOneData(data.meetings);
//             }
//         };

//         fetchMeetings();
//     }, []);

//     const renderOneOnOneHealthCard = () => {
//         const missedData = mgmtOneOnOneData.filter(m => m.status === "MISSED");

//         const total = mgmtOneOnOneData.length;
//         const missed = mgmtOneOnOneData.filter(m => m.status === "MISSED").length;
//         const completed = total - missed;

//         const rate = total > 0 ? Math.round((completed / total) * 100) : 0;

//         let status = "Healthy";
//         if (rate < 50) status = "Critical ⚠️";
//         else if (rate < 80) status = "Needs Attention";

//         return (
//             <div className="meeting-card" onClick={() => handleModuleChange("manager-one-on-one")}>

//                 <div className="mc-header">
//                     <h3>1:1 Meeting Scheduler</h3>
//                     <span>{status}</span>
//                 </div>

//                 {/* BIG NUMBER */}
//                 <div className="mc-center">
//                     <h1>{rate}%</h1>
//                     <p>Engagement</p>
//                 </div>

//                 {/* BARS */}
//                 <div className="mc-bars">
//                     <div className="bar completed" style={{ width: `${rate}%` }}></div>
//                     <div className="bar missed" style={{ width: `${100 - rate}%` }}></div>
//                 </div>

//                 {/* INFO */}
//                 <div className="mc-info">
//                     <span>✅ {completed} Done</span>
//                     <span>❌ {missed} Missed</span>
//                 </div>
//                 <button
//                     className="view-missed-btn"
//                     onClick={(e) => {
//                         e.stopPropagation();
//                         setShowMissedModal(true);
//                     }}
//                 >
//                     View Missed
//                 </button>

//             </div>
//         );
//     };

//     const [okrActivity, setOkrActivity] = useState([]);
//     useEffect(() => {
//         const fetchOKR = async () => {
//             try {
//                 const storedUser = localStorage.getItem("userData");
//                 const user = JSON.parse(storedUser) || {};

//                 const res = await fetch(
//                     `/gt-api/get_employee_okrs.php?role=${user.role}&managedDept=${user.department}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 if (data.success) {
//                     setOkrActivity(data.data);
//                 }

//             } catch (err) {
//                 console.error("OKR Fetch Error:", err);
//             }
//         };

//         fetchOKR();
//     }, []);

//     const recentOKR = okrActivity
//         .slice(0, 5)
//         .map(item => {
//             let type = "updated";

//             if (item.workflow_status === "Planning") {
//                 type = "new";
//             }

//             if (item.workflow_status === "Manager_Scoring_Review") {
//                 type = "pending";
//             }

//             return {
//                 name: item.emp_name,
//                 quarter: item.quarter,
//                 type,
//                 workflow_status: item.workflow_status   // 🔥 VERY IMPORTANT
//             };
//         });



//     const renderOKRActivityCard = () => {
//         const getStatusConfig = (status) => {
//             switch (status) {
//                 case "Planning": return { color: "#3b82f6", label: "submitted OKR" };
//                 case "Management_Review": return { color: "#f59e0b", label: "sent for Review" };
//                 case "Scoring": return { color: "#8b5cf6", label: "sent for Scoring" };
//                 case "Sign_Off": return { color: "#10b981", label: "finalized OKR" };
//                 default: return { color: "#00bcd4", label: "updated OKR" };
//             }
//         };

//         return (
//             <div className="mgt-okr-card1 timeline-style clickable" onClick={() => handleModuleChange("employee-okrs")}>
//                 <div className="card-header-v2">
//                     <div className="title-section">
//                         <h3>OKR Stream</h3>
//                         <div className="live-dot-wrapper">
//                             <span className="live-dot"></span>
//                             <span className="sub-text">Live updates</span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="okr-activity-timeline">
//                     {recentOKR.length === 0 ? (
//                         <div className="empty-state">No recent activity detected</div>
//                     ) : (
//                         recentOKR.slice(0, 3).map((item, i) => {
//                             const config = getStatusConfig(item.workflow_status);
//                             return (
//                                 <div key={i} className="timeline-item">
//                                     {/* The Vertical Line & Dot */}
//                                     <div className="timeline-visual">
//                                         <div className="timeline-line"></div>
//                                         <div className="timeline-marker" style={{ borderColor: '#111827', background: config.color }}>
//                                             <div className="marker-inner-dot"></div>
//                                         </div>
//                                     </div>

//                                     {/* Single Content Box */}
//                                     <div className="timeline-content-box">
//                                         <div className="content-top">
//                                             <span className="emp-name">{item.name}</span>
//                                             <span className="quarter-tag">{item.quarter}</span>
//                                         </div>
//                                         <p className="status-message">{config.label}</p>
//                                     </div>
//                                 </div>
//                             );
//                         })
//                     )}
//                 </div>

//                 <div className="card-footer-v2">
//                     <span>Access Module</span>
//                     {/* <div className="arrow-circle">→</div> */}
//                 </div>


//             </div>
//         );
//     };

//     const renderManagementShortcutsCard = () => {
//         const shortcuts = [

//             { name: "Create Invoice", icon: "🏦", slug: "create-invoice" },
//             { name: "Policy RnU", icon: "📋", slug: "policy-logs" },
//             { name: "Career Development", icon: "🏆", slug: "career pathways" },
//             { name: "Expense Reimbursement", icon: "💰", slug: "reimbursements" },
//             // { name: "ACM Updates", icon: "📢", slug: "manage-quarterly-updates" },
//             { name: "Self OKR", icon: "🎯", slug: "okr and performance tracker" },
//             { name: "Own Financial", icon: "💳", slug: "pay and benefits" },
//             { name: "Access ACM Info", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//             // { name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },
//             { name: "IT Support", icon: "🖥️", slug: "employee-it-support" },
//             { name: "Attendance Tracker", icon: "📊", slug: "attendance-tracker" },
//              { name: "Award Analytics", icon: "🏆", slug: "award-analytics" },
//             // { name: "Company Setup", icon: "⚙️", slug: "CompanySetup" },





//         ];

//         return (
//             <div className="mgt-shortcut-card">

//                 <div className="card-header">
//                     <h3>Quick Access</h3>
//                     <span className="sub-text">Shortcuts</span>
//                 </div>

//                 <div className="shortcut-grid">
//                     {shortcuts.map((item, i) => (
//                         <div
//                             key={i}
//                             className="shortcut-item"
//                             onClick={() => handleModuleChange(item.slug)}
//                         >
//                             <span className="shortcut-icon">{item.icon}</span>
//                             <span className="shortcut-text">{item.name}</span>
//                         </div>
//                     ))}
//                 </div>

//             </div>
//         );
//     };


//     const renderEmployeeDashboard = () => {
//         return (
//             <div className="dashboard-layout">

//                 <div className="dashboard-row row-top">
//                     {renderLeavePieChart()}
//                     {renderPayChart()}
//                     {renderOneOnOneCard()}



//                     {/* {renderEquipmentCard()} */}
//                 </div>

//                 <div className="dashboard-row row-middle">
//                     {renderOKRCard()}
//                     {renderCareerPathwaysCard()}
//                 </div>

//                 <div className="dashboard-row row-bottom">
//                     {renderPolicyCard()}
//                     <QuarterlyCard handleModuleChange={handleModuleChange} />
//                 </div>

//             </div>
//         );
//     };

//     const renderManagementDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>






//         );
//     };

//     const renderManagerDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>




//         );
//     };

//     const currentEvent =
//         todayEvents && todayEvents.length > 0
//             ? todayEvents[currentEventIndex]
//             : null;


//     const combinedEvents = [];

//     // 🎊 Festival TODAY (Priority if festival is today)
//     if (upcomingFestival && isFestivalToday) {
//         combinedEvents.push({
//             type: "festival",
//             title: upcomingFestival.name,
//             tag: "FESTIVAL TODAY",
//             icon: "🎊",
//             sub: "Today 🎉"
//         });
//     }

//     // 🎂 Birthday / Anniversary
//     if (currentEvent && currentEvent.fullName) {
//         combinedEvents.push({
//             type: "event",
//             title: currentEvent.fullName,
//             tag: currentEvent.isBirthday ? "BIRTHDAY" : "WORK ANNIVERSARY",
//             icon: currentEvent.isBirthday ? "🎂" : "🎉"
//         });
//     }

//     // 🎊 Upcoming Festival (If future)
//     if (upcomingFestival && !isFestivalToday) {
//         combinedEvents.push({
//             type: "festival",
//             title: upcomingFestival.name,
//             tag: "UPCOMING FESTIVAL",
//             icon: "🎊",
//             sub: `In ${daysLeft} days`
//         });
//     }

//     useEffect(() => {
//         if (combinedEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setActiveEventIndex(prev => (prev + 1) % combinedEvents.length);
//         }, 4000);

//         return () => clearInterval(interval);
//     }, [combinedEvents.length]);

//     const activeEvent = combinedEvents[activeEventIndex];


//     return (

//         <div


//             className={`dash-container ${theme}-theme`}
//             style={
//                 theme === 'light'
//                     ? {
//                         backgroundImage: `url(${logoLight})`,
//                         backgroundSize: 'cover',
//                         backgroundRepeat: 'no-repeat',
//                         backgroundPosition: 'center',
//                         backgroundColor: 'var(--bg-main)'

//                     }
//                     : {}
//             }
//         >


//             {showMissedModal && (
//                 <div className="modal-overlay" onClick={() => setShowMissedModal(false)}>
//                     <div className="modal-card" onClick={(e) => e.stopPropagation()}>

//                         <h3>Missed 1:1 Meetings</h3>

//                         {mgmtOneOnOneData.filter(m => m.status === "MISSED").length === 0 ? (
//                             <p>No missed meetings 🎉</p>
//                         ) : (
//                             mgmtOneOnOneData
//                                 .filter(m => m.status === "MISSED")
//                                 .map((m, i) => (
//                                     <div key={i} className="missed-item">
//                                         <strong>{m.employee_name}</strong>
//                                         <span>{m.date}</span>
//                                     </div>
//                                 ))
//                         )}

//                         <button onClick={() => setShowMissedModal(false)}>
//                             Close
//                         </button>

//                     </div>
//                 </div>
//             )}



//             <div className="auth-background-overlay"></div>






//             <Sidebar
//                 role={role}
//                 userData={userData}
//                 activeModule={activeModule}
//                 openMenus={openMenus}
//                 toggleSubMenu={toggleSubMenu}
//                 handleModuleChange={handleModuleChange}
//                 handleLogout={handleLogout}
//                 mobileMenuOpen={mobileMenuOpen}
//                 setMobileMenuOpen={setMobileMenuOpen}
//                 pendingRequestsCount={pendingRequestsCount}
//             />

//             <main className="dash-content">

//                 <header className="content-header">

//                     {/* 🔷 LEFT */}
//                     <div className="header-left">
//                         <div className="header-text">

//                             <h1>
//                                 {activeModule === "grid" && !showProfile ? "Welcome," : ""}{" "}
//                                 <span className={theme === 'light' ? "name-light" : "name-accent"}>
//                                     {showProfile
//                                         ? "MY PROFILE"
//                                         : (activeModule === "grid"
//                                             ? userData.firstName || userData.FirstName
//                                             : (activeModule === "attendance"
//                                                 ? "LEAVE MANAGEMENT"
//                                                 : (activeModule === "one-on-one-report"
//                                                     ? "ONE-ON-ONE REPORT"
//                                                     : activeModule.toUpperCase().replace(/-/g, ' ')
//                                                 )
//                                             )
//                                         )
//                                     }
//                                 </span>
//                             </h1>

//                             {activeModule === 'attendance' && userData.joiningDate && (
//                                 <div className="joining-info">
//                                     JOINING_DATE: {new Date(userData.joiningDate).toLocaleDateString('en-GB').toUpperCase()}
//                                 </div>
//                             )}

//                         </div>
//                     </div>







//                     <div className="header-center">

//                         {/* TIME + DATE FIRST */}
//                         <div className="time-date-right">
//                             <div className="live-time">{currentTime}</div>

//                             <div className="today-widget">
//                                 <span>📅 {todayDate}</span>
//                                 <small>Have a Nice Day!</small>
//                             </div>
//                         </div>

//                         {/* EVENT CARD SECOND */}
//                         <div
//                             className={`executive-event-bar ${theme === 'light' ? 'light-theme-elite' : 'dark-theme-elite'}
//         ${role === "Management" || role === "Manager" ? "clickable" : ""}`}
//                             onClick={() => {
//                                 if (role === "Management" || role === "Manager") {
//                                     handleModuleChange("events-celebrations");
//                                 }
//                             }}
//                         >
//                             <div
//                                 className={`event-status-box ${activeEvent
//                                     ? (activeEvent.type === 'festival'
//                                         ? 'bg-fest'
//                                         : (activeEvent.tag === 'BIRTHDAY' ? 'bg-birth' : 'bg-anniv'))
//                                     : 'bg-neutral'
//                                     }`}
//                             >
//                                 <span className="event-icon-small">
//                                     {activeEvent ? activeEvent.icon : "✨"}
//                                 </span>
//                             </div>

//                             <div className="event-content-main">
//                                 <div className="event-label-row">
//                                     <span className="event-tag">
//                                         {activeEvent ? activeEvent.tag : "TODAY"}
//                                     </span>
//                                 </div>

//                                 <h3 className="event-title-text">

//                                     {activeEvent ? (
//                                         <span className="event-highlight">
//                                             {activeEvent.icon} {activeEvent.title}
//                                         </span>
//                                     ) : (
//                                         <span className="event-empty-text">
//                                             No events today
//                                         </span>
//                                     )}
//                                 </h3>
//                             </div>

//                             <div className="event-action-wrapper">
//                                 <button
//                                     className="minimal-wish-btn"
//                                     disabled={!currentEvent}
//                                     onClick={(e) => e.stopPropagation()}
//                                 >
//                                     <div className="btn-line"></div>
//                                 </button>
//                             </div>
//                         </div>

//                     </div>







//                     <div className="header-controls">

//                         {/* 🌗 THEME */}
//                         <div className="theme-switch-container">
//                             <label className="theme-slider-switch">
//                                 <input
//                                     type="checkbox"
//                                     onChange={toggleTheme}
//                                     checked={theme === 'light'}
//                                 />
//                                 <span className="theme-slider round">
//                                     <span className="sun-icon">☀️</span>
//                                     <span className="moon-icon">🌙</span>
//                                 </span>
//                             </label>
//                         </div>




//                         {(activeModule !== "grid" || showProfile) && (
//                             <button
//                                 className="back-btn"
//                                 onClick={() => handleModuleChange("grid")}
//                             >
//                                 Back
//                             </button>
//                         )}

//                     </div>

//                 </header>


//                 {activeModule === "grid" ? (

//                     role === "Management"
//                         ? renderManagementDashboard()
//                         : role === "Manager"
//                             ? renderManagerDashboard()   // 🔥 ADD THIS LINE
//                             : renderEmployeeDashboard()

//                 ) : (
//                     renderActiveModule()
//                 )}

//                 <div className="dash-footer">
//                     Design & Developed by Genesis Tech Engineers © 2026
//                 </div>
//             </main>

//             {(role === "Management" || role === "Manager") && (
//                 <>
//                     <div
//                         className="ai-chat-float-btn"
//                         onClick={() => setShowAIChat(true)}
//                     >
//                         🤖
//                     </div>

//                     {showAIChat && (
//                         <div className="ai-chat-modal">
//                             <div className="ai-chat-header">
//                                 <span>ELMS AI Assistant</span>
//                                 <button onClick={() => setShowAIChat(false)}>
//                                     ✕
//                                 </button>
//                             </div>

//                             <div className="ai-chat-body">
//                                 {chatMessages.map((msg, index) => (
//                                     <div
//                                         key={index}
//                                         className={`chat-bubble ${msg.sender}`}
//                                     >
//                                         <pre>{msg.text}</pre>
//                                     </div>
//                                 ))}

//                                 {chatLoading && (
//                                     <div className="chat-bubble ai">
//                                         Thinking...
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="ai-chat-footer">
//                                 <input
//                                     type="text"
//                                     value={chatInput}
//                                     onChange={(e) => setChatInput(e.target.value)}
//                                     placeholder="Ask anything..."
//                                     onKeyDown={(e) => {
//                                         if (e.key === "Enter") {
//                                             sendAIMessage();
//                                         }
//                                     }}
//                                 />

//                                 <button onClick={sendAIMessage}>
//                                     Send
//                                 </button>
//                             </div>
//                         </div>
//                     )}
//                 </>
//             )}

//             {/* 🔴 MANDATORY PROFILE POPUP MODAL */}
//             {showMandatoryProfileModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">⚠️</div>
//                             <h2>Mandatory Profile Completion Required</h2>
//                             <p>
//                                 Your employee profile has missing information. Please fill in the required field(s) below to continue using the system.
//                             </p>
//                         </div>

//                         {mandatoryError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {mandatoryError}</span>
//                             </div>
//                         )}

//                         {mandatorySuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {mandatorySuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryProfile} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingProfileFields.phone && (
//                                     <div className="mandatory-input-group">
//                                         <label>Mobile Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="tel"
//                                             placeholder="Enter mobile number"
//                                             value={mandatoryFormData.phone}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, phone: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.dob && (
//                                     <div className="mandatory-input-group">
//                                         <label>Date of Birth <span className="req-star">*</span></label>
//                                         <input
//                                             type="date"
//                                             max={new Date().toISOString().split("T")[0]}
//                                             value={mandatoryFormData.dob}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, dob: e.target.value }))}
//                                             onClick={(e) => {
//                                                 try {
//                                                     if (e.target.showPicker) e.target.showPicker();
//                                                 } catch (err) { }
//                                             }}
//                                             required
//                                             className="mandatory-date-input"
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.city && (
//                                     <div className="mandatory-input-group">
//                                         <label>City <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter city"
//                                             value={mandatoryFormData.city}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, city: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.country && (
//                                     <div className="mandatory-input-group">
//                                         <label>Country <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter country"
//                                             value={mandatoryFormData.country}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, country: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Permanent Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter permanent address"
//                                             value={mandatoryFormData.address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.local_address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Current / Local Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter current / local address"
//                                             value={mandatoryFormData.local_address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, local_address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={mandatorySaving}
//                                 >
//                                     {mandatorySaving ? "Saving Profile..." : "Save Profile & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//             {/* 🏦 MANDATORY BANK DETAILS POPUP MODAL */}
//             {showMandatoryBankModal && !showMandatoryProfileModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">🏦</div>
//                             <h2>Mandatory Bank Details Required</h2>
//                             <p>
//                                 Your employee bank record has missing information. Please fill in the required field(s) below for payroll & salary processing.
//                             </p>
//                         </div>

//                         {bankError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {bankError}</span>
//                             </div>
//                         )}

//                         {bankSuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {bankSuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryBankDetails} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingBankFields.bankName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Bank Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC Bank, ICICI Bank"
//                                             value={bankFormData.bankName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, bankName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.holderName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Holder Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account holder name"
//                                             value={bankFormData.holderName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, holderName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accNumber && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account number"
//                                             value={bankFormData.accNumber}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accNumber: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.ifsc && (
//                                     <div className="mandatory-input-group">
//                                         <label>IFSC Code <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC0001234"
//                                             value={bankFormData.ifsc}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, ifsc: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.branch && (
//                                     <div className="mandatory-input-group">
//                                         <label>Branch Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter branch name"
//                                             value={bankFormData.branch}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, branch: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accType && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Type <span className="req-star">*</span></label>
//                                         <select
//                                             value={bankFormData.accType}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accType: e.target.value }))}
//                                             required
//                                         >
//                                             <option value="Saving Account">Saving Account</option>
//                                             <option value="Current Account">Current Account</option>
//                                             <option value="Salary Account">Salary Account</option>
//                                         </select>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={bankSaving}
//                                 >
//                                     {bankSaving ? "Saving Bank Details..." : "Save Bank Details & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Dashboard;

































// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';

// import {
//     ResponsiveContainer,
//     BarChart,
//     Bar,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip
// } from "recharts";
// import { Bar as ChartBar, Pie, Doughnut } from 'react-chartjs-2';

// // ✅ REACT + ROUTER
// import React, { useState, useEffect, useMemo } from 'react';
// import { useParams, useNavigate, useLocation } from 'react-router-dom';

// // ✅ MODULES
// import Attendance from '../../modules/Attendance';
// import PayBenefits from '../../modules/PayBenefits';
// import OKRTracker from '../../modules/OKRTracker';
// import CareerPathways from '../../modules/CareerPathways';
// import EquipmentRequest from '../../modules/EquipmentRequest';
// import OfficeRequisition from '../../modules/OfficeRequisition';
// import ITSupport from '../../modules/ITSupport';
// import Documents from '../../modules/Documents';
// import CompanyPolicy, { GENESIS_POLICIES } from '../../modules/CompanyPolicy';
// import OrgChart from '../../modules/OrgChart';
// import CampusInfo from '../../modules/CampusInfo';
// import AddDepartment from '../../modules/AddDepartment';
// import AddEmployee from '../../modules/AddEmployee';
// import ManageDepartment from '../../modules/ManageDepartment';
// import ManageEmployee from '../../modules/ManageEmployee';
// import MyProfile from '../../modules/MyProfile';
// import LeaveManagement from '../../modules/LeaveManagement';
// import EESExperience from '../../modules/EESExperience';
// import EESFeedbackManagement from '../../modules/EESFeedbackManagement';
// import MedicalReports from '../../modules/MedicalReports';
// import ManagementOKRViewer from '../../modules/ManagementOKRViewer';
// import ManagerLeaveManagement from '../../modules/ManagerLeaveManagement';
// import ManagerMedicalReports from '../../modules/ManagerMedicalReports';
// import EmployeeSalaryBenefits from '../../modules/EmployeeSalaryBenefits';
// import PolicyAdminDashboard from '../../modules/PolicyAdminDashboard';
// import ManageEmployeeDocs from '../../modules/ManageEmployeeDocs';
// import OneOnOne from '../../modules/OneOnOne';
// import EventsCelebrations from '../../modules/EventsCelebrations';
// import ProjectModule from '../../modules/ProjectModule';
// import QuarterlyUpdates from '../../modules/QuarterlyUpdates';
// import ManagementQuarterlyUpdate from '../../modules/ManagementQuarterlyUpdate';
// import ReimbursementManagement from '../../modules/ReimbursementManagement';
// import WorkFromHome from '../../modules/WorkFromHome';
// import WFHManagement from '../../modules/WFHManagement';
// import OneOnOneAnalyticsCard from "../../modules/OneOnOneAnalyticsCard";
// import OneOnOneReport from '../../modules/OneOnOneReport';
// import InvoiceGenerator from '../../modules/InvoiceGenerator';
// import AttendanceTracker from '../../modules/AttendanceTracker';
// import CompanySetup from '../../modules/CompanySetup';
// import AwardNominations from '../../modules/AwardNominations';
// import AwardAnalyticsDashboard from '../../modules/AwardAnalyticsDashboard';
// import Sidebar from "../../components/Sidebar/sidebar";

// // ✅ ASSETS
// import logoLight from '../../assets/logowhite-p.png';
// import logoDark from '../../assets/logo-white-r.png';

// // ✅ STYLES
// import './Dashboard.css';


// // ✅ CHART.JS CORE
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip as ChartTooltip,  // ✅ rename this
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// } from 'chart.js';

// // ✅ REGISTER CHART.JS
// ChartJS.register(
//     ArcElement,
//     ChartTooltip, // ✅ use renamed one
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// );



// const QuarterlyCard = ({ handleModuleChange }) => {

//     const [latest, setLatest] = React.useState(null);

//     React.useEffect(() => {
//         fetch(
//             "/gt-api/get_quarterly_media.php?type=ACM Presentation",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "ACM DATA:",
//                     data
//                 );

//                 if (data.success && data.data.length > 0) {
//                     setLatest(data.data[0]);
//                 }
//             })
//             .catch(err => console.error("Quarterly Fetch Error:", err));
//     }, []);

//     console.log("LATEST ACM:", latest);

//     return (
//         <div
//             className="quarterly-pro-card clickable"
//             onClick={() => handleModuleChange("quarterly-updates")}
//         >
//             {/* Glow Layer */}
//             <div className="card-glow"></div>

//             {/* HEADER */}
//             <div className="qp-header">
//                 <div className="qp-left">
//                     <span className="qp-tag">ACM Updates</span>
//                     <h3 className="qp-title">Quarterly Insights</h3>
//                 </div>

//                 <div className="qp-icon">📢</div>
//             </div>

//             {/* BODY */}
//             <div className="qp-body">
//                 {latest ? (
//                     <>
//                         <h4 className="qp-main-title">{latest.title}</h4>

//                         <div className="qp-meta">
//                             <span className="qp-date">
//                                 {new Date(latest.created_at).toLocaleDateString('en-GB')}
//                             </span>
//                             <span className="qp-badge">NEW</span>
//                         </div>
//                     </>
//                 ) : (
//                     <div className="qp-empty">
//                         <div className="qp-loader"></div>
//                         <span>Awaiting next update</span>
//                     </div>
//                 )}
//             </div>

//             {/* FOOTER */}
//             <div className="qp-footer">
//                 <span>View Presentation</span>
//                 <span className="arrow">→</span>
//             </div>
//         </div>
//     );
// };


// const Dashboard = () => {
//     const [dashboardDepartments, setDashboardDepartments] = useState([]);
//     const [dashboardPathways, setDashboardPathways] = useState([]);
//     const [policyCount, setPolicyCount] = useState(0);

//     const [showAIChat, setShowAIChat] = useState(false);

//     const [chatMessages, setChatMessages] = useState([
//         {
//             sender: "ai",
//             text: "Hello 👋 Ask me anything about your ELMS database."
//         }
//     ]);

//     const [chatInput, setChatInput] = useState("");
//     const [chatLoading, setChatLoading] = useState(false);



//     const [showMissedModal, setShowMissedModal] = useState(false);

//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//     const [todayEvents, setTodayEvents] = useState([]);
//     useEffect(() => {
//         const fetchTodayEvents = async () => {
//             try {
//                 const res = await fetch('/gt-api/get_celebrations.php');
//                 const data = await res.json();

//                 if (data.success) {
//                     setTodayEvents(data.data || []);
//                 }
//             } catch (err) {
//                 console.error("Dashboard Events Error:", err);
//             }
//         };

//         fetchTodayEvents();
//     }, []);
//     const [currentEventIndex, setCurrentEventIndex] = useState(0);
//     useEffect(() => {
//         if (!todayEvents || todayEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setCurrentEventIndex((prev) =>
//                 (prev + 1) % todayEvents.length
//             );
//         }, 3000); // change every 3 sec

//         return () => clearInterval(interval);
//     }, [todayEvents]);


//     const [equipmentData, setEquipmentData] = useState({
//         total: 0,
//         pending: 0,
//         blocking: 0
//     });



//     const [logs, setLogs] = useState({});

//     const totalPolicies = 11;
//     const readCount = Object.keys(logs || {}).length;

//     const progress = totalPolicies > 0
//         ? Math.round((readCount / totalPolicies) * 100)
//         : 0;


//     const params = useParams();
//     const module = params.module;

//     const storedUser = JSON.parse(localStorage.getItem("userData"));
//     const role = storedUser?.role;
//     const navigate = useNavigate();

//     useEffect(() => {
//         const storedUser = localStorage.getItem("userData");

//         if (!storedUser) {
//             navigate("/", { replace: true });
//             return;
//         }

//         // prevent back button access after logout
//         window.history.pushState(null, "", window.location.href);
//         window.onpopstate = function () {
//             const user = localStorage.getItem("userData");
//             if (!user) {
//                 navigate("/", { replace: true });
//             }
//         };

//     }, [navigate]);







//     const [policyLogs, setPolicyLogs] = useState({});





//     const checkIfFestivalIsToday = (festival, daysLeftVal, isTodayFlag) => {
//         if (!festival) return false;
//         if (isTodayFlag === true || daysLeftVal === 0) return true;

//         if (festival.date) {
//             const today = new Date();
//             const currentDay = today.getDate();
//             const currentMonth = today.getMonth();
//             const monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
//             const currentMonthName = monthNames[currentMonth];

//             const dateLower = String(festival.date).trim().toLowerCase();

//             // 1. Text Month Matching (e.g., "7th Sep", "7 Sep", "2nd to 10th Oct")
//             if (dateLower.includes(currentMonthName) || (currentMonthName === "sep" && dateLower.includes("sept"))) {
//                 const rangeMatch = dateLower.match(/(\d+)\s*(?:st|nd|rd|th)?\s*to\s*(\d+)\s*(?:st|nd|rd|th)?/);
//                 if (rangeMatch) {
//                     const startDay = parseInt(rangeMatch[1], 10);
//                     const endDay = parseInt(rangeMatch[2], 10);
//                     if (currentDay >= startDay && currentDay <= endDay) {
//                         return true;
//                     }
//                 }

//                 const numbers = dateLower.match(/\d+/g);
//                 if (numbers) {
//                     for (let numStr of numbers) {
//                         const num = parseInt(numStr, 10);
//                         if (num === currentDay) {
//                             return true;
//                         }
//                     }
//                 }
//             }

//             // 2. Numeric Date Matching (e.g., "7-9-2026", "07-09-2026", "7/9/2026", "2026-09-07")
//             const numMatch = dateLower.match(/^(\d{1,4})[-/.](\d{1,2})[-/.](\d{1,4})$/);
//             if (numMatch) {
//                 let p1 = parseInt(numMatch[1], 10);
//                 let p2 = parseInt(numMatch[2], 10);
//                 let p3 = parseInt(numMatch[3], 10);

//                 let d, m;
//                 if (p1 > 31) {
//                     m = p2; d = p3;
//                 } else {
//                     d = p1; m = p2;
//                 }

//                 if (d === currentDay && m === (currentMonth + 1)) {
//                     return true;
//                 }
//             }
//         }

//         if (typeof daysLeftVal === 'number' && daysLeftVal === 0) {
//             return true;
//         }

//         return false;
//     };

//     const [upcomingFestival, setUpcomingFestival] = useState(null);
//     const [daysLeft, setDaysLeft] = useState(null);
//     const [isFestivalToday, setIsFestivalToday] = useState(false);
//     const [activeEventIndex, setActiveEventIndex] = useState(0);
//     useEffect(() => {
//         fetch("/gt-api/get_upcoming_festival.php", {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 const fest = data.festival || data.upcoming || (data.data && data.data[0]);
//                 if (fest) {
//                     const normalized = {
//                         ...fest,
//                         name: fest.name || fest.festival_name || fest.title || "Festival",
//                         image: fest.image || fest.img || fest.imageName || ""
//                     };
//                     setUpcomingFestival(normalized);
//                     setDaysLeft(data.daysLeft ?? 0);
//                     const festIsToday = data.isToday || data.daysLeft === 0 || checkIfFestivalIsToday(normalized, data.daysLeft, data.isToday);
//                     setIsFestivalToday(festIsToday);
//                 }
//             })
//             .catch(err => console.error(err));
//     }, []);


//     const location = useLocation();



//     const [showProfile, setShowProfile] = useState(false);
//     const [showPasswordModal, setShowPasswordModal] = useState(false);
//     const [isEditing, setIsEditing] = useState(false);

//     const [activeModule, setActiveModule] = useState(module || "grid");
//     const [isLightMode, setIsLightMode] = useState(false);

//     const [openMenus, setOpenMenus] = useState({
//         department: false,
//         employee: false
//     });

//     const [pendingRequestsCount, setPendingRequestsCount] = useState(0);
//     const [pendingLeavesCount, setPendingLeavesCount] = useState(0);
//     const [requestsList, setRequestsList] = useState([]);
//     const [notifCount, setNotifCount] = useState(0);

//     const [eesSubmissions, setEesSubmissions] = useState([]);
//     const handleEESSubmit = (newFeedback) => {
//         setEesSubmissions(prev => [...prev, newFeedback]);
//     };

//     const [passwordForm, setPasswordForm] = useState({
//         currentPassword: '',
//         newPassword: '',
//         confirmPassword: ''
//     });

//     const [showMandatoryProfileModal, setShowMandatoryProfileModal] = useState(false);
//     const [missingProfileFields, setMissingProfileFields] = useState({
//         phone: false,
//         dob: false,
//         city: false,
//         address: false,
//         local_address: false,
//         country: false
//     });
//     const [mandatoryFormData, setMandatoryFormData] = useState({
//         phone: '',
//         dob: '',
//         city: '',
//         address: '',
//         local_address: '',
//         country: ''
//     });
//     const [mandatorySaving, setMandatorySaving] = useState(false);
//     const [mandatoryError, setMandatoryError] = useState('');
//     const [mandatorySuccessMsg, setMandatorySuccessMsg] = useState('');

//     // 🔴 MANDATORY BANK DETAILS MODAL STATE
//     const [showMandatoryBankModal, setShowMandatoryBankModal] = useState(false);
//     const [missingBankFields, setMissingBankFields] = useState({
//         bankName: false,
//         holderName: false,
//         accNumber: false,
//         ifsc: false,
//         branch: false,
//         accType: false
//     });
//     const [bankFormData, setBankFormData] = useState({
//         bankName: '',
//         holderName: '',
//         accNumber: '',
//         ifsc: '',
//         branch: '',
//         accType: 'Saving Account'
//     });
//     const [bankSaving, setBankSaving] = useState(false);
//     const [bankError, setBankError] = useState('');
//     const [bankSuccessMsg, setBankSuccessMsg] = useState('');

//     // 📜 MANDATORY COMPANY POLICY ACKNOWLEDGEMENT MODAL STATE
//     const [showMandatoryPolicyModal, setShowMandatoryPolicyModal] = useState(false);
//     const [allPoliciesList, setAllPoliciesList] = useState([]);
//     const [unacknowledgedPolicies, setUnacknowledgedPolicies] = useState([]);
//     const [selectedMandatoryPolicy, setSelectedMandatoryPolicy] = useState(null);
//     const [policyAckSaving, setPolicyAckSaving] = useState(false);
//     const [policyAckError, setPolicyAckError] = useState('');
//     const [policyAckSuccessMsg, setPolicyAckSuccessMsg] = useState('');
//     const [totalPoliciesCount, setTotalPoliciesCount] = useState(11);
//     const [acknowledgedPoliciesCount, setAcknowledgedPoliciesCount] = useState(0);
//     const [policyAgreed, setPolicyAgreed] = useState(false);




//     const [userData, setUserData] = useState(() => {
//         const storedData = localStorage.getItem("userData");
//         if (storedData) return JSON.parse(storedData);

//         const firstName = location.state?.userName?.split(' ')[0] || "User";
//         const lastName = location.state?.userName?.split(' ')[1] || "";

//         return {
//             firstName,
//             lastName,
//             email: "",
//             dept: "Loading...",
//             phone: "",
//             gender: "",
//             dob: "",
//             address: "",
//             city: "",
//             country: "",
//             employeeId: location.state?.empId || null,
//             profileImage: null,
//             joiningDate: null,
//             HOD: null
//         };
//     });


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_career_pathways.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setDashboardPathways(
//                         data.pathways || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_departments.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "DASHBOARD DEPARTMENTS:",
//                     data
//                 );

//                 if (data.success) {

//                     setDashboardDepartments(
//                         data.departments || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) {

//             setPolicyCount(11);
//             return;

//         }

//         fetch(
//             "/gt-api/get_policies.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setPolicyCount(
//                         data.policies?.length || 0
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);
//     // ✅ THEN use it
//     const employeeId = userData?.id || userData?.employeeId;


//     useEffect(() => {
//         const fetchLeaveDashboardData = async () => {
//             if (!employeeId) return;

//             try {
//                 const res = await fetch(`/gt-api/get_leaves.php?empid=${employeeId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 const wfhRes = await fetch(`/gt-api/get_wfh.php?empid=${employeeId}`, {
//                     credentials: "include"
//                 });
//                 const wfhData = await wfhRes.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];

//                     // 🔥 SAME LOGIC AS ATTENDANCE
//                     const today = new Date();
//                     const currentYear = today.getFullYear();

//                     const fiscalYearStart = new Date(currentYear, 3, 1);

//                     const activeFiscalYearStart =
//                         today < fiscalYearStart
//                             ? new Date(currentYear - 1, 3, 1)
//                             : fiscalYearStart;

//                     // ✅ Dynamic Sick Total (joining based)
//                     let sickTotal = 12;

//                     if (userData?.joiningDate) {
//                         const joining = new Date(userData.joiningDate);

//                         const fyEnd = new Date(activeFiscalYearStart);
//                         fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
//                         fyEnd.setMonth(2);
//                         fyEnd.setDate(31);

//                         if (joining > activeFiscalYearStart) {
//                             if (joining > fyEnd) {
//                                 sickTotal = 0;
//                             } else {
//                                 const joinMonth = joining.getMonth();
//                                 const fyEndMonth = 2;

//                                 let monthsRemaining;

//                                 if (joinMonth <= fyEndMonth) {
//                                     monthsRemaining = fyEndMonth - joinMonth + 1;
//                                 } else {
//                                     monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
//                                 }

//                                 sickTotal = monthsRemaining;
//                             }
//                         }
//                     }

//                     let sickUsed = 0;
//                     let earnedUsed = 0;

//                     leaves.forEach(leave => {
//                         const status = String(leave.Status);
//                         const days = parseFloat(leave.total) || 0;
//                         const leaveDate = new Date(leave.fromdate);
//                         const medStatus = String(leave.medical_doc_status);

//                         // ✅ SAME CONDITION AS ATTENDANCE
//                         if (status === '0' || status === '1') {

//                             if (leave.leavetype === 'Sick Leave') {
//                                 if (leaveDate >= activeFiscalYearStart) {
//                                     sickUsed += days;
//                                 }
//                             }

//                             else if (leave.leavetype === 'Earned Leave') {

//                                 // 🔥 MEDICAL CONVERSION LOGIC
//                                 if (medStatus === '1' || medStatus === '0') {
//                                     if (leaveDate >= activeFiscalYearStart) {
//                                         sickUsed += days;
//                                     }
//                                 } else {
//                                     earnedUsed += days;
//                                 }
//                             }
//                         }
//                     });


//                     console.log("LEAVES:", leaves);
//                     console.log("SICK USED:", sickUsed);
//                     console.log("EARNED USED:", earnedUsed);
//                     console.log("API EARNED BALANCE:", data.earned);

//                     setLeaveData({
//                         leaveHistory: leaves,
//                         leaveBalances: {
//                             sick: { used: sickUsed, total: sickTotal },
//                             earned: { used: earnedUsed, total: parseFloat(data.earned) || 0 }
//                         },
//                         wfhHistory: wfhData.requests || []
//                     });
//                 }

//             } catch (err) {
//                 console.error("Dashboard Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaveDashboardData();
//     }, [employeeId, userData?.joiningDate]);


//     useEffect(() => {
//         setActiveModule(module || "grid");
//     }, [module]);

//     useEffect(() => {

//         if (role === 'Management' || role === 'Manager') {

//             const fetchRealTimeLeaves = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_leaves.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {
//                         // Count requests with Status '0' or null
//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };


//             fetchRealTimeLeaves();


//             const liveInterval = setInterval(fetchRealTimeLeaves, 5000);

//             return () => clearInterval(liveInterval);
//         }
//     }, [role]);



//     useEffect(() => {

//         const fetchUserData = async () => {

//             try {

//                 const response = await fetch("/gt-api/get_profile.php", {
//                     credentials: "include"
//                 });

//                 const data = await response.json();

//                 if (data.success && data.employee) {

//                     const storedUser = JSON.parse(localStorage.getItem("userData"));

//                     const updatedUser = {
//                         id: data.employee.id,
//                         EmpId: data.employee.EmpId,

//                         firstName: data.employee.FirstName,
//                         FirstName: data.employee.FirstName,

//                         lastName: data.employee.LastName,
//                         LastName: data.employee.LastName,

//                         email: data.employee.EmailId,
//                         EmailId: data.employee.EmailId,

//                         Department: data.employee.DepartmentName || data.employee.Department,

//                         HOD: data.employee.HOD,
//                         Designation: data.employee.Designation,
//                         phone: data.employee.Phonenumber,
//                         gender: data.employee.Gender,
//                         dob: data.employee.Dob,
//                         address: data.employee.Address,
//                         local_address: data.employee.LocalAddress,
//                         city: data.employee.City,
//                         country: data.employee.Country,
//                         profileImage: data.employee.ProfilePicture || null,
//                         joiningDate: data.employee.JoiningDate,

//                         role: storedUser?.role
//                     };

//                     setUserData(updatedUser);

//                     localStorage.setItem("userData", JSON.stringify(updatedUser));

//                     // ✅ CHECK ONLY MISSING MANDATORY PROFILE FIELDS
//                     const isMissing = (val) => !val || String(val).trim() === '' || String(val).trim() === '0000-00-00';
//                     const missing = {
//                         phone: isMissing(updatedUser.phone),
//                         dob: isMissing(updatedUser.dob),
//                         city: isMissing(updatedUser.city),
//                         address: isMissing(updatedUser.address),
//                         local_address: isMissing(updatedUser.local_address),
//                         country: isMissing(updatedUser.country)
//                     };

//                     if (Object.values(missing).some(Boolean)) {
//                         setMissingProfileFields(missing);
//                         setMandatoryFormData({
//                             phone: updatedUser.phone || '',
//                             dob: updatedUser.dob || '',
//                             city: updatedUser.city || '',
//                             address: updatedUser.address || '',
//                             local_address: updatedUser.local_address || '',
//                             country: updatedUser.country || ''
//                         });
//                         setShowMandatoryProfileModal(true);
//                     }

//                     // 🏦 CHECK MANDATORY BANK DETAILS
//                     const empIdForBank = data.employee.id || data.employee.EmpId;
//                     if (empIdForBank) {
//                         let bank = null;
//                         try {
//                             const bankRes = await fetch(`/gt-api/get_bank_details.php?emp_id=${empIdForBank}`, {
//                                 credentials: "include"
//                             });
//                             const rawText = await bankRes.text();
//                             try {
//                                 const json = JSON.parse(rawText);
//                                 if (json && (json.success || json.bank || json.bank_name || json.bankName)) {
//                                     bank = json.bank || json.data || json.details || json.employee_bank_details || json;
//                                 }
//                             } catch (parseErr) {
//                                 console.log("get_bank_details json parse error:", parseErr);
//                             }
//                         } catch (bErr) {
//                             console.error("Bank details fetch network error:", bErr);
//                         }

//                         const b = bank || {};

//                         const getVal = (...keys) => {
//                             for (const k of keys) {
//                                 if (b[k] !== undefined && b[k] !== null && String(b[k]).trim() !== '') {
//                                     return String(b[k]).trim();
//                                 }
//                             }
//                             return '';
//                         };

//                         const bankNameVal = getVal('bankName', 'bank_name', 'BankName', 'Bankname');
//                         const holderNameVal = getVal('holderName', 'holder_name', 'HolderName', 'account_holder_name', 'AccountHolderName');
//                         const accNumberVal = getVal('accNumber', 'account_number', 'AccountNumber', 'AccNumber', 'account_no', 'AccountNo');
//                         const ifscVal = getVal('ifsc', 'ifsc_code', 'IFSC', 'Ifsc', 'IfscCode');
//                         const branchVal = getVal('branch', 'branch_name', 'Branch', 'BranchName');
//                         const accTypeVal = getVal('accType', 'account_type', 'AccountType', 'AccType');

//                         const isBankMissing = (val) => !val || String(val).trim() === '';

//                         const missingBank = {
//                             bankName: isBankMissing(bankNameVal),
//                             holderName: isBankMissing(holderNameVal),
//                             accNumber: isBankMissing(accNumberVal),
//                             ifsc: isBankMissing(ifscVal),
//                             branch: isBankMissing(branchVal),
//                             accType: isBankMissing(accTypeVal)
//                         };

//                         console.log("MANDATORY BANK CHECK RESULT:", { empId: empIdForBank, bankData: b, missingBank });

//                         if (Object.values(missingBank).some(Boolean)) {
//                             setMissingBankFields(missingBank);
//                             setBankFormData({
//                                 bankName: bankNameVal,
//                                 holderName: holderNameVal || `${data.employee.FirstName || ''} ${data.employee.LastName || ''}`.trim(),
//                                 accNumber: bankNameVal ? accNumberVal : '',
//                                 ifsc: ifscVal,
//                                 branch: branchVal,
//                                 accType: accTypeVal || 'Saving Account'
//                             });
//                             setShowMandatoryBankModal(true);
//                         }
//                     }

//                     // 📜 CHECK MANDATORY POLICY ACKNOWLEDGEMENTS
//                     const empIdForPolicy = data.employee.EmpId || data.employee.id || data.employee.employeeId;
//                     if (empIdForPolicy) {
//                         try {
//                             const email = data.employee.EmailId || storedUser?.email || "";
//                             const isGenesis =
//                                 email.toLowerCase().includes("genesistech.co.in") ||
//                                 email.toLowerCase().includes("gtecorpgroup.com") ||
//                                 email.toLowerCase().includes("gtcorpgroup.com");

//                             let allPolicyList = [];
//                             if (isGenesis) {
//                                 allPolicyList = GENESIS_POLICIES;
//                             } else {
//                                 try {
//                                     const pRes = await fetch("/gt-api/get_policies.php", { credentials: "include" });
//                                     const pData = await pRes.json();
//                                     if (pData.success && Array.isArray(pData.policies) && pData.policies.length > 0) {
//                                         allPolicyList = pData.policies.map((p, idx) => ({
//                                             id: p.id || idx + 1,
//                                             title: p.policy_title || p.title,
//                                             icon: p.policy_icon || p.icon || "📜",
//                                             content: p.content || p.policy_content || null
//                                         }));
//                                     } else {
//                                         allPolicyList = GENESIS_POLICIES;
//                                     }
//                                 } catch (pErr) {
//                                     allPolicyList = GENESIS_POLICIES;
//                                 }
//                             }

//                             const logRes = await fetch(`/gt-api/acknowledgepolicy.php?empId=${empIdForPolicy}`, {
//                                 credentials: "include"
//                             });
//                             const logData = await logRes.json();
//                             const logsArray = Array.isArray(logData?.logs) ? logData.logs : [];
//                             const logsMap = logsArray.reduce((acc, curr) => {
//                                 if (curr?.policy_title) {
//                                     acc[curr.policy_title] = true;
//                                 }
//                                 return acc;
//                             }, {});

//                             setLogs(logsMap);
//                             setAllPoliciesList(allPolicyList);

//                             const unack = allPolicyList.filter(p => !logsMap[p.title || p.policy_title]);
//                             setTotalPoliciesCount(allPolicyList.length);
//                             setAcknowledgedPoliciesCount(allPolicyList.length - unack.length);

//                             if (unack.length > 0) {
//                                 setUnacknowledgedPolicies(unack);
//                                 setSelectedMandatoryPolicy(unack[0]);
//                                 setShowMandatoryPolicyModal(true);
//                             }
//                         } catch (polErr) {
//                             console.error("Mandatory policy check error:", polErr);
//                         }
//                     }
//                 }

//             } catch (error) {
//                 console.error("Database Error:", error);
//             }

//         };

//         fetchUserData();

//     }, []);

//     // 🔒 LOCK BODY SCROLL WHEN MANDATORY MODAL IS OPEN
//     useEffect(() => {
//         if (showMandatoryProfileModal || showMandatoryBankModal || showMandatoryPolicyModal) {
//             document.body.style.overflow = 'hidden';
//             document.documentElement.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         }
//         return () => {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         };
//     }, [showMandatoryProfileModal, showMandatoryBankModal, showMandatoryPolicyModal]);

//     const handleAcknowledgeMandatoryPolicy = async (e) => {
//         if (e && e.preventDefault) e.preventDefault();
//         if (!selectedMandatoryPolicy) return;
//         const targetTitle = selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title;
//         if (!targetTitle) return;

//         setPolicyAckError('');
//         setPolicyAckSaving(true);

//         try {
//             const empBadgeId = userData?.EmpId || userData?.employeeId || userData?.id;
//             const fullName = `${userData?.FirstName || userData?.firstName || ''} ${userData?.LastName || userData?.lastName || ''}`.trim();

//             const response = await fetch("/gt-api/acknowledgepolicy.php", {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     empId: empBadgeId,
//                     fullName: fullName,
//                     policyTitle: targetTitle
//                 }),
//             });

//             const result = await response.json();
//             if (result.status === "success" || result.success) {
//                 setPolicyAckSuccessMsg(`Policy "${targetTitle}" acknowledged successfully!`);

//                 setLogs(prev => ({ ...prev, [targetTitle]: true }));

//                 const remaining = unacknowledgedPolicies.filter(
//                     p => (p.title || p.policy_title) !== targetTitle
//                 );
//                 setUnacknowledgedPolicies(remaining);
//                 setAcknowledgedPoliciesCount(prev => prev + 1);
//                 setPolicyAgreed(false);

//                 setTimeout(() => {
//                     setPolicyAckSuccessMsg('');
//                     if (remaining.length > 0) {
//                         setSelectedMandatoryPolicy(remaining[0]);
//                     } else {
//                         setShowMandatoryPolicyModal(false);
//                     }
//                 }, 1000);
//             } else {
//                 setPolicyAckError(result.message || "Could not save policy acknowledgement.");
//             }
//         } catch (err) {
//             console.error("Policy ack error:", err);
//             setPolicyAckError("Failed to connect to server to record policy acknowledgement.");
//         } finally {
//             setPolicyAckSaving(false);
//         }
//     };

//     const handleSaveMandatoryProfile = async (e) => {
//         e.preventDefault();
//         setMandatoryError('');

//         const { phone, dob, city, address, local_address, country } = mandatoryFormData;

//         if (missingProfileFields.phone && (!phone || !phone.trim())) {
//             setMandatoryError('Please enter your Mobile Number.');
//             return;
//         }
//         if (missingProfileFields.dob && (!dob || !dob.trim() || dob === '0000-00-00')) {
//             setMandatoryError('Please select your Date of Birth.');
//             return;
//         }
//         if (missingProfileFields.city && (!city || !city.trim())) {
//             setMandatoryError('Please enter your City.');
//             return;
//         }
//         if (missingProfileFields.country && (!country || !country.trim())) {
//             setMandatoryError('Please enter your Country.');
//             return;
//         }
//         if (missingProfileFields.address && (!address || !address.trim())) {
//             setMandatoryError('Please enter your Permanent Address.');
//             return;
//         }
//         if (missingProfileFields.local_address && (!local_address || !local_address.trim())) {
//             setMandatoryError('Please enter your Current / Local Address.');
//             return;
//         }

//         setMandatorySaving(true);
//         try {
//             const payload = {
//                 id: userData.id,
//                 EmpId: userData.EmpId,
//                 Phonenumber: (phone || userData.phone || '').trim(),
//                 Dob: (dob || userData.dob || '').trim(),
//                 City: (city || userData.city || '').trim(),
//                 Address: (address || userData.address || '').trim(),
//                 LocalAddress: (local_address || userData.local_address || '').trim(),
//                 Country: (country || userData.country || '').trim(),
//                 Gender: userData.gender || '',
//                 ProfilePicture: userData.profileImage || null
//             };

//             const res = await fetch("/gt-api/update_profile.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 const updatedUser = {
//                     ...userData,
//                     phone: phone.trim(),
//                     dob: dob.trim(),
//                     city: city.trim(),
//                     address: address.trim(),
//                     local_address: local_address.trim(),
//                     country: country.trim()
//                 };
//                 setUserData(updatedUser);
//                 localStorage.setItem("userData", JSON.stringify(updatedUser));
//                 setMandatorySuccessMsg("🎉 Profile information updated! You may now use the system.");
//                 setTimeout(() => {
//                     setShowMandatoryProfileModal(false);
//                     setMandatorySuccessMsg('');
//                 }, 1200);
//             } else {
//                 setMandatoryError(result.message || "Failed to update profile. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory profile update error:", err);
//             setMandatoryError("Connection error. Ensure backend API is running.");
//         } finally {
//             setMandatorySaving(false);
//         }
//     };

//     const handleSaveMandatoryBankDetails = async (e) => {
//         e.preventDefault();
//         setBankError('');

//         const { bankName, holderName, accNumber, ifsc, branch, accType } = bankFormData;

//         if (missingBankFields.bankName && (!bankName || !bankName.trim())) {
//             setBankError('Please enter Bank Name.');
//             return;
//         }
//         if (missingBankFields.holderName && (!holderName || !holderName.trim())) {
//             setBankError('Please enter Account Holder Name.');
//             return;
//         }
//         if (missingBankFields.accNumber && (!accNumber || !accNumber.trim())) {
//             setBankError('Please enter Bank Account Number.');
//             return;
//         }
//         if (missingBankFields.ifsc && (!ifsc || !ifsc.trim())) {
//             setBankError('Please enter IFSC Code.');
//             return;
//         }
//         if (missingBankFields.branch && (!branch || !branch.trim())) {
//             setBankError('Please enter Branch Name.');
//             return;
//         }
//         if (missingBankFields.accType && (!accType || !accType.trim())) {
//             setBankError('Please select Account Type.');
//             return;
//         }

//         setBankSaving(true);
//         try {
//             const payload = {
//                 emp_id: userData.id || userData.employeeId || userData.EmpId,
//                 emp_number: userData.EmpId || userData.employeeId,
//                 bankName: bankName.trim(),
//                 bank_name: bankName.trim(),
//                 holderName: holderName.trim(),
//                 account_holder_name: holderName.trim(),
//                 accNumber: accNumber.trim(),
//                 account_number: accNumber.trim(),
//                 ifsc: ifsc.trim(),
//                 ifsc_code: ifsc.trim(),
//                 branch: branch.trim(),
//                 branch_name: branch.trim(),
//                 accType: accType.trim(),
//                 account_type: accType.trim()
//             };

//             const res = await fetch("/gt-api/save_bank_details.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 setBankSuccessMsg("🎉 Bank details updated successfully!");
//                 setTimeout(() => {
//                     setShowMandatoryBankModal(false);
//                     setBankSuccessMsg('');
//                 }, 1200);
//             } else {
//                 setBankError(result.message || "Failed to save bank details. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory bank details update error:", err);
//             setBankError("Connection error. Ensure backend API is running.");
//         } finally {
//             setBankSaving(false);
//         }
//     };




//     // const employeeId = userData.id || userData.employeeId;

//     const toggleSubMenu = (menu) => {
//         setOpenMenus(prev => ({ ...prev, [menu]: !prev[menu] }));
//     };

//     useEffect(() => {
//         const checkNotifications = () => {
//             if (role !== 'Management' && userData?.employeeId) {
//                 fetch(`/gt-api/clear_notifications.php?employee_id=${userData.employeeId}`)
//                     .then(res => res.json())
//                     .then(data => {
//                         if (data.success) setNotifCount(data.count);
//                     })
//                     .catch(err => console.error("Notif Fetch Error:", err));
//             }
//         };
//         checkNotifications();
//         const interval = setInterval(checkNotifications, 30000);
//         return () => clearInterval(interval);
//     }, [userData.employeeId, role]);

//     useEffect(() => {
//         if (role === 'Management' || role === 'Manager') {
//             const fetchRealTimeLeaves = async () => {
//                 try {
//                     // Determine which API to call based on Role
//                     // Managers should call the specific manager-leaves API using their ID
//                     const url = role === 'Management'
//                         ? "/gt-api/get_all_leaves.php"
//                         : `/gt-api/get_manager_leaves.php?managerId=${userData.id || location.state?.empId}`;

//                     // const res = await fetch(url);
//                     const res = await fetch(url, {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {

//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };

//             // Only fetch if we have the ID for the Manager, or if role is Management
//             if (role === 'Management' || (role === 'Manager' && (userData.id || location.state?.empId))) {
//                 fetchRealTimeLeaves();
//                 const liveInterval = setInterval(fetchRealTimeLeaves, 5000);
//                 return () => clearInterval(liveInterval);
//             }
//         }
//     }, [role, userData.id, location.state?.empId]);

//     const handleStatusUpdate = async (id, newStatus) => {
//         try {
//             const response = await fetch("/gt-api/update_request_status.php", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ id, status: newStatus }),
//             });
//             const data = await response.json();
//             if (data.success) {
//                 setRequestsList(prev => prev.map(req => req.id === id ? { ...req, status: newStatus } : req));
//                 setPendingRequestsCount(prev => Math.max(0, prev - 1));
//                 alert(`Request ${newStatus} successfully!`);
//             }
//         } catch (error) {
//             console.error("Update error:", error);
//         }
//     };

//     ;


//     const sendAIMessage = async () => {
//         if (!chatInput.trim()) return;

//         const userMessage = {
//             sender: "user",
//             text: chatInput
//         };

//         setChatMessages(prev => [...prev, userMessage]);
//         setChatLoading(true);

//         try {
//             const res = await fetch("/gt-api/chatbot.php", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     question: chatInput
//                 })
//             });

//             const data = await res.json();

//             let aiReply = "No response.";

//             if (data.success) {
//                 aiReply = data.reply || "No response.";
//             } else {
//                 aiReply = data.message || "Something went wrong.";
//             }
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: aiReply
//                 }
//             ]);

//         } catch (err) {
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: "Server error."
//                 }
//             ]);
//         }

//         setChatInput("");
//         setChatLoading(false);
//     };
//     const handleModuleChange = (slug, extraData = null) => {
//         navigate(`/dashboard/${role}/${slug}`, {
//             state:
//                 extraData && typeof extraData === "object"
//                     ? extraData
//                     : { selectedPathway: extraData }
//         });
//     };

//     const handlePasswordSubmit = (e) => {
//         e.preventDefault();
//         if (passwordForm.newPassword !== passwordForm.confirmPassword) {
//             alert("New passwords do not match!");
//             return;
//         }
//         alert("Encryption Key Updated Successfully!");
//         setShowPasswordModal(false);
//     };

//     const handleSave = () => {
//         setIsEditing(false);
//         alert("Profile changes synchronized!");
//     };

//     // Ensure only ONE instance of this exists in your file
//     const [theme, setTheme] = useState(localStorage.getItem('dashboard-theme') || 'dark');

//     useEffect(() => {
//         document.documentElement.setAttribute('data-theme', theme);
//         localStorage.setItem('dashboard-theme', theme);
//     }, [theme]);

//     const toggleTheme = () => {
//         setTheme(prev => prev === 'dark' ? 'light' : 'dark');
//     };
//     useEffect(() => {

//         const handlePageShow = (event) => {
//             if (event.persisted) {
//                 const user = localStorage.getItem("userData");
//                 if (!user) {
//                     window.location.replace("/");
//                 }
//             }
//         };

//         window.addEventListener("pageshow", handlePageShow);

//         return () => window.removeEventListener("pageshow", handlePageShow);

//     }, []);
//     useEffect(() => {
//         if (role === 'Management') {
//             const fetchEquipmentCount = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_equip_request.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();
//                     if (data.success && data.requests) {
//                         const count = data.requests.filter(r => r.status?.toLowerCase() === 'pending').length;
//                         setPendingRequestsCount(count);
//                         setRequestsList(data.requests);
//                     }
//                 } catch (err) {
//                     console.error("Equipment Fetch Error:", err);
//                 }
//             };

//             fetchEquipmentCount();
//             const interval = setInterval(fetchEquipmentCount, 10000);
//             return () => clearInterval(interval);
//         }
//     }, [role]);




//     const [payData, setPayData] = useState([]);

//     useEffect(() => {

//         // 🔥 MANAGEMENT DASHBOARD
//         if (role === "Management") {

//             const fetchAllDocs = () => {
//                 fetch("/gt-api/get_all_salary_documents.php", {
//                     credentials: "include"
//                 })
//                     .then(res => res.json())
//                     .then(data => {
//                         console.log("MGMT DATA:", data);

//                         if (data.success) {

//                             setPayData(data.documents);
//                         }
//                     })
//                     .catch(err => console.error("Management Fetch Error:", err));
//             };

//             fetchAllDocs();

//             const interval = setInterval(fetchAllDocs, 5000);

//             return () => clearInterval(interval);
//         }

//         // 👤 EMPLOYEE DASHBOARD
//         if (employeeId) {
//             fetch(`/gt-api/get_my_documents.php?emp_id=${employeeId}`, {
//                 credentials: "include"
//             })
//                 .then(res => res.json())
//                 .then(data => {
//                     console.log("EMP DATA:", data);

//                     if (data.success) {
//                         setPayData(data.documents);
//                     }
//                 })
//                 .catch(err => console.error("Employee Fetch Error:", err));
//         }

//     }, [role, employeeId]);





//     const renderPayChart = () => {
//         const safePayData = payData || [];

//         const payslips = safePayData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = safePayData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = safePayData.filter(d => d.doc_type === "APPRAISAL LETTER").length;
//         const totalDocs = payslips + form16 + appraisal;

//         return (
//             <div className="pay-ultra-card" onClick={() => handleModuleChange("pay and benefits")}>
//                 <div className="card-inner">
//                     {/* Top Section */}
//                     <div className="pay-header">
//                         <div className="pay-icon-wrapper">
//                             <div className="pay-icon-glow"></div>
//                             <span className="main-icon">📄</span>
//                         </div>
//                         <div className="pay-total-info">
//                             <h3>Pay & Benefits</h3>
//                             <p>{totalDocs} Total Documents</p>
//                         </div>
//                     </div>

//                     {/* Distribution */}
//                     <div className="distribution-container">
//                         <div className="distribution-label">
//                             <span>Vault Composition</span>
//                             <span className="percentage">
//                                 {totalDocs > 0 ? "100%" : "0%"}
//                             </span>
//                         </div>

//                         <div className="multi-progress-bar">
//                             {totalDocs > 0 ? (
//                                 <>
//                                     <div
//                                         className="segment green"
//                                         style={{ flex: payslips, backgroundColor: '#22c55e' }}
//                                     ></div>
//                                     <div
//                                         className="segment blue"
//                                         style={{ flex: form16, backgroundColor: '#3b82f6' }}
//                                     ></div>
//                                     <div
//                                         className="segment amber"
//                                         style={{ flex: appraisal, backgroundColor: '#f59e0b' }}
//                                     ></div>
//                                 </>
//                             ) : (
//                                 <div
//                                     style={{
//                                         width: "100%",
//                                         height: "100%",
//                                         backgroundColor: "#e5e7eb",
//                                         borderRadius: "10px"
//                                     }}
//                                 ></div>
//                             )}
//                         </div>
//                     </div>

//                     {/* List */}
//                     <div className="pay-list">
//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator green"></span>
//                                 <span className="name">Monthly Payslips</span>
//                             </div>
//                             <span className="count-badge">{payslips}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator blue"></span>
//                                 <span className="name">Tax Form 16</span>
//                             </div>
//                             <span className="count-badge">{form16}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator amber"></span>
//                                 <span className="name">Appraisal Letter</span>
//                             </div>
//                             <span className="count-badge">{appraisal}</span>
//                         </div>
//                     </div>

//                     <div className="pay-footer">
//                         <span>Explore Document</span>
//                         <span className="arrow-icon">→</span>
//                     </div>

//                     <div className="reimburse-cta-wrapper">
//                         <button
//                             className="reimburse-btn"
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleModuleChange("supplies");
//                             }}
//                         >
//                             Click here for Reimbursement Form
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };



//     const renderLeavePieChart = () => {
//         const PUBLIC_HOLIDAYS = [
//             '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//             '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//         ];

//         const isWorkDay = (date) => {
//             const day = date.getDay();
//             const dateString = date.toISOString().split('T')[0];
//             return !(day === 0 || day === 6) && !PUBLIC_HOLIDAYS.includes(dateString);
//         };

//         if (!leaveData || !leaveData.leaveBalances) return null;

//         const sickUsed = leaveData.leaveBalances.sick.used || 0;
//         const earnedUsed = leaveData.leaveBalances.earned.used || 0;
//         const wfhCount = leaveData.wfhHistory.reduce((total, wfh) => {
//             const start = new Date(wfh.start);
//             const end = new Date(wfh.end);
//             let days = 0;
//             let current = new Date(start);
//             while (current <= end) {
//                 if (isWorkDay(current)) days++;
//                 current.setDate(current.getDate() + 1);
//             }
//             return total + days;
//         }, 0);

//         const totalUsed = sickUsed + earnedUsed;

//         // Determine max for scaling bars (minimum scale of 10)
//         const maxVal = Math.max(sickUsed, earnedUsed, wfhCount, 10);
//         return (

//             <div
//                 className={`elite-podium-card leave-analytics-card ${theme === 'dark' ? 'dark-variant' : 'light-theme'}`}
//                 onClick={() => handleModuleChange("attendance")}
//             >

//                 <div className="card-header-v3">
//                     <div className="title-group">

//                         <h2 className="main-title">Leave Overview</h2>
//                     </div>
//                     <div className="year-tag">2026</div>
//                 </div>

//                 <div className="podium-content">
//                     {/* VERTICAL BAR SECTION - Made prominent */}
//                     <div className="bar-podium-large">
//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill sick" style={{ height: `${(sickUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">SICK</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill earned" style={{ height: `${(earnedUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">EARNED</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill wfh" style={{ height: `${(wfhCount / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">WFH</span>
//                         </div>
//                     </div>

//                     {/* KPI SIDEBAR - Cleaned up to match image 1's style */}
//                     <div className="kpi-sidebar-compact">
//                         <div className="total-display">
//                             <span className="total-val">{totalUsed}</span>
//                             <span className="total-sub">Days Off-Site</span>
//                         </div>

//                         <div className="status-legend">
//                             <div className="legend-row">
//                                 <span className="indicator sick"></span>
//                                 <span>{sickUsed} Sick</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator earned"></span>
//                                 <span>{earnedUsed} Earned</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator wfh"></span>
//                                 <span>{wfhCount} WFH</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="card-footer-v3">
//                     <div className="sync-info">
//                         <span className="status-glow"></span>
//                         Annual Summary Active
//                     </div>
//                     <button className="details-btn">VIEW DETAILS →</button>
//                 </div>
//             </div>
//         );
//     };

//     const [leaveData, setLeaveData] = useState({
//         leaveHistory: [],
//         leaveBalances: {
//             sick: { used: 0, total: 0 },
//             earned: { used: 0, total: 0 }
//         },
//         wfhHistory: []
//     });


//     const [managementNotices, setManagementNotices] = useState({
//         reviews: [],
//         probations: []
//     });

//     useEffect(() => {
//         const fetchNotices = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/get_manager_feedback.php?empId=${userData.EmpId}`
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     setManagementNotices({
//                         reviews: data.reviews || [],
//                         probations: data.probations || []
//                     });
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchNotices();
//     }, [userData]);





//     const renderEquipmentCard = () => {
//         const { total, approved, rejected, pending } = equipmentData;

//         return (
//             <div className="equipment-ultra-card clickable" onClick={() => handleModuleChange("equipment-request")}>
//                 <div className="equip-header">
//                     <div className="equip-icon-box">💻</div>
//                     <div className="equip-title-group">
//                         <span className="equip-label">Hardware</span>
//                         <h3 className="equip-title">Requests</h3>
//                     </div>
//                 </div>

//                 <div className="equip-main-stat">
//                     <span className="total-count">{total}</span>
//                     <span className="total-label">Submissions</span>
//                 </div>

//                 <div className="equip-progress-bar">
//                     <div className="bar-fill approved" style={{ width: `${(approved / total) * 100}%` }}></div>
//                     <div className="bar-fill pending" style={{ width: `${(pending / total) * 100}%` }}></div>
//                 </div>

//                 <div className="equip-stats-list">
//                     <div className="equip-item">
//                         <span className="dot approved"></span>
//                         <span className="item-name">Approved</span>
//                         <span className="item-val">{approved}</span>
//                     </div>
//                     <div className="equip-item">
//                         <span className="dot pending"></span>
//                         <span className="item-name">Pending</span>
//                         <span className="item-val text-warning">{pending}</span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     useEffect(() => {
//         const empIdForFetch = userData?.EmpId || userData?.employeeId;

//         if (!empIdForFetch) return;

//         fetch(`/gt-api/get_all_equip_request.php?employee_id=${empIdForFetch}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log("EQUIPMENT API RESPONSE:", data);
//                 if (data.success && data.requests) {

//                     const requests = data.requests;

//                     const approved = requests.filter(r =>
//                         r.status?.toLowerCase() === "approved"
//                     ).length;

//                     const rejected = requests.filter(r =>
//                         r.status?.toLowerCase() === "rejected"
//                     ).length;

//                     const pending = requests.filter(r =>
//                         r.status?.toLowerCase() === "pending"
//                     ).length;

//                     setEquipmentData({
//                         total: requests.length,
//                         approved,
//                         rejected,
//                         pending
//                     });
//                 }
//             })
//             .catch(err => console.error("Equipment Dashboard Error:", err));
//         console.log("EMP ID:", empIdForFetch);



//     }, [userData?.EmpId, userData?.employeeId]);





//     const [oneOnOneData, setOneOnOneData] = useState({
//         totalMeetings: 0,
//         pendingTasks: 0,
//         completedTasks: 0
//     });

//     useEffect(() => {
//         if (!employeeId) return;

//         fetch(`/gt-api/get_my_meetings.php?emp_id=${employeeId}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.meetings) {

//                     const meetings = data.meetings;

//                     let pending = 0;
//                     let completed = 0;

//                     meetings.forEach(meet => {
//                         const tasks = JSON.parse(meet.action_items || "[]");

//                         tasks.forEach(task => {
//                             if (task.done) completed++;
//                             else pending++;
//                         });
//                     });

//                     setOneOnOneData({
//                         totalMeetings: meetings.length,
//                         pendingTasks: pending,
//                         completedTasks: completed
//                     });
//                 }
//             })
//             .catch(err => console.error("1-1 Fetch Error:", err));

//     }, [employeeId]);



//     const renderOneOnOneCard = () => {
//         const { totalMeetings, pendingTasks, completedTasks } = oneOnOneData;
//         const totalTasks = (pendingTasks + completedTasks) || 1;
//         const progressPercent = Math.min(Math.round((completedTasks / totalTasks) * 100), 100);

//         return (
//             <div className="liquid-card clickable" onClick={() => handleModuleChange("one-on-one")}>
//                 {/* BACKGROUND BLOOM */}
//                 <div className="liquid-bloom"></div>

//                 <div className="liquid-layout">
//                     {/* HERO TILE: THE CORE IDENTITY */}
//                     <div className="liquid-tile-hero">
//                         <div className="hero-header">
//                             {/* <span className="hero-eyebrow">Engagement Console</span> */}
//                             <h2 className="hero-title">1-on-1 Sessions</h2>
//                         </div>
//                         <div className="hero-main-metric">
//                             <span className="hero-val">{totalMeetings}</span>
//                             <span className="hero-label">TOTAL<br />MEETINGS</span>
//                         </div>
//                         {/* FULL WIDTH PROGRESS THREAD */}
//                         <div className="liquid-thread-container">
//                             <div className="liquid-thread-bg">
//                                 <div className="liquid-thread-fill" style={{ width: `${progressPercent}%` }}>
//                                     <div className="liquid-thread-glow-tip"></div>
//                                 </div>
//                             </div>
//                             <div className="liquid-thread-label">
//                                 <span className="label-text">Task Completion</span>
//                                 <span className="label-val">{progressPercent}%</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* DATA TRAY: THE SPECIFIC CHIPS */}
//                     <div className="liquid-tray">
//                         <div className="liquid-chip danger">
//                             <div className="chip-inner">
//                                 <label>Pending Task</label>
//                                 <span className="chip-val">{pendingTasks}</span>
//                             </div>
//                         </div>
//                         <div className="liquid-chip success">
//                             <div className="chip-inner">
//                                 <label>Completed Task</label>
//                                 <span className="chip-val">{completedTasks}</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* INTERACTIVE FOOTER */}
//                 <div className="liquid-footer">
//                     <div className="status-container">
//                         <div className={`status-node-wrapper ${pendingTasks > 0 ? 'is-alert' : 'is-sync'}`}>
//                             <div className="status-node-core"></div>
//                             <div className="status-node-bloom"></div>
//                         </div>
//                         <span className={`status-text ${pendingTasks > 0 ? 'text-alert' : ''}`}>
//                             {pendingTasks > 0 ? 'ACTION ITEMS DETECTED' : 'SYSTEM OPTIMIZED'}
//                         </span>
//                     </div>
//                     <div className="liquid-action">

//                         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
//                     </div>
//                 </div>
//             </div>
//         );
//     };






//     const renderCareerPathwaysCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const pathways = isGenesis

//             ? [

//                 {
//                     id: "01",
//                     name: "FI DESIGN",
//                     color: "rgba(0, 77, 113, 0.9)"
//                 },

//                 {
//                     id: "02",
//                     name: "BIM MODELING",
//                     color: "rgba(0, 120, 172, 0.8)"
//                 },

//                 {
//                     id: "03",
//                     name: "POWER BI",
//                     color: "rgba(0, 162, 237, 0.7)"
//                 }

//             ]

//             : dashboardPathways.map(
//                 (item, index) => ({
//                     id: String(index + 1)
//                         .padStart(2, "0"),

//                     name: item.pathway_title,

//                     color:
//                         "rgba(0, 120, 172, 0.8)"
//                 })
//             );

//         return (

//             <div
//                 className="pathway-card-container"
//                 onClick={() =>
//                     handleModuleChange(
//                         "career pathways"
//                     )
//                 }
//             >

//                 <h2 className="pathway-title">
//                     CAREER PATHWAYS
//                 </h2>

//                 <div className="pathway-stack">

//                     {pathways.map(
//                         (item, index) => (

//                             <div
//                                 key={index}
//                                 className="pathway-step"
//                                 style={{
//                                     '--step-color':
//                                         item.color
//                                 }}
//                                 onClick={(e) => {

//                                     e.stopPropagation();

//                                     handleModuleChange(
//                                         "career pathways",
//                                         item.name
//                                     );

//                                 }}
//                             >

//                                 <span className="step-number">
//                                     {item.id}
//                                 </span>

//                                 <div className="step-content">

//                                     <span className="step-name">
//                                         {item.name}
//                                     </span>

//                                     <div className="step-glow"></div>

//                                 </div>

//                             </div>

//                         )
//                     )}

//                 </div>

//                 <button
//                     className="explore-btn"
//                     onClick={(e) => {

//                         e.stopPropagation();

//                         handleModuleChange(
//                             "career pathways"
//                         );

//                     }}
//                 >
//                     EXPLORE CAREER PATHWAYS
//                 </button>

//             </div>

//         );

//     };


//     const renderPolicyCard = () => {
//         const totalPolicies =
//             policyCount;

//         console.log(
//             "Policy Count:",
//             totalPolicies
//         );

//         const readCount =
//             Object.keys(logs || {}).length;
//         const pending = totalPolicies - readCount;
//         const progress = totalPolicies > 0 ? Math.round((readCount / totalPolicies) * 100) : 0;

//         return (
//             <div className="terminal-policy-card" onClick={() => handleModuleChange("company-policy")}>
//                 {/* Background Decorative Scanline */}
//                 <div className="terminal-scanline"></div>

//                 <div className="terminal-header">
//                     <div className="header-left">
//                         {/* <span className="terminal-tag">PROTOCOL_09</span> */}
//                         <h3 className="terminal-title">Company Policy</h3>
//                     </div>
//                     <div className={`status-indicator ${progress === 100 ? 'secure' : 'breach'}`}>
//                         {progress === 100 ? "SECURE" : "PENDING"}
//                     </div>
//                 </div>

//                 <div className="terminal-content">
//                     {/* Circular Progress using SVG for precision */}
//                     <div className="terminal-visual">
//                         <svg viewBox="0 0 36 36" className="cyber-circle">
//                             <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                             <path
//                                 className="circle-fill"
//                                 strokeDasharray={`${progress}, 100`}
//                                 d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
//                                 style={{ stroke: progress === 100 ? '#22c55e' : '#3b82f6' }}
//                             />
//                         </svg>
//                         <div className="percentage-display">
//                             <span className="pct-num">{progress}</span>
//                             <span className="pct-unit">%</span>
//                         </div>
//                     </div>

//                     {/* Data Readout Section */}
//                     <div className="terminal-stats">
//                         <div className="stat-row">
//                             <span className="label">COMPLETED</span>
//                             <span className="value">{readCount}</span>
//                         </div>
//                         <div className="stat-row">
//                             <span className="label">TOTAL_FILES</span>
//                             <span className="value">{totalPolicies}</span>
//                         </div>
//                         <div className="stat-row urgent">
//                             <span className="label">AWAITING_ACTION</span>
//                             <span className="value">{pending}</span>
//                         </div>
//                     </div>
//                 </div>

//             </div>
//         );
//     };

//     useEffect(() => {
//         const fetchLogs = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/acknowledgepolicy.php?empId=${userData.EmpId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 console.log("API DATA:", data);

//                 // 🔥 FIX: use data.logs (NOT data)
//                 const logsArray = Array.isArray(data?.logs) ? data.logs : [];

//                 const map = logsArray.reduce((acc, curr) => {
//                     if (curr?.policy_title) {
//                         acc[curr.policy_title] = true;
//                     }
//                     return acc;
//                 }, {});

//                 setLogs(map);

//             } catch (err) {
//                 console.error("Policy logs error:", err);
//                 setLogs({});
//             }
//         };

//         fetchLogs();
//     }, [userData]);


//     const [showProfileOptions, setShowProfileOptions] = useState(false);



//     const [showProfileMenu, setShowProfileMenu] = useState(false);
//     const handleEditProfile = () => {
//         setShowProfileMenu(false);
//         navigate(`/dashboard/${role}/my-profile`);
//         setShowProfile(true);
//     };

//     const handleLogout = () => {
//         document.documentElement.removeAttribute('data-theme');
//         localStorage.clear();
//         sessionStorage.clear();
//         navigate("/", { replace: true });
//     };

//     const [currentTime, setCurrentTime] = useState("");

//     useEffect(() => {
//         const updateTime = () => {
//             const now = new Date();
//             setCurrentTime(
//                 now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
//             );
//         };

//         updateTime();
//         const interval = setInterval(updateTime, 1000);

//         return () => clearInterval(interval);
//     }, []);
//     const todayDate = new Date().toLocaleDateString('en-GB', {
//         day: '2-digit',
//         month: 'short'
//     });



//     const employeeModulesList = [
//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "attendance" },

//         { id: 2, name: "Pay and Benefits", icon: "💳", color: "#3b82f6", slug: "pay and benefits" },
//         { id: 3, name: "OKR and Performance Tracker", icon: "🎯", color: "#f59e0b", slug: "okr and performance tracker" },

//         { id: 5, name: "Career Pathways", icon: "🏆", color: "#ec4899", slug: "career pathways" },
//         { id: 6, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },

//         { id: 9, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         { id: 10, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         // { id: 11, name: "Documents", icon: "📂", color: "#f43f5e", slug: "documents" },
//         // { id: 12, name: "Employee Experience Survey - EES", icon: "📝", color: "#8b5cf6", slug: "ees-survey" },   
//         { id: 13, name: "1:1 Meeting", icon: "💬", color: "#00fff2", slug: "one-on-one" },
//         { id: 21, name: "ACM Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//         { id: 7, name: "Expense Reimbursement", icon: "🧾", color: "#10b981", slug: "supplies" },

//     ];

//     const managementModulesList = [

//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "leave-management", badge: pendingLeavesCount },

//         { id: 2, name: "Employee Salary and Benefits", icon: "💳", color: "#3b82f6", slug: "employee-salary-benefits" },

//         { id: 3, name: "Employee OKR'S", icon: "🎯", color: "#f59e0b", slug: "employee-okrs" },

//         { id: 5, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: pendingRequestsCount },

//         { id: 6, name: "Own Finanacials", icon: "💰", color: "#10b981", slug: "pay and benefits" },

//         { id: 8, name: "Career Development", icon: "🏆", color: "#ec4899", slug: "career pathways" },

//         { id: 10, name: "Self OKR Tracker", icon: "🏁", color: "#f59e0b", slug: "okr and performance tracker" },
//         { id: 11, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         { id: 12, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         // { id: 21, name: "Manage Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates", badge: "PUSH" },

//         {
//             id: 21,
//             name: "ACM Updates",
//             icon: "📢",
//             color: "#00fff2",
//             slug: "manage-quarterly-updates",
//             badge: "PUSH"
//         },

//         // {
//         //   id: 15,
//         //   name: "EES Feedback Analytics",
//         //   icon: "📊",
//         //   color: "#00f2ff",
//         //   slug: "ees-analytics",
//         //   badge: "NEW"
//         // },

//         // { id: 14, name: "Skills Development", icon: "📚", color: "#06b6d4", slug: "career" },

//         {
//             id: 16,
//             name: "Medical Reports",
//             icon: "🏥",
//             color: "#f43f5e",
//             slug: "medical-reports",
//             badge: "DOCS"
//         },
//         {
//             id: 17,
//             name: "Policy RnU Status",
//             icon: "📋",
//             color: "#10b981",
//             slug: "policy-logs",
//             badge: "ADMIN"
//         },

//         // { 
//         //   id: 18, 
//         //   name: "Employee Documents", 
//         //   icon: "📂", 
//         //   color: "#f43f5e", 
//         //   slug: "manage-documents", 
//         //   badge: "VIEW" 
//         // },

//         {
//             id: 19,
//             name: "1:1 Connect",
//             icon: "🤝",
//             color: "#00fff2",
//             slug: "manager-one-on-one",

//             badge: "LIVE"
//         },

//         { id: 20, name: "Events and Celebrations", icon: "🎉", color: "#3b82f6", slug: "events-celebrations" },

//         {
//             id: 22,
//             name: "Expense Reimbursements",
//             icon: "💰",
//             color: "#22c55e",
//             slug: "reimbursements",
//             badge: "NEW"
//         },

//         {
//             id: 25,
//             name: "Award Nominations Analytics",
//             icon: "📊",
//             color: "#f59e0b",
//             slug: "award-analytics",
//             badge: "GALA"
//         },

//         // {
//         //     id: 23,
//         //     name: "WFH Requests",
//         //     icon: "🏠",
//         //     color: "#3b82f6",
//         //     slug: "manage-wfh-requests",
//         //     badge: "WFH"
//         // },


//     ];

//     const renderActiveModule = () => {

//         switch (activeModule) {

//             case "attendance-tracker":
//                 return <AttendanceTracker />;

//             case "CompanySetup":
//                 return <CompanySetup />;

//             case "create-invoice":
//                 return <InvoiceGenerator />;

//             case "my-profile":
//                 return (
//                     <MyProfile
//                         userData={userData}
//                         setUserData={setUserData}
//                         isEditing={isEditing}
//                         setIsEditing={setIsEditing}
//                         handleSave={handleSave}
//                         setShowPasswordModal={setShowPasswordModal}
//                     />
//                 );


//             case "reimbursements":
//                 if (role === "Management" || role === "Manager") {
//                     return <ReimbursementManagement />;
//                 }
//                 return <OfficeRequisition userData={userData} />;

//             case "manage-wfh-requests":
//                 return <WFHManagement />;


//             case "work-from-home":
//                 return <WorkFromHome />;


//             case "quarterly-updates":

//                 return <QuarterlyUpdates />;

//             case "manage-quarterly-updates":

//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementQuarterlyUpdate userData={userData} />;
//                 }
//                 return <QuarterlyUpdates />;


//             case "leave-management":
//                 // Unified behavior for Management and Manager
//                 if (role === 'Management' || role === 'Manager') {
//                     return <LeaveManagement userData={userData} />;
//                 }


//                 return <Attendance employeeId={employeeId} userData={userData} />;

//             case "manage-documents":
//                 if (role === 'Management') {
//                     return <ManageEmployeeDocs />;
//                 }
//                 return <Documents userData={userData} />;



//             // case "attendance":
//             //     if (role === 'Management') return <Attendance />;
//             //     return (
//             //         <Attendance
//             //             employeeId={userData.id}
//             //             empBadgeId={userData.EmpId}
//             //             userData={userData}
//             //         />
//             //     );
//             case "attendance":

//                 if (role === 'Management') {

//                     return (
//                         <Attendance
//                             employeeId={userData.id}
//                             empBadgeId={userData.EmpId}
//                             userData={userData}
//                         />
//                     );

//                 }

//                 return (
//                     <Attendance
//                         employeeId={userData.id}
//                         empBadgeId={userData.EmpId}
//                         userData={userData}
//                     />
//                 );


//             case "policy-logs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <PolicyAdminDashboard />;
//                 }

//                 return (
//                     <CompanyPolicy
//                         employeeId={userData.id}
//                         userData={userData}
//                     />
//                 );

//             case "events-celebrations":
//                 return <EventsCelebrations userData={userData} />;

//             case "award-nominations":
//                 return <AwardNominations userData={userData} role={role} />;

//              case "award-analytics":
//                 return <AwardAnalyticsDashboard userData={userData} role={role} />;

//             case "pay and benefits": return <PayBenefits userData={userData} employeeId={employeeId} />;

//             // case "okr and performance tracker":
//             //     return <OKRTracker userData={userData} />;

//             case "okr and performance tracker":
//                 return (
//                     <OKRTracker
//                         userData={userData}
//                         defaultTab={location.state?.tab}
//                     />
//                 );

//             // Inside Dashboard.js -> renderActiveModule
//             // case "employee-okrs":
//             //     if (role === 'Management' || role === 'Manager') {
//             //         return (
//             //             <ManagementOKRViewer
//             //                 managerId={userData.id}
//             //                 userRole={role}
//             //                 // This is the CRITICAL line:
//             //                 managedDept={userData.HOD}
//             //             />
//             //         );
//             //     }
//             //     return <OKRTracker userData={userData} />;

//             case "employee-okrs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementOKRViewer userRole={role} />;
//                 }
//                 return <OKRTracker userData={userData} />;

//             case "career pathways": return <CareerPathways userData={userData} />;
//             case "add-department": return <AddDepartment />;
//             case "manage-department": return <ManageDepartment />;
//             case "add-employee": return <AddEmployee />;
//             case "manage-employee": return <ManageEmployee />;

//             case "employee-salary-benefits":
//                 return <EmployeeSalaryBenefits />;


//             case "equipment-request":
//                 if (role === "Management") {
//                     const pending = requestsList.filter(
//                         (r) => r.status?.toLowerCase() === "pending"
//                     );

//                     const history = requestsList.filter(
//                         (r) => r.status?.toLowerCase() !== "pending"
//                     );

//                     return (
//                         <div
//                             className="management-request-wrapper animate-fade"
//                             style={{ padding: "20px" }}
//                         >
//                             {/* Pending Queue */}
//                             <div
//                                 className="module-glass-card"
//                                 style={{ marginBottom: "30px" }}
//                             >
//                                 <h3 className="cyan-text">
//                                     ACTIVE_PENDING_QUEUE ({pending.length})
//                                 </h3>

//                                 {/* Desktop Table */}
//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>IMPACT</th>
//                                                 <th>ACTION</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {pending.length > 0 ? (
//                                                 pending.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                             >
//                                                                 {req.impact?.toUpperCase()}
//                                                             </span>
//                                                         </td>

//                                                         <td>
//                                                             <div className="equiptable-actions">
//                                                                 <button
//                                                                     className="equiptable-btn equiptable-approve"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Approved"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✔
//                                                                 </button>

//                                                                 <button
//                                                                     className="equiptable-btn equiptable-reject"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Rejected"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✖
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_PENDING_REQUESTS
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 {/* Mobile Cards */}
//                                 <div className="equiptable-mobile">
//                                     {pending.length > 0 ? (
//                                         pending.map((req) => (
//                                             <div
//                                                 className="equiptable-card"
//                                                 key={req.id}
//                                             >
//                                                 <div className="equiptable-row">
//                                                     <span>Employee</span>
//                                                     <strong>
//                                                         {req.employee_name}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Hardware</span>
//                                                     <strong>
//                                                         {req.equipment_type}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Impact</span>

//                                                     <span
//                                                         className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                     >
//                                                         {req.impact?.toUpperCase()}
//                                                     </span>
//                                                 </div>

//                                                 <div className="equiptable-actions">
//                                                     <button
//                                                         className="equiptable-btn equiptable-approve"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Approved"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✔ Approve
//                                                     </button>

//                                                     <button
//                                                         className="equiptable-btn equiptable-reject"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Rejected"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✖ Reject
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         ))
//                                     ) : (
//                                         <div className="equiptable-card">
//                                             NO_PENDING_REQUESTS
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Completed History */}
//                             <div
//                                 className="module-glass-card history-card"
//                                 style={{ opacity: 0.9 }}
//                             >
//                                 <h3
//                                     className="gray-text"
//                                     style={{ color: "#888" }}
//                                 >
//                                     📜 COMPLETED_HISTORY ({history.length})
//                                 </h3>

//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>DATE</th>
//                                                 <th>STATUS</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {history.length > 0 ? (
//                                                 history.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             {new Date(
//                                                                 req.updated_at ||
//                                                                 req.created_at
//                                                             ).toLocaleDateString(
//                                                                 "en-GB"
//                                                             )}
//                                                         </td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-status ${req.status?.toLowerCase()}`}
//                                                             >
//                                                                 {req.status?.toUpperCase()}
//                                                             </span>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_HISTORY_FOUND
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     );
//                 }

//                 return <EquipmentRequest userData={userData} />;

//             case "supplies": return <OfficeRequisition userData={userData} />;
//             // case "it": return <ITSupport userData={userData} />;
//             case "documents": return <Documents userData={userData} />;
//             // case "company-policy": return <CompanyPolicy />;
//             case "company-policy":
//                 return <CompanyPolicy userData={userData} />;
//             case "Organization Chart": return <OrgChart userData={userData} />;
//             // case "campus information": return <CampusInfo />;
//             case "campus information":
//                 return <CampusInfo userData={userData} />;
//             case "ees-survey": return <EESExperience userData={userData} />;

//             case "ees-analytics":
//                 if (role === 'Management' || role === 'Manager') {
//                     // Management sees the list of real data
//                     return <EESFeedbackManagement feedbacks={eesSubmissions} />;
//                 }
//                 // Employee sees the form
//                 return <EESExperience userData={userData} onFinalSubmit={handleEESSubmit} />;

//             //       case "one-on-one":
//             // return <OneOnOne userData={userData} role={role} />;

//             case "one-on-one":
//                 // This is the PERSONAL view (Employee mode)
//                 return <OneOnOne userData={userData} role="Employee" viewMode="personal" />;

//             case "manager-one-on-one":
//                 // This is the MANAGERIAL view (Manager/Management mode)
//                 return <OneOnOne userData={userData} role={role} viewMode="managerial" />;

//             case "one-on-one-report":
//                 return <OneOnOneReport userData={userData} role={role} handleModuleChange={handleModuleChange} />;

//             // Inside Dashboard.js renderActiveModule
//             case "medical-reports":
//                 if (role === 'Management') return <MedicalReports />;
//                 if (role === 'Manager') {
//                     return (
//                         <ManagerMedicalReports
//                             managerId={userData.id}           // Database Primary Key
//                             managerBadgeId={userData.EmpId}   // Company ID (HOD flag often matches this)
//                             managerDept={userData.Department} // The string "Software Development"
//                         />
//                     );
//                 }

//             case "employee-it-support":
//                 return <EquipmentRequest userData={userData} />;

//             default:


//                 if (role === 'Manager') {
//                     return renderManagerDashboard();
//                 }

//                 const currentList = role === 'Management' ? managementModulesList : employeeModulesList;
//                 return (
//                     <section className="bento-grid">
//                         {currentList.map((mod) => (
//                             <div key={mod.id} className="bento-card glass" style={{ "--accent": mod.color }} onClick={() => handleModuleChange(mod.slug)}>
//                                 <div className="card-top">
//                                     <span className="mod-icon">{mod.icon}</span>
//                                     {mod.badge > 0 && <span className={role === 'Management' ? "card-badge" : "notification-badge-ui"}>{mod.badge}</span>}
//                                 </div>
//                                 <div className="card-info"><h3>{mod.name}</h3><div className="cyber-line"></div></div>
//                             </div>
//                         ))}
//                     </section>
//                 );
//         }
//     };

//     const [companyLogo, setCompanyLogo] = useState("");
//     const currentLogo = theme === 'light' ? logoLight : logoDark;


//     const [leaveStats, setLeaveStats] = useState({
//         pending: 0,
//         approved: 0,
//         rejected: 0,
//         wfhPending: 0
//     });

//     useEffect(() => {
//         if (role !== "Management") return;

//         const fetchLeaveStats = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];


//                     const pending = leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                     const approved = leaves.filter(l => l.Status === '1').length;
//                     const rejected = leaves.filter(l => l.Status === '2').length;

//                     // WFH
//                     const wfhRes = await fetch("/gt-api/get_all_wfh_requests.php", {
//                         credentials: "include"
//                     });
//                     const wfhData = await wfhRes.json();

//                     const wfhPending = wfhData.success
//                         ? wfhData.requests.filter(r => r.status === "Pending").length
//                         : 0;

//                     setLeaveStats({ pending, approved, rejected, wfhPending });
//                 }

//             } catch (err) {
//                 console.error("Leave Stats Error:", err);
//             }
//         };

//         fetchLeaveStats();
//         const interval = setInterval(fetchLeaveStats, 5000);

//         return () => clearInterval(interval);
//     }, [role]);


//     const [mgmtLeaves, setMgmtLeaves] = useState([]);
//     const [mgmtActiveTeam, setMgmtActiveTeam] = useState("All");

//     useEffect(() => {
//         const fetchLeaves = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();
//                 if (data.success) setMgmtLeaves(data.leaves);
//             } catch (err) {
//                 console.error("Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaves();
//     }, []);





//     const mgmtChartData = useMemo(() => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept => dept.DepartmentName
//             );

//         const now = new Date();
//         const currentMonth = (now.getMonth() + 1).toString();
//         const currentYear = now.getFullYear().toString();

//         const teamList = mgmtActiveTeam === "All" ? teams : [mgmtActiveTeam];

//         return teamList.map(team => {

//             const filtered = mgmtLeaves.filter(l => {
//                 const dateParts = l.fromdate?.split("-");
//                 const lYear = dateParts?.[0];
//                 const lMonth = dateParts?.[1]
//                     ? parseInt(dateParts[1]).toString()
//                     : "";

//                 return (
//                     l.Department === team &&
//                     lMonth === currentMonth &&
//                     lYear === currentYear
//                 );
//             });

//             return {
//                 name: team,

//                 // ✅ SUM OF UNITS (FIXED)
//                 Approved: filtered
//                     .filter(l => l.Status === "1")
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

//                 Pending: filtered
//                     .filter(l => l.Status === "0" || l.Status === null)
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
//             };
//         });

//     }, [mgmtLeaves, mgmtActiveTeam]);


//     const renderManagementLeaveCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept =>
//                     dept.DepartmentName
//             );

//         return (
//             <div
//                 className="mgmt-leave-analytics clickable"
//                 onClick={() => handleModuleChange("leave-management")}
//             >

//                 <div className="card-header">
//                     <h3>Employee Leave Analytics</h3>
//                     <span className="sub-text">This Month</span>
//                 </div>

//                 {/* TEAM CHIPS */}
//                 <div className="team-row">
//                     <div
//                         className={`team-chip ${mgmtActiveTeam === "All" ? "active" : ""}`}
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             setMgmtActiveTeam("All");
//                         }}
//                     >
//                         ALL
//                     </div>

//                     {teams.map((team, i) => (
//                         <div
//                             key={i}
//                             className={`team-chip ${mgmtActiveTeam === team ? "active" : ""}`}
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 setMgmtActiveTeam(team);
//                             }}
//                         >
//                             {team}
//                         </div>
//                     ))}
//                 </div>

//                 {/* CHART */}
//                 {(() => {
//                     const isSingle = mgmtActiveTeam !== "All";

//                     return (
//                         <div className={`chart-area ${isSingle ? "single-view" : ""}`}>
//                             <ResponsiveContainer width="100%" height={170}>
//                                 <BarChart
//                                     data={mgmtChartData}
//                                     barCategoryGap={isSingle ? "70%" : "30%"}
//                                     margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
//                                 >

//                                     {/* GRADIENTS */}
//                                     <defs>
//                                         <linearGradient id="approvedGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#34d399" />
//                                             <stop offset="100%" stopColor="#059669" />
//                                         </linearGradient>

//                                         <linearGradient id="pendingGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#fbbf24" />
//                                             <stop offset="100%" stopColor="#f59e0b" />
//                                         </linearGradient>
//                                     </defs>

//                                     <CartesianGrid
//                                         strokeDasharray="3 3"
//                                         stroke="rgba(255,255,255,0.05)"
//                                         vertical={false}
//                                     />

//                                     <XAxis
//                                         dataKey="name"
//                                         tick={{ fill: "#888", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <YAxis
//                                         tick={{ fill: "#666", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <Tooltip
//                                         cursor={{ fill: "rgba(255,255,255,0.05)" }}
//                                         contentStyle={{
//                                             backgroundColor: "rgba(15, 23, 42, 0.95)", // dark glass
//                                             border: "1px solid rgba(0,255,242,0.3)",
//                                             borderRadius: "10px",
//                                             color: "#ffffff",
//                                             backdropFilter: "blur(8px)"
//                                         }}
//                                         labelStyle={{ color: "#00fff2", fontWeight: 600 }}
//                                         itemStyle={{ color: "#ffffff" }}
//                                     />


//                                     <Bar
//                                         dataKey="Approved"
//                                         stackId="a"
//                                         fill="url(#approvedGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                     <Bar
//                                         dataKey="Pending"
//                                         stackId="a"
//                                         fill="url(#pendingGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                 </BarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     );
//                 })()}


//                 <div className="card-footer">
//                     <span>Open Leave Console</span>
//                     <span>→</span>
//                 </div>
//             </div>
//         );
//     };

//     const renderSalaryIntelCard = () => {
//         // 1. Existing Counts
//         const payslips = payData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = payData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = payData.filter(d => d.doc_type === "APPRAISAL LETTER").length;

//         // 2. New Miscellaneous Count (Filtering for the images you provided)
//         const miscDocs = [
//             "FNF LETTER", "OFFER LETTER", "RELIEVING LETTER",
//             "EXPERIENCE LETTER", "EMPLOYEMENT AGREEMENT", "BANK ACCOUNT OPENING"
//         ];
//         const miscellaneous = payData.filter(d => miscDocs.includes(d.doc_type)).length;

//         // 3. Updated Total
//         const total = payslips + form16 + appraisal + miscellaneous;

//         // 4. SVG Math for 4 segments
//         const chartTotal = 125.6;
//         const gap = total > 0 ? 2 : 0;

//         const s1 = (payslips / total) * chartTotal || 0;
//         const s2 = (form16 / total) * chartTotal || 0;
//         const s3 = (appraisal / total) * chartTotal || 0;
//         const s4 = (miscellaneous / total) * chartTotal || 0;

//         return (
//             <div className="sa-card-wrapper" onClick={() => handleModuleChange("employee-salary-benefits")}>


//                 <div className="sa-card-header">
//                     <h3 className="sa-title">Salary Document Insights</h3>
//                     <button className="sa-menu-trigger">⋮</button>
//                 </div>

//                 <div className="sa-main-body">
//                     <div className="sa-gauge-area">
//                         <div className="sa-gauge-container">
//                             <svg viewBox="0 0 100 55" className="sa-gauge-svg">
//                                 {/* Background Track */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="var(--sa-track)" strokeWidth="9" strokeLinecap="round" />

//                                 {/* Segment 4: Misc (Blue) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#0ea5e9" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s4 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2 + s3}`} />

//                                 {/* Segment 3: Appraisals (Orange) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#f97316" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s3 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2}`} />

//                                 {/* Segment 2: Form 16 (Yellow) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#fbbf24" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s2 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1}`} />

//                                 {/* Segment 1: Payslips (Purple) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#8b5cf6" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s1 - gap)} ${chartTotal}`}
//                                     strokeDashoffset="0" />
//                             </svg>

//                             <div className="sa-gauge-text">
//                                 <span className="sa-overall-num">{total}</span>
//                                 <span className="sa-overall-label">Overall</span>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="sa-legend-area">
//                         {[
//                             { label: "Payslips", count: payslips, color: "purple" },
//                             { label: "Form 16", count: form16, color: "yellow" },
//                             { label: "Appraisals", count: appraisal, color: "orange" },
//                             { label: "Miscellaneous", count: miscellaneous, color: "blue" }
//                         ].map((item, index) => (
//                             <div key={index} className="sa-legend-item">
//                                 <div className="sa-item-top">
//                                     <span className={`sa-dot ${item.color}`}></span>
//                                     <span className="sa-item-count">{item.count}</span>
//                                 </div>
//                                 <span className="sa-item-label">{item.label}</span>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <div className="sa-card-footer">
//                     <span className="sa-footer-link">View Detailed Report →</span>
//                 </div>
//             </div>
//         );
//     };



//     const [okrData, setOkrData] = useState([]);
//     useEffect(() => {
//         if (!userData?.id) return;

//         const fetchOKR = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/get_user_okr.php?empId=${userData.id}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     const parsed = typeof data.data === "string"
//                         ? JSON.parse(data.data)
//                         : data.data;

//                     setOkrData(parsed);
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchOKR();

//     }, [userData?.id]);



//     const [okrStats, setOkrStats] = useState({
//         total: 0,
//         completed: 0,
//         pending: 0,
//         progressPercent: 0
//     });



//     const fetchOKRStats = async () => {
//         if (!userData?.EmpId) return;

//         try {
//             const res = await fetch(
//                 `/gt-api/get_okr_stats.php?empId=${userData.EmpId}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setOkrStats(data);
//             }

//         } catch (err) {
//             console.error("OKR STATS ERROR:", err);
//         }
//     };

//     useEffect(() => {
//         if (!userData?.EmpId) return;

//         fetchOKRStats();

//         const handleUpdate = () => fetchOKRStats();

//         window.addEventListener("okrUpdated", handleUpdate);

//         return () => window.removeEventListener("okrUpdated", handleUpdate);

//     }, [userData?.EmpId]);




//     const renderOKRCard = () => {
//         const { total, completed, pending, progressPercent } = okrStats;

//         return (
//             <div
//                 className="expanded-management-card clickable"
//                 onClick={() => handleModuleChange("okr and performance tracker")}
//             >
//                 <div className="okr-card-container">

//                     {/* HEADER */}
//                     <div className="okr-header">
//                         <div>
//                             <span className="eyebrow-text">Performance Tracker</span>
//                             <h2 className="display-title">OKR Progress</h2>
//                         </div>

//                         {/* TOP RIGHT TOTAL */}
//                         <div className="stat-box featured big">
//                             <span className="stat-label">Total KR</span>
//                             <span className="stat-value">{total}</span>
//                         </div>
//                     </div>

//                     {/* STATS ROW */}
//                     <div className="okr-stats-row">
//                         <div className="stat-box danger">
//                             <span className="stat-label">Pending</span>
//                             <span className="stat-value">{pending}</span>
//                         </div>

//                         <div className="stat-box success">
//                             <span className="stat-label">Completed</span>
//                             <span className="stat-value">{completed}</span>
//                         </div>
//                     </div>

//                     {/* PROGRESS FULL WIDTH */}
//                     <div className="progress-section-wide full">
//                         <div className="progress-labels">
//                             <span className="label-muted">Completion</span>
//                             <span className="label-bold">{progressPercent}%</span>
//                         </div>

//                         <div className="wide-bar-bg">
//                             <div
//                                 className="wide-bar-fill"
//                                 style={{ width: `${progressPercent}%` }}
//                             ></div>
//                         </div>
//                     </div>

//                     {/* FOOTER */}
//                     <div className="expanded-footer">
//                         <span className={`status-indicator ${pending > 0 ? 'is-warning' : 'is-clear'}`}>
//                             {pending > 0
//                                 ? `● ${pending} Key Results Pending`
//                                 : '● All Key Results Completed'}
//                         </span>

//                         <span className="interaction-hint">
//                             Open OKR Console →
//                         </span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     const [mgmtOneOnOneData, setMgmtOneOnOneData] = useState([]);
//     useEffect(() => {
//         const fetchMeetings = async () => {
//             const storedUser = localStorage.getItem('userData');
//             const user = JSON.parse(storedUser) || {};

//             const res = await fetch(
//                 `/gt-api/get_oneonone.php?manager_id=${user.id}&role=manager`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.meetings) {
//                 setMgmtOneOnOneData(data.meetings);
//             }
//         };

//         fetchMeetings();
//     }, []);

//     const renderOneOnOneHealthCard = () => {
//         const missedData = mgmtOneOnOneData.filter(m => m.status === "MISSED");

//         const total = mgmtOneOnOneData.length;
//         const missed = mgmtOneOnOneData.filter(m => m.status === "MISSED").length;
//         const completed = total - missed;

//         const rate = total > 0 ? Math.round((completed / total) * 100) : 0;

//         let status = "Healthy";
//         if (rate < 50) status = "Critical ⚠️";
//         else if (rate < 80) status = "Needs Attention";

//         return (
//             <div className="meeting-card" onClick={() => handleModuleChange("manager-one-on-one")}>

//                 <div className="mc-header">
//                     <h3>1:1 Meeting Scheduler</h3>
//                     <span>{status}</span>
//                 </div>

//                 {/* BIG NUMBER */}
//                 <div className="mc-center">
//                     <h1>{rate}%</h1>
//                     <p>Engagement</p>
//                 </div>

//                 {/* BARS */}
//                 <div className="mc-bars">
//                     <div className="bar completed" style={{ width: `${rate}%` }}></div>
//                     <div className="bar missed" style={{ width: `${100 - rate}%` }}></div>
//                 </div>

//                 {/* INFO */}
//                 <div className="mc-info">
//                     <span>✅ {completed} Done</span>
//                     <span>❌ {missed} Missed</span>
//                 </div>
//                 <button
//                     className="view-missed-btn"
//                     onClick={(e) => {
//                         e.stopPropagation();
//                         setShowMissedModal(true);
//                     }}
//                 >
//                     View Missed
//                 </button>

//             </div>
//         );
//     };

//     const [okrActivity, setOkrActivity] = useState([]);
//     useEffect(() => {
//         const fetchOKR = async () => {
//             try {
//                 const storedUser = localStorage.getItem("userData");
//                 const user = JSON.parse(storedUser) || {};

//                 const res = await fetch(
//                     `/gt-api/get_employee_okrs.php?role=${user.role}&managedDept=${user.department}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 if (data.success) {
//                     setOkrActivity(data.data);
//                 }

//             } catch (err) {
//                 console.error("OKR Fetch Error:", err);
//             }
//         };

//         fetchOKR();
//     }, []);

//     const recentOKR = okrActivity
//         .slice(0, 5)
//         .map(item => {
//             let type = "updated";

//             if (item.workflow_status === "Planning") {
//                 type = "new";
//             }

//             if (item.workflow_status === "Manager_Scoring_Review") {
//                 type = "pending";
//             }

//             return {
//                 name: item.emp_name,
//                 quarter: item.quarter,
//                 type,
//                 workflow_status: item.workflow_status   // 🔥 VERY IMPORTANT
//             };
//         });



//     const renderOKRActivityCard = () => {
//         const getStatusConfig = (status) => {
//             switch (status) {
//                 case "Planning": return { color: "#3b82f6", label: "submitted OKR" };
//                 case "Management_Review": return { color: "#f59e0b", label: "sent for Review" };
//                 case "Scoring": return { color: "#8b5cf6", label: "sent for Scoring" };
//                 case "Sign_Off": return { color: "#10b981", label: "finalized OKR" };
//                 default: return { color: "#00bcd4", label: "updated OKR" };
//             }
//         };

//         return (
//             <div className="mgt-okr-card1 timeline-style clickable" onClick={() => handleModuleChange("employee-okrs")}>
//                 <div className="card-header-v2">
//                     <div className="title-section">
//                         <h3>OKR Stream</h3>
//                         <div className="live-dot-wrapper">
//                             <span className="live-dot"></span>
//                             <span className="sub-text">Live updates</span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="okr-activity-timeline">
//                     {recentOKR.length === 0 ? (
//                         <div className="empty-state">No recent activity detected</div>
//                     ) : (
//                         recentOKR.slice(0, 3).map((item, i) => {
//                             const config = getStatusConfig(item.workflow_status);
//                             return (
//                                 <div key={i} className="timeline-item">
//                                     {/* The Vertical Line & Dot */}
//                                     <div className="timeline-visual">
//                                         <div className="timeline-line"></div>
//                                         <div className="timeline-marker" style={{ borderColor: '#111827', background: config.color }}>
//                                             <div className="marker-inner-dot"></div>
//                                         </div>
//                                     </div>

//                                     {/* Single Content Box */}
//                                     <div className="timeline-content-box">
//                                         <div className="content-top">
//                                             <span className="emp-name">{item.name}</span>
//                                             <span className="quarter-tag">{item.quarter}</span>
//                                         </div>
//                                         <p className="status-message">{config.label}</p>
//                                     </div>
//                                 </div>
//                             );
//                         })
//                     )}
//                 </div>

//                 <div className="card-footer-v2">
//                     <span>Access Module</span>
//                     {/* <div className="arrow-circle">→</div> */}
//                 </div>


//             </div>
//         );
//     };

//     const renderManagementShortcutsCard = () => {
//         const shortcuts = [

//             { name: "Create Invoice", icon: "🏦", slug: "create-invoice" },
//             { name: "Policy RnU", icon: "📋", slug: "policy-logs" },
//             { name: "Career Development", icon: "🏆", slug: "career pathways" },
//             { name: "Expense Reimbursement", icon: "💰", slug: "reimbursements" },
//             // { name: "ACM Updates", icon: "📢", slug: "manage-quarterly-updates" },
//             { name: "Self OKR", icon: "🎯", slug: "okr and performance tracker" },
//             { name: "Own Financial", icon: "💳", slug: "pay and benefits" },
//             { name: "Access ACM Info", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//             // { name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },
//             { name: "IT Support", icon: "🖥️", slug: "employee-it-support" },
//             { name: "Attendance Tracker", icon: "📊", slug: "attendance-tracker" },
//              { name: "Award Analytics", icon: "🏆", slug: "award-analytics" },
//             // { name: "Company Setup", icon: "⚙️", slug: "CompanySetup" },





//         ];

//         return (
//             <div className="mgt-shortcut-card">

//                 <div className="card-header">
//                     <h3>Quick Access</h3>
//                     <span className="sub-text">Shortcuts</span>
//                 </div>

//                 <div className="shortcut-grid">
//                     {shortcuts.map((item, i) => (
//                         <div
//                             key={i}
//                             className="shortcut-item"
//                             onClick={() => handleModuleChange(item.slug)}
//                         >
//                             <span className="shortcut-icon">{item.icon}</span>
//                             <span className="shortcut-text">{item.name}</span>
//                         </div>
//                     ))}
//                 </div>

//             </div>
//         );
//     };


//     const renderEmployeeDashboard = () => {
//         return (
//             <div className="dashboard-layout">

//                 <div className="dashboard-row row-top">
//                     {renderLeavePieChart()}
//                     {renderPayChart()}
//                     {renderOneOnOneCard()}



//                     {/* {renderEquipmentCard()} */}
//                 </div>

//                 <div className="dashboard-row row-middle">
//                     {renderOKRCard()}
//                     {renderCareerPathwaysCard()}
//                 </div>

//                 <div className="dashboard-row row-bottom">
//                     {renderPolicyCard()}
//                     <QuarterlyCard handleModuleChange={handleModuleChange} />
//                 </div>

//             </div>
//         );
//     };

//     const renderManagementDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>






//         );
//     };

//     const renderManagerDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>




//         );
//     };

//     const currentEvent =
//         todayEvents && todayEvents.length > 0
//             ? todayEvents[currentEventIndex]
//             : null;


//     const combinedEvents = [];

//     // 🎊 Festival TODAY (Priority if festival is today)
//     if (upcomingFestival && isFestivalToday) {
//         combinedEvents.push({
//             type: "festival",
//             title: upcomingFestival.name,
//             tag: "FESTIVAL TODAY",
//             icon: "🎊",
//             sub: "Today 🎉"
//         });
//     }

//     // 🎂 Birthday / Anniversary
//     if (currentEvent && currentEvent.fullName) {
//         combinedEvents.push({
//             type: "event",
//             title: currentEvent.fullName,
//             tag: currentEvent.isBirthday ? "BIRTHDAY" : "WORK ANNIVERSARY",
//             icon: currentEvent.isBirthday ? "🎂" : "🎉"
//         });
//     }

//     // 🎊 Upcoming Festival (If future)
//     if (upcomingFestival && !isFestivalToday) {
//         combinedEvents.push({
//             type: "festival",
//             title: upcomingFestival.name,
//             tag: "UPCOMING FESTIVAL",
//             icon: "🎊",
//             sub: `In ${daysLeft} days`
//         });
//     }

//     useEffect(() => {
//         if (combinedEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setActiveEventIndex(prev => (prev + 1) % combinedEvents.length);
//         }, 4000);

//         return () => clearInterval(interval);
//     }, [combinedEvents.length]);

//     const activeEvent = combinedEvents[activeEventIndex];


//     return (

//         <div


//             className={`dash-container ${theme}-theme`}
//             style={
//                 theme === 'light'
//                     ? {
//                         backgroundImage: `url(${logoLight})`,
//                         backgroundSize: 'cover',
//                         backgroundRepeat: 'no-repeat',
//                         backgroundPosition: 'center',
//                         backgroundColor: 'var(--bg-main)'

//                     }
//                     : {}
//             }
//         >


//             {showMissedModal && (
//                 <div className="modal-overlay" onClick={() => setShowMissedModal(false)}>
//                     <div className="modal-card" onClick={(e) => e.stopPropagation()}>

//                         <h3>Missed 1:1 Meetings</h3>

//                         {mgmtOneOnOneData.filter(m => m.status === "MISSED").length === 0 ? (
//                             <p>No missed meetings 🎉</p>
//                         ) : (
//                             mgmtOneOnOneData
//                                 .filter(m => m.status === "MISSED")
//                                 .map((m, i) => (
//                                     <div key={i} className="missed-item">
//                                         <strong>{m.employee_name}</strong>
//                                         <span>{m.date}</span>
//                                     </div>
//                                 ))
//                         )}

//                         <button onClick={() => setShowMissedModal(false)}>
//                             Close
//                         </button>

//                     </div>
//                 </div>
//             )}



//             <div className="auth-background-overlay"></div>






//             <Sidebar
//                 role={role}
//                 userData={userData}
//                 activeModule={activeModule}
//                 openMenus={openMenus}
//                 toggleSubMenu={toggleSubMenu}
//                 handleModuleChange={handleModuleChange}
//                 handleLogout={handleLogout}
//                 mobileMenuOpen={mobileMenuOpen}
//                 setMobileMenuOpen={setMobileMenuOpen}
//                 pendingRequestsCount={pendingRequestsCount}
//             />

//             <main className="dash-content">

//                 <header className="content-header">

//                     {/* 🔷 LEFT */}
//                     <div className="header-left">
//                         <div className="header-text">

//                             <h1>
//                                 {activeModule === "grid" && !showProfile ? "Welcome," : ""}{" "}
//                                 <span className={theme === 'light' ? "name-light" : "name-accent"}>
//                                     {showProfile
//                                         ? "MY PROFILE"
//                                         : (activeModule === "grid"
//                                             ? userData.firstName || userData.FirstName
//                                             : (activeModule === "attendance"
//                                                 ? "LEAVE MANAGEMENT"
//                                                 : (activeModule === "one-on-one-report"
//                                                     ? "ONE-ON-ONE REPORT"
//                                                     : activeModule.toUpperCase().replace(/-/g, ' ')
//                                                 )
//                                             )
//                                         )
//                                     }
//                                 </span>
//                             </h1>

//                             {activeModule === 'attendance' && userData.joiningDate && (
//                                 <div className="joining-info">
//                                     JOINING_DATE: {new Date(userData.joiningDate).toLocaleDateString('en-GB').toUpperCase()}
//                                 </div>
//                             )}

//                         </div>
//                     </div>







//                     <div className="header-center">

//                         {/* TIME + DATE FIRST */}
//                         <div className="time-date-right">
//                             <div className="live-time">{currentTime}</div>

//                             <div className="today-widget">
//                                 <span>📅 {todayDate}</span>
//                                 <small>Have a Nice Day!</small>
//                             </div>
//                         </div>

//                         {/* EVENT CARD SECOND */}
//                         <div
//                             className={`executive-event-bar ${theme === 'light' ? 'light-theme-elite' : 'dark-theme-elite'}
//         ${role === "Management" || role === "Manager" ? "clickable" : ""}`}
//                             onClick={() => {
//                                 if (role === "Management" || role === "Manager") {
//                                     handleModuleChange("events-celebrations");
//                                 }
//                             }}
//                         >
//                             <div
//                                 className={`event-status-box ${activeEvent
//                                     ? (activeEvent.type === 'festival'
//                                         ? 'bg-fest'
//                                         : (activeEvent.tag === 'BIRTHDAY' ? 'bg-birth' : 'bg-anniv'))
//                                     : 'bg-neutral'
//                                     }`}
//                             >
//                                 <span className="event-icon-small">
//                                     {activeEvent ? activeEvent.icon : "✨"}
//                                 </span>
//                             </div>

//                             <div className="event-content-main">
//                                 <div className="event-label-row">
//                                     <span className="event-tag">
//                                         {activeEvent ? activeEvent.tag : "TODAY"}
//                                     </span>
//                                 </div>

//                                 <h3 className="event-title-text">

//                                     {activeEvent ? (
//                                         <span className="event-highlight">
//                                             {activeEvent.icon} {activeEvent.title}
//                                         </span>
//                                     ) : (
//                                         <span className="event-empty-text">
//                                             No events today
//                                         </span>
//                                     )}
//                                 </h3>
//                             </div>

//                             <div className="event-action-wrapper">
//                                 <button
//                                     className="minimal-wish-btn"
//                                     disabled={!currentEvent}
//                                     onClick={(e) => e.stopPropagation()}
//                                 >
//                                     <div className="btn-line"></div>
//                                 </button>
//                             </div>
//                         </div>

//                     </div>







//                     <div className="header-controls">

//                         {/* 🌗 THEME */}
//                         <div className="theme-switch-container">
//                             <label className="theme-slider-switch">
//                                 <input
//                                     type="checkbox"
//                                     onChange={toggleTheme}
//                                     checked={theme === 'light'}
//                                 />
//                                 <span className="theme-slider round">
//                                     <span className="sun-icon">☀️</span>
//                                     <span className="moon-icon">🌙</span>
//                                 </span>
//                             </label>
//                         </div>




//                         {(activeModule !== "grid" || showProfile) && (
//                             <button
//                                 className="back-btn"
//                                 onClick={() => handleModuleChange("grid")}
//                             >
//                                 Back
//                             </button>
//                         )}

//                     </div>

//                 </header>


//                 {activeModule === "grid" ? (

//                     role === "Management"
//                         ? renderManagementDashboard()
//                         : role === "Manager"
//                             ? renderManagerDashboard()   // 🔥 ADD THIS LINE
//                             : renderEmployeeDashboard()

//                 ) : (
//                     renderActiveModule()
//                 )}

//                 <div className="dash-footer">
//                     Design & Developed by Genesis Tech Engineers © 2026
//                 </div>
//             </main>

//             {(role === "Management" || role === "Manager") && (
//                 <>
//                     <div
//                         className="ai-chat-float-btn"
//                         onClick={() => setShowAIChat(true)}
//                     >
//                         🤖
//                     </div>

//                     {showAIChat && (
//                         <div className="ai-chat-modal">
//                             <div className="ai-chat-header">
//                                 <span>ELMS AI Assistant</span>
//                                 <button onClick={() => setShowAIChat(false)}>
//                                     ✕
//                                 </button>
//                             </div>

//                             <div className="ai-chat-body">
//                                 {chatMessages.map((msg, index) => (
//                                     <div
//                                         key={index}
//                                         className={`chat-bubble ${msg.sender}`}
//                                     >
//                                         <pre>{msg.text}</pre>
//                                     </div>
//                                 ))}

//                                 {chatLoading && (
//                                     <div className="chat-bubble ai">
//                                         Thinking...
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="ai-chat-footer">
//                                 <input
//                                     type="text"
//                                     value={chatInput}
//                                     onChange={(e) => setChatInput(e.target.value)}
//                                     placeholder="Ask anything..."
//                                     onKeyDown={(e) => {
//                                         if (e.key === "Enter") {
//                                             sendAIMessage();
//                                         }
//                                     }}
//                                 />

//                                 <button onClick={sendAIMessage}>
//                                     Send
//                                 </button>
//                             </div>
//                         </div>
//                     )}
//                 </>
//             )}

//             {/* 1️⃣ MANDATORY COMPANY POLICY ACKNOWLEDGEMENT MODAL (FIRST) */}
//             {showMandatoryPolicyModal && (
//                 <div className="mandatory-policy-fullscreen-overlay">
//                     {/* Top Header Bar */}
//                     <div className="mandatory-policy-topbar">
//                         <div className="topbar-title-area">
//                             <span className="topbar-icon">📜</span>
//                             <h2>Mandatory Company Policy Acknowledgement</h2>
//                         </div>

//                         <div className="topbar-progress-area">
//                             <div className="topbar-progress-text">
//                                 <span>Progress: <strong>{acknowledgedPoliciesCount}</strong> of <strong>{totalPoliciesCount}</strong> Policies Acknowledged</span>
//                                 <span className="topbar-badge">{unacknowledgedPolicies.length} Remaining</span>
//                             </div>
//                             <div className="topbar-progress-track">
//                                 <div
//                                     className="topbar-progress-fill"
//                                     style={{ width: `${totalPoliciesCount > 0 ? (acknowledgedPoliciesCount / totalPoliciesCount) * 100 : 0}%` }}
//                                 ></div>
//                             </div>
//                         </div>

//                         <button
//                             type="button"
//                             className="topbar-logout-btn"
//                             onClick={handleLogout}
//                         >
//                             🚪 Logout
//                         </button>
//                     </div>

//                     {/* Alerts */}
//                     {policyAckError && (
//                         <div className="mandatory-alert-box error" style={{ margin: '8px 24px 0 24px' }}>
//                             <span>⚠️ {policyAckError}</span>
//                         </div>
//                     )}

//                     {policyAckSuccessMsg && (
//                         <div className="mandatory-alert-box success" style={{ margin: '8px 24px 0 24px' }}>
//                             <span>✅ {policyAckSuccessMsg}</span>
//                         </div>
//                     )}

//                     {/* Full Screen Layout Body */}
//                     <div className="mandatory-policy-fullscreen-body">
//                         {/* Left Sidebar Menu */}
//                         <div className="mandatory-policy-sidebar">
//                             <h3>Company Policies ({(allPoliciesList.length > 0 ? allPoliciesList : GENESIS_POLICIES).length})</h3>
//                             <div className="mandatory-policy-list">
//                                 {(allPoliciesList.length > 0 ? allPoliciesList : GENESIS_POLICIES).map((p, idx) => {
//                                     const pTitle = p.title || p.policy_title;
//                                     const pIcon = p.icon || p.policy_icon || "📜";
//                                     const isAck = !!logs[pTitle];
//                                     const isSelected = selectedMandatoryPolicy && (selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title) === pTitle;

//                                     return (
//                                         <div
//                                             key={p.id || idx}
//                                             className={`mandatory-policy-item ${isSelected ? "active" : ""} ${isAck ? "signed" : ""}`}
//                                             onClick={() => {
//                                                 setSelectedMandatoryPolicy(p);
//                                                 setPolicyAgreed(false);
//                                             }}
//                                         >
//                                             <span className="p-item-icon">{pIcon}</span>
//                                             <span className="p-item-title">{pTitle}</span>
//                                             {isAck ? (
//                                                 <span className="p-item-tag ack">✅ Signed</span>
//                                             ) : (
//                                                 <span className="p-item-tag pending">Required</span>
//                                             )}
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         </div>

//                         {/* Right Main Policy Content Viewer */}
//                         <div className="mandatory-policy-fullscreen-viewer">
//                             {selectedMandatoryPolicy ? (
//                                 <>
//                                     <div className="mandatory-viewer-header">
//                                         <h3>
//                                             <span>{selectedMandatoryPolicy.icon || selectedMandatoryPolicy.policy_icon || "📜"}</span>
//                                             {selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title}
//                                             {logs[selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title] && (
//                                                 <span className="viewer-signed-badge">✅ Acknowledged</span>
//                                             )}
//                                         </h3>
//                                     </div>

//                                     {/* Full Height Scrollable Document Body */}
//                                     <div className="mandatory-policy-document-body">
//                                         {selectedMandatoryPolicy.content ? (
//                                             typeof selectedMandatoryPolicy.content === 'string' ? (
//                                                 <div dangerouslySetInnerHTML={{ __html: selectedMandatoryPolicy.content }} />
//                                             ) : (
//                                                 selectedMandatoryPolicy.content
//                                             )
//                                         ) : (
//                                             <p className="policy-placeholder">Please review the contents of this policy carefully before accepting.</p>
//                                         )}
//                                     </div>

//                                     {/* Fixed Bottom Action Section */}
//                                     <div className="mandatory-policy-bottom-action-bar">
//                                         {logs[selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title] ? (
//                                             <div className="mandatory-policy-signed-banner">
//                                                 <span>✅ Policy Acknowledged & Signed</span>
//                                             </div>
//                                         ) : (
//                                             <form onSubmit={handleAcknowledgeMandatoryPolicy} className="mandatory-ack-stacked-form">
//                                                 <label className="mandatory-checkbox-container">
//                                                     <input
//                                                         type="checkbox"
//                                                         checked={policyAgreed}
//                                                         onChange={(e) => setPolicyAgreed(e.target.checked)}
//                                                     />
//                                                     <span>
//                                                         I confirm that I have read, understood, and agree to abide by the terms of <strong>{selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title}</strong>.
//                                                     </span>
//                                                 </label>

//                                                 <button
//                                                     type="submit"
//                                                     className="mandatory-save-btn"
//                                                     disabled={!policyAgreed || policyAckSaving}
//                                                 >
//                                                     {policyAckSaving ? "Recording..." : "Acknowledge & Accept Policy ✅"}
//                                                 </button>
//                                             </form>
//                                         )}
//                                     </div>
//                                 </>
//                             ) : (
//                                 <div className="mandatory-policy-document-body">
//                                     <p>Select a policy from the list on the left to read and acknowledge.</p>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* 2️⃣ MANDATORY BANK DETAILS POPUP MODAL (SECOND) */}
//             {showMandatoryBankModal && !showMandatoryPolicyModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">🏦</div>
//                             <h2>Mandatory Bank Details Required</h2>
//                             <p>
//                                 Your employee bank record has missing information. Please fill in the required field(s) below for payroll & salary processing.
//                             </p>
//                         </div>

//                         {bankError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {bankError}</span>
//                             </div>
//                         )}

//                         {bankSuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {bankSuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryBankDetails} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingBankFields.bankName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Bank Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC Bank, ICICI Bank"
//                                             value={bankFormData.bankName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, bankName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.holderName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Holder Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account holder name"
//                                             value={bankFormData.holderName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, holderName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accNumber && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account number"
//                                             value={bankFormData.accNumber}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accNumber: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.ifsc && (
//                                     <div className="mandatory-input-group">
//                                         <label>IFSC Code <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC0001234"
//                                             value={bankFormData.ifsc}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, ifsc: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.branch && (
//                                     <div className="mandatory-input-group">
//                                         <label>Branch Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter branch name"
//                                             value={bankFormData.branch}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, branch: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accType && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Type <span className="req-star">*</span></label>
//                                         <select
//                                             value={bankFormData.accType}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accType: e.target.value }))}
//                                             required
//                                         >
//                                             <option value="Saving Account">Saving Account</option>
//                                             <option value="Current Account">Current Account</option>
//                                             <option value="Salary Account">Salary Account</option>
//                                         </select>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={bankSaving}
//                                 >
//                                     {bankSaving ? "Saving Bank Details..." : "Save Bank Details & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}

//             {/* 3️⃣ MANDATORY PROFILE POPUP MODAL (THIRD) */}
//             {showMandatoryProfileModal && !showMandatoryPolicyModal && !showMandatoryBankModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">⚠️</div>
//                             <h2>Mandatory Profile Completion Required</h2>
//                             <p>
//                                 Your employee profile has missing information. Please fill in the required field(s) below to continue using the system.
//                             </p>
//                         </div>

//                         {mandatoryError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {mandatoryError}</span>
//                             </div>
//                         )}

//                         {mandatorySuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {mandatorySuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryProfile} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingProfileFields.phone && (
//                                     <div className="mandatory-input-group">
//                                         <label>Mobile Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="tel"
//                                             placeholder="Enter mobile number"
//                                             value={mandatoryFormData.phone}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, phone: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.dob && (
//                                     <div className="mandatory-input-group">
//                                         <label>Date of Birth <span className="req-star">*</span></label>
//                                         <input
//                                             type="date"
//                                             max={new Date().toISOString().split("T")[0]}
//                                             value={mandatoryFormData.dob}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, dob: e.target.value }))}
//                                             onClick={(e) => {
//                                                 try {
//                                                     if (e.target.showPicker) e.target.showPicker();
//                                                 } catch (err) { }
//                                             }}
//                                             required
//                                             className="mandatory-date-input"
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.city && (
//                                     <div className="mandatory-input-group">
//                                         <label>City <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter city"
//                                             value={mandatoryFormData.city}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, city: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.country && (
//                                     <div className="mandatory-input-group">
//                                         <label>Country <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter country"
//                                             value={mandatoryFormData.country}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, country: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Permanent Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter permanent address"
//                                             value={mandatoryFormData.address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.local_address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Current / Local Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter current / local address"
//                                             value={mandatoryFormData.local_address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, local_address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={mandatorySaving}
//                                 >
//                                     {mandatorySaving ? "Saving Profile..." : "Save Profile & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Dashboard;











































// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';

// import {
//     ResponsiveContainer,
//     BarChart,
//     Bar,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip
// } from "recharts";
// import { Bar as ChartBar, Pie, Doughnut } from 'react-chartjs-2';

// // ✅ REACT + ROUTER
// import React, { useState, useEffect, useMemo } from 'react';
// import { useParams, useNavigate, useLocation } from 'react-router-dom';

// // ✅ MODULES
// import Attendance from '../../modules/Attendance';
// import PayBenefits from '../../modules/PayBenefits';
// import OKRTracker from '../../modules/OKRTracker';
// import CareerPathways from '../../modules/CareerPathways';
// import EquipmentRequest from '../../modules/EquipmentRequest';
// import OfficeRequisition from '../../modules/OfficeRequisition';
// import ITSupport from '../../modules/ITSupport';
// import Documents from '../../modules/Documents';
// import CompanyPolicy, { GENESIS_POLICIES } from '../../modules/CompanyPolicy';
// import OrgChart from '../../modules/OrgChart';
// import CampusInfo from '../../modules/CampusInfo';
// import AddDepartment from '../../modules/AddDepartment';
// import AddEmployee from '../../modules/AddEmployee';
// import ManageDepartment from '../../modules/ManageDepartment';
// import ManageEmployee from '../../modules/ManageEmployee';
// import MyProfile from '../../modules/MyProfile';
// import LeaveManagement from '../../modules/LeaveManagement';
// import EESExperience from '../../modules/EESExperience';
// import EESFeedbackManagement from '../../modules/EESFeedbackManagement';
// import MedicalReports from '../../modules/MedicalReports';
// import ManagementOKRViewer from '../../modules/ManagementOKRViewer';
// import ManagerLeaveManagement from '../../modules/ManagerLeaveManagement';
// import ManagerMedicalReports from '../../modules/ManagerMedicalReports';
// import EmployeeSalaryBenefits from '../../modules/EmployeeSalaryBenefits';
// import PolicyAdminDashboard from '../../modules/PolicyAdminDashboard';
// import ManageEmployeeDocs from '../../modules/ManageEmployeeDocs';
// import OneOnOne from '../../modules/OneOnOne';
// import EventsCelebrations from '../../modules/EventsCelebrations';
// import ProjectModule from '../../modules/ProjectModule';
// import QuarterlyUpdates from '../../modules/QuarterlyUpdates';
// import ManagementQuarterlyUpdate from '../../modules/ManagementQuarterlyUpdate';
// import ReimbursementManagement from '../../modules/ReimbursementManagement';
// import WorkFromHome from '../../modules/WorkFromHome';
// import WFHManagement from '../../modules/WFHManagement';
// import OneOnOneAnalyticsCard from "../../modules/OneOnOneAnalyticsCard";
// import OneOnOneReport from '../../modules/OneOnOneReport';
// import InvoiceGenerator from '../../modules/InvoiceGenerator';
// import AttendanceTracker from '../../modules/AttendanceTracker';
// import CompanySetup from '../../modules/CompanySetup';
// import AwardNominations from '../../modules/AwardNominations';
// import AwardAnalyticsDashboard from '../../modules/AwardAnalyticsDashboard';
// import Sidebar from "../../components/Sidebar/sidebar";

// // ✅ ASSETS
// import logoLight from '../../assets/logowhite-p.png';
// import logoDark from '../../assets/logo-white-r.png';

// // ✅ STYLES
// import './Dashboard.css';


// // ✅ CHART.JS CORE
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip as ChartTooltip,  // ✅ rename this
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// } from 'chart.js';

// // ✅ REGISTER CHART.JS
// ChartJS.register(
//     ArcElement,
//     ChartTooltip, // ✅ use renamed one
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// );



// const QuarterlyCard = ({ handleModuleChange }) => {

//     const [latest, setLatest] = React.useState(null);

//     React.useEffect(() => {
//         fetch(
//             "/gt-api/get_quarterly_media.php?type=ACM Presentation",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "ACM DATA:",
//                     data
//                 );

//                 if (data.success && data.data.length > 0) {
//                     setLatest(data.data[0]);
//                 }
//             })
//             .catch(err => console.error("Quarterly Fetch Error:", err));
//     }, []);

//     console.log("LATEST ACM:", latest);

//     return (
//         <div
//             className="quarterly-pro-card clickable"
//             onClick={() => handleModuleChange("quarterly-updates")}
//         >
//             {/* Glow Layer */}
//             <div className="card-glow"></div>

//             {/* HEADER */}
//             <div className="qp-header">
//                 <div className="qp-left">
//                     <span className="qp-tag">ACM Updates</span>
//                     <h3 className="qp-title">Quarterly Insights</h3>
//                 </div>

//                 <div className="qp-icon">📢</div>
//             </div>

//             {/* BODY */}
//             <div className="qp-body">
//                 {latest ? (
//                     <>
//                         <h4 className="qp-main-title">{latest.title}</h4>

//                         <div className="qp-meta">
//                             <span className="qp-date">
//                                 {new Date(latest.created_at).toLocaleDateString('en-GB')}
//                             </span>
//                             <span className="qp-badge">NEW</span>
//                         </div>
//                     </>
//                 ) : (
//                     <div className="qp-empty">
//                         <div className="qp-loader"></div>
//                         <span>Awaiting next update</span>
//                     </div>
//                 )}
//             </div>

//             {/* FOOTER */}
//             <div className="qp-footer">
//                 <span>View Presentation</span>
//                 <span className="arrow">→</span>
//             </div>
//         </div>
//     );
// };


// const Dashboard = () => {
//     const [dashboardDepartments, setDashboardDepartments] = useState([]);
//     const [dashboardPathways, setDashboardPathways] = useState([]);
//     const [policyCount, setPolicyCount] = useState(0);

//     const [showAIChat, setShowAIChat] = useState(false);

//     const [chatMessages, setChatMessages] = useState([
//         {
//             sender: "ai",
//             text: "Hello 👋 Ask me anything about your ELMS database."
//         }
//     ]);

//     const [chatInput, setChatInput] = useState("");
//     const [chatLoading, setChatLoading] = useState(false);



//     const [showMissedModal, setShowMissedModal] = useState(false);

//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//     const [todayEvents, setTodayEvents] = useState([]);
//     useEffect(() => {
//         const fetchTodayEvents = async () => {
//             try {
//                 const res = await fetch('/gt-api/get_celebrations.php');
//                 const data = await res.json();

//                 if (data.success) {
//                     setTodayEvents(data.data || []);
//                 }
//             } catch (err) {
//                 console.error("Dashboard Events Error:", err);
//             }
//         };

//         fetchTodayEvents();
//     }, []);
//     const [currentEventIndex, setCurrentEventIndex] = useState(0);
//     useEffect(() => {
//         if (!todayEvents || todayEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setCurrentEventIndex((prev) =>
//                 (prev + 1) % todayEvents.length
//             );
//         }, 3000); // change every 3 sec

//         return () => clearInterval(interval);
//     }, [todayEvents]);


//     const [equipmentData, setEquipmentData] = useState({
//         total: 0,
//         pending: 0,
//         blocking: 0
//     });



//     const [logs, setLogs] = useState({});

//     const totalPolicies = 11;
//     const readCount = Object.keys(logs || {}).length;

//     const progress = totalPolicies > 0
//         ? Math.round((readCount / totalPolicies) * 100)
//         : 0;


//     const params = useParams();
//     const module = params.module;

//     const storedUser = JSON.parse(localStorage.getItem("userData"));
//     const role = storedUser?.role;
//     const navigate = useNavigate();

//     useEffect(() => {
//         const storedUser = localStorage.getItem("userData");

//         if (!storedUser) {
//             navigate("/", { replace: true });
//             return;
//         }

//         // prevent back button access after logout
//         window.history.pushState(null, "", window.location.href);
//         window.onpopstate = function () {
//             const user = localStorage.getItem("userData");
//             if (!user) {
//                 navigate("/", { replace: true });
//             }
//         };

//     }, [navigate]);







//     const [policyLogs, setPolicyLogs] = useState({});





//     const checkIfFestivalIsToday = (festival, daysLeftVal, isTodayFlag) => {
//         if (!festival) return false;
//         if (isTodayFlag === true || daysLeftVal === 0) return true;

//         if (festival.date) {
//             const today = new Date();
//             const currentDay = today.getDate();
//             const currentMonth = today.getMonth();
//             const monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
//             const currentMonthName = monthNames[currentMonth];

//             const dateLower = String(festival.date).trim().toLowerCase();

//             // 1. Text Month Matching (e.g., "7th Sep", "7 Sep", "2nd to 10th Oct")
//             if (dateLower.includes(currentMonthName) || (currentMonthName === "sep" && dateLower.includes("sept"))) {
//                 const rangeMatch = dateLower.match(/(\d+)\s*(?:st|nd|rd|th)?\s*to\s*(\d+)\s*(?:st|nd|rd|th)?/);
//                 if (rangeMatch) {
//                     const startDay = parseInt(rangeMatch[1], 10);
//                     const endDay = parseInt(rangeMatch[2], 10);
//                     if (currentDay >= startDay && currentDay <= endDay) {
//                         return true;
//                     }
//                 }

//                 const numbers = dateLower.match(/\d+/g);
//                 if (numbers) {
//                     for (let numStr of numbers) {
//                         const num = parseInt(numStr, 10);
//                         if (num === currentDay) {
//                             return true;
//                         }
//                     }
//                 }
//             }

//             // 2. Numeric Date Matching (e.g., "7-9-2026", "07-09-2026", "7/9/2026", "2026-09-07")
//             const numMatch = dateLower.match(/^(\d{1,4})[-/.](\d{1,2})[-/.](\d{1,4})$/);
//             if (numMatch) {
//                 let p1 = parseInt(numMatch[1], 10);
//                 let p2 = parseInt(numMatch[2], 10);
//                 let p3 = parseInt(numMatch[3], 10);

//                 let d, m;
//                 if (p1 > 31) {
//                     m = p2; d = p3;
//                 } else {
//                     d = p1; m = p2;
//                 }

//                 if (d === currentDay && m === (currentMonth + 1)) {
//                     return true;
//                 }
//             }
//         }

//         if (typeof daysLeftVal === 'number' && daysLeftVal === 0) {
//             return true;
//         }

//         return false;
//     };

//     const [upcomingFestival, setUpcomingFestival] = useState(null);
//     const [daysLeft, setDaysLeft] = useState(null);
//     const [isFestivalToday, setIsFestivalToday] = useState(false);
//     const [activeEventIndex, setActiveEventIndex] = useState(0);
//     useEffect(() => {
//         fetch("/gt-api/get_upcoming_festival.php", {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 const fest = data.festival || data.upcoming || (data.data && data.data[0]);
//                 if (fest) {
//                     const normalized = {
//                         ...fest,
//                         name: fest.name || fest.festival_name || fest.title || "Festival",
//                         image: fest.image || fest.img || fest.imageName || ""
//                     };
//                     setUpcomingFestival(normalized);
//                     setDaysLeft(data.daysLeft ?? 0);
//                     const festIsToday = data.isToday || data.daysLeft === 0 || checkIfFestivalIsToday(normalized, data.daysLeft, data.isToday);
//                     setIsFestivalToday(festIsToday);
//                 }
//             })
//             .catch(err => console.error(err));
//     }, []);


//     const location = useLocation();



//     const [showProfile, setShowProfile] = useState(false);
//     const [showPasswordModal, setShowPasswordModal] = useState(false);
//     const [isEditing, setIsEditing] = useState(false);

//     const [activeModule, setActiveModule] = useState(module || "grid");
//     const [isLightMode, setIsLightMode] = useState(false);

//     const [openMenus, setOpenMenus] = useState({
//         department: false,
//         employee: false
//     });

//     const [pendingRequestsCount, setPendingRequestsCount] = useState(0);
//     const [pendingLeavesCount, setPendingLeavesCount] = useState(0);
//     const [requestsList, setRequestsList] = useState([]);
//     const [notifCount, setNotifCount] = useState(0);

//     const [eesSubmissions, setEesSubmissions] = useState([]);
//     const handleEESSubmit = (newFeedback) => {
//         setEesSubmissions(prev => [...prev, newFeedback]);
//     };

//     const [passwordForm, setPasswordForm] = useState({
//         currentPassword: '',
//         newPassword: '',
//         confirmPassword: ''
//     });

//     const [showMandatoryProfileModal, setShowMandatoryProfileModal] = useState(false);
//     const [missingProfileFields, setMissingProfileFields] = useState({
//         phone: false,
//         dob: false,
//         city: false,
//         address: false,
//         local_address: false,
//         country: false
//     });
//     const [mandatoryFormData, setMandatoryFormData] = useState({
//         phone: '',
//         dob: '',
//         city: '',
//         address: '',
//         local_address: '',
//         country: ''
//     });
//     const [mandatorySaving, setMandatorySaving] = useState(false);
//     const [mandatoryError, setMandatoryError] = useState('');
//     const [mandatorySuccessMsg, setMandatorySuccessMsg] = useState('');

//     // 🔴 MANDATORY BANK DETAILS MODAL STATE
//     const [showMandatoryBankModal, setShowMandatoryBankModal] = useState(false);
//     const [missingBankFields, setMissingBankFields] = useState({
//         bankName: false,
//         holderName: false,
//         accNumber: false,
//         ifsc: false,
//         branch: false,
//         accType: false
//     });
//     const [bankFormData, setBankFormData] = useState({
//         bankName: '',
//         holderName: '',
//         accNumber: '',
//         ifsc: '',
//         branch: '',
//         accType: 'Saving Account'
//     });
//     const [bankSaving, setBankSaving] = useState(false);
//     const [bankError, setBankError] = useState('');
//     const [bankSuccessMsg, setBankSuccessMsg] = useState('');

//     // 📜 MANDATORY COMPANY POLICY ACKNOWLEDGEMENT MODAL STATE
//     const [showMandatoryPolicyModal, setShowMandatoryPolicyModal] = useState(false);
//     const [allPoliciesList, setAllPoliciesList] = useState([]);
//     const [unacknowledgedPolicies, setUnacknowledgedPolicies] = useState([]);
//     const [selectedMandatoryPolicy, setSelectedMandatoryPolicy] = useState(null);
//     const [policyAckSaving, setPolicyAckSaving] = useState(false);
//     const [policyAckError, setPolicyAckError] = useState('');
//     const [policyAckSuccessMsg, setPolicyAckSuccessMsg] = useState('');
//     const [totalPoliciesCount, setTotalPoliciesCount] = useState(11);
//     const [acknowledgedPoliciesCount, setAcknowledgedPoliciesCount] = useState(0);
//     const [policyAgreed, setPolicyAgreed] = useState(false);




//     const [userData, setUserData] = useState(() => {
//         const storedData = localStorage.getItem("userData");
//         if (storedData) return JSON.parse(storedData);

//         const firstName = location.state?.userName?.split(' ')[0] || "User";
//         const lastName = location.state?.userName?.split(' ')[1] || "";

//         return {
//             firstName,
//             lastName,
//             email: "",
//             dept: "Loading...",
//             phone: "",
//             gender: "",
//             dob: "",
//             address: "",
//             city: "",
//             country: "",
//             employeeId: location.state?.empId || null,
//             profileImage: null,
//             joiningDate: null,
//             HOD: null
//         };
//     });


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_career_pathways.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setDashboardPathways(
//                         data.pathways || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_departments.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "DASHBOARD DEPARTMENTS:",
//                     data
//                 );

//                 if (data.success) {

//                     setDashboardDepartments(
//                         data.departments || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) {

//             setPolicyCount(11);
//             return;

//         }

//         fetch(
//             "/gt-api/get_policies.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setPolicyCount(
//                         data.policies?.length || 0
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);
//     // ✅ THEN use it
//     const employeeId = userData?.id || userData?.employeeId;


//     useEffect(() => {
//         const fetchLeaveDashboardData = async () => {
//             if (!employeeId) return;

//             try {
//                 const res = await fetch(`/gt-api/get_leaves.php?empid=${employeeId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 const wfhRes = await fetch(`/gt-api/get_wfh.php?empid=${employeeId}`, {
//                     credentials: "include"
//                 });
//                 const wfhData = await wfhRes.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];

//                     // 🔥 SAME LOGIC AS ATTENDANCE
//                     const today = new Date();
//                     const currentYear = today.getFullYear();

//                     const fiscalYearStart = new Date(currentYear, 3, 1);

//                     const activeFiscalYearStart =
//                         today < fiscalYearStart
//                             ? new Date(currentYear - 1, 3, 1)
//                             : fiscalYearStart;

//                     // ✅ Dynamic Sick Total (joining based)
//                     let sickTotal = 12;

//                     if (userData?.joiningDate) {
//                         const joining = new Date(userData.joiningDate);

//                         const fyEnd = new Date(activeFiscalYearStart);
//                         fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
//                         fyEnd.setMonth(2);
//                         fyEnd.setDate(31);

//                         if (joining > activeFiscalYearStart) {
//                             if (joining > fyEnd) {
//                                 sickTotal = 0;
//                             } else {
//                                 const joinMonth = joining.getMonth();
//                                 const fyEndMonth = 2;

//                                 let monthsRemaining;

//                                 if (joinMonth <= fyEndMonth) {
//                                     monthsRemaining = fyEndMonth - joinMonth + 1;
//                                 } else {
//                                     monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
//                                 }

//                                 sickTotal = monthsRemaining;
//                             }
//                         }
//                     }

//                     let sickUsed = 0;
//                     let earnedUsed = 0;

//                     leaves.forEach(leave => {
//                         const status = String(leave.Status);
//                         const days = parseFloat(leave.total) || 0;
//                         const leaveDate = new Date(leave.fromdate);
//                         const medStatus = String(leave.medical_doc_status);

//                         // ✅ SAME CONDITION AS ATTENDANCE
//                         if (status === '0' || status === '1') {

//                             if (leave.leavetype === 'Sick Leave') {
//                                 if (leaveDate >= activeFiscalYearStart) {
//                                     sickUsed += days;
//                                 }
//                             }

//                             else if (leave.leavetype === 'Earned Leave') {

//                                 // 🔥 MEDICAL CONVERSION LOGIC
//                                 if (medStatus === '1' || medStatus === '0') {
//                                     if (leaveDate >= activeFiscalYearStart) {
//                                         sickUsed += days;
//                                     }
//                                 } else {
//                                     earnedUsed += days;
//                                 }
//                             }
//                         }
//                     });


//                     console.log("LEAVES:", leaves);
//                     console.log("SICK USED:", sickUsed);
//                     console.log("EARNED USED:", earnedUsed);
//                     console.log("API EARNED BALANCE:", data.earned);

//                     setLeaveData({
//                         leaveHistory: leaves,
//                         leaveBalances: {
//                             sick: { used: sickUsed, total: sickTotal },
//                             earned: { used: earnedUsed, total: parseFloat(data.earned) || 0 }
//                         },
//                         wfhHistory: wfhData.requests || []
//                     });
//                 }

//             } catch (err) {
//                 console.error("Dashboard Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaveDashboardData();
//     }, [employeeId, userData?.joiningDate]);


//     useEffect(() => {
//         setActiveModule(module || "grid");
//     }, [module]);

//     useEffect(() => {

//         if (role === 'Management' || role === 'Manager') {

//             const fetchRealTimeLeaves = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_leaves.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {
//                         // Count requests with Status '0' or null
//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };


//             fetchRealTimeLeaves();


//             const liveInterval = setInterval(fetchRealTimeLeaves, 5000);

//             return () => clearInterval(liveInterval);
//         }
//     }, [role]);



//     useEffect(() => {

//         const fetchUserData = async () => {

//             try {

//                 const response = await fetch("/gt-api/get_profile.php", {
//                     credentials: "include"
//                 });

//                 const data = await response.json();

//                 if (data.success && data.employee) {

//                     const storedUser = JSON.parse(localStorage.getItem("userData"));

//                     const updatedUser = {
//                         id: data.employee.id,
//                         EmpId: data.employee.EmpId,

//                         firstName: data.employee.FirstName,
//                         FirstName: data.employee.FirstName,

//                         lastName: data.employee.LastName,
//                         LastName: data.employee.LastName,

//                         email: data.employee.EmailId,
//                         EmailId: data.employee.EmailId,

//                         Department: data.employee.DepartmentName || data.employee.Department,

//                         HOD: data.employee.HOD,
//                         Designation: data.employee.Designation,
//                         phone: data.employee.Phonenumber,
//                         gender: data.employee.Gender,
//                         dob: data.employee.Dob,
//                         address: data.employee.Address,
//                         local_address: data.employee.LocalAddress,
//                         city: data.employee.City,
//                         country: data.employee.Country,
//                         profileImage: data.employee.ProfilePicture || null,
//                         joiningDate: data.employee.JoiningDate,
//                         probation_status: data.employee.probation_status || 'Probation',
//                         probation_feedback_sent_at: data.employee.probation_feedback_sent_at || null,
//                         probation_feedback_sent_by: data.employee.probation_feedback_sent_by || null,

//                         role: storedUser?.role
//                     };

//                     setUserData(updatedUser);

//                     localStorage.setItem("userData", JSON.stringify(updatedUser));

//                     // ✅ CHECK ONLY MISSING MANDATORY PROFILE FIELDS
//                     const isMissing = (val) => !val || String(val).trim() === '' || String(val).trim() === '0000-00-00';
//                     const missing = {
//                         phone: isMissing(updatedUser.phone),
//                         dob: isMissing(updatedUser.dob),
//                         city: isMissing(updatedUser.city),
//                         address: isMissing(updatedUser.address),
//                         local_address: isMissing(updatedUser.local_address),
//                         country: isMissing(updatedUser.country)
//                     };

//                     if (Object.values(missing).some(Boolean)) {
//                         setMissingProfileFields(missing);
//                         setMandatoryFormData({
//                             phone: updatedUser.phone || '',
//                             dob: updatedUser.dob || '',
//                             city: updatedUser.city || '',
//                             address: updatedUser.address || '',
//                             local_address: updatedUser.local_address || '',
//                             country: updatedUser.country || ''
//                         });
//                         setShowMandatoryProfileModal(true);
//                     }

//                     // 🏦 CHECK MANDATORY BANK DETAILS
//                     const empIdForBank = data.employee.id || data.employee.EmpId;
//                     if (empIdForBank) {
//                         let bank = null;
//                         try {
//                             const bankRes = await fetch(`/gt-api/get_bank_details.php?emp_id=${empIdForBank}`, {
//                                 credentials: "include"
//                             });
//                             const rawText = await bankRes.text();
//                             try {
//                                 const json = JSON.parse(rawText);
//                                 if (json && (json.success || json.bank || json.bank_name || json.bankName)) {
//                                     bank = json.bank || json.data || json.details || json.employee_bank_details || json;
//                                 }
//                             } catch (parseErr) {
//                                 console.log("get_bank_details json parse error:", parseErr);
//                             }
//                         } catch (bErr) {
//                             console.error("Bank details fetch network error:", bErr);
//                         }

//                         const b = bank || {};

//                         const getVal = (...keys) => {
//                             for (const k of keys) {
//                                 if (b[k] !== undefined && b[k] !== null && String(b[k]).trim() !== '') {
//                                     return String(b[k]).trim();
//                                 }
//                             }
//                             return '';
//                         };

//                         const bankNameVal = getVal('bankName', 'bank_name', 'BankName', 'Bankname');
//                         const holderNameVal = getVal('holderName', 'holder_name', 'HolderName', 'account_holder_name', 'AccountHolderName');
//                         const accNumberVal = getVal('accNumber', 'account_number', 'AccountNumber', 'AccNumber', 'account_no', 'AccountNo');
//                         const ifscVal = getVal('ifsc', 'ifsc_code', 'IFSC', 'Ifsc', 'IfscCode');
//                         const branchVal = getVal('branch', 'branch_name', 'Branch', 'BranchName');
//                         const accTypeVal = getVal('accType', 'account_type', 'AccountType', 'AccType');

//                         const isBankMissing = (val) => !val || String(val).trim() === '';

//                         const missingBank = {
//                             bankName: isBankMissing(bankNameVal),
//                             holderName: isBankMissing(holderNameVal),
//                             accNumber: isBankMissing(accNumberVal),
//                             ifsc: isBankMissing(ifscVal),
//                             branch: isBankMissing(branchVal),
//                             accType: isBankMissing(accTypeVal)
//                         };

//                         console.log("MANDATORY BANK CHECK RESULT:", { empId: empIdForBank, bankData: b, missingBank });

//                         if (Object.values(missingBank).some(Boolean)) {
//                             setMissingBankFields(missingBank);
//                             setBankFormData({
//                                 bankName: bankNameVal,
//                                 holderName: holderNameVal || `${data.employee.FirstName || ''} ${data.employee.LastName || ''}`.trim(),
//                                 accNumber: bankNameVal ? accNumberVal : '',
//                                 ifsc: ifscVal,
//                                 branch: branchVal,
//                                 accType: accTypeVal || 'Saving Account'
//                             });
//                             setShowMandatoryBankModal(true);
//                         }
//                     }

//                     // 📜 CHECK MANDATORY POLICY ACKNOWLEDGEMENTS
//                     const empIdForPolicy = data.employee.EmpId || data.employee.id || data.employee.employeeId;
//                     if (empIdForPolicy) {
//                         try {
//                             const email = data.employee.EmailId || storedUser?.email || "";
//                             const isGenesis =
//                                 email.toLowerCase().includes("genesistech.co.in") ||
//                                 email.toLowerCase().includes("gtecorpgroup.com") ||
//                                 email.toLowerCase().includes("gtcorpgroup.com");

//                             let allPolicyList = [];
//                             if (isGenesis) {
//                                 allPolicyList = GENESIS_POLICIES;
//                             } else {
//                                 try {
//                                     const pRes = await fetch("/gt-api/get_policies.php", { credentials: "include" });
//                                     const pData = await pRes.json();
//                                     if (pData.success && Array.isArray(pData.policies) && pData.policies.length > 0) {
//                                         allPolicyList = pData.policies.map((p, idx) => ({
//                                             id: p.id || idx + 1,
//                                             title: p.policy_title || p.title,
//                                             icon: p.policy_icon || p.icon || "📜",
//                                             content: p.content || p.policy_content || null
//                                         }));
//                                     } else {
//                                         allPolicyList = GENESIS_POLICIES;
//                                     }
//                                 } catch (pErr) {
//                                     allPolicyList = GENESIS_POLICIES;
//                                 }
//                             }

//                             const logRes = await fetch(`/gt-api/acknowledgepolicy.php?empId=${empIdForPolicy}`, {
//                                 credentials: "include"
//                             });
//                             const logData = await logRes.json();
//                             const logsArray = Array.isArray(logData?.logs) ? logData.logs : [];
//                             const logsMap = logsArray.reduce((acc, curr) => {
//                                 if (curr?.policy_title) {
//                                     acc[curr.policy_title] = true;
//                                 }
//                                 return acc;
//                             }, {});

//                             setLogs(logsMap);
//                             setAllPoliciesList(allPolicyList);

//                             const unack = allPolicyList.filter(p => !logsMap[p.title || p.policy_title]);
//                             setTotalPoliciesCount(allPolicyList.length);
//                             setAcknowledgedPoliciesCount(allPolicyList.length - unack.length);

//                             if (unack.length > 0) {
//                                 setUnacknowledgedPolicies(unack);
//                                 setSelectedMandatoryPolicy(unack[0]);
//                                 setShowMandatoryPolicyModal(true);
//                             }
//                         } catch (polErr) {
//                             console.error("Mandatory policy check error:", polErr);
//                         }
//                     }
//                 }

//             } catch (error) {
//                 console.error("Database Error:", error);
//             }

//         };

//         fetchUserData();

//     }, []);

//     // 🔒 LOCK BODY SCROLL WHEN MANDATORY MODAL IS OPEN
//     useEffect(() => {
//         if (showMandatoryProfileModal || showMandatoryBankModal || showMandatoryPolicyModal) {
//             document.body.style.overflow = 'hidden';
//             document.documentElement.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         }
//         return () => {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         };
//     }, [showMandatoryProfileModal, showMandatoryBankModal, showMandatoryPolicyModal]);

//     const handleAcknowledgeMandatoryPolicy = async (e) => {
//         if (e && e.preventDefault) e.preventDefault();
//         if (!selectedMandatoryPolicy) return;
//         const targetTitle = selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title;
//         if (!targetTitle) return;

//         setPolicyAckError('');
//         setPolicyAckSaving(true);

//         try {
//             const empBadgeId = userData?.EmpId || userData?.employeeId || userData?.id;
//             const fullName = `${userData?.FirstName || userData?.firstName || ''} ${userData?.LastName || userData?.lastName || ''}`.trim();

//             const response = await fetch("/gt-api/acknowledgepolicy.php", {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     empId: empBadgeId,
//                     fullName: fullName,
//                     policyTitle: targetTitle
//                 }),
//             });

//             const result = await response.json();
//             if (result.status === "success" || result.success) {
//                 setPolicyAckSuccessMsg(`Policy "${targetTitle}" acknowledged successfully!`);

//                 setLogs(prev => ({ ...prev, [targetTitle]: true }));

//                 const remaining = unacknowledgedPolicies.filter(
//                     p => (p.title || p.policy_title) !== targetTitle
//                 );
//                 setUnacknowledgedPolicies(remaining);
//                 setAcknowledgedPoliciesCount(prev => prev + 1);
//                 setPolicyAgreed(false);

//                 setTimeout(() => {
//                     setPolicyAckSuccessMsg('');
//                     if (remaining.length > 0) {
//                         setSelectedMandatoryPolicy(remaining[0]);
//                     } else {
//                         setShowMandatoryPolicyModal(false);
//                     }
//                 }, 1000);
//             } else {
//                 setPolicyAckError(result.message || "Could not save policy acknowledgement.");
//             }
//         } catch (err) {
//             console.error("Policy ack error:", err);
//             setPolicyAckError("Failed to connect to server to record policy acknowledgement.");
//         } finally {
//             setPolicyAckSaving(false);
//         }
//     };

//     const handleSaveMandatoryProfile = async (e) => {
//         e.preventDefault();
//         setMandatoryError('');

//         const { phone, dob, city, address, local_address, country } = mandatoryFormData;

//         if (missingProfileFields.phone && (!phone || !phone.trim())) {
//             setMandatoryError('Please enter your Mobile Number.');
//             return;
//         }
//         if (missingProfileFields.dob && (!dob || !dob.trim() || dob === '0000-00-00')) {
//             setMandatoryError('Please select your Date of Birth.');
//             return;
//         }
//         if (missingProfileFields.city && (!city || !city.trim())) {
//             setMandatoryError('Please enter your City.');
//             return;
//         }
//         if (missingProfileFields.country && (!country || !country.trim())) {
//             setMandatoryError('Please enter your Country.');
//             return;
//         }
//         if (missingProfileFields.address && (!address || !address.trim())) {
//             setMandatoryError('Please enter your Permanent Address.');
//             return;
//         }
//         if (missingProfileFields.local_address && (!local_address || !local_address.trim())) {
//             setMandatoryError('Please enter your Current / Local Address.');
//             return;
//         }

//         setMandatorySaving(true);
//         try {
//             const payload = {
//                 id: userData.id,
//                 EmpId: userData.EmpId,
//                 Phonenumber: (phone || userData.phone || '').trim(),
//                 Dob: (dob || userData.dob || '').trim(),
//                 City: (city || userData.city || '').trim(),
//                 Address: (address || userData.address || '').trim(),
//                 LocalAddress: (local_address || userData.local_address || '').trim(),
//                 Country: (country || userData.country || '').trim(),
//                 Gender: userData.gender || '',
//                 ProfilePicture: userData.profileImage || null
//             };

//             const res = await fetch("/gt-api/update_profile.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 const updatedUser = {
//                     ...userData,
//                     phone: phone.trim(),
//                     dob: dob.trim(),
//                     city: city.trim(),
//                     address: address.trim(),
//                     local_address: local_address.trim(),
//                     country: country.trim()
//                 };
//                 setUserData(updatedUser);
//                 localStorage.setItem("userData", JSON.stringify(updatedUser));
//                 setMandatorySuccessMsg("🎉 Profile information updated! You may now use the system.");
//                 setTimeout(() => {
//                     setShowMandatoryProfileModal(false);
//                     setMandatorySuccessMsg('');
//                 }, 1200);
//             } else {
//                 setMandatoryError(result.message || "Failed to update profile. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory profile update error:", err);
//             setMandatoryError("Connection error. Ensure backend API is running.");
//         } finally {
//             setMandatorySaving(false);
//         }
//     };

//     const handleSaveMandatoryBankDetails = async (e) => {
//         e.preventDefault();
//         setBankError('');

//         const { bankName, holderName, accNumber, ifsc, branch, accType } = bankFormData;

//         if (missingBankFields.bankName && (!bankName || !bankName.trim())) {
//             setBankError('Please enter Bank Name.');
//             return;
//         }
//         if (missingBankFields.holderName && (!holderName || !holderName.trim())) {
//             setBankError('Please enter Account Holder Name.');
//             return;
//         }
//         if (missingBankFields.accNumber && (!accNumber || !accNumber.trim())) {
//             setBankError('Please enter Bank Account Number.');
//             return;
//         }
//         if (missingBankFields.ifsc && (!ifsc || !ifsc.trim())) {
//             setBankError('Please enter IFSC Code.');
//             return;
//         }
//         if (missingBankFields.branch && (!branch || !branch.trim())) {
//             setBankError('Please enter Branch Name.');
//             return;
//         }
//         if (missingBankFields.accType && (!accType || !accType.trim())) {
//             setBankError('Please select Account Type.');
//             return;
//         }

//         setBankSaving(true);
//         try {
//             const payload = {
//                 emp_id: userData.id || userData.employeeId || userData.EmpId,
//                 emp_number: userData.EmpId || userData.employeeId,
//                 bankName: bankName.trim(),
//                 bank_name: bankName.trim(),
//                 holderName: holderName.trim(),
//                 account_holder_name: holderName.trim(),
//                 accNumber: accNumber.trim(),
//                 account_number: accNumber.trim(),
//                 ifsc: ifsc.trim(),
//                 ifsc_code: ifsc.trim(),
//                 branch: branch.trim(),
//                 branch_name: branch.trim(),
//                 accType: accType.trim(),
//                 account_type: accType.trim()
//             };

//             const res = await fetch("/gt-api/save_bank_details.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 setBankSuccessMsg("🎉 Bank details updated successfully!");
//                 setTimeout(() => {
//                     setShowMandatoryBankModal(false);
//                     setBankSuccessMsg('');
//                 }, 1200);
//             } else {
//                 setBankError(result.message || "Failed to save bank details. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory bank details update error:", err);
//             setBankError("Connection error. Ensure backend API is running.");
//         } finally {
//             setBankSaving(false);
//         }
//     };




//     // const employeeId = userData.id || userData.employeeId;

//     const toggleSubMenu = (menu) => {
//         setOpenMenus(prev => ({ ...prev, [menu]: !prev[menu] }));
//     };

//     useEffect(() => {
//         const checkNotifications = () => {
//             if (role !== 'Management' && userData?.employeeId) {
//                 fetch(`/gt-api/clear_notifications.php?employee_id=${userData.employeeId}`)
//                     .then(res => res.json())
//                     .then(data => {
//                         if (data.success) setNotifCount(data.count);
//                     })
//                     .catch(err => console.error("Notif Fetch Error:", err));
//             }
//         };
//         checkNotifications();
//         const interval = setInterval(checkNotifications, 30000);
//         return () => clearInterval(interval);
//     }, [userData.employeeId, role]);

//     useEffect(() => {
//         if (role === 'Management' || role === 'Manager') {
//             const fetchRealTimeLeaves = async () => {
//                 try {
//                     // Determine which API to call based on Role
//                     // Managers should call the specific manager-leaves API using their ID
//                     const url = role === 'Management'
//                         ? "/gt-api/get_all_leaves.php"
//                         : `/gt-api/get_manager_leaves.php?managerId=${userData.id || location.state?.empId}`;

//                     // const res = await fetch(url);
//                     const res = await fetch(url, {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {

//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };

//             // Only fetch if we have the ID for the Manager, or if role is Management
//             if (role === 'Management' || (role === 'Manager' && (userData.id || location.state?.empId))) {
//                 fetchRealTimeLeaves();
//                 const liveInterval = setInterval(fetchRealTimeLeaves, 5000);
//                 return () => clearInterval(liveInterval);
//             }
//         }
//     }, [role, userData.id, location.state?.empId]);

//     const handleStatusUpdate = async (id, newStatus) => {
//         try {
//             const response = await fetch("/gt-api/update_request_status.php", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ id, status: newStatus }),
//             });
//             const data = await response.json();
//             if (data.success) {
//                 setRequestsList(prev => prev.map(req => req.id === id ? { ...req, status: newStatus } : req));
//                 setPendingRequestsCount(prev => Math.max(0, prev - 1));
//                 alert(`Request ${newStatus} successfully!`);
//             }
//         } catch (error) {
//             console.error("Update error:", error);
//         }
//     };

//     ;


//     const sendAIMessage = async () => {
//         if (!chatInput.trim()) return;

//         const userMessage = {
//             sender: "user",
//             text: chatInput
//         };

//         setChatMessages(prev => [...prev, userMessage]);
//         setChatLoading(true);

//         try {
//             const res = await fetch("/gt-api/chatbot.php", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     question: chatInput
//                 })
//             });

//             const data = await res.json();

//             let aiReply = "No response.";

//             if (data.success) {
//                 aiReply = data.reply || "No response.";
//             } else {
//                 aiReply = data.message || "Something went wrong.";
//             }
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: aiReply
//                 }
//             ]);

//         } catch (err) {
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: "Server error."
//                 }
//             ]);
//         }

//         setChatInput("");
//         setChatLoading(false);
//     };
//     const handleModuleChange = (slug, extraData = null) => {
//         navigate(`/dashboard/${role}/${slug}`, {
//             state:
//                 extraData && typeof extraData === "object"
//                     ? extraData
//                     : { selectedPathway: extraData }
//         });
//     };

//     const handlePasswordSubmit = (e) => {
//         e.preventDefault();
//         if (passwordForm.newPassword !== passwordForm.confirmPassword) {
//             alert("New passwords do not match!");
//             return;
//         }
//         alert("Encryption Key Updated Successfully!");
//         setShowPasswordModal(false);
//     };

//     const handleSave = () => {
//         setIsEditing(false);
//         alert("Profile changes synchronized!");
//     };

//     // Ensure only ONE instance of this exists in your file
//     const [theme, setTheme] = useState(localStorage.getItem('dashboard-theme') || 'dark');

//     useEffect(() => {
//         document.documentElement.setAttribute('data-theme', theme);
//         localStorage.setItem('dashboard-theme', theme);
//     }, [theme]);

//     const toggleTheme = () => {
//         setTheme(prev => prev === 'dark' ? 'light' : 'dark');
//     };
//     useEffect(() => {

//         const handlePageShow = (event) => {
//             if (event.persisted) {
//                 const user = localStorage.getItem("userData");
//                 if (!user) {
//                     window.location.replace("/");
//                 }
//             }
//         };

//         window.addEventListener("pageshow", handlePageShow);

//         return () => window.removeEventListener("pageshow", handlePageShow);

//     }, []);
//     useEffect(() => {
//         if (role === 'Management') {
//             const fetchEquipmentCount = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_equip_request.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();
//                     if (data.success && data.requests) {
//                         const count = data.requests.filter(r => r.status?.toLowerCase() === 'pending').length;
//                         setPendingRequestsCount(count);
//                         setRequestsList(data.requests);
//                     }
//                 } catch (err) {
//                     console.error("Equipment Fetch Error:", err);
//                 }
//             };

//             fetchEquipmentCount();
//             const interval = setInterval(fetchEquipmentCount, 10000);
//             return () => clearInterval(interval);
//         }
//     }, [role]);




//     const [payData, setPayData] = useState([]);

//     useEffect(() => {

//         // 🔥 MANAGEMENT DASHBOARD
//         if (role === "Management") {

//             const fetchAllDocs = () => {
//                 fetch("/gt-api/get_all_salary_documents.php", {
//                     credentials: "include"
//                 })
//                     .then(res => res.json())
//                     .then(data => {
//                         console.log("MGMT DATA:", data);

//                         if (data.success) {

//                             setPayData(data.documents);
//                         }
//                     })
//                     .catch(err => console.error("Management Fetch Error:", err));
//             };

//             fetchAllDocs();

//             const interval = setInterval(fetchAllDocs, 5000);

//             return () => clearInterval(interval);
//         }

//         // 👤 EMPLOYEE DASHBOARD
//         if (employeeId) {
//             fetch(`/gt-api/get_my_documents.php?emp_id=${employeeId}`, {
//                 credentials: "include"
//             })
//                 .then(res => res.json())
//                 .then(data => {
//                     console.log("EMP DATA:", data);

//                     if (data.success) {
//                         setPayData(data.documents);
//                     }
//                 })
//                 .catch(err => console.error("Employee Fetch Error:", err));
//         }

//     }, [role, employeeId]);





//     const renderPayChart = () => {
//         const safePayData = payData || [];

//         const payslips = safePayData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = safePayData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = safePayData.filter(d => d.doc_type === "APPRAISAL LETTER").length;
//         const totalDocs = payslips + form16 + appraisal;

//         return (
//             <div className="pay-ultra-card" onClick={() => handleModuleChange("pay and benefits")}>
//                 <div className="card-inner">
//                     {/* Top Section */}
//                     <div className="pay-header">
//                         <div className="pay-icon-wrapper">
//                             <div className="pay-icon-glow"></div>
//                             <span className="main-icon">📄</span>
//                         </div>
//                         <div className="pay-total-info">
//                             <h3>Pay & Benefits</h3>
//                             <p>{totalDocs} Total Documents</p>
//                         </div>
//                     </div>

//                     {/* Distribution */}
//                     <div className="distribution-container">
//                         <div className="distribution-label">
//                             <span>Vault Composition</span>
//                             <span className="percentage">
//                                 {totalDocs > 0 ? "100%" : "0%"}
//                             </span>
//                         </div>

//                         <div className="multi-progress-bar">
//                             {totalDocs > 0 ? (
//                                 <>
//                                     <div
//                                         className="segment green"
//                                         style={{ flex: payslips, backgroundColor: '#22c55e' }}
//                                     ></div>
//                                     <div
//                                         className="segment blue"
//                                         style={{ flex: form16, backgroundColor: '#3b82f6' }}
//                                     ></div>
//                                     <div
//                                         className="segment amber"
//                                         style={{ flex: appraisal, backgroundColor: '#f59e0b' }}
//                                     ></div>
//                                 </>
//                             ) : (
//                                 <div
//                                     style={{
//                                         width: "100%",
//                                         height: "100%",
//                                         backgroundColor: "#e5e7eb",
//                                         borderRadius: "10px"
//                                     }}
//                                 ></div>
//                             )}
//                         </div>
//                     </div>

//                     {/* List */}
//                     <div className="pay-list">
//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator green"></span>
//                                 <span className="name">Monthly Payslips</span>
//                             </div>
//                             <span className="count-badge">{payslips}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator blue"></span>
//                                 <span className="name">Tax Form 16</span>
//                             </div>
//                             <span className="count-badge">{form16}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator amber"></span>
//                                 <span className="name">Appraisal Letter</span>
//                             </div>
//                             <span className="count-badge">{appraisal}</span>
//                         </div>
//                     </div>

//                     <div className="pay-footer">
//                         <span>Explore Document</span>
//                         <span className="arrow-icon">→</span>
//                     </div>

//                     <div className="reimburse-cta-wrapper">
//                         <button
//                             className="reimburse-btn"
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleModuleChange("supplies");
//                             }}
//                         >
//                             Click here for Reimbursement Form
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };



//     const renderLeavePieChart = () => {
//         const PUBLIC_HOLIDAYS = [
//             '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//             '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//         ];

//         const isWorkDay = (date) => {
//             const day = date.getDay();
//             const dateString = date.toISOString().split('T')[0];
//             return !(day === 0 || day === 6) && !PUBLIC_HOLIDAYS.includes(dateString);
//         };

//         if (!leaveData || !leaveData.leaveBalances) return null;

//         const sickUsed = leaveData.leaveBalances.sick.used || 0;
//         const earnedUsed = leaveData.leaveBalances.earned.used || 0;
//         const wfhCount = leaveData.wfhHistory.reduce((total, wfh) => {
//             const start = new Date(wfh.start);
//             const end = new Date(wfh.end);
//             let days = 0;
//             let current = new Date(start);
//             while (current <= end) {
//                 if (isWorkDay(current)) days++;
//                 current.setDate(current.getDate() + 1);
//             }
//             return total + days;
//         }, 0);

//         const totalUsed = sickUsed + earnedUsed;

//         // Determine max for scaling bars (minimum scale of 10)
//         const maxVal = Math.max(sickUsed, earnedUsed, wfhCount, 10);
//         return (

//             <div
//                 className={`elite-podium-card leave-analytics-card ${theme === 'dark' ? 'dark-variant' : 'light-theme'}`}
//                 onClick={() => handleModuleChange("attendance")}
//             >

//                 <div className="card-header-v3">
//                     <div className="title-group">

//                         <h2 className="main-title">Leave Overview</h2>
//                     </div>
//                     <div className="year-tag">2026</div>
//                 </div>

//                 <div className="podium-content">
//                     {/* VERTICAL BAR SECTION - Made prominent */}
//                     <div className="bar-podium-large">
//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill sick" style={{ height: `${(sickUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">SICK</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill earned" style={{ height: `${(earnedUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">EARNED</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill wfh" style={{ height: `${(wfhCount / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">WFH</span>
//                         </div>
//                     </div>

//                     {/* KPI SIDEBAR - Cleaned up to match image 1's style */}
//                     <div className="kpi-sidebar-compact">
//                         <div className="total-display">
//                             <span className="total-val">{totalUsed}</span>
//                             <span className="total-sub">Days Off-Site</span>
//                         </div>

//                         <div className="status-legend">
//                             <div className="legend-row">
//                                 <span className="indicator sick"></span>
//                                 <span>{sickUsed} Sick</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator earned"></span>
//                                 <span>{earnedUsed} Earned</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator wfh"></span>
//                                 <span>{wfhCount} WFH</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="card-footer-v3">
//                     <div className="sync-info">
//                         <span className="status-glow"></span>
//                         Annual Summary Active
//                     </div>
//                     <button className="details-btn">VIEW DETAILS →</button>
//                 </div>
//             </div>
//         );
//     };

//     const [leaveData, setLeaveData] = useState({
//         leaveHistory: [],
//         leaveBalances: {
//             sick: { used: 0, total: 0 },
//             earned: { used: 0, total: 0 }
//         },
//         wfhHistory: []
//     });


//     const [managementNotices, setManagementNotices] = useState({
//         reviews: [],
//         probations: []
//     });

//     useEffect(() => {
//         const fetchNotices = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/get_manager_feedback.php?empId=${userData.EmpId}`
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     setManagementNotices({
//                         reviews: data.reviews || [],
//                         probations: data.probations || []
//                     });
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchNotices();
//     }, [userData]);





//     const renderEquipmentCard = () => {
//         const { total, approved, rejected, pending } = equipmentData;

//         return (
//             <div className="equipment-ultra-card clickable" onClick={() => handleModuleChange("equipment-request")}>
//                 <div className="equip-header">
//                     <div className="equip-icon-box">💻</div>
//                     <div className="equip-title-group">
//                         <span className="equip-label">Hardware</span>
//                         <h3 className="equip-title">Requests</h3>
//                     </div>
//                 </div>

//                 <div className="equip-main-stat">
//                     <span className="total-count">{total}</span>
//                     <span className="total-label">Submissions</span>
//                 </div>

//                 <div className="equip-progress-bar">
//                     <div className="bar-fill approved" style={{ width: `${(approved / total) * 100}%` }}></div>
//                     <div className="bar-fill pending" style={{ width: `${(pending / total) * 100}%` }}></div>
//                 </div>

//                 <div className="equip-stats-list">
//                     <div className="equip-item">
//                         <span className="dot approved"></span>
//                         <span className="item-name">Approved</span>
//                         <span className="item-val">{approved}</span>
//                     </div>
//                     <div className="equip-item">
//                         <span className="dot pending"></span>
//                         <span className="item-name">Pending</span>
//                         <span className="item-val text-warning">{pending}</span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     useEffect(() => {
//         const empIdForFetch = userData?.EmpId || userData?.employeeId;

//         if (!empIdForFetch) return;

//         fetch(`/gt-api/get_all_equip_request.php?employee_id=${empIdForFetch}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log("EQUIPMENT API RESPONSE:", data);
//                 if (data.success && data.requests) {

//                     const requests = data.requests;

//                     const approved = requests.filter(r =>
//                         r.status?.toLowerCase() === "approved"
//                     ).length;

//                     const rejected = requests.filter(r =>
//                         r.status?.toLowerCase() === "rejected"
//                     ).length;

//                     const pending = requests.filter(r =>
//                         r.status?.toLowerCase() === "pending"
//                     ).length;

//                     setEquipmentData({
//                         total: requests.length,
//                         approved,
//                         rejected,
//                         pending
//                     });
//                 }
//             })
//             .catch(err => console.error("Equipment Dashboard Error:", err));
//         console.log("EMP ID:", empIdForFetch);



//     }, [userData?.EmpId, userData?.employeeId]);





//     const [oneOnOneData, setOneOnOneData] = useState({
//         totalMeetings: 0,
//         pendingTasks: 0,
//         completedTasks: 0
//     });

//     useEffect(() => {
//         if (!employeeId) return;

//         fetch(`/gt-api/get_my_meetings.php?emp_id=${employeeId}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.meetings) {

//                     const meetings = data.meetings;

//                     let pending = 0;
//                     let completed = 0;

//                     meetings.forEach(meet => {
//                         const tasks = JSON.parse(meet.action_items || "[]");

//                         tasks.forEach(task => {
//                             if (task.done) completed++;
//                             else pending++;
//                         });
//                     });

//                     setOneOnOneData({
//                         totalMeetings: meetings.length,
//                         pendingTasks: pending,
//                         completedTasks: completed
//                     });
//                 }
//             })
//             .catch(err => console.error("1-1 Fetch Error:", err));

//     }, [employeeId]);



//     const renderOneOnOneCard = () => {
//         const { totalMeetings, pendingTasks, completedTasks } = oneOnOneData;
//         const totalTasks = (pendingTasks + completedTasks) || 1;
//         const progressPercent = Math.min(Math.round((completedTasks / totalTasks) * 100), 100);

//         return (
//             <div className="liquid-card clickable" onClick={() => handleModuleChange("one-on-one")}>
//                 {/* BACKGROUND BLOOM */}
//                 <div className="liquid-bloom"></div>

//                 <div className="liquid-layout">
//                     {/* HERO TILE: THE CORE IDENTITY */}
//                     <div className="liquid-tile-hero">
//                         <div className="hero-header">
//                             {/* <span className="hero-eyebrow">Engagement Console</span> */}
//                             <h2 className="hero-title">1-on-1 Sessions</h2>
//                         </div>
//                         <div className="hero-main-metric">
//                             <span className="hero-val">{totalMeetings}</span>
//                             <span className="hero-label">TOTAL<br />MEETINGS</span>
//                         </div>
//                         {/* FULL WIDTH PROGRESS THREAD */}
//                         <div className="liquid-thread-container">
//                             <div className="liquid-thread-bg">
//                                 <div className="liquid-thread-fill" style={{ width: `${progressPercent}%` }}>
//                                     <div className="liquid-thread-glow-tip"></div>
//                                 </div>
//                             </div>
//                             <div className="liquid-thread-label">
//                                 <span className="label-text">Task Completion</span>
//                                 <span className="label-val">{progressPercent}%</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* DATA TRAY: THE SPECIFIC CHIPS */}
//                     <div className="liquid-tray">
//                         <div className="liquid-chip danger">
//                             <div className="chip-inner">
//                                 <label>Pending Task</label>
//                                 <span className="chip-val">{pendingTasks}</span>
//                             </div>
//                         </div>
//                         <div className="liquid-chip success">
//                             <div className="chip-inner">
//                                 <label>Completed Task</label>
//                                 <span className="chip-val">{completedTasks}</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* INTERACTIVE FOOTER */}
//                 <div className="liquid-footer">
//                     <div className="status-container">
//                         <div className={`status-node-wrapper ${pendingTasks > 0 ? 'is-alert' : 'is-sync'}`}>
//                             <div className="status-node-core"></div>
//                             <div className="status-node-bloom"></div>
//                         </div>
//                         <span className={`status-text ${pendingTasks > 0 ? 'text-alert' : ''}`}>
//                             {pendingTasks > 0 ? 'ACTION ITEMS DETECTED' : 'SYSTEM OPTIMIZED'}
//                         </span>
//                     </div>
//                     <div className="liquid-action">

//                         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
//                     </div>
//                 </div>
//             </div>
//         );
//     };






//     const renderCareerPathwaysCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const pathways = isGenesis

//             ? [

//                 {
//                     id: "01",
//                     name: "FI DESIGN",
//                     color: "rgba(0, 77, 113, 0.9)"
//                 },

//                 {
//                     id: "02",
//                     name: "BIM MODELING",
//                     color: "rgba(0, 120, 172, 0.8)"
//                 },

//                 {
//                     id: "03",
//                     name: "POWER BI",
//                     color: "rgba(0, 162, 237, 0.7)"
//                 }

//             ]

//             : dashboardPathways.map(
//                 (item, index) => ({
//                     id: String(index + 1)
//                         .padStart(2, "0"),

//                     name: item.pathway_title,

//                     color:
//                         "rgba(0, 120, 172, 0.8)"
//                 })
//             );

//         return (

//             <div
//                 className="pathway-card-container"
//                 onClick={() =>
//                     handleModuleChange(
//                         "career pathways"
//                     )
//                 }
//             >

//                 <h2 className="pathway-title">
//                     CAREER PATHWAYS
//                 </h2>

//                 <div className="pathway-stack">

//                     {pathways.map(
//                         (item, index) => (

//                             <div
//                                 key={index}
//                                 className="pathway-step"
//                                 style={{
//                                     '--step-color':
//                                         item.color
//                                 }}
//                                 onClick={(e) => {

//                                     e.stopPropagation();

//                                     handleModuleChange(
//                                         "career pathways",
//                                         item.name
//                                     );

//                                 }}
//                             >

//                                 <span className="step-number">
//                                     {item.id}
//                                 </span>

//                                 <div className="step-content">

//                                     <span className="step-name">
//                                         {item.name}
//                                     </span>

//                                     <div className="step-glow"></div>

//                                 </div>

//                             </div>

//                         )
//                     )}

//                 </div>

//                 <button
//                     className="explore-btn"
//                     onClick={(e) => {

//                         e.stopPropagation();

//                         handleModuleChange(
//                             "career pathways"
//                         );

//                     }}
//                 >
//                     EXPLORE CAREER PATHWAYS
//                 </button>

//             </div>

//         );

//     };


//     const renderPolicyCard = () => {
//         const totalPolicies =
//             policyCount;

//         console.log(
//             "Policy Count:",
//             totalPolicies
//         );

//         const readCount =
//             Object.keys(logs || {}).length;
//         const pending = totalPolicies - readCount;
//         const progress = totalPolicies > 0 ? Math.round((readCount / totalPolicies) * 100) : 0;

//         return (
//             <div className="terminal-policy-card" onClick={() => handleModuleChange("company-policy")}>
//                 {/* Background Decorative Scanline */}
//                 <div className="terminal-scanline"></div>

//                 <div className="terminal-header">
//                     <div className="header-left">
//                         {/* <span className="terminal-tag">PROTOCOL_09</span> */}
//                         <h3 className="terminal-title">Company Policy</h3>
//                     </div>
//                     <div className={`status-indicator ${progress === 100 ? 'secure' : 'breach'}`}>
//                         {progress === 100 ? "SECURE" : "PENDING"}
//                     </div>
//                 </div>

//                 <div className="terminal-content">
//                     {/* Circular Progress using SVG for precision */}
//                     <div className="terminal-visual">
//                         <svg viewBox="0 0 36 36" className="cyber-circle">
//                             <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                             <path
//                                 className="circle-fill"
//                                 strokeDasharray={`${progress}, 100`}
//                                 d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
//                                 style={{ stroke: progress === 100 ? '#22c55e' : '#3b82f6' }}
//                             />
//                         </svg>
//                         <div className="percentage-display">
//                             <span className="pct-num">{progress}</span>
//                             <span className="pct-unit">%</span>
//                         </div>
//                     </div>

//                     {/* Data Readout Section */}
//                     <div className="terminal-stats">
//                         <div className="stat-row">
//                             <span className="label">COMPLETED</span>
//                             <span className="value">{readCount}</span>
//                         </div>
//                         <div className="stat-row">
//                             <span className="label">TOTAL_FILES</span>
//                             <span className="value">{totalPolicies}</span>
//                         </div>
//                         <div className="stat-row urgent">
//                             <span className="label">AWAITING_ACTION</span>
//                             <span className="value">{pending}</span>
//                         </div>
//                     </div>
//                 </div>

//             </div>
//         );
//     };

//     useEffect(() => {
//         const fetchLogs = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/acknowledgepolicy.php?empId=${userData.EmpId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 console.log("API DATA:", data);

//                 // 🔥 FIX: use data.logs (NOT data)
//                 const logsArray = Array.isArray(data?.logs) ? data.logs : [];

//                 const map = logsArray.reduce((acc, curr) => {
//                     if (curr?.policy_title) {
//                         acc[curr.policy_title] = true;
//                     }
//                     return acc;
//                 }, {});

//                 setLogs(map);

//             } catch (err) {
//                 console.error("Policy logs error:", err);
//                 setLogs({});
//             }
//         };

//         fetchLogs();
//     }, [userData]);


//     const [showProfileOptions, setShowProfileOptions] = useState(false);



//     const [showProfileMenu, setShowProfileMenu] = useState(false);
//     const handleEditProfile = () => {
//         setShowProfileMenu(false);
//         navigate(`/dashboard/${role}/my-profile`);
//         setShowProfile(true);
//     };

//     const handleLogout = () => {
//         document.documentElement.removeAttribute('data-theme');
//         localStorage.clear();
//         sessionStorage.clear();
//         navigate("/", { replace: true });
//     };

//     const [currentTime, setCurrentTime] = useState("");

//     useEffect(() => {
//         const updateTime = () => {
//             const now = new Date();
//             setCurrentTime(
//                 now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
//             );
//         };

//         updateTime();
//         const interval = setInterval(updateTime, 1000);

//         return () => clearInterval(interval);
//     }, []);
//     const todayDate = new Date().toLocaleDateString('en-GB', {
//         day: '2-digit',
//         month: 'short'
//     });



//     const employeeModulesList = [
//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "attendance" },

//         { id: 2, name: "Pay and Benefits", icon: "💳", color: "#3b82f6", slug: "pay and benefits" },
//         { id: 3, name: "OKR and Performance Tracker", icon: "🎯", color: "#f59e0b", slug: "okr and performance tracker" },

//         { id: 5, name: "Career Pathways", icon: "🏆", color: "#ec4899", slug: "career pathways" },
//         { id: 6, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },

//         { id: 9, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         { id: 10, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         // { id: 11, name: "Documents", icon: "📂", color: "#f43f5e", slug: "documents" },
//         // { id: 12, name: "Employee Experience Survey - EES", icon: "📝", color: "#8b5cf6", slug: "ees-survey" },   
//         { id: 13, name: "1:1 Meeting", icon: "💬", color: "#00fff2", slug: "one-on-one" },
//         { id: 21, name: "ACM Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//         { id: 7, name: "Expense Reimbursement", icon: "🧾", color: "#10b981", slug: "supplies" },

//     ];

//     const managementModulesList = [

//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "leave-management", badge: pendingLeavesCount },

//         { id: 2, name: "Employee Salary and Benefits", icon: "💳", color: "#3b82f6", slug: "employee-salary-benefits" },

//         { id: 3, name: "Employee OKR'S", icon: "🎯", color: "#f59e0b", slug: "employee-okrs" },

//         { id: 5, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: pendingRequestsCount },

//         { id: 6, name: "Own Finanacials", icon: "💰", color: "#10b981", slug: "pay and benefits" },

//         { id: 8, name: "Career Development", icon: "🏆", color: "#ec4899", slug: "career pathways" },

//         { id: 10, name: "Self OKR Tracker", icon: "🏁", color: "#f59e0b", slug: "okr and performance tracker" },
//         { id: 11, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         { id: 12, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         // { id: 21, name: "Manage Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates", badge: "PUSH" },

//         {
//             id: 21,
//             name: "ACM Updates",
//             icon: "📢",
//             color: "#00fff2",
//             slug: "manage-quarterly-updates",
//             badge: "PUSH"
//         },

//         // {
//         //   id: 15,
//         //   name: "EES Feedback Analytics",
//         //   icon: "📊",
//         //   color: "#00f2ff",
//         //   slug: "ees-analytics",
//         //   badge: "NEW"
//         // },

//         // { id: 14, name: "Skills Development", icon: "📚", color: "#06b6d4", slug: "career" },

//         {
//             id: 16,
//             name: "Medical Reports",
//             icon: "🏥",
//             color: "#f43f5e",
//             slug: "medical-reports",
//             badge: "DOCS"
//         },
//         {
//             id: 17,
//             name: "Policy RnU Status",
//             icon: "📋",
//             color: "#10b981",
//             slug: "policy-logs",
//             badge: "ADMIN"
//         },

//         // { 
//         //   id: 18, 
//         //   name: "Employee Documents", 
//         //   icon: "📂", 
//         //   color: "#f43f5e", 
//         //   slug: "manage-documents", 
//         //   badge: "VIEW" 
//         // },

//         {
//             id: 19,
//             name: "1:1 Connect",
//             icon: "🤝",
//             color: "#00fff2",
//             slug: "manager-one-on-one",

//             badge: "LIVE"
//         },

//         { id: 20, name: "Events and Celebrations", icon: "🎉", color: "#3b82f6", slug: "events-celebrations" },

//         {
//             id: 22,
//             name: "Expense Reimbursements",
//             icon: "💰",
//             color: "#22c55e",
//             slug: "reimbursements",
//             badge: "NEW"
//         },

//         {
//             id: 25,
//             name: "Award Nominations Analytics",
//             icon: "📊",
//             color: "#f59e0b",
//             slug: "award-analytics",
//             badge: "GALA"
//         },

//         // {
//         //     id: 23,
//         //     name: "WFH Requests",
//         //     icon: "🏠",
//         //     color: "#3b82f6",
//         //     slug: "manage-wfh-requests",
//         //     badge: "WFH"
//         // },


//     ];

//     const renderActiveModule = () => {

//         switch (activeModule) {

//             case "attendance-tracker":
//                 return <AttendanceTracker />;

//             case "CompanySetup":
//                 return <CompanySetup />;

//             case "create-invoice":
//                 return <InvoiceGenerator />;

//             case "my-profile":
//                 return (
//                     <MyProfile
//                         userData={userData}
//                         setUserData={setUserData}
//                         isEditing={isEditing}
//                         setIsEditing={setIsEditing}
//                         handleSave={handleSave}
//                         setShowPasswordModal={setShowPasswordModal}
//                     />
//                 );


//             case "reimbursements":
//                 if (role === "Management" || role === "Manager") {
//                     return <ReimbursementManagement />;
//                 }
//                 return <OfficeRequisition userData={userData} />;

//             case "manage-wfh-requests":
//                 return <WFHManagement />;


//             case "work-from-home":
//                 return <WorkFromHome />;


//             case "quarterly-updates":

//                 return <QuarterlyUpdates />;

//             case "manage-quarterly-updates":

//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementQuarterlyUpdate userData={userData} />;
//                 }
//                 return <QuarterlyUpdates />;


//             case "leave-management":
//                 // Unified behavior for Management and Manager
//                 if (role === 'Management' || role === 'Manager') {
//                     return <LeaveManagement userData={userData} />;
//                 }


//                 return <Attendance employeeId={employeeId} userData={userData} />;

//             case "manage-documents":
//                 if (role === 'Management') {
//                     return <ManageEmployeeDocs />;
//                 }
//                 return <Documents userData={userData} />;



//             // case "attendance":
//             //     if (role === 'Management') return <Attendance />;
//             //     return (
//             //         <Attendance
//             //             employeeId={userData.id}
//             //             empBadgeId={userData.EmpId}
//             //             userData={userData}
//             //         />
//             //     );
//             case "attendance":

//                 if (role === 'Management') {

//                     return (
//                         <Attendance
//                             employeeId={userData.id}
//                             empBadgeId={userData.EmpId}
//                             userData={userData}
//                         />
//                     );

//                 }

//                 return (
//                     <Attendance
//                         employeeId={userData.id}
//                         empBadgeId={userData.EmpId}
//                         userData={userData}
//                     />
//                 );


//             case "policy-logs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <PolicyAdminDashboard />;
//                 }

//                 return (
//                     <CompanyPolicy
//                         employeeId={userData.id}
//                         userData={userData}
//                     />
//                 );

//             case "events-celebrations":
//                 return <EventsCelebrations userData={userData} />;

//             case "award-nominations":
//                 return <AwardNominations userData={userData} role={role} />;

//              case "award-analytics":
//                 return <AwardAnalyticsDashboard userData={userData} role={role} />;

//             case "pay and benefits": return <PayBenefits userData={userData} employeeId={employeeId} />;

//             // case "okr and performance tracker":
//             //     return <OKRTracker userData={userData} />;

//             case "okr and performance tracker":
//                 return (
//                     <OKRTracker
//                         userData={userData}
//                         defaultTab={location.state?.tab}
//                     />
//                 );

//             // Inside Dashboard.js -> renderActiveModule
//             // case "employee-okrs":
//             //     if (role === 'Management' || role === 'Manager') {
//             //         return (
//             //             <ManagementOKRViewer
//             //                 managerId={userData.id}
//             //                 userRole={role}
//             //                 // This is the CRITICAL line:
//             //                 managedDept={userData.HOD}
//             //             />
//             //         );
//             //     }
//             //     return <OKRTracker userData={userData} />;

//             case "employee-okrs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementOKRViewer userRole={role} />;
//                 }
//                 return <OKRTracker userData={userData} />;

//             case "career pathways": return <CareerPathways userData={userData} />;
//             case "add-department": return <AddDepartment />;
//             case "manage-department": return <ManageDepartment />;
//             case "add-employee": return <AddEmployee />;
//             case "manage-employee": return <ManageEmployee />;

//             case "employee-salary-benefits":
//                 return <EmployeeSalaryBenefits />;


//             case "equipment-request":
//                 if (role === "Management") {
//                     const pending = requestsList.filter(
//                         (r) => r.status?.toLowerCase() === "pending"
//                     );

//                     const history = requestsList.filter(
//                         (r) => r.status?.toLowerCase() !== "pending"
//                     );

//                     return (
//                         <div
//                             className="management-request-wrapper animate-fade"
//                             style={{ padding: "20px" }}
//                         >
//                             {/* Pending Queue */}
//                             <div
//                                 className="module-glass-card"
//                                 style={{ marginBottom: "30px" }}
//                             >
//                                 <h3 className="cyan-text">
//                                     ACTIVE_PENDING_QUEUE ({pending.length})
//                                 </h3>

//                                 {/* Desktop Table */}
//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>IMPACT</th>
//                                                 <th>ACTION</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {pending.length > 0 ? (
//                                                 pending.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                             >
//                                                                 {req.impact?.toUpperCase()}
//                                                             </span>
//                                                         </td>

//                                                         <td>
//                                                             <div className="equiptable-actions">
//                                                                 <button
//                                                                     className="equiptable-btn equiptable-approve"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Approved"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✔
//                                                                 </button>

//                                                                 <button
//                                                                     className="equiptable-btn equiptable-reject"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Rejected"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✖
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_PENDING_REQUESTS
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 {/* Mobile Cards */}
//                                 <div className="equiptable-mobile">
//                                     {pending.length > 0 ? (
//                                         pending.map((req) => (
//                                             <div
//                                                 className="equiptable-card"
//                                                 key={req.id}
//                                             >
//                                                 <div className="equiptable-row">
//                                                     <span>Employee</span>
//                                                     <strong>
//                                                         {req.employee_name}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Hardware</span>
//                                                     <strong>
//                                                         {req.equipment_type}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Impact</span>

//                                                     <span
//                                                         className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                     >
//                                                         {req.impact?.toUpperCase()}
//                                                     </span>
//                                                 </div>

//                                                 <div className="equiptable-actions">
//                                                     <button
//                                                         className="equiptable-btn equiptable-approve"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Approved"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✔ Approve
//                                                     </button>

//                                                     <button
//                                                         className="equiptable-btn equiptable-reject"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Rejected"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✖ Reject
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         ))
//                                     ) : (
//                                         <div className="equiptable-card">
//                                             NO_PENDING_REQUESTS
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Completed History */}
//                             <div
//                                 className="module-glass-card history-card"
//                                 style={{ opacity: 0.9 }}
//                             >
//                                 <h3
//                                     className="gray-text"
//                                     style={{ color: "#888" }}
//                                 >
//                                     📜 COMPLETED_HISTORY ({history.length})
//                                 </h3>

//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>DATE</th>
//                                                 <th>STATUS</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {history.length > 0 ? (
//                                                 history.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             {new Date(
//                                                                 req.updated_at ||
//                                                                 req.created_at
//                                                             ).toLocaleDateString(
//                                                                 "en-GB"
//                                                             )}
//                                                         </td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-status ${req.status?.toLowerCase()}`}
//                                                             >
//                                                                 {req.status?.toUpperCase()}
//                                                             </span>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_HISTORY_FOUND
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     );
//                 }

//                 return <EquipmentRequest userData={userData} />;

//             case "supplies": return <OfficeRequisition userData={userData} />;
//             // case "it": return <ITSupport userData={userData} />;
//             case "documents": return <Documents userData={userData} />;
//             // case "company-policy": return <CompanyPolicy />;
//             case "company-policy":
//                 return <CompanyPolicy userData={userData} />;
//             case "Organization Chart": return <OrgChart userData={userData} />;
//             // case "campus information": return <CampusInfo />;
//             case "campus information":
//                 return <CampusInfo userData={userData} />;
//             case "ees-survey": return <EESExperience userData={userData} />;

//             case "ees-analytics":
//                 if (role === 'Management' || role === 'Manager') {
//                     // Management sees the list of real data
//                     return <EESFeedbackManagement feedbacks={eesSubmissions} />;
//                 }
//                 // Employee sees the form
//                 return <EESExperience userData={userData} onFinalSubmit={handleEESSubmit} />;

//             //       case "one-on-one":
//             // return <OneOnOne userData={userData} role={role} />;

//             case "one-on-one":
//                 // This is the PERSONAL view (Employee mode)
//                 return <OneOnOne userData={userData} role="Employee" viewMode="personal" />;

//             case "manager-one-on-one":
//                 // This is the MANAGERIAL view (Manager/Management mode)
//                 return <OneOnOne userData={userData} role={role} viewMode="managerial" />;

//             case "one-on-one-report":
//                 return <OneOnOneReport userData={userData} role={role} handleModuleChange={handleModuleChange} />;

//             // Inside Dashboard.js renderActiveModule
//             case "medical-reports":
//                 if (role === 'Management') return <MedicalReports />;
//                 if (role === 'Manager') {
//                     return (
//                         <ManagerMedicalReports
//                             managerId={userData.id}           // Database Primary Key
//                             managerBadgeId={userData.EmpId}   // Company ID (HOD flag often matches this)
//                             managerDept={userData.Department} // The string "Software Development"
//                         />
//                     );
//                 }

//             case "employee-it-support":
//                 return <EquipmentRequest userData={userData} />;

//             default:


//                 if (role === 'Manager') {
//                     return renderManagerDashboard();
//                 }

//                 const currentList = role === 'Management' ? managementModulesList : employeeModulesList;
//                 return (
//                     <section className="bento-grid">
//                         {currentList.map((mod) => (
//                             <div key={mod.id} className="bento-card glass" style={{ "--accent": mod.color }} onClick={() => handleModuleChange(mod.slug)}>
//                                 <div className="card-top">
//                                     <span className="mod-icon">{mod.icon}</span>
//                                     {mod.badge > 0 && <span className={role === 'Management' ? "card-badge" : "notification-badge-ui"}>{mod.badge}</span>}
//                                 </div>
//                                 <div className="card-info"><h3>{mod.name}</h3><div className="cyber-line"></div></div>
//                             </div>
//                         ))}
//                     </section>
//                 );
//         }
//     };

//     const [companyLogo, setCompanyLogo] = useState("");
//     const currentLogo = theme === 'light' ? logoLight : logoDark;


//     const [leaveStats, setLeaveStats] = useState({
//         pending: 0,
//         approved: 0,
//         rejected: 0,
//         wfhPending: 0
//     });

//     useEffect(() => {
//         if (role !== "Management") return;

//         const fetchLeaveStats = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];


//                     const pending = leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                     const approved = leaves.filter(l => l.Status === '1').length;
//                     const rejected = leaves.filter(l => l.Status === '2').length;

//                     // WFH
//                     const wfhRes = await fetch("/gt-api/get_all_wfh_requests.php", {
//                         credentials: "include"
//                     });
//                     const wfhData = await wfhRes.json();

//                     const wfhPending = wfhData.success
//                         ? wfhData.requests.filter(r => r.status === "Pending").length
//                         : 0;

//                     setLeaveStats({ pending, approved, rejected, wfhPending });
//                 }

//             } catch (err) {
//                 console.error("Leave Stats Error:", err);
//             }
//         };

//         fetchLeaveStats();
//         const interval = setInterval(fetchLeaveStats, 5000);

//         return () => clearInterval(interval);
//     }, [role]);


//     const [mgmtLeaves, setMgmtLeaves] = useState([]);
//     const [mgmtActiveTeam, setMgmtActiveTeam] = useState("All");

//     useEffect(() => {
//         const fetchLeaves = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();
//                 if (data.success) setMgmtLeaves(data.leaves);
//             } catch (err) {
//                 console.error("Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaves();
//     }, []);





//     const mgmtChartData = useMemo(() => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept => dept.DepartmentName
//             );

//         const now = new Date();
//         const currentMonth = (now.getMonth() + 1).toString();
//         const currentYear = now.getFullYear().toString();

//         const teamList = mgmtActiveTeam === "All" ? teams : [mgmtActiveTeam];

//         return teamList.map(team => {

//             const filtered = mgmtLeaves.filter(l => {
//                 const dateParts = l.fromdate?.split("-");
//                 const lYear = dateParts?.[0];
//                 const lMonth = dateParts?.[1]
//                     ? parseInt(dateParts[1]).toString()
//                     : "";

//                 return (
//                     l.Department === team &&
//                     lMonth === currentMonth &&
//                     lYear === currentYear
//                 );
//             });

//             return {
//                 name: team,

//                 // ✅ SUM OF UNITS (FIXED)
//                 Approved: filtered
//                     .filter(l => l.Status === "1")
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

//                 Pending: filtered
//                     .filter(l => l.Status === "0" || l.Status === null)
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
//             };
//         });

//     }, [mgmtLeaves, mgmtActiveTeam]);


//     const renderManagementLeaveCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept =>
//                     dept.DepartmentName
//             );

//         return (
//             <div
//                 className="mgmt-leave-analytics clickable"
//                 onClick={() => handleModuleChange("leave-management")}
//             >

//                 <div className="card-header">
//                     <h3>Employee Leave Analytics</h3>
//                     <span className="sub-text">This Month</span>
//                 </div>

//                 {/* TEAM CHIPS */}
//                 <div className="team-row">
//                     <div
//                         className={`team-chip ${mgmtActiveTeam === "All" ? "active" : ""}`}
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             setMgmtActiveTeam("All");
//                         }}
//                     >
//                         ALL
//                     </div>

//                     {teams.map((team, i) => (
//                         <div
//                             key={i}
//                             className={`team-chip ${mgmtActiveTeam === team ? "active" : ""}`}
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 setMgmtActiveTeam(team);
//                             }}
//                         >
//                             {team}
//                         </div>
//                     ))}
//                 </div>

//                 {/* CHART */}
//                 {(() => {
//                     const isSingle = mgmtActiveTeam !== "All";

//                     return (
//                         <div className={`chart-area ${isSingle ? "single-view" : ""}`}>
//                             <ResponsiveContainer width="100%" height={170}>
//                                 <BarChart
//                                     data={mgmtChartData}
//                                     barCategoryGap={isSingle ? "70%" : "30%"}
//                                     margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
//                                 >

//                                     {/* GRADIENTS */}
//                                     <defs>
//                                         <linearGradient id="approvedGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#34d399" />
//                                             <stop offset="100%" stopColor="#059669" />
//                                         </linearGradient>

//                                         <linearGradient id="pendingGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#fbbf24" />
//                                             <stop offset="100%" stopColor="#f59e0b" />
//                                         </linearGradient>
//                                     </defs>

//                                     <CartesianGrid
//                                         strokeDasharray="3 3"
//                                         stroke="rgba(255,255,255,0.05)"
//                                         vertical={false}
//                                     />

//                                     <XAxis
//                                         dataKey="name"
//                                         tick={{ fill: "#888", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <YAxis
//                                         tick={{ fill: "#666", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <Tooltip
//                                         cursor={{ fill: "rgba(255,255,255,0.05)" }}
//                                         contentStyle={{
//                                             backgroundColor: "rgba(15, 23, 42, 0.95)", // dark glass
//                                             border: "1px solid rgba(0,255,242,0.3)",
//                                             borderRadius: "10px",
//                                             color: "#ffffff",
//                                             backdropFilter: "blur(8px)"
//                                         }}
//                                         labelStyle={{ color: "#00fff2", fontWeight: 600 }}
//                                         itemStyle={{ color: "#ffffff" }}
//                                     />


//                                     <Bar
//                                         dataKey="Approved"
//                                         stackId="a"
//                                         fill="url(#approvedGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                     <Bar
//                                         dataKey="Pending"
//                                         stackId="a"
//                                         fill="url(#pendingGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                 </BarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     );
//                 })()}


//                 <div className="card-footer">
//                     <span>Open Leave Console</span>
//                     <span>→</span>
//                 </div>
//             </div>
//         );
//     };

//     const renderSalaryIntelCard = () => {
//         // 1. Existing Counts
//         const payslips = payData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = payData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = payData.filter(d => d.doc_type === "APPRAISAL LETTER").length;

//         // 2. New Miscellaneous Count (Filtering for the images you provided)
//         const miscDocs = [
//             "FNF LETTER", "OFFER LETTER", "RELIEVING LETTER",
//             "EXPERIENCE LETTER", "EMPLOYEMENT AGREEMENT", "BANK ACCOUNT OPENING"
//         ];
//         const miscellaneous = payData.filter(d => miscDocs.includes(d.doc_type)).length;

//         // 3. Updated Total
//         const total = payslips + form16 + appraisal + miscellaneous;

//         // 4. SVG Math for 4 segments
//         const chartTotal = 125.6;
//         const gap = total > 0 ? 2 : 0;

//         const s1 = (payslips / total) * chartTotal || 0;
//         const s2 = (form16 / total) * chartTotal || 0;
//         const s3 = (appraisal / total) * chartTotal || 0;
//         const s4 = (miscellaneous / total) * chartTotal || 0;

//         return (
//             <div className="sa-card-wrapper" onClick={() => handleModuleChange("employee-salary-benefits")}>


//                 <div className="sa-card-header">
//                     <h3 className="sa-title">Salary Document Insights</h3>
//                     <button className="sa-menu-trigger">⋮</button>
//                 </div>

//                 <div className="sa-main-body">
//                     <div className="sa-gauge-area">
//                         <div className="sa-gauge-container">
//                             <svg viewBox="0 0 100 55" className="sa-gauge-svg">
//                                 {/* Background Track */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="var(--sa-track)" strokeWidth="9" strokeLinecap="round" />

//                                 {/* Segment 4: Misc (Blue) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#0ea5e9" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s4 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2 + s3}`} />

//                                 {/* Segment 3: Appraisals (Orange) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#f97316" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s3 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2}`} />

//                                 {/* Segment 2: Form 16 (Yellow) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#fbbf24" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s2 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1}`} />

//                                 {/* Segment 1: Payslips (Purple) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#8b5cf6" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s1 - gap)} ${chartTotal}`}
//                                     strokeDashoffset="0" />
//                             </svg>

//                             <div className="sa-gauge-text">
//                                 <span className="sa-overall-num">{total}</span>
//                                 <span className="sa-overall-label">Overall</span>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="sa-legend-area">
//                         {[
//                             { label: "Payslips", count: payslips, color: "purple" },
//                             { label: "Form 16", count: form16, color: "yellow" },
//                             { label: "Appraisals", count: appraisal, color: "orange" },
//                             { label: "Miscellaneous", count: miscellaneous, color: "blue" }
//                         ].map((item, index) => (
//                             <div key={index} className="sa-legend-item">
//                                 <div className="sa-item-top">
//                                     <span className={`sa-dot ${item.color}`}></span>
//                                     <span className="sa-item-count">{item.count}</span>
//                                 </div>
//                                 <span className="sa-item-label">{item.label}</span>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <div className="sa-card-footer">
//                     <span className="sa-footer-link">View Detailed Report →</span>
//                 </div>
//             </div>
//         );
//     };



//     const [okrData, setOkrData] = useState([]);
//     useEffect(() => {
//         if (!userData?.id) return;

//         const fetchOKR = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/get_user_okr.php?empId=${userData.id}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     const parsed = typeof data.data === "string"
//                         ? JSON.parse(data.data)
//                         : data.data;

//                     setOkrData(parsed);
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchOKR();

//     }, [userData?.id]);



//     const [okrStats, setOkrStats] = useState({
//         total: 0,
//         completed: 0,
//         pending: 0,
//         progressPercent: 0
//     });



//     const fetchOKRStats = async () => {
//         if (!userData?.EmpId) return;

//         try {
//             const res = await fetch(
//                 `/gt-api/get_okr_stats.php?empId=${userData.EmpId}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setOkrStats(data);
//             }

//         } catch (err) {
//             console.error("OKR STATS ERROR:", err);
//         }
//     };

//     useEffect(() => {
//         if (!userData?.EmpId) return;

//         fetchOKRStats();

//         const handleUpdate = () => fetchOKRStats();

//         window.addEventListener("okrUpdated", handleUpdate);

//         return () => window.removeEventListener("okrUpdated", handleUpdate);

//     }, [userData?.EmpId]);




//     const renderOKRCard = () => {
//         const { total, completed, pending, progressPercent } = okrStats;

//         return (
//             <div
//                 className="expanded-management-card clickable"
//                 onClick={() => handleModuleChange("okr and performance tracker")}
//             >
//                 <div className="okr-card-container">

//                     {/* HEADER */}
//                     <div className="okr-header">
//                         <div>
//                             <span className="eyebrow-text">Performance Tracker</span>
//                             <h2 className="display-title">OKR Progress</h2>
//                         </div>

//                         {/* TOP RIGHT TOTAL */}
//                         <div className="stat-box featured big">
//                             <span className="stat-label">Total KR</span>
//                             <span className="stat-value">{total}</span>
//                         </div>
//                     </div>

//                     {/* STATS ROW */}
//                     <div className="okr-stats-row">
//                         <div className="stat-box danger">
//                             <span className="stat-label">Pending</span>
//                             <span className="stat-value">{pending}</span>
//                         </div>

//                         <div className="stat-box success">
//                             <span className="stat-label">Completed</span>
//                             <span className="stat-value">{completed}</span>
//                         </div>
//                     </div>

//                     {/* PROGRESS FULL WIDTH */}
//                     <div className="progress-section-wide full">
//                         <div className="progress-labels">
//                             <span className="label-muted">Completion</span>
//                             <span className="label-bold">{progressPercent}%</span>
//                         </div>

//                         <div className="wide-bar-bg">
//                             <div
//                                 className="wide-bar-fill"
//                                 style={{ width: `${progressPercent}%` }}
//                             ></div>
//                         </div>
//                     </div>

//                     {/* FOOTER */}
//                     <div className="expanded-footer">
//                         <span className={`status-indicator ${pending > 0 ? 'is-warning' : 'is-clear'}`}>
//                             {pending > 0
//                                 ? `● ${pending} Key Results Pending`
//                                 : '● All Key Results Completed'}
//                         </span>

//                         <span className="interaction-hint">
//                             Open OKR Console →
//                         </span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     const [mgmtOneOnOneData, setMgmtOneOnOneData] = useState([]);
//     useEffect(() => {
//         const fetchMeetings = async () => {
//             const storedUser = localStorage.getItem('userData');
//             const user = JSON.parse(storedUser) || {};

//             const res = await fetch(
//                 `/gt-api/get_oneonone.php?manager_id=${user.id}&role=manager`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.meetings) {
//                 setMgmtOneOnOneData(data.meetings);
//             }
//         };

//         fetchMeetings();
//     }, []);

//     const renderOneOnOneHealthCard = () => {
//         const missedData = mgmtOneOnOneData.filter(m => m.status === "MISSED");

//         const total = mgmtOneOnOneData.length;
//         const missed = mgmtOneOnOneData.filter(m => m.status === "MISSED").length;
//         const completed = total - missed;

//         const rate = total > 0 ? Math.round((completed / total) * 100) : 0;

//         let status = "Healthy";
//         if (rate < 50) status = "Critical ⚠️";
//         else if (rate < 80) status = "Needs Attention";

//         return (
//             <div className="meeting-card" onClick={() => handleModuleChange("manager-one-on-one")}>

//                 <div className="mc-header">
//                     <h3>1:1 Meeting Scheduler</h3>
//                     <span>{status}</span>
//                 </div>

//                 {/* BIG NUMBER */}
//                 <div className="mc-center">
//                     <h1>{rate}%</h1>
//                     <p>Engagement</p>
//                 </div>

//                 {/* BARS */}
//                 <div className="mc-bars">
//                     <div className="bar completed" style={{ width: `${rate}%` }}></div>
//                     <div className="bar missed" style={{ width: `${100 - rate}%` }}></div>
//                 </div>

//                 {/* INFO */}
//                 <div className="mc-info">
//                     <span>✅ {completed} Done</span>
//                     <span>❌ {missed} Missed</span>
//                 </div>
//                 <button
//                     className="view-missed-btn"
//                     onClick={(e) => {
//                         e.stopPropagation();
//                         setShowMissedModal(true);
//                     }}
//                 >
//                     View Missed
//                 </button>

//             </div>
//         );
//     };

//     const [okrActivity, setOkrActivity] = useState([]);
//     useEffect(() => {
//         const fetchOKR = async () => {
//             try {
//                 const storedUser = localStorage.getItem("userData");
//                 const user = JSON.parse(storedUser) || {};

//                 const res = await fetch(
//                     `/gt-api/get_employee_okrs.php?role=${user.role}&managedDept=${user.department}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 if (data.success) {
//                     setOkrActivity(data.data);
//                 }

//             } catch (err) {
//                 console.error("OKR Fetch Error:", err);
//             }
//         };

//         fetchOKR();
//     }, []);

//     const recentOKR = okrActivity
//         .slice(0, 5)
//         .map(item => {
//             let type = "updated";

//             if (item.workflow_status === "Planning") {
//                 type = "new";
//             }

//             if (item.workflow_status === "Manager_Scoring_Review") {
//                 type = "pending";
//             }

//             return {
//                 name: item.emp_name,
//                 quarter: item.quarter,
//                 type,
//                 workflow_status: item.workflow_status   // 🔥 VERY IMPORTANT
//             };
//         });



//     const renderOKRActivityCard = () => {
//         const getStatusConfig = (status) => {
//             switch (status) {
//                 case "Planning": return { color: "#3b82f6", label: "submitted OKR" };
//                 case "Management_Review": return { color: "#f59e0b", label: "sent for Review" };
//                 case "Scoring": return { color: "#8b5cf6", label: "sent for Scoring" };
//                 case "Sign_Off": return { color: "#10b981", label: "finalized OKR" };
//                 default: return { color: "#00bcd4", label: "updated OKR" };
//             }
//         };

//         return (
//             <div className="mgt-okr-card1 timeline-style clickable" onClick={() => handleModuleChange("employee-okrs")}>
//                 <div className="card-header-v2">
//                     <div className="title-section">
//                         <h3>OKR Stream</h3>
//                         <div className="live-dot-wrapper">
//                             <span className="live-dot"></span>
//                             <span className="sub-text">Live updates</span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="okr-activity-timeline">
//                     {recentOKR.length === 0 ? (
//                         <div className="empty-state">No recent activity detected</div>
//                     ) : (
//                         recentOKR.slice(0, 3).map((item, i) => {
//                             const config = getStatusConfig(item.workflow_status);
//                             return (
//                                 <div key={i} className="timeline-item">
//                                     {/* The Vertical Line & Dot */}
//                                     <div className="timeline-visual">
//                                         <div className="timeline-line"></div>
//                                         <div className="timeline-marker" style={{ borderColor: '#111827', background: config.color }}>
//                                             <div className="marker-inner-dot"></div>
//                                         </div>
//                                     </div>

//                                     {/* Single Content Box */}
//                                     <div className="timeline-content-box">
//                                         <div className="content-top">
//                                             <span className="emp-name">{item.name}</span>
//                                             <span className="quarter-tag">{item.quarter}</span>
//                                         </div>
//                                         <p className="status-message">{config.label}</p>
//                                     </div>
//                                 </div>
//                             );
//                         })
//                     )}
//                 </div>

//                 <div className="card-footer-v2">
//                     <span>Access Module</span>
//                     {/* <div className="arrow-circle">→</div> */}
//                 </div>


//             </div>
//         );
//     };

//     const renderManagementShortcutsCard = () => {
//         const shortcuts = [

//             { name: "Create Invoice", icon: "🏦", slug: "create-invoice" },
//             { name: "Policy RnU", icon: "📋", slug: "policy-logs" },
//             { name: "Career Development", icon: "🏆", slug: "career pathways" },
//             { name: "Expense Reimbursement", icon: "💰", slug: "reimbursements" },
//             // { name: "ACM Updates", icon: "📢", slug: "manage-quarterly-updates" },
//             { name: "Self OKR", icon: "🎯", slug: "okr and performance tracker" },
//             { name: "Own Financial", icon: "💳", slug: "pay and benefits" },
//             { name: "Access ACM Info", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//             // { name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },
//             { name: "IT Support", icon: "🖥️", slug: "employee-it-support" },
//             { name: "Attendance Tracker", icon: "📊", slug: "attendance-tracker" },
//              { name: "Award Analytics", icon: "🏆", slug: "award-analytics" },
//             // { name: "Company Setup", icon: "⚙️", slug: "CompanySetup" },





//         ];

//         return (
//             <div className="mgt-shortcut-card">

//                 <div className="card-header">
//                     <h3>Quick Access</h3>
//                     <span className="sub-text">Shortcuts</span>
//                 </div>

//                 <div className="shortcut-grid">
//                     {shortcuts.map((item, i) => (
//                         <div
//                             key={i}
//                             className="shortcut-item"
//                             onClick={() => handleModuleChange(item.slug)}
//                         >
//                             <span className="shortcut-icon">{item.icon}</span>
//                             <span className="shortcut-text">{item.name}</span>
//                         </div>
//                     ))}
//                 </div>

//             </div>
//         );
//     };


//     const renderEmployeeDashboard = () => {
//         return (
//             <div className="dashboard-layout">

//                 <div className="dashboard-row row-top">
//                     {renderLeavePieChart()}
//                     {renderPayChart()}
//                     {renderOneOnOneCard()}



//                     {/* {renderEquipmentCard()} */}
//                 </div>

//                 <div className="dashboard-row row-middle">
//                     {renderOKRCard()}
//                     {renderCareerPathwaysCard()}
//                 </div>

//                 <div className="dashboard-row row-bottom">
//                     {renderPolicyCard()}
//                     <QuarterlyCard handleModuleChange={handleModuleChange} />
//                 </div>

//             </div>
//         );
//     };

//     const renderManagementDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>






//         );
//     };

//     const renderManagerDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>




//         );
//     };

//     const currentEvent =
//         todayEvents && todayEvents.length > 0
//             ? todayEvents[currentEventIndex]
//             : null;


//     const combinedEvents = [];

//     // 🎊 Festival TODAY (Priority if festival is today)
//     if (upcomingFestival && isFestivalToday) {
//         combinedEvents.push({
//             type: "festival",
//             title: upcomingFestival.name,
//             tag: "FESTIVAL TODAY",
//             icon: "🎊",
//             sub: "Today 🎉"
//         });
//     }

//     // 🎂 Birthday / Anniversary
//     if (currentEvent && currentEvent.fullName) {
//         combinedEvents.push({
//             type: "event",
//             title: currentEvent.fullName,
//             tag: currentEvent.isBirthday ? "BIRTHDAY" : "WORK ANNIVERSARY",
//             icon: currentEvent.isBirthday ? "🎂" : "🎉"
//         });
//     }

//     // 🎊 Upcoming Festival (If future)
//     if (upcomingFestival && !isFestivalToday) {
//         combinedEvents.push({
//             type: "festival",
//             title: upcomingFestival.name,
//             tag: "UPCOMING FESTIVAL",
//             icon: "🎊",
//             sub: `In ${daysLeft} days`
//         });
//     }

//     useEffect(() => {
//         if (combinedEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setActiveEventIndex(prev => (prev + 1) % combinedEvents.length);
//         }, 4000);

//         return () => clearInterval(interval);
//     }, [combinedEvents.length]);

//     const activeEvent = combinedEvents[activeEventIndex];


//     return (

//         <div


//             className={`dash-container ${theme}-theme`}
//             style={
//                 theme === 'light'
//                     ? {
//                         backgroundImage: `url(${logoLight})`,
//                         backgroundSize: 'cover',
//                         backgroundRepeat: 'no-repeat',
//                         backgroundPosition: 'center',
//                         backgroundColor: 'var(--bg-main)'

//                     }
//                     : {}
//             }
//         >


//             {showMissedModal && (
//                 <div className="modal-overlay" onClick={() => setShowMissedModal(false)}>
//                     <div className="modal-card" onClick={(e) => e.stopPropagation()}>

//                         <h3>Missed 1:1 Meetings</h3>

//                         {mgmtOneOnOneData.filter(m => m.status === "MISSED").length === 0 ? (
//                             <p>No missed meetings 🎉</p>
//                         ) : (
//                             mgmtOneOnOneData
//                                 .filter(m => m.status === "MISSED")
//                                 .map((m, i) => (
//                                     <div key={i} className="missed-item">
//                                         <strong>{m.employee_name}</strong>
//                                         <span>{m.date}</span>
//                                     </div>
//                                 ))
//                         )}

//                         <button onClick={() => setShowMissedModal(false)}>
//                             Close
//                         </button>

//                     </div>
//                 </div>
//             )}



//             <div className="auth-background-overlay"></div>






//             <Sidebar
//                 role={role}
//                 userData={userData}
//                 activeModule={activeModule}
//                 openMenus={openMenus}
//                 toggleSubMenu={toggleSubMenu}
//                 handleModuleChange={handleModuleChange}
//                 handleLogout={handleLogout}
//                 mobileMenuOpen={mobileMenuOpen}
//                 setMobileMenuOpen={setMobileMenuOpen}
//                 pendingRequestsCount={pendingRequestsCount}
//             />

//             <main className="dash-content">

//                 <header className="content-header">

//                     {/* 🔷 LEFT */}
//                     <div className="header-left">
//                         <div className="header-text">

//                             <h1>
//                                 {activeModule === "grid" && !showProfile ? "Welcome," : ""}{" "}
//                                 <span className={theme === 'light' ? "name-light" : "name-accent"}>
//                                     {showProfile
//                                         ? "MY PROFILE"
//                                         : (activeModule === "grid"
//                                             ? userData.firstName || userData.FirstName
//                                             : (activeModule === "attendance"
//                                                 ? "LEAVE MANAGEMENT"
//                                                 : (activeModule === "one-on-one-report"
//                                                     ? "ONE-ON-ONE REPORT"
//                                                     : activeModule.toUpperCase().replace(/-/g, ' ')
//                                                 )
//                                             )
//                                         )
//                                     }
//                                 </span>
//                             </h1>

//                             {activeModule === 'attendance' && userData.joiningDate && (
//                                 <div className="joining-info">
//                                     JOINING_DATE: {new Date(userData.joiningDate).toLocaleDateString('en-GB').toUpperCase()}
//                                 </div>
//                             )}

//                         </div>
//                     </div>







//                     <div className="header-center">

//                         {/* TIME + DATE FIRST */}
//                         <div className="time-date-right">
//                             <div className="live-time">{currentTime}</div>

//                             <div className="today-widget">
//                                 <span>📅 {todayDate}</span>
//                                 <small>Have a Nice Day!</small>
//                             </div>
//                         </div>

//                         {/* EVENT CARD SECOND */}
//                         <div
//                             className={`executive-event-bar ${theme === 'light' ? 'light-theme-elite' : 'dark-theme-elite'}
//         ${role === "Management" || role === "Manager" ? "clickable" : ""}`}
//                             onClick={() => {
//                                 if (role === "Management" || role === "Manager") {
//                                     handleModuleChange("events-celebrations");
//                                 }
//                             }}
//                         >
//                             <div
//                                 className={`event-status-box ${activeEvent
//                                     ? (activeEvent.type === 'festival'
//                                         ? 'bg-fest'
//                                         : (activeEvent.tag === 'BIRTHDAY' ? 'bg-birth' : 'bg-anniv'))
//                                     : 'bg-neutral'
//                                     }`}
//                             >
//                                 <span className="event-icon-small">
//                                     {activeEvent ? activeEvent.icon : "✨"}
//                                 </span>
//                             </div>

//                             <div className="event-content-main">
//                                 <div className="event-label-row">
//                                     <span className="event-tag">
//                                         {activeEvent ? activeEvent.tag : "TODAY"}
//                                     </span>
//                                 </div>

//                                 <h3 className="event-title-text">

//                                     {activeEvent ? (
//                                         <span className="event-highlight">
//                                             {activeEvent.icon} {activeEvent.title}
//                                         </span>
//                                     ) : (
//                                         <span className="event-empty-text">
//                                             No events today
//                                         </span>
//                                     )}
//                                 </h3>
//                             </div>

//                             <div className="event-action-wrapper">
//                                 <button
//                                     className="minimal-wish-btn"
//                                     disabled={!currentEvent}
//                                     onClick={(e) => e.stopPropagation()}
//                                 >
//                                     <div className="btn-line"></div>
//                                 </button>
//                             </div>
//                         </div>

//                     </div>







//                     <div className="header-controls">

//                         {/* 🌗 THEME */}
//                         <div className="theme-switch-container">
//                             <label className="theme-slider-switch">
//                                 <input
//                                     type="checkbox"
//                                     onChange={toggleTheme}
//                                     checked={theme === 'light'}
//                                 />
//                                 <span className="theme-slider round">
//                                     <span className="sun-icon">☀️</span>
//                                     <span className="moon-icon">🌙</span>
//                                 </span>
//                             </label>
//                         </div>




//                         {(activeModule !== "grid" || showProfile) && (
//                             <button
//                                 className="back-btn"
//                                 onClick={() => handleModuleChange("grid")}
//                             >
//                                 Back
//                             </button>
//                         )}

//                     </div>

//                 </header>


//                 {activeModule === "grid" ? (

//                     role === "Management"
//                         ? renderManagementDashboard()
//                         : role === "Manager"
//                             ? renderManagerDashboard()   // 🔥 ADD THIS LINE
//                             : renderEmployeeDashboard()

//                 ) : (
//                     renderActiveModule()
//                 )}

//                 <div className="dash-footer">
//                     Design & Developed by Genesis Tech Engineers © 2026
//                 </div>
//             </main>

//             {(role === "Management" || role === "Manager") && (
//                 <>
//                     <div
//                         className="ai-chat-float-btn"
//                         onClick={() => setShowAIChat(true)}
//                     >
//                         🤖
//                     </div>

//                     {showAIChat && (
//                         <div className="ai-chat-modal">
//                             <div className="ai-chat-header">
//                                 <span>ELMS AI Assistant</span>
//                                 <button onClick={() => setShowAIChat(false)}>
//                                     ✕
//                                 </button>
//                             </div>

//                             <div className="ai-chat-body">
//                                 {chatMessages.map((msg, index) => (
//                                     <div
//                                         key={index}
//                                         className={`chat-bubble ${msg.sender}`}
//                                     >
//                                         <pre>{msg.text}</pre>
//                                     </div>
//                                 ))}

//                                 {chatLoading && (
//                                     <div className="chat-bubble ai">
//                                         Thinking...
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="ai-chat-footer">
//                                 <input
//                                     type="text"
//                                     value={chatInput}
//                                     onChange={(e) => setChatInput(e.target.value)}
//                                     placeholder="Ask anything..."
//                                     onKeyDown={(e) => {
//                                         if (e.key === "Enter") {
//                                             sendAIMessage();
//                                         }
//                                     }}
//                                 />

//                                 <button onClick={sendAIMessage}>
//                                     Send
//                                 </button>
//                             </div>
//                         </div>
//                     )}
//                 </>
//             )}

//             {/* 1️⃣ MANDATORY COMPANY POLICY ACKNOWLEDGEMENT MODAL (FIRST) */}
//             {showMandatoryPolicyModal && (
//                 <div className="mandatory-policy-fullscreen-overlay">
//                     {/* Top Header Bar */}
//                     <div className="mandatory-policy-topbar">
//                         <div className="topbar-title-area">
//                             <span className="topbar-icon">📜</span>
//                             <h2>Mandatory Company Policy Acknowledgement</h2>
//                         </div>

//                         <div className="topbar-progress-area">
//                             <div className="topbar-progress-text">
//                                 <span>Progress: <strong>{acknowledgedPoliciesCount}</strong> of <strong>{totalPoliciesCount}</strong> Policies Acknowledged</span>
//                                 <span className="topbar-badge">{unacknowledgedPolicies.length} Remaining</span>
//                             </div>
//                             <div className="topbar-progress-track">
//                                 <div
//                                     className="topbar-progress-fill"
//                                     style={{ width: `${totalPoliciesCount > 0 ? (acknowledgedPoliciesCount / totalPoliciesCount) * 100 : 0}%` }}
//                                 ></div>
//                             </div>
//                         </div>

//                         <button
//                             type="button"
//                             className="topbar-logout-btn"
//                             onClick={handleLogout}
//                         >
//                             🚪 Logout
//                         </button>
//                     </div>

//                     {/* Alerts */}
//                     {policyAckError && (
//                         <div className="mandatory-alert-box error" style={{ margin: '8px 24px 0 24px' }}>
//                             <span>⚠️ {policyAckError}</span>
//                         </div>
//                     )}

//                     {policyAckSuccessMsg && (
//                         <div className="mandatory-alert-box success" style={{ margin: '8px 24px 0 24px' }}>
//                             <span>✅ {policyAckSuccessMsg}</span>
//                         </div>
//                     )}

//                     {/* Full Screen Layout Body */}
//                     <div className="mandatory-policy-fullscreen-body">
//                         {/* Left Sidebar Menu */}
//                         <div className="mandatory-policy-sidebar">
//                             <h3>Company Policies ({(allPoliciesList.length > 0 ? allPoliciesList : GENESIS_POLICIES).length})</h3>
//                             <div className="mandatory-policy-list">
//                                 {(allPoliciesList.length > 0 ? allPoliciesList : GENESIS_POLICIES).map((p, idx) => {
//                                     const pTitle = p.title || p.policy_title;
//                                     const pIcon = p.icon || p.policy_icon || "📜";
//                                     const isAck = !!logs[pTitle];
//                                     const isSelected = selectedMandatoryPolicy && (selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title) === pTitle;

//                                     return (
//                                         <div
//                                             key={p.id || idx}
//                                             className={`mandatory-policy-item ${isSelected ? "active" : ""} ${isAck ? "signed" : ""}`}
//                                             onClick={() => {
//                                                 setSelectedMandatoryPolicy(p);
//                                                 setPolicyAgreed(false);
//                                             }}
//                                         >
//                                             <span className="p-item-icon">{pIcon}</span>
//                                             <span className="p-item-title">{pTitle}</span>
//                                             {isAck ? (
//                                                 <span className="p-item-tag ack">✅ Signed</span>
//                                             ) : (
//                                                 <span className="p-item-tag pending">Required</span>
//                                             )}
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         </div>

//                         {/* Right Main Policy Content Viewer */}
//                         <div className="mandatory-policy-fullscreen-viewer">
//                             {selectedMandatoryPolicy ? (
//                                 <>
//                                     <div className="mandatory-viewer-header">
//                                         <h3>
//                                             <span>{selectedMandatoryPolicy.icon || selectedMandatoryPolicy.policy_icon || "📜"}</span>
//                                             {selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title}
//                                             {logs[selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title] && (
//                                                 <span className="viewer-signed-badge">✅ Acknowledged</span>
//                                             )}
//                                         </h3>
//                                     </div>

//                                     {/* Full Height Scrollable Document Body */}
//                                     <div className="mandatory-policy-document-body">
//                                         {selectedMandatoryPolicy.content ? (
//                                             typeof selectedMandatoryPolicy.content === 'string' ? (
//                                                 <div dangerouslySetInnerHTML={{ __html: selectedMandatoryPolicy.content }} />
//                                             ) : (
//                                                 selectedMandatoryPolicy.content
//                                             )
//                                         ) : (
//                                             <p className="policy-placeholder">Please review the contents of this policy carefully before accepting.</p>
//                                         )}
//                                     </div>

//                                     {/* Fixed Bottom Action Section */}
//                                     <div className="mandatory-policy-bottom-action-bar">
//                                         {logs[selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title] ? (
//                                             <div className="mandatory-policy-signed-banner">
//                                                 <span>✅ Policy Acknowledged & Signed</span>
//                                             </div>
//                                         ) : (
//                                             <form onSubmit={handleAcknowledgeMandatoryPolicy} className="mandatory-ack-stacked-form">
//                                                 <label className="mandatory-checkbox-container">
//                                                     <input
//                                                         type="checkbox"
//                                                         checked={policyAgreed}
//                                                         onChange={(e) => setPolicyAgreed(e.target.checked)}
//                                                     />
//                                                     <span>
//                                                         I confirm that I have read, understood, and agree to abide by the terms of <strong>{selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title}</strong>.
//                                                     </span>
//                                                 </label>

//                                                 <button
//                                                     type="submit"
//                                                     className="mandatory-save-btn"
//                                                     disabled={!policyAgreed || policyAckSaving}
//                                                 >
//                                                     {policyAckSaving ? "Recording..." : "Acknowledge & Accept Policy ✅"}
//                                                 </button>
//                                             </form>
//                                         )}
//                                     </div>
//                                 </>
//                             ) : (
//                                 <div className="mandatory-policy-document-body">
//                                     <p>Select a policy from the list on the left to read and acknowledge.</p>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* 2️⃣ MANDATORY BANK DETAILS POPUP MODAL (SECOND) */}
//             {showMandatoryBankModal && !showMandatoryPolicyModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">🏦</div>
//                             <h2>Mandatory Bank Details Required</h2>
//                             <p>
//                                 Your employee bank record has missing information. Please fill in the required field(s) below for payroll & salary processing.
//                             </p>
//                         </div>

//                         {bankError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {bankError}</span>
//                             </div>
//                         )}

//                         {bankSuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {bankSuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryBankDetails} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingBankFields.bankName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Bank Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC Bank, ICICI Bank"
//                                             value={bankFormData.bankName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, bankName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.holderName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Holder Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account holder name"
//                                             value={bankFormData.holderName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, holderName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accNumber && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account number"
//                                             value={bankFormData.accNumber}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accNumber: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.ifsc && (
//                                     <div className="mandatory-input-group">
//                                         <label>IFSC Code <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC0001234"
//                                             value={bankFormData.ifsc}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, ifsc: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.branch && (
//                                     <div className="mandatory-input-group">
//                                         <label>Branch Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter branch name"
//                                             value={bankFormData.branch}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, branch: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accType && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Type <span className="req-star">*</span></label>
//                                         <select
//                                             value={bankFormData.accType}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accType: e.target.value }))}
//                                             required
//                                         >
//                                             <option value="Saving Account">Saving Account</option>
//                                             <option value="Current Account">Current Account</option>
//                                             <option value="Salary Account">Salary Account</option>
//                                         </select>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={bankSaving}
//                                 >
//                                     {bankSaving ? "Saving Bank Details..." : "Save Bank Details & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}

//             {/* 3️⃣ MANDATORY PROFILE POPUP MODAL (THIRD) */}
//             {showMandatoryProfileModal && !showMandatoryPolicyModal && !showMandatoryBankModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">⚠️</div>
//                             <h2>Mandatory Profile Completion Required</h2>
//                             <p>
//                                 Your employee profile has missing information. Please fill in the required field(s) below to continue using the system.
//                             </p>
//                         </div>

//                         {mandatoryError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {mandatoryError}</span>
//                             </div>
//                         )}

//                         {mandatorySuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {mandatorySuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryProfile} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingProfileFields.phone && (
//                                     <div className="mandatory-input-group">
//                                         <label>Mobile Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="tel"
//                                             placeholder="Enter mobile number"
//                                             value={mandatoryFormData.phone}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, phone: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.dob && (
//                                     <div className="mandatory-input-group">
//                                         <label>Date of Birth <span className="req-star">*</span></label>
//                                         <input
//                                             type="date"
//                                             max={new Date().toISOString().split("T")[0]}
//                                             value={mandatoryFormData.dob}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, dob: e.target.value }))}
//                                             onClick={(e) => {
//                                                 try {
//                                                     if (e.target.showPicker) e.target.showPicker();
//                                                 } catch (err) { }
//                                             }}
//                                             required
//                                             className="mandatory-date-input"
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.city && (
//                                     <div className="mandatory-input-group">
//                                         <label>City <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter city"
//                                             value={mandatoryFormData.city}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, city: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.country && (
//                                     <div className="mandatory-input-group">
//                                         <label>Country <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter country"
//                                             value={mandatoryFormData.country}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, country: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Permanent Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter permanent address"
//                                             value={mandatoryFormData.address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.local_address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Current / Local Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter current / local address"
//                                             value={mandatoryFormData.local_address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, local_address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={mandatorySaving}
//                                 >
//                                     {mandatorySaving ? "Saving Profile..." : "Save Profile & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Dashboard;
















































// working before document module


// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';

// import {
//     ResponsiveContainer,
//     BarChart,
//     Bar,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip
// } from "recharts";
// import { Bar as ChartBar, Pie, Doughnut } from 'react-chartjs-2';

// // ✅ REACT + ROUTER
// import React, { useState, useEffect, useMemo } from 'react';
// import { useParams, useNavigate, useLocation } from 'react-router-dom';

// // ✅ MODULES
// import Attendance from '../../modules/Attendance';
// import PayBenefits from '../../modules/PayBenefits';
// import OKRTracker from '../../modules/OKRTracker';
// import CareerPathways from '../../modules/CareerPathways';
// import EquipmentRequest from '../../modules/EquipmentRequest';
// import OfficeRequisition from '../../modules/OfficeRequisition';
// import ITSupport from '../../modules/ITSupport';
// import Documents from '../../modules/Documents';
// import CompanyPolicy, { GENESIS_POLICIES } from '../../modules/CompanyPolicy';
// import OrgChart from '../../modules/OrgChart';
// import CampusInfo from '../../modules/CampusInfo';
// import AddDepartment from '../../modules/AddDepartment';
// import AddEmployee from '../../modules/AddEmployee';
// import ManageDepartment from '../../modules/ManageDepartment';
// import ManageEmployee from '../../modules/ManageEmployee';
// import MyProfile from '../../modules/MyProfile';
// import LeaveManagement from '../../modules/LeaveManagement';
// import EESExperience from '../../modules/EESExperience';
// import EESFeedbackManagement from '../../modules/EESFeedbackManagement';
// import MedicalReports from '../../modules/MedicalReports';
// import ManagementOKRViewer from '../../modules/ManagementOKRViewer';
// import ManagerLeaveManagement from '../../modules/ManagerLeaveManagement';
// import ManagerMedicalReports from '../../modules/ManagerMedicalReports';
// import EmployeeSalaryBenefits from '../../modules/EmployeeSalaryBenefits';
// import PolicyAdminDashboard from '../../modules/PolicyAdminDashboard';
// import ManageEmployeeDocs from '../../modules/ManageEmployeeDocs';
// import OneOnOne from '../../modules/OneOnOne';
// import EventsCelebrations from '../../modules/EventsCelebrations';
// import ProjectModule from '../../modules/ProjectModule';
// import QuarterlyUpdates from '../../modules/QuarterlyUpdates';
// import ManagementQuarterlyUpdate from '../../modules/ManagementQuarterlyUpdate';
// import ReimbursementManagement from '../../modules/ReimbursementManagement';
// import WorkFromHome from '../../modules/WorkFromHome';
// import WFHManagement from '../../modules/WFHManagement';
// import OneOnOneAnalyticsCard from "../../modules/OneOnOneAnalyticsCard";
// import OneOnOneReport from '../../modules/OneOnOneReport';
// import InvoiceGenerator from '../../modules/InvoiceGenerator';
// import AttendanceTracker from '../../modules/AttendanceTracker';
// import CompanySetup from '../../modules/CompanySetup';
// import AwardNominations from '../../modules/AwardNominations';
// import AwardAnalyticsDashboard from '../../modules/AwardAnalyticsDashboard';
// import Sidebar from "../../components/Sidebar/sidebar";

// // ✅ ASSETS
// import logoLight from '../../assets/logowhite-p.png';
// import logoDark from '../../assets/logo-white-r.png';

// // ✅ STYLES
// import './Dashboard.css';


// // ✅ CHART.JS CORE
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip as ChartTooltip,  // ✅ rename this
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// } from 'chart.js';

// // ✅ REGISTER CHART.JS
// ChartJS.register(
//     ArcElement,
//     ChartTooltip, // ✅ use renamed one
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement
// );



// const QuarterlyCard = ({ handleModuleChange }) => {

//     const [latest, setLatest] = React.useState(null);

//     React.useEffect(() => {
//         fetch(
//             "/gt-api/get_quarterly_media.php?type=ACM Presentation",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "ACM DATA:",
//                     data
//                 );

//                 if (data.success && data.data.length > 0) {
//                     setLatest(data.data[0]);
//                 }
//             })
//             .catch(err => console.error("Quarterly Fetch Error:", err));
//     }, []);

//     console.log("LATEST ACM:", latest);

//     return (
//         <div
//             className="quarterly-pro-card clickable"
//             onClick={() => handleModuleChange("quarterly-updates")}
//         >
//             {/* Glow Layer */}
//             <div className="card-glow"></div>

//             {/* HEADER */}
//             <div className="qp-header">
//                 <div className="qp-left">
//                     <span className="qp-tag">ACM Updates</span>
//                     <h3 className="qp-title">Quarterly Insights</h3>
//                 </div>

//                 <div className="qp-icon">📢</div>
//             </div>

//             {/* BODY */}
//             <div className="qp-body">
//                 {latest ? (
//                     <>
//                         <h4 className="qp-main-title">{latest.title}</h4>

//                         <div className="qp-meta">
//                             <span className="qp-date">
//                                 {new Date(latest.created_at).toLocaleDateString('en-GB')}
//                             </span>
//                             <span className="qp-badge">NEW</span>
//                         </div>
//                     </>
//                 ) : (
//                     <div className="qp-empty">
//                         <div className="qp-loader"></div>
//                         <span>Awaiting next update</span>
//                     </div>
//                 )}
//             </div>

//             {/* FOOTER */}
//             <div className="qp-footer">
//                 <span>View Presentation</span>
//                 <span className="arrow">→</span>
//             </div>
//         </div>
//     );
// };


// const Dashboard = () => {
//     const [dashboardDepartments, setDashboardDepartments] = useState([]);
//     const [dashboardPathways, setDashboardPathways] = useState([]);
//     const [policyCount, setPolicyCount] = useState(0);

//     const [showAIChat, setShowAIChat] = useState(false);

//     const [chatMessages, setChatMessages] = useState([
//         {
//             sender: "ai",
//             text: "Hello 👋 Ask me anything about your ELMS database."
//         }
//     ]);

//     const [chatInput, setChatInput] = useState("");
//     const [chatLoading, setChatLoading] = useState(false);



//     const [showMissedModal, setShowMissedModal] = useState(false);

//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//     const [todayEvents, setTodayEvents] = useState([]);
//     useEffect(() => {
//         const fetchTodayEvents = async () => {
//             try {
//                 const res = await fetch('/gt-api/get_celebrations.php');
//                 const data = await res.json();

//                 if (data.success) {
//                     setTodayEvents(data.data || []);
//                 }
//             } catch (err) {
//                 console.error("Dashboard Events Error:", err);
//             }
//         };

//         fetchTodayEvents();
//     }, []);
//     const [currentEventIndex, setCurrentEventIndex] = useState(0);
//     useEffect(() => {
//         if (!todayEvents || todayEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setCurrentEventIndex((prev) =>
//                 (prev + 1) % todayEvents.length
//             );
//         }, 3000); // change every 3 sec

//         return () => clearInterval(interval);
//     }, [todayEvents]);


//     const [equipmentData, setEquipmentData] = useState({
//         total: 0,
//         pending: 0,
//         blocking: 0
//     });



//     const [logs, setLogs] = useState({});

//     const totalPolicies = 11;
//     const readCount = Object.keys(logs || {}).length;

//     const progress = totalPolicies > 0
//         ? Math.round((readCount / totalPolicies) * 100)
//         : 0;


//     const params = useParams();
//     const module = params.module;

//     const storedUser = JSON.parse(localStorage.getItem("userData"));
//     const role = storedUser?.role;
//     const navigate = useNavigate();

//     useEffect(() => {
//         const storedUser = localStorage.getItem("userData");

//         if (!storedUser) {
//             navigate("/", { replace: true });
//             return;
//         }

//         // prevent back button access after logout
//         window.history.pushState(null, "", window.location.href);
//         window.onpopstate = function () {
//             const user = localStorage.getItem("userData");
//             if (!user) {
//                 navigate("/", { replace: true });
//             }
//         };

//     }, [navigate]);







//     const [policyLogs, setPolicyLogs] = useState({});





//     const checkIfFestivalIsToday = (festival, daysLeftVal, isTodayFlag) => {
//         if (!festival) return false;
//         if (isTodayFlag === true || daysLeftVal === 0) return true;

//         if (festival.date) {
//             const today = new Date();
//             const currentDay = today.getDate();
//             const currentMonth = today.getMonth();
//             const monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
//             const currentMonthName = monthNames[currentMonth];

//             const dateLower = String(festival.date).trim().toLowerCase();

//             // 1. Text Month Matching (e.g., "7th Sep", "7 Sep", "2nd to 10th Oct")
//             if (dateLower.includes(currentMonthName) || (currentMonthName === "sep" && dateLower.includes("sept"))) {
//                 const rangeMatch = dateLower.match(/(\d+)\s*(?:st|nd|rd|th)?\s*to\s*(\d+)\s*(?:st|nd|rd|th)?/);
//                 if (rangeMatch) {
//                     const startDay = parseInt(rangeMatch[1], 10);
//                     const endDay = parseInt(rangeMatch[2], 10);
//                     if (currentDay >= startDay && currentDay <= endDay) {
//                         return true;
//                     }
//                 }

//                 const numbers = dateLower.match(/\d+/g);
//                 if (numbers) {
//                     for (let numStr of numbers) {
//                         const num = parseInt(numStr, 10);
//                         if (num === currentDay) {
//                             return true;
//                         }
//                     }
//                 }
//             }

//             // 2. Numeric Date Matching (e.g., "7-9-2026", "07-09-2026", "7/9/2026", "2026-09-07")
//             const numMatch = dateLower.match(/^(\d{1,4})[-/.](\d{1,2})[-/.](\d{1,4})$/);
//             if (numMatch) {
//                 let p1 = parseInt(numMatch[1], 10);
//                 let p2 = parseInt(numMatch[2], 10);
//                 let p3 = parseInt(numMatch[3], 10);

//                 let d, m;
//                 if (p1 > 31) {
//                     m = p2; d = p3;
//                 } else {
//                     d = p1; m = p2;
//                 }

//                 if (d === currentDay && m === (currentMonth + 1)) {
//                     return true;
//                 }
//             }
//         }

//         if (typeof daysLeftVal === 'number' && daysLeftVal === 0) {
//             return true;
//         }

//         return false;
//     };

//     const [upcomingFestival, setUpcomingFestival] = useState(null);
//     const [daysLeft, setDaysLeft] = useState(null);
//     const [isFestivalToday, setIsFestivalToday] = useState(false);
//     const [activeEventIndex, setActiveEventIndex] = useState(0);
//     useEffect(() => {
//         fetch("/gt-api/get_upcoming_festival.php", {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 const fest = data.festival || data.upcoming || (data.data && data.data[0]);
//                 if (fest) {
//                     const normalized = {
//                         ...fest,
//                         name: fest.name || fest.festival_name || fest.title || "Festival",
//                         image: fest.image || fest.img || fest.imageName || ""
//                     };
//                     setUpcomingFestival(normalized);
//                     setDaysLeft(data.daysLeft ?? 0);
//                     const festIsToday = data.isToday || data.daysLeft === 0 || checkIfFestivalIsToday(normalized, data.daysLeft, data.isToday);
//                     setIsFestivalToday(festIsToday);
//                 }
//             })
//             .catch(err => console.error(err));
//     }, []);


//     const location = useLocation();



//     const [showProfile, setShowProfile] = useState(false);
//     const [showPasswordModal, setShowPasswordModal] = useState(false);
//     const [isEditing, setIsEditing] = useState(false);

//     const [activeModule, setActiveModule] = useState(module || "grid");
//     const [isLightMode, setIsLightMode] = useState(false);

//     const [openMenus, setOpenMenus] = useState({
//         department: false,
//         employee: false
//     });

//     const [pendingRequestsCount, setPendingRequestsCount] = useState(0);
//     const [pendingLeavesCount, setPendingLeavesCount] = useState(0);
//     const [requestsList, setRequestsList] = useState([]);
//     const [notifCount, setNotifCount] = useState(0);

//     const [eesSubmissions, setEesSubmissions] = useState([]);
//     const handleEESSubmit = (newFeedback) => {
//         setEesSubmissions(prev => [...prev, newFeedback]);
//     };

//     const [passwordForm, setPasswordForm] = useState({
//         currentPassword: '',
//         newPassword: '',
//         confirmPassword: ''
//     });

//     const [showMandatoryProfileModal, setShowMandatoryProfileModal] = useState(false);
//     const [missingProfileFields, setMissingProfileFields] = useState({
//         phone: false,
//         dob: false,
//         city: false,
//         address: false,
//         local_address: false,
//         country: false
//     });
//     const [mandatoryFormData, setMandatoryFormData] = useState({
//         phone: '',
//         dob: '',
//         city: '',
//         address: '',
//         local_address: '',
//         country: ''
//     });
//     const [mandatorySaving, setMandatorySaving] = useState(false);
//     const [mandatoryError, setMandatoryError] = useState('');
//     const [mandatorySuccessMsg, setMandatorySuccessMsg] = useState('');

//     // 🔴 MANDATORY BANK DETAILS MODAL STATE
//     const [showMandatoryBankModal, setShowMandatoryBankModal] = useState(false);
//     const [missingBankFields, setMissingBankFields] = useState({
//         bankName: false,
//         holderName: false,
//         accNumber: false,
//         ifsc: false,
//         branch: false,
//         accType: false
//     });
//     const [bankFormData, setBankFormData] = useState({
//         bankName: '',
//         holderName: '',
//         accNumber: '',
//         ifsc: '',
//         branch: '',
//         accType: 'Saving Account'
//     });
//     const [bankSaving, setBankSaving] = useState(false);
//     const [bankError, setBankError] = useState('');
//     const [bankSuccessMsg, setBankSuccessMsg] = useState('');

//     // 📜 MANDATORY COMPANY POLICY ACKNOWLEDGEMENT MODAL STATE
//     const [showMandatoryPolicyModal, setShowMandatoryPolicyModal] = useState(false);
//     const [allPoliciesList, setAllPoliciesList] = useState([]);
//     const [unacknowledgedPolicies, setUnacknowledgedPolicies] = useState([]);
//     const [selectedMandatoryPolicy, setSelectedMandatoryPolicy] = useState(null);
//     const [policyAckSaving, setPolicyAckSaving] = useState(false);
//     const [policyAckError, setPolicyAckError] = useState('');
//     const [policyAckSuccessMsg, setPolicyAckSuccessMsg] = useState('');
//     const [totalPoliciesCount, setTotalPoliciesCount] = useState(11);
//     const [acknowledgedPoliciesCount, setAcknowledgedPoliciesCount] = useState(0);
//     const [policyAgreed, setPolicyAgreed] = useState(false);




//     const [userData, setUserData] = useState(() => {
//         const storedData = localStorage.getItem("userData");
//         if (storedData) return JSON.parse(storedData);

//         const firstName = location.state?.userName?.split(' ')[0] || "User";
//         const lastName = location.state?.userName?.split(' ')[1] || "";

//         return {
//             firstName,
//             lastName,
//             email: "",
//             dept: "Loading...",
//             phone: "",
//             gender: "",
//             dob: "",
//             address: "",
//             city: "",
//             country: "",
//             employeeId: location.state?.empId || null,
//             profileImage: null,
//             joiningDate: null,
//             HOD: null
//         };
//     });


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_career_pathways.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setDashboardPathways(
//                         data.pathways || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_departments.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 console.log(
//                     "DASHBOARD DEPARTMENTS:",
//                     data
//                 );

//                 if (data.success) {

//                     setDashboardDepartments(
//                         data.departments || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);


//     useEffect(() => {

//         const email =
//             userData?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) {

//             setPolicyCount(11);
//             return;

//         }

//         fetch(
//             "/gt-api/get_policies.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setPolicyCount(
//                         data.policies?.length || 0
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, [userData]);
//     // ✅ THEN use it
//     const employeeId = userData?.id || userData?.employeeId;


//     useEffect(() => {
//         const fetchLeaveDashboardData = async () => {
//             if (!employeeId) return;

//             try {
//                 const res = await fetch(`/gt-api/get_leaves.php?empid=${employeeId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 const wfhRes = await fetch(`/gt-api/get_wfh.php?empid=${employeeId}`, {
//                     credentials: "include"
//                 });
//                 const wfhData = await wfhRes.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];

//                     // 🔥 SAME LOGIC AS ATTENDANCE
//                     const today = new Date();
//                     const currentYear = today.getFullYear();

//                     const fiscalYearStart = new Date(currentYear, 3, 1);

//                     const activeFiscalYearStart =
//                         today < fiscalYearStart
//                             ? new Date(currentYear - 1, 3, 1)
//                             : fiscalYearStart;

//                     // ✅ Dynamic Sick Total (joining based)
//                     let sickTotal = 12;

//                     if (userData?.joiningDate) {
//                         const joining = new Date(userData.joiningDate);

//                         const fyEnd = new Date(activeFiscalYearStart);
//                         fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
//                         fyEnd.setMonth(2);
//                         fyEnd.setDate(31);

//                         if (joining > activeFiscalYearStart) {
//                             if (joining > fyEnd) {
//                                 sickTotal = 0;
//                             } else {
//                                 const joinMonth = joining.getMonth();
//                                 const fyEndMonth = 2;

//                                 let monthsRemaining;

//                                 if (joinMonth <= fyEndMonth) {
//                                     monthsRemaining = fyEndMonth - joinMonth + 1;
//                                 } else {
//                                     monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
//                                 }

//                                 sickTotal = monthsRemaining;
//                             }
//                         }
//                     }

//                     let sickUsed = 0;
//                     let earnedUsed = 0;

//                     leaves.forEach(leave => {
//                         const status = String(leave.Status);
//                         const days = parseFloat(leave.total) || 0;
//                         const leaveDate = new Date(leave.fromdate);
//                         const medStatus = String(leave.medical_doc_status);

//                         // ✅ SAME CONDITION AS ATTENDANCE
//                         if (status === '0' || status === '1') {

//                             if (leave.leavetype === 'Sick Leave') {
//                                 if (leaveDate >= activeFiscalYearStart) {
//                                     sickUsed += days;
//                                 }
//                             }

//                             else if (leave.leavetype === 'Earned Leave') {

//                                 // 🔥 MEDICAL CONVERSION LOGIC
//                                 if (medStatus === '1' || medStatus === '0') {
//                                     if (leaveDate >= activeFiscalYearStart) {
//                                         sickUsed += days;
//                                     }
//                                 } else {
//                                     earnedUsed += days;
//                                 }
//                             }
//                         }
//                     });


//                     console.log("LEAVES:", leaves);
//                     console.log("SICK USED:", sickUsed);
//                     console.log("EARNED USED:", earnedUsed);
//                     console.log("API EARNED BALANCE:", data.earned);

//                     setLeaveData({
//                         leaveHistory: leaves,
//                         leaveBalances: {
//                             sick: { used: sickUsed, total: sickTotal },
//                             earned: { used: earnedUsed, total: parseFloat(data.earned) || 0 }
//                         },
//                         wfhHistory: wfhData.requests || []
//                     });
//                 }

//             } catch (err) {
//                 console.error("Dashboard Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaveDashboardData();
//     }, [employeeId, userData?.joiningDate]);


//     useEffect(() => {
//         setActiveModule(module || "grid");
//     }, [module]);

//     useEffect(() => {

//         if (role === 'Management' || role === 'Manager') {

//             const fetchRealTimeLeaves = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_leaves.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {
//                         // Count requests with Status '0' or null
//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };


//             fetchRealTimeLeaves();


//             const liveInterval = setInterval(fetchRealTimeLeaves, 5000);

//             return () => clearInterval(liveInterval);
//         }
//     }, [role]);



//     useEffect(() => {

//         const fetchUserData = async () => {

//             try {

//                 const response = await fetch("/gt-api/get_profile.php", {
//                     credentials: "include"
//                 });

//                 const data = await response.json();

//                 if (data.success && data.employee) {

//                     const storedUser = JSON.parse(localStorage.getItem("userData"));

//                     const updatedUser = {
//                         id: data.employee.id,
//                         EmpId: data.employee.EmpId,

//                         firstName: data.employee.FirstName,
//                         FirstName: data.employee.FirstName,

//                         lastName: data.employee.LastName,
//                         LastName: data.employee.LastName,

//                         email: data.employee.EmailId,
//                         EmailId: data.employee.EmailId,

//                         Department: data.employee.DepartmentName || data.employee.Department,

//                         HOD: data.employee.HOD,
//                         Designation: data.employee.Designation,
//                         phone: data.employee.Phonenumber,
//                         gender: data.employee.Gender,
//                         dob: data.employee.Dob,
//                         address: data.employee.Address,
//                         local_address: data.employee.LocalAddress,
//                         city: data.employee.City,
//                         country: data.employee.Country,
//                         profileImage: data.employee.ProfilePicture || null,
//                         joiningDate: data.employee.JoiningDate,
//                         probation_status: data.employee.probation_status || 'Probation',
//                         probation_feedback_sent_at: data.employee.probation_feedback_sent_at || null,
//                         probation_feedback_sent_by: data.employee.probation_feedback_sent_by || null,

//                         role: storedUser?.role
//                     };

//                     setUserData(updatedUser);

//                     localStorage.setItem("userData", JSON.stringify(updatedUser));

//                     // ✅ CHECK ONLY MISSING MANDATORY PROFILE FIELDS
//                     const isMissing = (val) => !val || String(val).trim() === '' || String(val).trim() === '0000-00-00';
//                     const missing = {
//                         phone: isMissing(updatedUser.phone),
//                         dob: isMissing(updatedUser.dob),
//                         city: isMissing(updatedUser.city),
//                         address: isMissing(updatedUser.address),
//                         local_address: isMissing(updatedUser.local_address),
//                         country: isMissing(updatedUser.country)
//                     };

//                     if (Object.values(missing).some(Boolean)) {
//                         setMissingProfileFields(missing);
//                         setMandatoryFormData({
//                             phone: updatedUser.phone || '',
//                             dob: updatedUser.dob || '',
//                             city: updatedUser.city || '',
//                             address: updatedUser.address || '',
//                             local_address: updatedUser.local_address || '',
//                             country: updatedUser.country || ''
//                         });
//                         setShowMandatoryProfileModal(true);
//                     }

//                     // 🏦 CHECK MANDATORY BANK DETAILS
//                     const empIdForBank = data.employee.id || data.employee.EmpId;
//                     if (empIdForBank) {
//                         let bank = null;
//                         try {
//                             const bankRes = await fetch(`/gt-api/get_bank_details.php?emp_id=${empIdForBank}`, {
//                                 credentials: "include"
//                             });
//                             const rawText = await bankRes.text();
//                             try {
//                                 const json = JSON.parse(rawText);
//                                 if (json && (json.success || json.bank || json.bank_name || json.bankName)) {
//                                     bank = json.bank || json.data || json.details || json.employee_bank_details || json;
//                                 }
//                             } catch (parseErr) {
//                                 console.log("get_bank_details json parse error:", parseErr);
//                             }
//                         } catch (bErr) {
//                             console.error("Bank details fetch network error:", bErr);
//                         }

//                         const b = bank || {};

//                         const getVal = (...keys) => {
//                             for (const k of keys) {
//                                 if (b[k] !== undefined && b[k] !== null && String(b[k]).trim() !== '') {
//                                     return String(b[k]).trim();
//                                 }
//                             }
//                             return '';
//                         };

//                         const bankNameVal = getVal('bankName', 'bank_name', 'BankName', 'Bankname');
//                         const holderNameVal = getVal('holderName', 'holder_name', 'HolderName', 'account_holder_name', 'AccountHolderName');
//                         const accNumberVal = getVal('accNumber', 'account_number', 'AccountNumber', 'AccNumber', 'account_no', 'AccountNo');
//                         const ifscVal = getVal('ifsc', 'ifsc_code', 'IFSC', 'Ifsc', 'IfscCode');
//                         const branchVal = getVal('branch', 'branch_name', 'Branch', 'BranchName');
//                         const accTypeVal = getVal('accType', 'account_type', 'AccountType', 'AccType');

//                         const isBankMissing = (val) => !val || String(val).trim() === '';

//                         const missingBank = {
//                             bankName: isBankMissing(bankNameVal),
//                             holderName: isBankMissing(holderNameVal),
//                             accNumber: isBankMissing(accNumberVal),
//                             ifsc: isBankMissing(ifscVal),
//                             branch: isBankMissing(branchVal),
//                             accType: isBankMissing(accTypeVal)
//                         };

//                         console.log("MANDATORY BANK CHECK RESULT:", { empId: empIdForBank, bankData: b, missingBank });

//                         if (Object.values(missingBank).some(Boolean)) {
//                             setMissingBankFields(missingBank);
//                             setBankFormData({
//                                 bankName: bankNameVal,
//                                 holderName: holderNameVal || `${data.employee.FirstName || ''} ${data.employee.LastName || ''}`.trim(),
//                                 accNumber: bankNameVal ? accNumberVal : '',
//                                 ifsc: ifscVal,
//                                 branch: branchVal,
//                                 accType: accTypeVal || 'Saving Account'
//                             });
//                             setShowMandatoryBankModal(true);
//                         }
//                     }

//                     // 📜 CHECK MANDATORY POLICY ACKNOWLEDGEMENTS
//                     const empIdForPolicy = data.employee.EmpId || data.employee.id || data.employee.employeeId;
//                     if (empIdForPolicy) {
//                         try {
//                             const email = data.employee.EmailId || storedUser?.email || "";
//                             const isGenesis =
//                                 email.toLowerCase().includes("genesistech.co.in") ||
//                                 email.toLowerCase().includes("gtecorpgroup.com") ||
//                                 email.toLowerCase().includes("gtcorpgroup.com");

//                             let allPolicyList = [];
//                             if (isGenesis) {
//                                 allPolicyList = GENESIS_POLICIES;
//                             } else {
//                                 try {
//                                     const pRes = await fetch("/gt-api/get_policies.php", { credentials: "include" });
//                                     const pData = await pRes.json();
//                                     if (pData.success && Array.isArray(pData.policies) && pData.policies.length > 0) {
//                                         allPolicyList = pData.policies.map((p, idx) => ({
//                                             id: p.id || idx + 1,
//                                             title: p.policy_title || p.title,
//                                             icon: p.policy_icon || p.icon || "📜",
//                                             content: p.content || p.policy_content || null
//                                         }));
//                                     } else {
//                                         allPolicyList = GENESIS_POLICIES;
//                                     }
//                                 } catch (pErr) {
//                                     allPolicyList = GENESIS_POLICIES;
//                                 }
//                             }

//                             const logRes = await fetch(`/gt-api/acknowledgepolicy.php?empId=${empIdForPolicy}`, {
//                                 credentials: "include"
//                             });
//                             const logData = await logRes.json();
//                             const logsArray = Array.isArray(logData?.logs) ? logData.logs : [];
//                             const logsMap = logsArray.reduce((acc, curr) => {
//                                 if (curr?.policy_title) {
//                                     acc[curr.policy_title] = true;
//                                 }
//                                 return acc;
//                             }, {});

//                             setLogs(logsMap);
//                             setAllPoliciesList(allPolicyList);

//                             const unack = allPolicyList.filter(p => !logsMap[p.title || p.policy_title]);
//                             setTotalPoliciesCount(allPolicyList.length);
//                             setAcknowledgedPoliciesCount(allPolicyList.length - unack.length);

//                             if (unack.length > 0) {
//                                 setUnacknowledgedPolicies(unack);
//                                 setSelectedMandatoryPolicy(unack[0]);
//                                 setShowMandatoryPolicyModal(true);
//                             }
//                         } catch (polErr) {
//                             console.error("Mandatory policy check error:", polErr);
//                         }
//                     }
//                 }

//             } catch (error) {
//                 console.error("Database Error:", error);
//             }

//         };

//         fetchUserData();

//     }, []);

//     // 🔒 LOCK BODY SCROLL WHEN MANDATORY MODAL IS OPEN
//     useEffect(() => {
//         if (showMandatoryProfileModal || showMandatoryBankModal || showMandatoryPolicyModal) {
//             document.body.style.overflow = 'hidden';
//             document.documentElement.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         }
//         return () => {
//             document.body.style.overflow = '';
//             document.documentElement.style.overflow = '';
//         };
//     }, [showMandatoryProfileModal, showMandatoryBankModal, showMandatoryPolicyModal]);

//     const handleAcknowledgeMandatoryPolicy = async (e) => {
//         if (e && e.preventDefault) e.preventDefault();
//         if (!selectedMandatoryPolicy) return;
//         const targetTitle = selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title;
//         if (!targetTitle) return;

//         setPolicyAckError('');
//         setPolicyAckSaving(true);

//         try {
//             const empBadgeId = userData?.EmpId || userData?.employeeId || userData?.id;
//             const fullName = `${userData?.FirstName || userData?.firstName || ''} ${userData?.LastName || userData?.lastName || ''}`.trim();

//             const response = await fetch("/gt-api/acknowledgepolicy.php", {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     empId: empBadgeId,
//                     fullName: fullName,
//                     policyTitle: targetTitle
//                 }),
//             });

//             const result = await response.json();
//             if (result.status === "success" || result.success) {
//                 setPolicyAckSuccessMsg(`Policy "${targetTitle}" acknowledged successfully!`);

//                 setLogs(prev => ({ ...prev, [targetTitle]: true }));

//                 const remaining = unacknowledgedPolicies.filter(
//                     p => (p.title || p.policy_title) !== targetTitle
//                 );
//                 setUnacknowledgedPolicies(remaining);
//                 setAcknowledgedPoliciesCount(prev => prev + 1);
//                 setPolicyAgreed(false);

//                 setTimeout(() => {
//                     setPolicyAckSuccessMsg('');
//                     if (remaining.length > 0) {
//                         setSelectedMandatoryPolicy(remaining[0]);
//                     } else {
//                         setShowMandatoryPolicyModal(false);
//                     }
//                 }, 1000);
//             } else {
//                 setPolicyAckError(result.message || "Could not save policy acknowledgement.");
//             }
//         } catch (err) {
//             console.error("Policy ack error:", err);
//             setPolicyAckError("Failed to connect to server to record policy acknowledgement.");
//         } finally {
//             setPolicyAckSaving(false);
//         }
//     };

//     const handleSaveMandatoryProfile = async (e) => {
//         e.preventDefault();
//         setMandatoryError('');

//         const { phone, dob, city, address, local_address, country } = mandatoryFormData;

//         if (missingProfileFields.phone && (!phone || !phone.trim())) {
//             setMandatoryError('Please enter your Mobile Number.');
//             return;
//         }
//         if (missingProfileFields.dob && (!dob || !dob.trim() || dob === '0000-00-00')) {
//             setMandatoryError('Please select your Date of Birth.');
//             return;
//         }
//         if (missingProfileFields.city && (!city || !city.trim())) {
//             setMandatoryError('Please enter your City.');
//             return;
//         }
//         if (missingProfileFields.country && (!country || !country.trim())) {
//             setMandatoryError('Please enter your Country.');
//             return;
//         }
//         if (missingProfileFields.address && (!address || !address.trim())) {
//             setMandatoryError('Please enter your Permanent Address.');
//             return;
//         }
//         if (missingProfileFields.local_address && (!local_address || !local_address.trim())) {
//             setMandatoryError('Please enter your Current / Local Address.');
//             return;
//         }

//         setMandatorySaving(true);
//         try {
//             const payload = {
//                 id: userData.id,
//                 EmpId: userData.EmpId,
//                 Phonenumber: (phone || userData.phone || '').trim(),
//                 Dob: (dob || userData.dob || '').trim(),
//                 City: (city || userData.city || '').trim(),
//                 Address: (address || userData.address || '').trim(),
//                 LocalAddress: (local_address || userData.local_address || '').trim(),
//                 Country: (country || userData.country || '').trim(),
//                 Gender: userData.gender || '',
//                 ProfilePicture: userData.profileImage || null
//             };

//             const res = await fetch("/gt-api/update_profile.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 const updatedUser = {
//                     ...userData,
//                     phone: phone.trim(),
//                     dob: dob.trim(),
//                     city: city.trim(),
//                     address: address.trim(),
//                     local_address: local_address.trim(),
//                     country: country.trim()
//                 };
//                 setUserData(updatedUser);
//                 localStorage.setItem("userData", JSON.stringify(updatedUser));
//                 setMandatorySuccessMsg("🎉 Profile information updated! You may now use the system.");
//                 setTimeout(() => {
//                     setShowMandatoryProfileModal(false);
//                     setMandatorySuccessMsg('');
//                 }, 1200);
//             } else {
//                 setMandatoryError(result.message || "Failed to update profile. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory profile update error:", err);
//             setMandatoryError("Connection error. Ensure backend API is running.");
//         } finally {
//             setMandatorySaving(false);
//         }
//     };

//     const handleSaveMandatoryBankDetails = async (e) => {
//         e.preventDefault();
//         setBankError('');

//         const { bankName, holderName, accNumber, ifsc, branch, accType } = bankFormData;

//         if (missingBankFields.bankName && (!bankName || !bankName.trim())) {
//             setBankError('Please enter Bank Name.');
//             return;
//         }
//         if (missingBankFields.holderName && (!holderName || !holderName.trim())) {
//             setBankError('Please enter Account Holder Name.');
//             return;
//         }
//         if (missingBankFields.accNumber && (!accNumber || !accNumber.trim())) {
//             setBankError('Please enter Bank Account Number.');
//             return;
//         }
//         if (missingBankFields.ifsc && (!ifsc || !ifsc.trim())) {
//             setBankError('Please enter IFSC Code.');
//             return;
//         }
//         if (missingBankFields.branch && (!branch || !branch.trim())) {
//             setBankError('Please enter Branch Name.');
//             return;
//         }
//         if (missingBankFields.accType && (!accType || !accType.trim())) {
//             setBankError('Please select Account Type.');
//             return;
//         }

//         setBankSaving(true);
//         try {
//             const payload = {
//                 emp_id: userData.id || userData.employeeId || userData.EmpId,
//                 emp_number: userData.EmpId || userData.employeeId,
//                 bankName: bankName.trim(),
//                 bank_name: bankName.trim(),
//                 holderName: holderName.trim(),
//                 account_holder_name: holderName.trim(),
//                 accNumber: accNumber.trim(),
//                 account_number: accNumber.trim(),
//                 ifsc: ifsc.trim(),
//                 ifsc_code: ifsc.trim(),
//                 branch: branch.trim(),
//                 branch_name: branch.trim(),
//                 accType: accType.trim(),
//                 account_type: accType.trim()
//             };

//             const res = await fetch("/gt-api/save_bank_details.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });

//             const result = await res.json();
//             if (result.success) {
//                 setBankSuccessMsg("🎉 Bank details updated successfully!");
//                 setTimeout(() => {
//                     setShowMandatoryBankModal(false);
//                     setBankSuccessMsg('');
//                 }, 1200);
//             } else {
//                 setBankError(result.message || "Failed to save bank details. Please try again.");
//             }
//         } catch (err) {
//             console.error("Mandatory bank details update error:", err);
//             setBankError("Connection error. Ensure backend API is running.");
//         } finally {
//             setBankSaving(false);
//         }
//     };




//     // const employeeId = userData.id || userData.employeeId;

//     const toggleSubMenu = (menu) => {
//         setOpenMenus(prev => ({ ...prev, [menu]: !prev[menu] }));
//     };

//     useEffect(() => {
//         const checkNotifications = () => {
//             if (role !== 'Management' && userData?.employeeId) {
//                 fetch(`/gt-api/clear_notifications.php?employee_id=${userData.employeeId}`)
//                     .then(res => res.json())
//                     .then(data => {
//                         if (data.success) setNotifCount(data.count);
//                     })
//                     .catch(err => console.error("Notif Fetch Error:", err));
//             }
//         };
//         checkNotifications();
//         const interval = setInterval(checkNotifications, 30000);
//         return () => clearInterval(interval);
//     }, [userData.employeeId, role]);

//     useEffect(() => {
//         if (role === 'Management' || role === 'Manager') {
//             const fetchRealTimeLeaves = async () => {
//                 try {
//                     // Determine which API to call based on Role
//                     // Managers should call the specific manager-leaves API using their ID
//                     const url = role === 'Management'
//                         ? "/gt-api/get_all_leaves.php"
//                         : `/gt-api/get_manager_leaves.php?managerId=${userData.id || location.state?.empId}`;

//                     // const res = await fetch(url);
//                     const res = await fetch(url, {
//                         credentials: "include"
//                     });
//                     const data = await res.json();

//                     if (data.success && data.leaves) {

//                         const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                         setPendingLeavesCount(count);
//                     }
//                 } catch (err) {
//                     console.error("Real-time Fetch Error:", err);
//                 }
//             };

//             // Only fetch if we have the ID for the Manager, or if role is Management
//             if (role === 'Management' || (role === 'Manager' && (userData.id || location.state?.empId))) {
//                 fetchRealTimeLeaves();
//                 const liveInterval = setInterval(fetchRealTimeLeaves, 5000);
//                 return () => clearInterval(liveInterval);
//             }
//         }
//     }, [role, userData.id, location.state?.empId]);

//     const handleStatusUpdate = async (id, newStatus) => {
//         try {
//             const response = await fetch("/gt-api/update_request_status.php", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ id, status: newStatus }),
//             });
//             const data = await response.json();
//             if (data.success) {
//                 setRequestsList(prev => prev.map(req => req.id === id ? { ...req, status: newStatus } : req));
//                 setPendingRequestsCount(prev => Math.max(0, prev - 1));
//                 alert(`Request ${newStatus} successfully!`);
//             }
//         } catch (error) {
//             console.error("Update error:", error);
//         }
//     };

//     ;


//     const sendAIMessage = async () => {
//         if (!chatInput.trim()) return;

//         const userMessage = {
//             sender: "user",
//             text: chatInput
//         };

//         setChatMessages(prev => [...prev, userMessage]);
//         setChatLoading(true);

//         try {
//             const res = await fetch("/gt-api/chatbot.php", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     question: chatInput
//                 })
//             });

//             const data = await res.json();

//             let aiReply = "No response.";

//             if (data.success) {
//                 aiReply = data.reply || "No response.";
//             } else {
//                 aiReply = data.message || "Something went wrong.";
//             }
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: aiReply
//                 }
//             ]);

//         } catch (err) {
//             setChatMessages(prev => [
//                 ...prev,
//                 {
//                     sender: "ai",
//                     text: "Server error."
//                 }
//             ]);
//         }

//         setChatInput("");
//         setChatLoading(false);
//     };
//     const handleModuleChange = (slug, extraData = null) => {
//         navigate(`/dashboard/${role}/${slug}`, {
//             state:
//                 extraData && typeof extraData === "object"
//                     ? extraData
//                     : { selectedPathway: extraData }
//         });
//     };

//     const handlePasswordSubmit = (e) => {
//         e.preventDefault();
//         if (passwordForm.newPassword !== passwordForm.confirmPassword) {
//             alert("New passwords do not match!");
//             return;
//         }
//         alert("Encryption Key Updated Successfully!");
//         setShowPasswordModal(false);
//     };

//     const handleSave = () => {
//         setIsEditing(false);
//         alert("Profile changes synchronized!");
//     };

//     // Ensure only ONE instance of this exists in your file
//     const [theme, setTheme] = useState(localStorage.getItem('dashboard-theme') || 'dark');

//     useEffect(() => {
//         document.documentElement.setAttribute('data-theme', theme);
//         localStorage.setItem('dashboard-theme', theme);
//         if (theme === 'dark') {
//             document.body.classList.remove('light-mode', 'light-theme');
//             document.documentElement.classList.remove('light-mode', 'light-theme');
//             document.body.classList.add('dark-theme');
//             document.documentElement.classList.add('dark-theme');
//         } else {
//             document.body.classList.remove('dark-mode', 'dark-theme');
//             document.documentElement.classList.remove('dark-mode', 'dark-theme');
//             document.body.classList.add('light-theme');
//             document.documentElement.classList.add('light-theme');
//         }
//     }, [theme]);

//     const toggleTheme = () => {
//         setTheme(prev => prev === 'dark' ? 'light' : 'dark');
//     };
//     useEffect(() => {

//         const handlePageShow = (event) => {
//             if (event.persisted) {
//                 const user = localStorage.getItem("userData");
//                 if (!user) {
//                     window.location.replace("/");
//                 }
//             }
//         };

//         window.addEventListener("pageshow", handlePageShow);

//         return () => window.removeEventListener("pageshow", handlePageShow);

//     }, []);
//     useEffect(() => {
//         if (role === 'Management') {
//             const fetchEquipmentCount = async () => {
//                 try {

//                     const res = await fetch("/gt-api/get_all_equip_request.php", {
//                         credentials: "include"
//                     });
//                     const data = await res.json();
//                     if (data.success && data.requests) {
//                         const count = data.requests.filter(r => r.status?.toLowerCase() === 'pending').length;
//                         setPendingRequestsCount(count);
//                         setRequestsList(data.requests);
//                     }
//                 } catch (err) {
//                     console.error("Equipment Fetch Error:", err);
//                 }
//             };

//             fetchEquipmentCount();
//             const interval = setInterval(fetchEquipmentCount, 10000);
//             return () => clearInterval(interval);
//         }
//     }, [role]);




//     const [payData, setPayData] = useState([]);

//     useEffect(() => {

//         // 🔥 MANAGEMENT DASHBOARD
//         if (role === "Management") {

//             const fetchAllDocs = () => {
//                 fetch("/gt-api/get_all_salary_documents.php", {
//                     credentials: "include"
//                 })
//                     .then(res => res.json())
//                     .then(data => {
//                         console.log("MGMT DATA:", data);

//                         if (data.success) {

//                             setPayData(data.documents);
//                         }
//                     })
//                     .catch(err => console.error("Management Fetch Error:", err));
//             };

//             fetchAllDocs();

//             const interval = setInterval(fetchAllDocs, 5000);

//             return () => clearInterval(interval);
//         }

//         // 👤 EMPLOYEE DASHBOARD
//         if (employeeId) {
//             fetch(`/gt-api/get_my_documents.php?emp_id=${employeeId}`, {
//                 credentials: "include"
//             })
//                 .then(res => res.json())
//                 .then(data => {
//                     console.log("EMP DATA:", data);

//                     if (data.success) {
//                         setPayData(data.documents);
//                     }
//                 })
//                 .catch(err => console.error("Employee Fetch Error:", err));
//         }

//     }, [role, employeeId]);





//     const renderPayChart = () => {
//         const safePayData = payData || [];

//         const payslips = safePayData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = safePayData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = safePayData.filter(d => d.doc_type === "APPRAISAL LETTER").length;
//         const totalDocs = payslips + form16 + appraisal;

//         return (
//             <div className="pay-ultra-card" onClick={() => handleModuleChange("pay and benefits")}>
//                 <div className="card-inner">
//                     {/* Top Section */}
//                     <div className="pay-header">
//                         <div className="pay-icon-wrapper">
//                             <div className="pay-icon-glow"></div>
//                             <span className="main-icon">📄</span>
//                         </div>
//                         <div className="pay-total-info">
//                             <h3>Pay & Benefits</h3>
//                             <p>{totalDocs} Total Documents</p>
//                         </div>
//                     </div>

//                     {/* Distribution */}
//                     <div className="distribution-container">
//                         <div className="distribution-label">
//                             <span>Vault Composition</span>
//                             <span className="percentage">
//                                 {totalDocs > 0 ? "100%" : "0%"}
//                             </span>
//                         </div>

//                         <div className="multi-progress-bar">
//                             {totalDocs > 0 ? (
//                                 <>
//                                     <div
//                                         className="segment green"
//                                         style={{ flex: payslips, backgroundColor: '#22c55e' }}
//                                     ></div>
//                                     <div
//                                         className="segment blue"
//                                         style={{ flex: form16, backgroundColor: '#3b82f6' }}
//                                     ></div>
//                                     <div
//                                         className="segment amber"
//                                         style={{ flex: appraisal, backgroundColor: '#f59e0b' }}
//                                     ></div>
//                                 </>
//                             ) : (
//                                 <div
//                                     style={{
//                                         width: "100%",
//                                         height: "100%",
//                                         backgroundColor: "#e5e7eb",
//                                         borderRadius: "10px"
//                                     }}
//                                 ></div>
//                             )}
//                         </div>
//                     </div>

//                     {/* List */}
//                     <div className="pay-list">
//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator green"></span>
//                                 <span className="name">Monthly Payslips</span>
//                             </div>
//                             <span className="count-badge">{payslips}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator blue"></span>
//                                 <span className="name">Tax Form 16</span>
//                             </div>
//                             <span className="count-badge">{form16}</span>
//                         </div>

//                         <div className="list-item">
//                             <div className="item-left">
//                                 <span className="indicator amber"></span>
//                                 <span className="name">Appraisal Letter</span>
//                             </div>
//                             <span className="count-badge">{appraisal}</span>
//                         </div>
//                     </div>

//                     <div className="pay-footer">
//                         <span>Explore Document</span>
//                         <span className="arrow-icon">→</span>
//                     </div>

//                     <div className="reimburse-cta-wrapper">
//                         <button
//                             className="reimburse-btn"
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleModuleChange("supplies");
//                             }}
//                         >
//                             Click here for Reimbursement Form
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };



//     const renderLeavePieChart = () => {
//         const PUBLIC_HOLIDAYS = [
//             '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//             '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//         ];

//         const isWorkDay = (date) => {
//             const day = date.getDay();
//             const dateString = date.toISOString().split('T')[0];
//             return !(day === 0 || day === 6) && !PUBLIC_HOLIDAYS.includes(dateString);
//         };

//         if (!leaveData || !leaveData.leaveBalances) return null;

//         const sickUsed = leaveData.leaveBalances.sick.used || 0;
//         const earnedUsed = leaveData.leaveBalances.earned.used || 0;
//         const wfhCount = leaveData.wfhHistory.reduce((total, wfh) => {
//             const start = new Date(wfh.start);
//             const end = new Date(wfh.end);
//             let days = 0;
//             let current = new Date(start);
//             while (current <= end) {
//                 if (isWorkDay(current)) days++;
//                 current.setDate(current.getDate() + 1);
//             }
//             return total + days;
//         }, 0);

//         const totalUsed = sickUsed + earnedUsed;

//         // Determine max for scaling bars (minimum scale of 10)
//         const maxVal = Math.max(sickUsed, earnedUsed, wfhCount, 10);
//         return (

//             <div
//                 className={`elite-podium-card leave-analytics-card ${theme === 'dark' ? 'dark-variant' : 'light-theme'}`}
//                 onClick={() => handleModuleChange("attendance")}
//             >

//                 <div className="card-header-v3">
//                     <div className="title-group">

//                         <h2 className="main-title">Leave Overview</h2>
//                     </div>
//                     <div className="year-tag">2026</div>
//                 </div>

//                 <div className="podium-content">
//                     {/* VERTICAL BAR SECTION - Made prominent */}
//                     <div className="bar-podium-large">
//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill sick" style={{ height: `${(sickUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">SICK</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill earned" style={{ height: `${(earnedUsed / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">EARNED</span>
//                         </div>

//                         <div className="mega-pillar">
//                             <div className="mega-track">
//                                 <div className="mega-fill wfh" style={{ height: `${(wfhCount / maxVal) * 100}%` }}></div>
//                             </div>
//                             <span className="mega-label">WFH</span>
//                         </div>
//                     </div>

//                     {/* KPI SIDEBAR - Cleaned up to match image 1's style */}
//                     <div className="kpi-sidebar-compact">
//                         <div className="total-display">
//                             <span className="total-val">{totalUsed}</span>
//                             <span className="total-sub">Days Off-Site</span>
//                         </div>

//                         <div className="status-legend">
//                             <div className="legend-row">
//                                 <span className="indicator sick"></span>
//                                 <span>{sickUsed} Sick</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator earned"></span>
//                                 <span>{earnedUsed} Earned</span>
//                             </div>
//                             <div className="legend-row">
//                                 <span className="indicator wfh"></span>
//                                 <span>{wfhCount} WFH</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="card-footer-v3">
//                     <div className="sync-info">
//                         <span className="status-glow"></span>
//                         Annual Summary Active
//                     </div>
//                     <button className="details-btn">VIEW DETAILS →</button>
//                 </div>
//             </div>
//         );
//     };

//     const [leaveData, setLeaveData] = useState({
//         leaveHistory: [],
//         leaveBalances: {
//             sick: { used: 0, total: 0 },
//             earned: { used: 0, total: 0 }
//         },
//         wfhHistory: []
//     });


//     const [managementNotices, setManagementNotices] = useState({
//         reviews: [],
//         probations: []
//     });

//     useEffect(() => {
//         const fetchNotices = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/get_manager_feedback.php?empId=${userData.EmpId}`
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     setManagementNotices({
//                         reviews: data.reviews || [],
//                         probations: data.probations || []
//                     });
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchNotices();
//     }, [userData]);





//     const renderEquipmentCard = () => {
//         const { total, approved, rejected, pending } = equipmentData;

//         return (
//             <div className="equipment-ultra-card clickable" onClick={() => handleModuleChange("equipment-request")}>
//                 <div className="equip-header">
//                     <div className="equip-icon-box">💻</div>
//                     <div className="equip-title-group">
//                         <span className="equip-label">Hardware</span>
//                         <h3 className="equip-title">Requests</h3>
//                     </div>
//                 </div>

//                 <div className="equip-main-stat">
//                     <span className="total-count">{total}</span>
//                     <span className="total-label">Submissions</span>
//                 </div>

//                 <div className="equip-progress-bar">
//                     <div className="bar-fill approved" style={{ width: `${(approved / total) * 100}%` }}></div>
//                     <div className="bar-fill pending" style={{ width: `${(pending / total) * 100}%` }}></div>
//                 </div>

//                 <div className="equip-stats-list">
//                     <div className="equip-item">
//                         <span className="dot approved"></span>
//                         <span className="item-name">Approved</span>
//                         <span className="item-val">{approved}</span>
//                     </div>
//                     <div className="equip-item">
//                         <span className="dot pending"></span>
//                         <span className="item-name">Pending</span>
//                         <span className="item-val text-warning">{pending}</span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     useEffect(() => {
//         const empIdForFetch = userData?.EmpId || userData?.employeeId;

//         if (!empIdForFetch) return;

//         fetch(`/gt-api/get_all_equip_request.php?employee_id=${empIdForFetch}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log("EQUIPMENT API RESPONSE:", data);
//                 if (data.success && data.requests) {

//                     const requests = data.requests;

//                     const approved = requests.filter(r =>
//                         r.status?.toLowerCase() === "approved"
//                     ).length;

//                     const rejected = requests.filter(r =>
//                         r.status?.toLowerCase() === "rejected"
//                     ).length;

//                     const pending = requests.filter(r =>
//                         r.status?.toLowerCase() === "pending"
//                     ).length;

//                     setEquipmentData({
//                         total: requests.length,
//                         approved,
//                         rejected,
//                         pending
//                     });
//                 }
//             })
//             .catch(err => console.error("Equipment Dashboard Error:", err));
//         console.log("EMP ID:", empIdForFetch);



//     }, [userData?.EmpId, userData?.employeeId]);





//     const [oneOnOneData, setOneOnOneData] = useState({
//         totalMeetings: 0,
//         pendingTasks: 0,
//         completedTasks: 0
//     });

//     useEffect(() => {
//         if (!employeeId) return;

//         fetch(`/gt-api/get_my_meetings.php?emp_id=${employeeId}`, {
//             credentials: "include"
//         })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.meetings) {

//                     const meetings = data.meetings;

//                     let pending = 0;
//                     let completed = 0;

//                     meetings.forEach(meet => {
//                         const tasks = JSON.parse(meet.action_items || "[]");

//                         tasks.forEach(task => {
//                             if (task.done) completed++;
//                             else pending++;
//                         });
//                     });

//                     setOneOnOneData({
//                         totalMeetings: meetings.length,
//                         pendingTasks: pending,
//                         completedTasks: completed
//                     });
//                 }
//             })
//             .catch(err => console.error("1-1 Fetch Error:", err));

//     }, [employeeId]);



//     const renderOneOnOneCard = () => {
//         const { totalMeetings, pendingTasks, completedTasks } = oneOnOneData;
//         const totalTasks = (pendingTasks + completedTasks) || 1;
//         const progressPercent = Math.min(Math.round((completedTasks / totalTasks) * 100), 100);

//         return (
//             <div className="liquid-card clickable" onClick={() => handleModuleChange("one-on-one")}>
//                 {/* BACKGROUND BLOOM */}
//                 <div className="liquid-bloom"></div>

//                 <div className="liquid-layout">
//                     {/* HERO TILE: THE CORE IDENTITY */}
//                     <div className="liquid-tile-hero">
//                         <div className="hero-header">
//                             {/* <span className="hero-eyebrow">Engagement Console</span> */}
//                             <h2 className="hero-title">1-on-1 Sessions</h2>
//                         </div>
//                         <div className="hero-main-metric">
//                             <span className="hero-val">{totalMeetings}</span>
//                             <span className="hero-label">TOTAL<br />MEETINGS</span>
//                         </div>
//                         {/* FULL WIDTH PROGRESS THREAD */}
//                         <div className="liquid-thread-container">
//                             <div className="liquid-thread-bg">
//                                 <div className="liquid-thread-fill" style={{ width: `${progressPercent}%` }}>
//                                     <div className="liquid-thread-glow-tip"></div>
//                                 </div>
//                             </div>
//                             <div className="liquid-thread-label">
//                                 <span className="label-text">Task Completion</span>
//                                 <span className="label-val">{progressPercent}%</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* DATA TRAY: THE SPECIFIC CHIPS */}
//                     <div className="liquid-tray">
//                         <div className="liquid-chip danger">
//                             <div className="chip-inner">
//                                 <label>Pending Task</label>
//                                 <span className="chip-val">{pendingTasks}</span>
//                             </div>
//                         </div>
//                         <div className="liquid-chip success">
//                             <div className="chip-inner">
//                                 <label>Completed Task</label>
//                                 <span className="chip-val">{completedTasks}</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* INTERACTIVE FOOTER */}
//                 <div className="liquid-footer">
//                     <div className="status-container">
//                         <div className={`status-node-wrapper ${pendingTasks > 0 ? 'is-alert' : 'is-sync'}`}>
//                             <div className="status-node-core"></div>
//                             <div className="status-node-bloom"></div>
//                         </div>
//                         <span className={`status-text ${pendingTasks > 0 ? 'text-alert' : ''}`}>
//                             {pendingTasks > 0 ? 'ACTION ITEMS DETECTED' : 'SYSTEM OPTIMIZED'}
//                         </span>
//                     </div>
//                     <div className="liquid-action">

//                         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
//                     </div>
//                 </div>
//             </div>
//         );
//     };






//     const renderCareerPathwaysCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const pathways = isGenesis

//             ? [

//                 {
//                     id: "01",
//                     name: "FI DESIGN",
//                     color: "rgba(0, 77, 113, 0.9)"
//                 },

//                 {
//                     id: "02",
//                     name: "BIM MODELING",
//                     color: "rgba(0, 120, 172, 0.8)"
//                 },

//                 {
//                     id: "03",
//                     name: "POWER BI",
//                     color: "rgba(0, 162, 237, 0.7)"
//                 }

//             ]

//             : dashboardPathways.map(
//                 (item, index) => ({
//                     id: String(index + 1)
//                         .padStart(2, "0"),

//                     name: item.pathway_title,

//                     color:
//                         "rgba(0, 120, 172, 0.8)"
//                 })
//             );

//         return (

//             <div
//                 className="pathway-card-container"
//                 onClick={() =>
//                     handleModuleChange(
//                         "career pathways"
//                     )
//                 }
//             >

//                 <h2 className="pathway-title">
//                     CAREER PATHWAYS
//                 </h2>

//                 <div className="pathway-stack">

//                     {pathways.map(
//                         (item, index) => (

//                             <div
//                                 key={index}
//                                 className="pathway-step"
//                                 style={{
//                                     '--step-color':
//                                         item.color
//                                 }}
//                                 onClick={(e) => {

//                                     e.stopPropagation();

//                                     handleModuleChange(
//                                         "career pathways",
//                                         item.name
//                                     );

//                                 }}
//                             >

//                                 <span className="step-number">
//                                     {item.id}
//                                 </span>

//                                 <div className="step-content">

//                                     <span className="step-name">
//                                         {item.name}
//                                     </span>

//                                     <div className="step-glow"></div>

//                                 </div>

//                             </div>

//                         )
//                     )}

//                 </div>

//                 <button
//                     className="explore-btn"
//                     onClick={(e) => {

//                         e.stopPropagation();

//                         handleModuleChange(
//                             "career pathways"
//                         );

//                     }}
//                 >
//                     EXPLORE CAREER PATHWAYS
//                 </button>

//             </div>

//         );

//     };


//     const renderPolicyCard = () => {
//         const totalPolicies =
//             policyCount;

//         console.log(
//             "Policy Count:",
//             totalPolicies
//         );

//         const readCount =
//             Object.keys(logs || {}).length;
//         const pending = totalPolicies - readCount;
//         const progress = totalPolicies > 0 ? Math.round((readCount / totalPolicies) * 100) : 0;

//         return (
//             <div className="terminal-policy-card" onClick={() => handleModuleChange("company-policy")}>
//                 {/* Background Decorative Scanline */}
//                 <div className="terminal-scanline"></div>

//                 <div className="terminal-header">
//                     <div className="header-left">
//                         {/* <span className="terminal-tag">PROTOCOL_09</span> */}
//                         <h3 className="terminal-title">Company Policy</h3>
//                     </div>
//                     <div className={`status-indicator ${progress === 100 ? 'secure' : 'breach'}`}>
//                         {progress === 100 ? "SECURE" : "PENDING"}
//                     </div>
//                 </div>

//                 <div className="terminal-content">
//                     {/* Circular Progress using SVG for precision */}
//                     <div className="terminal-visual">
//                         <svg viewBox="0 0 36 36" className="cyber-circle">
//                             <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                             <path
//                                 className="circle-fill"
//                                 strokeDasharray={`${progress}, 100`}
//                                 d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
//                                 style={{ stroke: progress === 100 ? '#22c55e' : '#3b82f6' }}
//                             />
//                         </svg>
//                         <div className="percentage-display">
//                             <span className="pct-num">{progress}</span>
//                             <span className="pct-unit">%</span>
//                         </div>
//                     </div>

//                     {/* Data Readout Section */}
//                     <div className="terminal-stats">
//                         <div className="stat-row">
//                             <span className="label">COMPLETED</span>
//                             <span className="value">{readCount}</span>
//                         </div>
//                         <div className="stat-row">
//                             <span className="label">TOTAL_FILES</span>
//                             <span className="value">{totalPolicies}</span>
//                         </div>
//                         <div className="stat-row urgent">
//                             <span className="label">AWAITING_ACTION</span>
//                             <span className="value">{pending}</span>
//                         </div>
//                     </div>
//                 </div>

//             </div>
//         );
//     };

//     useEffect(() => {
//         const fetchLogs = async () => {
//             if (!userData?.EmpId) return;

//             try {
//                 const res = await fetch(
//                     `/gt-api/acknowledgepolicy.php?empId=${userData.EmpId}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 console.log("API DATA:", data);

//                 // 🔥 FIX: use data.logs (NOT data)
//                 const logsArray = Array.isArray(data?.logs) ? data.logs : [];

//                 const map = logsArray.reduce((acc, curr) => {
//                     if (curr?.policy_title) {
//                         acc[curr.policy_title] = true;
//                     }
//                     return acc;
//                 }, {});

//                 setLogs(map);

//             } catch (err) {
//                 console.error("Policy logs error:", err);
//                 setLogs({});
//             }
//         };

//         fetchLogs();
//     }, [userData]);


//     const [showProfileOptions, setShowProfileOptions] = useState(false);



//     const [showProfileMenu, setShowProfileMenu] = useState(false);
//     const handleEditProfile = () => {
//         setShowProfileMenu(false);
//         navigate(`/dashboard/${role}/my-profile`);
//         setShowProfile(true);
//     };

//     const handleLogout = () => {
//         const rememberMe = localStorage.getItem("rememberMe");
//         const rememberedEmail = localStorage.getItem("rememberedEmail");
//         const rememberedPassword = localStorage.getItem("rememberedPassword");

//         document.documentElement.removeAttribute('data-theme');
//         localStorage.clear();
//         sessionStorage.clear();

//         if (rememberMe) {
//             localStorage.setItem("rememberMe", rememberMe);
//             if (rememberedEmail) localStorage.setItem("rememberedEmail", rememberedEmail);
//             if (rememberedPassword) localStorage.setItem("rememberedPassword", rememberedPassword);
//         }

//         navigate("/", { replace: true });
//     };

//     const [currentTime, setCurrentTime] = useState("");

//     useEffect(() => {
//         const updateTime = () => {
//             const now = new Date();
//             setCurrentTime(
//                 now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
//             );
//         };

//         updateTime();
//         const interval = setInterval(updateTime, 1000);

//         return () => clearInterval(interval);
//     }, []);
//     const todayDate = new Date().toLocaleDateString('en-GB', {
//         day: '2-digit',
//         month: 'short'
//     });



//     const employeeModulesList = [
//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "attendance" },

//         { id: 2, name: "Pay and Benefits", icon: "💳", color: "#3b82f6", slug: "pay and benefits" },
//         { id: 3, name: "OKR and Performance Tracker", icon: "🎯", color: "#f59e0b", slug: "okr and performance tracker" },

//         { id: 5, name: "Career Pathways", icon: "🏆", color: "#ec4899", slug: "career pathways" },
//         { id: 6, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },

//         { id: 9, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         { id: 10, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         // { id: 11, name: "Documents", icon: "📂", color: "#f43f5e", slug: "documents" },
//         // { id: 12, name: "Employee Experience Survey - EES", icon: "📝", color: "#8b5cf6", slug: "ees-survey" },   
//         { id: 13, name: "1:1 Meeting", icon: "💬", color: "#00fff2", slug: "one-on-one" },
//         { id: 21, name: "ACM Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//         { id: 7, name: "Expense Reimbursement", icon: "🧾", color: "#10b981", slug: "supplies" },

//     ];

//     const managementModulesList = [

//         { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "leave-management", badge: pendingLeavesCount },

//         { id: 2, name: "Employee Salary and Benefits", icon: "💳", color: "#3b82f6", slug: "employee-salary-benefits" },

//         { id: 3, name: "Employee OKR'S", icon: "🎯", color: "#f59e0b", slug: "employee-okrs" },

//         { id: 5, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: pendingRequestsCount },

//         { id: 6, name: "Own Finanacials", icon: "💰", color: "#10b981", slug: "pay and benefits" },

//         { id: 8, name: "Career Development", icon: "🏆", color: "#ec4899", slug: "career pathways" },

//         { id: 10, name: "Self OKR Tracker", icon: "🏁", color: "#f59e0b", slug: "okr and performance tracker" },
//         { id: 11, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
//         { id: 12, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
//         // { id: 21, name: "Manage Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates", badge: "PUSH" },

//         {
//             id: 21,
//             name: "ACM Updates",
//             icon: "📢",
//             color: "#00fff2",
//             slug: "manage-quarterly-updates",
//             badge: "PUSH"
//         },

//         // {
//         //   id: 15,
//         //   name: "EES Feedback Analytics",
//         //   icon: "📊",
//         //   color: "#00f2ff",
//         //   slug: "ees-analytics",
//         //   badge: "NEW"
//         // },

//         // { id: 14, name: "Skills Development", icon: "📚", color: "#06b6d4", slug: "career" },

//         {
//             id: 16,
//             name: "Medical Reports",
//             icon: "🏥",
//             color: "#f43f5e",
//             slug: "medical-reports",
//             badge: "DOCS"
//         },
//         {
//             id: 17,
//             name: "Policy RnU Status",
//             icon: "📋",
//             color: "#10b981",
//             slug: "policy-logs",
//             badge: "ADMIN"
//         },

//         // { 
//         //   id: 18, 
//         //   name: "Employee Documents", 
//         //   icon: "📂", 
//         //   color: "#f43f5e", 
//         //   slug: "manage-documents", 
//         //   badge: "VIEW" 
//         // },

//         {
//             id: 19,
//             name: "1:1 Connect",
//             icon: "🤝",
//             color: "#00fff2",
//             slug: "manager-one-on-one",

//             badge: "LIVE"
//         },

//         { id: 20, name: "Events and Celebrations", icon: "🎉", color: "#3b82f6", slug: "events-celebrations" },

//         {
//             id: 22,
//             name: "Expense Reimbursements",
//             icon: "💰",
//             color: "#22c55e",
//             slug: "reimbursements",
//             badge: "NEW"
//         },

//         {
//             id: 25,
//             name: "Award Nominations Analytics",
//             icon: "📊",
//             color: "#f59e0b",
//             slug: "award-analytics",
//             badge: "GALA"
//         },

//         // {
//         //     id: 23,
//         //     name: "WFH Requests",
//         //     icon: "🏠",
//         //     color: "#3b82f6",
//         //     slug: "manage-wfh-requests",
//         //     badge: "WFH"
//         // },


//     ];

//     const renderActiveModule = () => {

//         switch (activeModule) {

//             case "attendance-tracker":
//                 return <AttendanceTracker />;

//             case "CompanySetup":
//                 return <CompanySetup />;

//             case "create-invoice":
//                 return <InvoiceGenerator />;

//             case "my-profile":
//                 return (
//                     <MyProfile
//                         userData={userData}
//                         setUserData={setUserData}
//                         isEditing={isEditing}
//                         setIsEditing={setIsEditing}
//                         handleSave={handleSave}
//                         setShowPasswordModal={setShowPasswordModal}
//                     />
//                 );


//             case "reimbursements":
//                 if (role === "Management" || role === "Manager") {
//                     return <ReimbursementManagement />;
//                 }
//                 return <OfficeRequisition userData={userData} />;

//             case "manage-wfh-requests":
//                 return <WFHManagement />;


//             case "work-from-home":
//                 return <WorkFromHome />;


//             case "quarterly-updates":

//                 return <QuarterlyUpdates />;

//             case "manage-quarterly-updates":

//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementQuarterlyUpdate userData={userData} />;
//                 }
//                 return <QuarterlyUpdates />;


//             case "leave-management":
//                 // Unified behavior for Management and Manager
//                 if (role === 'Management' || role === 'Manager') {
//                     return <LeaveManagement userData={userData} />;
//                 }


//                 return <Attendance employeeId={employeeId} userData={userData} />;

//             case "manage-documents":
//                 if (role === 'Management') {
//                     return <ManageEmployeeDocs />;
//                 }
//                 return <Documents userData={userData} />;



//             // case "attendance":
//             //     if (role === 'Management') return <Attendance />;
//             //     return (
//             //         <Attendance
//             //             employeeId={userData.id}
//             //             empBadgeId={userData.EmpId}
//             //             userData={userData}
//             //         />
//             //     );
//             case "attendance":

//                 if (role === 'Management') {

//                     return (
//                         <Attendance
//                             employeeId={userData.id}
//                             empBadgeId={userData.EmpId}
//                             userData={userData}
//                         />
//                     );

//                 }

//                 return (
//                     <Attendance
//                         employeeId={userData.id}
//                         empBadgeId={userData.EmpId}
//                         userData={userData}
//                     />
//                 );


//             case "policy-logs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <PolicyAdminDashboard />;
//                 }

//                 return (
//                     <CompanyPolicy
//                         employeeId={userData.id}
//                         userData={userData}
//                     />
//                 );

//             case "events-celebrations":
//                 return <EventsCelebrations userData={userData} />;

//             case "award-nominations":
//                 return <AwardNominations userData={userData} role={role} />;

//             case "award-analytics":
//                 return <AwardAnalyticsDashboard userData={userData} role={role} />;

//             case "pay and benefits": return <PayBenefits userData={userData} employeeId={employeeId} />;

//             // case "okr and performance tracker":
//             //     return <OKRTracker userData={userData} />;

//             case "okr and performance tracker":
//                 return (
//                     <OKRTracker
//                         userData={userData}
//                         defaultTab={location.state?.tab}
//                     />
//                 );

//             // Inside Dashboard.js -> renderActiveModule
//             // case "employee-okrs":
//             //     if (role === 'Management' || role === 'Manager') {
//             //         return (
//             //             <ManagementOKRViewer
//             //                 managerId={userData.id}
//             //                 userRole={role}
//             //                 // This is the CRITICAL line:
//             //                 managedDept={userData.HOD}
//             //             />
//             //         );
//             //     }
//             //     return <OKRTracker userData={userData} />;

//             case "employee-okrs":
//                 if (role === 'Management' || role === 'Manager') {
//                     return <ManagementOKRViewer userRole={role} />;
//                 }
//                 return <OKRTracker userData={userData} />;

//             case "career pathways": return <CareerPathways userData={userData} />;
//             case "add-department": return <AddDepartment />;
//             case "manage-department": return <ManageDepartment />;
//             case "add-employee": return <AddEmployee />;
//             case "manage-employee": return <ManageEmployee />;

//             case "employee-salary-benefits":
//                 return <EmployeeSalaryBenefits />;


//             case "equipment-request":
//                 if (role === "Management") {
//                     const pending = requestsList.filter(
//                         (r) => r.status?.toLowerCase() === "pending"
//                     );

//                     const history = requestsList.filter(
//                         (r) => r.status?.toLowerCase() !== "pending"
//                     );

//                     return (
//                         <div
//                             className="management-request-wrapper animate-fade"
//                             style={{ padding: "20px" }}
//                         >
//                             {/* Pending Queue */}
//                             <div
//                                 className="module-glass-card"
//                                 style={{ marginBottom: "30px" }}
//                             >
//                                 <h3 className="cyan-text">
//                                     ACTIVE_PENDING_QUEUE ({pending.length})
//                                 </h3>

//                                 {/* Desktop Table */}
//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>IMPACT</th>
//                                                 <th>ACTION</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {pending.length > 0 ? (
//                                                 pending.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                             >
//                                                                 {req.impact?.toUpperCase()}
//                                                             </span>
//                                                         </td>

//                                                         <td>
//                                                             <div className="equiptable-actions">
//                                                                 <button
//                                                                     className="equiptable-btn equiptable-approve"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Approved"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✔
//                                                                 </button>

//                                                                 <button
//                                                                     className="equiptable-btn equiptable-reject"
//                                                                     onClick={() =>
//                                                                         handleStatusUpdate(
//                                                                             req.id,
//                                                                             "Rejected"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     ✖
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_PENDING_REQUESTS
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 {/* Mobile Cards */}
//                                 <div className="equiptable-mobile">
//                                     {pending.length > 0 ? (
//                                         pending.map((req) => (
//                                             <div
//                                                 className="equiptable-card"
//                                                 key={req.id}
//                                             >
//                                                 <div className="equiptable-row">
//                                                     <span>Employee</span>
//                                                     <strong>
//                                                         {req.employee_name}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Hardware</span>
//                                                     <strong>
//                                                         {req.equipment_type}
//                                                     </strong>
//                                                 </div>

//                                                 <div className="equiptable-row">
//                                                     <span>Impact</span>

//                                                     <span
//                                                         className={`equiptable-impact ${req.impact?.toLowerCase()}`}
//                                                     >
//                                                         {req.impact?.toUpperCase()}
//                                                     </span>
//                                                 </div>

//                                                 <div className="equiptable-actions">
//                                                     <button
//                                                         className="equiptable-btn equiptable-approve"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Approved"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✔ Approve
//                                                     </button>

//                                                     <button
//                                                         className="equiptable-btn equiptable-reject"
//                                                         onClick={() =>
//                                                             handleStatusUpdate(
//                                                                 req.id,
//                                                                 "Rejected"
//                                                             )
//                                                         }
//                                                     >
//                                                         ✖ Reject
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         ))
//                                     ) : (
//                                         <div className="equiptable-card">
//                                             NO_PENDING_REQUESTS
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Completed History */}
//                             <div
//                                 className="module-glass-card history-card"
//                                 style={{ opacity: 0.9 }}
//                             >
//                                 <h3
//                                     className="gray-text"
//                                     style={{ color: "#888" }}
//                                 >
//                                     📜 COMPLETED_HISTORY ({history.length})
//                                 </h3>

//                                 <div className="equiptable-container">
//                                     <table className="equiptable">
//                                         <thead>
//                                             <tr>
//                                                 <th>EMPLOYEE</th>
//                                                 <th>HARDWARE</th>
//                                                 <th>DATE</th>
//                                                 <th>STATUS</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {history.length > 0 ? (
//                                                 history.map((req) => (
//                                                     <tr key={req.id}>
//                                                         <td>{req.employee_name}</td>

//                                                         <td>{req.equipment_type}</td>

//                                                         <td>
//                                                             {new Date(
//                                                                 req.updated_at ||
//                                                                 req.created_at
//                                                             ).toLocaleDateString(
//                                                                 "en-GB"
//                                                             )}
//                                                         </td>

//                                                         <td>
//                                                             <span
//                                                                 className={`equiptable-status ${req.status?.toLowerCase()}`}
//                                                             >
//                                                                 {req.status?.toUpperCase()}
//                                                             </span>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td
//                                                         colSpan="4"
//                                                         style={{
//                                                             textAlign: "center",
//                                                             padding: "20px",
//                                                         }}
//                                                     >
//                                                         NO_HISTORY_FOUND
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     );
//                 }

//                 return <EquipmentRequest userData={userData} />;

//             case "supplies": return <OfficeRequisition userData={userData} />;
//             // case "it": return <ITSupport userData={userData} />;
//             case "documents": return <Documents userData={userData} />;
//             // case "company-policy": return <CompanyPolicy />;
//             case "company-policy":
//                 return <CompanyPolicy userData={userData} />;
//             case "Organization Chart": return <OrgChart userData={userData} />;
//             // case "campus information": return <CampusInfo />;
//             case "campus information":
//                 return <CampusInfo userData={userData} />;
//             case "ees-survey": return <EESExperience userData={userData} />;

//             case "ees-analytics":
//                 if (role === 'Management' || role === 'Manager') {
//                     // Management sees the list of real data
//                     return <EESFeedbackManagement feedbacks={eesSubmissions} />;
//                 }
//                 // Employee sees the form
//                 return <EESExperience userData={userData} onFinalSubmit={handleEESSubmit} />;

//             //       case "one-on-one":
//             // return <OneOnOne userData={userData} role={role} />;

//             case "one-on-one":
//                 // This is the PERSONAL view (Employee mode)
//                 return <OneOnOne userData={userData} role="Employee" viewMode="personal" />;

//             case "manager-one-on-one":
//                 // This is the MANAGERIAL view (Manager/Management mode)
//                 return <OneOnOne userData={userData} role={role} viewMode="managerial" />;

//             case "one-on-one-report":
//                 return <OneOnOneReport userData={userData} role={role} handleModuleChange={handleModuleChange} />;

//             // Inside Dashboard.js renderActiveModule
//             case "medical-reports":
//                 if (role === 'Management') return <MedicalReports />;
//                 if (role === 'Manager') {
//                     return (
//                         <ManagerMedicalReports
//                             managerId={userData.id}           // Database Primary Key
//                             managerBadgeId={userData.EmpId}   // Company ID (HOD flag often matches this)
//                             managerDept={userData.Department} // The string "Software Development"
//                         />
//                     );
//                 }

//             case "employee-it-support":
//                 return <EquipmentRequest userData={userData} />;

//             default:


//                 if (role === 'Manager') {
//                     return renderManagerDashboard();
//                 }

//                 const currentList = role === 'Management' ? managementModulesList : employeeModulesList;
//                 return (
//                     <section className="bento-grid">
//                         {currentList.map((mod) => (
//                             <div key={mod.id} className="bento-card glass" style={{ "--accent": mod.color }} onClick={() => handleModuleChange(mod.slug)}>
//                                 <div className="card-top">
//                                     <span className="mod-icon">{mod.icon}</span>
//                                     {mod.badge > 0 && <span className={role === 'Management' ? "card-badge" : "notification-badge-ui"}>{mod.badge}</span>}
//                                 </div>
//                                 <div className="card-info"><h3>{mod.name}</h3><div className="cyber-line"></div></div>
//                             </div>
//                         ))}
//                     </section>
//                 );
//         }
//     };

//     const [companyLogo, setCompanyLogo] = useState("");
//     const currentLogo = theme === 'light' ? logoLight : logoDark;


//     const [leaveStats, setLeaveStats] = useState({
//         pending: 0,
//         approved: 0,
//         rejected: 0,
//         wfhPending: 0
//     });

//     useEffect(() => {
//         if (role !== "Management") return;

//         const fetchLeaveStats = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();

//                 if (data.success) {
//                     const leaves = data.leaves || [];


//                     const pending = leaves.filter(l => l.Status === '0' || l.Status === null).length;
//                     const approved = leaves.filter(l => l.Status === '1').length;
//                     const rejected = leaves.filter(l => l.Status === '2').length;

//                     // WFH
//                     const wfhRes = await fetch("/gt-api/get_all_wfh_requests.php", {
//                         credentials: "include"
//                     });
//                     const wfhData = await wfhRes.json();

//                     const wfhPending = wfhData.success
//                         ? wfhData.requests.filter(r => r.status === "Pending").length
//                         : 0;

//                     setLeaveStats({ pending, approved, rejected, wfhPending });
//                 }

//             } catch (err) {
//                 console.error("Leave Stats Error:", err);
//             }
//         };

//         fetchLeaveStats();
//         const interval = setInterval(fetchLeaveStats, 5000);

//         return () => clearInterval(interval);
//     }, [role]);


//     const [mgmtLeaves, setMgmtLeaves] = useState([]);
//     const [mgmtActiveTeam, setMgmtActiveTeam] = useState("All");

//     useEffect(() => {
//         const fetchLeaves = async () => {
//             try {
//                 const res = await fetch("/gt-api/get_all_leaves.php", {
//                     credentials: "include"
//                 });
//                 const data = await res.json();
//                 if (data.success) setMgmtLeaves(data.leaves);
//             } catch (err) {
//                 console.error("Leave Fetch Error:", err);
//             }
//         };

//         fetchLeaves();
//     }, []);





//     const mgmtChartData = useMemo(() => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept => dept.DepartmentName
//             );

//         const now = new Date();
//         const currentMonth = (now.getMonth() + 1).toString();
//         const currentYear = now.getFullYear().toString();

//         const teamList = mgmtActiveTeam === "All" ? teams : [mgmtActiveTeam];

//         return teamList.map(team => {

//             const filtered = mgmtLeaves.filter(l => {
//                 const dateParts = l.fromdate?.split("-");
//                 const lYear = dateParts?.[0];
//                 const lMonth = dateParts?.[1]
//                     ? parseInt(dateParts[1]).toString()
//                     : "";

//                 return (
//                     l.Department === team &&
//                     lMonth === currentMonth &&
//                     lYear === currentYear
//                 );
//             });

//             return {
//                 name: team,

//                 // ✅ SUM OF UNITS (FIXED)
//                 Approved: filtered
//                     .filter(l => l.Status === "1")
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

//                 Pending: filtered
//                     .filter(l => l.Status === "0" || l.Status === null)
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
//             };
//         });

//     }, [mgmtLeaves, mgmtActiveTeam]);


//     const renderManagementLeaveCard = () => {

//         const isGenesis =
//             userData?.EmailId
//                 ?.toLowerCase()
//                 ?.includes("genesistech.co.in");

//         const teams = isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept =>
//                     dept.DepartmentName
//             );

//         return (
//             <div
//                 className="mgmt-leave-analytics clickable"
//                 onClick={() => handleModuleChange("leave-management")}
//             >

//                 <div className="card-header">
//                     <h3>Employee Leave Analytics</h3>
//                     <span className="sub-text">This Month</span>
//                 </div>

//                 {/* TEAM CHIPS */}
//                 <div className="team-row">
//                     <div
//                         className={`team-chip ${mgmtActiveTeam === "All" ? "active" : ""}`}
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             setMgmtActiveTeam("All");
//                         }}
//                     >
//                         ALL
//                     </div>

//                     {teams.map((team, i) => (
//                         <div
//                             key={i}
//                             className={`team-chip ${mgmtActiveTeam === team ? "active" : ""}`}
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 setMgmtActiveTeam(team);
//                             }}
//                         >
//                             {team}
//                         </div>
//                     ))}
//                 </div>

//                 {/* CHART */}
//                 {(() => {
//                     const isSingle = mgmtActiveTeam !== "All";

//                     return (
//                         <div className={`chart-area ${isSingle ? "single-view" : ""}`}>
//                             <ResponsiveContainer width="100%" height={170}>
//                                 <BarChart
//                                     data={mgmtChartData}
//                                     barCategoryGap={isSingle ? "70%" : "30%"}
//                                     margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
//                                 >

//                                     {/* GRADIENTS */}
//                                     <defs>
//                                         <linearGradient id="approvedGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#34d399" />
//                                             <stop offset="100%" stopColor="#059669" />
//                                         </linearGradient>

//                                         <linearGradient id="pendingGrad" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#fbbf24" />
//                                             <stop offset="100%" stopColor="#f59e0b" />
//                                         </linearGradient>
//                                     </defs>

//                                     <CartesianGrid
//                                         strokeDasharray="3 3"
//                                         stroke="rgba(255,255,255,0.05)"
//                                         vertical={false}
//                                     />

//                                     <XAxis
//                                         dataKey="name"
//                                         tick={{ fill: "#888", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <YAxis
//                                         tick={{ fill: "#666", fontSize: 10 }}
//                                         axisLine={false}
//                                         tickLine={false}
//                                     />

//                                     <Tooltip
//                                         cursor={{ fill: "rgba(255,255,255,0.05)" }}
//                                         contentStyle={{
//                                             backgroundColor: "rgba(15, 23, 42, 0.95)", // dark glass
//                                             border: "1px solid rgba(0,255,242,0.3)",
//                                             borderRadius: "10px",
//                                             color: "#ffffff",
//                                             backdropFilter: "blur(8px)"
//                                         }}
//                                         labelStyle={{ color: "#00fff2", fontWeight: 600 }}
//                                         itemStyle={{ color: "#ffffff" }}
//                                     />


//                                     <Bar
//                                         dataKey="Approved"
//                                         stackId="a"
//                                         fill="url(#approvedGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                     <Bar
//                                         dataKey="Pending"
//                                         stackId="a"
//                                         fill="url(#pendingGrad)"
//                                         barSize={isSingle ? 50 : 20}
//                                         radius={[6, 6, 0, 0]}
//                                     />

//                                 </BarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     );
//                 })()}


//                 <div className="card-footer">
//                     <span>Open Leave Console</span>
//                     <span>→</span>
//                 </div>
//             </div>
//         );
//     };

//     const renderSalaryIntelCard = () => {
//         // 1. Existing Counts
//         const payslips = payData.filter(d => d.doc_type === "Monthly Salary Slip").length;
//         const form16 = payData.filter(d => d.doc_type === "Annual Form 16").length;
//         const appraisal = payData.filter(d => d.doc_type === "APPRAISAL LETTER").length;

//         // 2. New Miscellaneous Count (Filtering for the images you provided)
//         const miscDocs = [
//             "FNF LETTER", "OFFER LETTER", "RELIEVING LETTER",
//             "EXPERIENCE LETTER", "EMPLOYEMENT AGREEMENT", "BANK ACCOUNT OPENING"
//         ];
//         const miscellaneous = payData.filter(d => miscDocs.includes(d.doc_type)).length;

//         // 3. Updated Total
//         const total = payslips + form16 + appraisal + miscellaneous;

//         // 4. SVG Math for 4 segments
//         const chartTotal = 125.6;
//         const gap = total > 0 ? 2 : 0;

//         const s1 = (payslips / total) * chartTotal || 0;
//         const s2 = (form16 / total) * chartTotal || 0;
//         const s3 = (appraisal / total) * chartTotal || 0;
//         const s4 = (miscellaneous / total) * chartTotal || 0;

//         return (
//             <div className="sa-card-wrapper" onClick={() => handleModuleChange("employee-salary-benefits")}>


//                 <div className="sa-card-header">
//                     <h3 className="sa-title">Salary Document Insights</h3>
//                     <button className="sa-menu-trigger">⋮</button>
//                 </div>

//                 <div className="sa-main-body">
//                     <div className="sa-gauge-area">
//                         <div className="sa-gauge-container">
//                             <svg viewBox="0 0 100 55" className="sa-gauge-svg">
//                                 {/* Background Track */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="var(--sa-track)" strokeWidth="9" strokeLinecap="round" />

//                                 {/* Segment 4: Misc (Blue) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#0ea5e9" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s4 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2 + s3}`} />

//                                 {/* Segment 3: Appraisals (Orange) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#f97316" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s3 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1 + s2}`} />

//                                 {/* Segment 2: Form 16 (Yellow) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#fbbf24" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s2 - gap)} ${chartTotal}`}
//                                     strokeDashoffset={`-${s1}`} />

//                                 {/* Segment 1: Payslips (Purple) */}
//                                 <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#8b5cf6" strokeWidth="9" strokeLinecap="round"
//                                     strokeDasharray={`${Math.max(0, s1 - gap)} ${chartTotal}`}
//                                     strokeDashoffset="0" />
//                             </svg>

//                             <div className="sa-gauge-text">
//                                 <span className="sa-overall-num">{total}</span>
//                                 <span className="sa-overall-label">Overall</span>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="sa-legend-area">
//                         {[
//                             { label: "Payslips", count: payslips, color: "purple" },
//                             { label: "Form 16", count: form16, color: "yellow" },
//                             { label: "Appraisals", count: appraisal, color: "orange" },
//                             { label: "Miscellaneous", count: miscellaneous, color: "blue" }
//                         ].map((item, index) => (
//                             <div key={index} className="sa-legend-item">
//                                 <div className="sa-item-top">
//                                     <span className={`sa-dot ${item.color}`}></span>
//                                     <span className="sa-item-count">{item.count}</span>
//                                 </div>
//                                 <span className="sa-item-label">{item.label}</span>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <div className="sa-card-footer">
//                     <span className="sa-footer-link">View Detailed Report →</span>
//                 </div>
//             </div>
//         );
//     };



//     const [okrData, setOkrData] = useState([]);
//     useEffect(() => {
//         if (!userData?.id) return;

//         const fetchOKR = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/get_user_okr.php?empId=${userData.id}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 if (data.success) {
//                     const parsed = typeof data.data === "string"
//                         ? JSON.parse(data.data)
//                         : data.data;

//                     setOkrData(parsed);
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         fetchOKR();

//     }, [userData?.id]);



//     const [okrStats, setOkrStats] = useState({
//         total: 0,
//         completed: 0,
//         pending: 0,
//         progressPercent: 0
//     });



//     const fetchOKRStats = async () => {
//         if (!userData?.EmpId) return;

//         try {
//             const res = await fetch(
//                 `/gt-api/get_okr_stats.php?empId=${userData.EmpId}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setOkrStats(data);
//             }

//         } catch (err) {
//             console.error("OKR STATS ERROR:", err);
//         }
//     };

//     useEffect(() => {
//         if (!userData?.EmpId) return;

//         fetchOKRStats();

//         const handleUpdate = () => fetchOKRStats();

//         window.addEventListener("okrUpdated", handleUpdate);

//         return () => window.removeEventListener("okrUpdated", handleUpdate);

//     }, [userData?.EmpId]);




//     const renderOKRCard = () => {
//         const { total, completed, pending, progressPercent } = okrStats;

//         return (
//             <div
//                 className="expanded-management-card clickable"
//                 onClick={() => handleModuleChange("okr and performance tracker")}
//             >
//                 <div className="okr-card-container">

//                     {/* HEADER */}
//                     <div className="okr-header">
//                         <div>
//                             <span className="eyebrow-text">Performance Tracker</span>
//                             <h2 className="display-title">OKR Progress</h2>
//                         </div>

//                         {/* TOP RIGHT TOTAL */}
//                         <div className="stat-box featured big">
//                             <span className="stat-label">Total KR</span>
//                             <span className="stat-value">{total}</span>
//                         </div>
//                     </div>

//                     {/* STATS ROW */}
//                     <div className="okr-stats-row">
//                         <div className="stat-box danger">
//                             <span className="stat-label">Pending</span>
//                             <span className="stat-value">{pending}</span>
//                         </div>

//                         <div className="stat-box success">
//                             <span className="stat-label">Completed</span>
//                             <span className="stat-value">{completed}</span>
//                         </div>
//                     </div>

//                     {/* PROGRESS FULL WIDTH */}
//                     <div className="progress-section-wide full">
//                         <div className="progress-labels">
//                             <span className="label-muted">Completion</span>
//                             <span className="label-bold">{progressPercent}%</span>
//                         </div>

//                         <div className="wide-bar-bg">
//                             <div
//                                 className="wide-bar-fill"
//                                 style={{ width: `${progressPercent}%` }}
//                             ></div>
//                         </div>
//                     </div>

//                     {/* FOOTER */}
//                     <div className="expanded-footer">
//                         <span className={`status-indicator ${pending > 0 ? 'is-warning' : 'is-clear'}`}>
//                             {pending > 0
//                                 ? `● ${pending} Key Results Pending`
//                                 : '● All Key Results Completed'}
//                         </span>

//                         <span className="interaction-hint">
//                             Open OKR Console →
//                         </span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     const [mgmtOneOnOneData, setMgmtOneOnOneData] = useState([]);
//     useEffect(() => {
//         const fetchMeetings = async () => {
//             const storedUser = localStorage.getItem('userData');
//             const user = JSON.parse(storedUser) || {};

//             const res = await fetch(
//                 `/gt-api/get_oneonone.php?manager_id=${user.id}&role=manager`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.meetings) {
//                 setMgmtOneOnOneData(data.meetings);
//             }
//         };

//         fetchMeetings();
//     }, []);

//     const renderOneOnOneHealthCard = () => {
//         const missedData = mgmtOneOnOneData.filter(m => m.status === "MISSED");

//         const total = mgmtOneOnOneData.length;
//         const missed = mgmtOneOnOneData.filter(m => m.status === "MISSED").length;
//         const completed = total - missed;

//         const rate = total > 0 ? Math.round((completed / total) * 100) : 0;

//         let status = "Healthy";
//         if (rate < 50) status = "Critical ⚠️";
//         else if (rate < 80) status = "Needs Attention";

//         return (
//             <div className="meeting-card" onClick={() => handleModuleChange("manager-one-on-one")}>

//                 <div className="mc-header">
//                     <h3>1:1 Meeting Scheduler</h3>
//                     <span>{status}</span>
//                 </div>

//                 {/* BIG NUMBER */}
//                 <div className="mc-center">
//                     <h1>{rate}%</h1>
//                     <p>Engagement</p>
//                 </div>

//                 {/* BARS */}
//                 <div className="mc-bars">
//                     <div className="bar completed" style={{ width: `${rate}%` }}></div>
//                     <div className="bar missed" style={{ width: `${100 - rate}%` }}></div>
//                 </div>

//                 {/* INFO */}
//                 <div className="mc-info">
//                     <span>✅ {completed} Done</span>
//                     <span>❌ {missed} Missed</span>
//                 </div>
//                 <button
//                     className="view-missed-btn"
//                     onClick={(e) => {
//                         e.stopPropagation();
//                         setShowMissedModal(true);
//                     }}
//                 >
//                     View Missed
//                 </button>

//             </div>
//         );
//     };

//     const [okrActivity, setOkrActivity] = useState([]);
//     useEffect(() => {
//         const fetchOKR = async () => {
//             try {
//                 const storedUser = localStorage.getItem("userData");
//                 const user = JSON.parse(storedUser) || {};

//                 const res = await fetch(
//                     `/gt-api/get_employee_okrs.php?role=${user.role}&managedDept=${user.department}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await res.json();

//                 if (data.success) {
//                     setOkrActivity(data.data);
//                 }

//             } catch (err) {
//                 console.error("OKR Fetch Error:", err);
//             }
//         };

//         fetchOKR();
//     }, []);

//     const recentOKR = okrActivity
//         .slice(0, 5)
//         .map(item => {
//             let type = "updated";

//             if (item.workflow_status === "Planning") {
//                 type = "new";
//             }

//             if (item.workflow_status === "Manager_Scoring_Review") {
//                 type = "pending";
//             }

//             return {
//                 name: item.emp_name,
//                 quarter: item.quarter,
//                 type,
//                 workflow_status: item.workflow_status   // 🔥 VERY IMPORTANT
//             };
//         });



//     const renderOKRActivityCard = () => {
//         const getStatusConfig = (status) => {
//             switch (status) {
//                 case "Planning": return { color: "#3b82f6", label: "submitted OKR" };
//                 case "Management_Review": return { color: "#f59e0b", label: "sent for Review" };
//                 case "Scoring": return { color: "#8b5cf6", label: "sent for Scoring" };
//                 case "Sign_Off": return { color: "#10b981", label: "finalized OKR" };
//                 default: return { color: "#00bcd4", label: "updated OKR" };
//             }
//         };

//         return (
//             <div className="mgt-okr-card1 timeline-style clickable" onClick={() => handleModuleChange("employee-okrs")}>
//                 <div className="card-header-v2">
//                     <div className="title-section">
//                         <h3>OKR Stream</h3>
//                         <div className="live-dot-wrapper">
//                             <span className="live-dot"></span>
//                             <span className="sub-text">Live updates</span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="okr-activity-timeline">
//                     {recentOKR.length === 0 ? (
//                         <div className="empty-state">No recent activity detected</div>
//                     ) : (
//                         recentOKR.slice(0, 3).map((item, i) => {
//                             const config = getStatusConfig(item.workflow_status);
//                             return (
//                                 <div key={i} className="timeline-item">
//                                     {/* The Vertical Line & Dot */}
//                                     <div className="timeline-visual">
//                                         <div className="timeline-line"></div>
//                                         <div className="timeline-marker" style={{ borderColor: '#111827', background: config.color }}>
//                                             <div className="marker-inner-dot"></div>
//                                         </div>
//                                     </div>

//                                     {/* Single Content Box */}
//                                     <div className="timeline-content-box">
//                                         <div className="content-top">
//                                             <span className="emp-name">{item.name}</span>
//                                             <span className="quarter-tag">{item.quarter}</span>
//                                         </div>
//                                         <p className="status-message">{config.label}</p>
//                                     </div>
//                                 </div>
//                             );
//                         })
//                     )}
//                 </div>

//                 <div className="card-footer-v2">
//                     <span>Access Module</span>
//                     {/* <div className="arrow-circle">→</div> */}
//                 </div>


//             </div>
//         );
//     };

//     const renderManagementShortcutsCard = () => {
//         const shortcuts = [

//             { name: "Create Invoice", icon: "🏦", slug: "create-invoice" },
//             { name: "Policy RnU", icon: "📋", slug: "policy-logs" },
//             { name: "Career Development", icon: "🏆", slug: "career pathways" },
//             { name: "Expense Reimbursement", icon: "💰", slug: "reimbursements" },
//             // { name: "ACM Updates", icon: "📢", slug: "manage-quarterly-updates" },
//             { name: "Self OKR", icon: "🎯", slug: "okr and performance tracker" },
//             { name: "Own Financial", icon: "💳", slug: "pay and benefits" },
//             { name: "Access ACM Info", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
//             // { name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },
//             { name: "IT Support", icon: "🖥️", slug: "employee-it-support" },
//             { name: "Attendance Tracker", icon: "📊", slug: "attendance-tracker" },
//             { name: "Award Analytics", icon: "🏆", slug: "award-analytics" },
//             // { name: "Company Setup", icon: "⚙️", slug: "CompanySetup" },





//         ];

//         return (
//             <div className="mgt-shortcut-card">

//                 <div className="card-header">
//                     <h3>Quick Access</h3>
//                     <span className="sub-text">Shortcuts</span>
//                 </div>

//                 <div className="shortcut-grid">
//                     {shortcuts.map((item, i) => (
//                         <div
//                             key={i}
//                             className="shortcut-item"
//                             onClick={() => handleModuleChange(item.slug)}
//                         >
//                             <span className="shortcut-icon">{item.icon}</span>
//                             <span className="shortcut-text">{item.name}</span>
//                         </div>
//                     ))}
//                 </div>

//             </div>
//         );
//     };


//     const renderEmployeeDashboard = () => {
//         return (
//             <div className="dashboard-layout">

//                 <div className="dashboard-row row-top">
//                     {renderLeavePieChart()}
//                     {renderPayChart()}
//                     {renderOneOnOneCard()}



//                     {/* {renderEquipmentCard()} */}
//                 </div>

//                 <div className="dashboard-row row-middle">
//                     {renderOKRCard()}
//                     {renderCareerPathwaysCard()}
//                 </div>

//                 <div className="dashboard-row row-bottom">
//                     {renderPolicyCard()}
//                     <QuarterlyCard handleModuleChange={handleModuleChange} />
//                 </div>

//             </div>
//         );
//     };

//     const renderManagementDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>






//         );
//     };

//     const renderManagerDashboard = () => {
//         return (


//             <div className="mgt-dashboard-layout">


//                 <div className="mgt-dashboard-row row-top two-card-layout">
//                     <div className="card-large">
//                         {renderManagementLeaveCard()}

//                     </div>

//                     <div className="mgt-card-small">
//                         {/* {renderSalaryIntelCard()} */}
//                         {/* {renderLeavePieChart()} */}
//                         <OneOnOneAnalyticsCard
//                             userData={userData}
//                             handleModuleChange={handleModuleChange}
//                         />





//                     </div>
//                 </div>

//                 <div className="mgt-dashboard-row row-second three-card-layout">

//                     <div className="mgt-card-medium">
//                         <div className="leave-card-content">
//                             {renderLeavePieChart()}
//                         </div>
//                     </div>

//                     <div className="mgt-card-medium">
//                         <div className="mgt-okrs">

//                             {renderOKRActivityCard()}
//                         </div>


//                     </div>

//                     <div className="mgt-card-medium">
//                         {renderManagementShortcutsCard()}
//                     </div>

//                 </div>
//             </div>




//         );
//     };

//     const currentEvent =
//         todayEvents && todayEvents.length > 0
//             ? todayEvents[currentEventIndex]
//             : null;


//     const combinedEvents = [];

//     // 🎊 Festival TODAY (Priority if festival is today)
//     if (upcomingFestival && isFestivalToday) {
//         combinedEvents.push({
//             type: "festival",
//             title: upcomingFestival.name,
//             tag: "FESTIVAL TODAY",
//             icon: "🎊",
//             sub: "Today 🎉"
//         });
//     }

//     // 🎂 Birthday / Anniversary
//     if (currentEvent && currentEvent.fullName) {
//         combinedEvents.push({
//             type: "event",
//             title: currentEvent.fullName,
//             tag: currentEvent.isBirthday ? "BIRTHDAY" : "WORK ANNIVERSARY",
//             icon: currentEvent.isBirthday ? "🎂" : "🎉"
//         });
//     }

//     // 🎊 Upcoming Festival (If future)
//     if (upcomingFestival && !isFestivalToday) {
//         combinedEvents.push({
//             type: "festival",
//             title: upcomingFestival.name,
//             tag: "UPCOMING FESTIVAL",
//             icon: "🎊",
//             sub: `In ${daysLeft} days`
//         });
//     }

//     useEffect(() => {
//         if (combinedEvents.length <= 1) return;

//         const interval = setInterval(() => {
//             setActiveEventIndex(prev => (prev + 1) % combinedEvents.length);
//         }, 4000);

//         return () => clearInterval(interval);
//     }, [combinedEvents.length]);

//     const activeEvent = combinedEvents[activeEventIndex];


//     return (

//         <div


//             className={`dash-container ${theme}-theme`}
//             style={
//                 theme === 'light'
//                     ? {
//                         backgroundImage: `url(${logoLight})`,
//                         backgroundSize: 'cover',
//                         backgroundRepeat: 'no-repeat',
//                         backgroundPosition: 'center',
//                         backgroundColor: 'var(--bg-main)'

//                     }
//                     : {}
//             }
//         >


//             {showMissedModal && (
//                 <div className="modal-overlay" onClick={() => setShowMissedModal(false)}>
//                     <div className="modal-card" onClick={(e) => e.stopPropagation()}>

//                         <h3>Missed 1:1 Meetings</h3>

//                         {mgmtOneOnOneData.filter(m => m.status === "MISSED").length === 0 ? (
//                             <p>No missed meetings 🎉</p>
//                         ) : (
//                             mgmtOneOnOneData
//                                 .filter(m => m.status === "MISSED")
//                                 .map((m, i) => (
//                                     <div key={i} className="missed-item">
//                                         <strong>{m.employee_name}</strong>
//                                         <span>{m.date}</span>
//                                     </div>
//                                 ))
//                         )}

//                         <button onClick={() => setShowMissedModal(false)}>
//                             Close
//                         </button>

//                     </div>
//                 </div>
//             )}



//             <div className="auth-background-overlay"></div>






//             <Sidebar
//                 role={role}
//                 userData={userData}
//                 activeModule={activeModule}
//                 openMenus={openMenus}
//                 toggleSubMenu={toggleSubMenu}
//                 handleModuleChange={handleModuleChange}
//                 handleLogout={handleLogout}
//                 mobileMenuOpen={mobileMenuOpen}
//                 setMobileMenuOpen={setMobileMenuOpen}
//                 pendingRequestsCount={pendingRequestsCount}
//             />

//             <main className="dash-content">

//                 <header className="content-header">

//                     {/* 🔷 LEFT */}
//                     <div className="header-left">
//                         <div className="header-text">

//                             <h1>
//                                 {activeModule === "grid" && !showProfile ? "Welcome," : ""}{" "}
//                                 <span className={theme === 'light' ? "name-light" : "name-accent"}>
//                                     {showProfile
//                                         ? "MY PROFILE"
//                                         : (activeModule === "grid"
//                                             ? userData.firstName || userData.FirstName
//                                             : (activeModule === "attendance"
//                                                 ? "LEAVE MANAGEMENT"
//                                                 : (activeModule === "one-on-one-report"
//                                                     ? "ONE-ON-ONE REPORT"
//                                                     : activeModule.toUpperCase().replace(/-/g, ' ')
//                                                 )
//                                             )
//                                         )
//                                     }
//                                 </span>
//                             </h1>

//                             {activeModule === 'attendance' && userData.joiningDate && (
//                                 <div className="joining-info">
//                                     JOINING_DATE: {new Date(userData.joiningDate).toLocaleDateString('en-GB').toUpperCase()}
//                                 </div>
//                             )}

//                         </div>
//                     </div>







//                     <div className="header-center">

//                         {/* TIME + DATE FIRST */}
//                         <div className="time-date-right">
//                             <div className="live-time">{currentTime}</div>

//                             <div className="today-widget">
//                                 <span>📅 {todayDate}</span>
//                                 <small>Have a Nice Day!</small>
//                             </div>
//                         </div>

//                         {/* EVENT CARD SECOND */}
//                         <div
//                             className={`executive-event-bar ${theme === 'light' ? 'light-theme-elite' : 'dark-theme-elite'}
//         ${role === "Management" || role === "Manager" ? "clickable" : ""}`}
//                             onClick={() => {
//                                 if (role === "Management" || role === "Manager") {
//                                     handleModuleChange("events-celebrations");
//                                 }
//                             }}
//                         >
//                             <div
//                                 className={`event-status-box ${activeEvent
//                                     ? (activeEvent.type === 'festival'
//                                         ? 'bg-fest'
//                                         : (activeEvent.tag === 'BIRTHDAY' ? 'bg-birth' : 'bg-anniv'))
//                                     : 'bg-neutral'
//                                     }`}
//                             >
//                                 <span className="event-icon-small">
//                                     {activeEvent ? activeEvent.icon : "✨"}
//                                 </span>
//                             </div>

//                             <div className="event-content-main">
//                                 <div className="event-label-row">
//                                     <span className="event-tag">
//                                         {activeEvent ? activeEvent.tag : "TODAY"}
//                                     </span>
//                                 </div>

//                                 <h3 className="event-title-text">

//                                     {activeEvent ? (
//                                         <span className="event-highlight">
//                                             {activeEvent.icon} {activeEvent.title}
//                                         </span>
//                                     ) : (
//                                         <span className="event-empty-text">
//                                             No events today
//                                         </span>
//                                     )}
//                                 </h3>
//                             </div>

//                             <div className="event-action-wrapper">
//                                 <button
//                                     className="minimal-wish-btn"
//                                     disabled={!currentEvent}
//                                     onClick={(e) => e.stopPropagation()}
//                                 >
//                                     <div className="btn-line"></div>
//                                 </button>
//                             </div>
//                         </div>

//                     </div>







//                     <div className="header-controls">

//                         {/* 🌗 THEME */}
//                         <div className="theme-switch-container">
//                             <label className="theme-slider-switch">
//                                 <input
//                                     type="checkbox"
//                                     onChange={toggleTheme}
//                                     checked={theme === 'light'}
//                                 />
//                                 <span className="theme-slider round">
//                                     <span className="sun-icon">☀️</span>
//                                     <span className="moon-icon">🌙</span>
//                                 </span>
//                             </label>
//                         </div>




//                         {(activeModule !== "grid" || showProfile) && (
//                             <button
//                                 className="back-btn"
//                                 onClick={() => handleModuleChange("grid")}
//                             >
//                                 Back
//                             </button>
//                         )}

//                     </div>

//                 </header>


//                 {activeModule === "grid" ? (

//                     role === "Management"
//                         ? renderManagementDashboard()
//                         : role === "Manager"
//                             ? renderManagerDashboard()   // 🔥 ADD THIS LINE
//                             : renderEmployeeDashboard()

//                 ) : (
//                     renderActiveModule()
//                 )}

//                 <div className="dash-footer">
//                     Design & Developed by Genesis Tech Engineers © 2026
//                 </div>
//             </main>

//             {(role === "Management" || role === "Manager") && (
//                 <>
//                     <div
//                         className="ai-chat-float-btn"
//                         onClick={() => setShowAIChat(true)}
//                     >
//                         🤖
//                     </div>

//                     {showAIChat && (
//                         <div className="ai-chat-modal">
//                             <div className="ai-chat-header">
//                                 <span>ELMS AI Assistant</span>
//                                 <button onClick={() => setShowAIChat(false)}>
//                                     ✕
//                                 </button>
//                             </div>

//                             <div className="ai-chat-body">
//                                 {chatMessages.map((msg, index) => (
//                                     <div
//                                         key={index}
//                                         className={`chat-bubble ${msg.sender}`}
//                                     >
//                                         <pre>{msg.text}</pre>
//                                     </div>
//                                 ))}

//                                 {chatLoading && (
//                                     <div className="chat-bubble ai">
//                                         Thinking...
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="ai-chat-footer">
//                                 <input
//                                     type="text"
//                                     value={chatInput}
//                                     onChange={(e) => setChatInput(e.target.value)}
//                                     placeholder="Ask anything..."
//                                     onKeyDown={(e) => {
//                                         if (e.key === "Enter") {
//                                             sendAIMessage();
//                                         }
//                                     }}
//                                 />

//                                 <button onClick={sendAIMessage}>
//                                     Send
//                                 </button>
//                             </div>
//                         </div>
//                     )}
//                 </>
//             )}

//             {/* 1️⃣ MANDATORY COMPANY POLICY ACKNOWLEDGEMENT MODAL (FIRST) */}
//             {showMandatoryPolicyModal && (
//                 <div className="mandatory-policy-fullscreen-overlay">
//                     {/* Top Header Bar */}
//                     <div className="mandatory-policy-topbar">
//                         <div className="topbar-title-area">
//                             <span className="topbar-icon">📜</span>
//                             <h2>Mandatory Company Policy Acknowledgement</h2>
//                         </div>

//                         <div className="topbar-progress-area">
//                             <div className="topbar-progress-text">
//                                 <span>Progress: <strong>{acknowledgedPoliciesCount}</strong> of <strong>{totalPoliciesCount}</strong> Policies Acknowledged</span>
//                                 <span className="topbar-badge">{unacknowledgedPolicies.length} Remaining</span>
//                             </div>
//                             <div className="topbar-progress-track">
//                                 <div
//                                     className="topbar-progress-fill"
//                                     style={{ width: `${totalPoliciesCount > 0 ? (acknowledgedPoliciesCount / totalPoliciesCount) * 100 : 0}%` }}
//                                 ></div>
//                             </div>
//                         </div>

//                         <button
//                             type="button"
//                             className="topbar-logout-btn"
//                             onClick={handleLogout}
//                         >
//                             🚪 Logout
//                         </button>
//                     </div>

//                     {/* Alerts */}
//                     {policyAckError && (
//                         <div className="mandatory-alert-box error" style={{ margin: '8px 24px 0 24px' }}>
//                             <span>⚠️ {policyAckError}</span>
//                         </div>
//                     )}

//                     {policyAckSuccessMsg && (
//                         <div className="mandatory-alert-box success" style={{ margin: '8px 24px 0 24px' }}>
//                             <span>✅ {policyAckSuccessMsg}</span>
//                         </div>
//                     )}

//                     {/* Full Screen Layout Body */}
//                     <div className="mandatory-policy-fullscreen-body">
//                         {/* Left Sidebar Menu */}
//                         <div className="mandatory-policy-sidebar">
//                             <h3>Company Policies ({(allPoliciesList.length > 0 ? allPoliciesList : GENESIS_POLICIES).length})</h3>
//                             <div className="mandatory-policy-list">
//                                 {(allPoliciesList.length > 0 ? allPoliciesList : GENESIS_POLICIES).map((p, idx) => {
//                                     const pTitle = p.title || p.policy_title;
//                                     const pIcon = p.icon || p.policy_icon || "📜";
//                                     const isAck = !!logs[pTitle];
//                                     const isSelected = selectedMandatoryPolicy && (selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title) === pTitle;

//                                     return (
//                                         <div
//                                             key={p.id || idx}
//                                             className={`mandatory-policy-item ${isSelected ? "active" : ""} ${isAck ? "signed" : ""}`}
//                                             onClick={() => {
//                                                 setSelectedMandatoryPolicy(p);
//                                                 setPolicyAgreed(false);
//                                             }}
//                                         >
//                                             <span className="p-item-icon">{pIcon}</span>
//                                             <span className="p-item-title">{pTitle}</span>
//                                             {isAck ? (
//                                                 <span className="p-item-tag ack">✅ Signed</span>
//                                             ) : (
//                                                 <span className="p-item-tag pending">Required</span>
//                                             )}
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         </div>

//                         {/* Right Main Policy Content Viewer */}
//                         <div className="mandatory-policy-fullscreen-viewer">
//                             {selectedMandatoryPolicy ? (
//                                 <>
//                                     <div className="mandatory-viewer-header">
//                                         <h3>
//                                             <span>{selectedMandatoryPolicy.icon || selectedMandatoryPolicy.policy_icon || "📜"}</span>
//                                             {selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title}
//                                             {logs[selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title] && (
//                                                 <span className="viewer-signed-badge">✅ Acknowledged</span>
//                                             )}
//                                         </h3>
//                                     </div>

//                                     {/* Full Height Scrollable Document Body */}
//                                     <div className="mandatory-policy-document-body">
//                                         {selectedMandatoryPolicy.content ? (
//                                             typeof selectedMandatoryPolicy.content === 'string' ? (
//                                                 <div dangerouslySetInnerHTML={{ __html: selectedMandatoryPolicy.content }} />
//                                             ) : (
//                                                 selectedMandatoryPolicy.content
//                                             )
//                                         ) : (
//                                             <p className="policy-placeholder">Please review the contents of this policy carefully before accepting.</p>
//                                         )}
//                                     </div>

//                                     {/* Fixed Bottom Action Section */}
//                                     <div className="mandatory-policy-bottom-action-bar">
//                                         {logs[selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title] ? (
//                                             <div className="mandatory-policy-signed-banner">
//                                                 <span>✅ Policy Acknowledged & Signed</span>
//                                             </div>
//                                         ) : (
//                                             <form onSubmit={handleAcknowledgeMandatoryPolicy} className="mandatory-ack-stacked-form">
//                                                 <label className="mandatory-checkbox-container">
//                                                     <input
//                                                         type="checkbox"
//                                                         checked={policyAgreed}
//                                                         onChange={(e) => setPolicyAgreed(e.target.checked)}
//                                                     />
//                                                     <span>
//                                                         I confirm that I have read, understood, and agree to abide by the terms of <strong>{selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title}</strong>.
//                                                     </span>
//                                                 </label>

//                                                 <button
//                                                     type="submit"
//                                                     className="mandatory-save-btn"
//                                                     disabled={!policyAgreed || policyAckSaving}
//                                                 >
//                                                     {policyAckSaving ? "Recording..." : "Acknowledge & Accept Policy ✅"}
//                                                 </button>
//                                             </form>
//                                         )}
//                                     </div>
//                                 </>
//                             ) : (
//                                 <div className="mandatory-policy-document-body">
//                                     <p>Select a policy from the list on the left to read and acknowledge.</p>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* 2️⃣ MANDATORY BANK DETAILS POPUP MODAL (SECOND) */}
//             {showMandatoryBankModal && !showMandatoryPolicyModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">🏦</div>
//                             <h2>Mandatory Bank Details Required</h2>
//                             <p>
//                                 Your employee bank record has missing information. Please fill in the required field(s) below for payroll & salary processing.
//                             </p>
//                         </div>

//                         {bankError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {bankError}</span>
//                             </div>
//                         )}

//                         {bankSuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {bankSuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryBankDetails} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingBankFields.bankName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Bank Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC Bank, ICICI Bank"
//                                             value={bankFormData.bankName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, bankName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.holderName && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Holder Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account holder name"
//                                             value={bankFormData.holderName}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, holderName: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accNumber && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter account number"
//                                             value={bankFormData.accNumber}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accNumber: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.ifsc && (
//                                     <div className="mandatory-input-group">
//                                         <label>IFSC Code <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="e.g. HDFC0001234"
//                                             value={bankFormData.ifsc}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, ifsc: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.branch && (
//                                     <div className="mandatory-input-group">
//                                         <label>Branch Name <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter branch name"
//                                             value={bankFormData.branch}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, branch: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingBankFields.accType && (
//                                     <div className="mandatory-input-group">
//                                         <label>Account Type <span className="req-star">*</span></label>
//                                         <select
//                                             value={bankFormData.accType}
//                                             onChange={(e) => setBankFormData(prev => ({ ...prev, accType: e.target.value }))}
//                                             required
//                                         >
//                                             <option value="Saving Account">Saving Account</option>
//                                             <option value="Current Account">Current Account</option>
//                                             <option value="Salary Account">Salary Account</option>
//                                         </select>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={bankSaving}
//                                 >
//                                     {bankSaving ? "Saving Bank Details..." : "Save Bank Details & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}

//             {/* 3️⃣ MANDATORY PROFILE POPUP MODAL (THIRD) */}
//             {showMandatoryProfileModal && !showMandatoryPolicyModal && !showMandatoryBankModal && (
//                 <div className="mandatory-profile-modal-overlay">
//                     <div className="mandatory-profile-modal-card">
//                         <div className="mandatory-modal-header">
//                             <div className="mandatory-warning-icon">⚠️</div>
//                             <h2>Mandatory Profile Completion Required</h2>
//                             <p>
//                                 Your employee profile has missing information. Please fill in the required field(s) below to continue using the system.
//                             </p>
//                         </div>

//                         {mandatoryError && (
//                             <div className="mandatory-alert-box error">
//                                 <span>⚠️ {mandatoryError}</span>
//                             </div>
//                         )}

//                         {mandatorySuccessMsg && (
//                             <div className="mandatory-alert-box success">
//                                 <span>✅ {mandatorySuccessMsg}</span>
//                             </div>
//                         )}

//                         <form onSubmit={handleSaveMandatoryProfile} className="mandatory-profile-form">
//                             <div className="mandatory-form-grid">
//                                 {missingProfileFields.phone && (
//                                     <div className="mandatory-input-group">
//                                         <label>Mobile Number <span className="req-star">*</span></label>
//                                         <input
//                                             type="tel"
//                                             placeholder="Enter mobile number"
//                                             value={mandatoryFormData.phone}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, phone: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.dob && (
//                                     <div className="mandatory-input-group">
//                                         <label>Date of Birth <span className="req-star">*</span></label>
//                                         <input
//                                             type="date"
//                                             max={new Date().toISOString().split("T")[0]}
//                                             value={mandatoryFormData.dob}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, dob: e.target.value }))}
//                                             onClick={(e) => {
//                                                 try {
//                                                     if (e.target.showPicker) e.target.showPicker();
//                                                 } catch (err) { }
//                                             }}
//                                             required
//                                             className="mandatory-date-input"
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.city && (
//                                     <div className="mandatory-input-group">
//                                         <label>City <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter city"
//                                             value={mandatoryFormData.city}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, city: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.country && (
//                                     <div className="mandatory-input-group">
//                                         <label>Country <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter country"
//                                             value={mandatoryFormData.country}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, country: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Permanent Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter permanent address"
//                                             value={mandatoryFormData.address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}

//                                 {missingProfileFields.local_address && (
//                                     <div className="mandatory-input-group full-width">
//                                         <label>Current / Local Address <span className="req-star">*</span></label>
//                                         <input
//                                             type="text"
//                                             placeholder="Enter current / local address"
//                                             value={mandatoryFormData.local_address}
//                                             onChange={(e) => setMandatoryFormData(prev => ({ ...prev, local_address: e.target.value }))}
//                                             required
//                                         />
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="mandatory-modal-footer">
//                                 <button
//                                     type="submit"
//                                     className="mandatory-save-btn"
//                                     disabled={mandatorySaving}
//                                 >
//                                     {mandatorySaving ? "Saving Profile..." : "Save Profile & Continue →"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="mandatory-logout-btn"
//                                     onClick={handleLogout}
//                                 >
//                                     🚪 Logout
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Dashboard;







































import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';

import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip
} from "recharts";
import { Bar as ChartBar, Pie, Doughnut } from 'react-chartjs-2';

// ✅ REACT + ROUTER
import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

// ✅ MODULES
import Attendance from '../../modules/Attendance';
import PayBenefits from '../../modules/PayBenefits';
import OKRTracker from '../../modules/OKRTracker';
import CareerPathways from '../../modules/CareerPathways';
import EquipmentRequest from '../../modules/EquipmentRequest';
import OfficeRequisition from '../../modules/OfficeRequisition';
import ITSupport from '../../modules/ITSupport';
import Documents from '../../modules/Documents';
import CompanyPolicy, { GENESIS_POLICIES } from '../../modules/CompanyPolicy';
import OrgChart from '../../modules/OrgChart';
import CampusInfo from '../../modules/CampusInfo';
import AddDepartment from '../../modules/AddDepartment';
import AddEmployee from '../../modules/AddEmployee';
import ManageDepartment from '../../modules/ManageDepartment';
import ManageEmployee from '../../modules/ManageEmployee';
import MyProfile from '../../modules/MyProfile';
import LeaveManagement from '../../modules/LeaveManagement';
import EESExperience from '../../modules/EESExperience';
import EESFeedbackManagement from '../../modules/EESFeedbackManagement';
import MedicalReports from '../../modules/MedicalReports';
import ManagementOKRViewer from '../../modules/ManagementOKRViewer';
import ManagerLeaveManagement from '../../modules/ManagerLeaveManagement';
import ManagerMedicalReports from '../../modules/ManagerMedicalReports';
import EmployeeSalaryBenefits from '../../modules/EmployeeSalaryBenefits';
import PolicyAdminDashboard from '../../modules/PolicyAdminDashboard';
import ManageEmployeeDocs from '../../modules/ManageEmployeeDocs';
import OneOnOne from '../../modules/OneOnOne';
import EventsCelebrations from '../../modules/EventsCelebrations';
import ProjectModule from '../../modules/ProjectModule';
import QuarterlyUpdates from '../../modules/QuarterlyUpdates';
import ManagementQuarterlyUpdate from '../../modules/ManagementQuarterlyUpdate';
import ReimbursementManagement from '../../modules/ReimbursementManagement';
import WorkFromHome from '../../modules/WorkFromHome';
import WFHManagement from '../../modules/WFHManagement';
import OneOnOneAnalyticsCard from "../../modules/OneOnOneAnalyticsCard";
import OneOnOneReport from '../../modules/OneOnOneReport';
import InvoiceGenerator from '../../modules/InvoiceGenerator';
import AttendanceTracker from '../../modules/AttendanceTracker';
import CompanySetup from '../../modules/CompanySetup';
import AwardNominations from '../../modules/AwardNominations';
import AwardAnalyticsDashboard from '../../modules/AwardAnalyticsDashboard';
import Sidebar from "../../components/Sidebar/sidebar";

// ✅ ASSETS
import logoLight from '../../assets/logowhite-p.png';
import logoDark from '../../assets/logo-white-r.png';

// ✅ STYLES
import './Dashboard.css';


// ✅ CHART.JS CORE
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip as ChartTooltip,  // ✅ rename this
    Legend,
    CategoryScale,
    LinearScale,
    BarElement
} from 'chart.js';

// ✅ REGISTER CHART.JS
ChartJS.register(
    ArcElement,
    ChartTooltip, // ✅ use renamed one
    Legend,
    CategoryScale,
    LinearScale,
    BarElement
);



const QuarterlyCard = ({ handleModuleChange }) => {

    const [latest, setLatest] = React.useState(null);

    React.useEffect(() => {
        fetch(
            "/gt-api/get_quarterly_media.php?type=ACM Presentation",
            {
                credentials: "include"
            }
        )
            .then(res => res.json())
            .then(data => {

                console.log(
                    "ACM DATA:",
                    data
                );

                if (data.success && data.data.length > 0) {
                    setLatest(data.data[0]);
                }
            })
            .catch(err => console.error("Quarterly Fetch Error:", err));
    }, []);

    console.log("LATEST ACM:", latest);

    return (
        <div
            className="quarterly-pro-card clickable"
            onClick={() => handleModuleChange("quarterly-updates")}
        >
            {/* Glow Layer */}
            <div className="card-glow"></div>

            {/* HEADER */}
            <div className="qp-header">
                <div className="qp-left">
                    <span className="qp-tag">ACM Updates</span>
                    <h3 className="qp-title">Quarterly Insights</h3>
                </div>

                <div className="qp-icon">📢</div>
            </div>

            {/* BODY */}
            <div className="qp-body">
                {latest ? (
                    <>
                        <h4 className="qp-main-title">{latest.title}</h4>

                        <div className="qp-meta">
                            <span className="qp-date">
                                {new Date(latest.created_at).toLocaleDateString('en-GB')}
                            </span>
                            <span className="qp-badge">NEW</span>
                        </div>
                    </>
                ) : (
                    <div className="qp-empty">
                        <div className="qp-loader"></div>
                        <span>Awaiting next update</span>
                    </div>
                )}
            </div>

            {/* FOOTER */}
            <div className="qp-footer">
                <span>View Presentation</span>
                <span className="arrow">→</span>
            </div>
        </div>
    );
};


const Dashboard = () => {
    const [dashboardDepartments, setDashboardDepartments] = useState([]);
    const [dashboardPathways, setDashboardPathways] = useState([]);
    const [policyCount, setPolicyCount] = useState(0);

    const [showAIChat, setShowAIChat] = useState(false);

    const [chatMessages, setChatMessages] = useState([
        {
            sender: "ai",
            text: "Hello 👋 Ask me anything about your ELMS database."
        }
    ]);

    const [chatInput, setChatInput] = useState("");
    const [chatLoading, setChatLoading] = useState(false);



    const [showMissedModal, setShowMissedModal] = useState(false);

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [todayEvents, setTodayEvents] = useState([]);
    useEffect(() => {
        const fetchTodayEvents = async () => {
            try {
                const res = await fetch('/gt-api/get_celebrations.php');
                const data = await res.json();

                if (data.success) {
                    setTodayEvents(data.data || []);
                }
            } catch (err) {
                console.error("Dashboard Events Error:", err);
            }
        };

        fetchTodayEvents();
    }, []);
    const [currentEventIndex, setCurrentEventIndex] = useState(0);
    useEffect(() => {
        if (!todayEvents || todayEvents.length <= 1) return;

        const interval = setInterval(() => {
            setCurrentEventIndex((prev) =>
                (prev + 1) % todayEvents.length
            );
        }, 3000); // change every 3 sec

        return () => clearInterval(interval);
    }, [todayEvents]);


    const [equipmentData, setEquipmentData] = useState({
        total: 0,
        pending: 0,
        blocking: 0
    });



    const [logs, setLogs] = useState({});

    const totalPolicies = 11;
    const readCount = Object.keys(logs || {}).length;

    const progress = totalPolicies > 0
        ? Math.round((readCount / totalPolicies) * 100)
        : 0;


    const params = useParams();
    const module = params.module;

    const storedUser = JSON.parse(localStorage.getItem("userData"));
    const role = storedUser?.role;
    const navigate = useNavigate();

    useEffect(() => {
        const storedUser = localStorage.getItem("userData");

        if (!storedUser) {
            navigate("/", { replace: true });
            return;
        }

        // prevent back button access after logout
        window.history.pushState(null, "", window.location.href);
        window.onpopstate = function () {
            const user = localStorage.getItem("userData");
            if (!user) {
                navigate("/", { replace: true });
            }
        };

    }, [navigate]);







    const [policyLogs, setPolicyLogs] = useState({});





    const checkIfFestivalIsToday = (festival, daysLeftVal, isTodayFlag) => {
        if (!festival) return false;
        if (isTodayFlag === true || daysLeftVal === 0) return true;

        if (festival.date) {
            const today = new Date();
            const currentDay = today.getDate();
            const currentMonth = today.getMonth();
            const monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
            const currentMonthName = monthNames[currentMonth];

            const dateLower = String(festival.date).trim().toLowerCase();

            // 1. Text Month Matching (e.g., "7th Sep", "7 Sep", "2nd to 10th Oct")
            if (dateLower.includes(currentMonthName) || (currentMonthName === "sep" && dateLower.includes("sept"))) {
                const rangeMatch = dateLower.match(/(\d+)\s*(?:st|nd|rd|th)?\s*to\s*(\d+)\s*(?:st|nd|rd|th)?/);
                if (rangeMatch) {
                    const startDay = parseInt(rangeMatch[1], 10);
                    const endDay = parseInt(rangeMatch[2], 10);
                    if (currentDay >= startDay && currentDay <= endDay) {
                        return true;
                    }
                }

                const numbers = dateLower.match(/\d+/g);
                if (numbers) {
                    for (let numStr of numbers) {
                        const num = parseInt(numStr, 10);
                        if (num === currentDay) {
                            return true;
                        }
                    }
                }
            }

            // 2. Numeric Date Matching (e.g., "7-9-2026", "07-09-2026", "7/9/2026", "2026-09-07")
            const numMatch = dateLower.match(/^(\d{1,4})[-/.](\d{1,2})[-/.](\d{1,4})$/);
            if (numMatch) {
                let p1 = parseInt(numMatch[1], 10);
                let p2 = parseInt(numMatch[2], 10);
                let p3 = parseInt(numMatch[3], 10);

                let d, m;
                if (p1 > 31) {
                    m = p2; d = p3;
                } else {
                    d = p1; m = p2;
                }

                if (d === currentDay && m === (currentMonth + 1)) {
                    return true;
                }
            }
        }

        if (typeof daysLeftVal === 'number' && daysLeftVal === 0) {
            return true;
        }

        return false;
    };

    const [upcomingFestival, setUpcomingFestival] = useState(null);
    const [daysLeft, setDaysLeft] = useState(null);
    const [isFestivalToday, setIsFestivalToday] = useState(false);
    const [activeEventIndex, setActiveEventIndex] = useState(0);
    useEffect(() => {
        fetch("/gt-api/get_upcoming_festival.php", {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                const fest = data.festival || data.upcoming || (data.data && data.data[0]);
                if (fest) {
                    const normalized = {
                        ...fest,
                        name: fest.name || fest.festival_name || fest.title || "Festival",
                        image: fest.image || fest.img || fest.imageName || ""
                    };
                    setUpcomingFestival(normalized);
                    setDaysLeft(data.daysLeft ?? 0);
                    const festIsToday = data.isToday || data.daysLeft === 0 || checkIfFestivalIsToday(normalized, data.daysLeft, data.isToday);
                    setIsFestivalToday(festIsToday);
                }
            })
            .catch(err => console.error(err));
    }, []);


    const location = useLocation();



    const [showProfile, setShowProfile] = useState(false);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const [activeModule, setActiveModule] = useState(module || "grid");
    const [isLightMode, setIsLightMode] = useState(false);

    const [openMenus, setOpenMenus] = useState({
        department: false,
        employee: false
    });

    const [pendingRequestsCount, setPendingRequestsCount] = useState(0);
    const [pendingLeavesCount, setPendingLeavesCount] = useState(0);
    const [requestsList, setRequestsList] = useState([]);
    const [notifCount, setNotifCount] = useState(0);

    const [eesSubmissions, setEesSubmissions] = useState([]);
    const handleEESSubmit = (newFeedback) => {
        setEesSubmissions(prev => [...prev, newFeedback]);
    };

    const [passwordForm, setPasswordForm] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    const [showMandatoryProfileModal, setShowMandatoryProfileModal] = useState(false);
    const [missingProfileFields, setMissingProfileFields] = useState({
        phone: false,
        dob: false,
        city: false,
        address: false,
        local_address: false,
        country: false
    });
    const [mandatoryFormData, setMandatoryFormData] = useState({
        phone: '',
        dob: '',
        city: '',
        address: '',
        local_address: '',
        country: ''
    });
    const [mandatorySaving, setMandatorySaving] = useState(false);
    const [mandatoryError, setMandatoryError] = useState('');
    const [mandatorySuccessMsg, setMandatorySuccessMsg] = useState('');

    // 🔴 MANDATORY BANK DETAILS MODAL STATE
    const [showMandatoryBankModal, setShowMandatoryBankModal] = useState(false);
    const [missingBankFields, setMissingBankFields] = useState({
        bankName: false,
        holderName: false,
        accNumber: false,
        ifsc: false,
        branch: false,
        accType: false
    });
    const [bankFormData, setBankFormData] = useState({
        bankName: '',
        holderName: '',
        accNumber: '',
        ifsc: '',
        branch: '',
        accType: 'Saving Account'
    });
    const [bankSaving, setBankSaving] = useState(false);
    const [bankError, setBankError] = useState('');
    const [bankSuccessMsg, setBankSuccessMsg] = useState('');

    // 📜 MANDATORY COMPANY POLICY ACKNOWLEDGEMENT MODAL STATE
    const [showMandatoryPolicyModal, setShowMandatoryPolicyModal] = useState(false);
    const [allPoliciesList, setAllPoliciesList] = useState([]);
    const [unacknowledgedPolicies, setUnacknowledgedPolicies] = useState([]);
    const [selectedMandatoryPolicy, setSelectedMandatoryPolicy] = useState(null);
    const [policyAckSaving, setPolicyAckSaving] = useState(false);
    const [policyAckError, setPolicyAckError] = useState('');
    const [policyAckSuccessMsg, setPolicyAckSuccessMsg] = useState('');
    const [totalPoliciesCount, setTotalPoliciesCount] = useState(11);
    const [acknowledgedPoliciesCount, setAcknowledgedPoliciesCount] = useState(0);
    const [policyAgreed, setPolicyAgreed] = useState(false);
    const [docRestrictionInfo, setDocRestrictionInfo] = useState(null);




    const [userData, setUserData] = useState(() => {
        const storedData = localStorage.getItem("userData");
        if (storedData) return JSON.parse(storedData);

        const firstName = location.state?.userName?.split(' ')[0] || "User";
        const lastName = location.state?.userName?.split(' ')[1] || "";

        return {
            firstName,
            lastName,
            email: "",
            dept: "Loading...",
            phone: "",
            gender: "",
            dob: "",
            address: "",
            city: "",
            country: "",
            employeeId: location.state?.empId || null,
            profileImage: null,
            joiningDate: null,
            HOD: null
        };
    });


    useEffect(() => {

        const email =
            userData?.EmailId || "";

        const isGenesis =
            email.toLowerCase().includes("genesistech.co.in") ||
            email.toLowerCase().includes("gtecorpgroup.com") ||
            email.toLowerCase().includes("gtcorpgroup.com");

        if (isGenesis) return;

        fetch(
            "/gt-api/get_career_pathways.php",
            {
                credentials: "include"
            }
        )
            .then(res => res.json())
            .then(data => {

                if (data.success) {

                    setDashboardPathways(
                        data.pathways || []
                    );

                }

            })
            .catch(console.error);

    }, [userData]);


    useEffect(() => {

        const email =
            userData?.EmailId || "";

        const isGenesis =
            email.toLowerCase().includes("genesistech.co.in") ||
            email.toLowerCase().includes("gtecorpgroup.com") ||
            email.toLowerCase().includes("gtcorpgroup.com");

        if (isGenesis) return;

        fetch(
            "/gt-api/get_departments.php",
            {
                credentials: "include"
            }
        )
            .then(res => res.json())
            .then(data => {

                console.log(
                    "DASHBOARD DEPARTMENTS:",
                    data
                );

                if (data.success) {

                    setDashboardDepartments(
                        data.departments || []
                    );

                }

            })
            .catch(console.error);

    }, [userData]);


    useEffect(() => {

        const email =
            userData?.EmailId || "";

        const isGenesis =
            email.toLowerCase().includes("genesistech.co.in") ||
            email.toLowerCase().includes("gtecorpgroup.com") ||
            email.toLowerCase().includes("gtcorpgroup.com");

        if (isGenesis) {

            setPolicyCount(11);
            return;

        }

        fetch(
            "/gt-api/get_policies.php",
            {
                credentials: "include"
            }
        )
            .then(res => res.json())
            .then(data => {

                if (data.success) {

                    setPolicyCount(
                        data.policies?.length || 0
                    );

                }

            })
            .catch(console.error);

    }, [userData]);
    // ✅ THEN use it
    const employeeId = userData?.id || userData?.employeeId;


    useEffect(() => {
        const fetchLeaveDashboardData = async () => {
            if (!employeeId) return;

            try {
                const res = await fetch(`/gt-api/get_leaves.php?empid=${employeeId}`,
                    {
                        credentials: "include"
                    }
                );
                const data = await res.json();

                const wfhRes = await fetch(`/gt-api/get_wfh.php?empid=${employeeId}`, {
                    credentials: "include"
                });
                const wfhData = await wfhRes.json();

                if (data.success) {
                    const leaves = data.leaves || [];

                    // 🔥 SAME LOGIC AS ATTENDANCE
                    const today = new Date();
                    const currentYear = today.getFullYear();

                    const fiscalYearStart = new Date(currentYear, 3, 1);

                    const activeFiscalYearStart =
                        today < fiscalYearStart
                            ? new Date(currentYear - 1, 3, 1)
                            : fiscalYearStart;

                    // ✅ Dynamic Sick Total (joining based)
                    let sickTotal = 12;

                    if (userData?.joiningDate) {
                        const joining = new Date(userData.joiningDate);

                        const fyEnd = new Date(activeFiscalYearStart);
                        fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
                        fyEnd.setMonth(2);
                        fyEnd.setDate(31);

                        if (joining > activeFiscalYearStart) {
                            if (joining > fyEnd) {
                                sickTotal = 0;
                            } else {
                                const joinMonth = joining.getMonth();
                                const fyEndMonth = 2;

                                let monthsRemaining;

                                if (joinMonth <= fyEndMonth) {
                                    monthsRemaining = fyEndMonth - joinMonth + 1;
                                } else {
                                    monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
                                }

                                sickTotal = monthsRemaining;
                            }
                        }
                    }

                    let sickUsed = 0;
                    let earnedUsed = 0;

                    leaves.forEach(leave => {
                        const status = String(leave.Status);
                        const days = parseFloat(leave.total) || 0;
                        const leaveDate = new Date(leave.fromdate);
                        const medStatus = String(leave.medical_doc_status);

                        // ✅ SAME CONDITION AS ATTENDANCE
                        if (status === '0' || status === '1') {

                            if (leave.leavetype === 'Sick Leave') {
                                if (leaveDate >= activeFiscalYearStart) {
                                    sickUsed += days;
                                }
                            }

                            else if (leave.leavetype === 'Earned Leave') {

                                // 🔥 MEDICAL CONVERSION LOGIC
                                if (medStatus === '1' || medStatus === '0') {
                                    if (leaveDate >= activeFiscalYearStart) {
                                        sickUsed += days;
                                    }
                                } else {
                                    earnedUsed += days;
                                }
                            }
                        }
                    });


                    console.log("LEAVES:", leaves);
                    console.log("SICK USED:", sickUsed);
                    console.log("EARNED USED:", earnedUsed);
                    console.log("API EARNED BALANCE:", data.earned);

                    setLeaveData({
                        leaveHistory: leaves,
                        leaveBalances: {
                            sick: { used: sickUsed, total: sickTotal },
                            earned: { used: earnedUsed, total: parseFloat(data.earned) || 0 }
                        },
                        wfhHistory: wfhData.requests || []
                    });
                }

            } catch (err) {
                console.error("Dashboard Leave Fetch Error:", err);
            }
        };

        fetchLeaveDashboardData();
    }, [employeeId, userData?.joiningDate]);


    useEffect(() => {
        setActiveModule(module || "grid");
    }, [module]);

    useEffect(() => {

        if (role === 'Management' || role === 'Manager') {

            const fetchRealTimeLeaves = async () => {
                try {

                    const res = await fetch("/gt-api/get_all_leaves.php", {
                        credentials: "include"
                    });
                    const data = await res.json();

                    if (data.success && data.leaves) {
                        // Count requests with Status '0' or null
                        const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
                        setPendingLeavesCount(count);
                    }
                } catch (err) {
                    console.error("Real-time Fetch Error:", err);
                }
            };


            fetchRealTimeLeaves();


            const liveInterval = setInterval(fetchRealTimeLeaves, 5000);

            return () => clearInterval(liveInterval);
        }
    }, [role]);



    useEffect(() => {

        const fetchUserData = async () => {

            try {

                const response = await fetch("/gt-api/get_profile.php", {
                    credentials: "include"
                });

                const data = await response.json();

                if (data.success && data.employee) {

                    const storedUser = JSON.parse(localStorage.getItem("userData"));

                    const updatedUser = {
                        id: data.employee.id,
                        EmpId: data.employee.EmpId,

                        firstName: data.employee.FirstName,
                        FirstName: data.employee.FirstName,

                        lastName: data.employee.LastName,
                        LastName: data.employee.LastName,

                        email: data.employee.EmailId,
                        EmailId: data.employee.EmailId,

                        Department: data.employee.DepartmentName || data.employee.Department,

                        HOD: data.employee.HOD,
                        Designation: data.employee.Designation,
                        phone: data.employee.Phonenumber,
                        gender: data.employee.Gender,
                        dob: data.employee.Dob,
                        address: data.employee.Address,
                        local_address: data.employee.LocalAddress,
                        city: data.employee.City,
                        country: data.employee.Country,
                        profileImage: data.employee.ProfilePicture || null,
                        joiningDate: data.employee.JoiningDate,
                        probation_status: data.employee.probation_status || 'Probation',
                        probation_feedback_sent_at: data.employee.probation_feedback_sent_at || null,
                        probation_feedback_sent_by: data.employee.probation_feedback_sent_by || null,

                        role: storedUser?.role
                    };

                    setUserData(updatedUser);

                    localStorage.setItem("userData", JSON.stringify(updatedUser));

                    // ✅ CHECK ONLY MISSING MANDATORY PROFILE FIELDS
                    const isMissing = (val) => !val || String(val).trim() === '' || String(val).trim() === '0000-00-00';
                    const missing = {
                        phone: isMissing(updatedUser.phone),
                        dob: isMissing(updatedUser.dob),
                        city: isMissing(updatedUser.city),
                        address: isMissing(updatedUser.address),
                        local_address: isMissing(updatedUser.local_address),
                        country: isMissing(updatedUser.country)
                    };

                    if (Object.values(missing).some(Boolean)) {
                        setMissingProfileFields(missing);
                        setMandatoryFormData({
                            phone: updatedUser.phone || '',
                            dob: updatedUser.dob || '',
                            city: updatedUser.city || '',
                            address: updatedUser.address || '',
                            local_address: updatedUser.local_address || '',
                            country: updatedUser.country || ''
                        });
                        setShowMandatoryProfileModal(true);
                    }

                    // 🏦 CHECK MANDATORY BANK DETAILS
                    const empIdForBank = data.employee.id || data.employee.EmpId;
                    if (empIdForBank) {
                        let bank = null;
                        try {
                            const bankRes = await fetch(`/gt-api/get_bank_details.php?emp_id=${empIdForBank}`, {
                                credentials: "include"
                            });
                            const rawText = await bankRes.text();
                            try {
                                const json = JSON.parse(rawText);
                                if (json && (json.success || json.bank || json.bank_name || json.bankName)) {
                                    bank = json.bank || json.data || json.details || json.employee_bank_details || json;
                                }
                            } catch (parseErr) {
                                console.log("get_bank_details json parse error:", parseErr);
                            }
                        } catch (bErr) {
                            console.error("Bank details fetch network error:", bErr);
                        }

                        const b = bank || {};

                        const getVal = (...keys) => {
                            for (const k of keys) {
                                if (b[k] !== undefined && b[k] !== null && String(b[k]).trim() !== '') {
                                    return String(b[k]).trim();
                                }
                            }
                            return '';
                        };

                        const bankNameVal = getVal('bankName', 'bank_name', 'BankName', 'Bankname');
                        const holderNameVal = getVal('holderName', 'holder_name', 'HolderName', 'account_holder_name', 'AccountHolderName');
                        const accNumberVal = getVal('accNumber', 'account_number', 'AccountNumber', 'AccNumber', 'account_no', 'AccountNo');
                        const ifscVal = getVal('ifsc', 'ifsc_code', 'IFSC', 'Ifsc', 'IfscCode');
                        const branchVal = getVal('branch', 'branch_name', 'Branch', 'BranchName');
                        const accTypeVal = getVal('accType', 'account_type', 'AccountType', 'AccType');

                        const isBankMissing = (val) => !val || String(val).trim() === '';

                        const missingBank = {
                            bankName: isBankMissing(bankNameVal),
                            holderName: isBankMissing(holderNameVal),
                            accNumber: isBankMissing(accNumberVal),
                            ifsc: isBankMissing(ifscVal),
                            branch: isBankMissing(branchVal),
                            accType: isBankMissing(accTypeVal)
                        };

                        console.log("MANDATORY BANK CHECK RESULT:", { empId: empIdForBank, bankData: b, missingBank });

                        if (Object.values(missingBank).some(Boolean)) {
                            setMissingBankFields(missingBank);
                            setBankFormData({
                                bankName: bankNameVal,
                                holderName: holderNameVal || `${data.employee.FirstName || ''} ${data.employee.LastName || ''}`.trim(),
                                accNumber: bankNameVal ? accNumberVal : '',
                                ifsc: ifscVal,
                                branch: branchVal,
                                accType: accTypeVal || 'Saving Account'
                            });
                            setShowMandatoryBankModal(true);
                        }
                    }

                    // 📜 CHECK MANDATORY POLICY ACKNOWLEDGEMENTS
                    const empIdForPolicy = data.employee.EmpId || data.employee.id || data.employee.employeeId;
                    if (empIdForPolicy) {
                        try {
                            const email = data.employee.EmailId || storedUser?.email || "";
                            const isGenesis =
                                email.toLowerCase().includes("genesistech.co.in") ||
                                email.toLowerCase().includes("gtecorpgroup.com") ||
                                email.toLowerCase().includes("gtcorpgroup.com");

                            let allPolicyList = [];
                            if (isGenesis) {
                                allPolicyList = GENESIS_POLICIES;
                            } else {
                                try {
                                    const pRes = await fetch("/gt-api/get_policies.php", { credentials: "include" });
                                    const pData = await pRes.json();
                                    if (pData.success && Array.isArray(pData.policies) && pData.policies.length > 0) {
                                        allPolicyList = pData.policies.map((p, idx) => ({
                                            id: p.id || idx + 1,
                                            title: p.policy_title || p.title,
                                            icon: p.policy_icon || p.icon || "📜",
                                            content: p.content || p.policy_content || null
                                        }));
                                    } else {
                                        allPolicyList = GENESIS_POLICIES;
                                    }
                                } catch (pErr) {
                                    allPolicyList = GENESIS_POLICIES;
                                }
                            }

                            const logRes = await fetch(`/gt-api/acknowledgepolicy.php?empId=${empIdForPolicy}`, {
                                credentials: "include"
                            });
                            const logData = await logRes.json();
                            const logsArray = Array.isArray(logData?.logs) ? logData.logs : [];
                            const logsMap = logsArray.reduce((acc, curr) => {
                                if (curr?.policy_title) {
                                    acc[curr.policy_title] = true;
                                }
                                return acc;
                            }, {});

                            setLogs(logsMap);
                            setAllPoliciesList(allPolicyList);

                            const unack = allPolicyList.filter(p => !logsMap[p.title || p.policy_title]);
                            setTotalPoliciesCount(allPolicyList.length);
                            setAcknowledgedPoliciesCount(allPolicyList.length - unack.length);

                            if (unack.length > 0) {
                                setUnacknowledgedPolicies(unack);
                                setSelectedMandatoryPolicy(unack[0]);
                                setShowMandatoryPolicyModal(true);
                            }
                        } catch (polErr) {
                            console.error("Mandatory policy check error:", polErr);
                        }
                    }
                }

                // 📁 CHECK MANDATORY DOCUMENT SUBMISSION RESTRICTION (Management & Manager are NEVER locked)
                const currentRole = (role || "").toLowerCase();
                if (currentRole !== "management" && currentRole !== "manager") {
                    const targetId = data.employee?.EmpId || data.employee?.empId || data.employee?.id || storedUser?.EmpId || storedUser?.empId || storedUser?.id;
                    if (targetId) {
                        try {
                            const docRes = await fetch(`/gt-api/check_employee_doc_restriction.php?emp_id=${encodeURIComponent(targetId)}&role=${encodeURIComponent(role)}`);
                            const docCheck = await docRes.json();
                            if (docCheck && docCheck.restricted) {
                                setDocRestrictionInfo(docCheck);
                            } else {
                                setDocRestrictionInfo(null);
                            }
                        } catch (dErr) {
                            console.error("Document compliance check error:", dErr);
                        }
                    }
                }

            } catch (error) {
                console.error("Database Error:", error);
            }

        };

        fetchUserData();

    }, []);

    // 🔒 LOCK BODY SCROLL WHEN MANDATORY MODAL IS OPEN
    useEffect(() => {
        if (showMandatoryProfileModal || showMandatoryBankModal || showMandatoryPolicyModal) {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        };
    }, [showMandatoryProfileModal, showMandatoryBankModal, showMandatoryPolicyModal]);

    const handleAcknowledgeMandatoryPolicy = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (!selectedMandatoryPolicy) return;
        const targetTitle = selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title;
        if (!targetTitle) return;

        setPolicyAckError('');
        setPolicyAckSaving(true);

        try {
            const empBadgeId = userData?.EmpId || userData?.employeeId || userData?.id;
            const fullName = `${userData?.FirstName || userData?.firstName || ''} ${userData?.LastName || userData?.lastName || ''}`.trim();

            const response = await fetch("/gt-api/acknowledgepolicy.php", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    empId: empBadgeId,
                    fullName: fullName,
                    policyTitle: targetTitle
                }),
            });

            const result = await response.json();
            if (result.status === "success" || result.success) {
                setPolicyAckSuccessMsg(`Policy "${targetTitle}" acknowledged successfully!`);

                setLogs(prev => ({ ...prev, [targetTitle]: true }));

                const remaining = unacknowledgedPolicies.filter(
                    p => (p.title || p.policy_title) !== targetTitle
                );
                setUnacknowledgedPolicies(remaining);
                setAcknowledgedPoliciesCount(prev => prev + 1);
                setPolicyAgreed(false);

                setTimeout(() => {
                    setPolicyAckSuccessMsg('');
                    if (remaining.length > 0) {
                        setSelectedMandatoryPolicy(remaining[0]);
                    } else {
                        setShowMandatoryPolicyModal(false);
                    }
                }, 1000);
            } else {
                setPolicyAckError(result.message || "Could not save policy acknowledgement.");
            }
        } catch (err) {
            console.error("Policy ack error:", err);
            setPolicyAckError("Failed to connect to server to record policy acknowledgement.");
        } finally {
            setPolicyAckSaving(false);
        }
    };

    const handleSaveMandatoryProfile = async (e) => {
        e.preventDefault();
        setMandatoryError('');

        const { phone, dob, city, address, local_address, country } = mandatoryFormData;

        if (missingProfileFields.phone && (!phone || !phone.trim())) {
            setMandatoryError('Please enter your Mobile Number.');
            return;
        }
        if (missingProfileFields.dob && (!dob || !dob.trim() || dob === '0000-00-00')) {
            setMandatoryError('Please select your Date of Birth.');
            return;
        }
        if (missingProfileFields.city && (!city || !city.trim())) {
            setMandatoryError('Please enter your City.');
            return;
        }
        if (missingProfileFields.country && (!country || !country.trim())) {
            setMandatoryError('Please enter your Country.');
            return;
        }
        if (missingProfileFields.address && (!address || !address.trim())) {
            setMandatoryError('Please enter your Permanent Address.');
            return;
        }
        if (missingProfileFields.local_address && (!local_address || !local_address.trim())) {
            setMandatoryError('Please enter your Current / Local Address.');
            return;
        }

        setMandatorySaving(true);
        try {
            const payload = {
                id: userData.id,
                EmpId: userData.EmpId,
                Phonenumber: (phone || userData.phone || '').trim(),
                Dob: (dob || userData.dob || '').trim(),
                City: (city || userData.city || '').trim(),
                Address: (address || userData.address || '').trim(),
                LocalAddress: (local_address || userData.local_address || '').trim(),
                Country: (country || userData.country || '').trim(),
                Gender: userData.gender || '',
                ProfilePicture: userData.profileImage || null
            };

            const res = await fetch("/gt-api/update_profile.php", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            const result = await res.json();
            if (result.success) {
                const updatedUser = {
                    ...userData,
                    phone: phone.trim(),
                    dob: dob.trim(),
                    city: city.trim(),
                    address: address.trim(),
                    local_address: local_address.trim(),
                    country: country.trim()
                };
                setUserData(updatedUser);
                localStorage.setItem("userData", JSON.stringify(updatedUser));
                setMandatorySuccessMsg("🎉 Profile information updated! You may now use the system.");
                setTimeout(() => {
                    setShowMandatoryProfileModal(false);
                    setMandatorySuccessMsg('');
                }, 1200);
            } else {
                setMandatoryError(result.message || "Failed to update profile. Please try again.");
            }
        } catch (err) {
            console.error("Mandatory profile update error:", err);
            setMandatoryError("Connection error. Ensure backend API is running.");
        } finally {
            setMandatorySaving(false);
        }
    };

    const handleSaveMandatoryBankDetails = async (e) => {
        e.preventDefault();
        setBankError('');

        const { bankName, holderName, accNumber, ifsc, branch, accType } = bankFormData;

        if (missingBankFields.bankName && (!bankName || !bankName.trim())) {
            setBankError('Please enter Bank Name.');
            return;
        }
        if (missingBankFields.holderName && (!holderName || !holderName.trim())) {
            setBankError('Please enter Account Holder Name.');
            return;
        }
        if (missingBankFields.accNumber && (!accNumber || !accNumber.trim())) {
            setBankError('Please enter Bank Account Number.');
            return;
        }
        if (missingBankFields.ifsc && (!ifsc || !ifsc.trim())) {
            setBankError('Please enter IFSC Code.');
            return;
        }
        if (missingBankFields.branch && (!branch || !branch.trim())) {
            setBankError('Please enter Branch Name.');
            return;
        }
        if (missingBankFields.accType && (!accType || !accType.trim())) {
            setBankError('Please select Account Type.');
            return;
        }

        setBankSaving(true);
        try {
            const payload = {
                emp_id: userData.id || userData.employeeId || userData.EmpId,
                emp_number: userData.EmpId || userData.employeeId,
                bankName: bankName.trim(),
                bank_name: bankName.trim(),
                holderName: holderName.trim(),
                account_holder_name: holderName.trim(),
                accNumber: accNumber.trim(),
                account_number: accNumber.trim(),
                ifsc: ifsc.trim(),
                ifsc_code: ifsc.trim(),
                branch: branch.trim(),
                branch_name: branch.trim(),
                accType: accType.trim(),
                account_type: accType.trim()
            };

            const res = await fetch("/gt-api/save_bank_details.php", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            const result = await res.json();
            if (result.success) {
                setBankSuccessMsg("🎉 Bank details updated successfully!");
                setTimeout(() => {
                    setShowMandatoryBankModal(false);
                    setBankSuccessMsg('');
                }, 1200);
            } else {
                setBankError(result.message || "Failed to save bank details. Please try again.");
            }
        } catch (err) {
            console.error("Mandatory bank details update error:", err);
            setBankError("Connection error. Ensure backend API is running.");
        } finally {
            setBankSaving(false);
        }
    };




    // const employeeId = userData.id || userData.employeeId;

    const toggleSubMenu = (menu) => {
        setOpenMenus(prev => ({ ...prev, [menu]: !prev[menu] }));
    };

    useEffect(() => {
        const checkNotifications = () => {
            if (role !== 'Management' && userData?.employeeId) {
                fetch(`/gt-api/clear_notifications.php?employee_id=${userData.employeeId}`)
                    .then(res => res.json())
                    .then(data => {
                        if (data.success) setNotifCount(data.count);
                    })
                    .catch(err => console.error("Notif Fetch Error:", err));
            }
        };
        checkNotifications();
        const interval = setInterval(checkNotifications, 30000);
        return () => clearInterval(interval);
    }, [userData.employeeId, role]);

    useEffect(() => {
        if (role === 'Management' || role === 'Manager') {
            const fetchRealTimeLeaves = async () => {
                try {
                    // Determine which API to call based on Role
                    // Managers should call the specific manager-leaves API using their ID
                    const url = role === 'Management'
                        ? "/gt-api/get_all_leaves.php"
                        : `/gt-api/get_manager_leaves.php?managerId=${userData.id || location.state?.empId}`;

                    // const res = await fetch(url);
                    const res = await fetch(url, {
                        credentials: "include"
                    });
                    const data = await res.json();

                    if (data.success && data.leaves) {

                        const count = data.leaves.filter(l => l.Status === '0' || l.Status === null).length;
                        setPendingLeavesCount(count);
                    }
                } catch (err) {
                    console.error("Real-time Fetch Error:", err);
                }
            };

            // Only fetch if we have the ID for the Manager, or if role is Management
            if (role === 'Management' || (role === 'Manager' && (userData.id || location.state?.empId))) {
                fetchRealTimeLeaves();
                const liveInterval = setInterval(fetchRealTimeLeaves, 5000);
                return () => clearInterval(liveInterval);
            }
        }
    }, [role, userData.id, location.state?.empId]);

    const handleStatusUpdate = async (id, newStatus) => {
        try {
            const response = await fetch("/gt-api/update_request_status.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id, status: newStatus }),
            });
            const data = await response.json();
            if (data.success) {
                setRequestsList(prev => prev.map(req => req.id === id ? { ...req, status: newStatus } : req));
                setPendingRequestsCount(prev => Math.max(0, prev - 1));
                alert(`Request ${newStatus} successfully!`);
            }
        } catch (error) {
            console.error("Update error:", error);
        }
    };

    ;


    const sendAIMessage = async () => {
        if (!chatInput.trim()) return;

        const userMessage = {
            sender: "user",
            text: chatInput
        };

        setChatMessages(prev => [...prev, userMessage]);
        setChatLoading(true);

        try {
            const res = await fetch("/gt-api/chatbot.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include",
                body: JSON.stringify({
                    question: chatInput
                })
            });

            const data = await res.json();

            let aiReply = "No response.";

            if (data.success) {
                aiReply = data.reply || "No response.";
            } else {
                aiReply = data.message || "Something went wrong.";
            }
            setChatMessages(prev => [
                ...prev,
                {
                    sender: "ai",
                    text: aiReply
                }
            ]);

        } catch (err) {
            setChatMessages(prev => [
                ...prev,
                {
                    sender: "ai",
                    text: "Server error."
                }
            ]);
        }

        setChatInput("");
        setChatLoading(false);
    };
    const handleModuleChange = (slug, extraData = null) => {
        navigate(`/dashboard/${role}/${slug}`, {
            state:
                extraData && typeof extraData === "object"
                    ? extraData
                    : { selectedPathway: extraData }
        });
    };

    const handlePasswordSubmit = (e) => {
        e.preventDefault();
        if (passwordForm.newPassword !== passwordForm.confirmPassword) {
            alert("New passwords do not match!");
            return;
        }
        alert("Encryption Key Updated Successfully!");
        setShowPasswordModal(false);
    };

    const handleSave = () => {
        setIsEditing(false);
        alert("Profile changes synchronized!");
    };

    // Ensure only ONE instance of this exists in your file
    const [theme, setTheme] = useState(localStorage.getItem('dashboard-theme') || 'dark');

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('dashboard-theme', theme);
        if (theme === 'dark') {
            document.body.classList.remove('light-mode', 'light-theme');
            document.documentElement.classList.remove('light-mode', 'light-theme');
            document.body.classList.add('dark-theme');
            document.documentElement.classList.add('dark-theme');
        } else {
            document.body.classList.remove('dark-mode', 'dark-theme');
            document.documentElement.classList.remove('dark-mode', 'dark-theme');
            document.body.classList.add('light-theme');
            document.documentElement.classList.add('light-theme');
        }
    }, [theme]);

    const toggleTheme = () => {
        setTheme(prev => prev === 'dark' ? 'light' : 'dark');
    };
    useEffect(() => {

        const handlePageShow = (event) => {
            if (event.persisted) {
                const user = localStorage.getItem("userData");
                if (!user) {
                    window.location.replace("/");
                }
            }
        };

        window.addEventListener("pageshow", handlePageShow);

        return () => window.removeEventListener("pageshow", handlePageShow);

    }, []);
    useEffect(() => {
        if (role === 'Management') {
            const fetchEquipmentCount = async () => {
                try {

                    const res = await fetch("/gt-api/get_all_equip_request.php", {
                        credentials: "include"
                    });
                    const data = await res.json();
                    if (data.success && data.requests) {
                        const count = data.requests.filter(r => r.status?.toLowerCase() === 'pending').length;
                        setPendingRequestsCount(count);
                        setRequestsList(data.requests);
                    }
                } catch (err) {
                    console.error("Equipment Fetch Error:", err);
                }
            };

            fetchEquipmentCount();
            const interval = setInterval(fetchEquipmentCount, 10000);
            return () => clearInterval(interval);
        }
    }, [role]);




    const [payData, setPayData] = useState([]);

    useEffect(() => {

        // 🔥 MANAGEMENT DASHBOARD
        if (role === "Management") {

            const fetchAllDocs = () => {
                fetch("/gt-api/get_all_salary_documents.php", {
                    credentials: "include"
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log("MGMT DATA:", data);

                        if (data.success) {

                            setPayData(data.documents);
                        }
                    })
                    .catch(err => console.error("Management Fetch Error:", err));
            };

            fetchAllDocs();

            const interval = setInterval(fetchAllDocs, 5000);

            return () => clearInterval(interval);
        }

        // 👤 EMPLOYEE DASHBOARD
        if (employeeId) {
            fetch(`/gt-api/get_my_documents.php?emp_id=${employeeId}`, {
                credentials: "include"
            })
                .then(res => res.json())
                .then(data => {
                    console.log("EMP DATA:", data);

                    if (data.success) {
                        setPayData(data.documents);
                    }
                })
                .catch(err => console.error("Employee Fetch Error:", err));
        }

    }, [role, employeeId]);





    const renderPayChart = () => {
        const safePayData = payData || [];

        const payslips = safePayData.filter(d => d.doc_type === "Monthly Salary Slip").length;
        const form16 = safePayData.filter(d => d.doc_type === "Annual Form 16").length;
        const appraisal = safePayData.filter(d => d.doc_type === "APPRAISAL LETTER").length;
        const totalDocs = payslips + form16 + appraisal;

        return (
            <div className="pay-ultra-card" onClick={() => handleModuleChange("pay and benefits")}>
                <div className="card-inner">
                    {/* Top Section */}
                    <div className="pay-header">
                        <div className="pay-icon-wrapper">
                            <div className="pay-icon-glow"></div>
                            <span className="main-icon">📄</span>
                        </div>
                        <div className="pay-total-info">
                            <h3>Pay & Benefits</h3>
                            <p>{totalDocs} Total Documents</p>
                        </div>
                    </div>

                    {/* Distribution */}
                    <div className="distribution-container">
                        <div className="distribution-label">
                            <span>Vault Composition</span>
                            <span className="percentage">
                                {totalDocs > 0 ? "100%" : "0%"}
                            </span>
                        </div>

                        <div className="multi-progress-bar">
                            {totalDocs > 0 ? (
                                <>
                                    <div
                                        className="segment green"
                                        style={{ flex: payslips, backgroundColor: '#22c55e' }}
                                    ></div>
                                    <div
                                        className="segment blue"
                                        style={{ flex: form16, backgroundColor: '#3b82f6' }}
                                    ></div>
                                    <div
                                        className="segment amber"
                                        style={{ flex: appraisal, backgroundColor: '#f59e0b' }}
                                    ></div>
                                </>
                            ) : (
                                <div
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: "#e5e7eb",
                                        borderRadius: "10px"
                                    }}
                                ></div>
                            )}
                        </div>
                    </div>

                    {/* List */}
                    <div className="pay-list">
                        <div className="list-item">
                            <div className="item-left">
                                <span className="indicator green"></span>
                                <span className="name">Monthly Payslips</span>
                            </div>
                            <span className="count-badge">{payslips}</span>
                        </div>

                        <div className="list-item">
                            <div className="item-left">
                                <span className="indicator blue"></span>
                                <span className="name">Tax Form 16</span>
                            </div>
                            <span className="count-badge">{form16}</span>
                        </div>

                        <div className="list-item">
                            <div className="item-left">
                                <span className="indicator amber"></span>
                                <span className="name">Appraisal Letter</span>
                            </div>
                            <span className="count-badge">{appraisal}</span>
                        </div>
                    </div>

                    <div className="pay-footer">
                        <span>Explore Document</span>
                        <span className="arrow-icon">→</span>
                    </div>

                    <div className="reimburse-cta-wrapper">
                        <button
                            className="reimburse-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleModuleChange("supplies");
                            }}
                        >
                            Click here for Reimbursement Form
                        </button>
                    </div>
                </div>
            </div>
        );
    };



    const renderLeavePieChart = () => {
        const PUBLIC_HOLIDAYS = [
            '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
            '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
        ];

        const isWorkDay = (date) => {
            const day = date.getDay();
            const dateString = date.toISOString().split('T')[0];
            return !(day === 0 || day === 6) && !PUBLIC_HOLIDAYS.includes(dateString);
        };

        if (!leaveData || !leaveData.leaveBalances) return null;

        const sickUsed = leaveData.leaveBalances.sick.used || 0;
        const earnedUsed = leaveData.leaveBalances.earned.used || 0;
        const wfhCount = leaveData.wfhHistory.reduce((total, wfh) => {
            const start = new Date(wfh.start);
            const end = new Date(wfh.end);
            let days = 0;
            let current = new Date(start);
            while (current <= end) {
                if (isWorkDay(current)) days++;
                current.setDate(current.getDate() + 1);
            }
            return total + days;
        }, 0);

        const totalUsed = sickUsed + earnedUsed;

        // Determine max for scaling bars (minimum scale of 10)
        const maxVal = Math.max(sickUsed, earnedUsed, wfhCount, 10);
        return (

            <div
                className={`elite-podium-card leave-analytics-card ${theme === 'dark' ? 'dark-variant' : 'light-theme'}`}
                onClick={() => handleModuleChange("attendance")}
            >

                <div className="card-header-v3">
                    <div className="title-group">

                        <h2 className="main-title">Leave Overview</h2>
                    </div>
                    <div className="year-tag">2026</div>
                </div>

                <div className="podium-content">
                    {/* VERTICAL BAR SECTION - Made prominent */}
                    <div className="bar-podium-large">
                        <div className="mega-pillar">
                            <div className="mega-track">
                                <div className="mega-fill sick" style={{ height: `${(sickUsed / maxVal) * 100}%` }}></div>
                            </div>
                            <span className="mega-label">SICK</span>
                        </div>

                        <div className="mega-pillar">
                            <div className="mega-track">
                                <div className="mega-fill earned" style={{ height: `${(earnedUsed / maxVal) * 100}%` }}></div>
                            </div>
                            <span className="mega-label">EARNED</span>
                        </div>

                        <div className="mega-pillar">
                            <div className="mega-track">
                                <div className="mega-fill wfh" style={{ height: `${(wfhCount / maxVal) * 100}%` }}></div>
                            </div>
                            <span className="mega-label">WFH</span>
                        </div>
                    </div>

                    {/* KPI SIDEBAR - Cleaned up to match image 1's style */}
                    <div className="kpi-sidebar-compact">
                        <div className="total-display">
                            <span className="total-val">{totalUsed}</span>
                            <span className="total-sub">Days Off-Site</span>
                        </div>

                        <div className="status-legend">
                            <div className="legend-row">
                                <span className="indicator sick"></span>
                                <span>{sickUsed} Sick</span>
                            </div>
                            <div className="legend-row">
                                <span className="indicator earned"></span>
                                <span>{earnedUsed} Earned</span>
                            </div>
                            <div className="legend-row">
                                <span className="indicator wfh"></span>
                                <span>{wfhCount} WFH</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-footer-v3">
                    <div className="sync-info">
                        <span className="status-glow"></span>
                        Annual Summary Active
                    </div>
                    <button className="details-btn">VIEW DETAILS →</button>
                </div>
            </div>
        );
    };

    const [leaveData, setLeaveData] = useState({
        leaveHistory: [],
        leaveBalances: {
            sick: { used: 0, total: 0 },
            earned: { used: 0, total: 0 }
        },
        wfhHistory: []
    });


    const [managementNotices, setManagementNotices] = useState({
        reviews: [],
        probations: []
    });

    useEffect(() => {
        const fetchNotices = async () => {
            if (!userData?.EmpId) return;

            try {
                const res = await fetch(
                    `/gt-api/get_manager_feedback.php?empId=${userData.EmpId}`
                );
                const data = await res.json();

                if (data.success) {
                    setManagementNotices({
                        reviews: data.reviews || [],
                        probations: data.probations || []
                    });
                }
            } catch (err) {
                console.error(err);
            }
        };

        fetchNotices();
    }, [userData]);





    const renderEquipmentCard = () => {
        const { total, approved, rejected, pending } = equipmentData;

        return (
            <div className="equipment-ultra-card clickable" onClick={() => handleModuleChange("equipment-request")}>
                <div className="equip-header">
                    <div className="equip-icon-box">💻</div>
                    <div className="equip-title-group">
                        <span className="equip-label">Hardware</span>
                        <h3 className="equip-title">Requests</h3>
                    </div>
                </div>

                <div className="equip-main-stat">
                    <span className="total-count">{total}</span>
                    <span className="total-label">Submissions</span>
                </div>

                <div className="equip-progress-bar">
                    <div className="bar-fill approved" style={{ width: `${(approved / total) * 100}%` }}></div>
                    <div className="bar-fill pending" style={{ width: `${(pending / total) * 100}%` }}></div>
                </div>

                <div className="equip-stats-list">
                    <div className="equip-item">
                        <span className="dot approved"></span>
                        <span className="item-name">Approved</span>
                        <span className="item-val">{approved}</span>
                    </div>
                    <div className="equip-item">
                        <span className="dot pending"></span>
                        <span className="item-name">Pending</span>
                        <span className="item-val text-warning">{pending}</span>
                    </div>
                </div>
            </div>
        );
    };


    useEffect(() => {
        const empIdForFetch = userData?.EmpId || userData?.employeeId;

        if (!empIdForFetch) return;

        fetch(`/gt-api/get_all_equip_request.php?employee_id=${empIdForFetch}`, {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                console.log("EQUIPMENT API RESPONSE:", data);
                if (data.success && data.requests) {

                    const requests = data.requests;

                    const approved = requests.filter(r =>
                        r.status?.toLowerCase() === "approved"
                    ).length;

                    const rejected = requests.filter(r =>
                        r.status?.toLowerCase() === "rejected"
                    ).length;

                    const pending = requests.filter(r =>
                        r.status?.toLowerCase() === "pending"
                    ).length;

                    setEquipmentData({
                        total: requests.length,
                        approved,
                        rejected,
                        pending
                    });
                }
            })
            .catch(err => console.error("Equipment Dashboard Error:", err));
        console.log("EMP ID:", empIdForFetch);



    }, [userData?.EmpId, userData?.employeeId]);





    const [oneOnOneData, setOneOnOneData] = useState({
        totalMeetings: 0,
        pendingTasks: 0,
        completedTasks: 0
    });

    useEffect(() => {
        if (!employeeId) return;

        fetch(`/gt-api/get_my_meetings.php?emp_id=${employeeId}`, {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (data.meetings) {

                    const meetings = data.meetings;

                    let pending = 0;
                    let completed = 0;

                    meetings.forEach(meet => {
                        const tasks = JSON.parse(meet.action_items || "[]");

                        tasks.forEach(task => {
                            if (task.done) completed++;
                            else pending++;
                        });
                    });

                    setOneOnOneData({
                        totalMeetings: meetings.length,
                        pendingTasks: pending,
                        completedTasks: completed
                    });
                }
            })
            .catch(err => console.error("1-1 Fetch Error:", err));

    }, [employeeId]);



    const renderOneOnOneCard = () => {
        const { totalMeetings, pendingTasks, completedTasks } = oneOnOneData;
        const totalTasks = (pendingTasks + completedTasks) || 1;
        const progressPercent = Math.min(Math.round((completedTasks / totalTasks) * 100), 100);

        return (
            <div className="liquid-card clickable" onClick={() => handleModuleChange("one-on-one")}>
                {/* BACKGROUND BLOOM */}
                <div className="liquid-bloom"></div>

                <div className="liquid-layout">
                    {/* HERO TILE: THE CORE IDENTITY */}
                    <div className="liquid-tile-hero">
                        <div className="hero-header">
                            {/* <span className="hero-eyebrow">Engagement Console</span> */}
                            <h2 className="hero-title">1-on-1 Sessions</h2>
                        </div>
                        <div className="hero-main-metric">
                            <span className="hero-val">{totalMeetings}</span>
                            <span className="hero-label">TOTAL<br />MEETINGS</span>
                        </div>
                        {/* FULL WIDTH PROGRESS THREAD */}
                        <div className="liquid-thread-container">
                            <div className="liquid-thread-bg">
                                <div className="liquid-thread-fill" style={{ width: `${progressPercent}%` }}>
                                    <div className="liquid-thread-glow-tip"></div>
                                </div>
                            </div>
                            <div className="liquid-thread-label">
                                <span className="label-text">Task Completion</span>
                                <span className="label-val">{progressPercent}%</span>
                            </div>
                        </div>
                    </div>

                    {/* DATA TRAY: THE SPECIFIC CHIPS */}
                    <div className="liquid-tray">
                        <div className="liquid-chip danger">
                            <div className="chip-inner">
                                <label>Pending Task</label>
                                <span className="chip-val">{pendingTasks}</span>
                            </div>
                        </div>
                        <div className="liquid-chip success">
                            <div className="chip-inner">
                                <label>Completed Task</label>
                                <span className="chip-val">{completedTasks}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* INTERACTIVE FOOTER */}
                <div className="liquid-footer">
                    <div className="status-container">
                        <div className={`status-node-wrapper ${pendingTasks > 0 ? 'is-alert' : 'is-sync'}`}>
                            <div className="status-node-core"></div>
                            <div className="status-node-bloom"></div>
                        </div>
                        <span className={`status-text ${pendingTasks > 0 ? 'text-alert' : ''}`}>
                            {pendingTasks > 0 ? 'ACTION ITEMS DETECTED' : 'SYSTEM OPTIMIZED'}
                        </span>
                    </div>
                    <div className="liquid-action">

                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                    </div>
                </div>
            </div>
        );
    };






    const renderCareerPathwaysCard = () => {

        const isGenesis =
            userData?.EmailId
                ?.toLowerCase()
                ?.includes("genesistech.co.in");

        const pathways = isGenesis

            ? [

                {
                    id: "01",
                    name: "FI DESIGN",
                    color: "rgba(0, 77, 113, 0.9)"
                },

                {
                    id: "02",
                    name: "BIM MODELING",
                    color: "rgba(0, 120, 172, 0.8)"
                },

                {
                    id: "03",
                    name: "POWER BI",
                    color: "rgba(0, 162, 237, 0.7)"
                }

            ]

            : dashboardPathways.map(
                (item, index) => ({
                    id: String(index + 1)
                        .padStart(2, "0"),

                    name: item.pathway_title,

                    color:
                        "rgba(0, 120, 172, 0.8)"
                })
            );

        return (

            <div
                className="pathway-card-container"
                onClick={() =>
                    handleModuleChange(
                        "career pathways"
                    )
                }
            >

                <h2 className="pathway-title">
                    CAREER PATHWAYS
                </h2>

                <div className="pathway-stack">

                    {pathways.map(
                        (item, index) => (

                            <div
                                key={index}
                                className="pathway-step"
                                style={{
                                    '--step-color':
                                        item.color
                                }}
                                onClick={(e) => {

                                    e.stopPropagation();

                                    handleModuleChange(
                                        "career pathways",
                                        item.name
                                    );

                                }}
                            >

                                <span className="step-number">
                                    {item.id}
                                </span>

                                <div className="step-content">

                                    <span className="step-name">
                                        {item.name}
                                    </span>

                                    <div className="step-glow"></div>

                                </div>

                            </div>

                        )
                    )}

                </div>

                <button
                    className="explore-btn"
                    onClick={(e) => {

                        e.stopPropagation();

                        handleModuleChange(
                            "career pathways"
                        );

                    }}
                >
                    EXPLORE CAREER PATHWAYS
                </button>

            </div>

        );

    };


    const renderPolicyCard = () => {
        const totalPolicies =
            policyCount;

        console.log(
            "Policy Count:",
            totalPolicies
        );

        const readCount =
            Object.keys(logs || {}).length;
        const pending = totalPolicies - readCount;
        const progress = totalPolicies > 0 ? Math.round((readCount / totalPolicies) * 100) : 0;

        return (
            <div className="terminal-policy-card" onClick={() => handleModuleChange("company-policy")}>
                {/* Background Decorative Scanline */}
                <div className="terminal-scanline"></div>

                <div className="terminal-header">
                    <div className="header-left">
                        {/* <span className="terminal-tag">PROTOCOL_09</span> */}
                        <h3 className="terminal-title">Company Policy</h3>
                    </div>
                    <div className={`status-indicator ${progress === 100 ? 'secure' : 'breach'}`}>
                        {progress === 100 ? "SECURE" : "PENDING"}
                    </div>
                </div>

                <div className="terminal-content">
                    {/* Circular Progress using SVG for precision */}
                    <div className="terminal-visual">
                        <svg viewBox="0 0 36 36" className="cyber-circle">
                            <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                            <path
                                className="circle-fill"
                                strokeDasharray={`${progress}, 100`}
                                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                style={{ stroke: progress === 100 ? '#22c55e' : '#3b82f6' }}
                            />
                        </svg>
                        <div className="percentage-display">
                            <span className="pct-num">{progress}</span>
                            <span className="pct-unit">%</span>
                        </div>
                    </div>

                    {/* Data Readout Section */}
                    <div className="terminal-stats">
                        <div className="stat-row">
                            <span className="label">COMPLETED</span>
                            <span className="value">{readCount}</span>
                        </div>
                        <div className="stat-row">
                            <span className="label">TOTAL_FILES</span>
                            <span className="value">{totalPolicies}</span>
                        </div>
                        <div className="stat-row urgent">
                            <span className="label">AWAITING_ACTION</span>
                            <span className="value">{pending}</span>
                        </div>
                    </div>
                </div>

            </div>
        );
    };

    useEffect(() => {
        const fetchLogs = async () => {
            if (!userData?.EmpId) return;

            try {
                const res = await fetch(
                    `/gt-api/acknowledgepolicy.php?empId=${userData.EmpId}`,
                    {
                        credentials: "include"
                    }
                );

                const data = await res.json();

                console.log("API DATA:", data);

                // 🔥 FIX: use data.logs (NOT data)
                const logsArray = Array.isArray(data?.logs) ? data.logs : [];

                const map = logsArray.reduce((acc, curr) => {
                    if (curr?.policy_title) {
                        acc[curr.policy_title] = true;
                    }
                    return acc;
                }, {});

                setLogs(map);

            } catch (err) {
                console.error("Policy logs error:", err);
                setLogs({});
            }
        };

        fetchLogs();
    }, [userData]);


    const [showProfileOptions, setShowProfileOptions] = useState(false);



    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const handleEditProfile = () => {
        setShowProfileMenu(false);
        navigate(`/dashboard/${role}/my-profile`);
        setShowProfile(true);
    };

    const handleLogout = () => {
        const rememberMe = localStorage.getItem("rememberMe");
        const rememberedEmail = localStorage.getItem("rememberedEmail");
        const rememberedPassword = localStorage.getItem("rememberedPassword");

        document.documentElement.removeAttribute('data-theme');
        localStorage.clear();
        sessionStorage.clear();

        if (rememberMe) {
            localStorage.setItem("rememberMe", rememberMe);
            if (rememberedEmail) localStorage.setItem("rememberedEmail", rememberedEmail);
            if (rememberedPassword) localStorage.setItem("rememberedPassword", rememberedPassword);
        }

        navigate("/", { replace: true });
    };

    const [currentTime, setCurrentTime] = useState("");

    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            setCurrentTime(
                now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
            );
        };

        updateTime();
        const interval = setInterval(updateTime, 1000);

        return () => clearInterval(interval);
    }, []);
    const todayDate = new Date().toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short'
    });



    const employeeModulesList = [
        { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "attendance" },

        { id: 2, name: "Pay and Benefits", icon: "💳", color: "#3b82f6", slug: "pay and benefits" },
        { id: 3, name: "OKR and Performance Tracker", icon: "🎯", color: "#f59e0b", slug: "okr and performance tracker" },

        { id: 5, name: "Career Pathways", icon: "🏆", color: "#ec4899", slug: "career pathways" },
        { id: 6, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },

        { id: 9, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
        { id: 10, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
        // { id: 11, name: "Documents", icon: "📂", color: "#f43f5e", slug: "documents" },
        // { id: 12, name: "Employee Experience Survey - EES", icon: "📝", color: "#8b5cf6", slug: "ees-survey" },   
        { id: 13, name: "1:1 Meeting", icon: "💬", color: "#00fff2", slug: "one-on-one" },
        { id: 21, name: "ACM Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
        { id: 7, name: "Expense Reimbursement", icon: "🧾", color: "#10b981", slug: "supplies" },

    ];

    const managementModulesList = [

        { id: 1, name: "Leave Management", icon: "🗓️", color: "#10b981", slug: "leave-management", badge: pendingLeavesCount },

        { id: 2, name: "Employee Salary and Benefits", icon: "💳", color: "#3b82f6", slug: "employee-salary-benefits" },

        { id: 3, name: "Employee OKR'S", icon: "🎯", color: "#f59e0b", slug: "employee-okrs" },

        { id: 5, name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: pendingRequestsCount },

        { id: 6, name: "Own Finanacials", icon: "💰", color: "#10b981", slug: "pay and benefits" },

        { id: 8, name: "Career Development", icon: "🏆", color: "#ec4899", slug: "career pathways" },

        { id: 10, name: "Self OKR Tracker", icon: "🏁", color: "#f59e0b", slug: "okr and performance tracker" },
        { id: 11, name: "Campus Information", icon: "🏢", color: "#f59e0b", slug: "campus information" },
        { id: 12, name: "Organization Chart", icon: "👥", color: "#3b82f6", slug: "Organization Chart" },
        // { id: 21, name: "Manage Updates", icon: "📢", color: "#00fff2", slug: "quarterly-updates", badge: "PUSH" },

        {
            id: 21,
            name: "ACM Updates",
            icon: "📢",
            color: "#00fff2",
            slug: "manage-quarterly-updates",
            badge: "PUSH"
        },

        // {
        //   id: 15,
        //   name: "EES Feedback Analytics",
        //   icon: "📊",
        //   color: "#00f2ff",
        //   slug: "ees-analytics",
        //   badge: "NEW"
        // },

        // { id: 14, name: "Skills Development", icon: "📚", color: "#06b6d4", slug: "career" },

        {
            id: 16,
            name: "Medical Reports",
            icon: "🏥",
            color: "#f43f5e",
            slug: "medical-reports",
            badge: "DOCS"
        },
        {
            id: 17,
            name: "Policy RnU Status",
            icon: "📋",
            color: "#10b981",
            slug: "policy-logs",
            badge: "ADMIN"
        },

        // { 
        //   id: 18, 
        //   name: "Employee Documents", 
        //   icon: "📂", 
        //   color: "#f43f5e", 
        //   slug: "manage-documents", 
        //   badge: "VIEW" 
        // },

        {
            id: 19,
            name: "1:1 Connect",
            icon: "🤝",
            color: "#00fff2",
            slug: "manager-one-on-one",

            badge: "LIVE"
        },

        { id: 20, name: "Events and Celebrations", icon: "🎉", color: "#3b82f6", slug: "events-celebrations" },

        {
            id: 22,
            name: "Expense Reimbursements",
            icon: "💰",
            color: "#22c55e",
            slug: "reimbursements",
            badge: "NEW"
        },

        {
            id: 25,
            name: "Award Nominations Analytics",
            icon: "📊",
            color: "#f59e0b",
            slug: "award-analytics",
            badge: "GALA"
        },

        // {
        //     id: 23,
        //     name: "WFH Requests",
        //     icon: "🏠",
        //     color: "#3b82f6",
        //     slug: "manage-wfh-requests",
        //     badge: "WFH"
        // },


    ];

    const renderActiveModule = () => {

        switch (activeModule) {

            case "attendance-tracker":
                return <AttendanceTracker />;

            case "CompanySetup":
                return <CompanySetup />;

            case "create-invoice":
                return <InvoiceGenerator />;

            case "my-profile":
                return (
                    <MyProfile
                        userData={userData}
                        setUserData={setUserData}
                        isEditing={isEditing}
                        setIsEditing={setIsEditing}
                        handleSave={handleSave}
                        setShowPasswordModal={setShowPasswordModal}
                    />
                );


            case "reimbursements":
                if (role === "Management" || role === "Manager") {
                    return <ReimbursementManagement />;
                }
                return <OfficeRequisition userData={userData} />;

            case "manage-wfh-requests":
                return <WFHManagement />;


            case "work-from-home":
                return <WorkFromHome />;


            case "quarterly-updates":

                return <QuarterlyUpdates />;

            case "manage-quarterly-updates":

                if (role === 'Management' || role === 'Manager') {
                    return <ManagementQuarterlyUpdate userData={userData} />;
                }
                return <QuarterlyUpdates />;


            case "leave-management":
                // Unified behavior for Management and Manager
                if (role === 'Management' || role === 'Manager') {
                    return <LeaveManagement userData={userData} />;
                }


                return <Attendance employeeId={employeeId} userData={userData} />;

            case "manage-documents":
                return <Documents userData={userData} />;



            // case "attendance":
            //     if (role === 'Management') return <Attendance />;
            //     return (
            //         <Attendance
            //             employeeId={userData.id}
            //             empBadgeId={userData.EmpId}
            //             userData={userData}
            //         />
            //     );
            case "attendance":

                if (role === 'Management') {

                    return (
                        <Attendance
                            employeeId={userData.id}
                            empBadgeId={userData.EmpId}
                            userData={userData}
                        />
                    );

                }

                return (
                    <Attendance
                        employeeId={userData.id}
                        empBadgeId={userData.EmpId}
                        userData={userData}
                    />
                );


            case "policy-logs":
                if (role === 'Management' || role === 'Manager') {
                    return <PolicyAdminDashboard />;
                }

                return (
                    <CompanyPolicy
                        employeeId={userData.id}
                        userData={userData}
                    />
                );

            case "events-celebrations":
                return <EventsCelebrations userData={userData} />;

            case "award-nominations":
                return <AwardNominations userData={userData} role={role} />;

            case "award-analytics":
                return <AwardAnalyticsDashboard userData={userData} role={role} />;

            case "pay and benefits": return <PayBenefits userData={userData} employeeId={employeeId} />;

            // case "okr and performance tracker":
            //     return <OKRTracker userData={userData} />;

            case "okr and performance tracker":
                return (
                    <OKRTracker
                        userData={userData}
                        defaultTab={location.state?.tab}
                    />
                );

            // Inside Dashboard.js -> renderActiveModule
            // case "employee-okrs":
            //     if (role === 'Management' || role === 'Manager') {
            //         return (
            //             <ManagementOKRViewer
            //                 managerId={userData.id}
            //                 userRole={role}
            //                 // This is the CRITICAL line:
            //                 managedDept={userData.HOD}
            //             />
            //         );
            //     }
            //     return <OKRTracker userData={userData} />;

            case "employee-okrs":
                if (role === 'Management' || role === 'Manager') {
                    return <ManagementOKRViewer userRole={role} />;
                }
                return <OKRTracker userData={userData} />;

            case "career pathways": return <CareerPathways userData={userData} />;
            case "add-department": return <AddDepartment />;
            case "manage-department": return <ManageDepartment />;
            case "add-employee": return <AddEmployee />;
            case "manage-employee": return <ManageEmployee />;

            case "employee-salary-benefits":
                return <EmployeeSalaryBenefits />;


            case "equipment-request":
                if (role === "Management") {
                    const pending = requestsList.filter(
                        (r) => r.status?.toLowerCase() === "pending"
                    );

                    const history = requestsList.filter(
                        (r) => r.status?.toLowerCase() !== "pending"
                    );

                    return (
                        <div
                            className="management-request-wrapper animate-fade"
                            style={{ padding: "20px" }}
                        >
                            {/* Pending Queue */}
                            <div
                                className="module-glass-card"
                                style={{ marginBottom: "30px" }}
                            >
                                <h3 className="cyan-text">
                                    ACTIVE_PENDING_QUEUE ({pending.length})
                                </h3>

                                {/* Desktop Table */}
                                <div className="equiptable-container">
                                    <table className="equiptable">
                                        <thead>
                                            <tr>
                                                <th>EMPLOYEE</th>
                                                <th>HARDWARE</th>
                                                <th>IMPACT</th>
                                                <th>ACTION</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {pending.length > 0 ? (
                                                pending.map((req) => (
                                                    <tr key={req.id}>
                                                        <td>{req.employee_name}</td>

                                                        <td>{req.equipment_type}</td>

                                                        <td>
                                                            <span
                                                                className={`equiptable-impact ${req.impact?.toLowerCase()}`}
                                                            >
                                                                {req.impact?.toUpperCase()}
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <div className="equiptable-actions">
                                                                <button
                                                                    className="equiptable-btn equiptable-approve"
                                                                    onClick={() =>
                                                                        handleStatusUpdate(
                                                                            req.id,
                                                                            "Approved"
                                                                        )
                                                                    }
                                                                >
                                                                    ✔
                                                                </button>

                                                                <button
                                                                    className="equiptable-btn equiptable-reject"
                                                                    onClick={() =>
                                                                        handleStatusUpdate(
                                                                            req.id,
                                                                            "Rejected"
                                                                        )
                                                                    }
                                                                >
                                                                    ✖
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan="4"
                                                        style={{
                                                            textAlign: "center",
                                                            padding: "20px",
                                                        }}
                                                    >
                                                        NO_PENDING_REQUESTS
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Mobile Cards */}
                                <div className="equiptable-mobile">
                                    {pending.length > 0 ? (
                                        pending.map((req) => (
                                            <div
                                                className="equiptable-card"
                                                key={req.id}
                                            >
                                                <div className="equiptable-row">
                                                    <span>Employee</span>
                                                    <strong>
                                                        {req.employee_name}
                                                    </strong>
                                                </div>

                                                <div className="equiptable-row">
                                                    <span>Hardware</span>
                                                    <strong>
                                                        {req.equipment_type}
                                                    </strong>
                                                </div>

                                                <div className="equiptable-row">
                                                    <span>Impact</span>

                                                    <span
                                                        className={`equiptable-impact ${req.impact?.toLowerCase()}`}
                                                    >
                                                        {req.impact?.toUpperCase()}
                                                    </span>
                                                </div>

                                                <div className="equiptable-actions">
                                                    <button
                                                        className="equiptable-btn equiptable-approve"
                                                        onClick={() =>
                                                            handleStatusUpdate(
                                                                req.id,
                                                                "Approved"
                                                            )
                                                        }
                                                    >
                                                        ✔ Approve
                                                    </button>

                                                    <button
                                                        className="equiptable-btn equiptable-reject"
                                                        onClick={() =>
                                                            handleStatusUpdate(
                                                                req.id,
                                                                "Rejected"
                                                            )
                                                        }
                                                    >
                                                        ✖ Reject
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="equiptable-card">
                                            NO_PENDING_REQUESTS
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Completed History */}
                            <div
                                className="module-glass-card history-card"
                                style={{ opacity: 0.9 }}
                            >
                                <h3
                                    className="gray-text"
                                    style={{ color: "#888" }}
                                >
                                    📜 COMPLETED_HISTORY ({history.length})
                                </h3>

                                <div className="equiptable-container">
                                    <table className="equiptable">
                                        <thead>
                                            <tr>
                                                <th>EMPLOYEE</th>
                                                <th>HARDWARE</th>
                                                <th>DATE</th>
                                                <th>STATUS</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {history.length > 0 ? (
                                                history.map((req) => (
                                                    <tr key={req.id}>
                                                        <td>{req.employee_name}</td>

                                                        <td>{req.equipment_type}</td>

                                                        <td>
                                                            {new Date(
                                                                req.updated_at ||
                                                                req.created_at
                                                            ).toLocaleDateString(
                                                                "en-GB"
                                                            )}
                                                        </td>

                                                        <td>
                                                            <span
                                                                className={`equiptable-status ${req.status?.toLowerCase()}`}
                                                            >
                                                                {req.status?.toUpperCase()}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan="4"
                                                        style={{
                                                            textAlign: "center",
                                                            padding: "20px",
                                                        }}
                                                    >
                                                        NO_HISTORY_FOUND
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    );
                }

                return <EquipmentRequest userData={userData} />;

            case "supplies": return <OfficeRequisition userData={userData} />;
            // case "it": return <ITSupport userData={userData} />;
            case "documents": return <Documents userData={userData} />;
            // case "company-policy": return <CompanyPolicy />;
            case "company-policy":
                return <CompanyPolicy userData={userData} />;
            case "Organization Chart": return <OrgChart userData={userData} />;
            // case "campus information": return <CampusInfo />;
            case "campus information":
                return <CampusInfo userData={userData} />;
            case "ees-survey": return <EESExperience userData={userData} />;

            case "ees-analytics":
                if (role === 'Management' || role === 'Manager') {
                    // Management sees the list of real data
                    return <EESFeedbackManagement feedbacks={eesSubmissions} />;
                }
                // Employee sees the form
                return <EESExperience userData={userData} onFinalSubmit={handleEESSubmit} />;

            //       case "one-on-one":
            // return <OneOnOne userData={userData} role={role} />;

            case "one-on-one":
                // This is the PERSONAL view (Employee mode)
                return <OneOnOne userData={userData} role="Employee" viewMode="personal" />;

            case "manager-one-on-one":
                // This is the MANAGERIAL view (Manager/Management mode)
                return <OneOnOne userData={userData} role={role} viewMode="managerial" />;

            case "one-on-one-report":
                return <OneOnOneReport userData={userData} role={role} handleModuleChange={handleModuleChange} />;

            // Inside Dashboard.js renderActiveModule
            case "medical-reports":
                if (role === 'Management') return <MedicalReports />;
                if (role === 'Manager') {
                    return (
                        <ManagerMedicalReports
                            managerId={userData.id}           // Database Primary Key
                            managerBadgeId={userData.EmpId}   // Company ID (HOD flag often matches this)
                            managerDept={userData.Department} // The string "Software Development"
                        />
                    );
                }

            case "employee-it-support":
                return <EquipmentRequest userData={userData} />;

            default:


                if (role === 'Manager') {
                    return renderManagerDashboard();
                }

                const currentList = role === 'Management' ? managementModulesList : employeeModulesList;
                return (
                    <section className="bento-grid">
                        {currentList.map((mod) => (
                            <div key={mod.id} className="bento-card glass" style={{ "--accent": mod.color }} onClick={() => handleModuleChange(mod.slug)}>
                                <div className="card-top">
                                    <span className="mod-icon">{mod.icon}</span>
                                    {mod.badge > 0 && <span className={role === 'Management' ? "card-badge" : "notification-badge-ui"}>{mod.badge}</span>}
                                </div>
                                <div className="card-info"><h3>{mod.name}</h3><div className="cyber-line"></div></div>
                            </div>
                        ))}
                    </section>
                );
        }
    };

    const [companyLogo, setCompanyLogo] = useState("");
    const currentLogo = theme === 'light' ? logoLight : logoDark;


    const [leaveStats, setLeaveStats] = useState({
        pending: 0,
        approved: 0,
        rejected: 0,
        wfhPending: 0
    });

    useEffect(() => {
        if (role !== "Management") return;

        const fetchLeaveStats = async () => {
            try {
                const res = await fetch("/gt-api/get_all_leaves.php", {
                    credentials: "include"
                });
                const data = await res.json();

                if (data.success) {
                    const leaves = data.leaves || [];


                    const pending = leaves.filter(l => l.Status === '0' || l.Status === null).length;
                    const approved = leaves.filter(l => l.Status === '1').length;
                    const rejected = leaves.filter(l => l.Status === '2').length;

                    // WFH
                    const wfhRes = await fetch("/gt-api/get_all_wfh_requests.php", {
                        credentials: "include"
                    });
                    const wfhData = await wfhRes.json();

                    const wfhPending = wfhData.success
                        ? wfhData.requests.filter(r => r.status === "Pending").length
                        : 0;

                    setLeaveStats({ pending, approved, rejected, wfhPending });
                }

            } catch (err) {
                console.error("Leave Stats Error:", err);
            }
        };

        fetchLeaveStats();
        const interval = setInterval(fetchLeaveStats, 5000);

        return () => clearInterval(interval);
    }, [role]);


    const [mgmtLeaves, setMgmtLeaves] = useState([]);
    const [mgmtActiveTeam, setMgmtActiveTeam] = useState("All");

    useEffect(() => {
        const fetchLeaves = async () => {
            try {
                const res = await fetch("/gt-api/get_all_leaves.php", {
                    credentials: "include"
                });
                const data = await res.json();
                if (data.success) setMgmtLeaves(data.leaves);
            } catch (err) {
                console.error("Leave Fetch Error:", err);
            }
        };

        fetchLeaves();
    }, []);





    const mgmtChartData = useMemo(() => {

        const isGenesis =
            userData?.EmailId
                ?.toLowerCase()
                ?.includes("genesistech.co.in");

        const teams = isGenesis

            ? [
                "FI Design",
                "FSPLO",
                "LTDM PC",
                "DDI",
                "DMS",
                "FI-IE",
                "LTO",
                "GTE-Technology Operations"
            ]

            : dashboardDepartments.map(
                dept => dept.DepartmentName
            );

        const now = new Date();
        const currentMonth = (now.getMonth() + 1).toString();
        const currentYear = now.getFullYear().toString();

        const teamList = mgmtActiveTeam === "All" ? teams : [mgmtActiveTeam];

        return teamList.map(team => {

            const filtered = mgmtLeaves.filter(l => {
                const dateParts = l.fromdate?.split("-");
                const lYear = dateParts?.[0];
                const lMonth = dateParts?.[1]
                    ? parseInt(dateParts[1]).toString()
                    : "";

                return (
                    l.Department === team &&
                    lMonth === currentMonth &&
                    lYear === currentYear
                );
            });

            return {
                name: team,

                // ✅ SUM OF UNITS (FIXED)
                Approved: filtered
                    .filter(l => l.Status === "1")
                    .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

                Pending: filtered
                    .filter(l => l.Status === "0" || l.Status === null)
                    .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
            };
        });

    }, [mgmtLeaves, mgmtActiveTeam]);


    const renderManagementLeaveCard = () => {

        const isGenesis =
            userData?.EmailId
                ?.toLowerCase()
                ?.includes("genesistech.co.in");

        const teams = isGenesis

            ? [
                "FI Design",
                "FSPLO",
                "LTDM PC",
                "DDI",
                "DMS",
                "FI-IE",
                "LTO",
                "GTE-Technology Operations"
            ]

            : dashboardDepartments.map(
                dept =>
                    dept.DepartmentName
            );

        return (
            <div
                className="mgmt-leave-analytics clickable"
                onClick={() => handleModuleChange("leave-management")}
            >

                <div className="card-header">
                    <h3>Employee Leave Analytics</h3>
                    <span className="sub-text">This Month</span>
                </div>

                {/* TEAM CHIPS */}
                <div className="team-row">
                    <div
                        className={`team-chip ${mgmtActiveTeam === "All" ? "active" : ""}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            setMgmtActiveTeam("All");
                        }}
                    >
                        ALL
                    </div>

                    {teams.map((team, i) => (
                        <div
                            key={i}
                            className={`team-chip ${mgmtActiveTeam === team ? "active" : ""}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                setMgmtActiveTeam(team);
                            }}
                        >
                            {team}
                        </div>
                    ))}
                </div>

                {/* CHART */}
                {(() => {
                    const isSingle = mgmtActiveTeam !== "All";

                    return (
                        <div className={`chart-area ${isSingle ? "single-view" : ""}`}>
                            <ResponsiveContainer width="100%" height={170}>
                                <BarChart
                                    data={mgmtChartData}
                                    barCategoryGap={isSingle ? "70%" : "30%"}
                                    margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
                                >

                                    {/* GRADIENTS */}
                                    <defs>
                                        <linearGradient id="approvedGrad" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="0%" stopColor="#34d399" />
                                            <stop offset="100%" stopColor="#059669" />
                                        </linearGradient>

                                        <linearGradient id="pendingGrad" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="0%" stopColor="#fbbf24" />
                                            <stop offset="100%" stopColor="#f59e0b" />
                                        </linearGradient>
                                    </defs>

                                    <CartesianGrid
                                        strokeDasharray="3 3"
                                        stroke="rgba(255,255,255,0.05)"
                                        vertical={false}
                                    />

                                    <XAxis
                                        dataKey="name"
                                        tick={{ fill: "#888", fontSize: 10 }}
                                        axisLine={false}
                                        tickLine={false}
                                    />

                                    <YAxis
                                        tick={{ fill: "#666", fontSize: 10 }}
                                        axisLine={false}
                                        tickLine={false}
                                    />

                                    <Tooltip
                                        cursor={{ fill: "rgba(255,255,255,0.05)" }}
                                        contentStyle={{
                                            backgroundColor: "rgba(15, 23, 42, 0.95)", // dark glass
                                            border: "1px solid rgba(0,255,242,0.3)",
                                            borderRadius: "10px",
                                            color: "#ffffff",
                                            backdropFilter: "blur(8px)"
                                        }}
                                        labelStyle={{ color: "#00fff2", fontWeight: 600 }}
                                        itemStyle={{ color: "#ffffff" }}
                                    />


                                    <Bar
                                        dataKey="Approved"
                                        stackId="a"
                                        fill="url(#approvedGrad)"
                                        barSize={isSingle ? 50 : 20}
                                        radius={[6, 6, 0, 0]}
                                    />

                                    <Bar
                                        dataKey="Pending"
                                        stackId="a"
                                        fill="url(#pendingGrad)"
                                        barSize={isSingle ? 50 : 20}
                                        radius={[6, 6, 0, 0]}
                                    />

                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    );
                })()}


                <div className="card-footer">
                    <span>Open Leave Console</span>
                    <span>→</span>
                </div>
            </div>
        );
    };

    const renderSalaryIntelCard = () => {
        // 1. Existing Counts
        const payslips = payData.filter(d => d.doc_type === "Monthly Salary Slip").length;
        const form16 = payData.filter(d => d.doc_type === "Annual Form 16").length;
        const appraisal = payData.filter(d => d.doc_type === "APPRAISAL LETTER").length;

        // 2. New Miscellaneous Count (Filtering for the images you provided)
        const miscDocs = [
            "FNF LETTER", "OFFER LETTER", "RELIEVING LETTER",
            "EXPERIENCE LETTER", "EMPLOYEMENT AGREEMENT", "BANK ACCOUNT OPENING"
        ];
        const miscellaneous = payData.filter(d => miscDocs.includes(d.doc_type)).length;

        // 3. Updated Total
        const total = payslips + form16 + appraisal + miscellaneous;

        // 4. SVG Math for 4 segments
        const chartTotal = 125.6;
        const gap = total > 0 ? 2 : 0;

        const s1 = (payslips / total) * chartTotal || 0;
        const s2 = (form16 / total) * chartTotal || 0;
        const s3 = (appraisal / total) * chartTotal || 0;
        const s4 = (miscellaneous / total) * chartTotal || 0;

        return (
            <div className="sa-card-wrapper" onClick={() => handleModuleChange("employee-salary-benefits")}>


                <div className="sa-card-header">
                    <h3 className="sa-title">Salary Document Insights</h3>
                    <button className="sa-menu-trigger">⋮</button>
                </div>

                <div className="sa-main-body">
                    <div className="sa-gauge-area">
                        <div className="sa-gauge-container">
                            <svg viewBox="0 0 100 55" className="sa-gauge-svg">
                                {/* Background Track */}
                                <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="var(--sa-track)" strokeWidth="9" strokeLinecap="round" />

                                {/* Segment 4: Misc (Blue) */}
                                <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#0ea5e9" strokeWidth="9" strokeLinecap="round"
                                    strokeDasharray={`${Math.max(0, s4 - gap)} ${chartTotal}`}
                                    strokeDashoffset={`-${s1 + s2 + s3}`} />

                                {/* Segment 3: Appraisals (Orange) */}
                                <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#f97316" strokeWidth="9" strokeLinecap="round"
                                    strokeDasharray={`${Math.max(0, s3 - gap)} ${chartTotal}`}
                                    strokeDashoffset={`-${s1 + s2}`} />

                                {/* Segment 2: Form 16 (Yellow) */}
                                <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#fbbf24" strokeWidth="9" strokeLinecap="round"
                                    strokeDasharray={`${Math.max(0, s2 - gap)} ${chartTotal}`}
                                    strokeDashoffset={`-${s1}`} />

                                {/* Segment 1: Payslips (Purple) */}
                                <path d="M10,50 A40,40 0 0,1 90,50" fill="none" stroke="#8b5cf6" strokeWidth="9" strokeLinecap="round"
                                    strokeDasharray={`${Math.max(0, s1 - gap)} ${chartTotal}`}
                                    strokeDashoffset="0" />
                            </svg>

                            <div className="sa-gauge-text">
                                <span className="sa-overall-num">{total}</span>
                                <span className="sa-overall-label">Overall</span>
                            </div>
                        </div>
                    </div>

                    <div className="sa-legend-area">
                        {[
                            { label: "Payslips", count: payslips, color: "purple" },
                            { label: "Form 16", count: form16, color: "yellow" },
                            { label: "Appraisals", count: appraisal, color: "orange" },
                            { label: "Miscellaneous", count: miscellaneous, color: "blue" }
                        ].map((item, index) => (
                            <div key={index} className="sa-legend-item">
                                <div className="sa-item-top">
                                    <span className={`sa-dot ${item.color}`}></span>
                                    <span className="sa-item-count">{item.count}</span>
                                </div>
                                <span className="sa-item-label">{item.label}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="sa-card-footer">
                    <span className="sa-footer-link">View Detailed Report →</span>
                </div>
            </div>
        );
    };



    const [okrData, setOkrData] = useState([]);
    useEffect(() => {
        if (!userData?.id) return;

        const fetchOKR = async () => {
            try {
                const res = await fetch(
                    `/gt-api/get_user_okr.php?empId=${userData.id}`,
                    {
                        credentials: "include"
                    }
                );
                const data = await res.json();

                if (data.success) {
                    const parsed = typeof data.data === "string"
                        ? JSON.parse(data.data)
                        : data.data;

                    setOkrData(parsed);
                }
            } catch (err) {
                console.error(err);
            }
        };

        fetchOKR();

    }, [userData?.id]);



    const [okrStats, setOkrStats] = useState({
        total: 0,
        completed: 0,
        pending: 0,
        progressPercent: 0
    });



    const fetchOKRStats = async () => {
        if (!userData?.EmpId) return;

        try {
            const res = await fetch(
                `/gt-api/get_okr_stats.php?empId=${userData.EmpId}`,
                {
                    credentials: "include"
                }
            );

            const data = await res.json();

            if (data.success) {
                setOkrStats(data);
            }

        } catch (err) {
            console.error("OKR STATS ERROR:", err);
        }
    };

    useEffect(() => {
        if (!userData?.EmpId) return;

        fetchOKRStats();

        const handleUpdate = () => fetchOKRStats();

        window.addEventListener("okrUpdated", handleUpdate);

        return () => window.removeEventListener("okrUpdated", handleUpdate);

    }, [userData?.EmpId]);




    const renderOKRCard = () => {
        const { total, completed, pending, progressPercent } = okrStats;

        return (
            <div
                className="expanded-management-card clickable"
                onClick={() => handleModuleChange("okr and performance tracker")}
            >
                <div className="okr-card-container">

                    {/* HEADER */}
                    <div className="okr-header">
                        <div>
                            <span className="eyebrow-text">Performance Tracker</span>
                            <h2 className="display-title">OKR Progress</h2>
                        </div>

                        {/* TOP RIGHT TOTAL */}
                        <div className="stat-box featured big">
                            <span className="stat-label">Total KR</span>
                            <span className="stat-value">{total}</span>
                        </div>
                    </div>

                    {/* STATS ROW */}
                    <div className="okr-stats-row">
                        <div className="stat-box danger">
                            <span className="stat-label">Pending</span>
                            <span className="stat-value">{pending}</span>
                        </div>

                        <div className="stat-box success">
                            <span className="stat-label">Completed</span>
                            <span className="stat-value">{completed}</span>
                        </div>
                    </div>

                    {/* PROGRESS FULL WIDTH */}
                    <div className="progress-section-wide full">
                        <div className="progress-labels">
                            <span className="label-muted">Completion</span>
                            <span className="label-bold">{progressPercent}%</span>
                        </div>

                        <div className="wide-bar-bg">
                            <div
                                className="wide-bar-fill"
                                style={{ width: `${progressPercent}%` }}
                            ></div>
                        </div>
                    </div>

                    {/* FOOTER */}
                    <div className="expanded-footer">
                        <span className={`status-indicator ${pending > 0 ? 'is-warning' : 'is-clear'}`}>
                            {pending > 0
                                ? `● ${pending} Key Results Pending`
                                : '● All Key Results Completed'}
                        </span>

                        <span className="interaction-hint">
                            Open OKR Console →
                        </span>
                    </div>
                </div>
            </div>
        );
    };


    const [mgmtOneOnOneData, setMgmtOneOnOneData] = useState([]);
    useEffect(() => {
        const fetchMeetings = async () => {
            const storedUser = localStorage.getItem('userData');
            const user = JSON.parse(storedUser) || {};

            const res = await fetch(
                `/gt-api/get_oneonone.php?manager_id=${user.id}&role=manager`,
                {
                    credentials: "include"
                }
            );

            const data = await res.json();

            if (data.meetings) {
                setMgmtOneOnOneData(data.meetings);
            }
        };

        fetchMeetings();
    }, []);

    const renderOneOnOneHealthCard = () => {
        const missedData = mgmtOneOnOneData.filter(m => m.status === "MISSED");

        const total = mgmtOneOnOneData.length;
        const missed = mgmtOneOnOneData.filter(m => m.status === "MISSED").length;
        const completed = total - missed;

        const rate = total > 0 ? Math.round((completed / total) * 100) : 0;

        let status = "Healthy";
        if (rate < 50) status = "Critical ⚠️";
        else if (rate < 80) status = "Needs Attention";

        return (
            <div className="meeting-card" onClick={() => handleModuleChange("manager-one-on-one")}>

                <div className="mc-header">
                    <h3>1:1 Meeting Scheduler</h3>
                    <span>{status}</span>
                </div>

                {/* BIG NUMBER */}
                <div className="mc-center">
                    <h1>{rate}%</h1>
                    <p>Engagement</p>
                </div>

                {/* BARS */}
                <div className="mc-bars">
                    <div className="bar completed" style={{ width: `${rate}%` }}></div>
                    <div className="bar missed" style={{ width: `${100 - rate}%` }}></div>
                </div>

                {/* INFO */}
                <div className="mc-info">
                    <span>✅ {completed} Done</span>
                    <span>❌ {missed} Missed</span>
                </div>
                <button
                    className="view-missed-btn"
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowMissedModal(true);
                    }}
                >
                    View Missed
                </button>

            </div>
        );
    };

    const [okrActivity, setOkrActivity] = useState([]);
    useEffect(() => {
        const fetchOKR = async () => {
            try {
                const storedUser = localStorage.getItem("userData");
                const user = JSON.parse(storedUser) || {};

                const res = await fetch(
                    `/gt-api/get_employee_okrs.php?role=${user.role}&managedDept=${user.department}`,
                    {
                        credentials: "include"
                    }
                );

                const data = await res.json();

                if (data.success) {
                    setOkrActivity(data.data);
                }

            } catch (err) {
                console.error("OKR Fetch Error:", err);
            }
        };

        fetchOKR();
    }, []);

    const recentOKR = okrActivity
        .slice(0, 5)
        .map(item => {
            let type = "updated";

            if (item.workflow_status === "Planning") {
                type = "new";
            }

            if (item.workflow_status === "Manager_Scoring_Review") {
                type = "pending";
            }

            return {
                name: item.emp_name,
                quarter: item.quarter,
                type,
                workflow_status: item.workflow_status   // 🔥 VERY IMPORTANT
            };
        });



    const renderOKRActivityCard = () => {
        const getStatusConfig = (status) => {
            switch (status) {
                case "Planning": return { color: "#3b82f6", label: "submitted OKR" };
                case "Management_Review": return { color: "#f59e0b", label: "sent for Review" };
                case "Scoring": return { color: "#8b5cf6", label: "sent for Scoring" };
                case "Sign_Off": return { color: "#10b981", label: "finalized OKR" };
                default: return { color: "#00bcd4", label: "updated OKR" };
            }
        };

        return (
            <div className="mgt-okr-card1 timeline-style clickable" onClick={() => handleModuleChange("employee-okrs")}>
                <div className="card-header-v2">
                    <div className="title-section">
                        <h3>OKR Stream</h3>
                        <div className="live-dot-wrapper">
                            <span className="live-dot"></span>
                            <span className="sub-text">Live updates</span>
                        </div>
                    </div>
                </div>

                <div className="okr-activity-timeline">
                    {recentOKR.length === 0 ? (
                        <div className="empty-state">No recent activity detected</div>
                    ) : (
                        recentOKR.slice(0, 3).map((item, i) => {
                            const config = getStatusConfig(item.workflow_status);
                            return (
                                <div key={i} className="timeline-item">
                                    {/* The Vertical Line & Dot */}
                                    <div className="timeline-visual">
                                        <div className="timeline-line"></div>
                                        <div className="timeline-marker" style={{ borderColor: '#111827', background: config.color }}>
                                            <div className="marker-inner-dot"></div>
                                        </div>
                                    </div>

                                    {/* Single Content Box */}
                                    <div className="timeline-content-box">
                                        <div className="content-top">
                                            <span className="emp-name">{item.name}</span>
                                            <span className="quarter-tag">{item.quarter}</span>
                                        </div>
                                        <p className="status-message">{config.label}</p>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>

                <div className="card-footer-v2">
                    <span>Access Module</span>
                    {/* <div className="arrow-circle">→</div> */}
                </div>


            </div>
        );
    };

    const renderManagementShortcutsCard = () => {
        const shortcuts = [

            { name: "Create Invoice", icon: "🏦", slug: "create-invoice" },
            { name: "Policy RnU", icon: "📋", slug: "policy-logs" },
            { name: "Career Development", icon: "🏆", slug: "career pathways" },
            { name: "Expense Reimbursement", icon: "💰", slug: "reimbursements" },
            // { name: "ACM Updates", icon: "📢", slug: "manage-quarterly-updates" },
            { name: "Self OKR", icon: "🎯", slug: "okr and performance tracker" },
            { name: "Own Financial", icon: "💳", slug: "pay and benefits" },
            { name: "Access ACM Info", icon: "📢", color: "#00fff2", slug: "quarterly-updates" },
            // { name: "Equipment & IT Support", icon: "🖥️", color: "#06b6d4", slug: "equipment-request", badge: notifCount },
            { name: "IT Support", icon: "🖥️", slug: "employee-it-support" },
            { name: "Attendance Tracker", icon: "📊", slug: "attendance-tracker" },
            { name: "Award Analytics", icon: "🏆", slug: "award-analytics" },
            // { name: "Company Setup", icon: "⚙️", slug: "CompanySetup" },





        ];

        return (
            <div className="mgt-shortcut-card">

                <div className="card-header">
                    <h3>Quick Access</h3>
                    <span className="sub-text">Shortcuts</span>
                </div>

                <div className="shortcut-grid">
                    {shortcuts.map((item, i) => (
                        <div
                            key={i}
                            className="shortcut-item"
                            onClick={() => handleModuleChange(item.slug)}
                        >
                            <span className="shortcut-icon">{item.icon}</span>
                            <span className="shortcut-text">{item.name}</span>
                        </div>
                    ))}
                </div>

            </div>
        );
    };


    const renderEmployeeDashboard = () => {
        return (
            <div className="dashboard-layout">

                <div className="dashboard-row row-top">
                    {renderLeavePieChart()}
                    {renderPayChart()}
                    {renderOneOnOneCard()}



                    {/* {renderEquipmentCard()} */}
                </div>

                <div className="dashboard-row row-middle">
                    {renderOKRCard()}
                    {renderCareerPathwaysCard()}
                </div>

                <div className="dashboard-row row-bottom">
                    {renderPolicyCard()}
                    <QuarterlyCard handleModuleChange={handleModuleChange} />
                </div>

            </div>
        );
    };

    const renderManagementDashboard = () => {
        return (


            <div className="mgt-dashboard-layout">


                <div className="mgt-dashboard-row row-top two-card-layout">
                    <div className="card-large">
                        {renderManagementLeaveCard()}

                    </div>

                    <div className="mgt-card-small">
                        {/* {renderSalaryIntelCard()} */}
                        {/* {renderLeavePieChart()} */}
                        <OneOnOneAnalyticsCard
                            userData={userData}
                            handleModuleChange={handleModuleChange}
                        />





                    </div>
                </div>

                <div className="mgt-dashboard-row row-second three-card-layout">

                    <div className="mgt-card-medium">
                        <div className="leave-card-content">
                            {renderLeavePieChart()}
                        </div>
                    </div>

                    <div className="mgt-card-medium">
                        <div className="mgt-okrs">

                            {renderOKRActivityCard()}
                        </div>


                    </div>

                    <div className="mgt-card-medium">
                        {renderManagementShortcutsCard()}
                    </div>

                </div>
            </div>






        );
    };

    const renderManagerDashboard = () => {
        return (


            <div className="mgt-dashboard-layout">


                <div className="mgt-dashboard-row row-top two-card-layout">
                    <div className="card-large">
                        {renderManagementLeaveCard()}

                    </div>

                    <div className="mgt-card-small">
                        {/* {renderSalaryIntelCard()} */}
                        {/* {renderLeavePieChart()} */}
                        <OneOnOneAnalyticsCard
                            userData={userData}
                            handleModuleChange={handleModuleChange}
                        />





                    </div>
                </div>

                <div className="mgt-dashboard-row row-second three-card-layout">

                    <div className="mgt-card-medium">
                        <div className="leave-card-content">
                            {renderLeavePieChart()}
                        </div>
                    </div>

                    <div className="mgt-card-medium">
                        <div className="mgt-okrs">

                            {renderOKRActivityCard()}
                        </div>


                    </div>

                    <div className="mgt-card-medium">
                        {renderManagementShortcutsCard()}
                    </div>

                </div>
            </div>




        );
    };

    const currentEvent =
        todayEvents && todayEvents.length > 0
            ? todayEvents[currentEventIndex]
            : null;


    const combinedEvents = [];

    // 🎊 Festival TODAY (Priority if festival is today)
    if (upcomingFestival && isFestivalToday) {
        combinedEvents.push({
            type: "festival",
            title: upcomingFestival.name,
            tag: "FESTIVAL TODAY",
            icon: "🎊",
            sub: "Today 🎉"
        });
    }

    // 🎂 Birthday / Anniversary
    if (currentEvent && currentEvent.fullName) {
        combinedEvents.push({
            type: "event",
            title: currentEvent.fullName,
            tag: currentEvent.isBirthday ? "BIRTHDAY" : "WORK ANNIVERSARY",
            icon: currentEvent.isBirthday ? "🎂" : "🎉"
        });
    }

    // 🎊 Upcoming Festival (If future)
    if (upcomingFestival && !isFestivalToday) {
        combinedEvents.push({
            type: "festival",
            title: upcomingFestival.name,
            tag: "UPCOMING FESTIVAL",
            icon: "🎊",
            sub: `In ${daysLeft} days`
        });
    }

    useEffect(() => {
        if (combinedEvents.length <= 1) return;

        const interval = setInterval(() => {
            setActiveEventIndex(prev => (prev + 1) % combinedEvents.length);
        }, 4000);

        return () => clearInterval(interval);
    }, [combinedEvents.length]);

    const activeEvent = combinedEvents[activeEventIndex];


    return (

        <div


            className={`dash-container ${theme}-theme`}
            style={
                theme === 'light'
                    ? {
                        backgroundImage: `url(${logoLight})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundColor: 'var(--bg-main)'

                    }
                    : {}
            }
        >


            {showMissedModal && (
                <div className="modal-overlay" onClick={() => setShowMissedModal(false)}>
                    <div className="modal-card" onClick={(e) => e.stopPropagation()}>

                        <h3>Missed 1:1 Meetings</h3>

                        {mgmtOneOnOneData.filter(m => m.status === "MISSED").length === 0 ? (
                            <p>No missed meetings 🎉</p>
                        ) : (
                            mgmtOneOnOneData
                                .filter(m => m.status === "MISSED")
                                .map((m, i) => (
                                    <div key={i} className="missed-item">
                                        <strong>{m.employee_name}</strong>
                                        <span>{m.date}</span>
                                    </div>
                                ))
                        )}

                        <button onClick={() => setShowMissedModal(false)}>
                            Close
                        </button>

                    </div>
                </div>
            )}



            <div className="auth-background-overlay"></div>






            <Sidebar
                role={role}
                userData={userData}
                activeModule={activeModule}
                openMenus={openMenus}
                toggleSubMenu={toggleSubMenu}
                handleModuleChange={handleModuleChange}
                handleLogout={handleLogout}
                mobileMenuOpen={mobileMenuOpen}
                setMobileMenuOpen={setMobileMenuOpen}
                pendingRequestsCount={pendingRequestsCount}
            />

            <main className="dash-content">

                <header className="content-header">

                    {/* 🔷 LEFT */}
                    <div className="header-left">
                        <div className="header-text">

                            <h1>
                                {activeModule === "grid" && !showProfile ? "Welcome," : ""}{" "}
                                <span className={theme === 'light' ? "name-light" : "name-accent"}>
                                    {showProfile
                                        ? "MY PROFILE"
                                        : (activeModule === "grid"
                                            ? userData.firstName || userData.FirstName
                                            : (activeModule === "attendance"
                                                ? "LEAVE MANAGEMENT"
                                                : (activeModule === "one-on-one-report"
                                                    ? "ONE-ON-ONE REPORT"
                                                    : activeModule.toUpperCase().replace(/-/g, ' ')
                                                )
                                            )
                                        )
                                    }
                                </span>
                            </h1>

                            {activeModule === 'attendance' && userData.joiningDate && (
                                <div className="joining-info">
                                    JOINING_DATE: {new Date(userData.joiningDate).toLocaleDateString('en-GB').toUpperCase()}
                                </div>
                            )}

                        </div>
                    </div>







                    <div className="header-center">

                        {/* TIME + DATE FIRST */}
                        <div className="time-date-right">
                            <div className="live-time">{currentTime}</div>

                            <div className="today-widget">
                                <span>📅 {todayDate}</span>
                                <small>Have a Nice Day!</small>
                            </div>
                        </div>

                        {/* EVENT CARD SECOND */}
                        <div
                            className={`executive-event-bar ${theme === 'light' ? 'light-theme-elite' : 'dark-theme-elite'}
        ${role === "Management" || role === "Manager" ? "clickable" : ""}`}
                            onClick={() => {
                                if (role === "Management" || role === "Manager") {
                                    handleModuleChange("events-celebrations");
                                }
                            }}
                        >
                            <div
                                className={`event-status-box ${activeEvent
                                    ? (activeEvent.type === 'festival'
                                        ? 'bg-fest'
                                        : (activeEvent.tag === 'BIRTHDAY' ? 'bg-birth' : 'bg-anniv'))
                                    : 'bg-neutral'
                                    }`}
                            >
                                <span className="event-icon-small">
                                    {activeEvent ? activeEvent.icon : "✨"}
                                </span>
                            </div>

                            <div className="event-content-main">
                                <div className="event-label-row">
                                    <span className="event-tag">
                                        {activeEvent ? activeEvent.tag : "TODAY"}
                                    </span>
                                </div>

                                <h3 className="event-title-text">

                                    {activeEvent ? (
                                        <span className="event-highlight">
                                            {activeEvent.icon} {activeEvent.title}
                                        </span>
                                    ) : (
                                        <span className="event-empty-text">
                                            No events today
                                        </span>
                                    )}
                                </h3>
                            </div>

                            <div className="event-action-wrapper">
                                <button
                                    className="minimal-wish-btn"
                                    disabled={!currentEvent}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <div className="btn-line"></div>
                                </button>
                            </div>
                        </div>

                    </div>







                    <div className="header-controls">

                        {/* 🌗 THEME */}
                        <div className="theme-switch-container">
                            <label className="theme-slider-switch">
                                <input
                                    type="checkbox"
                                    onChange={toggleTheme}
                                    checked={theme === 'light'}
                                />
                                <span className="theme-slider round">
                                    <span className="sun-icon">☀️</span>
                                    <span className="moon-icon">🌙</span>
                                </span>
                            </label>
                        </div>




                        {(activeModule !== "grid" || showProfile) && (
                            <button
                                className="back-btn"
                                onClick={() => handleModuleChange("grid")}
                            >
                                Back
                            </button>
                        )}

                    </div>

                </header>


                {activeModule === "grid" ? (

                    role === "Management"
                        ? renderManagementDashboard()
                        : role === "Manager"
                            ? renderManagerDashboard()   // 🔥 ADD THIS LINE
                            : renderEmployeeDashboard()

                ) : (
                    renderActiveModule()
                )}

                <div className="dash-footer">
                    Design & Developed by Genesis Tech Engineers © 2026
                </div>
            </main>

            {(role === "Management" || role === "Manager") && (
                <>
                    <div
                        className="ai-chat-float-btn"
                        onClick={() => setShowAIChat(true)}
                    >
                        🤖
                    </div>

                    {showAIChat && (
                        <div className="ai-chat-modal">
                            <div className="ai-chat-header">
                                <span>ELMS AI Assistant</span>
                                <button onClick={() => setShowAIChat(false)}>
                                    ✕
                                </button>
                            </div>

                            <div className="ai-chat-body">
                                {chatMessages.map((msg, index) => (
                                    <div
                                        key={index}
                                        className={`chat-bubble ${msg.sender}`}
                                    >
                                        <pre>{msg.text}</pre>
                                    </div>
                                ))}

                                {chatLoading && (
                                    <div className="chat-bubble ai">
                                        Thinking...
                                    </div>
                                )}
                            </div>

                            <div className="ai-chat-footer">
                                <input
                                    type="text"
                                    value={chatInput}
                                    onChange={(e) => setChatInput(e.target.value)}
                                    placeholder="Ask anything..."
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            sendAIMessage();
                                        }
                                    }}
                                />

                                <button onClick={sendAIMessage}>
                                    Send
                                </button>
                            </div>
                        </div>
                    )}
                </>
            )}

            {/* 1️⃣ MANDATORY COMPANY POLICY ACKNOWLEDGEMENT MODAL (FIRST) */}
            {showMandatoryPolicyModal && (
                <div className="mandatory-policy-fullscreen-overlay">
                    {/* Top Header Bar */}
                    <div className="mandatory-policy-topbar">
                        <div className="topbar-title-area">
                            <span className="topbar-icon">📜</span>
                            <h2>Mandatory Company Policy Acknowledgement</h2>
                        </div>

                        <div className="topbar-progress-area">
                            <div className="topbar-progress-text">
                                <span>Progress: <strong>{acknowledgedPoliciesCount}</strong> of <strong>{totalPoliciesCount}</strong> Policies Acknowledged</span>
                                <span className="topbar-badge">{unacknowledgedPolicies.length} Remaining</span>
                            </div>
                            <div className="topbar-progress-track">
                                <div
                                    className="topbar-progress-fill"
                                    style={{ width: `${totalPoliciesCount > 0 ? (acknowledgedPoliciesCount / totalPoliciesCount) * 100 : 0}%` }}
                                ></div>
                            </div>
                        </div>

                        <button
                            type="button"
                            className="topbar-logout-btn"
                            onClick={handleLogout}
                        >
                            🚪 Logout
                        </button>
                    </div>

                    {/* Alerts */}
                    {policyAckError && (
                        <div className="mandatory-alert-box error" style={{ margin: '8px 24px 0 24px' }}>
                            <span>⚠️ {policyAckError}</span>
                        </div>
                    )}

                    {policyAckSuccessMsg && (
                        <div className="mandatory-alert-box success" style={{ margin: '8px 24px 0 24px' }}>
                            <span>✅ {policyAckSuccessMsg}</span>
                        </div>
                    )}

                    {/* Full Screen Layout Body */}
                    <div className="mandatory-policy-fullscreen-body">
                        {/* Left Sidebar Menu */}
                        <div className="mandatory-policy-sidebar">
                            <h3>Company Policies ({(allPoliciesList.length > 0 ? allPoliciesList : GENESIS_POLICIES).length})</h3>
                            <div className="mandatory-policy-list">
                                {(allPoliciesList.length > 0 ? allPoliciesList : GENESIS_POLICIES).map((p, idx) => {
                                    const pTitle = p.title || p.policy_title;
                                    const pIcon = p.icon || p.policy_icon || "📜";
                                    const isAck = !!logs[pTitle];
                                    const isSelected = selectedMandatoryPolicy && (selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title) === pTitle;

                                    return (
                                        <div
                                            key={p.id || idx}
                                            className={`mandatory-policy-item ${isSelected ? "active" : ""} ${isAck ? "signed" : ""}`}
                                            onClick={() => {
                                                setSelectedMandatoryPolicy(p);
                                                setPolicyAgreed(false);
                                            }}
                                        >
                                            <span className="p-item-icon">{pIcon}</span>
                                            <span className="p-item-title">{pTitle}</span>
                                            {isAck ? (
                                                <span className="p-item-tag ack">✅ Signed</span>
                                            ) : (
                                                <span className="p-item-tag pending">Required</span>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Right Main Policy Content Viewer */}
                        <div className="mandatory-policy-fullscreen-viewer">
                            {selectedMandatoryPolicy ? (
                                <>
                                    <div className="mandatory-viewer-header">
                                        <h3>
                                            <span>{selectedMandatoryPolicy.icon || selectedMandatoryPolicy.policy_icon || "📜"}</span>
                                            {selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title}
                                            {logs[selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title] && (
                                                <span className="viewer-signed-badge">✅ Acknowledged</span>
                                            )}
                                        </h3>
                                    </div>

                                    {/* Full Height Scrollable Document Body */}
                                    <div className="mandatory-policy-document-body">
                                        {selectedMandatoryPolicy.content ? (
                                            typeof selectedMandatoryPolicy.content === 'string' ? (
                                                <div dangerouslySetInnerHTML={{ __html: selectedMandatoryPolicy.content }} />
                                            ) : (
                                                selectedMandatoryPolicy.content
                                            )
                                        ) : (
                                            <p className="policy-placeholder">Please review the contents of this policy carefully before accepting.</p>
                                        )}
                                    </div>

                                    {/* Fixed Bottom Action Section */}
                                    <div className="mandatory-policy-bottom-action-bar">
                                        {logs[selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title] ? (
                                            <div className="mandatory-policy-signed-banner">
                                                <span>✅ Policy Acknowledged & Signed</span>
                                            </div>
                                        ) : (
                                            <form onSubmit={handleAcknowledgeMandatoryPolicy} className="mandatory-ack-stacked-form">
                                                <label className="mandatory-checkbox-container">
                                                    <input
                                                        type="checkbox"
                                                        checked={policyAgreed}
                                                        onChange={(e) => setPolicyAgreed(e.target.checked)}
                                                    />
                                                    <span>
                                                        I confirm that I have read, understood, and agree to abide by the terms of <strong>{selectedMandatoryPolicy.title || selectedMandatoryPolicy.policy_title}</strong>.
                                                    </span>
                                                </label>

                                                <button
                                                    type="submit"
                                                    className="mandatory-save-btn"
                                                    disabled={!policyAgreed || policyAckSaving}
                                                >
                                                    {policyAckSaving ? "Recording..." : "Acknowledge & Accept Policy ✅"}
                                                </button>
                                            </form>
                                        )}
                                    </div>
                                </>
                            ) : (
                                <div className="mandatory-policy-document-body">
                                    <p>Select a policy from the list on the left to read and acknowledge.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* 2️⃣ MANDATORY BANK DETAILS POPUP MODAL (SECOND) */}
            {showMandatoryBankModal && !showMandatoryPolicyModal && (
                <div className="mandatory-profile-modal-overlay">
                    <div className="mandatory-profile-modal-card">
                        <div className="mandatory-modal-header">
                            <div className="mandatory-warning-icon">🏦</div>
                            <h2>Mandatory Bank Details Required</h2>
                            <p>
                                Your employee bank record has missing information. Please fill in the required field(s) below for payroll & salary processing.
                            </p>
                        </div>

                        {bankError && (
                            <div className="mandatory-alert-box error">
                                <span>⚠️ {bankError}</span>
                            </div>
                        )}

                        {bankSuccessMsg && (
                            <div className="mandatory-alert-box success">
                                <span>✅ {bankSuccessMsg}</span>
                            </div>
                        )}

                        <form onSubmit={handleSaveMandatoryBankDetails} className="mandatory-profile-form">
                            <div className="mandatory-form-grid">
                                {missingBankFields.bankName && (
                                    <div className="mandatory-input-group">
                                        <label>Bank Name <span className="req-star">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="e.g. HDFC Bank, ICICI Bank"
                                            value={bankFormData.bankName}
                                            onChange={(e) => setBankFormData(prev => ({ ...prev, bankName: e.target.value }))}
                                            required
                                        />
                                    </div>
                                )}

                                {missingBankFields.holderName && (
                                    <div className="mandatory-input-group">
                                        <label>Account Holder Name <span className="req-star">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="Enter account holder name"
                                            value={bankFormData.holderName}
                                            onChange={(e) => setBankFormData(prev => ({ ...prev, holderName: e.target.value }))}
                                            required
                                        />
                                    </div>
                                )}

                                {missingBankFields.accNumber && (
                                    <div className="mandatory-input-group">
                                        <label>Account Number <span className="req-star">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="Enter account number"
                                            value={bankFormData.accNumber}
                                            onChange={(e) => setBankFormData(prev => ({ ...prev, accNumber: e.target.value }))}
                                            required
                                        />
                                    </div>
                                )}

                                {missingBankFields.ifsc && (
                                    <div className="mandatory-input-group">
                                        <label>IFSC Code <span className="req-star">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="e.g. HDFC0001234"
                                            value={bankFormData.ifsc}
                                            onChange={(e) => setBankFormData(prev => ({ ...prev, ifsc: e.target.value }))}
                                            required
                                        />
                                    </div>
                                )}

                                {missingBankFields.branch && (
                                    <div className="mandatory-input-group">
                                        <label>Branch Name <span className="req-star">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="Enter branch name"
                                            value={bankFormData.branch}
                                            onChange={(e) => setBankFormData(prev => ({ ...prev, branch: e.target.value }))}
                                            required
                                        />
                                    </div>
                                )}

                                {missingBankFields.accType && (
                                    <div className="mandatory-input-group">
                                        <label>Account Type <span className="req-star">*</span></label>
                                        <select
                                            value={bankFormData.accType}
                                            onChange={(e) => setBankFormData(prev => ({ ...prev, accType: e.target.value }))}
                                            required
                                        >
                                            <option value="Saving Account">Saving Account</option>
                                            <option value="Current Account">Current Account</option>
                                            <option value="Salary Account">Salary Account</option>
                                        </select>
                                    </div>
                                )}
                            </div>

                            <div className="mandatory-modal-footer">
                                <button
                                    type="submit"
                                    className="mandatory-save-btn"
                                    disabled={bankSaving}
                                >
                                    {bankSaving ? "Saving Bank Details..." : "Save Bank Details & Continue →"}
                                </button>
                                <button
                                    type="button"
                                    className="mandatory-logout-btn"
                                    onClick={handleLogout}
                                >
                                    🚪 Logout
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* 3️⃣ MANDATORY PROFILE POPUP MODAL (THIRD) */}
            {showMandatoryProfileModal && !showMandatoryPolicyModal && !showMandatoryBankModal && (
                <div className="mandatory-profile-modal-overlay">
                    <div className="mandatory-profile-modal-card">
                        <div className="mandatory-modal-header">
                            <div className="mandatory-warning-icon">⚠️</div>
                            <h2>Mandatory Profile Completion Required</h2>
                            <p>
                                Your employee profile has missing information. Please fill in the required field(s) below to continue using the system.
                            </p>
                        </div>

                        {mandatoryError && (
                            <div className="mandatory-alert-box error">
                                <span>⚠️ {mandatoryError}</span>
                            </div>
                        )}

                        {mandatorySuccessMsg && (
                            <div className="mandatory-alert-box success">
                                <span>✅ {mandatorySuccessMsg}</span>
                            </div>
                        )}

                        <form onSubmit={handleSaveMandatoryProfile} className="mandatory-profile-form">
                            <div className="mandatory-form-grid">
                                {missingProfileFields.phone && (
                                    <div className="mandatory-input-group">
                                        <label>Mobile Number <span className="req-star">*</span></label>
                                        <input
                                            type="tel"
                                            placeholder="Enter mobile number"
                                            value={mandatoryFormData.phone}
                                            onChange={(e) => setMandatoryFormData(prev => ({ ...prev, phone: e.target.value }))}
                                            required
                                        />
                                    </div>
                                )}

                                {missingProfileFields.dob && (
                                    <div className="mandatory-input-group">
                                        <label>Date of Birth <span className="req-star">*</span></label>
                                        <input
                                            type="date"
                                            max={new Date().toISOString().split("T")[0]}
                                            value={mandatoryFormData.dob}
                                            onChange={(e) => setMandatoryFormData(prev => ({ ...prev, dob: e.target.value }))}
                                            onClick={(e) => {
                                                try {
                                                    if (e.target.showPicker) e.target.showPicker();
                                                } catch (err) { }
                                            }}
                                            required
                                            className="mandatory-date-input"
                                        />
                                    </div>
                                )}

                                {missingProfileFields.city && (
                                    <div className="mandatory-input-group">
                                        <label>City <span className="req-star">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="Enter city"
                                            value={mandatoryFormData.city}
                                            onChange={(e) => setMandatoryFormData(prev => ({ ...prev, city: e.target.value }))}
                                            required
                                        />
                                    </div>
                                )}

                                {missingProfileFields.country && (
                                    <div className="mandatory-input-group">
                                        <label>Country <span className="req-star">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="Enter country"
                                            value={mandatoryFormData.country}
                                            onChange={(e) => setMandatoryFormData(prev => ({ ...prev, country: e.target.value }))}
                                            required
                                        />
                                    </div>
                                )}

                                {missingProfileFields.address && (
                                    <div className="mandatory-input-group full-width">
                                        <label>Permanent Address <span className="req-star">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="Enter permanent address"
                                            value={mandatoryFormData.address}
                                            onChange={(e) => setMandatoryFormData(prev => ({ ...prev, address: e.target.value }))}
                                            required
                                        />
                                    </div>
                                )}

                                {missingProfileFields.local_address && (
                                    <div className="mandatory-input-group full-width">
                                        <label>Current / Local Address <span className="req-star">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="Enter current / local address"
                                            value={mandatoryFormData.local_address}
                                            onChange={(e) => setMandatoryFormData(prev => ({ ...prev, local_address: e.target.value }))}
                                            required
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="mandatory-modal-footer">
                                <button
                                    type="submit"
                                    className="mandatory-save-btn"
                                    disabled={mandatorySaving}
                                >
                                    {mandatorySaving ? "Saving Profile..." : "Save Profile & Continue →"}
                                </button>
                                <button
                                    type="button"
                                    className="mandatory-logout-btn"
                                    onClick={handleLogout}
                                >
                                    🚪 Logout
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* 🚫 DOCUMENT SUBMISSION OVERDUE RESTRICTION LOCKOUT */}
            {docRestrictionInfo && (
                <div className="lockout-fullscreen-overlay">
                    <div className="lockout-card animate-fade">
                        <div className="lockout-icon">🚫</div>
                        <h2>ACCESS RESTRICTED</h2>
                        <p className="lockout-msg">
                            {docRestrictionInfo.message || "Due to overdue document submission, your dashboard access has been restricted. Please contact Management / HR to unlock your account."}
                        </p>
                        <div className="lockout-missing-box">
                            <h4>Compliance Details</h4>
                            <p style={{ margin: '4px 0', fontSize: '13px' }}>
                                <b>Submission Deadline:</b> {docRestrictionInfo.due_date}
                            </p>
                            <p style={{ margin: '4px 0', fontSize: '13px' }}>
                                <b>Pending Documents:</b> {docRestrictionInfo.missing_count} of {docRestrictionInfo.total_required} required documents missing
                            </p>
                            <p style={{ margin: '8px 0 0 0', fontSize: '12px', color: 'rgba(255,255,255,0.7)', lineHeight: '1.5' }}>
                                Only Management has the authority to restore your access. Please contact HR at <b style={{ color: '#38bdf8' }}>hr@genesistech.co.in</b>.
                            </p>
                        </div>
                        <div className="lockout-footer">
                            <button
                                type="button"
                                className="btn-lockout-logout"
                                onClick={handleLogout}
                            >
                                🚪 Logout
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Dashboard;

